export default {
  "pl-PL": {
    "Ulubione": "Ulubione",
    "Dodaj do ulubionych": "Dodaj do ulubionych",
    "Usuń z ulubionych": "Usuń z ulubionych",
    "Wybierz typ Firmy": "Wybierz typ Firmy",
    "Zacznij pisać aby wyszukać dzielnice...": "Zacznij pisać aby wyszukać dzielnice...",
    "Co godzinę": "Co godzinę",
    "Dostępne wersje językowe.": "",
    "Strona nadrzędna": "",
    "Autor notatki": "Autor notatki",
    "zacznij pisać aby wyszukać artykuł...": "",
    "Slajd został dodany.": "",
    "Ten użytkownik już jest przypisany do czatu": "Ten użytkownik już jest przypisany do czatu",
    "Zlecenia": "Zlecenia",
    "Otwórz czat - link": "",
    "Na żądanie działu": "Na żądanie działu",
    "W każdy dzień tygodnia": "W każdy dzień tygodnia",
    "Rozwiń": "Rozwiń",
    "Artykuł": "",
    "10": "",
    "Budynek": "",
    "Ostatnio oglądane": "",
    "Nieobecność do": "Nieobecność do",
    "Wybierz pliki (do {0})": "Wybierz pliki (do {0})",
    "Co 2 godziny": "Co 2 godziny",
    "Moja trasa": "Moja trasa",
    "Dodanie źródła danych": "Dodanie źródła danych",
    "Publikuj szkolenie": "",
    "5 ostatnich zadań": "5 ostatnich zadań",
    "Eksportuj do Excel": "Eksportuj do Excel",
    "Przypisana do (Imię i Nazwisko)": "Przypisana do (Imię i Nazwisko)",
    "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "",
    "Zmniejsz": "Zmniejsz",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "",
    "Data Wykonania": "",
    "Dodaj kategorię": "Dodaj kategorię",
    "Dział został zaktualizowany.": "Dział został zaktualizowany.",
    "Klient aktywny": "Klient aktywny",
    "Wprowadzona wartość jest nieprawidłowa": "Wprowadzona wartość jest nieprawidłowa",
    "Slajd został zaktualizowany.": "",
    "Szablon checklisty": "Szablon checklisty",
    "Tak/Nie": "Tak/Nie",
    "Strona szkolenia ukryta": "",
    "Dodanie nieruchomości roboczej": "Dodanie nieruchomości roboczej",
    "Nazwa taga": "Nazwa taga",
    "Edytuj koszt": "",
    "Wybrana dzielnica": "Wybrana dzielnica",
    "Dodaj odpowiedź": "",
    "Nazwa użytkownika": "Nazwa użytkownika",
    "Kolejka": "Kolejka",
    "Wartości": "Wartości",
    "Strona dostępna tylko dla zalogowanych użytkowników": "",
    "Zastępstwo wygaśnie za minutę.": "Zastępstwo wygaśnie za minutę.",
    "Token został usunięty.": "Token został usunięty.",
    "Liczba wyświetlanych najnowszych elementów": "",
    "Pomyślnie dołączono do czatu": "Pomyślnie dołączono do czatu",
    "Początek szerokości geograficznej użytkownika": "Początek szerokości geograficznej użytkownika",
    "Wybrany szablon": "",
    "Link został zaktualizowany.": "",
    "Edycja zespołu": "Edycja zespołu",
    "Miasto": "Miasto",
    "Zakończone przez: ": "Zakończone przez: ",
    "Nie możesz wznowić obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "Nie możesz wznowić obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie",
    "Sekcje i bloki": "",
    "Tło strona 2": "",
    "Nazwa Kategorii": "",
    "Posprzątane": "Posprzątane",
    "Pokaż czaty": "",
    "Stwórz zadanie z tej rezerwacji": "Stwórz zadanie z tej rezerwacji",
    "Zespół został przypisany do ścieżki szkoleniowej.": "",
    "Dodaj test": "",
    "Usunięcie wybranych elementów": "Usunięcie wybranych elementów",
    "Zapisuję...": "Zapisuję...",
    "Sekcje dla gości": "",
    "Włączone (Index)": "",
    "Zdecydowanie nie": "Zdecydowanie nie",
    "Certyfikat został usunięty.": "",
    "Notatka została zaktualizowana.": "Notatka została zaktualizowana.",
    "Ważne": "Ważne",
    "Tryb monitorowania aktywności": "",
    "Link": "",
    "Maksymalny rozmiar pliku w MB": "Maksymalny rozmiar pliku w MB",
    "Stawka wynagrodzenia została zaktualizowana.": "Stawka wynagrodzenia została zaktualizowana.",
    "Statystyki wyniosków": "Statystyki wyniosków",
    "Lista plików": "Lista plików",
    "UWAGA! Ta tabela pokazuje tylko przeterminowane zadania, filtr \"STATUS\" nie jest aktywny. Wróć do \"Wszystkie zadania\" aby mieć dostępne wszystkie filtry": "UWAGA! Ta tabela pokazuje tylko przeterminowane zadania, filtr \"STATUS\" nie jest aktywny. Wróć do \"Wszystkie zadania\" aby mieć dostępne wszystkie filtry",
    "Usuń plik": "Usuń plik",
    "Element został zaktualizowany.": "",
    "Dział:": "Dział:",
    "Logi aktywności zostały wyczyszczone": "",
    "Nazwa katalogu lub pliku": "Nazwa katalogu lub pliku",
    "Utworzono kopię checklisty": "Utworzono kopię checklisty",
    "Tryb wyświetlania": "",
    "Użytkownik Obsługa": "Użytkownik Obsługa",
    "Zapisz zmiany": "Zapisz zmiany",
    "Zastępstwo zostało zaktualizowane.": "Zastępstwo zostało zaktualizowane.",
    "Polska": "Polska",
    "Skala 1-5": "Skala 1-5",
    "Wydrukuj": "Wydrukuj",
    "Firma domyślna": "Firma domyślna",
    "Nazwa Firmy": "Nazwa Firmy",
    "Zgoda": "Zgoda",
    "Wyszukiwarka miejsc": "Wyszukiwarka miejsc",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "Wstaw dwie kolumny 1/3 oraz 2/3",
    "Szablon został usunięty.": "Szablon został usunięty.",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "",
    "Niezakończone": "Niezakończone",
    "Data wykonania od": "Data wykonania od",
    "Ukryj czaty": "",
    "Co drugi miesiąc": "Co drugi miesiąc",
    "Nazwa kolumny z wartością": "Nazwa kolumny z wartością",
    "Ostatnia strona": "Ostatnia strona",
    "Komentarz konserwatora": "Komentarz konserwatora",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "Na pewno przenieść wybrane elementy do bieżącego katalogu?",
    "Statyczny": "",
    "Zadania na wniosek działu": "Zadania na wniosek działu",
    "Planuj automatycznie w dniu wymeldowania": "Planuj automatycznie w dniu wymeldowania",
    "Jutro": "Jutro",
    "Wszystkie próby": "Wszystkie próby",
    "Przejdź do zadania": "Przejdź do zadania",
    "Godzina przełomowa synchronizacji": "Godzina przełomowa synchronizacji",
    "Ilość wierszy": "Ilość wierszy",
    "Dodaj do zespołu": "Dodaj do zespołu",
    "Inspekcja": "Inspekcja",
    "Łazienka": "",
    "Wydział": "Wydział",
    "Nie udało się pobrać listy filtrów": "Nie udało się pobrać listy filtrów",
    "Strona logowania": "",
    "Administracja - Użytkownicy": "Administracja - Użytkownicy",
    "Wybierz plik lub katalog": "Wybierz plik lub katalog",
    "Miejsca po przecinku": "Miejsca po przecinku",
    "Dodane Koszty": "Dodane Koszty",
    "Designer": "",
    "-": "-",
    "Wyślij testowe powiadomienie": "Wyślij testowe powiadomienie",
    "Formularze": "Formularze",
    "Nie udało sie zaktualizować zadania": "Nie udało sie zaktualizować zadania",
    "Początek dystansu": "Początek dystansu",
    "Dane do sieci": "",
    "Koszt Renters": "Koszt Renters",
    "Brak właściciela": "Brak właściciela",
    "Publikacja": "",
    "Resetuj zmiany": "",
    "Cyfry": "Cyfry",
    "Status: ": "Status: ",
    "Potwierdzam": "Potwierdzam",
    "Co drugi dzień": "Co drugi dzień",
    "PDF": "",
    "Ustawienia globalne": "Ustawienia globalne",
    "Usuń": "Usuń",
    "Nieruchomość jest widoczna": "Nieruchomość jest widoczna",
    "Nie udało się pobrać listy katalogów": "",
    "Zaakceptowany": "Zaakceptowany",
    "Zadanie zostało rozpoczęte.": "Zadanie zostało rozpoczęte.",
    "Nazwa chatu": "Nazwa chatu",
    "Facebook Application ID": "",
    "Wyświetl nieruchomości robocze": "Wyświetl nieruchomości robocze",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.",
    "15 minut": "15 minut",
    "Edycja formularza": "Edycja formularza",
    "Zakolejkowane": "Zakolejkowane",
    "Adres URL profilu autora.": "",
    "Opis szkolenia": "",
    "Dostęp przyznany przez zespół": "",
    "Modyfikacja": "Modyfikacja",
    "Nieprzeczytane": "",
    "Numer nieruchomości (StreetNumber)": "Numer nieruchomości (StreetNumber)",
    "Kod Bing Webmaster": "",
    "Administracja - Stanowiska pracy": "Administracja - Stanowiska pracy",
    "Wszystkie konta": "",
    "Edytuj lekcje wideo": "",
    "Dostęp niezdefiniowany": "Dostęp niezdefiniowany",
    "Potwierdź wyłączenie publikacji": "",
    "Treść notatki": "Treść notatki",
    "edycja": "edycja",
    "Link został zaktualizowany.": "",
    "Widoczność": "Widoczność",
    "Przypisani użytkownicy": "Przypisani użytkownicy",
    "Ukończone przez użytkownika o Id": "Ukończone przez użytkownika o Id",
    "Ta dzielnica jest już przypisana do użytkownika.": "Ta dzielnica jest już przypisana do użytkownika.",
    "Kwota opłacona": "Kwota opłacona",
    "zacznij pisać aby wyszukać slajder...": "",
    "Odepnij menu": "",
    "Tekst alternatywny": "Tekst alternatywny",
    "Stawka za typ apartamentu": "Stawka za typ apartamentu",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Liczba pracowników pracujących w więcej niż jednym regionie",
    "Nie udało się pobrać listy kolejek": "Nie udało się pobrać listy kolejek",
    "Dodanie roli": "Dodanie roli",
    "Wyżej": "",
    "Role i uprawnienia": "Role i uprawnienia",
    "Tekst zastępczy": "Tekst zastępczy",
    "Zarządzaj zespołami": "",
    "Szkolenie kończy się": "",
    "Potwierdź wyczyszczenie logów": "",
    "W polu możemy umieszczać jedynie cyfry całkowite, nie ujemne": "W polu możemy umieszczać jedynie cyfry całkowite, nie ujemne",
    "Kierowca Główny": "Kierowca Główny",
    "Region został zaktualizowany.": "Region został zaktualizowany.",
    "Regulamin został zaktualizowany.": "",
    "Certyfikat jest opublikowany": "",
    "Nie masz uprawnień do publikacji aranżacji.": "",
    "Checklista nie ma przypisanych miast.": "Checklista nie ma przypisanych miast.",
    "Opublikuj materiał": "",
    "Monitoring": "Monitoring",
    "Status rozliczenia": "Status rozliczenia",
    "Zmień status": "Zmień status",
    "Klient został zaktualizowany.": "Klient został zaktualizowany.",
    "Edytuj treść": "",
    "Zaopatrzenie": "Zaopatrzenie",
    "Temat": "Temat",
    "Zdecydowanie się nie zgadzam": "Zdecydowanie się nie zgadzam",
    "Dodaj szkolenie": "",
    "Nazwa kosztu": "Nazwa kosztu",
    "Dostępny w sekcjach": "",
    "%$ – znacznik otwierający tag": "",
    "Notatka utworzona z zadania": "Notatka utworzona z zadania",
    "Wybierz sekcję": "",
    "Hasło": "Hasło",
    "Dodaj firmę": "Dodaj firmę",
    "Nieruchomość": "Nieruchomość",
    "Zapisz slajd": "",
    "Wyświetlaj tylko treść": "",
    "Sekcje wspólne": "",
    "Zdecydowanie nieważne": "Zdecydowanie nieważne",
    "Nazwa apartamentu": "Nazwa apartamentu",
    "${DepartmentName(DepartmentEnum[this.task.department])}": "${DepartmentName(DepartmentEnum[this.task.department])}",
    "Październik": "Październik",
    "Właściwość ``%0`` aktywnego wpisu": "",
    "W zespole do": "",
    "Usuń zadanie": "Usuń zadanie",
    "Materiał opisowy": "",
    "Wybierz strony": "",
    "Dodane przeze mnie": "Dodane przeze mnie",
    "Właściciel został usunięty": "Właściciel został usunięty",
    "Checklista została dodana.": "Checklista została dodana.",
    "zgłoś problem w apartamencie": "zgłoś problem w apartamencie",
    "Proszę zapisać postęp pracy i kliknąć przycisk \"Aktualizuj\".": "Proszę zapisać postęp pracy i kliknąć przycisk \"Aktualizuj\".",
    "Email": "Email",
    "Obraz został wycięty.": "Obraz został wycięty.",
    "Wybrany materiał został już dodany do lekcji": "",
    "Wybrane pliki": "Wybrane pliki",
    "Kontrolka wyboru (wybór wielokrotny)": "Kontrolka wyboru (wybór wielokrotny)",
    "Odpowiedź": "",
    "Można dodawać tylko pliki typu: \"%0\".": "Można dodawać tylko pliki typu: \"%0\".",
    "Typ pomieszczenia": "",
    "Paczki SCORM": "",
    "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "",
    "Zacznij pisać aby wyszukać szablon checklisty...": "Zacznij pisać aby wyszukać szablon checklisty...",
    "Nazwa pola": "Nazwa pola",
    "Projekt": "Projekt",
    "Edycja inwentaryzacji": "Edycja inwentaryzacji",
    "Wybór": "Wybór",
    "Dodanie zadania": "Dodanie zadania",
    "Wyświetlaj nazwę bloczka": "",
    "Uprawnienia": "Uprawnienia",
    "Renters": "Renters",
    "Log z aktywności": "",
    "Data dezaktywacji": "",
    "Słownik systemowy": "Słownik systemowy",
    "Umożliwienie sprawdzania odpowiedzi": "",
    "Ścieżka szkoleniowa została dodana.": "",
    "Źródło danych": "Źródło danych",
    "Inwentaryzacja została dodana.": "Inwentaryzacja została dodana.",
    "Zastępstwo wygaśnie za 10 minut.": "Zastępstwo wygaśnie za 10 minut.",
    "Kolor powinien być w formacie #XXXXXX (np. #f07d00)": "Kolor powinien być w formacie #XXXXXX (np. #f07d00)",
    "Strony opisowe": "",
    "Nie udało się pobrać listy kanałów": "Nie udało się pobrać listy kanałów",
    "Generator plików PDF:": "Generator plików PDF:",
    "Raporty z rozliczeń": "Raporty z rozliczeń",
    "Nie zdefiniowano żadnych ról.": "Nie zdefiniowano żadnych ról.",
    "Nie udało się wczytać podglądu strony.": "",
    "Nazwa testu": "",
    "Typ pomieszczenia jest wymagany": "",
    "Zmień rozmiar": "Zmień rozmiar",
    "Komunikat mailowy": "",
    "Notatka do zadania": "Notatka do zadania",
    "Numer pinezki": "Numer pinezki",
    "Dodanie regionu": "Dodanie regionu",
    "Checklisty": "Checklisty",
    "Dostęp zabroniony": "Dostęp zabroniony",
    "NIP": "NIP",
    "Adres email": "Adres email",
    "Materiał wideo": "",
    "Komunikat": "Komunikat",
    "Wprowadzona wartość jest za niska": "Wprowadzona wartość jest za niska",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "",
    "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "",
    "Stawka za apartamenty została zaktualizowana.": "Stawka za apartamenty została zaktualizowana.",
    "Pokaż numery stron": "Pokaż numery stron",
    "Tytuł witryny": "",
    "Organizuj": "Organizuj",
    "Zobacz wszystkie": "Zobacz wszystkie",
    "Sekcje dla zalogowanych": "",
    "Kobieta": "",
    "Przywróć": "Przywróć",
    "Dane wydziałów": "Dane wydziałów",
    "Typ strony": "",
    "Dostępne bloki": "",
    "Wpis domyślny": "Wpis domyślny",
    "Witryna została usunięta.": "",
    "Urlop został dodany.": "Urlop został dodany.",
    "Zmień nazwę pliku": "Zmień nazwę pliku",
    "Lewy panel": "Lewy panel",
    "Data przejścia": "Data przejścia",
    "Nieruchomość niestandardowa": "Nieruchomość niestandardowa",
    "MasterCode nieruchomości": "MasterCode nieruchomości",
    "Kreator trasy: ": "Kreator trasy: ",
    "Tytuł kafelka": "",
    "Dodaj slajd": "",
    "Wczytaj zapisany filtr": "Wczytaj zapisany filtr",
    "Wybrana data jest mniejsza niż dozwolona %0.": "Wybrana data jest mniejsza niż dozwolona %0.",
    "Pokaż nieaktywnych właścicieli": "Pokaż nieaktywnych właścicieli",
    "Litery i cyfry": "Litery i cyfry",
    "Klucze": "Klucze",
    "Lista urządzeń na których jesteś zalogowany": "Lista urządzeń na których jesteś zalogowany",
    "Edycja": "Edycja",
    "Statystyki": "Statystyki",
    "Odrzuć": "Odrzuć",
    "Formularz został zaktualizowany.": "Formularz został zaktualizowany.",
    "Lista": "Lista",
    "Usuń materiał z lekcji": "",
    "Szablon nr 1": "",
    "Nazwa przycisku": "",
    "Lista artykułów": "",
    "Szukaj": "Szukaj",
    "Logo firmy": "Logo firmy",
    "Pliki": "",
    "Filtruj": "Filtruj",
    "Data wystąpienia": "",
    "${PriorityName(PriorityEnum[this.task.priority])}": "${PriorityName(PriorityEnum[this.task.priority])}",
    "Lekcja SCORM została dodana.": "",
    "Opublikowane języki": "",
    "Do poziomu": "",
    "Wymagany": "",
    "Udało się usunąć zadania!": "Udało się usunąć zadania!",
    "Co rok": "",
    "Nieopublikowany": "",
    "Data wygaśnięcia": "Data wygaśnięcia",
    "Role użytkownika": "Role użytkownika",
    "Imie i nazwisko": "Imie i nazwisko",
    "Status": "Status",
    "Oznacz wszystkie jako przeczytane": "Oznacz wszystkie jako przeczytane",
    "Wartości statusów": "Wartości statusów",
    "Wznów zadanie": "Wznów zadanie",
    "Przeglądanie logów aktywności": "",
    "Walidacja": "Walidacja",
    "Trasa została rozpoczęta": "Trasa została rozpoczęta",
    "Lista linków": "",
    "Zdecydowanie ważne": "Zdecydowanie ważne",
    "Dodawanie wyposażenia": "Dodawanie wyposażenia",
    "Co 10 minut": "Co 10 minut",
    "Witryna internetowa": "",
    "Powiązane artykuły": "",
    "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "",
    "Zmodyfikowano": "Zmodyfikowano",
    "Odśwież": "Odśwież",
    "Wymeldowanie": "Wymeldowanie",
    "Wybierz pliki": "Wybierz pliki",
    "Użytkownicy": "Użytkownicy",
    "Typ wynagrodzenia": "Typ wynagrodzenia",
    "Dzielenie": "Dzielenie",
    "Co 2 minuty": "Co 2 minuty",
    "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "",
    "Link do rezerwacji": "Link do rezerwacji",
    "Odejmij kwotę": "Odejmij kwotę",
    "Koszt został dodany.": "Koszt został dodany.",
    "Dopasuj do kategorii": "",
    "Nazwa nieruchmości": "Nazwa nieruchmości",
    "Peticion informacion": "Peticion informacion",
    "Konfiguracja bloku została zapisana.": "",
    "Witryna tylko dla zalogowanych użytkowników": "",
    "Uzupełnij luki": "",
    "Zapis został usunięty": "",
    "Stawki nieruchomości": "Stawki nieruchomości",
    "Brak elementów podsumowania": "Brak elementów podsumowania",
    "Wynagrodzenie podstawowe": "Wynagrodzenie podstawowe",
    "Wpis nieprzeczytany": "",
    "Linia": "Linia",
    "Pobierz": "",
    "Usuń publikację": "",
    "Zaopatrzenie zostało zaktualizowane.": "Zaopatrzenie zostało zaktualizowane.",
    "Ważne informacje": "Ważne informacje",
    "Edycja regionu": "Edycja regionu",
    "12 godzin": "12 godzin",
    "Stan licznika końcowego nie może być mniejszy bądź równy w porównaniu do licznika początkującego": "Stan licznika końcowego nie może być mniejszy bądź równy w porównaniu do licznika początkującego",
    "Załaduj": "Załaduj",
    "Zastępstwo wygaśnie za 5 minut.": "Zastępstwo wygaśnie za 5 minut.",
    "Zdecydowanie tak": "Zdecydowanie tak",
    "Kwota opłacona do": "Kwota opłacona do",
    "Ten czat nie posiada przypisanych konkretnych użytkowników.": "",
    "Przywróć użytkownika": "Przywróć użytkownika",
    "Zadowolony": "Zadowolony",
    "Wybierz dzielnice": "Wybierz dzielnice",
    "Tagi:": "Tagi:",
    "Imię i nazwisko właściciela": "Imię i nazwisko właściciela",
    "Rozpocznij zadanie": "Rozpocznij zadanie",
    "Brak sekcji - najpierw utwórz sekcję": "",
    "Nieruchomość jest już przypisana": "Nieruchomość jest już przypisana",
    "Marka": "Marka",
    "Edycja ankiety": "",
    "Zapauzuj zadanie": "Zapauzuj zadanie",
    "Podgląd szablonu e-maila": "Podgląd szablonu e-maila",
    "zacznij pisać aby wyszukać paczkę SCORM...": "",
    "Nazwa serwera": "Nazwa serwera",
    "Google Nexus 10": "",
    "Kwota brakująca": "Kwota brakująca",
    "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.",
    "Powiązane": "Powiązane",
    "Czas realizacji": "Czas realizacji",
    "Brak nowych powiadomień.": "Brak nowych powiadomień.",
    "Wymuś zmianę hasła": "Wymuś zmianę hasła",
    "Data przejścia na nowe API": "Data przejścia na nowe API",
    "Zmodyfikowane przez": "Zmodyfikowane przez",
    "Kwota zniszczeń": "Kwota zniszczeń",
    "Wersje aranżacji": "",
    "Ustawienia podstawowe": "",
    "Id nieruchomości": "Id nieruchomości",
    "Wybrana data jest większa niż dozwolona %0.": "Wybrana data jest większa niż dozwolona %0.",
    "Status dokumentu został zmieniony.": "Status dokumentu został zmieniony.",
    "Wpis został usunięty.": "Wpis został usunięty.",
    "Edytuj datę opuszczenia zespołu": "",
    "Częstotliwość odświeżania": "",
    "Podgląd": "Podgląd",
    "Ustawienia witryny": "",
    "Ustawienia strony": "",
    "Liczba nocy": "Liczba nocy",
    "Program został zaktualizowany.": "",
    "Edycja artykułu": "",
    "Data automatycznej akceptacji": "",
    "Dodanie firmy": "Dodanie firmy",
    "Prawy panel": "Prawy panel",
    "Wynagrodzenie za sprzątanie": "Wynagrodzenie za sprzątanie",
    "Link do raportu": "Link do raportu",
    "Wynagrodzenie za inspecję": "Wynagrodzenie za inspecję",
    "Opis sekcji": "",
    "Edycja ustawień": "",
    "Port": "Port",
    "Nowa umowa": "Nowa umowa",
    "Użytkownik": "Użytkownik",
    "Tagi nieruchomości": "Tagi nieruchomości",
    "Dodaj typ wynagrodzenia": "Dodaj typ wynagrodzenia",
    "Data": "Data",
    "Pokaż na mapie": "Pokaż na mapie",
    "Dodatkowy komentarz do wynagrodzenia": "Dodatkowy komentarz do wynagrodzenia",
    "Opublikowane na wybranej stronie": "",
    "Rozpoczęcie": "",
    "Wybrano 1 plik": "",
    "Opracowane, zapisz": "Opracowane, zapisz",
    "Nie udało się pobrać użytkowników": "Nie udało się pobrać użytkowników",
    "Edycja firmy": "Edycja firmy",
    "Nazwa ścieżki": "",
    "Dodaj zasób": "Dodaj zasób",
    "Lista zespołów": "",
    "Warunki logiczne": "Warunki logiczne",
    "Pierwsza strona": "Pierwsza strona",
    "Usunięte": "Usunięte",
    "Zespół został przypisany do szkolenia.": "",
    "Wyczyść aranżację": "",
    "Słowa oddzielone przecinkami.": "",
    "Default mode": "Default mode",
    "Wybranie strony jest wymagane": "",
    "Powiadomienie dla administratora chatu o nowych wiadomościach": "",
    "Liczba pracowników zatrudnionych tylko w tym mieście": "Liczba pracowników zatrudnionych tylko w tym mieście",
    "Cancelled": "Cancelled",
    "Aktualność została dodana.": "",
    "Zdjęcia": "Zdjęcia",
    "Uruchom zadanie": "Uruchom zadanie",
    "Data dodania": "Data dodania",
    "Zarchiwizowany": "Zarchiwizowany",
    "Wiadomość testowa została wysłana.": "Wiadomość testowa została wysłana.",
    "Numer nieruchomości Avantio": "",
    "Inwentaryzacja": "Inwentaryzacja",
    "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "",
    "Kraj": "Kraj",
    "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "",
    "Informacja o ciasteczkach": "",
    "Wybierz koordynatora": "Wybierz koordynatora",
    "Plik": "",
    "Nieruchomość robocza": "Nieruchomość robocza",
    "Kopiuj": "Kopiuj",
    "Pokój dzienny": "",
    "Link do wybranej strony serwisu": "",
    "Robocizna": "Robocizna",
    "Nie do odzyskania": "Nie do odzyskania",
    "Tekst alternatywny": "Tekst alternatywny",
    "Koordynator Konserwacji": "Koordynator Konserwacji",
    "usuń notatkę": "usuń notatkę",
    "Domyślny": "",
    "Odstęp": "Odstęp",
    "Nazwa dzielnicy": "Nazwa dzielnicy",
    "Wyszukiwana fraza:": "Wyszukiwana fraza:",
    "zacznij pisać aby wyszukać kategorię...": "",
    "Usuń blok z sekcji": "",
    "Ranga": "Ranga",
    "Czyim kosztem jest dodany przedmiot?": "Czyim kosztem jest dodany przedmiot?",
    "Czas": "Czas",
    "Odrzucone": "Odrzucone",
    "Cofam": "Cofam",
    "Subskrypcja": "",
    "Ilość znaków": "Ilość znaków",
    "Excel został wygenerowany i wysłany na adres e-mail": "",
    "Aranżacje": "",
    "Informacje Podstawowe": "Informacje Podstawowe",
    "Zobacz szczegóły sesji użytkownika": "Zobacz szczegóły sesji użytkownika",
    "Sobota": "Sobota",
    "3 godziny": "3 godziny",
    "Rozliczenia pracowników": "Rozliczenia pracowników",
    "Ustawienia powiadomień zostały zaktualizowane.": "Ustawienia powiadomień zostały zaktualizowane.",
    "Adres url do pliku wideo": "",
    "Dark mode": "Dark mode",
    "Ten Miesiąc": "Ten Miesiąc",
    "Mapa": "Mapa",
    "Ilość łóżek dwuosobowe": "Ilość łóżek dwuosobowe",
    "Brak tagów": "Brak tagów",
    "Dane gościa": "Dane gościa",
    "Identyfikator zadania": "Identyfikator zadania",
    "Dodaj do trasy": "Dodaj do trasy",
    "Apple iPhone 5": "",
    "Program": "",
    "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "",
    "Certyfikaty": "",
    "Data zakończenia": "Data zakończenia",
    "Trasy można wykonywać w aplikacji Hi!Renters Mobile": "Trasy można wykonywać w aplikacji Hi!Renters Mobile",
    "Potwierdź akceptację": "Potwierdź akceptację",
    "Czy na pewno chcesz zkopiować szkolenie?": "",
    "Login": "Login",
    "Niepotwierdzeni": "",
    "Zakończone: ${$filters.datetime(route.dateCompletedUtc)}": "Zakończone: ${$filters.datetime(route.dateCompletedUtc)}",
    "Chat": "Chat",
    "Raczej się zgadzam": "Raczej się zgadzam",
    "Pole nie może być puste": "",
    "1 godzina": "1 godzina",
    "Wydział zadania": "Wydział zadania",
    "Wysokość": "Wysokość",
    "ISBN": "",
    "Tło certyfikatu": "",
    "Osoba zastępowana": "Osoba zastępowana",
    "do czasu ręcznego odblokowania": "do czasu ręcznego odblokowania",
    "Ikona": "",
    "Co 30 minut": "Co 30 minut",
    "Zobacz zdjęcia": "Zobacz zdjęcia",
    "Wynagrodzenie": "Wynagrodzenie",
    "Wyrażenie regularne": "Wyrażenie regularne",
    "Osiągnąłeś limit zdjęć. Nie możesz dodać więcej zdjęć": "Osiągnąłeś limit zdjęć. Nie możesz dodać więcej zdjęć",
    "Link przycisku": "",
    "Czy na pewno chcesz usunąć ten kolor?": "Czy na pewno chcesz usunąć ten kolor?",
    "Nie wybrano paczki.": "",
    "Proszę obciążyć gościa": "Proszę obciążyć gościa",
    "Data publikacji": "",
    "Blokowanie użytkowników": "",
    "Dodawanie checklisty": "Dodawanie checklisty",
    "Dodaj pytanie": "",
    "Zmodyfikował": "Zmodyfikował",
    "Numer telefonu": "Numer telefonu",
    "Dział nadrzędny": "Dział nadrzędny",
    "Wybierz tagi": "Wybierz tagi",
    "Kolejne pozycje z lewej strony": "",
    "Wykonaj": "Wykonaj",
    "Wyloguj się": "Wyloguj się",
    "Powiązane zadanie": "",
    "Poniedziałek": "Poniedziałek",
    "Nie mam zdania": "Nie mam zdania",
    "Lista rezerwacji": "Lista rezerwacji",
    "Ładuje...": "Ładuje...",
    "Jesteś pewien?": "Jesteś pewien?",
    "Teraz": "Teraz",
    "Strona została zaktualizowana.": "",
    "Synchronizuj": "",
    "Numer mieszkania (Number)": "",
    "Usunięto użytkownika z czatu": "Usunięto użytkownika z czatu",
    "Nazwa elementu": "",
    "Anuluj edycję": "",
    "Wróć na dół": "Wróć na dół",
    "Pokaż przycisk": "Pokaż przycisk",
    "Nazwa obiektu": "Nazwa obiektu",
    "Uwzględniaj zadania z miesiąca": "Uwzględniaj zadania z miesiąca",
    "Nazwa zespołu": "Nazwa zespołu",
    "Wideo z biblioteki": "",
    "Data logowania": "",
    "Archiwum": "",
    "Zastępstwo wygasło.": "Zastępstwo wygasło.",
    "Typ Firmy": "Typ Firmy",
    "Data przyjazdu": "Data przyjazdu",
    "ID użytkownika": "ID użytkownika",
    "Log błędu": "",
    "Książka": "",
    "Typ serwera": "Typ serwera",
    "Maksimum": "Maksimum",
    "Wybrany region": "Wybrany region",
    "Pobrane z magazynu Renters": "Pobrane z magazynu Renters",
    "Sekcja nie została znaleziona": "",
    "Nazwa zadania": "Nazwa zadania",
    "ID zadania": "ID zadania",
    "Nikomu nie przydzielono uprawnień": "Nikomu nie przydzielono uprawnień",
    "Kwota wynagrodzenia PLN brutto": "Kwota wynagrodzenia PLN brutto",
    "Rola aktywna": "Rola aktywna",
    "Usuń z zespołu": "Usuń z zespołu",
    "Utworzone": "Utworzone",
    "Nie udało się pobrać powiadomień.": "Nie udało się pobrać powiadomień.",
    "Utwórz raport wyników": "",
    "Get it on Appstore": "Get it on Appstore",
    "Nazwa koordynatora": "",
    "Aplikacja nie ma uprawnień do wysyłania powiadomień PUSH": "Aplikacja nie ma uprawnień do wysyłania powiadomień PUSH",
    "Opis kategorii": "",
    "Nazwa autora": "",
    "Certyfikat został dodany.": "",
    "Tłumaczenia": "Tłumaczenia",
    "Liczba": "Liczba",
    "Checkbox": "Checkbox",
    "Treść notatki": "Treść notatki",
    "Miasto zostało usunięte": "Miasto zostało usunięte",
    "+": "+",
    "Statystyki użytkowników": "Statystyki użytkowników",
    "Ustawienia wynagrodzenia zostały zaktualizowane.": "Ustawienia wynagrodzenia zostały zaktualizowane.",
    "Posiadasz niezapisane materiały": "",
    "Nadpisz kwotę": "Nadpisz kwotę",
    "Sortowanie rosnąco": "Sortowanie rosnąco",
    "Rejestr zmian": "Rejestr zmian",
    "Urządzenie zostało usunięte.": "Urządzenie zostało usunięte.",
    "Notatka została dodana.": "Notatka została dodana.",
    "Prawda-Fałsz": "",
    "Dodanie użytkownika": "Dodanie użytkownika",
    "Edytuj": "Edytuj",
    "Usuń filtr": "Usuń filtr",
    "Dodaj formularz": "Dodaj formularz",
    "Zapytanie SQL": "Zapytanie SQL",
    "Akceptacja": "Akceptacja",
    "Podana wartość jest nieprawidłowa.": "Podana wartość jest nieprawidłowa.",
    "Edycja nieruchomości": "Edycja nieruchomości",
    "Niezadowolony": "Niezadowolony",
    "Utwórz zlecenie": "Utwórz zlecenie",
    "Liczba całkowita": "Liczba całkowita",
    "Czas wykonania": "Czas wykonania",
    "Imie i nazwisko: ": "Imie i nazwisko: ",
    "Średnie wynagrodzenie koordynatora": "Średnie wynagrodzenie koordynatora",
    "Kwota jednostkowa": "Kwota jednostkowa",
    "Wyszukaj...": "Wyszukaj...",
    "Edycja zestawu regulaminóe": "",
    "Informacje dodatkowe": "Informacje dodatkowe",
    "Średnie wynagrodzenie pracowników": "Średnie wynagrodzenie pracowników",
    "Tytuł sekcji": "Tytuł sekcji",
    "Blokowanie użytkowników szkoleń": "",
    "Warunkowo": "Warunkowo",
    "Blok aktywny": "",
    "Aktualizuj": "Aktualizuj",
    "Wybierz autora z listy": "",
    "Kolor obramowania": "Kolor obramowania",
    "Urlop": "Urlop",
    "Stwórz czat": "Stwórz czat",
    "Rola została dodana.": "Rola została dodana.",
    "Lista zgłoszeń w tym apartamancie": "Lista zgłoszeń w tym apartamancie",
    "Brak": "Brak",
    "Szczegóły zmiany": "Szczegóły zmiany",
    "Ta nieruchomość nie posiada informacji na temat wyposażenia.": "Ta nieruchomość nie posiada informacji na temat wyposażenia.",
    "Edytuj kategorie": "",
    "Status dokumentu": "",
    "Osoby przypisane jako domyślne do zadań zwiazanych ze sprzątaniem": "Osoby przypisane jako domyślne do zadań zwiazanych ze sprzątaniem",
    "Jest problem": "Jest problem",
    "Adres domenowy": "",
    "i posiadających wymagane uprawnienia": "",
    "Wartość": "Wartość",
    "Dodaj stwierdzenie": "",
    "Tag został dodany.": "Tag został dodany.",
    "co 30 dni": "co 30 dni",
    "Sekcja jest wymagana": "",
    "Przenieś wyżej": "",
    "Komentarz zadania nie może być dłuższy niż 500 znaków.": "Komentarz zadania nie może być dłuższy niż 500 znaków.",
    "Szkolenie jest opublikowane": "",
    "Rozpocznij synchronizację": "Rozpocznij synchronizację",
    "Dane wydziału zostały usunięte.": "Dane wydziału zostały usunięte.",
    "Zadanie zostało uruchomione.": "Zadanie zostało uruchomione.",
    "Dodano zdjęć": "Dodano zdjęć",
    "Kategorie szkoleń": "",
    "Pole \"Nazwisko\" jest wymagane.": "Pole \"Nazwisko\" jest wymagane.",
    "Zabierz dostęp": "Zabierz dostęp",
    "Kategorie": "Kategorie",
    "Typ obciążenia": "Typ obciążenia",
    "Dokument nie jest jeszcze nigdzie opublikowany.": "",
    "Rozpocznij trasę": "Rozpocznij trasę",
    "Wybrano pliki różnych typów. Wybierz pliki tego samego typu.": "",
    "Nazwa tytułu nie może być dłuższa niż 240 znaków ani krótsza niż 3 znaki.": "",
    "Magazynier": "Magazynier",
    "Wielkość kroku": "Wielkość kroku",
    "Dodaj etykietę": "",
    "Firma sprzątająca": "Firma sprzątająca",
    "Jeszcze nie ma kategorii.": "",
    "Aranżacja została zachowana.": "",
    "Edycja dzielnicy": "Edycja dzielnicy",
    "Język domyślny": "",
    "Ogólne": "",
    "Koszty do zadania": "",
    "Dodanie ścieżki szkoleniowej": "",
    "Zaplanowane": "Zaplanowane",
    "Wyczyść": "Wyczyść",
    "Nazwa przycisku ``Dalej``": "Nazwa przycisku ``Dalej``",
    "Szkolenie jest puste": "",
    "Symbol strony": "",
    "Zacznij pisać aby wyszukać kierowcę...": "Zacznij pisać aby wyszukać kierowcę...",
    "Ilość wyników do pobrania": "Ilość wyników do pobrania",
    "Tylko priorytetowe": "",
    "Nie udało się wysłać pliku": "Nie udało się wysłać pliku",
    "Dodaj zdjęcia": "Dodaj zdjęcia",
    "Czas trwania:": "Czas trwania:",
    "Koordynator": "Koordynator",
    "Edycja źródła danych": "Edycja źródła danych",
    "Dane rezerwacji": "Dane rezerwacji",
    "Wersja opublikowana": "",
    "Użytkownik jest liderem zespołu": "Użytkownik jest liderem zespołu",
    "Utworzone przez:": "Utworzone przez:",
    "Użytkownik został usunięty.": "Użytkownik został usunięty.",
    "Deadline - Data wykonania": "",
    "L4": "L4",
    "Opis": "Opis",
    "Nie ma ustalonej roli dla tego wydziału": "Nie ma ustalonej roli dla tego wydziału",
    "Ukryj materiał": "",
    "Pokaż tytuły stron": "Pokaż tytuły stron",
    "Moje filtry": "Moje filtry",
    "Moje czaty": "Moje czaty",
    "Zapamiętaj logowanie": "Zapamiętaj logowanie",
    "Data zdarzenia": "Data zdarzenia",
    "Wartość musi być liczbą ujemną": "Wartość musi być liczbą ujemną",
    "Filtr prywatny": "Filtr prywatny",
    "Zakończ trasę": "Zakończ trasę",
    "Dodaj wszystkich dopasowanych użytkowników": "Dodaj wszystkich dopasowanych użytkowników",
    "Stawka nieruchomości": "",
    "Publikacja została dodana.": "",
    "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.",
    "Godzina zameldowania": "Godzina zameldowania",
    "Zakres czasu": "Zakres czasu",
    "Nazwa katalogu została zmieniona.": "Nazwa katalogu została zmieniona.",
    "Najnowsze": "",
    "Certyfikat nie jest opublikowany": "",
    "Tekst do uzupełnienia": "",
    "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "Aby dodawać członków zespołu musisz najpierw zapisać formularz.",
    "Statusy użytkowników": "Statusy użytkowników",
    "Nr telefonu": "Nr telefonu",
    "Dodaj nowy koszt": "Dodaj nowy koszt",
    "Zmodyfikowane przez użytkownika": "Zmodyfikowane przez użytkownika",
    "Liczba zgłoszonych problemów": "Liczba zgłoszonych problemów",
    "Domyślny kolor trasy (dotyczy kierowców)": "Domyślny kolor trasy (dotyczy kierowców)",
    "Peticion disponibilidad": "Peticion disponibilidad",
    "Brak miast": "Brak miast",
    "Nowa kwota": "Nowa kwota",
    "Łączenie treści": "Łączenie treści",
    "Data wykonania": "Data wykonania",
    "Ten użytkownik nie posiada jeszcze przypisanych dzielnic.": "Ten użytkownik nie posiada jeszcze przypisanych dzielnic.",
    "Niewidoczne": "Niewidoczne",
    "Zadania do wykonania": "Zadania do wykonania",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "",
    "Zapauzowane": "Zapauzowane",
    "Pole może zawierać jedynie cyfry.": "Pole może zawierać jedynie cyfry.",
    "kanał wymagany": "kanał wymagany",
    "Usuń regulamin": "",
    "Podstawowe operacje tekstowe": "Podstawowe operacje tekstowe",
    "Nierozwiązane": "Nierozwiązane",
    "Brak plików w sekcji": "",
    "Brak aktywnego filtru": "Brak aktywnego filtru",
    "Element został dodany.": "",
    "Dashboard": "Dashboard",
    "Odznacz wszystko": "Odznacz wszystko",
    "Nazwa przycisku ``Wstecz``": "Nazwa przycisku ``Wstecz``",
    "z": "",
    "Podstawowe": "Podstawowe",
    "Edycja wielu elementów": "Edycja wielu elementów",
    "Przesyłam...": "Przesyłam...",
    "Liczba wyświetlanych elementów": "",
    "Edycja aranżacji": "",
    "Formularz": "Formularz",
    "Łączny czas wykonywania zadań": "Łączny czas wykonywania zadań",
    "Przypisz do zadania": "",
    "Google Nexus 7": "",
    "Serwer dostępny": "Serwer dostępny",
    "Wybierz artykuł": "",
    "Archiwizuj": "Archiwizuj",
    "BIC/Swift": "BIC/Swift",
    "Koszty zadania zostały zaktualizowane.": "Koszty zadania zostały zaktualizowane.",
    "Wybrano:": "Wybrano:",
    "Dodanie właściciela": "Dodanie właściciela",
    "Przejdź do zlecenia z notatki": "Przejdź do zlecenia z notatki",
    "Dodaj do zestawu": "",
    "Data zakończenia do": "Data zakończenia do",
    "Role": "",
    "Twój token": "Twój token",
    "Publiczne": "Publiczne",
    "Edycja wynagrodzenia mieszanego dla:": "Edycja wynagrodzenia mieszanego dla:",
    "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
    "Przeciągnij i upuść aby posortować pliki": "Przeciągnij i upuść aby posortować pliki",
    "Edycja szablonu": "",
    "Słownik": "Słownik",
    "Wybierz wydział": "Wybierz wydział",
    "To szkolenie znajduje się już w ścieżce szkoleń": "",
    "Trasa została zapisana.": "Trasa została zapisana.",
    "Początkowy stan licznika": "Początkowy stan licznika",
    "Nie można jednocześnie wybrać tagów i zaznaczyć opcji 'Usuń wszystkie tagi'": "",
    "To zadanie dotyczy nieruchomości, która znajduje się na trasie. Czy chcesz przejść do mapy, aby edytować punkt?": "",
    "Rodzaj adresu kanonicznego": "",
    "Nie udało się pobrać listy powiadomień": "Nie udało się pobrać listy powiadomień",
    "Usuń odpowiedź": "",
    "Powiązane zadania": "Powiązane zadania",
    "Nie": "Nie",
    "Zaznacz wszystkie": "Zaznacz wszystkie",
    "Obsługa Klienta (BOK)": "Obsługa Klienta (BOK)",
    "Tak": "Tak",
    "Rozwiązane": "Rozwiązane",
    "Kolor został dodany": "Kolor został dodany",
    "Wybrana liczba jest mniejsza niż dozwolona %0.": "Wybrana liczba jest mniejsza niż dozwolona %0.",
    "Dodaj wiersz": "",
    "Dowolny": "Dowolny",
    "Pokaż nieaktywne nieruchomości": "Pokaż nieaktywne nieruchomości",
    "Dodano użytkownika do czatu": "Dodano użytkownika do czatu",
    "Ta dzielnica jest już przypisana do użytkownika.": "Ta dzielnica jest już przypisana do użytkownika.",
    "Zasoby": "Zasoby",
    "Utworzone przez": "Utworzone przez",
    "Adres kanoniczny": "",
    "Dodaj dni": "Dodaj dni",
    "Zamknięte przez użytkownika o Id": "Zamknięte przez użytkownika o Id",
    "Usuń wiersz": "",
    "Wielokrotnego wyboru": "",
    "Dodanie slajdów": "",
    "Dodaj nową stronę lub wybierz z menu aby edytować.": "",
    "Poprzednia strona": "Poprzednia strona",
    "Pomieszczenie": "Pomieszczenie",
    "Dostęp": "Dostęp",
    "Rola została zaktualizowana.": "Rola została zaktualizowana.",
    "Materiały": "",
    "Widok tygodniowy": "Widok tygodniowy",
    "Dodanie strony": "",
    "Definicja szablonu": "",
    "Stan powiadomienia": "Stan powiadomienia",
    "Uwzględniaj miasta": "Uwzględniaj miasta",
    "Nieruchomości": "Nieruchomości",
    "Bank": "Bank",
    "Usuń pytanie": "",
    "Moje trasy": "Moje trasy",
    "Plik wideo": "",
    "Edytowana wersja": "Edytowana wersja",
    "Edycja testu": "",
    "Dalej": "Dalej",
    "Zespół": "Zespół",
    "Przyczyna": "Przyczyna",
    "Opublikuj tutaj": "",
    "...nie znalazłeś bloku?": "",
    "Definicja formularza znajduje się w obiekcie Form.": "Definicja formularza znajduje się w obiekcie Form.",
    "Liczba dużych prześcieradeł": "Liczba dużych prześcieradeł",
    "Domyślna checklista": "Domyślna checklista",
    "Dodaj Koszt do zadania": "Dodaj Koszt do zadania",
    "Użytkownik został zaktualizowany.": "Użytkownik został zaktualizowany.",
    "Wstaw szablon informacyjny ze zdjęciem": "Wstaw szablon informacyjny ze zdjęciem",
    "Szkic": "Szkic",
    "Data końcowa nie może być wcześniejsza niż data początkowa": "Data końcowa nie może być wcześniejsza niż data początkowa",
    "Legacy mode": "",
    "Wrzesień": "Wrzesień",
    "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "",
    "Utwórz katalog": "Utwórz katalog",
    "Wszystkie typy": "",
    "Zobacz przed opublikowaniem": "",
    "Raport został wysłany na adres e-mail": "Raport został wysłany na adres e-mail",
    "Wybranie katalogu jest wymagane": "",
    "Nie udało się pobrać listy modułów": "",
    "Trasa została wznowiona": "Trasa została wznowiona",
    "Zapisz wersję": "",
    "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "",
    "Zacznij pisać numer aby wyszukać źródło rezerwacji...": "Zacznij pisać numer aby wyszukać źródło rezerwacji...",
    "Slajder został usunięty.": "",
    "Satysfakcja": "Satysfakcja",
    "Formularz kontaktowy": "",
    "Utwórz nowy": "",
    "Dodaj slajder": "",
    "Separator elementów w tytule": "",
    "Wyloguj": "Wyloguj",
    "Przypisane miasta:": "Przypisane miasta:",
    "Notatka magazyniera": "Notatka magazyniera",
    "Wyszukaj blok": "",
    "Usunięcie": "Usunięcie",
    "Nie udało się usunąć użytkownika z czatu": "Nie udało się usunąć użytkownika z czatu",
    "Statystyki regionalne - miasta": "Statystyki regionalne - miasta",
    "Nazwa konta (Klucz dostępu)": "Nazwa konta (Klucz dostępu)",
    "Aktywność": "Aktywność",
    "Nazwa szkolenia": "",
    "Ustawienia sekcji \"%0\"": "",
    "Id rezerwacji:": "",
    "Losowa kolejność elementów": "",
    "Edycja Notatki": "Edycja Notatki",
    "Wstaw z góry": "Wstaw z góry",
    "Standard 2004": "",
    "Mieszane": "Mieszane",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "",
    "Dodaj serwer": "Dodaj serwer",
    "Listopad": "Listopad",
    "obrót": "obrót",
    "Dodaj ścieżkę": "",
    "Wybierz kategorię": "Wybierz kategorię",
    "Nazwa paczki": "",
    "Aktualne urządzenie": "Aktualne urządzenie",
    "Priorytet": "Priorytet",
    "Edytuj zestaw": "",
    "Ustawienia zaawansowane": "Ustawienia zaawansowane",
    "Średnie wynagrodzenie pracownika": "Średnie wynagrodzenie pracownika",
    "Jedna kolumna": "Jedna kolumna",
    "Adres aktywnej strony": "",
    "Noclegi": "Noclegi",
    "Przypisane regiony:": "Przypisane regiony:",
    "Edytuj dział": "Edytuj dział",
    "Rozmiar zdjęcia został zmieniony.": "Rozmiar zdjęcia został zmieniony.",
    "Pole może zawierać jedynie litery i cyfry.": "Pole może zawierać jedynie litery i cyfry.",
    "Moje dokumenty": "",
    "Planowana data wykonania": "Planowana data wykonania",
    "Edycja tagu nieruchomości": "Edycja tagu nieruchomości",
    "Otwórz stronę w nowym oknie": "",
    "Dodano": "Dodano",
    "Data dodania inwentaryzacji": "Data dodania inwentaryzacji",
    "Edycja roli": "Edycja roli",
    "Dołączanie...": "Dołączanie...",
    "Czy zablokować użytkownika i jego wiadomość?": "Czy zablokować użytkownika i jego wiadomość?",
    "Typ plików jest wymagany": "",
    "Ogólne informacje": "",
    "Szerokość": "Szerokość",
    "URL": "",
    "Edytuj stawkę za godzinę": "Edytuj stawkę za godzinę",
    "Lista regulaminów": "",
    "Imię gościa": "Imię gościa",
    "Przenieś wybrane": "Przenieś wybrane",
    "Lista ścieżek szkoleniowych": "",
    "Oraz nowe hasło": "Oraz nowe hasło",
    "Dodaj tag nieruchomości": "Dodaj tag nieruchomości",
    "Zestaw został zaktualizowany.": "",
    "Serwer został usunięty.": "Serwer został usunięty.",
    "wybierz szablon": "",
    "Porównaj %0": "Porównaj %0",
    "Nie wybrano strony": "",
    "Status edytowanej wersji dokumentu": "Status edytowanej wersji dokumentu",
    "Edycja strony": "",
    "Jestem w pracy": "Jestem w pracy",
    "W pracy": "W pracy",
    "Poza pracą": "Poza pracą",
    "Status pracy": "Status pracy",
    "Przejdź do zadania": "Przejdź do zadania",
    "Jesteś w pracy. Kliknij, aby ustawić status Poza pracą": "Jesteś w pracy. Kliknij, aby ustawić status Poza pracą",
    "Jesteś poza pracą. Kliknij, aby ustawić status W pracy": "Jesteś poza pracą. Kliknij, aby ustawić status W pracy",
    "Zaloguj się loginem i hasłem": "Zaloguj się loginem i hasłem",
    "Zakończyć pracę?": "Zakończyć pracę?",
    "Masz rozpoczęte zadanie:": "Masz rozpoczęte zadanie:",
    "Po wyłączeniu statusu nie będziesz mógł rozpoczynać zadań.": "Po wyłączeniu statusu nie będziesz mógł rozpoczynać zadań.",
    "Zakończ pracę": "Zakończ pracę",
    "Aby rozpocząć zadanie, musisz mieć włączony status \"W pracy\".": "Aby rozpocząć zadanie, musisz mieć włączony status \"W pracy\".",
    "Status zostanie włączony automatycznie, a zadanie rozpocznie się od razu.": "Status zostanie włączony automatycznie, a zadanie rozpocznie się od razu.",
    "Włącz i rozpocznij zadanie": "Włącz i rozpocznij zadanie",
    "Zadanie pozostanie rozpoczęte. Pamiętaj, aby je zakończyć lub zapauzować.": "Zadanie pozostanie rozpoczęte. Pamiętaj, aby je zakończyć lub zapauzować.",
    "Nie jesteś w pracy": "Nie jesteś w pracy",
    "Dopasuj do obrazka": "",
    "Punkty": "",
    "Zmień hasło": "Zmień hasło",
    "Nie udało się pobrać listy aranżacji": "",
    "wybierz": "wybierz",
    "Opiekun ścieżki": "",
    "Powtórz hasło": "Powtórz hasło",
    "Czwartek": "Czwartek",
    "Nowe hasło": "Nowe hasło",
    "Dodawanie trasy": "Dodawanie trasy",
    "Dodaj trasę": "Dodaj trasę",
    "Strona główna": "Strona główna",
    "VAT": "",
    "Pokaż etykietę": "Pokaż etykietę",
    "Data modyfikacji od": "Data modyfikacji od",
    "Wyrażenia warunkowe": "Wyrażenia warunkowe",
    "Potwierdź zapis do aktualnej wersji": "",
    "Dział został dodany.": "Dział został dodany.",
    "Opracowane": "Opracowane",
    "Wysłane wezwanie do zapłaty": "Wysłane wezwanie do zapłaty",
    "Podpis": "Podpis",
    "Data początkowa nie może być późniejsza niż data końcowa": "Data początkowa nie może być późniejsza niż data końcowa",
    "Nieruchomość niestandardowa o Id": "Nieruchomość niestandardowa o Id",
    "Dodaj zastępstwo": "Dodaj zastępstwo",
    "Zastępstwo zostało dodane.": "Zastępstwo zostało dodane.",
    "Planowanie inwentaryzacji": "Planowanie inwentaryzacji",
    "Kategoria wyszukiwanego matariału": "",
    "Powiadomienia": "Powiadomienia",
    "Edycja wynagrodzenia stałego dla:": "Edycja wynagrodzenia stałego dla:",
    "Data ostatniej zmiany statusu": "Data ostatniej zmiany statusu",
    "Aby zakończyć trasę należy uzupełnić stan licznika na koniec": "Aby zakończyć trasę należy uzupełnić stan licznika na koniec",
    "Osoby przypisane jako domyślne do zadań zwiazanych z konserwacją": "Osoby przypisane jako domyślne do zadań zwiazanych z konserwacją",
    "Pliki zostały dodane": "",
    "Ustawienia ogólne": "Ustawienia ogólne",
    "Okładka": "",
    "Konserwacja": "Konserwacja",
    "Publikuj od": "",
    "Do sprawdzenia": "Do sprawdzenia",
    "Pliki prywatne": "Pliki prywatne",
    "Dodanie linku": "",
    "Czas trwania blokady": "Czas trwania blokady",
    "Stwórz nowy czat": "Stwórz nowy czat",
    "Nieopłacone/dłużnik": "Nieopłacone/dłużnik",
    "Wyświetl materiały": "",
    "Chat został zarchiwizowany.": "Chat został zarchiwizowany.",
    "Reżyseria": "",
    "Zablokowano możliwość edycji": "Zablokowano możliwość edycji",
    "IBAN": "IBAN",
    "Nie udało się pobrać listy typów modeli": "Nie udało się pobrać listy typów modeli",
    "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.",
    "Nazwa pliku": "Nazwa pliku",
    "Data zakończenia blokady konta": "Data zakończenia blokady konta",
    "Kategoria": "Kategoria",
    "Autor": "Autor",
    "Wybierz": "Wybierz",
    "Ilość koordynatorów w regionie": "Ilość koordynatorów w regionie",
    "Lista paczek SCORM": "",
    "Brak modułu": "",
    "Ukończone przez użytkownika o Id": "Ukończone przez użytkownika o Id",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.",
    "Zaloguj się na swoje konto": "",
    "Wideo": "",
    "W zespole od": "",
    "Potwierdzam, zapisz": "Potwierdzam, zapisz",
    "Wróć do logowania": "Wróć do logowania",
    "Suma Wynagrodzeń": "Suma Wynagrodzeń",
    "Grudzień": "Grudzień",
    "Najniższy": "",
    "Kuchnia": "",
    "Usuń element": "Usuń element",
    "Facturada": "Facturada",
    "Usunięte przez": "Usunięte przez",
    "Rodzaj kosztu": "Rodzaj kosztu",
    "Zastępuje osobę": "Zastępuje osobę",
    "Inspektor": "Inspektor",
    "Filtry powiadomień": "Filtry powiadomień",
    "Dodaj stronę": "Dodaj stronę",
    "Data ostatniej inwentaryzacji": "Data ostatniej inwentaryzacji",
    "Co 15 minut": "Co 15 minut",
    "Dane osobowe": "Dane osobowe",
    "Dopasowanie": "",
    "Data odrzucenia": "",
    "Formularz zarchiwizowany": "Formularz zarchiwizowany",
    "Wyzeruj licznik": "Wyzeruj licznik",
    "Kwota średnia": "Kwota średnia",
    "Nie podano nazwy poprzedniej kategorii.": "",
    "Dodaj obrazek": "",
    "Wybrany język": "Wybrany język",
    "Akceptuj": "Akceptuj",
    "Aby rozpocząć trasę należy uzupełnić stan licznika na start": "Aby rozpocząć trasę należy uzupełnić stan licznika na start",
    "Stan licznika nie może być wartością ujemną": "Stan licznika nie może być wartością ujemną",
    "Standard nieznany": "",
    "Data aktualizacji": "Data aktualizacji",
    "Stwierdzenia": "",
    "Legenda": "",
    "Przejdź do zadania z notatki": "Przejdź do zadania z notatki",
    "Pokaż tytuł sekcji": "Pokaż tytuł sekcji",
    "Trzy kolumny": "Trzy kolumny",
    "Ścieżka nawigacyjna": "",
    "Edytuj test": "",
    "Kontakty - Typ działania": "Kontakty - Typ działania",
    "Ten użytkownik nie posiada jeszcze przypisanych miast.": "Ten użytkownik nie posiada jeszcze przypisanych miast.",
    "Osoby przypisane jako domyślne do zadań zwiazanych z inspekcją": "Osoby przypisane jako domyślne do zadań zwiazanych z inspekcją",
    "24 godziny": "24 godziny",
    "Inna": "Inna",
    "Szczegóły zdarzenia nr %0": "Szczegóły zdarzenia nr %0",
    "Tytuł strony": "",
    "Dodanie formularza": "Dodanie formularza",
    "Wyloguj zalogowanego obecnie użytkownika": "Wyloguj zalogowanego obecnie użytkownika",
    "Potwierdzenie archiwizacji": "Potwierdzenie archiwizacji",
    "Dodaj pliki": "",
    "źródło zostało usunięte.": "źródło zostało usunięte.",
    "Uwzględnij wydziały i statusy jednocześnie": "Uwzględnij wydziały i statusy jednocześnie",
    "Włącz system powiadomień": "Włącz system powiadomień",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".",
    "Wygeneruj plik": "Wygeneruj plik",
    "Nie pokazuj linku do archiwum strony (NoArchive)": "",
    "Nazwa roli": "Nazwa roli",
    "Organizacja": "Organizacja",
    "${title}": "${title}",
    "Usuń z trasy": "Usuń z trasy",
    "Serwery plików": "Serwery plików",
    "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "",
    "Ten Tydzień": "Ten Tydzień",
    "Element został usunięty.": "Element został usunięty.",
    "Co 2 tygodnie": "Co 2 tygodnie",
    "Co tydzień": "Co tydzień",
    "Zlecenie": "Zlecenie",
    "Właściciel został zaktualizowany.": "Właściciel został zaktualizowany.",
    "Radio": "Radio",
    "Lekcja ukryta": "",
    "Suma wynagrodzeń": "Suma wynagrodzeń",
    "Koordynator*": "",
    "Nie udało się dodać użytkownika do czatu": "Nie udało się dodać użytkownika do czatu",
    "Aktywne": "Aktywne",
    "Nazwa strony": "",
    "Uwzględniaj tagi": "Uwzględniaj tagi",
    "Google Nexus 5": "",
    "Brakujące tytuły kafelków.": "",
    "Kwota pobrana": "Kwota pobrana",
    "Dodaj media": "Dodaj media",
    "Ikona wyświetlana jest w postaci kwadratu.": "",
    "Edycja aktualności": "",
    "Dane został wgrane": "Dane został wgrane",
    "Pokaż cały błąd": "",
    "Wybrana liczba jest większa niż dozwolona %0.": "Wybrana liczba jest większa niż dozwolona %0.",
    "Krótki opis": "",
    "Komentarz dotyczący naprawy problemu": "Komentarz dotyczący naprawy problemu",
    "Strony": "",
    "Serial telewizyjny": "",
    "Wyszukaj wszędzie": "Wyszukaj wszędzie",
    "Hasło (Klucz ukryty)": "Hasło (Klucz ukryty)",
    "Ustawienia chatów": "Ustawienia chatów",
    "Filtr został zapisany": "Filtr został zapisany",
    "Odpowiedź 3": "Odpowiedź 3",
    "Edycja serwera": "Edycja serwera",
    "Nie przypisano": "Nie przypisano",
    "Wykonaj akcję": "Wykonaj akcję",
    "Czaty": "Czaty",
    "Dodaj katalog": "",
    "Firma została usunięta.": "Firma została usunięta.",
    "Data wymeldowania do": "Data wymeldowania do",
    "Konta publiczne": "",
    "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.",
    "Pole \"%0\" jest wymagane.": "Pole \"%0\" jest wymagane.",
    "Nie udało się pobrać listy stron": "",
    "Jeśli pole jest puste to wstawiana automatycznie.": "",
    "Płyta z muzyką": "",
    "Tagi zadań": "Tagi zadań",
    "Próg zaliczenia (%)": "",
    "Wybierz autora": "",
    "Co 10 dni": "Co 10 dni",
    "Konfiguracja harmonogramu": "Konfiguracja harmonogramu",
    "Repozytorium plików": "Repozytorium plików",
    "Usuń kafelek": "",
    "Musisz najpierw zapisać zmienioną kolejność punktów zanim oznaczysz punkt": "Musisz najpierw zapisać zmienioną kolejność punktów zanim oznaczysz punkt",
    "Kalendarz pracowników": "",
    "Przypisane tagi: ": "Przypisane tagi: ",
    "Dodaj Zadanie": "Dodaj Zadanie",
    "Obok siebie": "Obok siebie",
    "Potwierdź wyłączenie publikacji": "",
    "Ilość kosztów": "Ilość kosztów",
    "Co 6 godzin": "Co 6 godzin",
    "Czat": "Czat",
    "Imię": "Imię",
    "Kolory rezerwacji": "Kolory rezerwacji",
    "Proszę obciążyć właściciela obiektu": "Proszę obciążyć właściciela obiektu",
    "Usuń trasę": "Usuń trasę",
    "Zacznij pisać aby wyszukać właściciela...": "Zacznij pisać aby wyszukać właściciela...",
    "Slajdy": "",
    "Dzielnica nieruchomości": "Dzielnica nieruchomości",
    "Resetuj": "Resetuj",
    "Urlop został usunięty": "Urlop został usunięty",
    "Host dodatkowy": "Host dodatkowy",
    "Komentarz": "Komentarz",
    "Status notatki": "Status notatki",
    "Witryna została zaktualizowana.": "",
    "Imię i nazwisko": "Imię i nazwisko",
    "Zacznij pisać numer aby wyszukać rezerwację...": "Zacznij pisać numer aby wyszukać rezerwację...",
    "Zdecydowanie się zgadzam": "Zdecydowanie się zgadzam",
    "Element został przywrócony.": "Element został przywrócony.",
    "Wymagaj kolejności zaliczania elementów": "",
    "co rok": "co rok",
    "Zajawka": "",
    "Zestaw niestandardowy": "",
    "Edycja lekcji": "",
    "Co minutę": "Co minutę",
    "Open Graph": "",
    "Role i uprawnienia": "Role i uprawnienia",
    "Coś poszło nie tak": "Coś poszło nie tak",
    "Data wymeldowania od": "Data wymeldowania od",
    "Nazwa przycisku ``Wyślij``": "Nazwa przycisku ``Wyślij``",
    "Rezerwacje anulowane": "Rezerwacje anulowane",
    "Dane": "Dane",
    "zacznij pisać aby wyszukać certyfikat...": "",
    "Wyżej": "",
    "Nie udało się pobrać listy zastępstw": "Nie udało się pobrać listy zastępstw",
    "Id sesji": "Id sesji",
    "Opłacono": "Opłacono",
    "Przekroczono dozwoloną ilość znaków: %0.": "Przekroczono dozwoloną ilość znaków: %0.",
    "Inwentaryzacja została zaktualizowana.": "Inwentaryzacja została zaktualizowana.",
    "Bułgarski": "Bułgarski",
    "Ok": "Ok",
    "Nazwa certyfikatu": "",
    "Edycja właściciela": "Edycja właściciela",
    "Data rezerwacji do": "Data rezerwacji do",
    "Domyślne ustawienie dla witryny": "",
    "znaki": "znaki",
    "Edycja slajdów": "",
    "Data Zmiany": "Data Zmiany",
    "Niżej": "",
    "Pytanie i odpowiedzi": "",
    "Wgraj plik": "Wgraj plik",
    "Odpowiedź 1": "Odpowiedź 1",
    "Przypisani użytkownicy": "Przypisani użytkownicy",
    "Miejsce logowania": "Miejsce logowania",
    "Wróć do strony głównej": "Wróć do strony głównej",
    "Użytkownik Sprzatanie": "Użytkownik Sprzatanie",
    "Laptop 17\"": "",
    "Ukraiński": "Ukraiński",
    "6 godzin": "6 godzin",
    "Koszt został zaktualizowany.": "Koszt został zaktualizowany.",
    "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "",
    "Imię lub nazwisko właściciela": "",
    "W zespole od %0": "W zespole od %0",
    "Adres IP": "Adres IP",
    "Konfiguracja": "",
    "Profil użytkownika": "Profil użytkownika",
    "Notatki Koordynatorów": "Notatki Koordynatorów",
    "Ilość nocy": "Ilość nocy",
    "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "",
    "Trasa została zakończona": "Trasa została zakończona",
    "Czy opublikowany": "",
    "Zaakceptowane": "Zaakceptowane",
    "Niewykonane zadania": "Niewykonane zadania",
    "Edytuj kolor": "Edytuj kolor",
    "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.",
    "Strona lekcji SCORM opublikowana": "",
    "Nieaktywni właściciele": "Nieaktywni właściciele",
    "Data następnej inwentaryzacji": "Data następnej inwentaryzacji",
    "Przetestuj ustawienia poczty": "Przetestuj ustawienia poczty",
    "Wszystkie kategorie": "Wszystkie kategorie",
    "Odpowiedzi": "Odpowiedzi",
    "Kalendarz Pracowniczy": "Kalendarz Pracowniczy",
    "Element": "",
    "Brak dodanych punktów trasy": "Brak dodanych punktów trasy",
    "Słownik dowolny": "Słownik dowolny",
    "Nazwa witryny": "",
    "Raporty": "Raporty",
    "Dodaj kategorie": "",
    "Synchronizuj razem z anulowanymi": "Synchronizuj razem z anulowanymi",
    "Pytanie 2": "Pytanie 2",
    "Zrób zdjęcie": "Zrób zdjęcie",
    "Numer domu": "Numer domu",
    "Ilość toalet": "Ilość toalet",
    "Dodaj zadanie: inspekcja": "Dodaj zadanie: inspekcja",
    "ID": "ID",
    "Przycisk": "",
    "Wysłane powiadomienie": "",
    "co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)": "co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)",
    "Nie udało się zapisać komentarza": "",
    "Powiadomienie o oczekującym szkoleniu": "",
    "Pokaż zdjęcie w raporcie": "Pokaż zdjęcie w raporcie",
    "zacznij pisać aby wyszukać użytkownika...": "zacznij pisać aby wyszukać użytkownika...",
    "Zaznacz": "Zaznacz",
    "Historia zmian": "Historia zmian",
    "Dodaj nieruchomość do trasy": "Dodaj nieruchomość do trasy",
    "Rozwiń do": "",
    "Wstaw z lewej strony": "Wstaw z lewej strony",
    "Kopiuj filtr": "Kopiuj filtr",
    "Nieaktywne": "Nieaktywne",
    "Ilość zadań": "Ilość zadań",
    "Hasło zostało zmienione. Zaloguj się ponownie": "Hasło zostało zmienione. Zaloguj się ponownie",
    "Nazwa wydziału": "Nazwa wydziału",
    "Poziomo": "",
    "Bardzo zadowolony": "Bardzo zadowolony",
    "Zacznij pisać aby wyszukać...": "Zacznij pisać aby wyszukać...",
    "Nie udało się pobrać danych odnośnie rezerwacji i zadań": "Nie udało się pobrać danych odnośnie rezerwacji i zadań",
    "Publikacja została usunięta.": "",
    "Zlecenie zostało utworzone.": "Zlecenie zostało utworzone.",
    "Podaj adres url...": "",
    "KRS": "KRS",
    "Przedrostek": "Przedrostek",
    "Galeria zdjęć": "",
    "Bloki": "",
    "Pytanie": "",
    "Od poziomu": "",
    "Nie udało się zapisać szablonu": "Nie udało się zapisać szablonu",
    "Strona testu opublikowana": "",
    "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "",
    "Stworzone przez użytkownika": "Stworzone przez użytkownika",
    "Wstaw przycisk": "",
    "Id checklisty": "Id checklisty",
    "Region apartamentu": "Region apartamentu",
    "Nie udało się utworzyć zlecenia.": "Nie udało się utworzyć zlecenia.",
    "5": "",
    "Bardzo niezadowolony": "Bardzo niezadowolony",
    "Cron": "Cron",
    "Dzielnica została zaktualizowana.": "Dzielnica została zaktualizowana.",
    "Luty": "Luty",
    "Włącz social media": "",
    "Monitor aktywności": "",
    "Utworzono przez: ": "Utworzono przez: ",
    "Drugie imię": "Drugie imię",
    "Typ elementu": "",
    "Podaj dane autora": "",
    "${(ex as any).response.data.errors.message[0]}": "${(ex as any).response.data.errors.message[0]}",
    "Usuń kategorię": "",
    "Po przejściu na mapę zadanie zostanie usunięte.": "",
    "Typ pola": "Typ pola",
    "Opracowanie kosztu": "Opracowanie kosztu",
    "Dodanie miasta": "Dodanie miasta",
    "Katalog linków": "",
    "Przypisani użytkownicy:": "",
    "Elementy": "",
    "Dane wydziału zostały dodane.": "Dane wydziału zostały dodane.",
    "Zapisz": "Zapisz",
    "Kwota kosztu od": "Kwota kosztu od",
    "Pobierz plik": "Pobierz plik",
    "Data wznowienia": "Data wznowienia",
    "zacznij pisać aby wyszukać szkolenie...": "",
    "Imię klienta": "Imię klienta",
    "Opis obrazka": "",
    "Edycja ustawień wynagrodzenia dla:": "Edycja ustawień wynagrodzenia dla:",
    "Usuń obrazek": "",
    "Wymagane": "Wymagane",
    "Lista jest pusta": "Lista jest pusta",
    "Porównywana wersja": "Porównywana wersja",
    "Edytuj lekcje SCORM": "",
    "Zacznij pisać aby wyszukać region...": "Zacznij pisać aby wyszukać region...",
    "Nazwisko i Imię": "Nazwisko i Imię",
    "Region został usunięty": "Region został usunięty",
    "Stwórz zadanie z notatki": "Stwórz zadanie z notatki",
    "Edytuj sekcję": "",
    "Dostępne języki": "",
    "Wybierz dział": "Wybierz dział",
    "Usuń slajd": "",
    "Lista certyfikatów": "",
    "Niestandardowy adres strony": "",
    "Dodatkowe wynagrodzenie - komentarz": "Dodatkowe wynagrodzenie - komentarz",
    "Nazwa slajdu": "",
    "Data utworzenia do": "Data utworzenia do",
    "Ten zespół nie posiada jeszcze żadnych członków.": "Ten zespół nie posiada jeszcze żadnych członków.",
    "Harmonogram": "Harmonogram",
    "Za przepracowane godziny": "Za przepracowane godziny",
    "Wynagrodzenie PLN brutto": "Wynagrodzenie PLN brutto",
    "Symbol": "",
    "Zaznacz wszystko ": "Zaznacz wszystko ",
    "Witryna została dodana.": "",
    "Lista punktów": "Lista punktów",
    "Środa": "Środa",
    "Zwierzątko": "",
    "Są to wszystkie obiekty, nawet te, które posiadają już właściciela.": "Są to wszystkie obiekty, nawet te, które posiadają już właściciela.",
    "Ukryj filtry": "Ukryj filtry",
    "Typ zestawu": "",
    "Edycja certyfikatu": "",
    "Wpisz kwotę": "Wpisz kwotę",
    "Testowy adres email": "Testowy adres email",
    "Szablon": "",
    "Wynagrodzenie stałe miesięczne": "Wynagrodzenie stałe miesięczne",
    "Udało się zaktualizować zadania!": "Udało się zaktualizować zadania!",
    "Ostateczne wynagrodzenie:": "Ostateczne wynagrodzenie:",
    "Nie udało się dodać pliku typu ": "Nie udało się dodać pliku typu ",
    "Nieruchomość została dodana.": "Nieruchomość została dodana.",
    "Standard": "",
    "E-mail": "E-mail",
    "Miesiąc edycji wynagrodzenia": "Miesiąc edycji wynagrodzenia",
    "Edytuj lekcje wideo": "",
    "Edycja trasy": "Edycja trasy",
    "Powrót do historii": "Powrót do historii",
    "Nazwa domyślnej checklisty": "Nazwa domyślnej checklisty",
    "Moje zadania": "Moje zadania",
    "Link został usunięty.": "",
    "Ustawienia": "Ustawienia",
    "Nie udało się dodać miasta lub dzielnicy": "Nie udało się dodać miasta lub dzielnicy",
    "Dodaj lekcję Wideo": "",
    "Apple iPad": "",
    "Nie ma żadnych etykiet dla wybranej daty": "Nie ma żadnych etykiet dla wybranej daty",
    "Sekcja została usunięta": "",
    "Zdjęcie główne": "",
    "Aktualność została zaktualizowana.": "",
    "Liczba pracowników w regionie": "Liczba pracowników w regionie",
    "Slajd został usunięty.": "",
    "Notatka została usunięta.": "Notatka została usunięta.",
    "Filtry map": "Filtry map",
    "Wysłane": "Wysłane",
    "Pole może zawierać jedynie litery.": "Pole może zawierać jedynie litery.",
    "Nie udało się pobrać listy kolejek": "Nie udało się pobrać listy kolejek",
    "Stack Trace": "",
    "Stwierdzenie": "Stwierdzenie",
    "Data utworzenia zadania": "",
    "Wyczyść filtry": "Wyczyść filtry",
    "Zobacz szczegóły zdarzenia": "Zobacz szczegóły zdarzenia",
    "Ustawienia Domyślne": "Ustawienia Domyślne",
    "Firma została dodana.": "Firma została dodana.",
    "Całkowity dystans (km)": "Całkowity dystans (km)",
    "Checklista została zaktualizowana.": "Checklista została zaktualizowana.",
    "Brak kategorii nadrzędnej": "",
    "Przyjazd": "Przyjazd",
    "Wyczyść defaultowych użytkowników": "Wyczyść defaultowych użytkowników",
    "Automatyczna akceptacja": "",
    "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.",
    "Liczba szkoleń w ścieżce": "",
    "Data wyjazdu": "Data wyjazdu",
    "Dodanie zestawu regulaminów": "",
    "Kategoria materiałów": "",
    "Edytuj slajder": "",
    "Szukana fraza": "Szukana fraza",
    "Punkt został oznaczony": "Punkt został oznaczony",
    "Akcje": "Akcje",
    "Wstaw cztery kolumny 1/4": "Wstaw cztery kolumny 1/4",
    "Podsumowanie": "Podsumowanie",
    "Miesiące": "Miesiące",
    "Marketing": "",
    "Co 4 miesiące": "Co 4 miesiące",
    "Wyrażone zgody": "",
    "Sierpień": "Sierpień",
    "Potwierdzenie zmiany statusu": "Potwierdzenie zmiany statusu",
    "Film": "",
    "Wymagane jest wybranie źródła danych": "Wymagane jest wybranie źródła danych",
    "Obciążenie Gościa": "Obciążenie Gościa",
    "Numer rezerwacji Avantio": "",
    "Nie udało się pobrać listy wydziałów": "Nie udało się pobrać listy wydziałów",
    "Pozycja": "Pozycja",
    "Strona ukryta": "",
    "wybierz...": "wybierz...",
    "Certyfikat został zaktualizowany.": "",
    "Wybrana ikona powinna być kwadratem": "",
    "Wybierz serwer": "Wybierz serwer",
    "Zarządzaj zespołami": "",
    "Zwrócony": "Zwrócony",
    "Wiadomość została ukryta.": "Wiadomość została ukryta.",
    "Kolor trasy": "",
    "Potwierdzenie przywrócenia": "Potwierdzenie przywrócenia",
    "Data nieobecności do": "Data nieobecności do",
    "Dowolna data": "Dowolna data",
    "Zmiana hasła": "Zmiana hasła",
    "Pole \"Drugie imię\" jest wymagane.": "Pole \"Drugie imię\" jest wymagane.",
    "Resetuj filtry": "Resetuj filtry",
    "Zaawansowane": "",
    "Nie możesz wpływać na kolejność punktów już oznaczonych jako odwiedzone": "Nie możesz wpływać na kolejność punktów już oznaczonych jako odwiedzone",
    "Automatyczny": "",
    "Aktywne kanały komunikacji": "Aktywne kanały komunikacji",
    "Nieruchomość została usunięta.": "Nieruchomość została usunięta.",
    "ID lub typ zadania": "ID lub typ zadania",
    "Tło przycisku": "",
    "Lista koordynatorów": "",
    "Lekcja wideo została dodana.": "",
    "Nie znaleziono żadnych wyników.": "Nie znaleziono żadnych wyników.",
    "Back Office": "Back Office",
    "Szkolenie rozpoczyna się": "",
    "Nazwa grupy": "",
    "ŚREDNIA": "ŚREDNIA",
    "Niemiecki": "Niemiecki",
    "Data akceptacji": "",
    "Wymiary": "Wymiary",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Liczba pracowników pracujących w więcej niż jednym regionie",
    "Ostatnia aktywność": "Ostatnia aktywność",
    "Dodaj wszystkie z kategorii": "",
    "Widoczność": "Widoczność",
    "Uwzględniaj nieruchomości": "Uwzględniaj nieruchomości",
    "Host": "Host",
    "Id zdarzenia": "Id zdarzenia",
    "Długość": "",
    "Rok": "Rok",
    "Dodaj nowy": "",
    "Edycja wynagrodzenia": "Edycja wynagrodzenia",
    "słowa": "słowa",
    "Wersje": "Wersje",
    "Dodanie": "Dodanie",
    "Zablokowany": "Zablokowany",
    "Więcej...": "Więcej...",
    "Dodaj zdjęcia do wiadomości": "Dodaj zdjęcia do wiadomości",
    "Ten punkt został już odwiedzony": "Ten punkt został już odwiedzony",
    "Dodaj premię": "Dodaj premię",
    "Płeć": "",
    "Dodaj link": "",
    "Zespół został dodany.": "Zespół został dodany.",
    "Przejdź do mapy": "Przejdź do mapy",
    "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "",
    "Opublikowany": "",
    "Data rezerwacji od": "Data rezerwacji od",
    "Porównaj z edytowaną wersją": "Porównaj z edytowaną wersją",
    "Symbol lekcji": "",
    "Numer aktywnej strony": "",
    "Wpis został zaktualizowany.": "Wpis został zaktualizowany.",
    "Co miesiąc": "Co miesiąc",
    "Sprawdzenie czy pusty": "Sprawdzenie czy pusty",
    "Właściciel został dodany.": "Właściciel został dodany.",
    "Pracownicy": "Pracownicy",
    "Historia zadania": "Historia zadania",
    "Nieobecność od": "Nieobecność od",
    "Kategoria została zaktualizowana.": "Kategoria została zaktualizowana.",
    "Całkowity czas": "Całkowity czas",
    "Przetwarzane": "Przetwarzane",
    "Data zmiany statusu do": "Data zmiany statusu do",
    "Przejdź do Checklisty": "Przejdź do Checklisty",
    "Slajder został zaktualizowany.": "",
    "Kwota rezerwacji": "Kwota rezerwacji",
    "Wybierz język": "",
    "Zacznij pisać aby wyszukać miasto...": "Zacznij pisać aby wyszukać miasto...",
    "Element opublikowany": "",
    "30 minut": "30 minut",
    "Dodanie roli": "Dodanie roli",
    "Lekcja została zaktualizowana.": "",
    "Wysyłaj tym kanałem": "Wysyłaj tym kanałem",
    "Zmień kolejność punktów": "Zmień kolejność punktów",
    "Prywatne": "Prywatne",
    "Pojedynczy artykuł (strona opisowa)": "",
    "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
    "Wszystkie obiekty:": "Wszystkie obiekty:",
    "Inwentaryzaje": "",
    "Typ slajdu": "",
    "brak danych": "brak danych",
    "Regulaminy": "",
    "Usuń wszystkie tagi": "",
    "Dodanie działu": "Dodanie działu",
    "Ustawienia slajdera": "",
    "Zmień nazwę": "Zmień nazwę",
    "Exclusivity": "Exclusivity",
    "Resetowanie podejść użytkowników": "",
    "Dodaj nieruchomość": "Dodaj nieruchomość",
    "Domyślna wartość": "Domyślna wartość",
    "Powiadomienie o zmianach": "Powiadomienie o zmianach",
    "Nie udało się zaktualizować zlecenia.": "Nie udało się zaktualizować zlecenia.",
    "Wyliczenie stawki godzinowej (statystyczna)": "Wyliczenie stawki godzinowej (statystyczna)",
    "Link do strony": "",
    "Zacznij pisać aby wyszukać zaopatrzenie...": "Zacznij pisać aby wyszukać zaopatrzenie...",
    "Poprawne": "Poprawne",
    "Zapisz trasę": "Zapisz trasę",
    "Rodzaj odpowiedzi": "Rodzaj odpowiedzi",
    "Upload": "Upload",
    "Data dodania kosztu": "Data dodania kosztu",
    "Właściciel": "Właściciel",
    "Etykiety": "Etykiety",
    "Typ rezerwacji": "Typ rezerwacji",
    "${ex.data.errors.symbol[0]}": "",
    "Odznacz wszystkie": "Odznacz wszystkie",
    "Anuluj": "Anuluj",
    "Treści odpowiedzi są wymagane": "Treści odpowiedzi są wymagane",
    "Rezerwacja właścicielska": "Rezerwacja właścicielska",
    "Publikacja została zmieniona.": "",
    "Wczutuję...": "",
    "Tłumacz checklistę": "Tłumacz checklistę",
    "Koszt dla nieruchomości roboczej": "Koszt dla nieruchomości roboczej",
    "Załączone zdjęcia": "Załączone zdjęcia",
    "Źródło URL": "",
    "Wstęp": "",
    "Dane wydziału zostały zaktualizowane.": "Dane wydziału zostały zaktualizowane.",
    "Kopiuj numer rezerwacji": "Kopiuj numer rezerwacji",
    "Wymagaj znaków specjalnych w hasłach": "Wymagaj znaków specjalnych w hasłach",
    "Wybór kategorii": "",
    "Aktywni": "Aktywni",
    "Wpis został dodany.": "Wpis został dodany.",
    "zacznij pisać aby wyszukać slajder...": "",
    "Szczegóły": "Szczegóły",
    "Brak historii zmian": "",
    "po %0 nieudanych próbach logowania": "po %0 nieudanych próbach logowania",
    "Nazwa źródła danych": "Nazwa źródła danych",
    "Nazwa ulicy (StreetName)": "Nazwa ulicy (StreetName)",
    "Odpowiedź 2": "Odpowiedź 2",
    "Administracja - Zespoły": "Administracja - Zespoły",
    "Użytkownik posiada pełne uprawnienia": "Użytkownik posiada pełne uprawnienia",
    "Liczba inspektorów": "Liczba inspektorów",
    "Pole zawiera": "Pole zawiera",
    "Odpowiedź": "",
    "Rezerwacja właściciela": "",
    "Niedostępne": "",
    "Zapytanie": "",
    "Odrzucone": "",
    "Wygasłe": "",
    "Anulowane": "",
    "Zamknięte": "",
    "Zarezerwowane": "",
    "Potwierdzone": "",
    "Katalog został utworzony.": "Katalog został utworzony.",
    "W tym katalogu nie ma jeszcze żadnych stron.": "",
    "Dodanie dzielnicy": "Dodanie dzielnicy",
    "Data zdarzenia": "Data zdarzenia",
    "Edytuj stawkę za godzinę": "Edytuj stawkę za godzinę",
    "Dostęp do": "",
    "Data publikacji": "",
    "Profil użytkownika": "Profil użytkownika",
    "ID nazwa obiektu": "ID nazwa obiektu",
    "Stała wartość": "Stała wartość",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Błąd 404. Nie znaleziono żądanego zasobu.",
    "Edycja ścieżki szkoleniowej": "",
    "Czy opublikowany": "",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Czy zapisać trasę i wysłac ją do kierowcy?",
    "Rola została dodana.": "Rola została dodana.",
    "Tryb monitorowania aktywności wyłączony.": "",
    "Następna inwentaryzacja": "Następna inwentaryzacja",
    "Godzina wykonania": "Godzina wykonania",
    "Pokaż szczegóły": "Pokaż szczegóły",
    "Wszyscy": "Wszyscy",
    "Urlop został zaktualizowany.": "Urlop został zaktualizowany.",
    "Aktualności ze strony": "",
    "Miasto zostało dodane.": "Miasto zostało dodane.",
    "(AirBnb) Wysłano żądanie do portalu": "(AirBnb) Wysłano żądanie do portalu",
    "Widoczny obszar": "",
    "ZMIANA": "ZMIANA",
    "REGON": "REGON",
    "Kanały włączone w ustawieniach aplikacji": "Kanały włączone w ustawieniach aplikacji",
    "Edycja użytkownika": "Edycja użytkownika",
    "Wyłącz powiadomienia": "Wyłącz powiadomienia",
    "Zresetuj hasło": "Zresetuj hasło",
    "Wstecz": "Wstecz",
    "Załącz zdjęcia": "",
    "Edycja regulaminu": "",
    "Nieruchomości (Data przyjazdu)": "Nieruchomości (Data przyjazdu)",
    "Nazwa bloku": "",
    "Wartość musi być liczbą dodatnią": "Wartość musi być liczbą dodatnią",
    "Fiirma została zaktualizowana.": "Fiirma została zaktualizowana.",
    "Przypisane miasta do regionu:": "Przypisane miasta do regionu:",
    "Imie i nazwisko właściciela": "Imie i nazwisko właściciela",
    "Nazwa działu": "Nazwa działu",
    "Hasło do sieci Wi-Fi": "Hasło do sieci Wi-Fi",
    "Etykieta": "Etykieta",
    "Udostępnij": "Udostępnij",
    "Cancelled by owner": "Cancelled by owner",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "",
    "Wyświetl również zarchiwizowane formularze": "Wyświetl również zarchiwizowane formularze",
    "jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji": "jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji",
    "Potwierdzenie usunięcia. Usunięcie tematu spowoduje usunięcie przypisanych do niego lekcji": "",
    "Kod HTML": "",
    "Uprawnienia użytkownika": "",
    "Wybrane regulaminy:": "",
    "Kategoria materiału": "",
    "Grupa": "Grupa",
    "Under request": "Under request",
    "Dodanie ankiety": "",
    "Liczba pracowników": "Liczba pracowników",
    "Dodaj zlecenie": "Dodaj zlecenie",
    "Wpisz komentarz...": "Wpisz komentarz...",
    "Komunikat walidacji": "Komunikat walidacji",
    "Publikuj na stronie": "",
    "Wpisz nazwę regionu...": "Wpisz nazwę regionu...",
    "Błędne": "Błędne",
    "Zasięg": "Zasięg",
    "Język:": "Język:",
    "Publikacja priorytetowa": "",
    "Ukryj przycisk": "Ukryj przycisk",
    "Pole \"Tytuł\" jest wymagane.": "Pole \"Tytuł\" jest wymagane.",
    "Pralnia": "Pralnia",
    "Zdjęcie": "",
    "Test został dodany.": "",
    "Ostatnia wiadomość - użytkownik": "Ostatnia wiadomość - użytkownik",
    "Elementy inwentaryzacji": "Elementy inwentaryzacji",
    "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "",
    "Przypisane miasta": "Przypisane miasta",
    "Ponów zadanie": "",
    "UWAGA! Nieruchomość jest już przypisana od innego właściciela": "UWAGA! Nieruchomość jest już przypisana od innego właściciela",
    "Wszystkie niezapisane zmiany zostaną utracone.": "Wszystkie niezapisane zmiany zostaną utracone.",
    "Usuń zaznaczone": "",
    "Szablon nr 3": "",
    "Aranżacja utowrzona przez": "",
    "Osoba zastępująca": "Osoba zastępująca",
    "Kanały komunikacji": "Kanały komunikacji",
    "Nazwa nieruchomości": "Nazwa nieruchomości",
    "Kroki": "Kroki",
    "Dodaj lekcję SCORM": "",
    "Strona została usunięta.": "Strona została usunięta.",
    "Osoba przypisana do zadania": "Osoba przypisana do zadania",
    "Pokaż czat": "Pokaż czat",
    "Dostępy": "",
    "Powiększ": "Powiększ",
    "Filtr globalny": "Filtr globalny",
    "Uzupełnij dane dotyczące szkolenia": "",
    "Brak kluczy": "Brak kluczy",
    "Polski": "Polski",
    "Cztery kolumny": "Cztery kolumny",
    "Avantio ID nieruchomości": "Avantio ID nieruchomości",
    "Wybierz kierowce": "Wybierz kierowce",
    "Szkolenie": "",
    "Przeciągnij do innej sekcji": "",
    "Brak zadań": "Brak zadań",
    "Edycja poradnika": "",
    "Zlecenie zostało usunięte.": "Zlecenie zostało usunięte.",
    "Opis zadania": "Opis zadania",
    "Pliki do wysłania: %0": "Pliki do wysłania: %0",
    "Nie podano nazwy poprzedniego elementu.": "",
    "Ta nieruchomość już posiada takie wyposażenie.": "Ta nieruchomość już posiada takie wyposażenie.",
    "OwnerService": "OwnerService",
    "Przyznaj dostęp": "Przyznaj dostęp",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "",
    "Ładuję zgłoszenia...": "Ładuję zgłoszenia...",
    "Wstaw kontrolkę": "Wstaw kontrolkę",
    "Top kosztów wg miast": "Top kosztów wg miast",
    "Nieprawidłowy adres email": "Nieprawidłowy adres email",
    "Potwierdź wyczyszczenie logów": "",
    "Brak przypisanych użytkowników.": "Brak przypisanych użytkowników.",
    "Nie znaleziono szczegółów zmiany": "Nie znaleziono szczegółów zmiany",
    "Wybierz pliki do dodania": "",
    "Witryna domyślna": "",
    "Ścieżka szkoleniowa": "",
    "Generuj PDF": "Generuj PDF",
    "Dodanie etykiety": "",
    "Brudne": "Brudne",
    "Nr nieruchomości Guesty": "Nr nieruchomości Guesty",
    "Ta czynność została wykonana przez kogoś innego. Odśwież aplikację.": "Ta czynność została wykonana przez kogoś innego. Odśwież aplikację.",
    "Poprzedni miesiąc": "Poprzedni miesiąc",
    "Nieaktywna": "Nieaktywna",
    "Strona": "Strona",
    "Rejestracja konta": "",
    "Nie udało się pobrać listy bloków": "",
    "Nowa data": "Nowa data",
    "Typ plików": "",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "Wstaw dwie kolumny 2/3 oraz 1/3",
    "Edycja etykiety": "",
    "Publikuj certyfikat": "",
    "Kategoria linku": "",
    "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
    "Nazwa płyty": "",
    "Obojętny": "Obojętny",
    "Twoje hasło wygasło. Zmień je na nowe.": "Twoje hasło wygasło. Zmień je na nowe.",
    "Liczba dni co ile wysyłane jest powiadomienie": "",
    "Nazwa slajdera": "",
    "Token": "Token",
    "Ukryj przypisane zadania": "Ukryj przypisane zadania",
    "Baza danych tego klienta jest nieaktualna. Uruchom aktualizację za pomocą przycisku na dole formularza.": "Baza danych tego klienta jest nieaktualna. Uruchom aktualizację za pomocą przycisku na dole formularza.",
    "Typ szablonu": "Typ szablonu",
    "Dodaj element": "Dodaj element",
    "Edycja witryny": "",
    "${StatusName(StatusEnum[this.form.bookingType])}": "${StatusName(StatusEnum[this.form.bookingType])}",
    "Bardzo źle": "Bardzo źle",
    "Przywrócić użytkownika i jego wiadomości?": "Przywrócić użytkownika i jego wiadomości?",
    "Kolor tła": "",
    "Administracja": "Administracja",
    "Status regulaminu został zmieniony.": "",
    "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "",
    "Szef regionu": "Szef regionu",
    "Zadanie znajduje się na trasach:": "",
    "Ilość": "Ilość",
    "Średnio": "Średnio",
    "Logowanie zakończyło się niepowodzeniem.": "Logowanie zakończyło się niepowodzeniem.",
    "Opisy": "Opisy",
    "Wybierz zaznaczone": "Wybierz zaznaczone",
    "Stałe/miesięczne": "Stałe/miesięczne",
    "Wydział / Rola": "Wydział / Rola",
    "Trasa została zapauzowana": "Trasa została zapauzowana",
    "Wybierz typy powiadomień, które chcesz wyłączyć:": "Wybierz typy powiadomień, które chcesz wyłączyć:",
    "Wysłano kolejne powiadomienie": "",
    "Wybierz punkt": "Wybierz punkt",
    "Regiony": "Regiony",
    "Użytkownik został dodany do zespołu.": "Użytkownik został dodany do zespołu.",
    "Źródło danych zostało zaktualizowane.": "Źródło danych zostało zaktualizowane.",
    "Przesuń na dół": "Przesuń na dół",
    "Pliki zostały usunięte": "",
    "Laptop 15\"": "",
    "Zobacz sesję użytkownika": "Zobacz sesję użytkownika",
    "Kwota": "Kwota",
    "Konto publiczne": "",
    "Wpis przeczytany": "",
    "Słowa kluczowe": "",
    "Szef Regionu": "Szef Regionu",
    "Dane kosztu": "",
    "Wartość musi być liczbą całkowitą": "Wartość musi być liczbą całkowitą",
    "Początek długości geograficznej użytkownika": "Początek długości geograficznej użytkownika",
    "Akcja": "Akcja",
    "Ukryj już zaplanowane punkty": "Ukryj już zaplanowane punkty",
    "Właściciel aktywny": "Właściciel aktywny",
    "Zmień daty publikacji": "",
    "Wybierz certyfikat": "",
    "Zawsze": "Zawsze",
    "Typ dodanego kosztu": "Typ dodanego kosztu",
    "Dodaj sekcję": "",
    "Nie zdefiniowano żadnych sekcji.": "",
    "Powiązania z dzielnicą": "Powiązania z dzielnicą",
    "Wpisz nazwę dzielnicy...": "Wpisz nazwę dzielnicy...",
    "Sortuj po": "",
    "Informacje": "Informacje",
    "Blok został usunięty.": "",
    "Do sprawdzenia - przeniesione": "Do sprawdzenia - przeniesione",
    "Potwierdzenie usunięcia": "Potwierdzenie usunięcia",
    "Wybór listy stron": "",
    "zacznij pisać aby wyszukać zespół...": "",
    "Miasta": "Miasta",
    "Lista nieruchomości": "Lista nieruchomości",
    "Nie podano odpowiedzi dla ostatniego elementu.": "",
    "Mężczyzna": "",
    "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Pole \"%0\" nie zawiera prawidłowego adresu URL.",
    "zaznacz wszystko": "zaznacz wszystko",
    "Metadane": "",
    "Tag został usunięty.": "Tag został usunięty.",
    "Adres 2": "Adres 2",
    "Wartość domyślna": "Wartość domyślna",
    "Brak zadania": "",
    "Dodanie certyfikatu": "",
    "Dokument": "",
    "Nazwa linku": "",
    "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
    "Nazwa nieruchomości roboczej": "Nazwa nieruchomości roboczej",
    "Generuję plik...": "Generuję plik...",
    "Opcje": "Opcje",
    "Imie i nazwisko osoby, która dodawała koszty": "Imie i nazwisko osoby, która dodawała koszty",
    "Pozostało %0 znaków.": "Pozostało %0 znaków.",
    "Nie udało się zmienić statusu zadania": "Nie udało się zmienić statusu zadania",
    "Kwota brutto": "",
    "Treść certyfikatu": "",
    "Nazwa katalogu": "Nazwa katalogu",
    "Laptop 15,6\"": "",
    "Dokument nie ma ustawionej daty publikacji.": "",
    "Wstaw dwie równe kolumny": "Wstaw dwie równe kolumny",
    "Zastępstwo": "Zastępstwo",
    "Ma dzisiaj": "Ma dzisiaj",
    "Grafik pracowniczy": "Grafik pracowniczy",
    "Adres": "Adres",
    "Narzędzia": "Narzędzia",
    "Wersja": "",
    "Strona dostępna dla wszystkich": "",
    "Pionowo": "",
    "Dziś": "Dziś",
    "Edycja szkolenia": "",
    "Odejmowanie": "Odejmowanie",
    "Kolor": "Kolor",
    "Symbol testu": "",
    "Brak daty": "Brak daty",
    "Obciążenie Magazyn": "Obciążenie Magazyn",
    "Kwota za zadania": "Kwota za zadania",
    "Odpowiedź 4": "Odpowiedź 4",
    "Adres e-mail": "Adres e-mail",
    "Zapisz i wróć": "Zapisz i wróć",
    "Wiadomość": "Wiadomość",
    "Lipiec": "Lipiec",
    "Typ nieruchomości": "Typ nieruchomości",
    "Koordynator HK": "Koordynator HK",
    "Obciążenie Właściciela": "Obciążenie Właściciela",
    "Host główny": "Host główny",
    "Dodaj kafelek": "",
    "Dodanie zastępstwa": "Dodanie zastępstwa",
    "Data usunięcia": "Data usunięcia",
    "Test został zaktualizowany.": "",
    "Edytuj katalog": "",
    "Zapomniałeś hasła?": "Zapomniałeś hasła?",
    "Zadanie zostało ukończone przez kogoś z Twojego zespołu.": "",
    "Niski": "Niski",
    "Domyślny czas rezerwacji": "Domyślny czas rezerwacji",
    "Stwórz czat z zadania": "Stwórz czat z zadania",
    "Zakończone": "Zakończone",
    "Ścieżka": "",
    "Not Available": "Not Available",
    "Firma": "Firma",
    "Wybór koloru jest wymagany": "",
    "Typ konta": "",
    "Dodanie szablonu": "",
    "Dodaj szablon": "Dodaj szablon",
    "Docelowa strona": "",
    "Dodanie serwera": "Dodanie serwera",
    "Włączenie protokołu SSL dla tej witryny": "",
    "Test ukryty": "",
    "Wyszukaj użytkownika": "",
    "Zespoły": "Zespoły",
    "Miesiąc": "Miesiąc",
    "Załączniki": "Załączniki",
    "Zgłoszenie serwisowe": "",
    "Konta prywatne": "",
    "Inspekcje": "Inspekcje",
    "Brak wersji": "Brak wersji",
    "Anuluj i wyjdź z kreatora": "Anuluj i wyjdź z kreatora",
    "Wyszukuję...": "Wyszukuję...",
    "Marzec": "Marzec",
    "Filtry globalne": "Filtry globalne",
    "Zadanie zostało dodane.": "Zadanie zostało dodane.",
    "Dodawanie": "Dodawanie",
    "Dane dostępowe": "Dane dostępowe",
    "Data zakończenia od": "Data zakończenia od",
    "Nie możesz edytować tego punktu. Został on już oznaczony jako odwiedzony": "Nie możesz edytować tego punktu. Został on już oznaczony jako odwiedzony",
    "Przenieś do sekcji": "",
    "Adres url": "",
    "Numer rezerwacji": "Numer rezerwacji",
    "usunięto dzielnice": "usunięto dzielnice",
    "edycja": "edycja",
    "Wyszukaj nieruchomość...": "Wyszukaj nieruchomość...",
    "reset": "reset",
    "Nie udało się pobrać listy działów": "Nie udało się pobrać listy działów",
    "Nie wybrano obrazu.": "",
    "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.",
    "Wybierz inspektora": "Wybierz inspektora",
    "Notatka/Komentarz": "",
    "Nie podano wymaganej ilości znaków: %0.": "Nie podano wymaganej ilości znaków: %0.",
    "Dodaj urlop": "Dodaj urlop",
    "Wynagrodzenia HK": "Wynagrodzenia HK",
    "Gotowe": "Gotowe",
    "Wykonane zadania": "Wykonane zadania",
    "Przywrócić wiadomość?": "Przywrócić wiadomość?",
    "5 minut": "5 minut",
    "Get it on Google Play": "Get it on Google Play",
    "Nazwa klienta": "Nazwa klienta",
    "Zlecenie zostało zaktualizowane.": "Zlecenie zostało zaktualizowane.",
    "SUMA": "SUMA",
    "Edytuj obraz": "Edytuj obraz",
    "Nazwa tagu": "Nazwa tagu",
    "Typ powiadomienia": "Typ powiadomienia",
    "Nie podano nazwy tytułu.": "",
    "Komentarz został zapisany": "",
    "Właściwości": "",
    "Usuń datę": "Usuń datę",
    "Wystąpił problem z dostępem do kamery": "Wystąpił problem z dostępem do kamery",
    "Ulica": "Ulica",
    "Ukryj czat": "Ukryj czat",
    "Minimalna długość hasła": "Minimalna długość hasła",
    "Nie masz uprawnień do panelu administracyjnego.": "Nie masz uprawnień do panelu administracyjnego.",
    "Ilość gości": "Ilość gości",
    "Zawartość": "",
    "checklista": "checklista",
    "Nie wybrano żadnej strony.": "",
    "Styczeń": "Styczeń",
    "Progress Gotowości": "",
    "Szablon nr 2": "",
    "Facebook Admins": "",
    "Nie udało się ustawić miasta.": "Nie udało się ustawić miasta.",
    "Edycja linku": "",
    "Pracownicy z brakującymi ustawieniami wynagrodzenia": "Pracownicy z brakującymi ustawieniami wynagrodzenia",
    "Dodaj inwentaryzacje": "Dodaj inwentaryzacje",
    "Wygeneruj pilik": "",
    "Pobyt: ": "Pobyt: ",
    "Checklista:": "Checklista:",
    "Strona lekcji opublikowana": "",
    "Zapisz komentarz": "",
    "Usuń materiał z testu": "",
    "Migracje": "Migracje",
    "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "",
    "Nie można przenosić plików między sekcjami o różnych typach": "",
    "Jest to lista obiektów które nie mają jeszcze przypisanego właściciela.": "Jest to lista obiektów które nie mają jeszcze przypisanego właściciela.",
    "Folder został usunięty.": "",
    "Symbol strony szkolenia": "",
    "Czy na pewno chcesz usunąć tę sekcję?": "",
    "Łóżeczko": "Łóżeczko",
    "Brak działu nadrzędnego": "Brak działu nadrzędnego",
    "Adres firmy": "Adres firmy",
    "Kwota kosztów": "Kwota kosztów",
    "Nazwa źródła": "Nazwa źródła",
    "Katalog": "Katalog",
    "Dane nieruchomości": "Dane nieruchomości",
    "$% - znacznik zamykający tag": "",
    "Wstaw trzy kolumny 1/3": "Wstaw trzy kolumny 1/3",
    "Brak danych.": "",
    "Rola": "Rola",
    "CustomerService": "CustomerService",
    "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "Ten kanał ma możliwość wysyłania tekstu sformatowanego.",
    "BOK": "BOK",
    "Koszt pracownika": "",
    "Dział": "Dział",
    "Typy materiałów": "",
    "Bazy danych": "Bazy danych",
    "Włączone (Follow)": "",
    "Zapauzowano:": "Zapauzowano:",
    "Wyjazd": "Wyjazd",
    "pl": "",
    "Przełącznik": "Przełącznik",
    "Pokaż tytuł formularza": "Pokaż tytuł formularza",
    "Wyposażenie": "Wyposażenie",
    "Neutralne": "Neutralne",
    "Dane kierowcy: ": "Dane kierowcy: ",
    "Nazwa bazy danych": "Nazwa bazy danych",
    "HR": "HR",
    "Kategorie materiałów": "",
    "NIP firmy": "NIP firmy",
    "Połącz w pary": "",
    "Lekcja wideo została zaktualizowana.": "",
    "Adres serwera": "Adres serwera",
    "Zadania dzisiaj": "Zadania dzisiaj",
    "Ten element nie zawiera menu kontekstowego.": "Ten element nie zawiera menu kontekstowego.",
    "Zastępstwa": "Zastępstwa",
    "Wzorzec": "Wzorzec",
    "Liczba podejść": "",
    "Edytuj szablon": "Edytuj szablon",
    "Usunięte zadanie": "Usunięte zadanie",
    "Data od": "Data od",
    "Data ukończenia": "Data ukończenia",
    "Szczegóły zdarzenia": "Szczegóły zdarzenia",
    "Zapisz jako": "Zapisz jako",
    "Wyposażenie zostało zaktualizowane.": "Wyposażenie zostało zaktualizowane.",
    "Edytuj uprawnienia": "Edytuj uprawnienia",
    "Powiadomienie o zbliżającym się zakończeniu szkolenia": "",
    "Pokaż": "Pokaż",
    "Data realizacji": "",
    "Jestem w drodze": "Jestem w drodze",
    "Poczta": "Poczta",
    "Numer Guesty": "Numer Guesty",
    "Dostęp przyznany": "Dostęp przyznany",
    "Wyszukaj": "Wyszukaj",
    "Wybierz regulamin": "",
    "Nazwa nadawcy": "Nazwa nadawcy",
    "Filtry": "Filtry",
    "Zakończenie": "",
    "Firma własna": "Firma własna",
    "Przepracowana liczba godzin w miesiącu": "Przepracowana liczba godzin w miesiącu",
    "Zadanie na dziś": "Zadanie na dziś",
    "W momencie tworzenia kosztu": "W momencie tworzenia kosztu",
    "Edytuj temat": "",
    "Uczestnicy rozmowy:": "Uczestnicy rozmowy:",
    "linie": "linie",
    "Ilość punktów: ": "Ilość punktów: ",
    "Przypisane tagi:": "Przypisane tagi:",
    "Otwórz w nowym oknie": "Otwórz w nowym oknie",
    "Dostępne czaty:": "Dostępne czaty:",
    "Usługi": "Usługi",
    "Oczekuje na wysłanie": "Oczekuje na wysłanie",
    "Nazwa trasy": "Nazwa trasy",
    "Informacje o czacie": "Informacje o czacie",
    "Multimedia": "Multimedia",
    "Dopuść brak odpowiedzi": "Dopuść brak odpowiedzi",
    "Dodaj treść": "",
    "Dane Adresowe": "Dane Adresowe",
    "Wynagrodzenia Pracowników": "Wynagrodzenia Pracowników",
    "Nazwa pokoju": "Nazwa pokoju",
    "Niedziela": "Niedziela",
    "Wymagane jest ustawienie minimalnej długości hasła": "Wymagane jest ustawienie minimalnej długości hasła",
    "Zgłoszenia w apartamencie": "Zgłoszenia w apartamencie",
    "To miasto jest już przypisane do użytkownika.": "To miasto jest już przypisane do użytkownika.",
    "Dodaj źródło": "Dodaj źródło",
    "Skrócony opis": "",
    "Wybierz sekcję, do której chcesz dodać pliki": "",
    "Data zakończenia/wykonania": "",
    "Zapisz nową kolejność punktów": "Zapisz nową kolejność punktów",
    "Strona została dodana.": "",
    "pokaż więcej...": "pokaż więcej...",
    "Nie znaleziono nieruchomości": "",
    "Źródła danych": "Źródła danych",
    "Wyświetl popup z kontynuacją lekcji": "",
    "Przypisane do:": "Przypisane do:",
    "Dodaj rolę": "Dodaj rolę",
    "Status linku został zmieniony.": "",
    "Dodaj opłaconą kwotę": "Dodaj opłaconą kwotę",
    "Zapisz filtr": "Zapisz filtr",
    "Utworzył": "Utworzył",
    "Suma wynagrodzeń koordynatorów": "Suma wynagrodzeń koordynatorów",
    "Harmonogram został zmieniony": "Harmonogram został zmieniony",
    "Typ obiektu": "Typ obiektu",
    "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
    "Wyczyść sesję": "Wyczyść sesję",
    "Minuty": "Minuty",
    "Nie udało się pobrać ról!": "Nie udało się pobrać ról!",
    "Miasto zostało zaktualizowane.": "Miasto zostało zaktualizowane.",
    "Bez dzielnicy": "Bez dzielnicy",
    "Aktywna nieruchomość": "Aktywna nieruchomość",
    "Wewnętrznie": "Wewnętrznie",
    "Potwierdzenie publikacji": "",
    "Tytuł formularza jest wymagany": "Tytuł formularza jest wymagany",
    "Powiadomienia zostały skonfigurowane.": "Powiadomienia zostały skonfigurowane.",
    "Ustawienia dostępności": "",
    "Pasek": "Pasek",
    "E-learning": "",
    "Szablon został zaktualizowany.": "Szablon został zaktualizowany.",
    "Liczba dziesiętna": "Liczba dziesiętna",
    "Filtr został usunięty": "Filtr został usunięty",
    "Usuń tag": "",
    "Dołącz stronę do pliku sitemap.xml": "",
    "Zmiana motywu": "Zmiana motywu",
    "Rola przypisana do tego wydziału jest nieaktywna": "Rola przypisana do tego wydziału jest nieaktywna",
    "Numer konta bankowego": "Numer konta bankowego",
    "Logger": "",
    "Pokaż zadania bez przypisanej osoby": "Pokaż zadania bez przypisanej osoby",
    "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
    "Gość": "Gość",
    "Ten miesiąc": "Ten miesiąc",
    "Koordynator Główny": "Koordynator Główny",
    "Firmy": "Firmy",
    "Nieudane": "Nieudane",
    "Data utworzenia wersji": "Data utworzenia wersji",
    "Treść została dodana.": "",
    "Raczej się nie zgadzam": "Raczej się nie zgadzam",
    "Nie udało się pobrać szczegółów zmiany": "Nie udało się pobrać szczegółów zmiany",
    "Dodaj koszt": "Dodaj koszt",
    "Wykonane": "Wykonane",
    "Dane dostępu": "Dane dostępu",
    "Członkowie zespołu": "Członkowie zespołu",
    "Pre-booking": "Pre-booking",
    "Nazwa zestawu": "",
    "Inwentaryzacje": "Inwentaryzacje",
    "Wszystkie zadania": "Wszystkie zadania",
    "Szablon graficzny": "",
    "Opis witryny": "",
    "Data:": "Data:",
    "Id": "Id",
    "Utwórz czat": "Utwórz czat",
    "Stawka PLN brutto za godzinę": "Stawka PLN brutto za godzinę",
    "Rozmiar": "Rozmiar",
    "Dodaj do regionu": "Dodaj do regionu",
    "Data zalogowania": "Data zalogowania",
    "Wysłano powiadomienie.": "Wysłano powiadomienie.",
    "Trasy archiwalne": "Trasy archiwalne",
    "Musisz wybrać obiekt na mapie": "Musisz wybrać obiekt na mapie",
    "Pokaż filtry": "Pokaż filtry",
    "Włączenie obsługi cacheu dla witryny": "",
    "do": "do",
    "Komentarz Konserwatora": "Komentarz Konserwatora",
    "Imię właściciela": "Imię właściciela",
    "Kategoria slajdu": "",
    "Obiekty": "Obiekty",
    "Nie udało się wgrać pliku": "Nie udało się wgrać pliku",
    "W drodze": "W drodze",
    "Zaawansowane polecenia": "",
    "Wyszukiwany ciąg znaków": "Wyszukiwany ciąg znaków",
    "Udało się dodać nieruchomość do trasy": "Udało się dodać nieruchomość do trasy",
    "Edycja wynagrodzenia za posprzątane obiekty dla:": "Edycja wynagrodzenia za posprzątane obiekty dla:",
    "Nieprawidłowy adres URL": "Nieprawidłowy adres URL",
    "Wybierz blok": "",
    "Obrazek wyróżniający": "",
    "Niestandardowy błąd": "Niestandardowy błąd",
    "Koszt został usunięty": "",
    "Slajder został dodany.": "",
    "Synchronizacja rezerwacji": "Synchronizacja rezerwacji",
    "Manager Firmy Zewnętrznej": "Manager Firmy Zewnętrznej",
    "Logowanie": "",
    "Brak kategorii": "",
    "Faktyczny czas pracy": "Faktyczny czas pracy",
    "Ustawienia konta": "",
    "Domyślny tytuł aktywnej strony": "",
    "Ustawienia zostały zaktualizowane.": "Ustawienia zostały zaktualizowane.",
    "Nie udało się pobrać zadań": "Nie udało się pobrać zadań",
    "Aktywna": "Aktywna",
    "Wprowadzona wartość nie jest poprawna": "Wprowadzona wartość nie jest poprawna",
    "Wybór języka": "Wybór języka",
    "Zmień nazwę katalogu": "Zmień nazwę katalogu",
    "Problemy": "Problemy",
    "Edycja kategorii": "",
    "Dzielnica została dodana.": "Dzielnica została dodana.",
    "Brak numeru": "Brak numeru",
    "Kategoria została usunięta.": "Kategoria została usunięta.",
    "Wybierz stronę": "",
    "Zadanie zostało włączone": "Zadanie zostało włączone",
    "Ankieta": "Ankieta",
    "Dodaj temat/link": "",
    "Koszty wg regionów": "Koszty wg regionów",
    "Dane właściciela": "Dane właściciela",
    "Brak typu zadania": "",
    "zacznij pisać aby wyszukać regulamin...": "",
    "Wprowadzona wartość jest za wysoka": "Wprowadzona wartość jest za wysoka",
    "Dodatkowe wynagrodzenie - kwota": "Dodatkowe wynagrodzenie - kwota",
    "REGON firmy": "REGON firmy",
    "VAT (wyliczany automatycznie)": "",
    "Miniaturka wideo": "",
    "Ukończone przez użytkownika": "Ukończone przez użytkownika",
    "Logo": "Logo",
    "Brak strony nadrzędnej": "",
    "Tagi": "Tagi",
    "Archiwalny": "Archiwalny",
    "Pokaż tytuł strony": "Pokaż tytuł strony",
    "Administracja - Kraje": "Administracja - Kraje",
    "Pomoc": "Pomoc",
    "Dane podstawowe": "Dane podstawowe",
    "Czas (minuty)": "",
    "Sformatowany rzeczywisty czas pracy": "Sformatowany rzeczywisty czas pracy",
    "Przesyłanie zdjęcia nie powiodło się": "Przesyłanie zdjęcia nie powiodło się",
    "dni temu": "dni temu",
    "Nie możesz rozpocząć obsługi tego zadania": "",
    "Zarządzaj": "Zarządzaj",
    "Wideo zewnętrzne (URL)": "",
    "Dane zadania": "Dane zadania",
    "Szkolenie zostało zaktualizowane.": "",
    "Filmy": "",
    "Pytania i odpowiedzi": "",
    "Aktywny": "Aktywny",
    "Liczba szkoleń": "",
    "Dostęp do": "",
    "Dodanie wpisu": "",
    "Zacznik pisać Form lub Entry aby uruchomić podpowiadanie.": "Zacznik pisać Form lub Entry aby uruchomić podpowiadanie.",
    "Kalendarz nieruchomości": "",
    "Dodanie Notatki": "Dodanie Notatki",
    "Bezpieczeństwo": "Bezpieczeństwo",
    "Dwie kolumny": "Dwie kolumny",
    "Administracja - Miasta": "Administracja - Miasta",
    "Stawka mieszana została zaktualizowana.": "Stawka mieszana została zaktualizowana.",
    "Zacznij pisać aby wyszukać osobę...": "Zacznij pisać aby wyszukać osobę...",
    "Szczegóły rezerwacji": "Szczegóły rezerwacji",
    "Link do czatu": "Link do czatu",
    "Kwota kosztu do": "Kwota kosztu do",
    "Obrazek": "",
    "Podaj swój adres email": "Podaj swój adres email",
    "Edytuj Notatkę": "Edytuj Notatkę",
    "Nieruchomość zagrożona wypowiedzeniem": "Nieruchomość zagrożona wypowiedzeniem",
    "Nie udało się pobrać danych o rolach zalogowanego użytkownika": "Nie udało się pobrać danych o rolach zalogowanego użytkownika",
    "Tryb monitorowania aktywności wyłączony.": "",
    "Stawka za godzinę brutto": "Stawka za godzinę brutto",
    "To zadanie nie posiada jeszcze przypisanych użytkowników.": "",
    "Regulamin wymagany": "",
    "Uwzględnij miasto": "Uwzględnij miasto",
    "Dodaj dane wydziału": "Dodaj dane wydziału",
    "Czy na pewno chcesz ukryć wiadomość?": "Czy na pewno chcesz ukryć wiadomość?",
    "Układ": "Układ",
    "Serwer plików": "Serwer plików",
    "Kwota opłacona": "Kwota opłacona",
    "Koniec szerokości geograficznej użytkownika": "Koniec szerokości geograficznej użytkownika",
    "Zadania": "Zadania",
    "ID obiektu": "ID obiektu",
    "W tym katalogu nie ma jeszcze żadnych stron.": "",
    "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "",
    "Serwer został zaktualizowany.": "Serwer został zaktualizowany.",
    "Srednie wynagrodzenie pracowników": "Srednie wynagrodzenie pracowników",
    "Zmiana rozmiaru obrazu": "Zmiana rozmiaru obrazu",
    "źródło danych zostało dodane.": "źródło danych zostało dodane.",
    "Zestaw został dodany.": "",
    "Edytuj blok": "",
    "Przypisane dzielnice:": "Przypisane dzielnice:",
    "Nazwisko właściciela": "Nazwisko właściciela",
    "Język": "Język",
    "Nazwa sekcji": "",
    "Stawka domyślna": "Stawka domyślna",
    "Pokaż więcej": "Pokaż więcej",
    "Odpowiedź 5": "Odpowiedź 5",
    "Witryna / Wersja językowa": "",
    "Weekend": "Weekend",
    "Uwzględnij zadania z miesiąca:": "Uwzględnij zadania z miesiąca:",
    "Zamknięte przez": "Zamknięte przez",
    "Przypisane do": "Przypisane do",
    "Historia logowania": "Historia logowania",
    "Wstaw z prawej strony": "Wstaw z prawej strony",
    "Wyłączone (NoIndex)": "",
    "Artykuły": "",
    "Data wykonania do": "Data wykonania do",
    "Zadanie zostało wznowione.": "Zadanie zostało wznowione.",
    "Witryna aktywna": "",
    "Nie udało się pobrać listy serwerów baz danych": "Nie udało się pobrać listy serwerów baz danych",
    "Data nieobecności od": "Data nieobecności od",
    "Ten region nie posiada jeszcze przypisanych miast.": "Ten region nie posiada jeszcze przypisanych miast.",
    "Masz nową wiadomość!": "Masz nową wiadomość!",
    "Wpisz nazwę trasy": "Wpisz nazwę trasy",
    "Przeglądnij logi": "",
    "Nieudane próby logowania": "Nieudane próby logowania",
    "Na pewno usunąć wybrane elementy?": "Na pewno usunąć wybrane elementy?",
    "dzisiaj": "dzisiaj",
    "Wróć do strony logowania": "",
    "Telefon": "Telefon",
    "Nazwa aranżacji": "",
    "Zadanie na nieruchomościach roboczych": "Zadanie na nieruchomościach roboczych",
    "Biblioteka": "",
    "Usuń plik z listy": "Usuń plik z listy",
    "Zmień dane kosztu": "Zmień dane kosztu",
    "Zmień status edytowanej wersji": "Zmień status edytowanej wersji",
    "Filtry systemowe": "Filtry systemowe",
    "Wynagrodzenia Konserwatorzy": "Wynagrodzenia Konserwatorzy",
    "Walidacja certyfikatu SSL": "Walidacja certyfikatu SSL",
    "Operacja": "Operacja",
    "Edycja ścieżki szkoleniowej": "",
    "Wybrane miasto": "Wybrane miasto",
    "Stawka za typ apartamentu": "Stawka za typ apartamentu",
    "Mnożenie": "Mnożenie",
    "Uwzględniaj Miasta": "Uwzględniaj Miasta",
    "Edycja zastępstwa": "Edycja zastępstwa",
    "Konfiguruj stronę": "",
    "Zaczyna sie od": "Zaczyna sie od",
    "Nieobecny do": "Nieobecny do",
    "Dodaj zaopatrzenie": "Dodaj zaopatrzenie",
    "Email został wysłany.": "Email został wysłany.",
    "Co 20 minut": "Co 20 minut",
    "km": "km",
    "Ustaw w kolejności": "",
    "Użytkownik został przypisany do ścieżki szkoleniowej.": "",
    "Oczekujące": "Oczekujące",
    "Confirmed": "Confirmed",
    "Godzina:": "Godzina:",
    "Lekcja SCORM ukryta": "",
    "Adres strony": "",
    "Administratorzy": "Administratorzy",
    "Notatki": "",
    "Edycja stawki godzinowej dla:": "Edycja stawki godzinowej dla:",
    "Dodaj opis...": "Dodaj opis...",
    "Wynagrodzenie stałe brutto": "Wynagrodzenie stałe brutto",
    "Przejdź do rezerwacji": "Przejdź do rezerwacji",
    "Parametry, wymagane do wykonania zapytania:": "Parametry, wymagane do wykonania zapytania:",
    "Pliki zostały pobrane": "",
    "gotowe": "gotowe",
    "Co 5 minut": "Co 5 minut",
    "Szkolenie kończy się": "",
    "Link został dodany.": "",
    "Kolejne pozycje z prawej strony": "",
    "Miasta:": "Miasta:",
    "Usuń poprzednie wersje certyfikatu": "",
    "Wynagrodzenie za przepracowane godziny": "Wynagrodzenie za przepracowane godziny",
    "10 minut": "10 minut",
    "Paczka została usunięta.": "",
    "Typ mime": "Typ mime",
    "Dodaj temat": "",
    "Edytuj urlop": "Edytuj urlop",
    "Szukaj...": "",
    "Ścieżka szkoleniowa została zaktualizowana.": "",
    "Powtórzone": "Powtórzone",
    "Nie wybrano żadnej kategorii.": "",
    "Azure AD": "Azure AD",
    "Prestiżowe": "Prestiżowe",
    "Błąd": "",
    "3": "",
    "Sformatowany czas całkowity": "Sformatowany czas całkowity",
    "Liczba małych prześcieradeł": "Liczba małych prześcieradeł",
    "Wersja językowa": "",
    "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
    "Użytkownik został zablokowany, a jego wiadomość ukryte.": "Użytkownik został zablokowany, a jego wiadomość ukryte.",
    "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ",
    "Dział aktywny": "Dział aktywny",
    "Wynagrodzenia mieszane": "Wynagrodzenia mieszane",
    "Inne": "Inne",
    "Zdarzenie": "Zdarzenie",
    "Kategorie linków": "",
    "Co 12 godzin": "Co 12 godzin",
    "Zadanie zostało wyłączone": "Zadanie zostało wyłączone",
    "Wyślij": "Wyślij",
    "Nie udało się zapisać notatki": "Nie udało się zapisać notatki",
    "Nie możesz modyfikować uprawnień": "Nie możesz modyfikować uprawnień",
    "Bezpieczne połączenie SSL": "Bezpieczne połączenie SSL",
    "Przepracowana ilość godzin": "Przepracowana ilość godzin",
    "Dane dostępowe:  ": "Dane dostępowe:  ",
    "Końcowy stan licznika": "Końcowy stan licznika",
    "Ilość wyświetlanych aktualności": "",
    "Wyznacz punkty": "Wyznacz punkty",
    "%0 znaków": "%0 znaków",
    "Szkolenie zostało dodane.": "",
    "Domyślna witryna": "",
    "więcej...": "więcej...",
    "Dodanie testu": "",
    "Imię i nazwisko pracownika": "Imię i nazwisko pracownika",
    "Wpisz treść wiadomości.": "Wpisz treść wiadomości.",
    "Publikacja zarchiwizowana": "",
    "Plik jest wysyłany": "Plik jest wysyłany",
    "Brak wyników": "Brak wyników",
    "Nazwa sieci Wi-Fi": "Nazwa sieci Wi-Fi",
    "Sekcja została utworzona": "",
    "Trasa została zaktualizowana.": "Trasa została zaktualizowana.",
    "Nazwa checklisty": "Nazwa checklisty",
    "Szkolenie nie jest opublikowane": "",
    "Zlecenia magazynowe": "Zlecenia magazynowe",
    "Edytuj tag": "",
    "Dodanie witryny": "",
    "Biuro": "Biuro",
    "Ilość wyników do odrzucenia": "Ilość wyników do odrzucenia",
    "Paid": "Paid",
    "Zewnętrzny serwis": "",
    "Element grupujący": "",
    "Brak tematu": "",
    "Notatka dla": "Notatka dla",
    "Wybrana sekcja nie istnieje": "",
    "Szkolenie zostało usunięte.": "",
    "Scenariusz": "",
    "Numer mieszkania (Door)": "Numer mieszkania (Door)",
    "Czas pomiędzy": "Czas pomiędzy",
    "Wersja nieopublikowana": "",
    "Opublikuj": "",
    "Wymuszaj zaliczenie elementów ścieżki zgodnie z kolejnością szkoleń na liście": "",
    "Lista wyboru": "",
    "Filtr o podanej nazwie już istnieje.": "",
    "Równość": "Równość",
    "Podstawowe operacje na datach": "Podstawowe operacje na datach",
    "Zakończone przez": "Zakończone przez",
    "Porównanie": "Porównanie",
    "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *",
    "Przypisz do czatu": "",
    "np. pl-PL": "",
    "Standard 1.2": "",
    "Zdjęcie użytkownika": "Zdjęcie użytkownika",
    "Włączone": "Włączone",
    "Wtorek": "Wtorek",
    "Upload plików": "Upload plików",
    "Status formularza został zmieniony.": "Status formularza został zmieniony.",
    "Powrót": "Powrót",
    "Szczegóły zadania": "Szczegóły zadania",
    "Pracownik niedostępny od": "Pracownik niedostępny od",
    "Strona opublikowana": "",
    "Włączenie generowania pliku sitemap.xml dla całej witryny": "",
    "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "",
    "Dodaj zadanie": "Dodaj zadanie",
    "Kategoria została dodana.": "Kategoria została dodana.",
    "Rozliczone": "Rozliczone",
    "(nowe wiadomości)": "(nowe wiadomości)",
    "Usuń spacje": "Usuń spacje",
    "Data utworzenia aranżacji": "",
    "Zarządzanie zespołami": "",
    "Trasy dla Kierowców": "Trasy dla Kierowców",
    "Nawiguj do kolejnego punktu": "Nawiguj do kolejnego punktu",
    "Testowe powiadomienie wysłane": "Testowe powiadomienie wysłane",
    "Średni": "Średni",
    "Katalog został utworzony.": "Katalog został utworzony.",
    "Tryb monitorowania aktywności włączony.": "",
    "Zarządzanie witrynami": "",
    "Miejscowość": "Miejscowość",
    "Sekcje": "",
    "Źle": "Źle",
    "Dodanie aktualności": "",
    "zacznij pisać aby wyszukać materiał...": "",
    "Nie można usunąć kategorii do ktorej są przypisane elementy.": "",
    "Wytnij": "Wytnij",
    "Skopiowano": "",
    "Pozostałe ustawienia": "",
    "Liczba wyświetlanych slajdów": "",
    "Dashboard szkolenia": "",
    "Ładuję...": "Ładuję...",
    "Włącz chat": "",
    "Nieaktywni": "Nieaktywni",
    "Stwórz zlecenie z notatki": "Stwórz zlecenie z notatki",
    "Nie udało się usunąć szablonu": "Nie udało się usunąć szablonu",
    "Usuń kurs z ścieżki szkoleń": "",
    " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": "",
    "Źródło rezerwacji": "Źródło rezerwacji",
    "Zaznacz wszystkie w sekcji": "",
    "Nowe połączenie": "",
    "Właściciele": "Właściciele",
    "Wczytuję...": "Wczytuję...",
    "Regulamin został dodany.": "",
    "Publikuj do": "",
    "Zobacz trasę": "Zobacz trasę",
    "Wybrane elementy zostały przeniesione.": "Wybrane elementy zostały przeniesione.",
    "Zamknięte przez użytkownika": "Zamknięte przez użytkownika",
    "Zapisz wersję slajdu": "",
    "Kontrolki specjalizowane": "Kontrolki specjalizowane",
    "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "",
    "Dodaj paczkę SCORM": "",
    "Dodawanie inwentaryzacji": "Dodawanie inwentaryzacji",
    "Wybierz osobę spoza dzielnicy": "Wybierz osobę spoza dzielnicy",
    "Stała wartość": "Stała wartość",
    "Data rejestracji": "Data rejestracji",
    "Treści pytań są wymagane": "Treści pytań są wymagane",
    "Planuj automatycznie w dniu zakończenia blokady": "Planuj automatycznie w dniu zakończenia blokady",
    "Data opuszczenia zespołu": "Data opuszczenia zespołu",
    "Zamiany zostały zapisane.": "Zamiany zostały zapisane.",
    "Brak przypisanych tagów.": "Brak przypisanych tagów.",
    "Podano nieprawidłowe dane.": "Podano nieprawidłowe dane.",
    "Konserwacje": "Konserwacje",
    "Dodatkowa kwota wynagrodzenia": "Dodatkowa kwota wynagrodzenia",
    "Pełny ekran": "",
    "Zacznij pisać aby wyszukać tag nieruchomości...": "Zacznij pisać aby wyszukać tag nieruchomości...",
    "Wstaw stronę": "Wstaw stronę",
    "Moje konto": "Moje konto",
    "co się wydarzyło": "co się wydarzyło",
    "Ilość łóżek jednoosobowe": "Ilość łóżek jednoosobowe",
    "Wszystkie": "Wszystkie",
    "Opublikowana": "",
    "Zwierzę": "Zwierzę",
    "wybierz długość": "wybierz długość",
    "Nieruchomość została zaktualizowana.": "Nieruchomość została zaktualizowana.",
    "Dodaj klienta": "Dodaj klienta",
    "Usunięte zadania": "Usunięte zadania",
    "Owner Booking": "Owner Booking",
    "Nazwa paczki SCORM": "",
    "Co 3 miesiące": "Co 3 miesiące",
    "Nie możesz rozpocząć obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "Nie możesz rozpocząć obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie",
    "${item.text}": "${item.text}",
    "Wybrane": "Wybrane",
    "Rodzaj nieruchomości": "Rodzaj nieruchomości",
    "Co pół roku": "Co pół roku",
    "Nieruchomości robocze": "Nieruchomości robocze",
    "Miasto apartamentu": "Miasto apartamentu",
    "Podstawowe operacje na liczbach": "Podstawowe operacje na liczbach",
    "W przyszłości": "W przyszłości",
    "Wybrane pliki: {0}": "Wybrane pliki: {0}",
    "Zgłoszone problemy": "Zgłoszone problemy",
    "odznacz wszystko": "odznacz wszystko",
    "Podążanie za linkami": "",
    "Dodaj witrynę": "",
    "Kalendarz": "Kalendarz",
    "Podana nazwa jest zajęta.": "Podana nazwa jest zajęta.",
    "Wysoki": "Wysoki",
    "Dobrze": "Dobrze",
    "wybierz katalog": "",
    "Materiał": "Materiał",
    "Wybrane kategorie": "",
    "zacznij pisać aby wyszukać autora...": "",
    "Statystyki pracownicze": "Statystyki pracownicze",
    "Sprzątanie": "Sprzątanie",
    "Udało się zaktualizować nieruchomości!": "Udało się zaktualizować nieruchomości!",
    "Inwentaryzacja została usunięta.": "Inwentaryzacja została usunięta.",
    "Wynagrodzenia w regionie łącznie z wynagrodzeniami koordynatorów": "Wynagrodzenia w regionie łącznie z wynagrodzeniami koordynatorów",
    "Zaloguj się": "Zaloguj się",
    "Data informująca o terminie wejścia w życie tego regulaminu.": "",
    "Edytuj dane wydziału": "Edytuj dane wydziału",
    "Pytanie 3": "Pytanie 3",
    "Lista rozwijana": "Lista rozwijana",
    "Edycja slajdera": "",
    "Ankiety": "",
    "Dni": "Dni",
    "Potwierdź usunięcie": "Potwierdź usunięcie",
    "Przywróć oryginał": "Przywróć oryginał",
    "Podziedziałek - Piątek": "Podziedziałek - Piątek",
    "Godzina wymeldowania": "Godzina wymeldowania",
    "Data i czas": "Data i czas",
    "Jednokrotnego wyboru": "",
    "Nie podano opisu.": "",
    "Id rezerwacji": "Id rezerwacji",
    "Zmień widok": "Zmień widok",
    "Dodanie kategorii": "",
    "Suma wynagrodzeń pracowników": "Suma wynagrodzeń pracowników",
    "Zmień ustawienia": "Zmień ustawienia",
    "Powiązany artykuł": "",
    "Wiadomości": "Wiadomości",
    "Data modyfikacji do": "Data modyfikacji do",
    "Baza danych": "Baza danych",
    "Główny Konserwator": "Główny Konserwator",
    "Ilość sypialni": "Ilość sypialni",
    "Dzielnica została usunięta.": "Dzielnica została usunięta.",
    "Publikacja aranżacji została wyłączona.": "",
    "Kod pocztowy": "Kod pocztowy",
    "Do akceptacji": "Do akceptacji",
    "Tłumaczę...": "Tłumaczę...",
    "Rzeczywisty czas pracy": "Rzeczywisty czas pracy",
    "Dodaj wpis": "Dodaj wpis",
    "Edytuj wpis": "Edytuj wpis",
    "Zwiń": "Zwiń",
    "Data rozpoczęcia": "Data rozpoczęcia",
    "Dodane przez: ": "Dodane przez: ",
    "Szkolenia": "",
    "Wiadomość została przywrócona.": "Wiadomość została przywrócona.",
    "Właściciel regionu": "Właściciel regionu",
    "Brak szczegółów zmian": "Brak szczegółów zmian",
    "Dostęp przyznany ręcznie": "",
    "Wpisz tytuł...": "Wpisz tytuł...",
    "Uwaga! wraz z miastem": "Uwaga! wraz z miastem",
    "Usunięto": "Usunięto",
    "Dodanie szkolenia": "",
    "Profil został zaktualizowany.": "Profil został zaktualizowany.",
    "Nazwa:": "Nazwa:",
    "Data dodania do": "",
    "Wyszukaj albo dodaj nowy tag": "",
    "Dostępne obiekty:": "Dostępne obiekty:",
    "Dostępne moduły": "",
    "Ustawienia zostały zapisane.": "Ustawienia zostały zapisane.",
    "Attempt of reservation by Credit Card": "Attempt of reservation by Credit Card",
    "Czas uruchomienia": "Czas uruchomienia",
    "Premiera": "",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Czy zapisać trasę i wysłac ją do kierowcy?",
    "Zacznij pisać aby wyszukać regionu...": "Zacznij pisać aby wyszukać regionu...",
    "Avantio ID": "Avantio ID",
    "Lekcja SCORM została zaktualizowana.": "",
    "Zawierające jeden z wybranych tagów": "",
    "Co 3 godziny": "Co 3 godziny",
    "Godziny": "Godziny",
    "Edytuj stronę": "",
    "Zespół został usunięty.": "Zespół został usunięty.",
    "Indeksowanie strony": "",
    "Wybierz plik": "Wybierz plik",
    "Tag został zaktualizowany.": "Tag został zaktualizowany.",
    "Dodanie zespołu": "Dodanie zespołu",
    "Przesuń do góry": "Przesuń do góry",
    "Koszty": "",
    "przejdź do komentarzy": "",
    "Wersje dokumentu": "Wersje dokumentu",
    "Kategoria nadrzędna": "",
    "Dodanych plików %0 (limit wynosi %1).": "Dodanych plików %0 (limit wynosi %1).",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.",
    "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "",
    "Zakończ zadanie": "Zakończ zadanie",
    "Indywidualne tokeny": "Indywidualne tokeny",
    "Aby dodawać strony należy najpierw stworzyć nowy katalog.": "",
    "Zacznij pisać aby wyszukać firmę...": "Zacznij pisać aby wyszukać firmę...",
    "Nazwa firmy": "Nazwa firmy",
    "Dodanie artykułu": "",
    "Małe znaki": "Małe znaki",
    "Nie można usunąć swojego konta.": "Nie można usunąć swojego konta.",
    "Czas na slajd": "",
    "Uwzględnij wydziały podrzędne": "Uwzględnij wydziały podrzędne",
    "Kwota pozostała": "Kwota pozostała",
    "Paczka SCORM została dodana.": "",
    "Administracja - Role": "Administracja - Role",
    "Zadanie na trasie": "",
    "Ustawienia powiadomień zostały zapisane": "Ustawienia powiadomień zostały zapisane",
    "Tekst": "Tekst",
    "Apple iPhone 6": "",
    "Stan licznika koniec": "Stan licznika koniec",
    "Plik został przeniesiony": "",
    "Brak powiązań": "",
    "Dokument %0": "Dokument %0",
    "Opublikowany na stronach": "",
    "Wpisz nazwę miasta...": "Wpisz nazwę miasta...",
    "Szkolenie zostało skopiowane": "",
    "Data zmiany statusu od": "Data zmiany statusu od",
    "Lista powiadomień": "Lista powiadomień",
    "Numer zadania": "",
    "Formularz został dodany.": "Formularz został dodany.",
    "co 3 miesiące": "co 3 miesiące",
    "Brak odpowiedzi": "Brak odpowiedzi",
    "Litery": "Litery",
    "Data utworzenia": "Data utworzenia",
    "Koniec dystansu": "Koniec dystansu",
    "Hasło użytkownika serwisowego": "Hasło użytkownika serwisowego",
    "Data utworzenia od": "Data utworzenia od",
    "Ustaw szerokości proporcjonalnie": "Ustaw szerokości proporcjonalnie",
    "Zacznij pisać aby wyszukać tagi...": "Zacznij pisać aby wyszukać tagi...",
    "Pokaż przycisk ``Wyślij``": "Pokaż przycisk ``Wyślij``",
    "Czeklisty": "Czeklisty",
    "Zadanie": "Zadanie",
    "Uwzględniaj Dzielnice": "Uwzględniaj Dzielnice",
    "Edycja wpisu": "",
    "Powtóz hasło": "",
    "Dołącz do czatu": "Dołącz do czatu",
    "Dodaj dane dostepowe...": "Dodaj dane dostepowe...",
    "Edycja miasta": "Edycja miasta",
    "Nie udało się przesłać plików": "",
    "Niestandardowy adres": "",
    "Ilość pracowników": "Ilość pracowników",
    "Pasek postępu": "Pasek postępu",
    "Wyłączone (NoFollow)": "",
    "Uzupełnij brakujące pola.": "",
    "Magazyn": "Magazyn",
    "Brak nowych wiadomości.": "Brak nowych wiadomości.",
    "Podano nieprawidłowe dane": "Podano nieprawidłowe dane",
    "Hasło zostało zmienione.": "",
    "Brak stron": "",
    "Dodane:": "Dodane:",
    "Pobierz Excel": "",
    "Treść została zaktualizowana.": "",
    "Nieobecny od": "Nieobecny od",
    "Nazwa": "Nazwa",
    "Back Office (BO)": "Back Office (BO)",
    "Lekcja może zawierać tylko materiały opisowe lub materiały video": "",
    "Wyświetl szczegóły": "Wyświetl szczegóły",
    "Podstawowe operacje warunkowe": "Podstawowe operacje warunkowe",
    "Nazwa kolumny z opisem": "Nazwa kolumny z opisem",
    "Tag": "Tag",
    "Moduł": "",
    "Ostatnie 5 zadań": "Ostatnie 5 zadań",
    "Pilne": "Pilne",
    "*Koordynator zespołu posiada dostęp do panelu koordynatora": "",
    "Opis źródła": "Opis źródła",
    "Nazwisko klienta": "Nazwisko klienta",
    "Zadanie zostało zapauzowane.": "Zadanie zostało zapauzowane.",
    "Wprowadzona wartość jest za krótka": "Wprowadzona wartość jest za krótka",
    "Lista użytkowników": "",
    "Pokaż listę dostępnych tras": "Pokaż listę dostępnych tras",
    "Wyszukaj tag...": "Wyszukaj tag...",
    "Nazwa przedmiotu": "Nazwa przedmiotu",
    "Przypisane:": "Przypisane:",
    "Checklista": "Checklista",
    "Zapisz filtry": "Zapisz filtry",
    "Zostałeś zablokowany, dodanie wiadomości jest niemożliwe": "Zostałeś zablokowany, dodanie wiadomości jest niemożliwe",
    "Nie udało się dodać nieruchomość do trasy": "Nie udało się dodać nieruchomość do trasy",
    "Zbliżająca się data zakończenia": "",
    "Załącz plik excel": "Załącz plik excel",
    "Status został zmieniony.": "",
    "Wybierz...": "",
    "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "",
    "Wybierz użytkownika": "Wybierz użytkownika",
    "Podlega ocenie": "",
    "Zaopatrzenie zostało usunięte.": "Zaopatrzenie zostało usunięte.",
    "Nie udało się pobrać listy typów materiałów": "",
    "Historia zmian kosztu": "",
    "Prefix": "Prefix",
    "Użytkownik został dodany.": "Użytkownik został dodany.",
    "Tak, przejdź do mapy": "",
    "Wynagrodzenia Koordynatorzy": "Wynagrodzenia Koordynatorzy",
    "Data wylogowania": "Data wylogowania",
    "Usunięte przez użytkownika": "Usunięte przez użytkownika",
    "Adres email nadawcy": "Adres email nadawcy",
    "Klient został dodany.": "Klient został dodany.",
    "Rola została usunięta.": "Rola została usunięta.",
    "Edycja klienta": "Edycja klienta",
    "Wartości": "Wartości",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "",
    "Wczytuję...": "Wczytuję...",
    "Zrób zdjęcie": "Zrób zdjęcie",
    "Zdecydowanie nie": "Zdecydowanie nie",
    "Koniec dystansu": "Koniec dystansu",
    "Zastępuje osobę": "Zastępuje osobę",
    "Zawartość": "",
    "Nazwa bloku": "",
    "Nazwa zadania": "Nazwa zadania",
    "Domyślna": "",
    "Nazwa źródła danych": "Nazwa źródła danych",
    "Zastępstwa": "Zastępstwa",
    "Brak zadań": "Brak zadań",
    "Stwórz zadanie z tej rezerwacji": "Stwórz zadanie z tej rezerwacji",
    "Rozwiń do": "",
    "Przyznaj dostęp": "Przyznaj dostęp",
    "Dark mode": "Dark mode",
    "Wyświetl materiały": "",
    "Klient aktywny": "Klient aktywny",
    "Zobacz czaty": "Zobacz czaty",
    "Maksymalny rozmiar pliku w MB": "Maksymalny rozmiar pliku w MB",
    "Rola": "Rola",
    "Strona została usunięta.": "Strona została usunięta.",
    "Ładuję zgłoszenia...": "Ładuję zgłoszenia...",
    "Separator elementów w tytule": "",
    "Domyślna firma": "Domyślna firma",
    "Dodaj do zestawu": "",
    "Wklej komponent": "Wklej komponent",
    "Odpowiedź 3": "Odpowiedź 3",
    "Przywrócić wiadomość?": "Przywrócić wiadomość?",
    "Zmień rozmiar": "Zmień rozmiar",
    "3": "",
    "Strona nadrzędna": "",
    "Książka": "",
    "Zapisuję...": "Zapisuję...",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "Tytuł formularza nie może być dłuższy niż %0 znaków",
    "Kolor obramowania": "Kolor obramowania",
    "Laptop 15,6\"": "",
    "Podgląd szablonu e-maila": "Podgląd szablonu e-maila",
    "Nadpisz kwotę dla": "Nadpisz kwotę dla",
    "Filtry kalendarza": "Filtry kalendarza",
    "Województwo": "Województwo",
    "Data modyfikacji": "Data modyfikacji",
    "Wymagane jest wybranie sekcji": "",
    "Sekcja": "Sekcja",
    "Sortowanie malejąco": "Sortowanie malejąco",
    "Nie udało się pobrać tras": "Nie udało się pobrać tras",
    "Typ": "Typ",
    "Najwyższy": "",
    "Czy na pewno chcesz zablokować użytkownika?": "Czy na pewno chcesz zablokować użytkownika?",
    "Przenieś niżej": "",
    "Kwota za godzinę": "Kwota za godzinę",
    "Edycja zadania": "Edycja zadania",
    "Kategoria jest wymagana": "Kategoria jest wymagana",
    "Potwierdź publikację wersji": "",
    "Potwierdzenie usunięcia.": "",
    "Zaokrąglenie": "Zaokrąglenie",
    "Wprowadzona wartość jest za długa": "Wprowadzona wartość jest za długa",
    "Edytuj zlecenie": "Edytuj zlecenie",
    "Treść": "Treść",
    "Bez \"http(s)://\" i \"/\" na końcu.": "",
    "Nie znaleziono żadnych plików": "Nie znaleziono żadnych plików",
    "Usuń powiązanie": "",
    "Użytkownicy w tej roli": "Użytkownicy w tej roli",
    "Został przywrócony oryginalny harmonogram": "Został przywrócony oryginalny harmonogram",
    "Zaakceptuj, wyślij": "Zaakceptuj, wyślij",
    "treść notatki": "treść notatki",
    "Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\".": "Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\".",
    "Przypisz obiekty": "Przypisz obiekty",
    "Zacznij pisać aby wyszukać dzielnicę...": "Zacznij pisać aby wyszukać dzielnicę...",
    "Poprawna odpowiedź": "",
    "Sypialnia": "",
    "Edycja nowej trasy": "Edycja nowej trasy",
    "Następna strona": "Następna strona",
    "Dodanie regulaminu": "",
    "Przypisane zadanie:": "Przypisane zadanie:",
    "Harmonogram zadań": "Harmonogram zadań",
    "Lista Tras:": "Lista Tras:",
    "Opis certyfikatu": "",
    "Ścieżka aktywnej strony": "",
    "Potwierdzenie ukrycia": "",
    "Slajder": "",
    "Kwota łącznie": "Kwota łącznie",
    "Przypnij menu": "",
    "Nie masz uprawnień do modyfikacji aranżacji.": "",
    "Data wydania": "",
    "Zadanie zostało ukończone.": "Zadanie zostało ukończone.",
    "Wyświetlanie": "",
    "Uwzględniaj dzielnice": "Uwzględniaj dzielnice",
    "Numer inwentaryzacji": "Numer inwentaryzacji",
    "Brak sekcji multimediów": "",
    "Kosz": "Kosz",
    "Dodanie poradnika": "",
    "Kierowca": "Kierowca",
    "Zajęte": "Zajęte",
    "Brak zmian": "Brak zmian",
    "Edycja działu": "Edycja działu",
    "Porównania": "Porównania",
    "Informacje podstawowe": "Informacje podstawowe",
    "Nieobecność": "Nieobecność",
    "Dodanie nieruchomości": "Dodanie nieruchomości",
    "Nie udało się pobrać listy serwerów plików": "Nie udało się pobrać listy serwerów plików",
    "Odepnij menu": "",
    "Ilość dostępnych bloków": "",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "",
    "Kontener plików": "Kontener plików",
    "Kalendarz - Kategorie zasobów": "Kalendarz - Kategorie zasobów",
    "Opublikowane wersje językowe.": "",
    "Dodaj kolor": "Dodaj kolor",
    "Do kogo chcesz napisać?": "Do kogo chcesz napisać?",
    "Statystyki wniosków": "Statystyki wniosków",
    "Wstaw treść widoczną po rozwinięciu": "",
    "Wynagrodzenie za konserwację": "Wynagrodzenie za konserwację",
    "Kod Google Webmaster": "",
    "Domyślna": "",
    "od": "od",
    "co 6 miesięcy": "co 6 miesięcy",
    "Wybierz paczkę": "",
    "Wstaw z dołu": "Wstaw z dołu",
    "Ustawienia powiadomień": "Ustawienia powiadomień",
    "Pokaż zdjęcia": "Pokaż zdjęcia",
    "FavIcona": "",
    "Region": "Region",
    "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
    "Dostęp do szkoleń:": "",
    "Miniaturki": "Miniaturki",
    "Nowy materiał": "",
    "Zastosuj": "Zastosuj",
    "Dodanie klienta": "Dodanie klienta",
    "Nazwa szablonu": "Nazwa szablonu",
    "Czy jesteś pewien? ": "Czy jesteś pewien? ",
    "Wyświetlam": "Wyświetlam",
    "Checklista została usunięta": "Checklista została usunięta",
    "Identyfikator publiczny": "Identyfikator publiczny",
    "Slajdery": "",
    "Nazwa kategorii": "Nazwa kategorii",
    "Liczba miast w regionie": "Liczba miast w regionie",
    "Kontrolki podstawowe": "Kontrolki podstawowe",
    "Tydzień": "Tydzień",
    "Usuń katalog": "",
    "Podtytuł": "",
    "Codziennie": "Codziennie",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "Tytuł formularza nie może być dłuższy niż %0 znaków",
    "Rozpoczęto synchronizację rezerwacji": "Rozpoczęto synchronizację rezerwacji",
    "Adres URL": "Adres URL",
    "Dodaj notatkę/komentarz": "",
    "Szablony": "",
    "Typ źródła danych": "Typ źródła danych",
    "Zobacz czaty": "Zobacz czaty",
    "Housekeeping (HK)": "Housekeeping (HK)",
    "Klienci": "Klienci",
    "Zacznij pisać aby wyszukać inspektora...": "Zacznij pisać aby wyszukać inspektora...",
    "Przybornik": "Przybornik",
    "Angielski": "Angielski",
    "Nie możesz zapisać zmian, gdyż liczba elementów nie może być mniejsza niż ustawiona liczba wymaganych elementów w zakładce ustawienia testu": "",
    "Zamknięte": "Zamknięte",
    "Pokaż zaplanowane punkty": "Pokaż zaplanowane punkty",
    "Opis kosztu": "",
    "ID nazwa obiektu": "ID nazwa obiektu",
    "Zacznij pisać aby wyszukać nieruchomość...": "Zacznij pisać aby wyszukać nieruchomość...",
    "Odrzucone zgody": "",
    "Witryny": "",
    "Zadanie zostało zaktualizowane.": "Zadanie zostało zaktualizowane.",
    "Kwota opłacona od": "Kwota opłacona od",
    "Pole zawiera": "Pole zawiera",
    "Pole \"Imię\" jest wymagane.": "Pole \"Imię\" jest wymagane.",
    "Koniec długości geograficznej użytkownika": "Koniec długości geograficznej użytkownika",
    "TAK": "TAK",
    "Pokaż nieruchomości (bez zadań i rezerwacji)": "Pokaż nieruchomości (bez zadań i rezerwacji)",
    "Zadanie zostało usunięte": "Zadanie zostało usunięte",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "Nie masz wymaganych uprawnień do wykonania wybranej operacji.",
    "Numer mieszkania": "Numer mieszkania",
    "Numer telefonu: ": "Numer telefonu: ",
    "Zamknij": "Zamknij",
    "Statystyki regionalne - regiony": "Statystyki regionalne - regiony",
    "Tryb konserwacji systemu": "Tryb konserwacji systemu",
    "Przyrostek": "Przyrostek",
    "Numer sesji": "Numer sesji",
    "Notatka": "Notatka",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "",
    "Konfiguracja bloku": "",
    "Brak dostępnych tras": "Brak dostępnych tras",
    "Statystyki kosztów w obiektach": "Statystyki kosztów w obiektach",
    "Stwórz czat z rezerwacji": "Stwórz czat z rezerwacji",
    "Klient został usunięty.": "Klient został usunięty.",
    "Zawiera": "Zawiera",
    "Krótki tytuł": "",
    "Opis zespołu": "Opis zespołu",
    "Krzesełko": "Krzesełko",
    "Serwer bazy danych": "Serwer bazy danych",
    "Wynagrodzenia Kierowcy": "Wynagrodzenia Kierowcy",
    "Adres e-mail potwierdzony": "",
    "Podanie nazwy jest wymagane.": "Podanie nazwy jest wymagane.",
    "Data dodania od": "",
    "Ilość osób": "Ilość osób",
    "Nazwisko": "Nazwisko",
    "Wartość 0 oznacza brak limitu": "",
    "Szablon został dodany.": "Szablon został dodany.",
    "NIE": "NIE",
    "Data uruchomienia": "Data uruchomienia",
    "Wyszukaj zespół": "",
    "Paczka SCORM została zaktualizowana.": "",
    "Co 5 dni": "Co 5 dni",
    "Daty publikacji zostały zaktualizowane.": "",
    "Urlopy": "Urlopy",
    "Stopka": "Stopka",
    "Aranżacja została opublikowana.": "",
    "Rozliczenia": "Rozliczenia",
    "Nie wiem": "Nie wiem",
    "Historia lokalizacji": "Historia lokalizacji",
    "Nigdy": "Nigdy",
    "Nie udało się pobrać listy szablonów": "",
    "Wersja utowrzona przez": "Wersja utowrzona przez",
    "Kategoria szkolenia": "",
    "Lista szkoleń": "",
    "Ukryj": "Ukryj",
    "Wykonawca": "",
    "Profil koordynatora": "",
    "Edytuj aranżację": "",
    "Wybierz miasta": "Wybierz miasta",
    "Moduły": "",
    "Przeniesienie wybranych elementów": "Przeniesienie wybranych elementów",
    "Link do zewnętrznej strony": "",
    "Data zakońćzenia": "",
    "Wystąpił błąd podczas zapisywania ustawień": "Wystąpił błąd podczas zapisywania ustawień",
    "Ukryj podczas dodawania zadania": "Ukryj podczas dodawania zadania",
    "Tytuł aktywnej witryny": "",
    "Czerwiec": "Czerwiec",
    "Osoba odpowiedzialna": "Osoba odpowiedzialna",
    "Usunął": "Usunął",
    "Zacznij pisać aby wyszukać nieruchomość roboczą...": "Zacznij pisać aby wyszukać nieruchomość roboczą...",
    "Eksportuj do PDF": "Eksportuj do PDF",
    "Zlecenie na nieruchomość roboczą": "Zlecenie na nieruchomość roboczą",
    "Kolejność punktów trasy została zaktualizowana": "Kolejność punktów trasy została zaktualizowana",
    "Obsługa Właściciela (OW)": "Obsługa Właściciela (OW)",
    "Dozwolone rozszerzenia": "Dozwolone rozszerzenia",
    "Tag nieruchomości": "Tag nieruchomości",
    "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "",
    "Blokada konta": "Blokada konta",
    "Status paczki został zmieniony.": "",
    "Usuń ze szkolenia": "",
    "Dokument został dodany.": "",
    "Wymagaj odpowiedzi, aby przejść dalej": "",
    "Typ nieobecności": "Typ nieobecności",
    "Następna inwentaryzacja": "Następna inwentaryzacja",
    "Tylko do odczytu": "Tylko do odczytu",
    "Bardzo dobrze": "Bardzo dobrze",
    "Struktura serwisu": "",
    "W organizacji nie ma jeszcze żadnych działów.": "W organizacji nie ma jeszcze żadnych działów.",
    "Trasa została usunięta": "Trasa została usunięta",
    "Nr nieruchomości Avantio": "Nr nieruchomości Avantio",
    "Imię i Nazwisko": "Imię i Nazwisko",
    "Ważność": "Ważność",
    "Pracownik": "Pracownik",
    "Dokument został zaktualizowany.": "",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Błąd 404. Nie znaleziono żądanego zasobu.",
    "W zespole od %0 do %1": "W zespole od %0 do %1",
    "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
    "To pole jest wymagane": "To pole jest wymagane",
    "Dodanie paczki SCORM": "",
    "Wynagrodzenia od ilości posprzątanych obiektów": "Wynagrodzenia od ilości posprzątanych obiektów",
    "OW": "OW",
    "(AirBnb) Wysłano żądanie do gościa": "(AirBnb) Wysłano żądanie do gościa",
    "Data pauzy": "Data pauzy",
    "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.",
    "Wysłano kolejne wezwanie do zapłaty": "Wysłano kolejne wezwanie do zapłaty",
    "Zastępstwo zostało usunięte.": "Zastępstwo zostało usunięte.",
    "Wklej komponent": "Wklej komponent",
    "Przeterminowane": "Przeterminowane",
    "Procent": "Procent",
    "Rezerwacje": "Rezerwacje",
    "Zacznij pisać aby wyszukać tag...": "Zacznij pisać aby wyszukać tag...",
    "Data do": "Data do",
    "Oznacz widoczne jako przeczytane": "Oznacz widoczne jako przeczytane",
    "Dzisiaj": "Dzisiaj",
    "Szczegóły zmian": "Szczegóły zmian",
    "Zakończone: ${$filters.datetime(task.dateCompleted)}": "Zakończone: ${$filters.datetime(task.dateCompleted)}",
    "Treść opublikowana": "",
    "Nazwa lekcji": "",
    "Użytkownik Inspekcja": "Użytkownik Inspekcja",
    "Typ słownika": "Typ słownika",
    "Zablokuj użytkownika": "Zablokuj użytkownika",
    "Data użycia": "Data użycia",
    "Typ zadania": "Typ zadania",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą klienta": "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą klienta",
    "Pytanie 1": "Pytanie 1",
    "Nieważne": "Nieważne",
    "Sekcja została zaktualizowana": "",
    "Kontrolka wyboru (pojedynczy wybór)": "Kontrolka wyboru (pojedynczy wybór)",
    "Kolor został zaktualizowany": "Kolor został zaktualizowany",
    "Lekcja została dodana.": "",
    "Kwiecień": "Kwiecień",
    "Kanały obsługiwane przez wybrany typ powiadmienia": "Kanały obsługiwane przez wybrany typ powiadmienia",
    "Region został dodany.": "Region został dodany.",
    "Usunięto przez: ": "Usunięto przez: ",
    "Komunikat błędu": "Komunikat błędu",
    "Typ Nieruchomości": "Typ Nieruchomości",
    "Classic mode": "",
    "Strona %0": "Strona %0",
    "Pokaż rezerwacje właścicielskie": "Pokaż rezerwacje właścicielskie",
    "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "",
    "nie wymuszaj zmiany hasła": "nie wymuszaj zmiany hasła",
    "Nazwa pliku została zmieniona.": "Nazwa pliku została zmieniona.",
    "Nazwa użytkownika serwisowego": "Nazwa użytkownika serwisowego",
    "Nadpisz kwotę dla": "Nadpisz kwotę dla",
    "Konfiguracja domyślna": "Konfiguracja domyślna",
    "Edytuj lekcje": "",
    "Aby wysłać wiadomość, dołącz do czatu": "Aby wysłać wiadomość, dołącz do czatu",
    "Plik został wysłany": "Plik został wysłany",
    "Nazwa regionu": "Nazwa regionu",
    "Tytuł": "Tytuł",
    "Edycja nieruchomości roboczej": "Edycja nieruchomości roboczej",
    "Uwzględnij dodatkowe nieruchomości": "Uwzględnij dodatkowe nieruchomości",
    "Rezerwacja": "Rezerwacja",
    "Admin": "Admin",
    "Cena PLN": "Cena PLN",
    "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.",
    "Administracja - Województwa": "Administracja - Województwa",
    "Pokaż punkty bez kierowcy": "Pokaż punkty bez kierowcy",
    "Nie udało się pobrać listy kategorii": "",
    "Materiały szkoleniowe": "",
    "Przypomnij": "Przypomnij",
    "Typ źródła": "Typ źródła",
    "Domyślna firma": "Domyślna firma",
    "Czy jesteś pewien, że chcesz przypisać dzielnicę do nowego miasta? Wszystkie nieruchomości i użytkownicy przypisani do tej dzielnicy przestaną być do niej przypisani.": "Czy jesteś pewien, że chcesz przypisać dzielnicę do nowego miasta? Wszystkie nieruchomości i użytkownicy przypisani do tej dzielnicy przestaną być do niej przypisani.",
    "Wyślij link": "Wyślij link",
    "Dostęp niezdefiniowany": "Dostęp niezdefiniowany",
    "Na wniosek": "",
    "Od ilości posprzątanych obiektów": "Od ilości posprzątanych obiektów",
    "Aktualności": "",
    "Przenieś": "Przenieś",
    "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.",
    "Zadanie do wykonania": "Zadanie do wykonania",
    "Pole wymagane": "Pole wymagane",
    "Maj": "Maj",
    "Dane formularza są przechowywane w obiekcie Entry.": "Dane formularza są przechowywane w obiekcie Entry.",
    "Pliki publiczne": "Pliki publiczne",
    "Zaakceptowane, zapisz": "Zaakceptowane, zapisz",
    "Symbol klienta": "Symbol klienta",
    "Dodaj zespół": "Dodaj zespół",
    "Dodanie lekcji": "",
    "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Pole \"%0\" nie zawiera prawidłowego adresu email.",
    "Kwota netto": "",
    "Korytarz": "",
    "Numer dowodu osobistego": "Numer dowodu osobistego",
    "W trakcie": "W trakcie",
    "Użytkownik został przypisany do szkolenia.": "",
    "Skopiuj szkolenie": "",
    "Piosenka": "",
    "Edytuj datę dostępu": "",
    "Ostatnia wiadomość - data": "Ostatnia wiadomość - data",
    "Wybrane regulaminy: ": "",
    "Sprawdzić": "Sprawdzić",
    "Dodaj nowy tag": "Dodaj nowy tag",
    "Zatwierdź": "Zatwierdź",
    "Nie udało się pobrać listy ról": "Nie udało się pobrać listy ról",
    "kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)": "kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)",
    "Wynagrodzenia Pracownicy": "Wynagrodzenia Pracownicy",
    "Pytania": "Pytania",
    "Pobierz raport": "Pobierz raport",
    "Sesja": "Sesja",
    "Treść wiadomości": "Treść wiadomości",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą właściciela": "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą właściciela",
    "Przeczytane": "",
    "Użytkownik i jego wiadomości zostały przywrócone.": "Użytkownik i jego wiadomości zostały przywrócone.",
    "Serwer został dodany.": "Serwer został dodany.",
    "Booking with conflict": "Booking with conflict",
    "Usuń zestaw": "",
    "Otwórz Ustawienia": "Otwórz Ustawienia",
    "Obciążenie Renters": "Obciążenie Renters",
    "Brak zadań do wyświetlenia": "Brak zadań do wyświetlenia",
    "Rozwiń/Zwiń": "",
    "Dodane przez moje zespoły": "",
    "Typ wynagrodzenia został usunięty": "Typ wynagrodzenia został usunięty",
    "Sesja użytkownika": "Sesja użytkownika",
    "Tekst zastępczy": "Tekst zastępczy",
    "Dodaj użytkownika": "Dodaj użytkownika",
    "Dodaj Notatkę": "Dodaj Notatkę",
    "Zadanie wykonuje": "Zadanie wykonuje",
    "Pokaż historię": "Pokaż historię",
    "Edycja paczek SCORM": "",
    "Dodaj certyfikat": "",
    "Resetowanie podejść": "",
    "Piątek": "Piątek",
    "Aktualne hasło": "Aktualne hasło",
    "Kolor został usunięty": "Kolor został usunięty",
    "Maksymalna ilość plików": "Maksymalna ilość plików",
    "Dodaj dział": "Dodaj dział",
    "Włącz monitorowanie aktywności": "",
    "Średnie wynagrodzenie": "Średnie wynagrodzenie",
    "Wybierz temat": "",
    "Nie udało się usunąć zlecenia.": "Nie udało się usunąć zlecenia.",
    "Edycja checklisty": "Edycja checklisty",
    "Zespół aktywny": "Zespół aktywny",
    "Nr rezerwacji": "Nr rezerwacji",
    "Batch": "",
    "Historia nieruchomości": "Historia nieruchomości",
    "Zaopatrzenie zostało dodane.": "Zaopatrzenie zostało dodane.",
    "Wybrane elementy zostały usunięte.": "Wybrane elementy zostały usunięte.",
    "Dodaj": "Dodaj",
    "Dodaj chat": "Dodaj chat",
    "Typ materiału": "",
    "Top mieszkań generujacych najwięcej kosztów": "Top mieszkań generujacych najwięcej kosztów",
    "Sesja nr %0": "Sesja nr %0",
    "Dodanie slajdera": "",
    "Procent obciążeń": "Procent obciążeń",
    "Stan licznika start": "Stan licznika start",
    "Id modelu: %0": "Id modelu: %0",
    "Do kogo wysłać testowe powiadomienie": "Do kogo wysłać testowe powiadomienie",
    "Zespół został zaktualizowany.": "Zespół został zaktualizowany.",
    "Wybierz paczkę SCORM": "",
    "Dzielnice": "Dzielnice",
    "Dodanie dzielnicy": "Dodanie dzielnicy",
    "Stwórz zadanie": "",
    "Standardowa strona": "",
    "Wielokrotny wybór": "Wielokrotny wybór",
    "To miasto znajduję się już w tym regionie.": "To miasto znajduję się już w tym regionie.",
    "Pseudonim": "",
    "Minimum": "Minimum",
    "Ustawienia domyślne": "Ustawienia domyślne",
    "Ostatnie sprzątanie": "Ostatnie sprzątanie",
    "Dodaj Koszt": "Dodaj Koszt",
    "Dodaj zestaw": "",
    "Usuń wybrane": "Usuń wybrane",
    "Ten region jest już przypisany do użytkownika.": "Ten region jest już przypisany do użytkownika.",
    "Źródło": "Źródło",
    "Nie wypełniono poprzedniego wiersza.": "",
    "Status zadania": "Status zadania",
    "Nazwa aktywnej strony": "",
    "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "",
    "Aranżacja": "",
    "Dostęp od": "",
    "Godzina trasy": "Godzina trasy",
    "Ścieżka szkoleniowa została usunięta.": "",
    "Program szkolenia": "",
    "Dzielnica": "Dzielnica",
    "Tłumacz": "Tłumacz",
    "W polu możemy umieszczać jedynie cyfry": "W polu możemy umieszczać jedynie cyfry",
    "Edytuj zadanie": "Edytuj zadanie",
    "Nadpisanie kwoty wynagrodzenia zostało dodane.": "Nadpisanie kwoty wynagrodzenia zostało dodane.",
    "Zameldowanie": "Zameldowanie",
    "Monitor kolejek": "Monitor kolejek",
    "Zawiera sekcje": "",
    "Konto aktywne": "Konto aktywne",
    "Usuń stronę": "",
    "Pojedynczy wybór": "Pojedynczy wybór",
    "Dodaj lekcję": "",
    "Zacznij pisać aby wyszukać użytkownika...": "Zacznij pisać aby wyszukać użytkownika...",
    "dzień temu": "dzień temu",
    "Zapisz wersję": "",
    "Trasa została wznowiona": "Trasa została wznowiona",
    "Ustawienia powiadomień": "Ustawienia powiadomień",
    "Marka": "Marka",
    "Kategoria wyszukiwanego matariału": "",
    "Ilość pracowników": "Ilość pracowników",
    "Wybierz osobę spoza dzielnicy": "Wybierz osobę spoza dzielnicy",
    "Nieaktywne": "Nieaktywne",
    "Przeciągnij do innej sekcji": "",
    "Podlega ocenie": "",
    "Nieruchomość zagrożona wypowiedzeniem": "Nieruchomość zagrożona wypowiedzeniem",
    "Nie udało się pobrać listy serwerów baz danych": "Nie udało się pobrać listy serwerów baz danych",
    "Ustawienia": "Ustawienia",
    "Zaplanowane": "Zaplanowane",
    "Usuń wybrane": "Usuń wybrane",
    "Niewidoczne": "Niewidoczne",
    "Filtry systemowe": "Filtry systemowe",
    "Szkolenie zostało zaktualizowane.": "",
    "Opis sekcji": "",
    "Imię właściciela": "Imię właściciela",
    "Krótki tytuł": "",
    "Opis certyfikatu": "",
    "Szczegóły zmiany": "Szczegóły zmiany",
    "Lewy panel": "Lewy panel",
    "Dodaj media": "Dodaj media",
    "Nieobecność do": "Nieobecność do",
    "Nie udało się zapisać komentarza": "",
    "Host główny": "Host główny",
    "Dodaj pliki": "",
    "Dodaj sekcję": "",
    "Edytuj sekcję": "",
    "Sekcja została utworzona": "",
    "Sekcja została zaktualizowana": "",
    "Sekcja została usunięta": "",
    "Sekcja nie została znaleziona": "",
    "Typ pomieszczenia jest wymagany": "",
    "Typ plików jest wymagany": "",
    "Wybierz pliki do dodania": "",
    "Pliki zostały dodane": "",
    "Pliki zostały pobrane": "",
    "Plik został przeniesiony": "",
    "Brak sekcji multimediów": "",
    "Czy na pewno chcesz usunąć tę sekcję?": "",
    "Zaznacz wszystkie w sekcji": "",
    "Brak plików w sekcji": "",
    "Wybierz sekcję": "",
    "Brak sekcji - najpierw utwórz sekcję": "",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "",
    "Wybierz sekcję, do której chcesz dodać pliki": "",
    "Sekcja jest wymagana": "",
    "Wybrana sekcja nie istnieje": "",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "",
    "Nie udało się przesłać plików": "",
    "Budynek": "",
    "Pokój dzienny": "",
    "Sypialnia": "",
    "Kuchnia": "",
    "Łazienka": "",
    "Korytarz": "",
    "Typ pomieszczenia": "",
    "Nie znaleziono nieruchomości": "",
    "Nie udało się załadować plików": "",
    "Usuń zaznaczone": "",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "",
    "Pliki zostały usunięte": "",
    "Nie można przenosić plików między sekcjami o różnych typach": "",
    "Pliki zostaną automatycznie dodane do odpowiednich sekcji 'Inne' na podstawie typu pliku.": "",
    "Pliki": "",
    "Dane kosztu": "",
    "Nazwa kosztu": "",
    "Opis kosztu": "",
    "Kwota brutto": "",
    "Kwota netto": "",
    "VAT (wyliczany automatycznie)": "",
    "VAT": "",
    "Historia zmian kosztu": "",
    "Brak historii zmian": "",
    "Wersja": "",
    "Koszt został dodany.": "",
    "Koszt został zaktualizowany.": "",
    "Pobierz Excel": "",
    "Koszt został usunięty": "",
    "Excel został wygenerowany i wysłany na adres e-mail": "",
    "Materiały": "",
    "Koszt pracownika": "",
    "Dane z VROS": "",
    "Parking": "",
    "Wi-Fi": "",
    "Router": "",
    "Nazwa sieci": "",
    "Instrukcje": "",
    "Instrukcje zameldowania": "",
    "Instrukcje wymeldowania": "",
    "Przewodnik gościa": "",
    "Kod do skrytki na klucze": "",
    "Godzina zameldowania (Guesty)": "",
    "Godzina końca zameldowania (Guesty)": "",
    "Godzina wymeldowania (Guesty)": "",
    "Hiszpański": "Hiszpański",
    "Brak wybranej firmy": "Brak wybranej firmy",
    "Lista kosztów": "Lista kosztów",
    "Akceptacja kosztów": "Akceptacja kosztów",
    "Recenzje sprzątaczy": "Recenzje sprzątaczy",
    "Kwota dodatkowego wynagrodzenia nie może być ujemna": "Kwota dodatkowego wynagrodzenia nie może być ujemna",
    "Nazwa czynności": "Nazwa czynności",
    "Dodaj czynność": "Dodaj czynność",
    "Liczba czynności": "NLiczba czynności",
    "Dodaj kategorię zadań": "odaj kategorię zadań",
    "Obsługa właścicieli": "OW",
    "Edycja kategorii zadań": "Edycja kategorii zadań",
    "Edycja czynności": "Edycja czynności",
    "Brak wydziału": "Brak wydziału",
    "Zacznij pisać aby wyszukać czynność...": "Zacznij pisać aby wyszukać czynność...",
    "Czynność została zaktualizowana.": "Czynność została zaktualizowana.",
    "Czynność została usunięta.": "Czynność została usunięta.",
    "Czynność została dodana.": "Czynność została dodana.",
    "Nie można dodać tej czynności do zadania.": "Nie można dodać tej czynności do zadania.",
    "Przypisane czynności": "Przypisane czynności",
    "Brak przypisanych czynności.": "Brak przypisanych czynności.",
    "Kategorie zadań": "Kategorie zadań",
    "Czynności zadań": "Czynności zadań",
    "czynności": "czynności",
    "usunięta": "usunięta",
    "Komentarz (opcjonalny)": "Komentarz (opcjonalny)",
    "Formularz zadania nie jest poprawny.": "Formularz zadania nie jest poprawny.",
    "Biblioteka czynności": "Biblioteka czynności",
    "Szukaj czynności": "Szukaj czynności",
    "Wszystkie statusy": "Wszystkie statusy",
    "Przenieś na samą górę": "Przenieś na samą górę",
    "Przenieś na sam dół": "Przenieś na sam dół",
    "Widoczna w zadaniach": "Widoczna w zadaniach",
    "Czynność jest widoczna w zadaniach.": "Czynność jest widoczna w zadaniach.",
    "Czynność została ukryta w zadaniach.": "Czynność została ukryta w zadaniach.",
    "Edytuj kategorię": "Edytuj kategorię",
    "Edytuj czynność": "Edytuj czynność",
    "Nowa czynność": "Nowa czynność",
    "Kolejność została zapisana.": "Kolejność została zapisana.",
    "Nie udało się zapisać kolejności.": "Nie udało się zapisać kolejności.",
    "Przypisana do działu": "Przypisana do działu",
    "Przypisana do kategorii": "Przypisana do kategorii",
    "Np. wymiana okien": "Np. wymiana okien",
    "Użyta w": "Użyta w",
    "%0 zadaniach": "%0 zadaniach",
    "Zmiana nazwy nie zmieni istniejących zadań.": "Zmiana nazwy nie zmieni istniejących zadań.",
    "Upewnij się, że nazwa czynności:": "Upewnij się, że nazwa czynności:",
    "Nie zawiera literówek": "Nie zawiera literówek",
    "Jest jasna, klarowna i precyzyjna": "Jest jasna, klarowna i precyzyjna",
    "Zawiera polskie znaki": "Zawiera polskie znaki",
    "Aktywna w nowych zadaniach": "Aktywna w nowych zadaniach",
    "Czynność „Inne” (pokazuje pole komentarza w aplikacji mobilnej)": "Czynność „Inne” (pokazuje pole komentarza w aplikacji mobilnej)",
    "Czynności nigdy nie są usuwane, można je tylko dezaktywować": "Czynności nigdy nie są usuwane, można je tylko dezaktywować",
    "Np. Hydraulika": "Np. Hydraulika",
    "Przeciągnij, aby zmienić kolejność działów": "Przeciągnij, aby zmienić kolejność działów",
    "Zameldowanie / Wymeldowanie": "Zameldowanie / Wymeldowanie",
    "Media": "Media",
    "Dostawca": "Dostawca",
    "Inwentarz": "Inwentarz",
    "Komfort": "Komfort",
    "Dodatki": "Dodatki",
    "A/C": "A/C",
    "Ogrzewanie centralne": "Ogrzewanie centralne",
    "Kanapa": "Kanapa",
    "Zaciemnienie": "Zaciemnienie",
    "Grzejniki": "Grzejniki",
    "Bojler": "Bojler",
    "Pościel": "Pościel",
    "TV": "TV",
    "Suszarka do ubrań": "Suszarka do ubrań",
    "Suszarka do włosów": "Suszarka do włosów",
    "Żelazko": "Żelazko",
    "Piekarnik": "Piekarnik",
    "Kuchenka mikrofalowa": "Kuchenka mikrofalowa",
    "Czajnik": "Czajnik",
    "Dzbanek na wodę": "Dzbanek na wodę",
    "Środki czystości": "Środki czystości",
    "Pralka": "Pralka",
    "Suszarka na pranie": "Suszarka na pranie",
    "Lampki nocne": "Lampki nocne",
    "Deska do prasowania": "Deska do prasowania",
    "Kuchenka": "Kuchenka",
    "Toster": "Toster",
    "Zmywarka": "Zmywarka",
    "Odkurzacz": "Odkurzacz",
    "Ekspres do kawy": "Ekspres do kawy",
    "Apteczka": "Apteczka",
    "Czujnik CO2": "Czujnik CO2",
    "Gaśnica": "Gaśnica",
    "Czujnik dymu": "Czujnik dymu",
    "Przyjazne zwierzętom": "Przyjazne zwierzętom",
    "Widok": "Widok",
    "Prąd": "Prąd",
    "Ogrzewanie": "Ogrzewanie",
    "Woda": "Woda",
    "Gaz": "Gaz",
    "Internet": "Internet",
    "Dane zostały zapisane.": "Dane zostały zapisane.",
    "Piętro": "Piętro",
    "Winda": "Winda",
    "Balkon": "Balkon"
  },
  "en-US": {
    "Ulubione": "Favorites",
    "Dodaj do ulubionych": "Add to favorites",
    "Usuń z ulubionych": "Remove from favorites",
    "Wybierz typ Firmy": "Select a company type",
    "Zacznij pisać aby wyszukać dzielnice...": "Start typing to search for neighborhoods...",
    "Co godzinę": "Every hour",
    "Dostępne wersje językowe.": "Available language versions.",
    "Strona nadrzędna": "Parent page",
    "Autor notatki": "Author of the note",
    "zacznij pisać aby wyszukać artykuł...": "start typing to search for an article...",
    "Slajd został dodany.": "The slide has been added.",
    "Ten użytkownik już jest przypisany do czatu": "This user is already assigned to the chat",
    "Zlecenia": "Orders",
    "Otwórz czat - link": "Open chat - link",
    "Na żądanie działu": "At the request of the department",
    "W każdy dzień tygodnia": "Every day of the week",
    "Rozwiń": "Expand",
    "Artykuł": "Article",
    "10": "10",
    "Budynek": "",
    "Ostatnio oglądane": "Recently viewed",
    "Nieobecność do": "Absence until",
    "Wybierz pliki (do {0})": "Select files (to {0})",
    "Co 2 godziny": "Every 2 hours",
    "Moja trasa": "My route",
    "Dodanie źródła danych": "Add data source",
    "Publikuj szkolenie": "Publish training",
    "5 ostatnich zadań": "5 recent tasks",
    "Eksportuj do Excel": "Export to Excel",
    "Przypisana do (Imię i Nazwisko)": "Assigned to (Name and Surname)",
    "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "To preview the certificate, click Save.",
    "Zmniejsz": "Reduce",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "",
    "Data Wykonania": "Date of execution",
    "Dodaj kategorię": "Add category",
    "Dział został zaktualizowany.": "The department has been updated.",
    "Klient aktywny": "Active client",
    "Wprowadzona wartość jest nieprawidłowa": "The value you entered is invalid",
    "Slajd został zaktualizowany.": "The slide has been updated.",
    "Szablon checklisty": "Checklist template",
    "Tak/Nie": "Yes/No",
    "Strona szkolenia ukryta": "Training page hidden",
    "Dodanie nieruchomości roboczej": "Add a working property",
    "Nazwa taga": "Tag name",
    "Edytuj koszt": "",
    "Wybrana dzielnica": "Selected district",
    "Dodaj odpowiedź": "Add an answer",
    "Nazwa użytkownika": "User name",
    "Kolejka": "Queue",
    "Wartości": "Values",
    "Strona dostępna tylko dla zalogowanych użytkowników": "Page available only to logged in users",
    "Zastępstwo wygaśnie za minutę.": "The substitution will expire in a minute.",
    "Token został usunięty.": "The token has been removed.",
    "Liczba wyświetlanych najnowszych elementów": "Number of recent elements displayed",
    "Pomyślnie dołączono do czatu": "Successfully joined the chat",
    "Początek szerokości geograficznej użytkownika": "The beginning of the user's latitude",
    "Wybrany szablon": "Selected template",
    "Link został zaktualizowany.": "The link has been updated.",
    "Edycja zespołu": "Edit team",
    "Miasto": "City",
    "Zakończone przez: ": "Completed by: ",
    "Nie możesz wznowić obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "You cannot resume handling this task because you are now performing a different task",
    "Sekcje i bloki": "Sections and blocks",
    "Tło strona 2": "Background page 2",
    "Nazwa Kategorii": "Category Name",
    "Posprzątane": "Cleaned up",
    "Pokaż czaty": "Show chats",
    "Stwórz zadanie z tej rezerwacji": "Create a task from this booking",
    "Zespół został przypisany do ścieżki szkoleniowej.": "The team has been assigned to a learning path.",
    "Dodaj test": "Add test",
    "Usunięcie wybranych elementów": "Delete selected items",
    "Zapisuję...": "I'm saving...",
    "Sekcje dla gości": "Guest sections",
    "Włączone (Index)": "Enabled (Index)",
    "Zdecydowanie nie": "Definitely no",
    "Certyfikat został usunięty.": "The certificate has been removed.",
    "Notatka została zaktualizowana.": "The note has been updated.",
    "Ważne": "Important",
    "Tryb monitorowania aktywności": "Activity monitoring mode",
    "Link": "Link",
    "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
    "Stawka wynagrodzenia została zaktualizowana.": "The pay rate has been updated.",
    "Statystyki wyniosków": "Request statistics",
    "Lista plików": "List of files",
    "UWAGA! Ta tabela pokazuje tylko przeterminowane zadania, filtr \"STATUS\" nie jest aktywny. Wróć do \"Wszystkie zadania\" aby mieć dostępne wszystkie filtry": "ATTENTION! This table shows only overdue tasks, the \"STATUS\" filter is not active. Go back to \"All Tasks\" to have all filters available",
    "Usuń plik": "Delete file",
    "Element został zaktualizowany.": "The element has been updated.",
    "Dział:": "Department:",
    "Logi aktywności zostały wyczyszczone": "Activity logs cleared",
    "Nazwa katalogu lub pliku": "Directory or file name",
    "Utworzono kopię checklisty": "A copy of the checklist has been created",
    "Tryb wyświetlania": "Display mode",
    "Użytkownik Obsługa": "User Service",
    "Zapisz zmiany": "Save changes",
    "Zastępstwo zostało zaktualizowane.": "The substitution has been updated.",
    "Polska": "Poland",
    "Skala 1-5": "Scale 1-5",
    "Wydrukuj": "Print",
    "Firma domyślna": "Default company",
    "Nazwa Firmy": "Company name",
    "Zgoda": "Consent",
    "Wyszukiwarka miejsc": "Seats Finder",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "Insert two columns 1/3 and 2/3",
    "Szablon został usunięty.": "The template has been removed.",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "",
    "Niezakończone": "Unfinished",
    "Data wykonania od": "Exectuion date from",
    "Ukryj czaty": "Hide chats",
    "Co drugi miesiąc": "Every other month",
    "Nazwa kolumny z wartością": "Name of column with value",
    "Ostatnia strona": "Last page",
    "Komentarz konserwatora": "Comment by the conservator",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "Are you sure you want to move the selected elements to the current directory?",
    "Statyczny": "Static",
    "Zadania na wniosek działu": "Tasks at the request of the department",
    "Planuj automatycznie w dniu wymeldowania": "Schedule automatically on the day of check-out",
    "Jutro": "Tomorrow",
    "Wszystkie próby": "All attempts",
    "Przejdź do zadania": "Go to task",
    "Godzina przełomowa synchronizacji": "Breakthrough Hour of Synchronization",
    "Ilość wierszy": "Number of rows",
    "Dodaj do zespołu": "Add to team",
    "Inspekcja": "Inspection",
    "Łazienka": "",
    "Wydział": "Department",
    "Nie udało się pobrać listy filtrów": "Failed to download filter list",
    "Strona logowania": "Login page",
    "Administracja - Użytkownicy": "Administration - Users",
    "Wybierz plik lub katalog": "Select a file or directory",
    "Miejsca po przecinku": "Decimal points",
    "Dodane Koszty": "Added costs",
    "Designer": "Designer",
    "-": "-",
    "Wyślij testowe powiadomienie": "Send test notification",
    "Formularze": "Forms",
    "Nie udało sie zaktualizować zadania": "Failed to update task",
    "Początek dystansu": "The beginning of the distance",
    "Dane do sieci": "Data to the network",
    "Koszt Renters": "Renters cost",
    "Brak właściciela": "No owner",
    "Publikacja": "Publication",
    "Resetuj zmiany": "Reset changes",
    "Cyfry": "Digits",
    "Status: ": "Status: ",
    "Potwierdzam": "Confirm",
    "Co drugi dzień": "Every other day",
    "PDF": "",
    "Ustawienia globalne": "Global Settings",
    "Usuń": "Delete",
    "Nieruchomość jest widoczna": "The property is visible",
    "Zaakceptowany": "Accepted",
    "Zadanie zostało rozpoczęte.": "The task has started.",
    "Nazwa chatu": "Chat name",
    "Facebook Application ID": "Facebook Application ID",
    "Wyświetl nieruchomości robocze": "View working properties",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "A server error occurred while handling the selected operation. Please try again.",
    "15 minut": "15 minutes",
    "Edycja formularza": "Edit form",
    "Zakolejkowane": "Pending",
    "Adres URL profilu autora.": "URL of the author profile.",
    "Opis szkolenia": "Training description",
    "Dostęp przyznany przez zespół": "Team-granted access",
    "Modyfikacja": "Modification",
    "Nieprzeczytane": "Unread",
    "Numer nieruchomości (StreetNumber)": "Property number (StreetNumber)",
    "Kod Bing Webmaster": "Bing Webmaster Code",
    "Administracja - Stanowiska pracy": "Administration - Positions",
    "Wszystkie konta": "All accounts",
    "Edytuj lekcje wideo": "Edit video lesson",
    "Dostęp niezdefiniowany": "Undefined access",
    "Potwierdź wyłączenie publikacji": "Confirm that you want to disable publication",
    "Treść notatki": "Contents of the note",
    "edycja": "edit",
    "Link został zaktualizowany.": "The link has been updated.",
    "Widoczność": "Visibility",
    "Przypisani użytkownicy": "Assigned users",
    "Ukończone przez użytkownika o Id": "Completed by user o Id",
    "Ta dzielnica jest już przypisana do użytkownika.": "This district is already assigned to the user.",
    "Kwota opłacona": "Amount paid",
    "zacznij pisać aby wyszukać slajder...": "start typing to search for a slider...",
    "Tekst alternatywny": "Alternative text",
    "Stawka za typ apartamentu": "Rate per apartment type",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Number of employees working in more then one region",
    "Nie udało się pobrać listy kolejek": "Failed to retrieve queue list",
    "Dodanie roli": "Add role",
    "Wyżej": "Above",
    "Role i uprawnienia": "Roles and permissions",
    "Tekst zastępczy": "Substitute text",
    "Zarządzaj zespołami": "Manage teams",
    "Szkolenie kończy się": "Training is ending up",
    "Potwierdź wyczyszczenie logów": "Confirm clearing logs",
    "W polu możemy umieszczać jedynie cyfry całkowite, nie ujemne": "In the field we can put only whole digits, not negative ones",
    "Kierowca Główny": "Lead Driver",
    "Region został zaktualizowany.": "The region has been updated.",
    "Regulamin został zaktualizowany.": "Ragulations have been updated.",
    "Certyfikat jest opublikowany": "The certificate is published",
    "Nie masz uprawnień do publikacji aranżacji.": "You don't have permission to publish the arrangement.",
    "Checklista nie ma przypisanych miast.": "Checklista has no assigned cities.",
    "Opublikuj materiał": "Publish material",
    "Monitoring": "Monitoring",
    "Status rozliczenia": "Settlement status",
    "Zmień status": "Change status",
    "Klient został zaktualizowany.": "The client has been updated.",
    "Zaopatrzenie": "Supply",
    "Temat": "Subject",
    "Zdecydowanie się nie zgadzam": "I strongly disagree",
    "Dodaj szkolenie": "Add training",
    "Nazwa kosztu": "Name of cost",
    "Dostępny w sekcjach": "Available in sections",
    "%$ – znacznik otwierający tag": "%$ – tag to start a tag",
    "Notatka utworzona z zadania": "Note created from task",
    "Wybierz sekcję": "Select a section",
    "Hasło": "Password",
    "Dodaj firmę": "Add company",
    "Nieruchomość": "Property",
    "Zapisz slajd": "Save slide",
    "Wyświetlaj tylko treść": "Display only content ",
    "Sekcje wspólne": "Common sections",
    "Zdecydowanie nieważne": "Definitely not important",
    "Nazwa apartamentu": "Name of the apartment",
    "${DepartmentName(DepartmentEnum[this.task.department])}": "${DepartmentName(DepartmentEnum[this.task.department])}",
    "Październik": "October",
    "Właściwość ``%0`` aktywnego wpisu": "The ''%0'' feature of the active entry",
    "W zespole do": "In the team to",
    "Usuń zadanie": "Delete a task",
    "Materiał opisowy": "Descriptive material",
    "Wybierz strony": "Select pages",
    "Dodane przeze mnie": "Added by me",
    "Właściciel został usunięty": "The owner has been removed",
    "Checklista została dodana.": "Checklist has been added.",
    "zgłoś problem w apartamencie": "report a problem in the apartment",
    "Proszę zapisać postęp pracy i kliknąć przycisk \"Aktualizuj\".": "Please save the progress of the work and click the “Update” button.",
    "Email": "E-mail",
    "Obraz został wycięty.": "The image has been cut out.",
    "Wybrany materiał został już dodany do lekcji": "The selected material has already been added to the lesson",
    "Wybrane pliki": "Selected files",
    "Kontrolka wyboru (wybór wielokrotny)": "Choice control (multiple choice)",
    "Odpowiedź": "Answer",
    "Można dodawać tylko pliki typu: \"%0\".": "You can only add files of type: “⇑”.",
    "Typ pomieszczenia": "",
    "Paczki SCORM": "SCORM packages",
    "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "Number of days until the end of the training at which the notification will be sent",
    "Zacznij pisać aby wyszukać szablon checklisty...": "Start typing to search for a checklist template...",
    "Nazwa pola": "Field name",
    "Projekt": "Project",
    "Edycja inwentaryzacji": "Edit inventory",
    "Wybór": "Choice",
    "Dodanie zadania": "Add a task",
    "Wyświetlaj nazwę bloczka": "Display block name",
    "Uprawnienia": "Permissions",
    "Renters": "Renters",
    "Log z aktywności": "Activity log",
    "Data dezaktywacji": "Deactivation date",
    "Słownik systemowy": "System dictionary",
    "Umożliwienie sprawdzania odpowiedzi": "Enable checking of responses",
    "Ścieżka szkoleniowa została dodana.": "The learning path has been added.",
    "Źródło danych": "Data source",
    "Inwentaryzacja została dodana.": "The inventory has been added.",
    "Zastępstwo wygaśnie za 10 minut.": "The substitution will expire in 10 minutes.",
    "Kolor powinien być w formacie #XXXXXX (np. #f07d00)": "The color should be in the format #XXXXXX (e.g. #f07d00)",
    "Nie udało się pobrać listy kanałów": "Failed to download channel list",
    "Generator plików PDF:": "PDF Generator:",
    "Raporty z rozliczeń": "Billing reports",
    "Nie zdefiniowano żadnych ról.": "No roles are defined.",
    "Nie udało się wczytać podglądu strony.": "Failed to load the website preview.",
    "Nazwa testu": "Test name",
    "Typ pomieszczenia jest wymagany": "",
    "Zmień rozmiar": "Resize",
    "Komunikat mailowy": "E-mail message",
    "Notatka do zadania": "Task note",
    "Numer pinezki": "Pin number",
    "Dodanie regionu": "Add a region",
    "Checklisty": "Checklists",
    "Dostęp zabroniony": "Access denied",
    "NIP": "NIP",
    "Adres email": "Email address",
    "Materiał wideo": "Video",
    "Komunikat": "Message",
    "Wprowadzona wartość jest za niska": "The value you entered is too low",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "Number of days from which the user will receive a notification",
    "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Enable at least one language version for your site to start managing your pages.",
    "Stawka za apartamenty została zaktualizowana.": "The property pay rate has been updated.",
    "Pokaż numery stron": "Show page numbers",
    "Tytuł witryny": "Site title",
    "Organizuj": "Organize",
    "Zobacz wszystkie": "See all",
    "Sekcje dla zalogowanych": "Sections for logged in",
    "Kobieta": "Woman",
    "Przywróć": "Restore",
    "Dane wydziałów": "Departments data",
    "Typ strony": "Page type",
    "Dostępne bloki": "Available blocks",
    "Wpis domyślny": "Default entry",
    "Witryna została usunięta.": "The site has been removed.",
    "Urlop został dodany.": "Absence has been added.",
    "Zmień nazwę pliku": "Rename a file",
    "Lewy panel": "Left panel",
    "Data przejścia": "Date of passage",
    "Nieruchomość niestandardowa": "Custom Property",
    "MasterCode nieruchomości": "MasterCode Real Estate",
    "Kreator trasy: ": "Route creator: ",
    "Tytuł kafelka": "Tile title",
    "Dodaj slajd": "Add slide",
    "Wczytaj zapisany filtr": "Load saved filter",
    "Wybrana data jest mniejsza niż dozwolona %0.": "Selected date is before the permitted one %0.",
    "Pokaż nieaktywnych właścicieli": "Show inactive owners",
    "Litery i cyfry": "Letters and digits",
    "Klucze": "Keys",
    "Lista urządzeń na których jesteś zalogowany": "List of devices on which you are logged in",
    "Edycja": "Edit",
    "Statystyki": "Statistics",
    "Odrzuć": "Reject",
    "Formularz został zaktualizowany.": "The form has been updated.",
    "Lista": "List",
    "Usuń materiał z lekcji": "Remove material from the lesson",
    "Nazwa przycisku": "Button name",
    "Lista artykułów": "List of articles",
    "Szukaj": "Search",
    "Logo firmy": "Company logo",
    "Pliki": "",
    "Filtruj": "Filter",
    "Data wystąpienia": "Occurrence date",
    "${PriorityName(PriorityEnum[this.task.priority])}": "${PriorityName(PriorityEnum[this.task.priority])}",
    "Lekcja SCORM została dodana.": "The SCORM lesson has been added.",
    "Opublikowane języki": "Published languages",
    "Do poziomu": "To level",
    "Wymagany": "Required",
    "Udało się usunąć zadania!": "Successfully deleted tasks!",
    "Co rok": "Every year",
    "Nieopublikowany": "Unpublished",
    "Data wygaśnięcia": "Expiration date",
    "Role użytkownika": "User roles",
    "Imie i nazwisko": "Name and surname",
    "Status": "Status",
    "Oznacz wszystkie jako przeczytane": "Mark all as read",
    "Wartości statusów": "Status values",
    "Wznów zadanie": "Resume task",
    "Przeglądanie logów aktywności": "View activity logs",
    "Walidacja": "Validation",
    "Trasa została rozpoczęta": "The route has started",
    "Lista linków": "Links list",
    "Zdecydowanie ważne": "Definitely important",
    "Dodawanie wyposażenia": "Adding amenities",
    "Co 10 minut": "Every 10 minutes",
    "Witryna internetowa": "Website",
    "Powiązane artykuły": "Related articles",
    "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "No assigned users to the training.",
    "Zmodyfikowano": "Modified",
    "Odśwież": "Refresh",
    "Wymeldowanie": "Check-out",
    "Wybierz pliki": "Select files",
    "Użytkownicy": "Users",
    "Typ wynagrodzenia": "Salary type",
    "Dzielenie": "Division",
    "Co 2 minuty": "Every 2 minutes",
    "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "List of available variables that can be used in all text fields:",
    "Link do rezerwacji": "Link to booking",
    "Odejmij kwotę": "Subtract amount",
    "Koszt został dodany.": "The cost has been added.",
    "Dopasuj do kategorii": "Match to category",
    "Nazwa nieruchmości": "Property name",
    "Peticion informacion": "Peticion informacion",
    "Konfiguracja bloku została zapisana.": "The block configuration has been saved.",
    "Witryna tylko dla zalogowanych użytkowników": "Site for logged-in users only",
    "Uzupełnij luki": "Fill in the gaps",
    "Zapis został usunięty": "The record has been deleted",
    "Stawki nieruchomości": "Real Estate Rates",
    "Brak elementów podsumowania": "No summary items",
    "Wynagrodzenie podstawowe": "Basic salary",
    "Wpis nieprzeczytany": "Unread post",
    "Linia": "Line",
    "Pobierz": "",
    "Usuń publikację": "Delete a publication",
    "Zaopatrzenie zostało zaktualizowane.": "The supply has been updated.",
    "Ważne informacje": "Important information",
    "Edycja regionu": "Edit a region",
    "12 godzin": "12 hours",
    "Stan licznika końcowego nie może być mniejszy bądź równy w porównaniu do licznika początkującego": "The state of the final counter must not be less than or equal to the initial counter",
    "Załaduj": "Load",
    "Zastępstwo wygaśnie za 5 minut.": "The substitution will expire in 5 minutes.",
    "Zdecydowanie tak": "Definitely yes",
    "Kwota opłacona do": "Amount paid up to",
    "Ten czat nie posiada przypisanych konkretnych użytkowników.": "This chat does not have specific users assigned to it.",
    "Przywróć użytkownika": "Restore user",
    "Zadowolony": "Satisfied",
    "Wybierz dzielnice": "Select districts",
    "Tagi:": "Tags:",
    "Imię i nazwisko właściciela": "Owner's name and surname",
    "Rozpocznij zadanie": "Start a task",
    "Brak sekcji - najpierw utwórz sekcję": "",
    "Nieruchomość jest już przypisana": "Property is already assigned",
    "Marka": "Brand",
    "Edycja ankiety": "Edit survey",
    "Zapauzuj zadanie": "Pause task",
    "Podgląd szablonu e-maila": "Email template preview",
    "zacznij pisać aby wyszukać paczkę SCORM...": "start typing to search for a SCORM package...",
    "Nazwa serwera": "Server name",
    "Google Nexus 10": "Google Nexus 10",
    "Kwota brakująca": "Amount missing",
    "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "The possibility of modifying this department is limited. Inactive fields are synchronized with the external database %0.",
    "Powiązane": "Related",
    "Czas realizacji": "Delivery time",
    "Brak nowych powiadomień.": "No new notifications.",
    "Wymuś zmianę hasła": "Force password change",
    "Data przejścia na nowe API": "Date of transition to the new API",
    "Zmodyfikowane przez": "Modified by",
    "Kwota zniszczeń": "Amount of damage",
    "Wersje aranżacji": "Arrangement versions",
    "Ustawienia podstawowe": "Basic settings",
    "Id nieruchomości": "Property Id",
    "Wybrana data jest większa niż dozwolona %0.": "Selected date is above the permitted one %0.",
    "Status dokumentu został zmieniony.": "The status of the document has been changed.",
    "Wpis został usunięty.": "The post has been deleted.",
    "Edytuj datę opuszczenia zespołu": "Edit team leave date",
    "Częstotliwość odświeżania": "Refresh rate",
    "Podgląd": "Preview",
    "Ustawienia witryny": "Site settings",
    "Ustawienia strony": "Page settings",
    "Liczba nocy": "Number of nights",
    "Program został zaktualizowany.": "The program has been updated.",
    "Edycja artykułu": "Edit article",
    "Data automatycznej akceptacji": "Auto acceptance date",
    "Dodanie firmy": "Add a company",
    "Prawy panel": "Right panel",
    "Wynagrodzenie za sprzątanie": "Remuneration for cleaning",
    "Link do raportu": "Link to the report",
    "Wynagrodzenie za inspecję": "Salary for inspection",
    "Opis sekcji": "Section description",
    "Edycja ustawień": "Edit settings",
    "Port": "Port",
    "Nowa umowa": "New contract",
    "Użytkownik": "User",
    "Tagi nieruchomości": "Property tags",
    "Dodaj typ wynagrodzenia": "Add salary type",
    "Data": "Date",
    "Pokaż na mapie": "Show on map",
    "Dodatkowy komentarz do wynagrodzenia": "Additional comment on salary",
    "Opublikowane na wybranej stronie": "Published on the selected page",
    "Rozpoczęcie": "Start ",
    "Opracowane, zapisz": "Edited, save",
    "Nie udało się pobrać użytkowników": "Failed to download users",
    "Edycja firmy": "Edit company",
    "Nazwa ścieżki": "Path name",
    "Dodaj zasób": "Add resource",
    "Lista zespołów": "Teams list",
    "Warunki logiczne": "Logical conditions",
    "Pierwsza strona": "First page",
    "Usunięte": "Deleted",
    "Zespół został przypisany do szkolenia.": "The team was assigned to the training.",
    "Wyczyść aranżację": "Clear arrangement",
    "Słowa oddzielone przecinkami.": "Words separated by commas.",
    "Default mode": "Default mode",
    "Wybranie strony jest wymagane": "Selecting a page is required",
    "Powiadomienie dla administratora chatu o nowych wiadomościach": "Notification to the chat administrator about new messages",
    "Liczba pracowników zatrudnionych tylko w tym mieście": "The number of employees employed only in this city",
    "Cancelled": "Cancelled",
    "Zdjęcia": "Photos",
    "Uruchom zadanie": "Run the task",
    "Data dodania": "Adding date",
    "Zarchiwizowany": "Archived",
    "Wiadomość testowa została wysłana.": "A test message has been sent.",
    "Numer nieruchomości Avantio": "Avantio Property ID",
    "Inwentaryzacja": "Inventory",
    "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "The selected character will replace the separator marker | inserted in the title.",
    "Kraj": "Country",
    "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "Do not show the page as an image source in search results (NoImageIndex)",
    "Informacja o ciasteczkach": "Information about cookies",
    "Wybierz koordynatora": "Choose a coordinator",
    "Plik": "File",
    "Nieruchomość robocza": "Working property",
    "Kopiuj": "Copy",
    "Pokój dzienny": "",
    "Link do wybranej strony serwisu": "Link to the selected page of the website",
    "Robocizna": "Labor",
    "Nie do odzyskania": "Unrecoverable",
    "Tekst alternatywny": "Alternative text",
    "Koordynator Konserwacji": "Maintenance Coordinator",
    "usuń notatkę": "delete note",
    "Domyślny": "Default",
    "Odstęp": "Space",
    "Nazwa dzielnicy": "Name of the district",
    "Wyszukiwana fraza:": "Search phrase:",
    "zacznij pisać aby wyszukać kategorię...": "start typing to search for a category...",
    "Usuń blok z sekcji": "Remove a block from a section",
    "Ranga": "Rank",
    "Czyim kosztem jest dodany przedmiot?": "At whose expense is the item added?",
    "Czas": "Time",
    "Odrzucone": "Rejected",
    "Cofam": "Recollection",
    "Subskrypcja": "Subscription",
    "Ilość znaków": "Number of characters",
    "Excel został wygenerowany i wysłany na adres e-mail": "",
    "Aranżacje": "Arrangements",
    "Informacje Podstawowe": "Basic information",
    "Zobacz szczegóły sesji użytkownika": "View user session details",
    "Sobota": "Saturday",
    "3 godziny": "3 hours",
    "Rozliczenia pracowników": "Employee settlements",
    "Ustawienia powiadomień zostały zaktualizowane.": "Your notification settings have been updated.",
    "Adres url do pliku wideo": "Url to video file",
    "Dark mode": "Dark mode",
    "Ten Miesiąc": "This month",
    "Mapa": "Map",
    "Ilość łóżek dwuosobowe": "Number of double beds",
    "Brak tagów": "No tags",
    "Dane gościa": "Guest details",
    "Identyfikator zadania": "Task ID",
    "Dodaj do trasy": "Add to route",
    "Apple iPhone 5": "Apple iPhone 5",
    "Program": "Program",
    "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Add a new website to start managing your pages.",
    "Certyfikaty": "Certificates",
    "Data zakończenia": "End date",
    "Trasy można wykonywać w aplikacji Hi!Renters Mobile": "Routes can be done in the Hi! Mobile Renters",
    "Potwierdź akceptację": "Confirm acceptance",
    "Czy na pewno chcesz zkopiować szkolenie?": "Are you sure you want to copy the training?",
    "Login": "Login",
    "Niepotwierdzeni": "Unconfirmed",
    "Zakończone: ${$filters.datetime(route.dateCompletedUtc)}": "Completed: ${$filters.datetime(route.dateCompletedUtc)}",
    "Chat": "Chat",
    "Raczej się zgadzam": "I rather agree",
    "Pole nie może być puste": "",
    "1 godzina": "1 hour",
    "Wydział zadania": "Task department",
    "Wysokość": "Height",
    "ISBN": "ISBN",
    "Tło certyfikatu": "Certificate background",
    "Osoba zastępowana": "Person being substituted",
    "do czasu ręcznego odblokowania": "until manually unlocked",
    "Ikona": "Icon",
    "Co 30 minut": "Every 30 minutes",
    "Zobacz zdjęcia": "See photos",
    "Wynagrodzenie": "Salary",
    "Wyrażenie regularne": "Regular expression",
    "Osiągnąłeś limit zdjęć. Nie możesz dodać więcej zdjęć": "You have reached your photo limit. You can't add more photos",
    "Link przycisku": "Button link",
    "Czy na pewno chcesz usunąć ten kolor?": "Are you sure you want to remove this color?",
    "Nie wybrano paczki.": "No package has been selected.",
    "Proszę obciążyć gościa": "Please charge the guest",
    "Data publikacji": "Publication date",
    "Blokowanie użytkowników": "Block users",
    "Dodawanie checklisty": "Add a checklist",
    "Dodaj pytanie": "Add a question",
    "Zmodyfikował": "Modified by",
    "Numer telefonu": "Phone number",
    "Dział nadrzędny": "Parent department",
    "Wybierz tagi": "Select tags",
    "Kolejne pozycje z lewej strony": "Next items on the left",
    "Wykonaj": "Execute",
    "Wyloguj się": "Log out",
    "Powiązane zadanie": "",
    "Poniedziałek": "Monday",
    "Nie mam zdania": "I have no opinion",
    "Lista rezerwacji": "Booking list",
    "Ładuje...": "Loading...",
    "Jesteś pewien?": "Are you sure?",
    "Teraz": "Now",
    "Strona została zaktualizowana.": "The page has been updated.",
    "Synchronizuj": "Sync",
    "Numer mieszkania (Number)": "Apartment number",
    "Usunięto użytkownika z czatu": "Removed user from chat",
    "Nazwa elementu": "Item name",
    "Anuluj edycję": "Undo",
    "Wróć na dół": "Back to bottom",
    "Pokaż przycisk": "Show button",
    "Nazwa obiektu": "Object name",
    "Uwzględniaj zadania z miesiąca": "Include the month's tasks",
    "Nazwa zespołu": "Team name",
    "Wideo z biblioteki": "Video from library",
    "Data logowania": "Login date",
    "Archiwum": "Archive",
    "Zastępstwo wygasło.": "The substitution has expired.",
    "Typ Firmy": "Company Type",
    "Data przyjazdu": "Arrival date",
    "ID użytkownika": "User ID",
    "Log błędu": "Error log",
    "Książka": "Book",
    "Typ serwera": "Server type",
    "Maksimum": "Maximum",
    "Wybrany region": "Selected region",
    "Pobrane z magazynu Renters": "Retrieved from Renters storage",
    "Sekcja nie została znaleziona": "",
    "Nazwa zadania": "Task name",
    "ID zadania": "Task ID",
    "Nikomu nie przydzielono uprawnień": "No one has been granted permissions",
    "Kwota wynagrodzenia PLN brutto": "Gross salary amount in PLN",
    "Rola aktywna": "Active role",
    "Usuń z zespołu": "Remove from team",
    "Utworzone": "Created",
    "Nie udało się pobrać powiadomień.": "Failed to download notifications.",
    "Utwórz raport wyników": "Create a results report",
    "Get it on Appstore": "Get it on Appstore",
    "Nazwa koordynatora": "Coordinator name",
    "Aplikacja nie ma uprawnień do wysyłania powiadomień PUSH": "App has no permission to send PUSH notification",
    "Opis kategorii": "Category description",
    "Nazwa autora": "Author name",
    "Certyfikat został dodany.": "The certificate has been added.",
    "Tłumaczenia": "Translations",
    "Liczba": "Number",
    "Checkbox": "Checkbox",
    "Treść notatki": "Contents of the note",
    "Miasto zostało usunięte": "The city has been removed",
    "+": "+",
    "Statystyki użytkowników": "User statistics",
    "Ustawienia wynagrodzenia zostały zaktualizowane.": "Salary settings have been updated.",
    "Posiadasz niezapisane materiały": "You have unsaved materials",
    "Nadpisz kwotę": "Overwrite the amount",
    "Sortowanie rosnąco": "Sort ascending",
    "Rejestr zmian": "Changelog",
    "Urządzenie zostało usunięte.": "The device has been removed.",
    "Notatka została dodana.": "The note has been added.",
    "Prawda-Fałsz": "True-False",
    "Dodanie użytkownika": "Add user",
    "Edytuj": "Edit",
    "Usuń filtr": "Remove filter",
    "Dodaj formularz": "Add form",
    "Zapytanie SQL": "SQL Query",
    "Akceptacja": "Acceptance",
    "Podana wartość jest nieprawidłowa.": "The provided value is not valid.",
    "Edycja nieruchomości": "Edit a property",
    "Niezadowolony": "Unsatisfied",
    "Utwórz zlecenie": "Create an order",
    "Liczba całkowita": "Integer",
    "Czas wykonania": "Completion time",
    "Imie i nazwisko: ": "First and last name: ",
    "Średnie wynagrodzenie koordynatora": "Average coordinator salary",
    "Kwota jednostkowa": "Pay per unit",
    "Wyszukaj...": "Search...",
    "Edycja zestawu regulaminóe": "Edit set of regulations",
    "Informacje dodatkowe": "Additional information",
    "Średnie wynagrodzenie pracowników": "Average salary of employees",
    "Tytuł sekcji": "Section title",
    "Blokowanie użytkowników szkoleń": "Block training users",
    "Warunkowo": "Conditionally",
    "Blok aktywny": "Active block",
    "Aktualizuj": "Update",
    "Wybierz autora z listy": "Select an author from the list",
    "Kolor obramowania": "Border color",
    "Urlop": "Paid leave",
    "Stwórz czat": "Create chat",
    "Rola została dodana.": "The role has been added.",
    "Lista zgłoszeń w tym apartamancie": "List of requests in this apartment",
    "Brak": "None",
    "Szczegóły zmiany": "Details of the change",
    "Ta nieruchomość nie posiada informacji na temat wyposażenia.": "This property has no information on amenity.",
    "Edytuj kategorie": "Edit category",
    "Osoby przypisane jako domyślne do zadań zwiazanych ze sprzątaniem": "People assigned as default to cleaning-related tasks",
    "Jest problem": "There is a problem",
    "Adres domenowy": "Domain address",
    "i posiadających wymagane uprawnienia": "and having the required permissions",
    "Wartość": "Value",
    "Dodaj stwierdzenie": "Add statement",
    "Tag został dodany.": "Tag has been added.",
    "co 30 dni": "every 30 days",
    "Sekcja jest wymagana": "",
    "Przenieś wyżej": "Move higher",
    "Komentarz zadania nie może być dłuższy niż 500 znaków.": "The task comment cannot be longer than 500 characters.",
    "Szkolenie jest opublikowane": "The training is published",
    "Rozpocznij synchronizację": "Start syncing",
    "Dane wydziału zostały usunięte.": "The department's data has been deleted.",
    "Zadanie zostało uruchomione.": "The task has started.",
    "Dodano zdjęć": "Added photos",
    "Kategorie szkoleń": "Training categories",
    "Pole \"Nazwisko\" jest wymagane.": "''Surname'' is required.",
    "Zabierz dostęp": "Take away access",
    "Kategorie": "Categories",
    "Typ obciążenia": "Cost type",
    "Dokument nie jest jeszcze nigdzie opublikowany.": "The document has yet not been published anywhere.",
    "Rozpocznij trasę": "Start your route",
    "Wybrano pliki różnych typów. Wybierz pliki tego samego typu.": "",
    "Nazwa tytułu nie może być dłuższa niż 240 znaków ani krótsza niż 3 znaki.": "The title cannot contain neither more than 240 characters nor less than 3 characters.",
    "Magazynier": "Warehouseman",
    "Wielkość kroku": "Step size",
    "Dodaj etykietę": "Add tag",
    "Firma sprzątająca": "Cleaning company",
    "Jeszcze nie ma kategorii.": "There are no categories yet.",
    "Aranżacja została zachowana.": "The arrangement has been saved.",
    "Edycja dzielnicy": "District Edit",
    "Język domyślny": "Default language",
    "Ogólne": "General",
    "Koszty do zadania": "Costs in the task",
    "Dodanie ścieżki szkoleniowej": "Add learning path",
    "Zaplanowane": "Scheduled",
    "Wyczyść": "Clear",
    "Nazwa przycisku ``Dalej``": "Button name ''Next''",
    "Szkolenie jest puste": "Training is empty",
    "Symbol strony": "Page symbol",
    "Zacznij pisać aby wyszukać kierowcę...": "Start typing to search for a driver...",
    "Ilość wyników do pobrania": "Number of results to download",
    "Tylko priorytetowe": "Priority only",
    "Nie udało się wysłać pliku": "Failed to send file",
    "Dodaj zdjęcia": "Add photos",
    "Czas trwania:": "Duration:",
    "Koordynator": "Coordinator",
    "Edycja źródła danych": "Edit data source",
    "Dane rezerwacji": "Booking details",
    "Wersja opublikowana": "Published version",
    "Użytkownik jest liderem zespołu": "The user is a team leader",
    "Utworzone przez:": "Created by:",
    "Użytkownik został usunięty.": "User has been deleted.",
    "Deadline - Data wykonania": "Deadline - Date of execution",
    "L4": "L4",
    "Opis": "Description",
    "Nie ma ustalonej roli dla tego wydziału": "There is no fixed role for this department",
    "Ukryj materiał": "Hide material",
    "Pokaż tytuły stron": "Show page titles",
    "Moje filtry": "My filters",
    "Moje czaty": "My chats",
    "Zapamiętaj logowanie": "Remember login",
    "Data zdarzenia": "Event date",
    "Wartość musi być liczbą ujemną": "The value must be a negative number",
    "Filtr prywatny": "Private filter",
    "Zakończ trasę": "End the route",
    "Dodaj wszystkich dopasowanych użytkowników": "Add all matched users",
    "Stawka nieruchomości": "Property rate",
    "Publikacja została dodana.": "The publication has been added.",
    "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "You won't be able to add terms to the dictionary until you save the data source.",
    "Godzina zameldowania": "Check-in time",
    "Zakres czasu": "Time range",
    "Nazwa katalogu została zmieniona.": "The directory has been renamed.",
    "Najnowsze": "Recent",
    "Certyfikat nie jest opublikowany": "Certificate is not published",
    "Tekst do uzupełnienia": "Text to be completed",
    "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you have to save the form first.",
    "Statusy użytkowników": "User statuses",
    "Nr telefonu": "Phone number",
    "Dodaj nowy koszt": "Add new cost",
    "Zmodyfikowane przez użytkownika": "Modified by the user",
    "Liczba zgłoszonych problemów": "Number of issues reported",
    "Domyślny kolor trasy (dotyczy kierowców)": "Default route color (applies to drivers)",
    "Peticion disponibilidad": "Peticion disponibilidad",
    "Brak miast": "No cities",
    "Nowa kwota": "New amount",
    "Łączenie treści": "Combining content",
    "Data wykonania": "Execution date",
    "Ten użytkownik nie posiada jeszcze przypisanych dzielnic.": "This user does not yet have assigned districts.",
    "Niewidoczne": "Not visible",
    "Zadania do wykonania": "To-do tasks",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "",
    "Zapauzowane": "Abandoned",
    "Pole może zawierać jedynie cyfry.": "Field can only contain digits.",
    "kanał wymagany": "required channel",
    "Usuń regulamin": "Delete regulations",
    "Podstawowe operacje tekstowe": "Basic text operations",
    "Nierozwiązane": "Unresolved",
    "Brak plików w sekcji": "",
    "Brak aktywnego filtru": "No active filter",
    "Element został dodany.": "The element has been added.",
    "Dashboard": "Dashboard",
    "Odznacz wszystko": "Uncheck all",
    "Nazwa przycisku ``Wstecz``": "Button name ''Back''",
    "z": "",
    "Podstawowe": "Basic",
    "Edycja wielu elementów": "Editing multiple items",
    "Przesyłam...": "I'm sending...",
    "Liczba wyświetlanych elementów": "Number of elements displayed",
    "Edycja aranżacji": "Edit arrangement",
    "Formularz": "Form",
    "Łączny czas wykonywania zadań": "Total task completion time",
    "Przypisz do zadania": "Assign to task",
    "Google Nexus 7": "Google Nexus 7",
    "Serwer dostępny": "Server available",
    "Wybierz artykuł": "Select an article",
    "Archiwizuj": "Archive",
    "BIC/Swift": "BIC/Swift",
    "Koszty zadania zostały zaktualizowane.": "The cost of the task has been updated.",
    "Wybrano:": "Selected:",
    "Dodanie właściciela": "Add an owner",
    "Przejdź do zlecenia z notatki": "Go to the order from the note",
    "Dodaj do zestawu": "Add to set",
    "Data zakończenia do": "End date to",
    "Twój token": "Your token",
    "Publiczne": "Public",
    "Edycja wynagrodzenia mieszanego dla:": "Edit mixed salary for:",
    "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "To add a team to the learning path, you have to save the form.",
    "Przeciągnij i upuść aby posortować pliki": "Drag and drop to sort files",
    "Edycja szablonu": "Edit template",
    "Słownik": "Dictionary",
    "Wybierz wydział": "Select Faculty",
    "To szkolenie znajduje się już w ścieżce szkoleń": "This training is already in the training path",
    "Trasa została zapisana.": "The route has been saved.",
    "Początkowy stan licznika": "The initial state of the counter",
    "Nie można jednocześnie wybrać tagów i zaznaczyć opcji 'Usuń wszystkie tagi'": "",
    "To zadanie dotyczy nieruchomości, która znajduje się na trasie. Czy chcesz przejść do mapy, aby edytować punkt?": "",
    "Rodzaj adresu kanonicznego": "Type of canonical address",
    "Nie udało się pobrać listy powiadomień": "Failed to download notification list",
    "Usuń odpowiedź": "Delete answer",
    "Powiązane zadania": "Related tasks",
    "Nie": "No",
    "Zaznacz wszystkie": "Select all",
    "Obsługa Klienta (BOK)": "Customer Service (BOK)",
    "Tak": "Yes",
    "Rozwiązane": "Resolved",
    "Kolor został dodany": "Color has been added",
    "Wybrana liczba jest mniejsza niż dozwolona %0.": "Selected number is lesser than allowed %0.",
    "Dodaj wiersz": "Add row",
    "Dowolny": "Any",
    "Pokaż nieaktywne nieruchomości": "Show inactive properties",
    "Dodano użytkownika do czatu": "Added a user to the chat",
    "Ta dzielnica jest już przypisana do użytkownika.": "This district is already assigned to the user.",
    "Zasoby": "Resources",
    "Utworzone przez": "Created by",
    "Adres kanoniczny": "Canonical address",
    "Dodaj dni": "Add days",
    "Zamknięte przez użytkownika o Id": "Closed by user about Id",
    "Usuń wiersz": "Delete row",
    "Wielokrotnego wyboru": "Multiple choice",
    "Dodanie slajdów": "Add slides",
    "Poprzednia strona": "Previous page",
    "Pomieszczenie": "Room",
    "Dostęp": "Access",
    "Rola została zaktualizowana.": "The role has been updated.",
    "Materiały": "",
    "Widok tygodniowy": "Week view",
    "Dodanie strony": "Add page",
    "Definicja szablonu": "Template definition",
    "Stan powiadomienia": "Notification status",
    "Uwzględniaj miasta": "Include cities",
    "Nieruchomości": "Properties",
    "Bank": "Bank",
    "Usuń pytanie": "Delete question",
    "Moje trasy": "My routes",
    "Plik wideo": "Video file",
    "Edytowana wersja": "Edited version",
    "Edycja testu": "Edit test",
    "Dalej": "Next",
    "Zespół": "Team",
    "Przyczyna": "Reason",
    "...nie znalazłeś bloku?": "... have you not found the block?",
    "Definicja formularza znajduje się w obiekcie Form.": "The form definition is in the Form object.",
    "Liczba dużych prześcieradeł": "Number of large sheets",
    "Domyślna checklista": "Default checklist",
    "Dodaj Koszt do zadania": "Add Cost to Task",
    "Użytkownik został zaktualizowany.": "The user has been updated.",
    "Wstaw szablon informacyjny ze zdjęciem": "Insert information template with photo",
    "Szkic": "Draft",
    "Data końcowa nie może być wcześniejsza niż data początkowa": "End date cannot be earlier than start date",
    "Wrzesień": "September",
    "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "Section configuration is not available because no template definition is provided.",
    "Utwórz katalog": "Create a directory",
    "Wszystkie typy": "All types",
    "Zobacz przed opublikowaniem": "View before publishing",
    "Raport został wysłany na adres e-mail": "The report has been sent to the email",
    "Wybranie katalogu jest wymagane": "Selecting a directory is required",
    "Nie udało się pobrać listy modułów": "Failed to download module list",
    "Trasa została wznowiona": "The route has resumed",
    "Zapisz wersję": "Save version",
    "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "To add a team to the training, you have to save the form.",
    "Zacznij pisać numer aby wyszukać źródło rezerwacji...": "Start typing the number to search for a booking source...",
    "Slajder został usunięty.": "The slider has been removed.",
    "Satysfakcja": "Satisfaction",
    "Formularz kontaktowy": "Contact form",
    "Utwórz nowy": "Create new",
    "Dodaj slajder": "Add slider",
    "Separator elementów w tytule": "Element separator in title",
    "Wyloguj": "Logout",
    "Przypisane miasta:": "Assigned cities:",
    "Notatka magazyniera": "Storekeeper's note",
    "Wyszukaj blok": "Search blocks",
    "Usunięcie": "Deletion",
    "Nie udało się usunąć użytkownika z czatu": "Failed to remove user from chat",
    "Statystyki regionalne - miasta": "Regional statistics - cities",
    "Nazwa konta (Klucz dostępu)": "Account Name (Access Key)",
    "Aktywność": "Activity",
    "Nazwa szkolenia": "Training name",
    "Ustawienia sekcji \"%0\"": "Settings of the \"%0\" section",
    "Id rezerwacji:": "Booking ID:",
    "Losowa kolejność elementów": "Random order of elements",
    "Edycja Notatki": "Edit a note",
    "Wstaw z góry": "Insert from above",
    "Standard 2004": "Standard 2004",
    "Mieszane": "Mixed",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "",
    "Dodaj serwer": "Add server",
    "Listopad": "November",
    "obrót": "spin",
    "Dodaj ścieżkę": "Add path",
    "Wybierz kategorię": "Select a category",
    "Nazwa paczki": "Package name",
    "Aktualne urządzenie": "Current device",
    "Priorytet": "Priority",
    "Edytuj zestaw": "Edit set",
    "Ustawienia zaawansowane": "Advanced settings",
    "Średnie wynagrodzenie pracownika": "The average salary of an employee",
    "Jedna kolumna": "One column",
    "Adres aktywnej strony": "Address of the active page",
    "Noclegi": "Accomodations",
    "Przypisane regiony:": "Assigned regions:",
    "Edytuj dział": "Edit department",
    "Rozmiar zdjęcia został zmieniony.": "The image has been resized.",
    "Pole może zawierać jedynie litery i cyfry.": "This field can contain only letters and digits.",
    "Planowana data wykonania": "Planned execution date",
    "Edycja tagu nieruchomości": "Edit property tag",
    "Otwórz stronę w nowym oknie": "Open the page in a new window",
    "Dodano": "Added",
    "Data dodania inwentaryzacji": "Date the inventory was added",
    "Edycja roli": "Edit role",
    "Dołączanie...": "Joining...",
    "Czy zablokować użytkownika i jego wiadomość?": "Do you want to block the user and messages?",
    "Typ plików jest wymagany": "",
    "Ogólne informacje": "General information",
    "Szerokość": "Width",
    "URL": "URL",
    "Edytuj stawkę za godzinę": "Edit hourly rate",
    "Lista regulaminów": "Regulation list",
    "Imię gościa": "Guest name",
    "Przenieś wybrane": "Move selected",
    "Lista ścieżek szkoleniowych": "Learning path list",
    "Oraz nowe hasło": "And a new password",
    "Dodaj tag nieruchomości": "Add a property tag",
    "Zestaw został zaktualizowany.": "The set has been updated.",
    "Serwer został usunięty.": "Server has been removed.",
    "wybierz szablon": "select a template",
    "Porównaj %0": "Compare %0",
    "Nie wybrano strony": "No page has been selected",
    "Status edytowanej wersji dokumentu": "Status of the edited version of the document",
    "Edycja strony": "Edit page",
    "Jestem w pracy": "I'm at work",
    "W pracy": "At work",
    "Poza pracą": "Off work",
    "Status pracy": "Work status",
    "Przejdź do zadania": "Go to the task",
    "Jesteś w pracy. Kliknij, aby ustawić status Poza pracą": "You are at work. Click to set status to Off work",
    "Jesteś poza pracą. Kliknij, aby ustawić status W pracy": "You are off work. Click to set status to At work",
    "Zaloguj się loginem i hasłem": "Log in with username and password",
    "Zakończyć pracę?": "End work?",
    "Masz rozpoczęte zadanie:": "You have a task in progress:",
    "Po wyłączeniu statusu nie będziesz mógł rozpoczynać zadań.": "After turning the status off you will not be able to start tasks.",
    "Zakończ pracę": "End work",
    "Aby rozpocząć zadanie, musisz mieć włączony status \"W pracy\".": "To start the task you must have the \"At work\" status turned on.",
    "Status zostanie włączony automatycznie, a zadanie rozpocznie się od razu.": "The status will be turned on automatically and the task will start right away.",
    "Włącz i rozpocznij zadanie": "Turn on and start the task",
    "Zadanie pozostanie rozpoczęte. Pamiętaj, aby je zakończyć lub zapauzować.": "The task will stay in progress. Remember to finish or pause it.",
    "Nie jesteś w pracy": "You are not at work",
    "Dopasuj do obrazka": "Match image",
    "Punkty": "Points",
    "Zmień hasło": "Change password",
    "Nie udało się pobrać listy aranżacji": "Failed to download the arrangement list",
    "wybierz": "select",
    "Opiekun ścieżki": "Path supervisor",
    "Powtórz hasło": "Repeat password",
    "Czwartek": "Thursday",
    "Nowe hasło": "New password",
    "Dodawanie trasy": "Add a route",
    "Dodaj trasę": "Add a route",
    "Strona główna": "Homepage",
    "VAT": "",
    "Pokaż etykietę": "Show tag",
    "Data modyfikacji od": "Modified date from",
    "Wyrażenia warunkowe": "Conditional expressions",
    "Potwierdź zapis do aktualnej wersji": "Confirm saving to the current version",
    "Dział został dodany.": "The department has been added.",
    "Opracowane": "Edited",
    "Wysłane wezwanie do zapłaty": "Payment request sent",
    "Podpis": "Signature",
    "Data początkowa nie może być późniejsza niż data końcowa": "Start date cannot be later than end date",
    "Nieruchomość niestandardowa o Id": "Custom Property with Id",
    "Dodaj zastępstwo": "Add a substitution",
    "Zastępstwo zostało dodane.": "The substitution has been added.",
    "Planowanie inwentaryzacji": "Inventory planning",
    "Kategoria wyszukiwanego matariału": "Category of the searched material",
    "Powiadomienia": "Notifications",
    "Edycja wynagrodzenia stałego dla:": "Edit fixed salary for:",
    "Data ostatniej zmiany statusu": "Date of last status change",
    "Aby zakończyć trasę należy uzupełnić stan licznika na koniec": "To complete the route you must complete the meter status at the end",
    "Osoby przypisane jako domyślne do zadań zwiazanych z konserwacją": "People assigned as default to maintenance tasks",
    "Pliki zostały dodane": "",
    "Ustawienia ogólne": "General settings",
    "Okładka": "Cover",
    "Konserwacja": "Maintenance",
    "Publikuj od": "Publish from",
    "Do sprawdzenia": "To be checked",
    "Pliki prywatne": "Private files",
    "Dodanie linku": "Add link",
    "Czas trwania blokady": "Account blocking time",
    "Stwórz nowy czat": "Create new chat",
    "Nieopłacone/dłużnik": "Unpaid/debtor",
    "Wyświetl materiały": "View materials",
    "Chat został zarchiwizowany.": "The chat has been archived.",
    "Reżyseria": "Direction",
    "Zablokowano możliwość edycji": "Blocked the ability to edit",
    "IBAN": "IBAN / Acc number",
    "Nie udało się pobrać listy typów modeli": "Failed to download the list of model types",
    "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "The possibility to modify this account is limited. Inactive fields are synchronized with the external database %0.",
    "Nazwa pliku": "File name",
    "Data zakończenia blokady konta": "Account block end date",
    "Kategoria": "Category",
    "Autor": "Author",
    "Wybierz": "Select",
    "Ilość koordynatorów w regionie": "Number of coordinatiors in the region",
    "Lista paczek SCORM": "SCORM Packages List",
    "Brak modułu": "No module",
    "Ukończone przez użytkownika o Id": "Completed by user o Id",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "A connection error has occurred. Make sure you are online and try again.",
    "Zaloguj się na swoje konto": "Log in to your account",
    "Wideo": "Video",
    "W zespole od": "In the team from",
    "Potwierdzam, zapisz": "I confirm, save",
    "Wróć do logowania": "Back to login",
    "Suma Wynagrodzeń": "Sum of salaries",
    "Grudzień": "December",
    "Najniższy": "Lowest",
    "Kuchnia": "",
    "Usuń element": "Delete item",
    "Facturada": "Facturada",
    "Usunięte przez": "Deleted by",
    "Rodzaj kosztu": "Cost Type",
    "Zastępuje osobę": "Substituting",
    "Inspektor": "Inspector",
    "Filtry powiadomień": "Notification filters",
    "Dodaj stronę": "Add page",
    "Data ostatniej inwentaryzacji": "Date of the last inventory",
    "Co 15 minut": "Every 15 minutes",
    "Dane osobowe": "Personal data",
    "Dopasowanie": "Match",
    "Data odrzucenia": "Rejection date",
    "Formularz zarchiwizowany": "Archived form",
    "Wyzeruj licznik": "Reset counter",
    "Kwota średnia": "Average amount",
    "Nie podano nazwy poprzedniej kategorii.": "No name is given for the previous category.",
    "Dodaj obrazek": "Add image",
    "Wybrany język": "Selected language",
    "Akceptuj": "Accept",
    "Aby rozpocząć trasę należy uzupełnić stan licznika na start": "To start the route it is necessary to complete the status of the start counter",
    "Stan licznika nie może być wartością ujemną": "The counter value cannot be negative",
    "Standard nieznany": "Standard unknown",
    "Data aktualizacji": "Update date",
    "Stwierdzenia": "Statement",
    "Legenda": "Legend",
    "Przejdź do zadania z notatki": "Go to a task from a note",
    "Pokaż tytuł sekcji": "Show section title",
    "Trzy kolumny": "Three columns",
    "Ścieżka nawigacyjna": "Navigation path",
    "Edytuj test": "Edit test",
    "Kontakty - Typ działania": "Contacts - Activity Type",
    "Ten użytkownik nie posiada jeszcze przypisanych miast.": "This user does not have assigned cities yet.",
    "Osoby przypisane jako domyślne do zadań zwiazanych z inspekcją": "People assigned as defaults to audit-related tasks",
    "24 godziny": "24 hours",
    "Inna": "Inna",
    "Szczegóły zdarzenia nr %0": "Details of event number %0",
    "Tytuł strony": "Page title",
    "Dodanie formularza": "Add form",
    "Wyloguj zalogowanego obecnie użytkownika": "Log off the currently logged-in user",
    "Potwierdzenie archiwizacji": "Archiving confirmation",
    "Dodaj pliki": "",
    "źródło zostało usunięte.": "the source has been removed.",
    "Uwzględnij wydziały i statusy jednocześnie": "Include Faculties and Statuses at Once",
    "Włącz system powiadomień": "Enable the notification system",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "Unable to add file(s): \"%0\". You can only add files of type: \"%1\".",
    "Wygeneruj plik": "Generate file",
    "Nie pokazuj linku do archiwum strony (NoArchive)": "Do not show a link to the archive of the page (NoArchive)",
    "Nazwa roli": "Role name",
    "Organizacja": "Organization",
    "${title}": "${title}",
    "Usuń z trasy": "Remove from route",
    "Serwery plików": "File servers",
    "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "The variable %HEAD_TITLE% can be used in other text boxes.",
    "Ten Tydzień": "This week",
    "Element został usunięty.": "The element has been deleted.",
    "Co 2 tygodnie": "Every 2 weeks",
    "Co tydzień": "Every week",
    "Zlecenie": "Order",
    "Właściciel został zaktualizowany.": "The owner has been updated.",
    "Radio": "Radio",
    "Lekcja ukryta": "Hidden lesson",
    "Suma wynagrodzeń": "Sum of salaries",
    "Koordynator*": "Coordinator*",
    "Nie udało się dodać użytkownika do czatu": "Failed to add user to chat",
    "Aktywne": "Active",
    "Nazwa strony": "Page name",
    "Uwzględniaj tagi": "Include tags",
    "Google Nexus 5": "Google Nexus 5",
    "Brakujące tytuły kafelków.": "Missing tile titles.",
    "Kwota pobrana": "Amount collected",
    "Dodaj media": "Add media",
    "Ikona wyświetlana jest w postaci kwadratu.": "The icon is displayed in the form of a square.",
    "Edycja aktualności": "Edit news",
    "Dane został wgrane": "Data has been uploaded",
    "Pokaż cały błąd": "Show whole error",
    "Wybrana liczba jest większa niż dozwolona %0.": "Selected number is greater then allowed %0.",
    "Krótki opis": "Short description",
    "Komentarz dotyczący naprawy problemu": "Comment on fixing the problem",
    "Strony": "Page",
    "Serial telewizyjny": "Television series",
    "Wyszukaj wszędzie": "Search everywhere",
    "Hasło (Klucz ukryty)": "Password (Hidden Key)",
    "Ustawienia chatów": "Chat settings",
    "Filtr został zapisany": "Filter has been saved",
    "Odpowiedź 3": "Answer 3",
    "Edycja serwera": "Edit server",
    "Nie przypisano": "Not assigned",
    "Wykonaj akcję": "Execute the action",
    "Czaty": "Chats",
    "Dodaj katalog": "Add directory",
    "Firma została usunięta.": "The company has been removed.",
    "Data wymeldowania do": "Check-out date to",
    "Konta publiczne": "Public accounts",
    "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No communication channel has been enabled in the notification settings.",
    "Pole \"%0\" jest wymagane.": "Field ''%0'' is required.",
    "Nie udało się pobrać listy stron": "Failed to download the pages list ",
    "Jeśli pole jest puste to wstawiana automatycznie.": "If the field is empty, the value is inserted automatically.",
    "Płyta z muzyką": "Music CD",
    "Tagi zadań": "Task tags",
    "Próg zaliczenia (%)": "Pass marker (%)",
    "Wybierz autora": "Choose an author",
    "Co 10 dni": "Every 10 days",
    "Konfiguracja harmonogramu": "Schedule configuration",
    "Repozytorium plików": "File repository",
    "Usuń kafelek": "Remove tile",
    "Musisz najpierw zapisać zmienioną kolejność punktów zanim oznaczysz punkt": "You must first save the changed order of points before marking a point",
    "Kalendarz pracowników": "",
    "Przypisane tagi: ": "Assigned tags: ",
    "Dodaj Zadanie": "Add a task",
    "Obok siebie": "Next to each other",
    "Potwierdź wyłączenie publikacji": "Confirm that you want to disable publication",
    "Ilość kosztów": "Costs amount",
    "Co 6 godzin": "Every 6 hours",
    "Czat": "Chat",
    "Imię": "First name",
    "Kolory rezerwacji": "Booking Colors",
    "Proszę obciążyć właściciela obiektu": "Please charge the property owner",
    "Usuń trasę": "Delete route",
    "Zacznij pisać aby wyszukać właściciela...": "Start typing to search for an owner...",
    "Slajdy": "Slides",
    "Dzielnica nieruchomości": "Real Estate District",
    "Resetuj": "Reset",
    "Urlop został usunięty": "Absence has been removed",
    "Host dodatkowy": "Secondary host",
    "Komentarz": "Comments",
    "Status notatki": "Note status",
    "Witryna została zaktualizowana.": "The site has been updated.",
    "Imię i nazwisko": "Name and Surname",
    "Zacznij pisać numer aby wyszukać rezerwację...": "Start typing the number to search for a reservation...",
    "Zdecydowanie się zgadzam": "I strongly agree",
    "Element został przywrócony.": "The element has been restored.",
    "Wymagaj kolejności zaliczania elementów": "Require element passing order",
    "co rok": "every year",
    "Zajawka": "Sneak peek",
    "Zestaw niestandardowy": "Custom set",
    "Edycja lekcji": "Editing lesson",
    "Co minutę": "Every minute",
    "Open Graph": "Open Graph",
    "Role i uprawnienia": "Roles and permissions",
    "Coś poszło nie tak": "Something went wrong",
    "Data wymeldowania od": "Check-out date from",
    "Nazwa przycisku ``Wyślij``": "Button name ''Send''",
    "Rezerwacje anulowane": "Reservations cancelled",
    "Dane": "Data",
    "zacznij pisać aby wyszukać certyfikat...": "start typing to search for a certificate...",
    "Wyżej": "Above",
    "Nie udało się pobrać listy zastępstw": "Failed to download the substitution list",
    "Id sesji": "Session Id",
    "Opłacono": "Paid",
    "Przekroczono dozwoloną ilość znaków: %0.": "Allowed number of characters exceeded: %0.",
    "Inwentaryzacja została zaktualizowana.": "The inventory has been updated.",
    "Bułgarski": "Bulgarian",
    "Ok": "Ok",
    "Nazwa certyfikatu": "Certificate name",
    "Edycja właściciela": "Edit owner",
    "Data rezerwacji do": "Booking date to",
    "Domyślne ustawienie dla witryny": "Default site setting",
    "znaki": "characters",
    "Edycja slajdów": "Edit slides",
    "Data Zmiany": "Date of change",
    "Niżej": "Below",
    "Pytanie i odpowiedzi": "Question and answers",
    "Wgraj plik": "Upload file",
    "Odpowiedź 1": "Answer 1",
    "Przypisani użytkownicy": "Assigned users",
    "Miejsce logowania": "Sign in place",
    "Wróć do strony głównej": "Back to Home Page",
    "Użytkownik Sprzatanie": "User Cleaning",
    "Laptop 17\"": "17\" laptop",
    "Ukraiński": "Ukrainian",
    "6 godzin": "6 hours",
    "Koszt został zaktualizowany.": "The cost has been updated.",
    "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Specifies where you want to add additional items to the path.",
    "Imię lub nazwisko właściciela": "",
    "W zespole od %0": "In the team from %0",
    "Adres IP": "IP address",
    "Konfiguracja": "Settings",
    "Profil użytkownika": "User's profile",
    "Notatki Koordynatorów": "Coordinators' notes",
    "Ilość nocy": "Number of nights",
    "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "Automatic version acceptance on the publication date. The selected version must be given status \"Completed\"",
    "Trasa została zakończona": "The route has been completed",
    "Czy opublikowany": "Whether published",
    "Zaakceptowane": "Accepted",
    "Niewykonane zadania": "Unfinished tasks",
    "Edytuj kolor": "Edit Color",
    "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Notification is required by default. You cannot turn off this notification.",
    "Strona lekcji SCORM opublikowana": "SCORM lesson page published",
    "Nieaktywni właściciele": "Inactive owners",
    "Data następnej inwentaryzacji": "Date of next inventory",
    "Przetestuj ustawienia poczty": "Test your mail settings",
    "Wszystkie kategorie": "All categories",
    "Odpowiedzi": "Responses",
    "Kalendarz Pracowniczy": "Employee Calendar",
    "Element": "Element",
    "Brak dodanych punktów trasy": "No route points added",
    "Słownik dowolny": "Dictionary allowed",
    "Nazwa witryny": "Site name",
    "Raporty": "Reports",
    "Dodaj kategorie": "Add category",
    "Synchronizuj razem z anulowanymi": "Synchronize together with canceled",
    "Pytanie 2": "Question 2",
    "Zrób zdjęcie": "Take a picture",
    "Numer domu": "House no",
    "Ilość toalet": "Number of toilets",
    "Dodaj zadanie: inspekcja": "Add task: Inspection",
    "ID": "ID",
    "Przycisk": "Button",
    "Wysłane powiadomienie": "Notification sent",
    "co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)": "what is to happen now (what is the expectation of the guest)",
    "Nie udało się zapisać komentarza": "",
    "Powiadomienie o oczekującym szkoleniu": "Pending training notification",
    "Pokaż zdjęcie w raporcie": "Show photo in report",
    "zacznij pisać aby wyszukać użytkownika...": "start typing to search for a user...",
    "Zaznacz": "Mark",
    "Historia zmian": "History of changes",
    "Dodaj nieruchomość do trasy": "Add property to route",
    "Rozwiń do": "Expand to",
    "Wstaw z lewej strony": "Insert left",
    "Kopiuj filtr": "Copy filter",
    "Nieaktywne": "Inactive",
    "Ilość zadań": "Number of tasks",
    "Hasło zostało zmienione. Zaloguj się ponownie": "The password has been changed. Log in again",
    "Nazwa wydziału": "Department name",
    "Poziomo": "Horizontally",
    "Bardzo zadowolony": "Very satisfied",
    "Zacznij pisać aby wyszukać...": "Start typing to search...",
    "Nie udało się pobrać danych odnośnie rezerwacji i zadań": "Failed to retrieve booking and task data",
    "Publikacja została usunięta.": "The publication has been deleted.",
    "Zlecenie zostało utworzone.": "The order has been created.",
    "Podaj adres url...": "Enter the url...",
    "KRS": "KRS",
    "Przedrostek": "Prefix",
    "Galeria zdjęć": "Photo gallery",
    "Bloki": "Blocks",
    "Pytanie": "Question",
    "Od poziomu": "From level",
    "Nie udało się zapisać szablonu": "Failed to save template",
    "Strona testu opublikowana": "Test page published",
    "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "To add users to the training, you have to save the form.",
    "Stworzone przez użytkownika": "Created by the user",
    "Wstaw przycisk": "Insert button",
    "Id checklisty": "Checklist Id",
    "Region apartamentu": "Region of the apartment",
    "Nie udało się utworzyć zlecenia.": "Failed to create order.",
    "5": "5",
    "Bardzo niezadowolony": "Very unsatisfied",
    "Cron": "Cron",
    "Dzielnica została zaktualizowana.": "The district has been updated.",
    "Luty": "February",
    "Włącz social media": "Enable social media",
    "Monitor aktywności": "Activity monitor",
    "Utworzono przez: ": "Created by: ",
    "Drugie imię": "Middle name",
    "Typ elementu": "Element type",
    "Podaj dane autora": "Enter author details",
    "${(ex as any).response.data.errors.message[0]}": "${(ex as any).response.data.errors.message[0]}",
    "Usuń kategorię": "Delete category",
    "Po przejściu na mapę zadanie zostanie usunięte.": "",
    "Typ pola": "Field type",
    "Opracowanie kosztu": "Cost edit",
    "Dodanie miasta": "Add a city",
    "Katalog linków": "Links directory",
    "Przypisani użytkownicy:": "Assigned users:",
    "Elementy": "Elements",
    "Dane wydziału zostały dodane.": "The department's data has been added.",
    "Zapisz": "Save",
    "Kwota kosztu od": "Cost amount from",
    "Pobierz plik": "Download file",
    "Data wznowienia": "Date of resumption",
    "zacznij pisać aby wyszukać szkolenie...": "start typing to search for training...",
    "Imię klienta": "Customer name",
    "Opis obrazka": "Image description",
    "Edycja ustawień wynagrodzenia dla:": "Edit salary settings for:",
    "Usuń obrazek": "Delete image",
    "Wymagane": "Required",
    "Lista jest pusta": "The list is empty",
    "Porównywana wersja": "Compared version",
    "Edytuj lekcje SCORM": "Edit SCORM lessons",
    "Zacznij pisać aby wyszukać region...": "Start typing to search for a region...",
    "Nazwisko i Imię": "Last name and first name",
    "Region został usunięty": "The region has been deleted",
    "Stwórz zadanie z notatki": "Create a task from a note",
    "Edytuj sekcję": "",
    "Dostępne języki": "Available languages",
    "Wybierz dział": "Select a department",
    "Usuń slajd": "Delete slide",
    "Lista certyfikatów": "List of certificates",
    "Niestandardowy adres strony": "Non-standard page address",
    "Dodatkowe wynagrodzenie - komentarz": "Additional salary - comment",
    "Nazwa slajdu": "Slide name",
    "Data utworzenia do": "Creation date to",
    "Ten zespół nie posiada jeszcze żadnych członków.": "This team does not have any members yet.",
    "Harmonogram": "Schedule",
    "Za przepracowane godziny": "For hours worked",
    "Wynagrodzenie PLN brutto": "Gross salary amount in PLN",
    "Symbol": "Symbol",
    "Zaznacz wszystko ": "Tick all ",
    "Witryna została dodana.": "The site has been added.",
    "Lista punktów": "List of points",
    "Środa": "Wednesday",
    "Zwierzątko": "Pet",
    "Są to wszystkie obiekty, nawet te, które posiadają już właściciela.": "These are all properties, even those that already have an owner.",
    "Ukryj filtry": "Hide filters",
    "Typ zestawu": "Set type",
    "Edycja certyfikatu": "Edit certificate",
    "Wpisz kwotę": "Enter the amount",
    "Testowy adres email": "Tested email address",
    "Wynagrodzenie stałe miesięczne": "Fixed monthly salary",
    "Udało się zaktualizować zadania!": "Successfully updated tasks!",
    "Ostateczne wynagrodzenie:": "Final salary:",
    "Nie udało się dodać pliku typu ": "Failed to add file type ",
    "Nieruchomość została dodana.": "The property has been added.",
    "Standard": "Standard",
    "E-mail": "E-mail",
    "Miesiąc edycji wynagrodzenia": "Month of salary edition",
    "Edytuj lekcje wideo": "Edit video lesson",
    "Edycja trasy": "Edit a route",
    "Powrót do historii": "Back to history",
    "Nazwa domyślnej checklisty": "Name of the default checklist",
    "Moje zadania": "My tasks",
    "Link został usunięty.": "The link has been removed.",
    "Ustawienia": "Settings",
    "Nie udało się dodać miasta lub dzielnicy": "Failed to add city or district",
    "Dodaj lekcję Wideo": "Add Video lesson",
    "Apple iPad": "Apple iPad",
    "Nie ma żadnych etykiet dla wybranej daty": "There are no labels for the selected date",
    "Sekcja została usunięta": "",
    "Zdjęcie główne": "Main photo",
    "Liczba pracowników w regionie": "Number of employees in the region",
    "Slajd został usunięty.": "The slide has been deleted.",
    "Notatka została usunięta.": "The note has been deleted.",
    "Filtry map": "Map filters",
    "Wysłane": "Sent",
    "Pole może zawierać jedynie litery.": "This field can only contain letters.",
    "Nie udało się pobrać listy kolejek": "Failed to retrieve queue list",
    "Stack Trace": "Stack Trace",
    "Stwierdzenie": "Statement",
    "Data utworzenia zadania": "Date the task was created",
    "Wyczyść filtry": "Clear filters",
    "Zobacz szczegóły zdarzenia": "View event details",
    "Ustawienia Domyślne": "Default settings",
    "Firma została dodana.": "The company has been added.",
    "Całkowity dystans (km)": "Total distance (km)",
    "Checklista została zaktualizowana.": "The checklist has been updated.",
    "Brak kategorii nadrzędnej": "No parent category",
    "Przyjazd": "Arrival",
    "Wyczyść defaultowych użytkowników": "Clear default users",
    "Automatyczna akceptacja": "Auto acceptance",
    "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Only templates for enabled and supported channels can be edited.",
    "Liczba szkoleń w ścieżce": "Number of trainings in the path",
    "Data wyjazdu": "Date of departure",
    "Dodanie zestawu regulaminów": "Add set of regulations",
    "Kategoria materiałów": "Material category",
    "Edytuj slajder": "Edit slider",
    "Szukana fraza": "Search term",
    "Punkt został oznaczony": "The point has been marked",
    "Akcje": "Actions",
    "Wstaw cztery kolumny 1/4": "Insert four columns 1/4",
    "Podsumowanie": "Summary",
    "Miesiące": "Months",
    "Marketing": "Marketing",
    "Co 4 miesiące": "Every 4 months",
    "Wyrażone zgody": "Consents given",
    "Sierpień": "August",
    "Potwierdzenie zmiany statusu": "Confirmation of status change",
    "Film": "Film",
    "Wymagane jest wybranie źródła danych": "Choosing data source is required",
    "Obciążenie Gościa": "Charge Guest",
    "Numer rezerwacji Avantio": "Avantio Reservation number",
    "Nie udało się pobrać listy wydziałów": "Failed to download the list of departments",
    "Pozycja": "Position",
    "Strona ukryta": "Hidden page",
    "wybierz...": "select...",
    "Certyfikat został zaktualizowany.": "The certificate has been updated.",
    "Wybrana ikona powinna być kwadratem": "The selected icon should be a square",
    "Wybierz serwer": "Select server",
    "Zarządzaj zespołami": "Manage teams",
    "Zwrócony": "Returned",
    "Wiadomość została ukryta.": "The message has been hidden.",
    "Kolor trasy": "Route color",
    "Potwierdzenie przywrócenia": "Confirmation of restoration",
    "Data nieobecności do": "Date of absence to",
    "Dowolna data": "Any date",
    "Zmiana hasła": "Password change",
    "Pole \"Drugie imię\" jest wymagane.": "''Middle name'' is required.",
    "Resetuj filtry": "Reset filters",
    "Zaawansowane": "Advanced",
    "Nie możesz wpływać na kolejność punktów już oznaczonych jako odwiedzone": "You cannot influence the order of points already marked as visited",
    "Automatyczny": "Automatic",
    "Aktywne kanały komunikacji": "Active communication channels",
    "Nieruchomość została usunięta.": "The property has been removed.",
    "ID lub typ zadania": "Task ID or type",
    "Tło przycisku": "Button background",
    "Lista koordynatorów": "Coordinators list",
    "Lekcja wideo została dodana.": "The video lesson has been added.",
    "Nie znaleziono żadnych wyników.": "No results found.",
    "Back Office": "Back Office",
    "Szkolenie rozpoczyna się": "Training begins",
    "Nazwa grupy": "Group name",
    "ŚREDNIA": "AVERAGE",
    "Niemiecki": "German",
    "Data akceptacji": "Acceptance date",
    "Wymiary": "Dimensions",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Number of employees working in more then one region",
    "Ostatnia aktywność": "Recent activity",
    "Dodaj wszystkie z kategorii": "Add all categories",
    "Widoczność": "Visibility",
    "Uwzględniaj nieruchomości": "Take real estate into account",
    "Host": "Host",
    "Id zdarzenia": "Event Id",
    "Długość": "Length",
    "Rok": "Year",
    "Dodaj nowy": "Add new",
    "Edycja wynagrodzenia": "Edit salary",
    "słowa": "words",
    "Wersje": "Versions",
    "Dodanie": "Adding",
    "Zablokowany": "Blocked",
    "Więcej...": "More…",
    "Dodaj zdjęcia do wiadomości": "Add photos to the message",
    "Ten punkt został już odwiedzony": "This place has already been visited",
    "Dodaj premię": "Add bonus",
    "Płeć": "Gender",
    "Dodaj link": "Add link",
    "Zespół został dodany.": "The team has been added.",
    "Przejdź do mapy": "Go to map",
    "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "Do not show a short description of the page in search results (NoSnippet)",
    "Opublikowany": "Published",
    "Data rezerwacji od": "Booking date from",
    "Porównaj z edytowaną wersją": "Compare with edited version",
    "Symbol lekcji": "Lesson symbol",
    "Numer aktywnej strony": "Active page number",
    "Wpis został zaktualizowany.": "The post has been updated.",
    "Co miesiąc": "Every month",
    "Sprawdzenie czy pusty": "Check if empty",
    "Właściciel został dodany.": "The owner has been added.",
    "Pracownicy": "Employees",
    "Historia zadania": "Task history",
    "Nieobecność od": "Absence from",
    "Kategoria została zaktualizowana.": "The category has been updated.",
    "Całkowity czas": "Total time",
    "Przetwarzane": "Processing",
    "Data zmiany statusu do": "Date of status change to",
    "Przejdź do Checklisty": "Go to Checklist",
    "Slajder został zaktualizowany.": "The slider has been updated.",
    "Kwota rezerwacji": "Booking amount",
    "Zacznij pisać aby wyszukać miasto...": "Start typing to search for a city...",
    "Element opublikowany": "Published element",
    "30 minut": "30 minutes",
    "Dodanie roli": "Add role",
    "Lekcja została zaktualizowana.": "The lesson has been updated.",
    "Wysyłaj tym kanałem": "Send through this channel",
    "Zmień kolejność punktów": "Change the order of points",
    "Prywatne": "Private",
    "Pojedynczy artykuł (strona opisowa)": "Single article (descriptive page)",
    "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "To add users to the learning path, you have to save the form.",
    "Wszystkie obiekty:": "All objects:",
    "Inwentaryzaje": "Inventory",
    "Typ slajdu": "Slide type",
    "brak danych": "no data",
    "Regulaminy": "Regulations",
    "Usuń wszystkie tagi": "",
    "Dodanie działu": "Add department",
    "Ustawienia slajdera": "Slider settings",
    "Zmień nazwę": "Rename",
    "Exclusivity": "Exclusivity",
    "Resetowanie podejść użytkowników": "Reset user approaches",
    "Dodaj nieruchomość": "Add property",
    "Domyślna wartość": "Default value",
    "Powiadomienie o zmianach": "Notification of changes",
    "Nie udało się zaktualizować zlecenia.": "Failed to update order.",
    "Wyliczenie stawki godzinowej (statystyczna)": "Calculation of the hourly rate (statistical)",
    "Link do strony": "Website link",
    "Zacznij pisać aby wyszukać zaopatrzenie...": "Start typing to search for supplies...",
    "Poprawne": "Correct",
    "Zapisz trasę": "Save route",
    "Rodzaj odpowiedzi": "Type of response",
    "Upload": "Upload",
    "Data dodania kosztu": "Date the cost was added",
    "Właściciel": "Owner",
    "Etykiety": "Tags",
    "Typ rezerwacji": "Booking type",
    "${ex.data.errors.symbol[0]}": "${ex.data.errors.symbol[0]}",
    "Odznacz wszystkie": "Unselect all",
    "Anuluj": "Cancel",
    "Treści odpowiedzi są wymagane": "Answers are required",
    "Rezerwacja właścicielska": "Owner's reservation",
    "Wczutuję...": "",
    "Tłumacz checklistę": "Translate checklist",
    "Koszt dla nieruchomości roboczej": "Cost for working property",
    "Załączone zdjęcia": "Attached photos",
    "Źródło URL": "URL source",
    "Wstęp": "Introduction",
    "Dane wydziału zostały zaktualizowane.": "The department's data has been updated.",
    "Kopiuj numer rezerwacji": "Copy booking number",
    "Wymagaj znaków specjalnych w hasłach": "Require special characters in passwords",
    "Wybór kategorii": "Category selection",
    "Aktywni": "Active",
    "Wpis został dodany.": "The post has been added.",
    "zacznij pisać aby wyszukać slajder...": "start typing to search for a slider...",
    "Szczegóły": "Details",
    "Brak historii zmian": "",
    "po %0 nieudanych próbach logowania": "after %0 unsuccessful login attempts",
    "Nazwa źródła danych": "Data source name",
    "Nazwa ulicy (StreetName)": "Street Name",
    "Odpowiedź 2": "Answer 2",
    "Administracja - Zespoły": "Administration - Teams",
    "Użytkownik posiada pełne uprawnienia": "The user has full permissions",
    "Liczba inspektorów": "Number of inspectors",
    "Godzina wykonania": "Time of execution",
    "Pokaż szczegóły": "Show details",
    "Wszyscy": "Everyone",
    "Urlop został zaktualizowany.": "Absence has been updated.",
    "Aktualności ze strony": "Website news",
    "Miasto zostało dodane.": "The city has been added.",
    "(AirBnb) Wysłano żądanie do portalu": "(AirBnb) A request has been sent to the portal",
    "Widoczny obszar": "Visible area",
    "ZMIANA": "CHANGE",
    "REGON": "REGON",
    "Kanały włączone w ustawieniach aplikacji": "Channels enabled in app settings",
    "Edycja użytkownika": "Edit user",
    "Wyłącz powiadomienia": "Disable notifications",
    "Zresetuj hasło": "Reset password",
    "Wstecz": "Back",
    "Załącz zdjęcia": "Attach photos",
    "Edycja regulaminu": "Edit regulations",
    "Nieruchomości (Data przyjazdu)": "Properties (Arrival Date)",
    "Nazwa bloku": "Block name",
    "Wartość musi być liczbą dodatnią": "The value must be a positive number",
    "Fiirma została zaktualizowana.": "Company has been updated.",
    "Przypisane miasta do regionu:": "Cities assigned to the region:",
    "Imie i nazwisko właściciela": "Owner's name and surname",
    "Nazwa działu": "Department name",
    "Hasło do sieci Wi-Fi": "Wi-Fi network password",
    "Etykieta": "Tag",
    "Udostępnij": "Share",
    "Cancelled by owner": "Cancelled by owner",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "",
    "Wyświetl również zarchiwizowane formularze": "Display archived forms too",
    "jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji": "if contact is needed, please indicate with whom and when and contact details if different from those of the reservation",
    "Potwierdzenie usunięcia. Usunięcie tematu spowoduje usunięcie przypisanych do niego lekcji": "Confirmation of deletion. Deleting a topic will delete the lessons assigned to it",
    "Kod HTML": "HTML code",
    "Uprawnienia użytkownika": "User permissions",
    "Wybrane regulaminy:": "Selected regulations:",
    "Kategoria materiału": "Material category",
    "Grupa": "Group",
    "Under request": "Under request",
    "Dodanie ankiety": "Add surveys",
    "Liczba pracowników": "Number of employees",
    "Dodaj zlecenie": "Add order",
    "Wpisz komentarz...": "Write a comment...",
    "Komunikat walidacji": "Validation message",
    "Publikuj na stronie": "Publish to page",
    "Wpisz nazwę regionu...": "Enter the name of the region...",
    "Błędne": "Incorrect",
    "Zasięg": "Range",
    "Język:": "Language:",
    "Publikacja priorytetowa": "Priority publication",
    "Ukryj przycisk": "Hide button",
    "Pole \"Tytuł\" jest wymagane.": "''Title'' is required.",
    "Pralnia": "Laundry",
    "Zdjęcie": "Photo",
    "Test został dodany.": "The test has been added.",
    "Ostatnia wiadomość - użytkownik": "Last message - user",
    "Elementy inwentaryzacji": "Inventory elements",
    "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "The certificate is prepared in A4 format. The preview displayed is only a draft. The desired appearance of the certificate will be associated with the relevant training and user data.",
    "Przypisane miasta": "Assigned cities",
    "Ponów zadanie": "Retry task",
    "UWAGA! Nieruchomość jest już przypisana od innego właściciela": "ATTENTION! The property is already assigned to another owner",
    "Wszystkie niezapisane zmiany zostaną utracone.": "Any unsaved changes will be lost.",
    "Usuń zaznaczone": "",
    "Aranżacja utowrzona przez": "Arranged by",
    "Osoba zastępująca": "Substitute",
    "Kanały komunikacji": "Communication channels",
    "Nazwa nieruchomości": "Property name",
    "Kroki": "Steps",
    "Dodaj lekcję SCORM": "Add SCORM lesson",
    "Strona została usunięta.": "The page has been deleted.",
    "Osoba przypisana do zadania": "Person assigned to the task",
    "Pokaż czat": "Show Chat",
    "Dostępy": "Available",
    "Powiększ": "Zoom in",
    "Filtr globalny": "Global filter",
    "Uzupełnij dane dotyczące szkolenia": "Fill in the training data",
    "Brak kluczy": "No keys",
    "Polski": "Polish",
    "Cztery kolumny": "Four columns",
    "Avantio ID nieruchomości": "Avantio Property ID",
    "Wybierz kierowce": "Choose a driver",
    "Szkolenie": "Training",
    "Przeciągnij do innej sekcji": "Drag to another section",
    "Brak zadań": "No task",
    "Edycja poradnika": "Edit guide",
    "Zlecenie zostało usunięte.": "The order has been deleted.",
    "Opis zadania": "Task description",
    "Pliki do wysłania: %0": "Files to send: %0",
    "Nie podano nazwy poprzedniego elementu.": "No name is given for the previous element.",
    "Ta nieruchomość już posiada takie wyposażenie.": "This property already has such amenity.",
    "OwnerService": "OwnerService",
    "Przyznaj dostęp": "Grant access",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "No assigned teams to the learning path.",
    "Ładuję zgłoszenia...": "Loading submissions...",
    "Wstaw kontrolkę": "Insert control",
    "Top kosztów wg miast": "Top costs by city",
    "Nieprawidłowy adres email": "Invalid email address",
    "Potwierdź wyczyszczenie logów": "Confirm clearing logs",
    "Brak przypisanych użytkowników.": "No assigned users.",
    "Nie znaleziono szczegółów zmiany": "No change details found",
    "Wybierz pliki do dodania": "",
    "Witryna domyślna": "Default site",
    "Ścieżka szkoleniowa": "Learning path",
    "Generuj PDF": "Generate PDF",
    "Dodanie etykiety": "Add taf",
    "Brudne": "Dirty",
    "Nr nieruchomości Guesty": "Property no. Guesty",
    "Ta czynność została wykonana przez kogoś innego. Odśwież aplikację.": "This action was done by someone else. Refresh the app.",
    "Poprzedni miesiąc": "Previous month",
    "Nieaktywna": "Inactive",
    "Strona": "Page",
    "Rejestracja konta": "Sign-up",
    "Nie udało się pobrać listy bloków": "Failed to download block list",
    "Nowa data": "New date",
    "Typ plików": "",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "Insert two columns 2/3 and 1/3",
    "Edycja etykiety": "Edit label",
    "Publikuj certyfikat": "Publish certificate",
    "Kategoria linku": "Link category",
    "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "List of effective user permissions resulting from individual permissions and roles.",
    "Nazwa płyty": "Disc name",
    "Obojętny": "Indifferent",
    "Twoje hasło wygasło. Zmień je na nowe.": "Your password has expired. Change it to new one.",
    "Liczba dni co ile wysyłane jest powiadomienie": "Number of days of how often a notification is sent",
    "Nazwa slajdera": "Slider name",
    "Token": "Token",
    "Ukryj przypisane zadania": "Hide Assigned Tasks",
    "Baza danych tego klienta jest nieaktualna. Uruchom aktualizację za pomocą przycisku na dole formularza.": "This customer's database is out of date. Install an update with the button at the bottom of the form.",
    "Typ szablonu": "Template type",
    "Dodaj element": "Add element",
    "Edycja witryny": "Edit site",
    "${StatusName(StatusEnum[this.form.bookingType])}": "${StatusName(StatusEnum[this.form.bookingType])}",
    "Bardzo źle": "Very bad",
    "Przywrócić użytkownika i jego wiadomości?": "Restore the user and their messages?",
    "Kolor tła": "Background color",
    "Administracja": "Administration",
    "Status regulaminu został zmieniony.": "The status of the regulations has been changed.",
    "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Add a new directory to start managing your pages.",
    "Szef regionu": "Head of the Region",
    "Zadanie znajduje się na trasach:": "",
    "Ilość": "Quantity",
    "Średnio": "Moderately",
    "Logowanie zakończyło się niepowodzeniem.": "Login failed.",
    "Opisy": "Descriptions",
    "Wybierz zaznaczone": "Choose selected",
    "Stałe/miesięczne": "Fixed/monthly",
    "Wydział / Rola": "Department / Role",
    "Trasa została zapauzowana": "The route has been paused",
    "Wybierz typy powiadomień, które chcesz wyłączyć:": "Select the types of notifications you want to disable:",
    "Wysłano kolejne powiadomienie": "Another notification has been sent",
    "Wybierz punkt": "Select a point",
    "Regiony": "Regions",
    "Użytkownik został dodany do zespołu.": "The user has been added to the team.",
    "Źródło danych zostało zaktualizowane.": "The data source has been updated.",
    "Przesuń na dół": "Move down",
    "Pliki zostały usunięte": "",
    "Laptop 15\"": "15\" laptop",
    "Zobacz sesję użytkownika": "View user session",
    "Kwota": "Amount",
    "Konto publiczne": "Public account",
    "Wpis przeczytany": "Read post",
    "Słowa kluczowe": "Keywords",
    "Szef Regionu": "Head of the Region",
    "Dane kosztu": "",
    "Wartość musi być liczbą całkowitą": "The value must be an integer",
    "Początek długości geograficznej użytkownika": "The beginning of the user's longitude",
    "Akcja": "Action",
    "Ukryj już zaplanowane punkty": "Hide already scheduled points",
    "Właściciel aktywny": "Active owner",
    "Zmień daty publikacji": "Change publication dates",
    "Wybierz certyfikat": "Select a certificate",
    "Zawsze": "Always",
    "Typ dodanego kosztu": "The type of added cost",
    "Dodaj sekcję": "",
    "Nie zdefiniowano żadnych sekcji.": "No sections are defined.",
    "Powiązania z dzielnicą": "Connections to the District",
    "Wpisz nazwę dzielnicy...": "Enter the name of the district...",
    "Sortuj po": "Sort by",
    "Informacje": "Information",
    "Blok został usunięty.": "The block has been removed.",
    "Do sprawdzenia - przeniesione": "To be checked - moved",
    "Potwierdzenie usunięcia": "Deletion confirmation",
    "Wybór listy stron": "Selection of the list of pages",
    "zacznij pisać aby wyszukać zespół...": "start typing to search for a team...",
    "Miasta": "Cities",
    "Lista nieruchomości": "List of properties",
    "Nie podano odpowiedzi dla ostatniego elementu.": "No response was given for the last element.",
    "Mężczyzna": "Man",
    "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Field ''%0'' does not contain a valid URL address.",
    "zaznacz wszystko": "select all",
    "Metadane": "Metadata",
    "Tag został usunięty.": "The tag has been removed.",
    "Adres 2": "Address 2",
    "Wartość domyślna": "Default value",
    "Brak zadania": "No task",
    "Dodanie certyfikatu": "Add certificate",
    "Dokument": "Document",
    "Nazwa linku": "Link name",
    "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Lowercase letters only, no special characters, numbers, and spaces.",
    "Nazwa nieruchomości roboczej": "Name of the working property",
    "Generuję plik...": "Generating a file...",
    "Opcje": "Options",
    "Imie i nazwisko osoby, która dodawała koszty": "Name of the person who added costs",
    "Pozostało %0 znaków.": "There are %0 characters left.",
    "Nie udało się zmienić statusu zadania": "Failed to change task status",
    "Kwota brutto": "",
    "Treść certyfikatu": "Certificate content",
    "Nazwa katalogu": "Directory name",
    "Laptop 15,6\"": "Laptop 15.6\"",
    "Dokument nie ma ustawionej daty publikacji.": "The document does not have a publication date set.",
    "Wstaw dwie równe kolumny": "Insert two equal columns",
    "Zastępstwo": "Substitution",
    "Ma dzisiaj": "He has today",
    "Grafik pracowniczy": "Work schedule",
    "Adres": "Address",
    "Narzędzia": "Tools",
    "Wersja": "",
    "Strona dostępna dla wszystkich": "Website available to everyone",
    "Pionowo": "Vertically",
    "Dziś": "Today",
    "Edycja szkolenia": "Edit training",
    "Odejmowanie": "Subtraction",
    "Kolor": "colour",
    "Symbol testu": "Test symbol",
    "Brak daty": "No date",
    "Obciążenie Magazyn": "Charge Storage",
    "Kwota za zadania": "Pay per task",
    "Odpowiedź 4": "Answer 4",
    "Adres e-mail": "E-mail address",
    "Zapisz i wróć": "Save and return",
    "Wiadomość": "Message",
    "Lipiec": "July",
    "Typ nieruchomości": "Property type",
    "Koordynator HK": "Coordinator HK",
    "Obciążenie Właściciela": "Charge Homeowner",
    "Host główny": "Main host",
    "Dodaj kafelek": "Add tile",
    "Dodanie zastępstwa": "Add replacement",
    "Data usunięcia": "Deletion date",
    "Test został zaktualizowany.": "The test has been updated.",
    "Edytuj katalog": "Edit directory",
    "Zapomniałeś hasła?": "Forgot your password?",
    "Zadanie zostało ukończone przez kogoś z Twojego zespołu.": "The task was completed by someone from your team.",
    "Niski": "Low",
    "Domyślny czas rezerwacji": "Default booking time",
    "Stwórz czat z zadania": "Create chat from task",
    "Zakończone": "Completed",
    "Ścieżka": "Path",
    "Not Available": "Not Available",
    "Firma": "Company",
    "Wybór koloru jest wymagany": "Color selection is required",
    "Typ konta": "Account type",
    "Dodanie szablonu": "Add template",
    "Dodaj szablon": "Add template",
    "Docelowa strona": "Target page",
    "Dodanie serwera": "Add server",
    "Włączenie protokołu SSL dla tej witryny": "Enable SSL for this site",
    "Test ukryty": "Hidden test",
    "Wyszukaj użytkownika": "Search users",
    "Zespoły": "Teams",
    "Miesiąc": "Month",
    "Załączniki": "Attachments",
    "Zgłoszenie serwisowe": "Support Request",
    "Konta prywatne": "Private accounts",
    "Inspekcje": "Inspections",
    "Brak wersji": "No version",
    "Anuluj i wyjdź z kreatora": "Cancel and exit the creator",
    "Wyszukuję...": "I'm looking for...",
    "Marzec": "March",
    "Filtry globalne": "Global filters",
    "Zadanie zostało dodane.": "The task has been added.",
    "Dodawanie": "Adding",
    "Dane dostępowe": "Access data",
    "Data zakończenia od": "End date from",
    "Nie możesz edytować tego punktu. Został on już oznaczony jako odwiedzony": "You cannot edit this point. It has already been marked as visited",
    "Przenieś do sekcji": "Move to section",
    "Adres url": "Url",
    "Numer rezerwacji": "Reservation number",
    "usunięto dzielnice": "removed neighborhoods",
    "edycja": "edit",
    "Wyszukaj nieruchomość...": "Search for a property...",
    "reset": "reset",
    "Nie udało się pobrać listy działów": "Failed to download the departments list",
    "Nie wybrano obrazu.": "No image has been selected.",
    "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Select the notification type to see the available keys.",
    "Wybierz inspektora": "Select an inspector",
    "Notatka/Komentarz": "",
    "Nie podano wymaganej ilości znaków: %0.": "The required number of characters was not met: %0.",
    "Dodaj urlop": "Add absence",
    "Wynagrodzenia HK": "HK salary",
    "Gotowe": "Ready",
    "Wykonane zadania": "Completed tasks",
    "Przywrócić wiadomość?": "Restore a message?",
    "5 minut": "5 minutes",
    "Get it on Google Play": "Get it on Google Play",
    "Nazwa klienta": "Client name",
    "Zlecenie zostało zaktualizowane.": "The order has been updated.",
    "SUMA": "SUM",
    "Edytuj obraz": "Edit image",
    "Nazwa tagu": "Tag name",
    "Typ powiadomienia": "Notification type",
    "Nie podano nazwy tytułu.": "No title name is given.",
    "Komentarz został zapisany": "",
    "Właściwości": "Characteristics",
    "Usuń datę": "Delete date",
    "Wystąpił problem z dostępem do kamery": "There was a problem with access to the camera",
    "Ulica": "Street",
    "Ukryj czat": "Hide chat",
    "Minimalna długość hasła": "Minimum password length",
    "Nie masz uprawnień do panelu administracyjnego.": "You do not have permission to access the administration panel.",
    "Ilość gości": "Number of guests",
    "Zawartość": "Content",
    "checklista": "checklist",
    "Nie wybrano żadnej strony.": "No page has been selected.",
    "Styczeń": "January",
    "Progress Gotowości": "Readiness progress",
    "Facebook Admins": "Facebook Admins",
    "Nie udało się ustawić miasta.": "Failed to set up city.",
    "Edycja linku": "Edit link",
    "Pracownicy z brakującymi ustawieniami wynagrodzenia": "Employees with missing salary settings",
    "Dodaj inwentaryzacje": "Add inventories",
    "Wygeneruj pilik": "Generate file",
    "Pobyt: ": "Stay: ",
    "Checklista:": "Checklist:",
    "Strona lekcji opublikowana": "Lesson page published",
    "Zapisz komentarz": "",
    "Usuń materiał z testu": "Remove material from the test",
    "Migracje": "Migrations",
    "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "Incorrect number, check the number of published materials.",
    "Nie można przenosić plików między sekcjami o różnych typach": "",
    "Jest to lista obiektów które nie mają jeszcze przypisanego właściciela.": "This is a list of apartments that have not yet been assigned an owner.",
    "Folder został usunięty.": "The folder has been deleted.",
    "Symbol strony szkolenia": "Training page symbol",
    "Czy na pewno chcesz usunąć tę sekcję?": "",
    "Łóżeczko": "Cot",
    "Brak działu nadrzędnego": "No parent department",
    "Adres firmy": "Company address",
    "Kwota kosztów": "Amount of costs",
    "Nazwa źródła": "Source name",
    "Katalog": "Directory",
    "Dane nieruchomości": "Property data",
    "$% - znacznik zamykający tag": "$% - tag to close a tag",
    "Wstaw trzy kolumny 1/3": "Insert three columns 1/3",
    "Rola": "Role",
    "CustomerService": "Kundendienst",
    "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "This channel provides a possibility to send formatted text.",
    "BOK": "Customer Service",
    "Koszt pracownika": "",
    "Dział": "Department",
    "Typy materiałów": "Material types",
    "Bazy danych": "Database",
    "Włączone (Follow)": "Enabled (Follow)",
    "Zapauzowano:": "Paused:",
    "Wyjazd": "Check-out",
    "pl": "pl",
    "Przełącznik": "Switcher",
    "Pokaż tytuł formularza": "Show form title",
    "Wyposażenie": "Amenities",
    "Neutralne": "Neutral",
    "Dane kierowcy: ": "Driver data: ",
    "Nazwa bazy danych": "Database name",
    "HR": "HR",
    "Kategorie materiałów": "Material categories",
    "NIP firmy": "Company VAT number",
    "Połącz w pary": "Pair up",
    "Lekcja wideo została zaktualizowana.": "The video lesson has been updated.",
    "Adres serwera": "Server address",
    "Zadania dzisiaj": "Tasks for today",
    "Ten element nie zawiera menu kontekstowego.": "This item does not contain a context menu.",
    "Zastępstwa": "Substitutions",
    "Wzorzec": "Pattern",
    "Liczba podejść": "Number of approaches",
    "Edytuj szablon": "Edit template",
    "Usunięte zadanie": "Deleted task",
    "Data od": "Date from",
    "Data ukończenia": "Completion Date",
    "Szczegóły zdarzenia": "Event details",
    "Zapisz jako": "Save As",
    "Wyposażenie zostało zaktualizowane.": "Amenities has been updated.",
    "Edytuj uprawnienia": "Edit permissions",
    "Powiadomienie o zbliżającym się zakończeniu szkolenia": "Notification of the upcoming end of the training",
    "Pokaż": "show",
    "Data realizacji": "Execution date",
    "Jestem w drodze": "I'm on my way",
    "Poczta": "Mail",
    "Numer Guesty": "Guest Number",
    "Dostęp przyznany": "Access granted",
    "Wyszukaj": "Search",
    "Wybierz regulamin": "Select regulations",
    "Nazwa nadawcy": "Sender name",
    "Filtry": "Filters",
    "Zakończenie": "End",
    "Firma własna": "Own company",
    "Przepracowana liczba godzin w miesiącu": "Number of hours worked per month",
    "Zadanie na dziś": "Task for today",
    "W momencie tworzenia kosztu": "At cost creation time",
    "Edytuj temat": "Edit topic",
    "Uczestnicy rozmowy:": "Chat participants:",
    "linie": "lines",
    "Ilość punktów: ": "Number of points: ",
    "Przypisane tagi:": "Assigned tags:",
    "Otwórz w nowym oknie": "Open in a new window",
    "Dostępne czaty:": "Available chats:",
    "Usługi": "Services",
    "Oczekuje na wysłanie": "To be send",
    "Nazwa trasy": "Route name",
    "Informacje o czacie": "Chat info",
    "Multimedia": "Multimedia",
    "Dopuść brak odpowiedzi": "Allow lack of response",
    "Dane Adresowe": "Address data",
    "Wynagrodzenia Pracowników": "Employees salary",
    "Nazwa pokoju": "Room name",
    "Niedziela": "Sunday",
    "Wymagane jest ustawienie minimalnej długości hasła": "Minimum password length is required",
    "Zgłoszenia w apartamencie": "Submissions in the apartment",
    "To miasto jest już przypisane do użytkownika.": "This city is already assigned to the user.",
    "Dodaj źródło": "Add source",
    "Skrócony opis": "Short description",
    "Wybierz sekcję, do której chcesz dodać pliki": "",
    "Data zakończenia/wykonania": "End/Execution Date",
    "Zapisz nową kolejność punktów": "Save a new order of points",
    "Strona została dodana.": "The page has been added.",
    "pokaż więcej...": "show more...",
    "Nie znaleziono nieruchomości": "",
    "Źródła danych": "Data Sources",
    "Wyświetl popup z kontynuacją lekcji": "View the popup with the continuation of the lesson",
    "Przypisane do:": "Assigned to:",
    "Dodaj rolę": "Add a role",
    "Status linku został zmieniony.": "The status of the link has been changed.",
    "Dodaj opłaconą kwotę": "Add a paid amount",
    "Zapisz filtr": "Save filter",
    "Utworzył": "Created",
    "Suma wynagrodzeń koordynatorów": "Sum of coordinators' salaries",
    "Harmonogram został zmieniony": "The schedule has been changed",
    "Typ obiektu": "Object type",
    "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "A symbol can only consist of lowercase letters, numbers, and a character - ",
    "Wyczyść sesję": "Clear session",
    "Minuty": "Minutes",
    "Nie udało się pobrać ról!": "Failed to download roles!",
    "Miasto zostało zaktualizowane.": "The city has been updated.",
    "Bez dzielnicy": "Without district",
    "Aktywna nieruchomość": "Active property",
    "Wewnętrznie": "Internally",
    "Potwierdzenie publikacji": "Publication confirmation",
    "Tytuł formularza jest wymagany": "Form title is required",
    "Powiadomienia zostały skonfigurowane.": "Notifications have been configured.",
    "Ustawienia dostępności": "Accessibility settings",
    "Pasek": "Bar",
    "E-learning": "E-Learning",
    "Szablon został zaktualizowany.": "The template has been updated.",
    "Liczba dziesiętna": "Decimal",
    "Filtr został usunięty": "Filter has been removed",
    "Usuń tag": "Remove tag",
    "Dołącz stronę do pliku sitemap.xml": "Add the page to the sitemap file.xml",
    "Zmiana motywu": "Theme change",
    "Rola przypisana do tego wydziału jest nieaktywna": "The role assigned to this department is inactive",
    "Numer konta bankowego": "Bank account number (IBAN)",
    "Logger": "Logger",
    "Pokaż zadania bez przypisanej osoby": "Show tasks without an assigned person",
    "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "The browser you are using does not support PUSH notifications",
    "Gość": "Guest",
    "Ten miesiąc": "This month",
    "Koordynator Główny": "Chief Coordinator",
    "Firmy": "Companies",
    "Nieudane": "Failed",
    "Data utworzenia wersji": "Version creation date",
    "Raczej się nie zgadzam": "I rather disagree",
    "Nie udało się pobrać szczegółów zmiany": "Failed to download change details",
    "Dodaj koszt": "Add cost",
    "Wykonane": "Executed",
    "Dane dostępu": "Access data",
    "Członkowie zespołu": "Team members",
    "Pre-booking": "Pre-booking",
    "Nazwa zestawu": "Set name",
    "Inwentaryzacje": "Inventories",
    "Wszystkie zadania": "All tasks",
    "Szablon graficzny": "Graphic template",
    "Opis witryny": "Site description",
    "Data:": "Datum:",
    "Id": "Id",
    "Utwórz czat": "Create chat",
    "Stawka PLN brutto za godzinę": "PLN gross rate per hour",
    "Rozmiar": "Size",
    "Dodaj do regionu": "Add to region",
    "Data zalogowania": "Login date",
    "Wysłano powiadomienie.": "A notification has been sent.",
    "Trasy archiwalne": "Archival routes",
    "Musisz wybrać obiekt na mapie": "You need to select an object on the map",
    "Pokaż filtry": "Show filters",
    "Włączenie obsługi cacheu dla witryny": "Enable cache support for the website",
    "do": "to",
    "Komentarz Konserwatora": "Handyman comment",
    "Imię właściciela": "Owner's name",
    "Kategoria slajdu": "Slide category",
    "Obiekty": "Apartments",
    "Nie udało się wgrać pliku": "Failed to upload file",
    "W drodze": "On the road",
    "Zaawansowane polecenia": "Advanced commands",
    "Wyszukiwany ciąg znaków": "Search set of characters",
    "Udało się dodać nieruchomość do trasy": "Successfully added property to route",
    "Edycja wynagrodzenia za posprzątane obiekty dla:": "Edit salary for cleaned properties for:",
    "Nieprawidłowy adres URL": "Invalid URL address",
    "Wybierz blok": "Select a block",
    "Obrazek wyróżniający": "Featured image",
    "Niestandardowy błąd": "Non-standard error",
    "Koszt został usunięty": "",
    "Slajder został dodany.": "The slider has been added.",
    "Synchronizacja rezerwacji": "Synchronization of reservations",
    "Manager Firmy Zewnętrznej": "External Company Manager",
    "Logowanie": "Log in",
    "Brak kategorii": "No categories",
    "Faktyczny czas pracy": "Actual working time",
    "Ustawienia konta": "Account settings",
    "Domyślny tytuł aktywnej strony": "Default title of the active page",
    "Ustawienia zostały zaktualizowane.": "The settings have been updated.",
    "Nie udało się pobrać zadań": "Failed to download tasks",
    "Aktywna": "Active",
    "Wprowadzona wartość nie jest poprawna": "The value you entered is not valid",
    "Wybór języka": "Language selection",
    "Zmień nazwę katalogu": "Rename a directory",
    "Problemy": "problems",
    "Edycja kategorii": "Edit category",
    "Dzielnica została dodana.": "The district has been added.",
    "Brak numeru": "No number",
    "Kategoria została usunięta.": "The category has been removed.",
    "Wybierz stronę": "Select a page",
    "Zadanie zostało włączone": "The task has been enabled",
    "Ankieta": "Survey",
    "Dodaj temat/link": "Add topic/link",
    "Koszty wg regionów": "Costs by region",
    "Dane właściciela": "Owner details",
    "Brak typu zadania": "No task type",
    "zacznij pisać aby wyszukać regulamin...": "start typing to search for the rules ...",
    "Wprowadzona wartość jest za wysoka": "The value you entered is too high",
    "Dodatkowe wynagrodzenie - kwota": "Additional salary - amount",
    "REGON firmy": "Company REGON",
    "VAT (wyliczany automatycznie)": "",
    "Miniaturka wideo": "Video thumbnail",
    "Ukończone przez użytkownika": "Completed by user",
    "Logo": "Logo",
    "Brak strony nadrzędnej": "No parent page",
    "Tagi": "Tags",
    "Archiwalny": "Archival",
    "Pokaż tytuł strony": "Show page title",
    "Administracja - Kraje": "Administration - Countries",
    "Pomoc": "Help",
    "Dane podstawowe": "Basic data",
    "Czas (minuty)": "Time (minutes)",
    "Sformatowany rzeczywisty czas pracy": "Formatted actual working time",
    "Przesyłanie zdjęcia nie powiodło się": "Failed to upload photo",
    "dni temu": "days ago",
    "Nie możesz rozpocząć obsługi tego zadania": "You can't start this task",
    "Zarządzaj": "Manage",
    "Wideo zewnętrzne (URL)": "External video (URL)",
    "Dane zadania": "Task data",
    "Szkolenie zostało zaktualizowane.": "The training has been updated.",
    "Filmy": "",
    "Pytania i odpowiedzi": "Questions & Answers",
    "Aktywny": "Active",
    "Liczba szkoleń": "Number of trainings",
    "Statyczny": "Static",
    "Data wyjazdu": "Date of departure",
    "Właściwość ``%0`` aktywnego wpisu": "The ''%0'' feature of the active entry",
    "Całkowity czas": "Total time",
    "Zapauzowane": "Abandoned",
    "Planuj automatycznie w dniu zakończenia blokady": "Schedule automatically on the day the lockdown ends",
    "Do poziomu": "To level",
    "Tylko priorytetowe": "Priority only",
    "Zmień hasło": "Change password",
    "Odrzucone": "Rejected",
    "Stawka wynagrodzenia została zaktualizowana.": "The pay rate has been updated.",
    "Konfiguracja": "Settings",
    "Właściciel regionu": "Region owner",
    "Wysoki": "High",
    "Nie udało się zaktualizować zlecenia.": "Failed to update order.",
    "Pole zawiera": "Field contains",
    "Odpowiedź": "Answer",
    "Rezerwacja właściciela": "Owner Booking",
    "Niedostępne": "Not Available",
    "Zapytanie": "Inquiry",
    "Odrzucone": "Declined",
    "Wygasłe": "Expired",
    "Anulowane": "Canceled",
    "Zamknięte": "Closed",
    "Zarezerwowane": "Reserved",
    "Potwierdzone": "Confirmed",
    "Katalog został utworzony.": "The directory has been created.",
    "W tym katalogu nie ma jeszcze żadnych stron.": "There are no pages in this directory yet.",
    "Dodanie dzielnicy": "Adding a District",
    "Data zdarzenia": "Event date",
    "Edytuj stawkę za godzinę": "Edit hourly rate",
    "Dostęp do": "Access to",
    "Dodanie wpisu": "Add entry",
    "Zacznik pisać Form lub Entry aby uruchomić podpowiadanie.": "Start typing Form or Entry to show the hints.",
    "Kalendarz nieruchomości": "",
    "Dodanie Notatki": "Add a note",
    "Bezpieczeństwo": "Safety",
    "Dwie kolumny": "Two columns",
    "Administracja - Miasta": "Administration - Cities",
    "Stawka mieszana została zaktualizowana.": "Mixed rate has been updated.",
    "Zacznij pisać aby wyszukać osobę...": "Start typing to search for a person...",
    "Szczegóły rezerwacji": "Booking details",
    "Link do czatu": "Chat link",
    "Kwota kosztu do": "Cost amount up to",
    "Obrazek": "Image",
    "Podaj swój adres email": "Enter your email address",
    "Edytuj Notatkę": "Edit Note",
    "Nieruchomość zagrożona wypowiedzeniem": "Property at risk of termination",
    "Nie udało się pobrać danych o rolach zalogowanego użytkownika": "Failed to retrieve role data for logged-in user",
    "Tryb monitorowania aktywności wyłączony.": "Activity monitoring mode disabled.",
    "Stawka za godzinę brutto": "Gross hourly rate",
    "To zadanie nie posiada jeszcze przypisanych użytkowników.": "This task does not yet have users assigned.",
    "Regulamin wymagany": "Regulations required",
    "Uwzględnij miasto": "Include city",
    "Dodaj dane wydziału": "Add departmental data",
    "Czy na pewno chcesz ukryć wiadomość?": "Are you sure you want to hide the message?",
    "Układ": "Layout",
    "Serwer plików": "File server",
    "Kwota opłacona": "Amount paid",
    "Koniec szerokości geograficznej użytkownika": "End of user latitude",
    "Zadania": "Tasks",
    "ID obiektu": "Object ID",
    "W tym katalogu nie ma jeszcze żadnych stron.": "There are no pages in this directory yet.",
    "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "Notification to the user about new messages in the chat",
    "Serwer został zaktualizowany.": "Server has been updated.",
    "Srednie wynagrodzenie pracowników": "Average salary of employees",
    "Zmiana rozmiaru obrazu": "Resize an image",
    "źródło danych zostało dodane.": "the data source has been added.",
    "Zestaw został dodany.": "The set has been added.",
    "Edytuj blok": "Edit block",
    "Przypisane dzielnice:": "Assigned districts:",
    "Nazwisko właściciela": "Owner's name",
    "Język": "Language",
    "Nazwa sekcji": "Section name",
    "Stawka domyślna": "Default rate",
    "Pokaż więcej": "Show more",
    "Odpowiedź 5": "Answer 5",
    "Witryna / Wersja językowa": "Website / Language version",
    "Weekend": "Weekend",
    "Uwzględnij zadania z miesiąca:": "Inclued tasks from month:",
    "Zamknięte przez": "Closed by",
    "Przypisane do": "Assigned to",
    "Historia logowania": "Login history",
    "Wstaw z prawej strony": "Insert right",
    "Wyłączone (NoIndex)": "Disabled (NoIndex)",
    "Artykuły": "Articles",
    "Data wykonania do": "Execution date to",
    "Zadanie zostało wznowione.": "The task has been resumed.",
    "Witryna aktywna": "Active site",
    "Nie udało się pobrać listy serwerów baz danych": "Failed to retrieve the database server list",
    "Data nieobecności od": "Date of absence from",
    "Ten region nie posiada jeszcze przypisanych miast.": "This region does not yet have assigned cities.",
    "Masz nową wiadomość!": "You have a new message!",
    "Wpisz nazwę trasy": "Enter a name for the route",
    "Przeglądnij logi": "View logs",
    "Nieudane próby logowania": "Failed login attempts",
    "Na pewno usunąć wybrane elementy?": "Are you sure to delete the selected elements?",
    "dzisiaj": "today",
    "Telefon": "Phone",
    "Nazwa aranżacji": "Arrangement name",
    "Zadanie na nieruchomościach roboczych": "Task on working properties",
    "Biblioteka": "Library",
    "Usuń plik z listy": "Remove the file from the list",
    "Zmień dane kosztu": "Change the cost data",
    "Zmień status edytowanej wersji": "Change the status of the edited version",
    "Filtry systemowe": "System filters",
    "Wynagrodzenia Konserwatorzy": "Maintenance salary",
    "Walidacja certyfikatu SSL": "SSL certificate validation",
    "Operacja": "surgery",
    "Edycja ścieżki szkoleniowej": "Edit learning path",
    "Wybrane miasto": "Selected city",
    "Stawka za typ apartamentu": "Rate per apartment type",
    "Mnożenie": "Multiplication",
    "Uwzględniaj Miasta": "Include cities",
    "Edycja zastępstwa": "Edit substitution",
    "Konfiguruj stronę": "Configure page",
    "Zaczyna sie od": "It starts with",
    "Nieobecny do": "Absent until",
    "Dodaj zaopatrzenie": "Add Supplies",
    "Email został wysłany.": "Email has been sent.",
    "Co 20 minut": "Every 20 minutes",
    "km": "kms",
    "Ustaw w kolejności": "Set in order",
    "Użytkownik został przypisany do ścieżki szkoleniowej.": "The user has been assigned to a learning path.",
    "Oczekujące": "Waiting",
    "Confirmed": "Confirmed",
    "Godzina:": "Time:",
    "Lekcja SCORM ukryta": "SCORM Lesson Hidden",
    "Adres strony": "Website address",
    "Administratorzy": "Administrators",
    "Notatki": "Notes",
    "Edycja stawki godzinowej dla:": "Edit the hourly rate for:",
    "Dodaj opis...": "Add a description...",
    "Wynagrodzenie stałe brutto": "Gross fixed salary",
    "Przejdź do rezerwacji": "Go to booking",
    "Parametry, wymagane do wykonania zapytania:": "Parameters required to execute the request:",
    "Pliki zostały pobrane": "",
    "gotowe": "ready",
    "Co 5 minut": "Every 5 minutes",
    "Szkolenie kończy się": "Training is ending up",
    "Link został dodany.": "Link has been added.",
    "Kolejne pozycje z prawej strony": "Next items on the right",
    "Miasta:": "Cities:",
    "Usuń poprzednie wersje certyfikatu": "Delete previous versions of the certificate",
    "Wynagrodzenie za przepracowane godziny": "Salary for hours worked",
    "10 minut": "10 minutes",
    "Paczka została usunięta.": "The package has been removed.",
    "Typ mime": "Mime type",
    "Dodaj temat": "Add topic",
    "Edytuj urlop": "Edit absence",
    "Ścieżka szkoleniowa została zaktualizowana.": "The learning path has been updated.",
    "Powtórzone": "Repeated",
    "Nie wybrano żadnej kategorii.": "No category has been selected.",
    "Azure AD": "Azure AD",
    "Prestiżowe": "Prestigious",
    "Błąd": "Error",
    "3": "3",
    "Sformatowany czas całkowity": "Formatted total time",
    "Liczba małych prześcieradeł": "Number of small sheets",
    "Wersja językowa": "Language version",
    "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "A new update is available. Please save the work progress and click the \"Update\" button. You can also accept the update by refreshing the browser. No update may result in errors.",
    "Użytkownik został zablokowany, a jego wiadomość ukryte.": "The user has been blocked and their message has been hidden.",
    "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Development server only. Do not use in production mode. ",
    "Dział aktywny": "Active department",
    "Wynagrodzenia mieszane": "Mixed salary",
    "Inne": "Other",
    "Zdarzenie": "Event",
    "Kategorie linków": "Link categories",
    "Co 12 godzin": "Every 12 hours",
    "Zadanie zostało wyłączone": "The task has been disabled",
    "Wyślij": "Send",
    "Nie udało się zapisać notatki": "Failed to save note",
    "Nie możesz modyfikować uprawnień": "You cannot modify permissions",
    "Bezpieczne połączenie SSL": "Secure SSL connection",
    "Przepracowana ilość godzin": "Number of hours worked",
    "Dane dostępowe:  ": "Access data:  ",
    "Końcowy stan licznika": "The final state of the meter",
    "Ilość wyświetlanych aktualności": "Number of news updates displayed",
    "Wyznacz punkty": "Set points",
    "%0 znaków": "%0 characters",
    "Szkolenie zostało dodane.": "Training has been added.",
    "Domyślna witryna": "Default site",
    "więcej...": "more...",
    "Dodanie testu": "Add test",
    "Imię i nazwisko pracownika": "Name and surname of employee",
    "Wpisz treść wiadomości.": "Enter the text of the message.",
    "Publikacja zarchiwizowana": "Archived publication",
    "Plik jest wysyłany": "The file is being sent",
    "Brak wyników": "No results",
    "Nazwa sieci Wi-Fi": "Wi-Fi network name",
    "Sekcja została utworzona": "",
    "Trasa została zaktualizowana.": "The route has been updated.",
    "Nazwa checklisty": "Checklist name",
    "Szkolenie nie jest opublikowane": "Training is not published",
    "Zlecenia magazynowe": "Warehouse orders",
    "Edytuj tag": "Edit tag",
    "Dodanie witryny": "Add website",
    "Biuro": "Office",
    "Ilość wyników do odrzucenia": "Number of results to be rejected",
    "Paid": "Paid",
    "Zewnętrzny serwis": "External service",
    "Element grupujący": "Grouping element",
    "Brak tematu": "No topic",
    "Notatka dla": "Memo for",
    "Wybrana sekcja nie istnieje": "",
    "Szkolenie zostało usunięte.": "The training has been removed.",
    "Scenariusz": "Scenario",
    "Numer mieszkania (Door)": "Number of the apartment (Door)",
    "Czas pomiędzy": "Time between",
    "Wersja nieopublikowana": "Unpublished version",
    "Opublikuj": "Publish",
    "Wymuszaj zaliczenie elementów ścieżki zgodnie z kolejnością szkoleń na liście": "Force path elements pass according to the order of training on the list",
    "Lista wyboru": "Selection list",
    "Filtr o podanej nazwie już istnieje.": "The filter with a given name already exists.",
    "Równość": "Equality",
    "Podstawowe operacje na datach": "Basic date operations",
    "Zakończone przez": "Completed by",
    "Porównanie": "Comparison",
    "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "The password must contain at least one special character, e.g.: ~ @ $ % ^ & *",
    "Przypisz do czatu": "Assign to chat",
    "np. pl-PL": "i.e., pl-PL",
    "Standard 1.2": "Standard 1.2",
    "Zdjęcie użytkownika": "User's photo",
    "Włączone": "Enabled",
    "Wtorek": "Tuesday",
    "Upload plików": "Upload files",
    "Status formularza został zmieniony.": "The status of the form has been changed.",
    "Powrót": "Back",
    "Szczegóły zadania": "Task details",
    "Pracownik niedostępny od": "Employee absent from",
    "Strona opublikowana": "Published page",
    "Włączenie generowania pliku sitemap.xml dla całej witryny": "Enable sitemap.xml file generation for the website",
    "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "No assigned teams to the training.",
    "Dodaj zadanie": "Add a task",
    "Kategoria została dodana.": "The category has been added.",
    "Rozliczone": "Accounted",
    "(nowe wiadomości)": "(new messages)",
    "Usuń spacje": "Remove spaces",
    "Data utworzenia aranżacji": "Arrangement creation date",
    "Zarządzanie zespołami": "Team management",
    "Trasy dla Kierowców": "Routes for Drivers",
    "Nawiguj do kolejnego punktu": "Navigate to the next point",
    "Testowe powiadomienie wysłane": "Test notification sent",
    "Średni": "Medium",
    "Katalog został utworzony.": "The directory has been created.",
    "Tryb monitorowania aktywności włączony.": "Activity monitoring mode enabled.",
    "Zarządzanie witrynami": "Manage sites",
    "Miejscowość": "Town",
    "Sekcje": "Sections",
    "Źle": "Bad",
    "Dodanie aktualności": "Add news",
    "zacznij pisać aby wyszukać materiał...": "start typing to search for material...",
    "Nie można usunąć kategorii do ktorej są przypisane elementy.": "You cannot delete a category to which the elements are assigned.",
    "Wytnij": "Cut",
    "Skopiowano": "Copied",
    "Pozostałe ustawienia": "Other settings",
    "Liczba wyświetlanych slajdów": "Number of slides displayed",
    "Dashboard szkolenia": "Training dashboard",
    "Ładuję...": "Loading...",
    "Włącz chat": "Enable chat",
    "Nieaktywni": "Deactivated",
    "Stwórz zlecenie z notatki": "Create an order from a note",
    "Nie udało się usunąć szablonu": "Failed to delete template",
    "Usuń kurs z ścieżki szkoleń": "Remove the course from the learning path",
    " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": "Elements to be completed are placed between the defined tags %$dowolna_name$%.",
    "Źródło rezerwacji": "Reservation source",
    "Zaznacz wszystkie w sekcji": "",
    "Nowe połączenie": "New connection",
    "Właściciele": "Owners",
    "Wczytuję...": "Loading...",
    "Regulamin został dodany.": "Regulations have been added.",
    "Publikuj do": "Publish to",
    "Zobacz trasę": "See the route",
    "Wybrane elementy zostały przeniesione.": "The selected items have been moved.",
    "Zamknięte przez użytkownika": "Closed by user",
    "Zapisz wersję slajdu": "Save slide version",
    "Kontrolki specjalizowane": "Specialized controls",
    "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "It indicates to search engine robots whether to follow the links.",
    "Dodaj paczkę SCORM": "Add SCORM package",
    "Dodawanie inwentaryzacji": "Inventory adding",
    "Wybierz osobę spoza dzielnicy": "Select a person from outside the neighborhood",
    "Stała wartość": "Constant value",
    "Data rejestracji": "Registration date",
    "Treści pytań są wymagane": "Questions are required",
    "Planuj automatycznie w dniu zakończenia blokady": "Schedule automatically on the day the lockdown ends",
    "Data opuszczenia zespołu": "Date of leaving the team",
    "Zamiany zostały zapisane.": "The changes have been saved.",
    "Brak przypisanych tagów.": "No tags assigned.",
    "Podano nieprawidłowe dane.": "Invalid data provided.",
    "Konserwacje": "Maintenance",
    "Dodatkowa kwota wynagrodzenia": "Additional amount of salary",
    "Pełny ekran": "Full screen",
    "Zacznij pisać aby wyszukać tag nieruchomości...": "Start typing to search property tag...",
    "Wstaw stronę": "Insert page",
    "Moje konto": "My account",
    "co się wydarzyło": "what happened",
    "Ilość łóżek jednoosobowe": "Number of single beds",
    "Wszystkie": "All",
    "Opublikowana": "Published",
    "Zwierzę": "Pet",
    "wybierz długość": "choose length",
    "Nieruchomość została zaktualizowana.": "The property has been updated.",
    "Dodaj klienta": "Add client",
    "Usunięte zadania": "Deleted tasks",
    "Owner Booking": "Owner Booking",
    "Nazwa paczki SCORM": "SCORM package name",
    "Co 3 miesiące": "Every 3 months",
    "Nie możesz rozpocząć obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "You cannot start handling this task because you are now performing a different task",
    "${item.text}": "${item.text}",
    "Wybrane": "Selected",
    "Rodzaj nieruchomości": "Type of property",
    "Co pół roku": "Semi-annually",
    "Nieruchomości robocze": "Working real estate",
    "Miasto apartamentu": "City of the apartment",
    "Podstawowe operacje na liczbach": "Basic digits operations",
    "W przyszłości": "In the future",
    "Wybrane pliki: {0}": "Selected files: {0}",
    "Zgłoszone problemy": "Reported issues",
    "odznacz wszystko": "unselect all",
    "Podążanie za linkami": "Links following",
    "Dodaj witrynę": "Add website",
    "Kalendarz": "Calendar",
    "Podana nazwa jest zajęta.": "The name you entered is already taken.",
    "Wysoki": "High",
    "Dobrze": "Good",
    "wybierz katalog": "select directory",
    "Materiał": "Material",
    "Wybrane kategorie": "Selected categories",
    "zacznij pisać aby wyszukać autora...": "start typing to search for an author...",
    "Statystyki pracownicze": "Employee statistics",
    "Sprzątanie": "Cleaning",
    "Udało się zaktualizować nieruchomości!": "Successfully updated the property!",
    "Inwentaryzacja została usunięta.": "Inventory has been removed.",
    "Wynagrodzenia w regionie łącznie z wynagrodzeniami koordynatorów": "Salaries in the region including salaries of coordinators",
    "Zaloguj się": "Log in",
    "Data informująca o terminie wejścia w życie tego regulaminu.": "The date informing about date of entry into force of these regulations.",
    "Edytuj dane wydziału": "Edit department data",
    "Pytanie 3": "Question 3",
    "Lista rozwijana": "Drop-down list",
    "Edycja slajdera": "Edit slider",
    "Ankiety": "Surveys",
    "Dni": "Days",
    "Potwierdź usunięcie": "Confirm deletion",
    "Przywróć oryginał": "Restore original",
    "Podziedziałek - Piątek": "Monday - Friday",
    "Godzina wymeldowania": "Check-out time",
    "Data i czas": "Date and time",
    "Jednokrotnego wyboru": "Single choice",
    "Nie podano opisu.": "No description is given.",
    "Id rezerwacji": "Booking Id",
    "Zmień widok": "Change view",
    "Dodanie kategorii": "Add category",
    "Suma wynagrodzeń pracowników": "Sum of employees' salaries",
    "Zmień ustawienia": "Change settings",
    "Powiązany artykuł": "Related article",
    "Wiadomości": "Messages",
    "Data modyfikacji do": "Date modified to",
    "Baza danych": "Database",
    "Główny Konserwator": "Chief Conservator",
    "Ilość sypialni": "Number of bedrooms",
    "Dzielnica została usunięta.": "The district has been removed.",
    "Publikacja aranżacji została wyłączona.": "The publication of the arrangement has been disabled.",
    "Kod pocztowy": "Postal code",
    "Do akceptacji": "To be accepted",
    "Tłumaczę...": "Translating...",
    "Rzeczywisty czas pracy": "Actual working time",
    "Dodaj wpis": "Add entry",
    "Edytuj wpis": "Edit post",
    "Zwiń": "Collapse",
    "Data rozpoczęcia": "Start date",
    "Dodane przez: ": "Added by: ",
    "Szkolenia": "Trainings",
    "Wiadomość została przywrócona.": "The message has been restored.",
    "Właściciel regionu": "Region owner",
    "Brak szczegółów zmian": "No change details",
    "Dostęp przyznany ręcznie": "Manually-granted access",
    "Wpisz tytuł...": "Enter a title...",
    "Uwaga! wraz z miastem": "Attention! together with the city",
    "Usunięto": "Removed",
    "Dodanie szkolenia": "Add training",
    "Profil został zaktualizowany.": "The profile has been updated.",
    "Nazwa:": "Name:",
    "Data dodania do": "Adding date to",
    "Wyszukaj albo dodaj nowy tag": "Search for or add a new tag",
    "Dostępne obiekty:": "Available objects:",
    "Dostępne moduły": "Available modules",
    "Ustawienia zostały zapisane.": "Settings have been saved.",
    "Attempt of reservation by Credit Card": "Attempt of reservation by Credit Card",
    "Czas uruchomienia": "Start-up time",
    "Premiera": "Premiere",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Save the route and send it to the driver?",
    "Zacznij pisać aby wyszukać regionu...": "Start typing to search for a region...",
    "Avantio ID": "Avantio ID",
    "Lekcja SCORM została zaktualizowana.": "The SCORM lesson has been updated.",
    "Zawierające jeden z wybranych tagów": "Containing one of the selected tags",
    "Co 3 godziny": "Every 3 hours",
    "Godziny": "Hours",
    "Edytuj stronę": "Edit page",
    "Zespół został usunięty.": "The team has been removed.",
    "Indeksowanie strony": "Page indexing",
    "Wybierz plik": "Select a file",
    "Tag został zaktualizowany.": "Tag has been updated.",
    "Dodanie zespołu": "Add team",
    "Przesuń do góry": "Move up",
    "Koszty": "Costs",
    "przejdź do komentarzy": "go to comments",
    "Wersje dokumentu": "Document versions",
    "Kategoria nadrzędna": "Parent category",
    "Dodanych plików %0 (limit wynosi %1).": "Added files %0 (limit is %1).",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Not all selected items have been transfered. You do not have the required permissions or, if you are moving directories, the destination directory is a subdirectory of the source directory. Directories and files that could not have been transfered remain in the Selected tab.",
    "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "Block configuration is not available because no template definition is provided.",
    "Zakończ zadanie": "End task",
    "Indywidualne tokeny": "Individual tokens",
    "Zacznij pisać aby wyszukać firmę...": "Start typing to search for a company...",
    "Nazwa firmy": "Company name",
    "Dodanie artykułu": "Add article",
    "Małe znaki": "Small characters",
    "Nie można usunąć swojego konta.": "You can't delete your account.",
    "Czas na slajd": "Time per slide",
    "Uwzględnij wydziały podrzędne": "Include sub-departments",
    "Kwota pozostała": "Remaining amount",
    "Paczka SCORM została dodana.": "The SCORM package has been added.",
    "Administracja - Role": "Administration - Roles",
    "Zadanie na trasie": "",
    "Ustawienia powiadomień zostały zapisane": "Notification settings have been saved",
    "Tekst": "Text",
    "Apple iPhone 6": "Apple iPhone 6",
    "Stan licznika koniec": "End counter status",
    "Plik został przeniesiony": "",
    "Brak powiązań": "No connection",
    "Dokument %0": "Document %0",
    "Opublikowany na stronach": "Published on pages",
    "Wpisz nazwę miasta...": "Enter the name of the city...",
    "Szkolenie zostało skopiowane": "Training has been copied",
    "Data zmiany statusu od": "Date of status change from",
    "Lista powiadomień": "Notification list",
    "Numer zadania": "Task number",
    "Formularz został dodany.": "The form has been added.",
    "co 3 miesiące": "every 3 months",
    "Brak odpowiedzi": "No response",
    "Litery": "Letters",
    "Data utworzenia": "Creation date",
    "Koniec dystansu": "End of distance",
    "Hasło użytkownika serwisowego": "Maintenace user password",
    "Data utworzenia od": "Creation date from",
    "Ustaw szerokości proporcjonalnie": "Set widths proportionally",
    "Zacznij pisać aby wyszukać tagi...": "Start typing to search for tags...",
    "Pokaż przycisk ``Wyślij``": "Show ''Send'' button",
    "Czeklisty": "Checklists",
    "Zadanie": "Task",
    "Uwzględniaj Dzielnice": "Include Districts",
    "Edycja wpisu": "Edit post",
    "Dołącz do czatu": "Join the chat",
    "Dodaj dane dostepowe...": "Add available data...",
    "Edycja miasta": "Edit a city",
    "Nie udało się przesłać plików": "",
    "Niestandardowy adres": "Non-standard address",
    "Ilość pracowników": "Number of employees",
    "Pasek postępu": "Progress bar",
    "Wyłączone (NoFollow)": "Off (NoFollow)",
    "Uzupełnij brakujące pola.": "Fill in the missing fields.",
    "Magazyn": "Storage",
    "Brak nowych wiadomości.": "No new messages.",
    "Podano nieprawidłowe dane": "Invalid data provided",
    "Brak stron": "No pages",
    "Dodane:": "Added:",
    "Pobierz Excel": "",
    "Nieobecny od": "Absent from",
    "Nazwa": "Name",
    "Back Office (BO)": "Back Office (BO)",
    "Lekcja może zawierać tylko materiały opisowe lub materiały video": "The lesson can contain only descriptive or video materials",
    "Wyświetl szczegóły": "Show details",
    "Podstawowe operacje warunkowe": "Basic conditional operations",
    "Nazwa kolumny z opisem": "Name of column with description",
    "Tag": "Tag",
    "Moduł": "Module",
    "Ostatnie 5 zadań": "Last 5 tasks",
    "Pilne": "Important",
    "*Koordynator zespołu posiada dostęp do panelu koordynatora": "*The team coordinator has access to the coordinator panel",
    "Opis źródła": "Source description",
    "Nazwisko klienta": "Customer name",
    "Zadanie zostało zapauzowane.": "The task has been paused.",
    "Wprowadzona wartość jest za krótka": "The value you entered is too short",
    "Lista użytkowników": "List of users",
    "Pokaż listę dostępnych tras": "Show list of available routes",
    "Wyszukaj tag...": "Search for a tag...",
    "Nazwa przedmiotu": "Item Name",
    "Przypisane:": "Assigned:",
    "Checklista": "Checklist",
    "Zapisz filtry": "Save filters",
    "Zostałeś zablokowany, dodanie wiadomości jest niemożliwe": "You have been blocked, adding a message is not possible",
    "Nie udało się dodać nieruchomość do trasy": "Failed to add property to route",
    "Zbliżająca się data zakończenia": "Upcoming end date",
    "Załącz plik excel": "Attach excel file",
    "Wybierz...": "Select...",
    "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "It indicates to search engine robots whether to index the page.",
    "Wybierz użytkownika": "Select a user",
    "Podlega ocenie": "To be graded",
    "Zaopatrzenie zostało usunięte.": "The supply has been removed.",
    "Nie udało się pobrać listy typów materiałów": "Failed to download material type list",
    "Historia zmian kosztu": "",
    "Prefix": "Prefix",
    "Użytkownik został dodany.": "The user has been added.",
    "Tak, przejdź do mapy": "",
    "Wynagrodzenia Koordynatorzy": "Coordinator salary",
    "Data wylogowania": "Logout date",
    "Usunięte przez użytkownika": "Deleted by user",
    "Adres email nadawcy": "Sender's email address",
    "Klient został dodany.": "The client has been added.",
    "Rola została usunięta.": "The role has been removed.",
    "Edycja klienta": "Edit client",
    "Wartości": "Values",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "Number of days from which the user will receive a notification",
    "Wczytuję...": "Loading...",
    "Zrób zdjęcie": "Take a picture",
    "Zdecydowanie nie": "Definitely no",
    "Koniec dystansu": "End of distance",
    "Zastępuje osobę": "Substituting",
    "Zawartość": "Content",
    "Nazwa bloku": "Block name",
    "Nazwa zadania": "Task name",
    "Domyślna": "Default",
    "Nazwa źródła danych": "Data source name",
    "Zastępstwa": "Substitutions",
    "Brak zadań": "No task",
    "Stwórz zadanie z tej rezerwacji": "Create a task from this booking",
    "Rozwiń do": "Expand to",
    "Przyznaj dostęp": "Grant access",
    "Dark mode": "Dark mode",
    "Wyświetl materiały": "View materials",
    "Klient aktywny": "Active client",
    "Zobacz czaty": "See chat",
    "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
    "Rola": "Role",
    "Strona została usunięta.": "The page has been deleted.",
    "Ładuję zgłoszenia...": "Loading submissions...",
    "Separator elementów w tytule": "Element separator in title",
    "Domyślna firma": "Default company",
    "Dodaj do zestawu": "Add to set",
    "Wklej komponent": "Paste component",
    "Odpowiedź 3": "Answer 3",
    "Przywrócić wiadomość?": "Restore a message?",
    "Zmień rozmiar": "Resize",
    "3": "3",
    "Strona nadrzędna": "Parent page",
    "Książka": "Book",
    "Zapisuję...": "I'm saving...",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "The title of the form cannot be longer than %0 characters",
    "Kolor obramowania": "Border color",
    "Laptop 15,6\"": "Laptop 15.6\"",
    "Podgląd szablonu e-maila": "Email template preview",
    "Nadpisz kwotę dla": "Overwrite the amount for",
    "Filtry kalendarza": "Calendar filters",
    "Województwo": "Province",
    "Data modyfikacji": "Modification date",
    "Wymagane jest wybranie sekcji": "A section must be selected",
    "Sekcja": "Section",
    "Sortowanie malejąco": "Sort descending",
    "Nie udało się pobrać tras": "Failed to download routes",
    "Typ": "Type",
    "Najwyższy": "Highest",
    "Czy na pewno chcesz zablokować użytkownika?": "Are you sure you want to block a user?",
    "Przenieś niżej": "Move lower",
    "Kwota za godzinę": "Pay per hour",
    "Edycja zadania": "Edit a task",
    "Kategoria jest wymagana": "Category is required",
    "Potwierdź publikację wersji": "Confirm version publication",
    "Potwierdzenie usunięcia.": "Deletion confirmation",
    "Zaokrąglenie": "Rounding",
    "Wprowadzona wartość jest za długa": "The value you entered is too long",
    "Edytuj zlecenie": "Edit Order",
    "Treść": "Content",
    "Bez \"http(s)://\" i \"/\" na końcu.": "No \"http(s)://\" and \"/\" at the end.",
    "Nie znaleziono żadnych plików": "No files found",
    "Usuń powiązanie": "Unlink",
    "Użytkownicy w tej roli": "Users in this role",
    "Został przywrócony oryginalny harmonogram": "The original schedule has been restored",
    "Zaakceptuj, wyślij": "Accept, send",
    "treść notatki": "contents of the note",
    "Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\".": "Please save the progress of the work and click the “Update” button.",
    "Przypisz obiekty": "Assign objects",
    "Zacznij pisać aby wyszukać dzielnicę...": "Start typing to search for a neighborhood...",
    "Poprawna odpowiedź": "Correct answer",
    "Sypialnia": "",
    "Edycja nowej trasy": "Edit a new route",
    "Następna strona": "Next page",
    "Dodanie regulaminu": "Add regulations",
    "Przypisane zadanie:": "Assigned task:",
    "Harmonogram zadań": "Task schedule",
    "Lista Tras:": "List of routes:",
    "Opis certyfikatu": "Certificate description",
    "Ścieżka aktywnej strony": "Path of the active page",
    "Potwierdzenie ukrycia": "Hiding confirmation",
    "Slajder": "Slider",
    "Kwota łącznie": "Total amount",
    "Nie masz uprawnień do modyfikacji aranżacji.": "You do not have permission to modify the arrangement.",
    "Data wydania": "Release date",
    "Zadanie zostało ukończone.": "The task is complete.",
    "Wyświetlanie": "Displaying",
    "Uwzględniaj dzielnice": "Include Districts",
    "Numer inwentaryzacji": "Inventory number",
    "Brak sekcji multimediów": "",
    "Kosz": "Recycle bin",
    "Dodanie poradnika": "Add guide",
    "Kierowca": "Driver",
    "Zajęte": "Occupied",
    "Brak zmian": "No changes",
    "Edycja działu": "Edit department",
    "Porównania": "Comparison",
    "Informacje podstawowe": "Basic information",
    "Nieobecność": "Absence",
    "Dodanie nieruchomości": "Add a property",
    "Nie udało się pobrać listy serwerów plików": "Failed to download the file server list",
    "Ilość dostępnych bloków": "Number of available blocks",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "No assigned users to the learning path.",
    "Kontener plików": "File container",
    "Kalendarz - Kategorie zasobów": "Calendar - Resource Categories",
    "Opublikowane wersje językowe.": "Published language versions.",
    "Dodaj kolor": "Add color",
    "Do kogo chcesz napisać?": "Who do you want to write to?",
    "Statystyki wniosków": "Request statistics",
    "Wstaw treść widoczną po rozwinięciu": "Insert content visible when expanded",
    "Wynagrodzenie za konserwację": "Maintenance pay",
    "Kod Google Webmaster": "Google Webmaster Code",
    "Domyślna": "Default",
    "od": "from",
    "co 6 miesięcy": "every 6 months",
    "Wybierz paczkę": "Select a package",
    "Wstaw z dołu": "Insert from below",
    "Ustawienia powiadomień": "Notification settings",
    "Pokaż zdjęcia": "Show photos",
    "FavIcona": "FavIcona",
    "Region": "Region",
    "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "The number of slides visible to the user cannot be greater than the number of slides added in the panel.",
    "Dostęp do szkoleń:": "Access to training:",
    "Miniaturki": "Thumbnails",
    "Nowy materiał": "New material",
    "Zastosuj": "Apply",
    "Dodanie klienta": "Add client",
    "Nazwa szablonu": "Template name",
    "Czy jesteś pewien? ": "Are you sure? ",
    "Wyświetlam": "Displaying",
    "Checklista została usunięta": "Checklist has been removed",
    "Identyfikator publiczny": "Public ID",
    "Slajdery": "Sliders",
    "Nazwa kategorii": "Category name",
    "Liczba miast w regionie": "Number of cities in the region",
    "Kontrolki podstawowe": "Basic controls",
    "Tydzień": "Week",
    "Usuń katalog": "Delete directory",
    "Podtytuł": "Subtitle",
    "Codziennie": "Every day",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "The title of the form cannot be longer than %0 characters",
    "Rozpoczęto synchronizację rezerwacji": "Booking synchronization started",
    "Adres URL": "URL address",
    "Dodaj notatkę/komentarz": "",
    "Szablony": "Templates",
    "Typ źródła danych": "Data source type",
    "Zobacz czaty": "See chat",
    "Housekeeping (HK)": "Housekeeping (HK)",
    "Klienci": "Clients",
    "Zacznij pisać aby wyszukać inspektora...": "Start typing to search for an inspector...",
    "Przybornik": "Kit",
    "Angielski": "English",
    "Nie możesz zapisać zmian, gdyż liczba elementów nie może być mniejsza niż ustawiona liczba wymaganych elementów w zakładce ustawienia testu": "You cannot save changes because the number of elements cannot indicate less than the set number of required elements in the test settings tab",
    "Zamknięte": "closed",
    "Pokaż zaplanowane punkty": "Show scheduled points",
    "Opis kosztu": "",
    "ID nazwa obiektu": "ID property name",
    "Zacznij pisać aby wyszukać nieruchomość...": "Start typing to search for a property...",
    "Odrzucone zgody": "Rejected consents",
    "Witryny": "Sites",
    "Zadanie zostało zaktualizowane.": "The task has been updated.",
    "Kwota opłacona od": "Amount paid from",
    "Pole zawiera": "Field contains",
    "Pole \"Imię\" jest wymagane.": "''Name'' is required.",
    "Koniec długości geograficznej użytkownika": "End of user longitude",
    "TAK": "YES",
    "Pokaż nieruchomości (bez zadań i rezerwacji)": "Show properties (without tasks and reservations)",
    "Zadanie zostało usunięte": "The task has been deleted",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "You do not have the required permissions to perform the selected operation.",
    "Numer mieszkania": "Apartment number",
    "Numer telefonu: ": "Phone number: ",
    "Zamknij": "Close",
    "Statystyki regionalne - regiony": "Regional statistics - regions",
    "Tryb konserwacji systemu": "System maintenance Mode",
    "Przyrostek": "Suffix",
    "Numer sesji": "Session number",
    "Notatka": "Memo",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "",
    "Konfiguracja bloku": "Block configuration",
    "Brak dostępnych tras": "No routes available",
    "Statystyki kosztów w obiektach": "Properties cost statistics",
    "Stwórz czat z rezerwacji": "Create chat from reservation",
    "Klient został usunięty.": "The client has been deleted.",
    "Zawiera": "Contains",
    "Krótki tytuł": "Short title",
    "Opis zespołu": "Team description",
    "Krzesełko": "Chair",
    "Serwer bazy danych": "Database server",
    "Wynagrodzenia Kierowcy": "Drivers salary",
    "Adres e-mail potwierdzony": "The email address has been confirmed",
    "Podanie nazwy jest wymagane.": "Name is required.",
    "Data dodania od": "Adding date from",
    "Ilość osób": "Number of people",
    "Nazwisko": "Last name",
    "Wartość 0 oznacza brak limitu": "A value of 0 indicates no limit",
    "Szablon został dodany.": "The template has been added.",
    "NIE": "NO",
    "Data uruchomienia": "Launch date",
    "Wyszukaj zespół": "Search teams",
    "Paczka SCORM została zaktualizowana.": "The SCORM package has been updated.",
    "Co 5 dni": "Every 5 days",
    "Daty publikacji zostały zaktualizowane.": "The publication dates have been updated.",
    "Urlopy": "Absences",
    "Stopka": "Footer",
    "Aranżacja została opublikowana.": "The arrangement has been published.",
    "Rozliczenia": "Settlements",
    "Nie wiem": "I don't know",
    "Historia lokalizacji": "Location History",
    "Nigdy": "Never",
    "Nie udało się pobrać listy szablonów": "Failed to download template list",
    "Wersja utowrzona przez": "Version created by",
    "Kategoria szkolenia": "Training category",
    "Lista szkoleń": "Training list",
    "Ukryj": "Hide",
    "Wykonawca": "Artist ",
    "Profil koordynatora": "Coordinator profile",
    "Edytuj aranżację": "Edit arrangement",
    "Wybierz miasta": "Select cities",
    "Moduły": "Modules",
    "Przeniesienie wybranych elementów": "Transfer selected items",
    "Link do zewnętrznej strony": "Link to external site",
    "Data zakońćzenia": "End date",
    "Wystąpił błąd podczas zapisywania ustawień": "An error occurred while saving settings",
    "Ukryj podczas dodawania zadania": "Hide when adding a task",
    "Tytuł aktywnej witryny": "Title of the active site",
    "Czerwiec": "June",
    "Osoba odpowiedzialna": "Responsible person",
    "Usunął": "Deleted",
    "Zacznij pisać aby wyszukać nieruchomość roboczą...": "Start typing to search for a working property...",
    "Eksportuj do PDF": "Export to PDF",
    "Zlecenie na nieruchomość roboczą": "Order for working real estate",
    "Kolejność punktów trasy została zaktualizowana": "The order of the route points has been updated",
    "Obsługa Właściciela (OW)": "Owner Service (OW)",
    "Dozwolone rozszerzenia": "Allowed extensions",
    "Tag nieruchomości": "Property tag",
    "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "Provide Facebook user IDs, separated by commas, so they can access to their statistics (Facebook Insights).",
    "Blokada konta": "Account blocked",
    "Status paczki został zmieniony.": "The status of the package has been changed.",
    "Usuń ze szkolenia": "Remove from training",
    "Dokument został dodany.": "Document has been added.",
    "Wymagaj odpowiedzi, aby przejść dalej": "Require a response to move on",
    "Typ nieobecności": "Absence type",
    "Następna inwentaryzacja": "Next inventory",
    "Tylko do odczytu": "Read-only",
    "Bardzo dobrze": "Very good",
    "Struktura serwisu": "Site structure",
    "W organizacji nie ma jeszcze żadnych działów.": "There are no sections in the organization yet.",
    "Trasa została usunięta": "The route has been removed",
    "Nr nieruchomości Avantio": "Property no. Avantio",
    "Imię i Nazwisko": "First name and last name",
    "Ważność": "Validity",
    "Pracownik": "Employee",
    "Dokument został zaktualizowany.": "The document has been updated.",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. The requested resource was not found.",
    "W zespole od %0 do %1": "In Team from %0 to %1",
    "To pole jest wymagane": "The field is required",
    "Dodanie paczki SCORM": "Add SCORM package",
    "Wynagrodzenia od ilości posprzątanych obiektów": "Salary based on the number of cleaned properties",
    "OW": "Owner Service",
    "(AirBnb) Wysłano żądanie do gościa": "(AirBnb) A request has been sent to the guest",
    "Data pauzy": "Pause Date",
    "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "The channel is required by default. It is not possible to stop sending a notification through this channel. It is only possible to change the title and content of the message.",
    "Wysłano kolejne wezwanie do zapłaty": "Another payment request sent",
    "Zastępstwo zostało usunięte.": "The substitution has been removed.",
    "Wklej komponent": "Paste component",
    "Przeterminowane": "Overdue",
    "Procent": "Percentage",
    "Rezerwacje": "Reservations",
    "Zacznij pisać aby wyszukać tag...": "Start typing to search for tag...",
    "Data do": "Date to",
    "Oznacz widoczne jako przeczytane": "Mark visible as read",
    "Dzisiaj": "Today",
    "Szczegóły zmian": "Details of changes",
    "Zakończone: ${$filters.datetime(task.dateCompleted)}": "Completed: ${$filters.datetime(task.dateCompleted)}",
    "Nazwa lekcji": "Lesson name",
    "Użytkownik Inspekcja": "User Inspection",
    "Typ słownika": "Dictionary type",
    "Zablokuj użytkownika": "Block user",
    "Data użycia": "Date of use",
    "Typ zadania": "Task type",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą klienta": "People assigned as default to customer service tasks",
    "Pytanie 1": "Question 1",
    "Nieważne": "Not important",
    "Sekcja została zaktualizowana": "",
    "Kontrolka wyboru (pojedynczy wybór)": "Choice control (single choice)",
    "Kolor został zaktualizowany": "Color has been updated",
    "Lekcja została dodana.": "The lesson has been added.",
    "Kwiecień": "April",
    "Kanały obsługiwane przez wybrany typ powiadmienia": "Channels supported by the selected notification type",
    "Region został dodany.": "The region has been added.",
    "Usunięto przez: ": "Removed by: ",
    "Komunikat błędu": "Error message",
    "Typ Nieruchomości": "Property Type",
    "Classic mode": "Classic mode",
    "Strona %0": "Page %0",
    "Pokaż rezerwacje właścicielskie": "Show owner reservations",
    "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "The arrangement configuration is not available because no template definition is provided.",
    "nie wymuszaj zmiany hasła": "do not force password change",
    "Nazwa pliku została zmieniona.": "The file has been renamed.",
    "Nazwa użytkownika serwisowego": "Maintenance user name",
    "Nadpisz kwotę dla": "Overwrite the amount for",
    "Konfiguracja domyślna": "Default configuration",
    "Edytuj lekcje": "Edit lessons",
    "Aby wysłać wiadomość, dołącz do czatu": "To send a message, join the chat",
    "Plik został wysłany": "The file has been sent",
    "Nazwa regionu": "Region name",
    "Tytuł": "Title",
    "Edycja nieruchomości roboczej": "Editing a working property",
    "Uwzględnij dodatkowe nieruchomości": "Include additional properties",
    "Rezerwacja": "Reservation",
    "Admin": "Adminul",
    "Cena PLN": "Price PLN",
    "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "This channel does not provide a possibility to send formatted text.",
    "Administracja - Województwa": "Administration - Voivodships",
    "Pokaż punkty bez kierowcy": "Show points without driver",
    "Nie udało się pobrać listy kategorii": "Failed to download category list",
    "Materiały szkoleniowe": "Training materials",
    "Przypomnij": "remind",
    "Typ źródła": "Source type",
    "Domyślna firma": "Default company",
    "Czy jesteś pewien, że chcesz przypisać dzielnicę do nowego miasta? Wszystkie nieruchomości i użytkownicy przypisani do tej dzielnicy przestaną być do niej przypisani.": "Are you sure you want to assign a district to a new city? All properties and users assigned to this district will no longer be assigned to it.",
    "Wyślij link": "Send link",
    "Dostęp niezdefiniowany": "Undefined access",
    "Na wniosek": "On request",
    "Od ilości posprzątanych obiektów": "By the number of cleaned properties",
    "Aktualności": "News",
    "Przenieś": "Move",
    "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "When you select this option, individual and role permissions will not be considered.",
    "Zadanie do wykonania": "Task to be done",
    "Pole wymagane": "Field required",
    "Maj": "May",
    "Dane formularza są przechowywane w obiekcie Entry.": "The form data is stored in the Entry object.",
    "Pliki publiczne": "Public files",
    "Zaakceptowane, zapisz": "Accepted, save",
    "Symbol klienta": "Customer symbol",
    "Dodaj zespół": "Add team",
    "Dodanie lekcji": "Add lesson",
    "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Field ''%0'' does not contain a valid email address.",
    "Kwota netto": "",
    "Korytarz": "",
    "Numer dowodu osobistego": "ID card number",
    "W trakcie": "In progress",
    "Użytkownik został przypisany do szkolenia.": "The user has been assigned to the training.",
    "Skopiuj szkolenie": "Copy training",
    "Piosenka": "Song",
    "Edytuj datę dostępu": "Edit access date",
    "Ostatnia wiadomość - data": "Last message - date",
    "Wybrane regulaminy: ": "Selected regulations: ",
    "Sprawdzić": "Check",
    "Dodaj nowy tag": "Add a new tag",
    "Zatwierdź": "submit",
    "Nie udało się pobrać listy ról": "Failed to download role list",
    "kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)": "when is it supposed to happen (when we can visit the apartment)",
    "Wynagrodzenia Pracownicy": "Employees salary",
    "Pytania": "Questions",
    "Pobierz raport": "Download the report",
    "Sesja": "Session",
    "Treść wiadomości": "Message content",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą właściciela": "People assigned as default to tasks related to the owner service",
    "Przeczytane": "Read",
    "Użytkownik i jego wiadomości zostały przywrócone.": "The user and their messages have been restored.",
    "Serwer został dodany.": "Server has been added.",
    "Booking with conflict": "Booking with conflict",
    "Usuń zestaw": "Delete set",
    "Otwórz Ustawienia": "Open settings",
    "Obciążenie Renters": "Charge Renters",
    "Brak zadań do wyświetlenia": "No tasks to display",
    "Rozwiń/Zwiń": "Expand/Collapse",
    "Dodane przez moje zespoły": "Added by my teams",
    "Typ wynagrodzenia został usunięty": "Salary type has been deleted",
    "Sesja użytkownika": "User's session",
    "Tekst zastępczy": "Substitute text",
    "Dodaj użytkownika": "Add user",
    "Dodaj Notatkę": "Add a note",
    "Zadanie wykonuje": "The task performs",
    "Pokaż historię": "Show history",
    "Edycja paczek SCORM": "Edit SCORM packages",
    "Dodaj certyfikat": "Add certificate",
    "Resetowanie podejść": "Reset approaches",
    "Piątek": "Friday",
    "Aktualne hasło": "Current password",
    "Kolor został usunięty": "The color has been removed",
    "Maksymalna ilość plików": "Maximum number of files",
    "Dodaj dział": "Add section",
    "Włącz monitorowanie aktywności": "Turn on activity monitoring",
    "Średnie wynagrodzenie": "Average salary",
    "Wybierz temat": "Select a topic",
    "Nie udało się usunąć zlecenia.": "Failed to delete order.",
    "Edycja checklisty": "Edit checklist",
    "Zespół aktywny": "Active team",
    "Nr rezerwacji": "Reservation No",
    "Batch": "Batch",
    "Historia nieruchomości": "History of the property",
    "Zaopatrzenie zostało dodane.": "Supplies have been added.",
    "Wybrane elementy zostały usunięte.": "The selected items have been removed.",
    "Dodaj": "Add",
    "Dodaj chat": "Add chat",
    "Typ materiału": "Material type",
    "Top mieszkań generujacych najwięcej kosztów": "Top costs by apartments",
    "Sesja nr %0": "Session No . %0",
    "Dodanie slajdera": "Add slider",
    "Procent obciążeń": "Percentage of loads",
    "Stan licznika start": "Start counter status",
    "Id modelu: %0": "Model Id: %0",
    "Do kogo wysłać testowe powiadomienie": "To whom to send the test notification",
    "Zespół został zaktualizowany.": "The team has been updated.",
    "Wybierz paczkę SCORM": "Select the SCORM package.",
    "Dzielnice": "Districts",
    "Dodanie dzielnicy": "Adding a District",
    "Stwórz zadanie": "",
    "Standardowa strona": "Standard page",
    "Wielokrotny wybór": "Multiple choice",
    "To miasto znajduję się już w tym regionie.": "This city is already in this region.",
    "Pseudonim": "Pseudonym",
    "Minimum": "Minimum",
    "Nr rezerwacji:": "Booking no:",
    "Ustawienia domyślne": "Default settings",
    "Ostatnie sprzątanie": "Last cleaning",
    "Dodaj Koszt": "Add cost",
    "Dodaj zestaw": "Add set",
    "Usuń wybrane": "Delete selected",
    "Ten region jest już przypisany do użytkownika.": "This region is already assigned to the user.",
    "Źródło": "Source",
    "Nie wypełniono poprzedniego wiersza.": "The previous line was not filled in.",
    "Status zadania": "Task Status",
    "Nazwa aktywnej strony": "Active page name",
    "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Select a canonical address from the list or enter it manually.",
    "Aranżacja": "Arrangement",
    "Dostęp od": "Access from",
    "Godzina trasy": "Hour of the route",
    "Ścieżka szkoleniowa została usunięta.": "The learning path has been removed.",
    "Program szkolenia": "Training program",
    "Dzielnica": "borough",
    "Tłumacz": "Translate",
    "W polu możemy umieszczać jedynie cyfry": "In the field we can only put numbers",
    "Edytuj zadanie": "Edit task",
    "Nadpisanie kwoty wynagrodzenia zostało dodane.": "Overwriting the salary amount has been added.",
    "Zameldowanie": "Check-in",
    "Monitor kolejek": "Queue monitor",
    "Zawiera sekcje": "Contains sections",
    "Konto aktywne": "Active account",
    "Usuń stronę": "Delete page",
    "Pojedynczy wybór": "Single choice",
    "Dodaj lekcję": "Add lesson",
    "Zacznij pisać aby wyszukać użytkownika...": "Start typing to search for a user...",
    "dzień temu": "a day ago",
    "Niewidoczne": "Not visible",
    "Filtry systemowe": "System filters",
    "Szkolenie zostało zaktualizowane.": "The training has been updated.",
    "Opis sekcji": "Section description",
    "Imię właściciela": "Owner's name",
    "Krótki tytuł": "Short title",
    "Opis certyfikatu": "Certificate description",
    "Szczegóły zmiany": "Details of the change",
    "Lewy panel": "Left panel",
    "Dodaj media": "Add media",
    "Nieobecność do": "Absence until",
    "Nie udało się zapisać komentarza": "",
    "Host główny": "Main host",
    "Dodaj pliki": "Add files",
    "Dodaj sekcję": "Add section",
    "Edytuj sekcję": "Edit section",
    "Sekcja została utworzona": "Section has been created",
    "Sekcja została zaktualizowana": "Section has been updated",
    "Sekcja została usunięta": "Section has been deleted",
    "Sekcja nie została znaleziona": "Section not found",
    "Typ pomieszczenia jest wymagany": "Room type is required",
    "Typ plików jest wymagany": "",
    "Wybierz pliki do dodania": "Select files to add",
    "Pliki zostały dodane": "Files have been added",
    "Pliki zostały pobrane": "Files have been downloaded",
    "Plik został przeniesiony": "File has been moved",
    "Brak sekcji multimediów": "No media section",
    "Czy na pewno chcesz usunąć tę sekcję?": "Are you sure you want to delete this section?",
    "Zaznacz wszystkie w sekcji": "Select all in section",
    "Brak plików w sekcji": "No files in this section",
    "Wybierz sekcję": "Select section",
    "Brak sekcji - najpierw utwórz sekcję": "No section – create a section first",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "To add files, you must first create a section.",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "The selected section accepts only files of type: {0}",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "The selected files are of type {0}, and the section accepts only {1}",
    "Wybierz sekcję, do której chcesz dodać pliki": "Select the section to which you want to add files",
    "Sekcja jest wymagana": "Section is required",
    "Wybrana sekcja nie istnieje": "The selected section does not exist",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "You cannot add files of different types at the same time. Select files of the same type.",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "Cannot add files of type {0} to a section of type {1}",
    "Nie udało się przesłać plików": "Failed to upload files",
    "Budynek": "Building",
    "Pokój dzienny": "Living room",
    "Sypialnia": "Bedroom",
    "Kuchnia": "Kitchen",
    "Łazienka": "Bathroom",
    "Korytarz": "Hallway",
    "Typ pomieszczenia": "Room type",
    "Nie znaleziono nieruchomości": "Property not found",
    "Nie udało się załadować plików": "Failed to load files",
    "Usuń zaznaczone": "Delete selected",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "Are you sure you want to delete the selected files?",
    "Pliki zostały usunięte": "Files have been deleted",
    "Nie można przenosić plików między sekcjami o różnych typach": "Files cannot be moved between sections with different types",
    "Pliki zostaną automatycznie dodane do odpowiednich sekcji 'Inne' na podstawie typu pliku.": "Files will be automatically added to the appropriate 'Other' sections based on the file type.",
    "Pliki": "Files",
    "Dane kosztu": "Cost data",
    "Nazwa kosztu": "Cost name",
    "Opis kosztu": "Cost description",
    "Kwota brutto": "Gross amount",
    "Kwota netto": "Net amount",
    "VAT (wyliczany automatycznie)": "VAT (calculated automatically)",
    "VAT": "VAT",
    "Historia zmian kosztu": "Cost change history",
    "Brak historii zmian": "No change history",
    "Wersja": "Version",
    "Koszt został dodany.": "The cost has been added.",
    "Koszt został zaktualizowany.": "The cost has been updated.",
    "Pobierz Excel": "Download Excel",
    "Koszt został usunięty": "The cost has been deleted",
    "Excel został wygenerowany i wysłany na adres e-mail": "The Excel file has been generated and sent to the email address",
    "Materiały": "Materials",
    "Koszt pracownika": "Employee cost",
    "Dane z VROS": "VROS data",
    "Parking": "Parking",
    "Wi-Fi": "Wi-Fi",
    "Router": "Router",
    "Nazwa sieci": "Network name",
    "Instrukcje": "Instructions",
    "Instrukcje zameldowania": "Check-in instructions",
    "Instrukcje wymeldowania": "Check-out instructions",
    "Przewodnik gościa": "Guest guide",
    "Kod do skrytki na klucze": "Key box code",
    "Godzina zameldowania (Guesty)": "Check-in time (Guesty)",
    "Godzina końca zameldowania (Guesty)": "Check-in end time (Guesty)",
    "Godzina wymeldowania (Guesty)": "Check-out time (Guesty)",
    "Hiszpański": "Spanish",
    "Brak wybranej firmy": "No company selected",
    "Lista kosztów": "Cost list",
    "Akceptacja kosztów": "Cost approval",
    "Recenzje sprzątaczy": "Cleaner reviews",
    "Przekroczono czas oczekiwania na odpowiedź serwera lub połączenie zostało anulowane.": "The waiting time for the server response has been exceeded or the connection was canceled.",
    "Tylko Administrator lub ExternalManager może tworzyć nowe konta": "Only Administrator or ExternalManager can create new accounts.",
    "Kwota dodatkowego wynagrodzenia nie może być ujemna": "The amount of additional salary cannot be negative",
    "Nazwa czynności": "Activity name",
    "Dodaj czynność": "Add activity",
    "Liczba czynności": "Number of activities",
    "Dodaj kategorię zadań": "Add task category",
    "Obsługa właścicieli": "OW",
    "Edycja kategorii zadań": "Edit task category",
    "Edycja czynności": "Edit activity",
    "Brak wydziału": "No department",
    "Zacznij pisać aby wyszukać czynność...": "Start typing to search for an activity...",
    "Czynność została zaktualizowana.": "Activity has been updated.",
    "Czynność została usunięta.": "Activity has been deleted.",
    "Czynność została dodana.": "Activity has been added.",
    "Nie można dodać tej czynności do zadania.": "This activity cannot be added to the task.",
    "Przypisane czynności": "Assigned activities",
    "Brak przypisanych czynności.": "No activities assigned.",
    "Kategorie zadań": "Task categories",
    "Czynności zadań": "Task activities",
    "czynności": "activities",
    "usunięta": "deleted",
    "Komentarz (opcjonalny)": "Comment (optional)",
    "Formularz zadania nie jest poprawny.": "The task form is invalid.",
    "Biblioteka czynności": "Activity library",
    "Szukaj czynności": "Search activities",
    "Wszystkie statusy": "All statuses",
    "Przenieś na samą górę": "Move to top",
    "Przenieś na sam dół": "Move to bottom",
    "Widoczna w zadaniach": "Visible in tasks",
    "Czynność jest widoczna w zadaniach.": "The activity is now visible in tasks.",
    "Czynność została ukryta w zadaniach.": "The activity has been hidden from tasks.",
    "Edytuj kategorię": "Edit category",
    "Edytuj czynność": "Edit activity",
    "Nowa czynność": "New activity",
    "Kolejność została zapisana.": "The order has been saved.",
    "Nie udało się zapisać kolejności.": "Failed to save the order.",
    "Przypisana do działu": "Assigned to department",
    "Przypisana do kategorii": "Assigned to category",
    "Np. wymiana okien": "E.g. window replacement",
    "Użyta w": "Used in",
    "%0 zadaniach": "%0 tasks",
    "Zmiana nazwy nie zmieni istniejących zadań.": "Renaming it won't change existing tasks.",
    "Upewnij się, że nazwa czynności:": "Make sure the activity name:",
    "Nie zawiera literówek": "Has no typos",
    "Jest jasna, klarowna i precyzyjna": "Is clear and precise",
    "Zawiera polskie znaki": "Uses Polish characters",
    "Aktywna w nowych zadaniach": "Active in new tasks",
    "Czynność „Inne” (pokazuje pole komentarza w aplikacji mobilnej)": "“Other” activity (shows a comment field in the mobile app)",
    "Czynności nigdy nie są usuwane, można je tylko dezaktywować": "Activities are never deleted, they can only be deactivated",
    "Np. Hydraulika": "E.g. Plumbing",
    "Przeciągnij, aby zmienić kolejność działów": "Drag to change the order of departments",
    "Zameldowanie / Wymeldowanie": "Check-in / Check-out",
    "Media": "Utilities",
    "Dostawca": "Provider",
    "Inwentarz": "Inventory",
    "Komfort": "Comfort",
    "Dodatki": "Extras",
    "A/C": "A/C",
    "Ogrzewanie centralne": "Central heating",
    "Kanapa": "Couch",
    "Zaciemnienie": "Blackout",
    "Grzejniki": "Heaters",
    "Bojler": "Boiler",
    "Pościel": "Linens",
    "TV": "TV",
    "Suszarka do ubrań": "Dryer",
    "Suszarka do włosów": "Hair dryer",
    "Żelazko": "Iron",
    "Piekarnik": "Oven",
    "Kuchenka mikrofalowa": "Microwave oven",
    "Czajnik": "Kettle",
    "Dzbanek na wodę": "Water jug",
    "Środki czystości": "Cleaning supplies",
    "Pralka": "Washing machine",
    "Suszarka na pranie": "Drying rack",
    "Lampki nocne": "Night lamps",
    "Deska do prasowania": "Ironing board",
    "Kuchenka": "Stove",
    "Toster": "Toaster",
    "Zmywarka": "Dishwasher",
    "Odkurzacz": "Vacuum cleaner",
    "Ekspres do kawy": "Coffee machine",
    "Apteczka": "First aid kit",
    "Czujnik CO2": "CO2 detector",
    "Gaśnica": "Fire extinguisher",
    "Czujnik dymu": "Smoke detector",
    "Przyjazne zwierzętom": "Pet friendly",
    "Widok": "View",
    "Prąd": "Electricity",
    "Ogrzewanie": "Heating",
    "Woda": "Water",
    "Gaz": "Gas",
    "Internet": "Internet",
    "Dane zostały zapisane.": "Data has been saved.",
    "Piętro": "Floor",
    "Winda": "Elevator",
    "Balkon": "Balcony"
  },
  "uk-UA": {
    "Ulubione": "Обране",
    "Dodaj do ulubionych": "Додати до обраного",
    "Usuń z ulubionych": "Видалити з обраного",
    "Wybierz typ Firmy": "Виберіть тип компанії",
    "Zacznij pisać aby wyszukać dzielnice...": "Почніть писати для пошуку районів....",
    "Co godzinę": "Щогодини",
    "Autor notatki": "Автор замітки",
    "Ten użytkownik już jest przypisany do czatu": "Цей користувач вже призначений до чату",
    "Zlecenia": "Замовлення",
    "Otwórz czat - link": "Відкрити чат - посилання",
    "Na żądanie działu": "За бажанням кафедри",
    "W każdy dzień tygodnia": "Кожен день тижня",
    "Rozwiń": "Розширити",
    "Budynek": "",
    "Nieobecność do": "Відсутність до",
    "Wybierz pliki (do {0})": "Виберіть файли (до {0})",
    "Co 2 godziny": "Кожні 2 години",
    "Moja trasa": "Мій маршрут",
    "Dodanie źródła danych": "Додавання джерела даних",
    "5 ostatnich zadań": "5 останніх завдань",
    "Eksportuj do Excel": "Експортуйте до Excel",
    "Przypisana do (Imię i Nazwisko)": "Призначено (ім'я та прізвище)",
    "Zmniejsz": "Зменшити",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "",
    "Data Wykonania": "Дата Виконання",
    "Dodaj kategorię": "Додати категорію",
    "Dział został zaktualizowany.": "Розділ оновлено.",
    "Klient aktywny": "Активний клієнт",
    "Wprowadzona wartość jest nieprawidłowa": "Введене значення невірно",
    "Szablon checklisty": "Шаблон чек-листа",
    "Tak/Nie": "Так/Ні",
    "Dodanie nieruchomości roboczej": "Додавання робочої нерухомості",
    "Nazwa taga": "Назва тегу",
    "Edytuj koszt": "",
    "Wybrana dzielnica": "Вибраний район",
    "Nazwa użytkownika": "Ім'я користувача",
    "Kolejka": "Черга",
    "Wartości": "Цінності",
    "Zastępstwo wygaśnie za minutę.": "Термін дії заміни закінчиться через хвилину.",
    "Token został usunięty.": "Токен видалено.",
    "Pomyślnie dołączono do czatu": "Успішно приєднався до чату",
    "Początek szerokości geograficznej użytkownika": "Початок широти користувача",
    "Edycja zespołu": "Редагування команди",
    "Miasto": "Місто",
    "Zakończone przez: ": "Завершено: ",
    "Nie możesz wznowić obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "Ви не можете повернутися до цього завдання, оскільки зараз виконуєте інше завдання",
    "Posprzątane": "Прибрано",
    "Pokaż czaty": "Покажи чати",
    "Stwórz zadanie z tej rezerwacji": "Створіть завдання з цього бронювання",
    "Usunięcie wybranych elementów": "Видалення виділених елементів",
    "Zapisuję...": "Записую...",
    "Zdecydowanie nie": "Однозначно ні",
    "Notatka została zaktualizowana.": "Примітка була оновлена.",
    "Ważne": "Важливо",
    "Maksymalny rozmiar pliku w MB": "Максимальний розмір файлу в Мб",
    "Stawka wynagrodzenia została zaktualizowana.": "Ставка заробітної плати актуалізована.",
    "Statystyki wyniosków": "Статистика висновків",
    "Lista plików": "Список файлів",
    "UWAGA! Ta tabela pokazuje tylko przeterminowane zadania, filtr \"STATUS\" nie jest aktywny. Wróć do \"Wszystkie zadania\" aby mieć dostępne wszystkie filtry": "Увага! У цій таблиці показані лише прострочені завдання, фільтр \"СТАТУС\" не активний. Поверніться до \"УСІ ЗАВДАННЯ\" щоб мати всі фільтри",
    "Usuń plik": "Видалити файл",
    "Dział:": "Відділ:",
    "Nazwa katalogu lub pliku": "Назва каталог або файлу",
    "Utworzono kopię checklisty": "Створена копія контрольного списку",
    "Użytkownik Obsługa": "Сервіс користувача",
    "Zapisz zmiany": "Зберегти зміни",
    "Zastępstwo zostało zaktualizowane.": "Заміна оновлена.",
    "Polska": "Польща",
    "Skala 1-5": "Масштаб 1-5",
    "Wydrukuj": "Друк",
    "Firma domyślna": "Компанія за замовчуванням",
    "Nazwa Firmy": "Назва Компанії",
    "Zgoda": "Згоден",
    "Wyszukiwarka miejsc": "Пошук місць",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "Вставте два стовпця 1/3 і 2/3",
    "Szablon został usunięty.": "Шаблон видалено.",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "",
    "Niezakończone": "Незавершені",
    "Data wykonania od": "Дата виконання від",
    "Ukryj czaty": "Сховай чати",
    "Co drugi miesiąc": "Кожні два місяці",
    "Nazwa kolumny z wartością": "Назва стовпця зі значенням",
    "Ostatnia strona": "Остання сторінка",
    "Komentarz konserwatora": "Коментар консерватора",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "Дійсно перемістити обрані позиції в поточний каталог?",
    "Zadania na wniosek działu": "Завдання за запитом відділу",
    "Planuj automatycznie w dniu wymeldowania": "Автоматичний розклад в день виїзду",
    "Jutro": "Завтра",
    "Wszystkie próby": "Всі спроби",
    "Przejdź do zadania": "Перейти до завдання",
    "Godzina przełomowa synchronizacji": "Проривна година синхронізації",
    "Ilość wierszy": "Кількість рядків",
    "Dodaj do zespołu": "Додати в команду",
    "Inspekcja": "Інспекція",
    "Łazienka": "",
    "Wydział": "Відділ",
    "Nie udało się pobrać listy filtrów": "Не вдалося завантажити список фільтрів",
    "Administracja - Użytkownicy": "Адміністрування - Користувачі",
    "Wybierz plik lub katalog": "Виберіть файл або каталог",
    "Miejsca po przecinku": "Десятковий знак",
    "Dodane Koszty": "Додай кошти",
    "-": "-",
    "Wyślij testowe powiadomienie": "Надіслати тестове повідомлення",
    "Formularze": "Форми",
    "Nie udało sie zaktualizować zadania": "Не вдалося оновити завдання",
    "Początek dystansu": "Початок дистанції",
    "Dane do sieci": "Дані для мережі",
    "Koszt Renters": "На рахунок Рентерс",
    "Brak właściciela": "Немає власника",
    "Cyfry": "Цифри",
    "Status: ": "Статус: ",
    "Potwierdzam": "Підтверджую",
    "Co drugi dzień": "Кожен другий день",
    "PDF": "",
    "Ustawienia globalne": "Глобальні налаштування",
    "Usuń": "Видалити",
    "Nieruchomość jest widoczna": "Власність видима",
    "Zaakceptowany": "Прийнятий",
    "Zadanie zostało rozpoczęte.": "Завдання розпочато.",
    "Nazwa chatu": "Назва чату",
    "Wyświetl nieruchomości robocze": "Перегляд робочих властивостей",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Сталася помилка сервера при обробці обраної операції. Спробуйте ще раз.",
    "15 minut": "15 хвилин",
    "Edycja formularza": "Редагування форми",
    "Zakolejkowane": "У черзі",
    "Modyfikacja": "Зміненення",
    "Numer nieruchomości (StreetNumber)": "Номер об'єкта нерухомості (StreetNumber)",
    "Administracja - Stanowiska pracy": "Адміністрування - Робочі місця",
    "W polu możemy umieszczać jedynie cyfry całkowite, nie ujemne": "У поле ми можемо поставити тільки цілі цифри, а не від'ємні",
    "Kierowca Główny": "Головний водій",
    "Region został zaktualizowany.": "Регіон оновлено.",
    "Checklista nie ma przypisanych miast.": "Checklista не має призначених міст.",
    "Monitoring": "Контроль",
    "Status rozliczenia": "Статус розрахунку",
    "Zmień status": "Змінити статус",
    "Klient został zaktualizowany.": "Клієнт оновився.",
    "Zaopatrzenie": "Поставка",
    "Temat": "Тема",
    "Zdecydowanie się nie zgadzam": "Я категорично не згоден",
    "Nazwa kosztu": "Назва вартості",
    "Notatka utworzona z zadania": "Примітка, створена із завдання",
    "Wybierz sekcję": "",
    "Hasło": "Пароль",
    "Dodaj firmę": "Додати компанію",
    "Nieruchomość": "Нерухомість",
    "Zdecydowanie nieważne": "Однозначно не важливо",
    "Nazwa apartamentu": "Назва апартаменту",
    "${DepartmentName(DepartmentEnum[this.task.department])}": "${DepartmentName(DepartmentEnum[this.task.department])}",
    "Październik": "Жовтень",
    "Usuń zadanie": "Видалити завдання",
    "Dodane przeze mnie": "Додано мною",
    "Właściciel został usunięty": "Власника прибрано",
    "Checklista została dodana.": "Додано чек-лист.",
    "zgłoś problem w apartamencie": "повідомити про проблему в апартаменті",
    "Proszę zapisać postęp pracy i kliknąć przycisk \"Aktualizuj\".": "Будь ласка, збережіть хід роботи та натисніть кнопку «Оновити».",
    "Email": "Електронна пошта",
    "Obraz został wycięty.": "Зображення вирізано.",
    "Wybrane pliki": "Вибрані файли",
    "Kontrolka wyboru (wybór wielokrotny)": "Елемент керування виділенням (кілька виділень)",
    "Można dodawać tylko pliki typu: \"%0\".": "Додавати можна тільки файли типу: «».",
    "Typ pomieszczenia": "",
    "Zacznij pisać aby wyszukać szablon checklisty...": "Почніть вводити текст для пошуку шаблону чек-листа...",
    "Nazwa pola": "Назва поля",
    "Projekt": "Проект",
    "Edycja inwentaryzacji": "Редагування інвентаризації",
    "Wybór": "Вибір",
    "Dodanie zadania": "Додавання завдання",
    "Uprawnienia": "Дозвіл",
    "Renters": "Renters",
    "Słownik systemowy": "Системний словник",
    "Źródło danych": "Джерело даних",
    "Inwentaryzacja została dodana.": "Інвентаризація додана.",
    "Zastępstwo wygaśnie za 10 minut.": "Термін дії заміни закінчується через 10 хвилин.",
    "Kolor powinien być w formacie #XXXXXX (np. #f07d00)": "Колір повинен бути у форматі #XXXXXX (наприклад, #f07d00)",
    "Nie udało się pobrać listy kanałów": "Не вдалося завантажити список каналів",
    "Generator plików PDF:": "Генератор PDF:",
    "Raporty z rozliczeń": "Платіжні звіти",
    "Nie zdefiniowano żadnych ról.": "Ролі не визначені.",
    "Typ pomieszczenia jest wymagany": "",
    "Zmień rozmiar": "Змінити розмір",
    "Notatka do zadania": "Примітка завдання",
    "Numer pinezki": "Номер штифта",
    "Dodanie regionu": "Додавання регіону",
    "Checklisty": "Чек-листи",
    "Dostęp zabroniony": "Доступ заборонений",
    "NIP": "Номер платника ПДВ",
    "Adres email": "Електронна пошта",
    "Komunikat": "Комунікат",
    "Wprowadzona wartość jest za niska": "Введене значення занадто низьке",
    "Stawka za apartamenty została zaktualizowana.": "Ставка за апартамент актуалізована.",
    "Pokaż numery stron": "Показати номери сторінок",
    "Organizuj": "Організувати",
    "Zobacz wszystkie": "Дивитись все",
    "Przywróć": "Відновити",
    "Dane wydziałów": "Дані відділів",
    "Wpis domyślny": "Запис за замовчуванням",
    "Urlop został dodany.": "Відпустка була додана.",
    "Zmień nazwę pliku": "Перейменувати файл",
    "Lewy panel": "Ліва панель",
    "Data przejścia": "Дата проходження",
    "Nieruchomość niestandardowa": "Спеціальна власність",
    "MasterCode nieruchomości": "Мастеркод нерухомості",
    "Kreator trasy: ": "Майстер маршрутів: ",
    "Wczytaj zapisany filtr": "Завантажити збережений фільтр",
    "Wybrana data jest mniejsza niż dozwolona %0.": "Вибрана дата менша ніж дозволена %0.",
    "Pokaż nieaktywnych właścicieli": "Показати неактивних власників",
    "Litery i cyfry": "Букви і цифри",
    "Klucze": "Ключі",
    "Lista urządzeń na których jesteś zalogowany": "Список пристроїв, на яких ви увійшли в систему",
    "Edycja": "Редагування",
    "Statystyki": "Статистика",
    "Odrzuć": "Відкидати",
    "Formularz został zaktualizowany.": "Форму оновлено.",
    "Lista": "Список",
    "Szukaj": "Шукати",
    "Logo firmy": "Логотип компанії",
    "Pliki": "",
    "Filtruj": "Фільтрувати",
    "${PriorityName(PriorityEnum[this.task.priority])}": "${PriorityName(PriorityEnum[this.task.priority])}",
    "Udało się usunąć zadania!": "Вдалося видалити завдання!",
    "Data wygaśnięcia": "Термін закінчення терміну дії",
    "Role użytkownika": "Ролі користувачів",
    "Imie i nazwisko": "Ім'я і прізвище",
    "Status": "Статус",
    "Oznacz wszystkie jako przeczytane": "Позначити все як прочитане",
    "Wartości statusów": "Значення статусу",
    "Wznów zadanie": "Поновити завдання",
    "Walidacja": "Перевірка",
    "Trasa została rozpoczęta": "Маршрут було розпочато",
    "Zdecydowanie ważne": "Безумовно важливо",
    "Dodawanie wyposażenia": "Додавання обладнання",
    "Co 10 minut": "Кожні 10 хвилин",
    "Zmodyfikowano": "модифікований",
    "Odśwież": "Оновити",
    "Wymeldowanie": "Виселення",
    "Wybierz pliki": "Виберіть файли",
    "Użytkownicy": "Користувачі",
    "Typ wynagrodzenia": "Тип заробітної плати",
    "Dzielenie": "Поділ",
    "Co 2 minuty": "Кожні 2 хвилини",
    "Link do rezerwacji": "Посилання на бронювання",
    "Odejmij kwotę": "Відніми сумму",
    "Koszt został dodany.": "Вартість додана.",
    "Nazwa nieruchmości": "Назва об'єкта нерухомості",
    "Peticion informacion": "Peticion informacion",
    "Stawki nieruchomości": "Ставка нерухомості",
    "Brak elementów podsumowania": "Бракує підсумкових елементів",
    "Wynagrodzenie podstawowe": "Базова зарплата",
    "Linia": "Лінія",
    "Pobierz": "",
    "Zaopatrzenie zostało zaktualizowane.": "Постачання було оновлено.",
    "Ważne informacje": "Важлива інформація",
    "Edycja regionu": "Редагування області",
    "12 godzin": "12 годин",
    "Stan licznika końcowego nie może być mniejszy bądź równy w porównaniu do licznika początkującego": "Стан кінцевого лічильника не повинен бути меншим або рівним початковому лічильнику",
    "Załaduj": "Навантаження",
    "Zastępstwo wygaśnie za 5 minut.": "Термін дії заміни закінчується через 5 хвилин.",
    "Zdecydowanie tak": "Безумовно так",
    "Kwota opłacona do": "Сума виплачена до",
    "Ten czat nie posiada przypisanych konkretnych użytkowników.": "Цей чат не має приписаних конкретних користувачів.",
    "Przywróć użytkownika": "Поверни користувача",
    "Zadowolony": "Задоволений",
    "Wybierz dzielnice": "Виберіть райони",
    "Tagi:": "Теги:",
    "Imię i nazwisko właściciela": "Ім'я і прізвище власника",
    "Rozpocznij zadanie": "Почати завдання",
    "Brak sekcji - najpierw utwórz sekcję": "",
    "Nieruchomość jest już przypisana": "Нерухомість вже присвоєна",
    "Marka": "Бренд",
    "Zapauzuj zadanie": "Призупинити завдання",
    "Podgląd szablonu e-maila": "Попередній перегляд шаблону Електронної Пошти",
    "Nazwa serwera": "Назва сервера",
    "Kwota brakująca": "Сума котрої бракує",
    "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Можливість модифікації цього розділу обмежена. Неактивні поля синхронізуються із зовнішньою базою даних %0.",
    "Powiązane": "Пов'язане",
    "Czas realizacji": "Терміни реалізації",
    "Brak nowych powiadomień.": "Немає нових повідомлень.",
    "Wymuś zmianę hasła": "Примусово змінити пароль",
    "Data przejścia na nowe API": "Дата переходу на новий API",
    "Zmodyfikowane przez": "Змінено",
    "Kwota zniszczeń": "Розмір збитку",
    "Id nieruchomości": "Ідентифікатор об'єкта",
    "Wybrana data jest większa niż dozwolona %0.": "Вибрана дата більша за дозволену %0.",
    "Status dokumentu został zmieniony.": "Статус документа змінено.",
    "Wpis został usunięty.": "Запис видалено.",
    "Podgląd": "Попередній перегляд",
    "Liczba nocy": "Кількість ночей",
    "Dodanie firmy": "Додавання компанії",
    "Prawy panel": "Права панель",
    "Wynagrodzenie za sprzątanie": "Винагорода за прибирання",
    "Link do raportu": "Посилання на звіт",
    "Wynagrodzenie za inspecję": "Зарплата за перевірку",
    "Port": "Порт",
    "Nowa umowa": "Новий контракт",
    "Użytkownik": "Користувач",
    "Tagi nieruchomości": "Теги нерухомості",
    "Dodaj typ wynagrodzenia": "Додай тип винагороди",
    "Data": "Дата",
    "Pokaż na mapie": "Показати на карті",
    "Dodatkowy komentarz do wynagrodzenia": "Додатковий коментар щодо зарплати",
    "Opracowane, zapisz": "Розроблено, збережено",
    "Nie udało się pobrać użytkowników": "Не вдалося завантажити користувачів",
    "Edycja firmy": "Редагування компанії",
    "Dodaj zasób": "Додати ресурс",
    "Warunki logiczne": "Логічні умови",
    "Pierwsza strona": "Перша сторінка",
    "Usunięte": "Видалено",
    "Default mode": "Режим за замовчуванням",
    "Liczba pracowników zatrudnionych tylko w tym mieście": "Кількість співробітників, які працюють тільки в цьому місті",
    "Cancelled": "Cancelled",
    "Zdjęcia": "Фотографії",
    "Uruchom zadanie": "Запустити задачу",
    "Data dodania": "Дата додавання",
    "Zarchiwizowany": "Архівовані",
    "Wiadomość testowa została wysłana.": "Тестове повідомлення відправлено.",
    "Numer nieruchomości Avantio": "Номер нерухомості Avantio",
    "Inwentaryzacja": "Інвентаризація",
    "Kraj": "Країна",
    "Wybierz koordynatora": "Виберіть координатора",
    "Nieruchomość robocza": "Робоча власність",
    "Kopiuj": "Копіювати",
    "Pokój dzienny": "",
    "Robocizna": "Праця",
    "Nie do odzyskania": "Не підлягає відновленню",
    "Data realizacji": "Дата реалізації",
    "Ten użytkownik już jest przypisany do czatu": "Цей користувач вже призначений до чату",
    "Ostatnia strona": "Остання сторінка",
    "Wynagrodzenie za sprzątanie": "Винагорода за прибирання",
    "Dzielnica została zaktualizowana.": "Район було оновлено.",
    "Dopuść brak odpowiedzi": "Дозволити відсутність відповіді",
    "Dane dostępowe:  ": "Дані доступу:  ",
    "Kwota brakująca": "Сума котрої бракує",
    "Typ obciążenia": "Тип навантаження",
    "Nieruchomości": "Нерухомості",
    "ID zadania": "ID завдання",
    "Wybrana data jest większa niż dozwolona %0.": "Вибрана дата більша за дозволену %0.",
    "Data końcowa nie może być wcześniejsza niż data początkowa": "Дата закінчення не може бути раніше дати початку",
    "Kategoria została usunięta.": "Категорію видалено.",
    "Usługi": "Послуги",
    "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "Ви зможете додавати терміни до словника лише після збереження джерела даних.",
    "Sortowanie rosnąco": "Сортування за зростанням",
    "Checklisty": "Чек-листи",
    "Dostęp niezdefiniowany": "Невизначений доступ",
    "Treść notatki": "зміст примітки",
    "edycja": "редагування",
    "Widoczność": "Видимість",
    "Przypisani użytkownicy": "Приписані користувачі",
    "Ukończone przez użytkownika o Id": "Завершено користувачем o Id",
    "Ta dzielnica jest już przypisana do użytkownika.": "Цей район вже закріплена за користувачем.",
    "Kwota opłacona": "Сума сплачена",
    "Tekst alternatywny": "Альтернативний текст",
    "Koordynator Konserwacji": "Координатор технічного обслуговування",
    "usuń notatkę": "видалити примітку",
    "Odstęp": "Відступ",
    "Nazwa dzielnicy": "Назва району",
    "Wyszukiwana fraza:": "Пошукова фраза:",
    "Ranga": "Ранг",
    "Czyim kosztem jest dodany przedmiot?": "За чий рахунок додається предмет?",
    "Czas": "Час",
    "Odrzucone": "Відхилено",
    "Cofam": "Вертаюсь",
    "Ilość znaków": "Кількість символів",
    "Excel został wygenerowany i wysłany na adres e-mail": "",
    "Informacje Podstawowe": "Основна Інформація",
    "Zobacz szczegóły sesji użytkownika": "Переглянути деталі сеансу користувача",
    "Sobota": "Субота",
    "3 godziny": "3 години",
    "Rozliczenia pracowników": "Розрахування працівників",
    "Ustawienia powiadomień zostały zaktualizowane.": "Налаштування сповіщень оновлено.",
    "Dark mode": "Темний режим",
    "Ten Miesiąc": "Цей Місяць",
    "Mapa": "Карта",
    "Ilość łóżek dwuosobowe": "Кількість двоспальних ліжок",
    "Brak tagów": "Немає тегів",
    "Dane gościa": "Дані про гостя",
    "Identyfikator zadania": "Ідентифікатор завдання",
    "Dodaj do trasy": "Додати до маршруту",
    "Data zakończenia": "Дата закінчення",
    "Trasy można wykonywać w aplikacji Hi!Renters Mobile": "Маршрути можна виконати в Hi! Мобільні орендарі",
    "Potwierdź akceptację": "Підтвердження прийняття",
    "Login": "Логін",
    "Niepotwierdzeni": "Непідтверджені",
    "Zakończone: ${$filters.datetime(route.dateCompletedUtc)}": "Виконано: ${$filters.datetime(route.dateCompletedUtc)}",
    "Chat": "Чат",
    "Raczej się zgadzam": "Скоріше погоджуюсь",
    "Pole nie może być puste": "",
    "1 godzina": "1 година",
    "Wydział zadania": "Відділ завдань",
    "Wysokość": "Висота",
    "Osoba zastępowana": "Особа, яку замінюють",
    "do czasu ręcznego odblokowania": "до розблокування вручну",
    "Co 30 minut": "Кожні 30 хвилин",
    "Zobacz zdjęcia": "Дивитись фото",
    "Wynagrodzenie": "Заробітна плата",
    "Wyrażenie regularne": "Регулярний вираз",
    "Osiągnąłeś limit zdjęć. Nie możesz dodać więcej zdjęć": "Ви вичерпали свій ліміт фотографій. Ви не можете додати більше фотографій",
    "Czy na pewno chcesz usunąć ten kolor?": "Ви впевнені, що хочете видалити цей колір?",
    "Proszę obciążyć gościa": "Будь ласка, стягніть плату з гостя",
    "Dodawanie checklisty": "Додавання чек-листа",
    "Zmodyfikował": "Змінено",
    "Numer telefonu": "Номер телефону",
    "Dział nadrzędny": "Головний відділ",
    "Wybierz tagi": "Виберіть теги",
    "Wykonaj": "Виконати",
    "Wyloguj się": "Вийти",
    "Powiązane zadanie": "",
    "Poniedziałek": "Понеділок",
    "Nie mam zdania": "У мене немає думки",
    "Lista rezerwacji": "Перелік бронювань",
    "Ładuje...": "Завантажує...",
    "Jesteś pewien?": "Ви впевнені?",
    "Teraz": "Прямо зараз",
    "Numer mieszkania (Number)": "Номер квартири (Number)",
    "Usunięto użytkownika z czatu": "Користувача видалено з чату",
    "Wróć na dół": "Повернутися вниз",
    "Pokaż przycisk": "Показати кнопку",
    "Nazwa obiektu": "Назва об'єкта",
    "Uwzględniaj zadania z miesiąca": "Включити завдання за місяць",
    "Nazwa zespołu": "Назва команди",
    "Zastępstwo wygasło.": "Заміна закінчилася.",
    "Typ Firmy": "Тип Компанії",
    "Data przyjazdu": "Дата прибуття",
    "ID użytkownika": "Ідентифікатор користувача",
    "Typ serwera": "Тип сервера",
    "Maksimum": "Максимум",
    "Wybrany region": "Обраний регіон",
    "Pobrane z magazynu Renters": "Отримано зі сховища Renters",
    "Sekcja nie została znaleziona": "",
    "Nazwa zadania": "Назва завдання",
    "ID zadania": "ID завдання",
    "Nikomu nie przydzielono uprawnień": "Нікому не призначено дозволів",
    "Kwota wynagrodzenia PLN brutto": "Сумма заробітної плати PLN брутто",
    "Rola aktywna": "Активна роль",
    "Usuń z zespołu": "Видалити з команди",
    "Utworzone": "Створене",
    "Nie udało się pobrać powiadomień.": "Не вдалося завантажити сповіщення.",
    "Get it on Appstore": "Отримайте його в Appstore",
    "Aplikacja nie ma uprawnień do wysyłania powiadomień PUSH": "Додаток не має дозволу на відправку PUSH-повідомлень",
    "Tłumaczenia": "Переклади",
    "Liczba": "Підрахунок",
    "Checkbox": "Чек-бокс",
    "Treść notatki": "Зміст примітки",
    "Miasto zostało usunięte": "Місто видалено",
    "+": "+",
    "Statystyki użytkowników": "Статистика користувачів",
    "Ustawienia wynagrodzenia zostały zaktualizowane.": "Налаштування заробітної плати були оновлені.",
    "Nadpisz kwotę": "Перепишіть сумму",
    "Sortowanie rosnąco": "Сортування за зростанням",
    "Rejestr zmian": "Реєстр змін",
    "Urządzenie zostało usunięte.": "Пристрій було видалено.",
    "Notatka została dodana.": "Примітка додана.",
    "Dodanie użytkownika": "Додавання користувача",
    "Edytuj": "Редагувати",
    "Usuń filtr": "Видалити фільтр",
    "Dodaj formularz": "Додати форму",
    "Zapytanie SQL": "SQL запит",
    "Akceptacja": "Прийняття",
    "Podana wartość jest nieprawidłowa.": "Дане значення недійсне.",
    "Edycja nieruchomości": "Редагування нерухомості",
    "Niezadowolony": "Незадоволений",
    "Utwórz zlecenie": "Створити замовлення",
    "Liczba całkowita": "Ціле число",
    "Czas wykonania": "Час виконання",
    "Imie i nazwisko: ": "Ім'я та прізвище: ",
    "Średnie wynagrodzenie koordynatora": "Середня зарплата координатора",
    "Kwota jednostkowa": "Одинична сумма",
    "Wyszukaj...": "Пошук...",
    "Informacje dodatkowe": "Додаткова інформація",
    "Średnie wynagrodzenie pracowników": "Середня заробітна плата працівників",
    "Tytuł sekcji": "Назва розділу",
    "Warunkowo": "Умовно",
    "Aktualizuj": "Оновити",
    "Kolor obramowania": "Колір бордюру",
    "Urlop": "Відпустка",
    "Stwórz czat": "Створіть чат",
    "Rola została dodana.": "Роль додана.",
    "Lista zgłoszeń w tym apartamancie": "Список зголошень у цій квартирі",
    "Brak": "Відсутність",
    "Szczegóły zmiany": "Подробиці зміни",
    "Ta nieruchomość nie posiada informacji na temat wyposażenia.": "Ця нерухомість не має інформації про обладнання.",
    "Osoby przypisane jako domyślne do zadań zwiazanych ze sprzątaniem": "Люди, призначені за замовчуванням для завдань, пов'язаних з очищенням",
    "Jest problem": "Є проблема",
    "Wartość": "Вартість",
    "Tag został dodany.": "Тег було додано.",
    "co 30 dni": "кожні 30 днів",
    "Sekcja jest wymagana": "",
    "Komentarz zadania nie może być dłuższy niż 500 znaków.": "Коментар завдання не може перевищувати 500 символів.",
    "Rozpocznij synchronizację": "Почніть синхронізацію",
    "Dane wydziału zostały usunięte.": "Дані відділу були видалені.",
    "Zadanie zostało uruchomione.": "Завдання розпочато.",
    "Dodano zdjęć": "Додано фотографії",
    "Pole \"Nazwisko\" jest wymagane.": "Поле «Прізвище» обов'язкове для заповнення.",
    "Zabierz dostęp": "Заберіть доступ",
    "Kategorie": "Катигорії",
    "Typ obciążenia": "Тип навантаження",
    "Rozpocznij trasę": "Почніть маршрут",
    "Wybrano pliki różnych typów. Wybierz pliki tego samego typu.": "",
    "Magazynier": "Складщик",
    "Wielkość kroku": "Розмір кроку",
    "Firma sprzątająca": "Клінінгова компанія",
    "Edycja dzielnicy": "Редагування району",
    "Koszty do zadania": "Витрати, які потрібно запросити",
    "Zaplanowane": "Заплановано",
    "Wyczyść": "Очистити",
    "Nazwa przycisku ``Dalej``": "Назва кнопки ''Далі''",
    "Zacznij pisać aby wyszukać kierowcę...": "Почніть вводити текст для пошуку водія...",
    "Ilość wyników do pobrania": "Кількість результатів для завантаження",
    "Nie udało się wysłać pliku": "Не вдалося надіслати файл",
    "Dodaj zdjęcia": "Додайте фотографії",
    "Czas trwania:": "Тривалість:",
    "Koordynator": "Координатор",
    "Edycja źródła danych": "Редагування джерела даних",
    "Dane rezerwacji": "Дані бронювання",
    "Użytkownik jest liderem zespołu": "Користувач є лідером команди",
    "Utworzone przez:": "Створено:",
    "Użytkownik został usunięty.": "Користувача видалено.",
    "Deadline - Data wykonania": "Дедлайн - Дата виконання",
    "L4": "Л4",
    "Opis": "Опис",
    "Nie ma ustalonej roli dla tego wydziału": "Для цього відділу немає фіксованої ролі",
    "Pokaż tytuły stron": "Показати заголовки сторінок",
    "Moje filtry": "Мої фільтри",
    "Moje czaty": "Мої чати",
    "Zapamiętaj logowanie": "Запам'ятати логін",
    "Data zdarzenia": "Дата події",
    "Wartość musi być liczbą ujemną": "Вартість має бути від'ємним числом",
    "Filtr prywatny": "Приватний фільтр",
    "Zakończ trasę": "Закінчити маршрут",
    "Dodaj wszystkich dopasowanych użytkowników": "Додати всіх відповідних користувачів",
    "Stawka nieruchomości": "Сумма нерухомості",
    "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "Ви зможете додавати терміни до словника лише після збереження джерела даних.",
    "Godzina zameldowania": "Час заїзду",
    "Zakres czasu": "Часовий діапазон",
    "Nazwa katalogu została zmieniona.": "Каталог перейменовано.",
    "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "Щоб додати учасників команди, спочатку потрібно зберегти форму.",
    "Statusy użytkowników": "Статуси користувачів",
    "Nr telefonu": "Контактний телефон",
    "Dodaj nowy koszt": "Додати нову вартість",
    "Zmodyfikowane przez użytkownika": "Змінено користувачем",
    "Liczba zgłoszonych problemów": "Кількість повідомлених проблем",
    "Domyślny kolor trasy (dotyczy kierowców)": "Колір маршруту за замовчуванням (для водіїв)",
    "Peticion disponibilidad": "Peticion disponibilidad",
    "Brak miast": "Немає міст",
    "Nowa kwota": "Нова сумма",
    "Łączenie treści": "Об'єднання контенту",
    "Data wykonania": "Дата виконання",
    "Ten użytkownik nie posiada jeszcze przypisanych dzielnic.": "Цей користувач ще не має призначених районів.",
    "Niewidoczne": "Невидимий",
    "Zadania do wykonania": "Завдання для виконання",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "",
    "Zapauzowane": "Призупинено",
    "Pole może zawierać jedynie cyfry.": "Поле може містити тільки числа.",
    "kanał wymagany": "необхідний канал",
    "Podstawowe operacje tekstowe": "Основні текстові операції",
    "Nierozwiązane": "Невирішені",
    "Brak plików w sekcji": "",
    "Brak aktywnego filtru": "Бракує активного фільтру",
    "Dashboard": "Панель приладів",
    "Odznacz wszystko": "Зніміть прапорець у всіх",
    "Nazwa przycisku ``Wstecz``": "Назва кнопки ''Назад''",
    "z": "",
    "Podstawowe": "основні",
    "Edycja wielu elementów": "Редагування декількох елементів",
    "Przesyłam...": "Відправляю...",
    "Formularz": "Форма",
    "Łączny czas wykonywania zadań": "Загальний час виконання завдань",
    "Przypisz do zadania": "Призначити завдання",
    "Serwer dostępny": "Доступний сервер",
    "Archiwizuj": "Архівуй",
    "BIC/Swift": "BIC/Swift",
    "Koszty zadania zostały zaktualizowane.": "Вартість завдання оновлено.",
    "Wybrano:": "Вибрано:",
    "Dodanie właściciela": "Додавання власника",
    "Przejdź do zlecenia z notatki": "Перейти до замовлення з записки",
    "Data zakończenia do": "Дата закінчення до",
    "Twój token": "Ваш токен",
    "Publiczne": "Громадський",
    "Edycja wynagrodzenia mieszanego dla:": "Редагування змішаної заробітної плати для:",
    "Przeciągnij i upuść aby posortować pliki": "Перетягніть, щоб сортувати файли",
    "Słownik": "Словник",
    "Wybierz wydział": "Виберіть факультет",
    "Trasa została zapisana.": "Маршрут було записано.",
    "Początkowy stan licznika": "Початковий стан лічильника",
    "Nie można jednocześnie wybrać tagów i zaznaczyć opcji 'Usuń wszystkie tagi'": "",
    "To zadanie dotyczy nieruchomości, która znajduje się na trasie. Czy chcesz przejść do mapy, aby edytować punkt?": "",
    "Nie udało się pobrać listy powiadomień": "Не вдалося отримати список сповіщень",
    "Powiązane zadania": "Пов'язані завдання",
    "Nie": "Ні",
    "Zaznacz wszystkie": "Виділити всі",
    "Obsługa Klienta (BOK)": "Служба підтримки клієнта (BOK)",
    "Tak": "Так",
    "Rozwiązane": "Вирішені",
    "Kolor został dodany": "Додано колір",
    "Wybrana liczba jest mniejsza niż dozwolona %0.": "Вибране число менше дозволеного %0.",
    "Dowolny": "Будь-який",
    "Pokaż nieaktywne nieruchomości": "Показати неактивні властивості",
    "Dodano użytkownika do czatu": "Додано користувача до чату",
    "Ta dzielnica jest już przypisana do użytkownika.": "Цей район вже закріплена за користувачем.",
    "Zasoby": "Ресурси",
    "Utworzone przez": "Створене з",
    "Dodaj dni": "Додати дні",
    "Zamknięte przez użytkownika o Id": "Закрито користувачем про Id",
    "Poprzednia strona": "Попередня сторінка",
    "Pomieszczenie": "Кімната",
    "Dostęp": "Доступ",
    "Rola została zaktualizowana.": "Роль оновлена.",
    "Materiały": "",
    "Widok tygodniowy": "Тижневий перегляд",
    "Stan powiadomienia": "Стан сповіщення",
    "Uwzględniaj miasta": "Включити міста",
    "Nieruchomości": "Нерухомості",
    "Bank": "Банк",
    "Moje trasy": "Мої маршрути",
    "Edytowana wersja": "Відредагована версія",
    "Dalej": "Далі",
    "Zespół": "Команда",
    "Przyczyna": "Причина",
    "Definicja formularza znajduje się w obiekcie Form.": "Визначення форми знаходиться в об'єкті Form.",
    "Liczba dużych prześcieradeł": "Кількість великих листів",
    "Domyślna checklista": "Чек-лист за замовчуванням",
    "Dodaj Koszt do zadania": "Додати вартість до завдання",
    "Użytkownik został zaktualizowany.": "Користувач оновлений.",
    "Wstaw szablon informacyjny ze zdjęciem": "Вставити інформаційний шаблон з фотографією",
    "Szkic": "Ескіз",
    "Data końcowa nie może być wcześniejsza niż data początkowa": "Дата закінчення не може бути раніше дати початку",
    "Wrzesień": "Вересень",
    "Utwórz katalog": "Створити каталог",
    "Raport został wysłany na adres e-mail": "Звіт надіслано на електронну пошту",
    "Trasa została wznowiona": "Маршрут відновився",
    "Zacznij pisać numer aby wyszukać źródło rezerwacji...": "Почніть писати номер для пошуку джерела бронювання....",
    "Satysfakcja": "Задоволення",
    "Wyloguj": "Вийди",
    "Przypisane miasta:": "Призначені міста:",
    "Notatka magazyniera": "Примітка комірника",
    "Usunięcie": "Видалення",
    "Nie udało się usunąć użytkownika z czatu": "Не вдалося видалити користувача з чату",
    "Statystyki regionalne - miasta": "Регіональна статистика - міста",
    "Nazwa konta (Klucz dostępu)": "Назва облікового запису (ключ доступу)",
    "Aktywność": "Активність",
    "Id rezerwacji:": "Id бронювання:",
    "Edycja Notatki": "Редагування нотатки",
    "Wstaw z góry": "Вставити зверху",
    "Mieszane": "Змішане",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "",
    "Dodaj serwer": "Додати сервер",
    "Listopad": "Листопад",
    "obrót": "обіг",
    "Aktualne urządzenie": "Поточний пристрій",
    "Priorytet": "Пріоритет",
    "Ustawienia zaawansowane": "Додаткові налаштування",
    "Średnie wynagrodzenie pracownika": "Середня зарплата працівника",
    "Jedna kolumna": "Один стовпець",
    "Noclegi": "Розміщення",
    "Przypisane regiony:": "Приписане регіони:",
    "Edytuj dział": "Редагувати розділ",
    "Rozmiar zdjęcia został zmieniony.": "Розмір фото змінено.",
    "Pole może zawierać jedynie litery i cyfry.": "Поле може містити тільки букви і цифри.",
    "Planowana data wykonania": "Планова дата виконання",
    "Edycja tagu nieruchomości": "Редагування тегу нерухомості",
    "Dodano": "Додано",
    "Data dodania inwentaryzacji": "Дата додавання інвентаризації",
    "Edycja roli": "Редагування ролі",
    "Dołączanie...": "Приєднуючись до...",
    "Czy zablokować użytkownika i jego wiadomość?": "Чи заблокувати користувача і його повідомлення?",
    "Typ plików jest wymagany": "",
    "Szerokość": "Ширина",
    "Edytuj stawkę za godzinę": "Редагуй ставку за годину",
    "Imię gościa": "Ім'я гостя",
    "Przenieś wybrane": "Перемістити вибране",
    "Oraz nowe hasło": "І новий пароль",
    "Dodaj tag nieruchomości": "Додай тег нерухомості",
    "Serwer został usunięty.": "Сервер видалено.",
    "Porównaj %0": "Порівняйте %0",
    "Status edytowanej wersji dokumentu": "Статус відредагованої версії документа",
    "Jestem w pracy": "Я на роботі",
    "W pracy": "На роботі",
    "Poza pracą": "Поза роботою",
    "Status pracy": "Статус роботи",
    "Przejdź do zadania": "Перейти до завдання",
    "Jesteś w pracy. Kliknij, aby ustawić status Poza pracą": "Ви на роботі. Натисніть, щоб встановити статус Поза роботою",
    "Jesteś poza pracą. Kliknij, aby ustawić status W pracy": "Ви поза роботою. Натисніть, щоб встановити статус На роботі",
    "Zaloguj się loginem i hasłem": "Увійти за логіном і паролем",
    "Zakończyć pracę?": "Завершити роботу?",
    "Masz rozpoczęte zadanie:": "У вас є розпочате завдання:",
    "Po wyłączeniu statusu nie będziesz mógł rozpoczynać zadań.": "Після вимкнення статусу ви не зможете розпочинати завдання.",
    "Zakończ pracę": "Завершити роботу",
    "Aby rozpocząć zadanie, musisz mieć włączony status \"W pracy\".": "Щоб розпочати завдання, потрібно ввімкнути статус \"На роботі\".",
    "Status zostanie włączony automatycznie, a zadanie rozpocznie się od razu.": "Статус буде ввімкнено автоматично, а завдання розпочнеться одразу.",
    "Włącz i rozpocznij zadanie": "Ввімкнути і розпочати завдання",
    "Zadanie pozostanie rozpoczęte. Pamiętaj, aby je zakończyć lub zapauzować.": "Завдання залишиться розпочатим. Не забудьте завершити або призупинити його.",
    "Nie jesteś w pracy": "Ви не на роботі",
    "Zmień hasło": "Змінити пароль",
    "wybierz": "виберіть",
    "Powtórz hasło": "Повторіть пароль",
    "Czwartek": "Четвер",
    "Nowe hasło": "Новий пароль",
    "Dodawanie trasy": "Додавання маршруту",
    "Dodaj trasę": "Додати маршрут",
    "Strona główna": "Головна сторінка",
    "VAT": "",
    "Pokaż etykietę": "Показати мітку",
    "Data modyfikacji od": "Дата зміни від",
    "Wyrażenia warunkowe": "Умовні вирази",
    "Dział został dodany.": "Розділ додано.",
    "Opracowane": "Обреблені",
    "Wysłane wezwanie do zapłaty": "Надісланий запит на оплату",
    "Podpis": "Підпис",
    "Data początkowa nie może być późniejsza niż data końcowa": "Дата початку не може бути пізніше дати закінчення",
    "Nieruchomość niestandardowa o Id": "Користувальницька властивість з Id",
    "Dodaj zastępstwo": "Додати заміну",
    "Zastępstwo zostało dodane.": "Заміну додано.",
    "Planowanie inwentaryzacji": "Планування інвентаризації",
    "Powiadomienia": "Сповіщення",
    "Edycja wynagrodzenia stałego dla:": "Редагування постійної заробітної плати для:",
    "Data ostatniej zmiany statusu": "Дата останньої зміни статусу",
    "Aby zakończyć trasę należy uzupełnić stan licznika na koniec": "Щоб завершити маршрут, ви повинні заповнити статус лічильника в кінці",
    "Osoby przypisane jako domyślne do zadań zwiazanych z konserwacją": "Люди, призначені за замовчуванням для виконання завдань технічного обслуговування",
    "Pliki zostały dodane": "",
    "Ustawienia ogólne": "Загальне налаштування",
    "Konserwacja": "Обслуговування",
    "Do sprawdzenia": "На перевірку",
    "Pliki prywatne": "Особисті файли",
    "Czas trwania blokady": "Тривалість блокади",
    "Stwórz nowy czat": "Створи новий чат",
    "Nieopłacone/dłużnik": "Неоплачений/боржник",
    "Chat został zarchiwizowany.": "Чат був заархівований.",
    "Zablokowano możliwość edycji": "Можливість редагування заблокована",
    "IBAN": "IBAN",
    "Nie udało się pobrać listy typów modeli": "Не вдалося отримати список типів моделей",
    "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Можливість змінювати цей обліковий запис обмежена. Неактивні поля синхронізуються із зовнішньою базою даних %0.",
    "Nazwa pliku": "Назва файлу",
    "Data zakończenia blokady konta": "Дата завершення блокування облікового запису",
    "Kategoria": "Категорія",
    "Autor": "Автор",
    "Wybierz": "Вибрати",
    "Ilość koordynatorów w regionie": "Кількість координаторів у регіоні",
    "Ukończone przez użytkownika o Id": "Завершено користувачем o Id",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Сталася помилка підключення. Переконайтеся, що у вас увімкнено інтернет і спробуйте ще раз.",
    "Potwierdzam, zapisz": "Підтверджую, зберігти",
    "Wróć do logowania": "Повернутися до входу",
    "Suma Wynagrodzeń": "Сума Заробітної Плати",
    "Grudzień": "Грудень",
    "Kuchnia": "",
    "Usuń element": "Видалити елемент",
    "Facturada": "Exclusivity",
    "Usunięte przez": "Видалено",
    "Rodzaj kosztu": "Тип вартості",
    "Zastępuje osobę": "Замінює людину",
    "Inspektor": "Інспектор",
    "Filtry powiadomień": "Фільтри сповіщень",
    "Dodaj stronę": "Додати сторінку",
    "Data ostatniej inwentaryzacji": "Дата останньої інвентаризації",
    "Co 15 minut": "Кожні 15 хвилин",
    "Dane osobowe": "Особисті дані",
    "Formularz zarchiwizowany": "Архівна форма",
    "Wyzeruj licznik": "Скинути лічильник",
    "Kwota średnia": "Середня сума",
    "Wybrany język": "Вибрана мова",
    "Akceptuj": "Прийми",
    "Aby rozpocząć trasę należy uzupełnić stan licznika na start": "Для початку маршруту необхідно заповнити статус лічильника старту",
    "Stan licznika nie może być wartością ujemną": "Значення лічильника не може бути від'ємним",
    "Data aktualizacji": "Дата поновлення",
    "Przejdź do zadania z notatki": "Перейти до завдання із замітки",
    "Pokaż tytuł sekcji": "Показати заголовок розділу",
    "Trzy kolumny": "Три стовпці",
    "Kontakty - Typ działania": "Контакти - Вид дії",
    "Ten użytkownik nie posiada jeszcze przypisanych miast.": "У цього користувача ще немає призначених міст.",
    "Osoby przypisane jako domyślne do zadań zwiazanych z inspekcją": "Люди, призначені за замовчуванням для завдань, пов'язаних з аудитом",
    "24 godziny": "24 години",
    "Inna": "Інше",
    "Szczegóły zdarzenia nr %0": "Деталі події %0",
    "Dodanie formularza": "Додавання форми",
    "Wyloguj zalogowanego obecnie użytkownika": "Вийти з поточного користувача",
    "Potwierdzenie archiwizacji": "Підтвердження архівації",
    "Dodaj pliki": "",
    "źródło zostało usunięte.": "джерело було видалено.",
    "Uwzględnij wydziały i statusy jednocześnie": "Включайте відділи та статуси одночасно",
    "Włącz system powiadomień": "Включити систему повідомлень",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "Не вдається додати файл(и): \"%0\". Можна додавати тільки файли типу: \"%1\".",
    "Wygeneruj plik": "Створити файл",
    "Nazwa roli": "Назва ролі",
    "Organizacja": "Організація",
    "${title}": "${title}",
    "Usuń z trasy": "Вилучити з маршруту",
    "Serwery plików": "Файлові сервери",
    "Ten Tydzień": "Цей Тиждень",
    "Element został usunięty.": "Елемент видалено.",
    "Co 2 tygodnie": "Кожні 2 тижні",
    "Co tydzień": "Щотиждень",
    "Zlecenie": "Порядок",
    "Właściciel został zaktualizowany.": "Власник оновлений.",
    "Radio": "Радіо",
    "Suma wynagrodzeń": "Сума заробітної плати",
    "Nie udało się dodać użytkownika do czatu": "Не вдалося додати користувача до чату",
    "Aktywne": "Активні",
    "Uwzględniaj tagi": "Включити теги",
    "Kwota pobrana": "Зібрана сума",
    "Dodaj media": "Додати медіа",
    "Dane został wgrane": "Дані завантажені",
    "Wybrana liczba jest większa niż dozwolona %0.": "Вибране число більше дозволеного %0.",
    "Komentarz dotyczący naprawy problemu": "Коментар щодо усунення проблеми",
    "Wyszukaj wszędzie": "Пошук усюди",
    "Hasło (Klucz ukryty)": "Пароль (прихований ключ)",
    "Ustawienia chatów": "Налаштування чатів",
    "Filtr został zapisany": "Фільтр збережено",
    "Odpowiedź 3": "Відповідь 3",
    "Edycja serwera": "Редагування сервера",
    "Nie przypisano": "Не призначено",
    "Wykonaj akcję": "Виконати дію",
    "Czaty": "Чати",
    "Firma została usunięta.": "Компанія була видалена.",
    "Data wymeldowania do": "Дата виїзду до",
    "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "Жоден канал зв'язку не був увімкнений в налаштуваннях сповіщень.",
    "Pole \"%0\" jest wymagane.": "Поле «%0» обов'язкове для заповнення.",
    "Tagi zadań": "Теги завдань",
    "Co 10 dni": "Кожні 10 днів",
    "Konfiguracja harmonogramu": "Конфігурація розкладу",
    "Repozytorium plików": "Сховище файлів",
    "Musisz najpierw zapisać zmienioną kolejność punktów zanim oznaczysz punkt": "Перед тим, як позначити точку, ви повинні спочатку зберегти змінений порядок точок",
    "Kalendarz pracowników": "Календар працівників",
    "Przypisane tagi: ": "Приписані теги: ",
    "Dodaj Zadanie": "Додати Завдання",
    "Obok siebie": "Біля себе",
    "Ilość kosztów": "Кількість витрат",
    "Co 6 godzin": "Кожні 6 годин",
    "Czat": "Чат",
    "Imię": "Ім\"я",
    "Kolory rezerwacji": "Кольори бронювання",
    "Proszę obciążyć właściciela obiektu": "Будь ласка, стягніть плату з власника нерухомості",
    "Usuń trasę": "Видалити маршрут",
    "Zacznij pisać aby wyszukać właściciela...": "Почніть вводити для пошуку власника...",
    "Dzielnica nieruchomości": "Район нерухомості",
    "Resetuj": "Скинути",
    "Urlop został usunięty": "Відпустку було видалено",
    "Host dodatkowy": "Додатковий хост",
    "Komentarz": "Коментар",
    "Status notatki": "Статус примітки",
    "Imię i nazwisko": "Ім'я і прізвище",
    "Zacznij pisać numer aby wyszukać rezerwację...": "Почніть писати номер для пошуку бронювання....",
    "Zdecydowanie się zgadzam": "Я повністю згоден",
    "Element został przywrócony.": "Елемент відновлено.",
    "co rok": "щороку",
    "Co minutę": "Щохвилини",
    "Role i uprawnienia": "Ролі та дозволи",
    "Coś poszło nie tak": "Щось пішло не так",
    "Data wymeldowania od": "Дата виїзду з",
    "Nazwa przycisku ``Wyślij``": "Назва кнопки ''Надіслати''",
    "Rezerwacje anulowane": "Бронювання скасовано",
    "Dane": "Дані",
    "Nie udało się pobrać listy zastępstw": "Не вдалося завантажити список замін",
    "Id sesji": "Id сеансу",
    "Opłacono": "Сплачено",
    "Przekroczono dozwoloną ilość znaków: %0.": "Ви перевищили дозволену кількість символів: %0.",
    "Inwentaryzacja została zaktualizowana.": "Інвентаризація оновлена.",
    "Bułgarski": "Българска",
    "Ok": "Гаразд",
    "Edycja właściciela": "Редагування власника",
    "Data rezerwacji do": "Дата бронювання до",
    "znaki": "символи",
    "Data Zmiany": "Дата зміни",
    "Wgraj plik": "Завантажити файл",
    "Odpowiedź 1": "Відповідь 1",
    "Przypisani użytkownicy": "Приписані користувачі",
    "Miejsce logowania": "Місцезнаходження для входу",
    "Wróć do strony głównej": "Повернутися на головну сторінку",
    "Użytkownik Sprzatanie": "Прибирання користувача",
    "Ukraiński": "Українська",
    "6 godzin": "6 годин",
    "Koszt został zaktualizowany.": "Вартість оновлено.",
    "Imię lub nazwisko właściciela": "Ім'я або прізвище власника",
    "W zespole od %0": "У команді від %0",
    "Adres IP": "IP-адреса",
    "Profil użytkownika": "Профіль користувача",
    "Notatki Koordynatorów": "Нотатки координаторів",
    "Ilość nocy": "Кількість ночей",
    "Trasa została zakończona": "Маршрут було завершено",
    "Zaakceptowane": "Прийнято",
    "Niewykonane zadania": "Невиконані завдання",
    "Edytuj kolor": "Редагувати колір",
    "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "За замовчуванням потрібне сповіщення. Ви не можете вимкнути надсилання цього повідомлення.",
    "Nieaktywni właściciele": "Неактивні власники",
    "Data następnej inwentaryzacji": "Дата наступної інвентаризації",
    "Przetestuj ustawienia poczty": "Перевірте налаштування пошти",
    "Odpowiedzi": "Відповіді",
    "Kalendarz Pracowniczy": "Календар для співробітників",
    "Brak dodanych punktów trasy": "Не додано жодної маршрутної точки",
    "Słownik dowolny": "Будь-який словник",
    "Raporty": "Звіти",
    "Synchronizuj razem z anulowanymi": "Синхронізувати разом зі скасованими",
    "Pytanie 2": "Питання 2",
    "Zrób zdjęcie": "Зробіть фото",
    "Numer domu": "Номер будинку",
    "Ilość toalet": "Кількість туалетів",
    "Dodaj zadanie: inspekcja": "Додати завдання: аудит",
    "ID": "ID",
    "Wysłane powiadomienie": "Відправлене повідомлення",
    "co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)": "що має відбутися зараз (яке очікування гостя)",
    "Nie udało się zapisać komentarza": "",
    "Pokaż zdjęcie w raporcie": "Показати фото у звіті",
    "zacznij pisać aby wyszukać użytkownika...": "почніть вводити текст для пошуку користувача...",
    "Zaznacz": "Марк",
    "Historia zmian": "Історія змін",
    "Dodaj nieruchomość do trasy": "Додайте нерухомість до маршруту",
    "Wstaw z lewej strony": "Вставити зліва",
    "Kopiuj filtr": "Фільтр копіювання",
    "Nieaktywne": "Неактивні",
    "Ilość zadań": "Кількість завдань",
    "Hasło zostało zmienione. Zaloguj się ponownie": "Пароль змінено. Увійти ще раз",
    "Nazwa wydziału": "Назва відділу",
    "Bardzo zadowolony": "Дуже задоволений",
    "Zacznij pisać aby wyszukać...": "Почніть писати щоб шукати...",
    "Nie udało się pobrać danych odnośnie rezerwacji i zadań": "Не вдалося отримати дані про бронювання та завдання",
    "Zlecenie zostało utworzone.": "Наказ створено.",
    "KRS": "KRS",
    "Przedrostek": "Префікс",
    "Nie udało się zapisać szablonu": "Не вдалося зберегти шаблон",
    "Stworzone przez użytkownika": "Створено користувачем",
    "Id checklisty": "Id контрольного списку",
    "Region apartamentu": "Регіон квартири",
    "Nie udało się utworzyć zlecenia.": "Не вдалося створити замовлення.",
    "Bardzo niezadowolony": "Дуже незадоволений",
    "Cron": "Крон",
    "Dzielnica została zaktualizowana.": "Район було оновлено.",
    "Luty": "Лютий",
    "Utworzono przez: ": "Створено: ",
    "Drugie imię": "Друге ім'я",
    "${(ex as any).response.data.errors.message[0]}": "${(ex as any).response.data.errors.message[0]}",
    "Po przejściu na mapę zadanie zostanie usunięte.": "",
    "Typ pola": "Тип поля",
    "Opracowanie kosztu": "Оброблення витрат",
    "Dodanie miasta": "Додавання міста",
    "Przypisani użytkownicy:": "Призначені користувачі:",
    "Dane wydziału zostały dodane.": "Дані відділу були додані.",
    "Zapisz": "Зберегти",
    "Kwota kosztu od": "Сума витрат від",
    "Pobierz plik": "Завантажити файл",
    "Data wznowienia": "Дата відновлення",
    "Imię klienta": "Ім'я клієнта",
    "Edycja ustawień wynagrodzenia dla:": "Зміна налаштування заробітної плати для:",
    "Wymagane": "Необхідне",
    "Lista jest pusta": "Список пустий",
    "Porównywana wersja": "Порівняна версія",
    "Zacznij pisać aby wyszukać region...": "Почніть вводити текст для пошуку регіону...",
    "Nazwisko i Imię": "Прізвище та ім'я",
    "Region został usunięty": "Регіон видалено",
    "Stwórz zadanie z notatki": "Створіть завдання з нотатки",
    "Edytuj sekcję": "",
    "Wybierz dział": "Виберіть відділ",
    "Dodatkowe wynagrodzenie - komentarz": "Додаткова винагорода - коментар",
    "Data utworzenia do": "Дата створення до",
    "Ten zespół nie posiada jeszcze żadnych członków.": "У цій команді ще немає членів.",
    "Harmonogram": "Розклад",
    "Za przepracowane godziny": "За відпрацьовані години",
    "Wynagrodzenie PLN brutto": "Зарплата брутто",
    "Zaznacz wszystko ": "Позначте всі ",
    "Lista punktów": "Список пунктів",
    "Środa": "Середа",
    "Zwierzątko": "Тваринка",
    "Są to wszystkie obiekty, nawet te, które posiadają już właściciela.": "Це всі об'єкти, навіть ті, які вже мають власника.",
    "Ukryj filtry": "Сховати фільтри",
    "Wpisz kwotę": "Введіть суму",
    "Testowy adres email": "Тестова адреса електронної пошти",
    "Wynagrodzenie stałe miesięczne": "Фіксована місячна заробітна плата",
    "Udało się zaktualizować zadania!": "Вдалося оновити завдання!",
    "Ostateczne wynagrodzenie:": "Остаточна зарплата:",
    "Nie udało się dodać pliku typu ": "Не вдалося додати тип файлу ",
    "Nieruchomość została dodana.": "Нерухомість додана.",
    "E-mail": "електронна почта",
    "Miesiąc edycji wynagrodzenia": "Місяць зміни заробітної плати",
    "Edycja trasy": "Редагування маршруту",
    "Powrót do historii": "Назад до історії",
    "Nazwa domyślnej checklisty": "Ім'я чек-листа за замовчуванням",
    "Moje zadania": "Мої завдання",
    "Ustawienia": "Налаштування",
    "Nie udało się dodać miasta lub dzielnicy": "Не вдалося додати місто або район",
    "Nie ma żadnych etykiet dla wybranej daty": "Немає міток для вибраної дати",
    "Sekcja została usunięta": "",
    "Liczba pracowników w regionie": "Кількість працівників у регіоні",
    "Notatka została usunięta.": "Примітку видалено.",
    "Filtry map": "Фільтри мапи",
    "Wysłane": "Відправлене",
    "Pole może zawierać jedynie litery.": "Поле може містити тільки букви.",
    "Nie udało się pobrać listy kolejek": "Не вдалося отримати список черги",
    "Stwierdzenie": "Констатація",
    "Data utworzenia zadania": "Дата створення завдання",
    "Wyczyść filtry": "Очистити фільтри",
    "Zobacz szczegóły zdarzenia": "Детальніше про подію",
    "Ustawienia Domyślne": "Налаштування за замовчуванням",
    "Firma została dodana.": "Компанія була додана.",
    "Całkowity dystans (km)": "Загальна відстань (км)",
    "Checklista została zaktualizowana.": "Оновлено чек-лист.",
    "Przyjazd": "Прибуття",
    "Wyczyść defaultowych użytkowników": "Очистити користувачів за замовчуванням",
    "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Редагувати можна лише шаблони для ввімкнених і підтримуваних каналів.",
    "Data wyjazdu": "Дата виїзду",
    "Szukana fraza": "Пошукова фраза",
    "Punkt został oznaczony": "Точку позначено",
    "Akcje": "Дії",
    "Wstaw cztery kolumny 1/4": "Вставте чотири стовпці 1/4",
    "Podsumowanie": "Зведення",
    "Miesiące": "Місяці",
    "Co 4 miesiące": "Кожні 4 місяці",
    "Sierpień": "Серпень",
    "Potwierdzenie zmiany statusu": "Підтвердження зміну статусу",
    "Wymagane jest wybranie źródła danych": "Необхідно вибрати джерело даних",
    "Obciążenie Gościa": "Плата стягується з Гостя",
    "Numer rezerwacji Avantio": "Номер бронювання Авантіо",
    "Nie udało się pobrać listy wydziałów": "Не вдалося завантажити список відділів",
    "Pozycja": "Позиція",
    "wybierz...": "виберіть...",
    "Wybierz serwer": "Виберіть сервер",
    "Zwrócony": "Повернений",
    "Wiadomość została ukryta.": "Повідомлення було приховано.",
    "Kolor trasy": "Колір маршруту",
    "Potwierdzenie przywrócenia": "Підтвердження відновлення",
    "Data nieobecności do": "Дата відсутності до",
    "Dowolna data": "Будь-яка дата",
    "Zmiana hasła": "Зміна пароля",
    "Pole \"Drugie imię\" jest wymagane.": "Поле «Друге ім'я» обов'язкове для заповнення.",
    "Resetuj filtry": "Скинути фільтри",
    "Nie możesz wpływać na kolejność punktów już oznaczonych jako odwiedzone": "Ви не можете вплинути на порядок пунктів, які вже позначені як відвідані",
    "Aktywne kanały komunikacji": "Активні канали зв'язку",
    "Nieruchomość została usunięta.": "Нерухомість видалена.",
    "ID lub typ zadania": "ID або тип завдання",
    "Nie znaleziono żadnych wyników.": "Результатів не виявлено.",
    "Back Office": "Бек-офіс",
    "ŚREDNIA": "СЕРЕДНЄ",
    "Niemiecki": "Німецькі",
    "Wymiary": "Розміри",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Кількість працівників, які працюють у більш ніж одному регіоні",
    "Ostatnia aktywność": "Остання активність",
    "Widoczność": "Видимість",
    "Uwzględniaj nieruchomości": "Включити нерухомості",
    "Host": "Хост",
    "Id zdarzenia": "Id події",
    "Rok": "Рік",
    "Edycja wynagrodzenia": "Зміна заробітної плати",
    "słowa": "слова",
    "Wersje": "Версії",
    "Dodanie": "Додавання",
    "Zablokowany": "Заблокований",
    "Więcej...": "Більше...",
    "Dodaj zdjęcia do wiadomości": "Додайте фотографії до повідомлення",
    "Ten punkt został już odwiedzony": "Цей пункт вже відвідано",
    "Dodaj premię": "Додай премію",
    "Zespół został dodany.": "Команда була додана.",
    "Przejdź do mapy": "Перейти до карти",
    "Data rezerwacji od": "Дата бронювання від",
    "Porównaj z edytowaną wersją": "Порівняння з відредагованою версією",
    "Wpis został zaktualizowany.": "Запис оновлено.",
    "Co miesiąc": "Щомісяця",
    "Sprawdzenie czy pusty": "Перевірка якщо порожній",
    "Właściciel został dodany.": "Власника додано.",
    "Pracownicy": "Співробітники",
    "Historia zadania": "Історія завдань",
    "Nieobecność od": "Відсутність від",
    "Kategoria została zaktualizowana.": "Категорія була оновлена.",
    "Całkowity czas": "Загальний час",
    "Przetwarzane": "Оброблені",
    "Data zmiany statusu do": "Дата зміни стану до",
    "Przejdź do Checklisty": "Перейти до чек листа",
    "Kwota rezerwacji": "Сума бронювання",
    "Zacznij pisać aby wyszukać miasto...": "Почніть вводити текст для пошуку міста...",
    "30 minut": "30 хвилин",
    "Dodanie roli": "Додавання ролі",
    "Wysyłaj tym kanałem": "Надіслати через цей канал",
    "Zmień kolejność punktów": "Змінити порядок пунктів",
    "Prywatne": "Приватний",
    "Wszystkie obiekty:": "Всі об'єкти:",
    "Inwentaryzaje": "Інвентаризація",
    "brak danych": "бракує даних",
    "Usuń wszystkie tagi": "",
    "Dodanie działu": "Додавання відділу",
    "Zmień nazwę": "Перейменувати",
    "Exclusivity": "Exclusivity",
    "Dodaj nieruchomość": "Додати нерухомість",
    "Domyślna wartość": "Вартість за замовчуванням",
    "Powiadomienie o zmianach": "Повідомлення про зміни",
    "Nie udało się zaktualizować zlecenia.": "Не вдалося оновити замовлення.",
    "Wyliczenie stawki godzinowej (statystyczna)": "Розрахунок погодинної ставки (статистичний)",
    "Zacznij pisać aby wyszukać zaopatrzenie...": "Почніть вводити текст для пошуку припасів...",
    "Poprawne": "Правильно",
    "Zapisz trasę": "Зберегти маршрут",
    "Rodzaj odpowiedzi": "Тип відповіді",
    "Upload": "Завантажити",
    "Data dodania kosztu": "Дата додавання вартості",
    "Właściciel": "Власник",
    "Etykiety": "Мітки",
    "Typ rezerwacji": "Тип бронювання",
    "Odznacz wszystkie": "Зняти прапорець для всіх",
    "Anuluj": "Скасувати",
    "Treści odpowiedzi są wymagane": "Потрібен зміст відповідей",
    "Rezerwacja właścicielska": "Бронювання власника",
    "Wczutuję...": "",
    "Tłumacz checklistę": "Перекласти контрольний список",
    "Koszt dla nieruchomości roboczej": "Вартість робочого майна",
    "Załączone zdjęcia": "Прикріплені фотографії",
    "Dane wydziału zostały zaktualizowane.": "Дані відділу були оновлені.",
    "Kopiuj numer rezerwacji": "Копіювати номер бронювання",
    "Wymagaj znaków specjalnych w hasłach": "Вимагати спеціальні символи в паролях",
    "Aktywni": "Активні",
    "Wpis został dodany.": "Запис додано.",
    "Szczegóły": "Деталі",
    "Brak historii zmian": "",
    "po %0 nieudanych próbach logowania": "після %0 невдалих спроб входу",
    "Nazwa źródła danych": "Назва джерела даних",
    "Nazwa ulicy (StreetName)": "Назва вулиці",
    "Odpowiedź 2": "Відповідь 2",
    "Administracja - Zespoły": "Адміністрування - Команди",
    "Użytkownik posiada pełne uprawnienia": "Користувач має повні права",
    "Liczba inspektorów": "Кількість інспекторів",
    "Pole zawiera": "Поле містить",
    "Rezerwacja właściciela": "Бронювання власника",
    "Niedostępne": "Недоступно",
    "Zapytanie": "Запит",
    "Odrzucone": "Відхилено",
    "Wygasłe": "Термін дії минув",
    "Anulowane": "Скасовано",
    "Zamknięte": "Закрито",
    "Zarezerwowane": "Зарезервовано",
    "Potwierdzone": "Підтверджено",
    "Katalog został utworzony.": "Створено каталог.",
    "Dodanie dzielnicy": "Додавання району",
    "Data zdarzenia": "Дата події",
    "Edytuj stawkę za godzinę": "Редагуй ставку за годину",
    "Profil użytkownika": "Профіль користувача",
    "ID nazwa obiektu": "ID назва об'єкту",
    "Stała wartość": "Стала вартість",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Помилка 404. Запитуваний ресурс не був знайдений.",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Зберегти маршрут і відправити його водієві?",
    "Rola została dodana.": "Роль додана.",
    "Następna inwentaryzacja": "Наступна інвентаризація",
    "Godzina wykonania": "Час виконання",
    "Pokaż szczegóły": "Показати подробиці",
    "Wszyscy": "Всі",
    "Urlop został zaktualizowany.": "Відпустка актуалізована.",
    "Miasto zostało dodane.": "Місто додалося.",
    "(AirBnb) Wysłano żądanie do portalu": "(AirBnb) Запит висланий до портала",
    "ZMIANA": "ЗМІНА",
    "REGON": "REGON",
    "Kanały włączone w ustawieniach aplikacji": "Канали, увімкнені в налаштуваннях програми",
    "Edycja użytkownika": "Редагування користувача",
    "Wyłącz powiadomienia": "Вимкнути сповіщення",
    "Zresetuj hasło": "Скинути пароль",
    "Wstecz": "Назад",
    "Załącz zdjęcia": "Прикріпити фотографії",
    "Nieruchomości (Data przyjazdu)": "Нерухомості (дата прибуття)",
    "Wartość musi być liczbą dodatnią": "Вартість має бути додатним числом",
    "Fiirma została zaktualizowana.": "Фіірма була оновлена.",
    "Przypisane miasta do regionu:": "Міста, закріплені за регіоном:",
    "Imie i nazwisko właściciela": "Ім'я власника",
    "Nazwa działu": "Назва відділу",
    "Hasło do sieci Wi-Fi": "Пароль від мережі Wi-Fi",
    "Etykieta": "Мітка",
    "Udostępnij": "Поділитися",
    "Cancelled by owner": "Cancelled by owner",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "",
    "Wyświetl również zarchiwizowane formularze": "Перегляд також заархівованих форм",
    "jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji": "якщо потрібен контакт, будь ласка, вкажіть, з ким і коли, а також контактні дані, якщо вони відрізняються від даних бронювання",
    "Grupa": "Група",
    "Under request": "Under request",
    "Liczba pracowników": "Кількість співробітників",
    "Dodaj zlecenie": "Додати замовлення",
    "Wpisz komentarz...": "Введіть коментар...",
    "Komunikat walidacji": "Повідомлення про перевірку",
    "Wpisz nazwę regionu...": "Введіть назву регіону...",
    "Błędne": "Неправильне",
    "Zasięg": "Діапазон",
    "Język:": "Мова:",
    "Ukryj przycisk": "Приховати кнопку",
    "Pole \"Tytuł\" jest wymagane.": "Поле «Назва» є обов’язковим для заповнення.",
    "Pralnia": "Пральня",
    "Ostatnia wiadomość - użytkownik": "Останнє повідомлення - користувач",
    "Elementy inwentaryzacji": "Елементи інвентаризації",
    "Przypisane miasta": "Призначені міста",
    "UWAGA! Nieruchomość jest już przypisana od innego właściciela": "Увага! Нерухомість вже призначена від іншого власника",
    "Wszystkie niezapisane zmiany zostaną utracone.": "Усі незбережені зміни будуть втрачені.",
    "Usuń zaznaczone": "",
    "Osoba zastępująca": "Особа на заміну",
    "Kanały komunikacji": "Канали зв'язку",
    "Nazwa nieruchomości": "Назва об'єкта нерухомості",
    "Kroki": "Кроки",
    "Strona została usunięta.": "Сторінку видалено.",
    "Osoba przypisana do zadania": "Особа, призначена для виконання завдання",
    "Pokaż czat": "Показати чат",
    "Powiększ": "Збільшити",
    "Filtr globalny": "Глобальний фільтр",
    "Brak kluczy": "Бракує ключів",
    "Polski": "Польська",
    "Cztery kolumny": "Чотири стовпці",
    "Avantio ID nieruchomości": "Авантіо ID нерухомості",
    "Wybierz kierowce": "Виберіть водія",
    "Brak zadań": "Немає завдань",
    "Zlecenie zostało usunięte.": "Наказ видалено.",
    "Opis zadania": "Опис завдання",
    "Pliki do wysłania: %0": "Файли для висилання: %0",
    "Ta nieruchomość już posiada takie wyposażenie.": "Ця нерухомість вже має таке обладнання.",
    "OwnerService": "Сервіс власника",
    "Przyznaj dostęp": "Надати доступ",
    "Ładuję zgłoszenia...": "Завантажую заявки...",
    "Wstaw kontrolkę": "Вставити елемент управління",
    "Top kosztów wg miast": "Кращі ціни по містах",
    "Nieprawidłowy adres email": "Недійсна адреса електронної пошти",
    "Brak przypisanych użytkowników.": "Немає призначених користувачів.",
    "Nie znaleziono szczegółów zmiany": "Деталі змін не знайдено",
    "Wybierz pliki do dodania": "",
    "Generuj PDF": "Створити PDF",
    "Brudne": "Брудний",
    "Nr nieruchomości Guesty": "Нерухомість № Гостьовий",
    "Ta czynność została wykonana przez kogoś innego. Odśwież aplikację.": "Ця дія була виконана іншою особою. Оновіть програму.",
    "Poprzedni miesiąc": "Попередній місяць",
    "Nieaktywna": "Неактивна",
    "Strona": "Сторінка",
    "Nowa data": "Нова дата",
    "Typ plików": "",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "Вставте два стовпця 2/3 і 1/3",
    "Obojętny": "Байдужий",
    "Twoje hasło wygasło. Zmień je na nowe.": "Термін дії вашого пароля минув. Змініть його на новий.",
    "Token": "Toкен",
    "Ukryj przypisane zadania": "Приховати призначені завдання",
    "Baza danych tego klienta jest nieaktualna. Uruchom aktualizację za pomocą przycisku na dole formularza.": "База даних цього клієнта застаріла. Запустіть оновлення за допомогою кнопки внизу форми.",
    "Typ szablonu": "Тип шаблону",
    "Dodaj element": "Додати елемент",
    "${StatusName(StatusEnum[this.form.bookingType])}": "${StatusName(StatusEnum[this.form.bookingType])}",
    "Bardzo źle": "Дуже погано",
    "Przywrócić użytkownika i jego wiadomości?": "Повернути користувача і його повідомлення?",
    "Administracja": "Адміністрування",
    "Szef regionu": "Очільник області",
    "Zadanie znajduje się na trasach:": "",
    "Ilość": "Кількість",
    "Średnio": "В середньому",
    "Logowanie zakończyło się niepowodzeniem.": "Не вдалося ввійти.",
    "Opisy": "Описи",
    "Wybierz zaznaczone": "Виберіть позначене",
    "Stałe/miesięczne": "Постійне/місячне",
    "Wydział / Rola": "Відділ / Роль",
    "Trasa została zapauzowana": "Маршрут призупинено",
    "Wybierz typy powiadomień, które chcesz wyłączyć:": "Виберіть типи сповіщень, які потрібно відключити:",
    "Wysłano kolejne powiadomienie": "Відправлено чергове повідомлення",
    "Wybierz punkt": "Виберіть пункт",
    "Regiony": "Регіони",
    "Użytkownik został dodany do zespołu.": "Користувач був доданий в команду.",
    "Źródło danych zostało zaktualizowane.": "Джерело даних оновлено.",
    "Przesuń na dół": "Проведіть вниз",
    "Pliki zostały usunięte": "",
    "Zobacz sesję użytkownika": "Переглянути сеанс користувача",
    "Kwota": "Сумма",
    "Szef Regionu": "Очільник області",
    "Dane kosztu": "",
    "Wartość musi być liczbą całkowitą": "Вартість має бути цілим числом",
    "Początek długości geograficznej użytkownika": "Початок довготи користувача",
    "Akcja": "Дія",
    "Ukryj już zaplanowane punkty": "Приховати вже заплановані точки",
    "Właściciel aktywny": "Активний власник",
    "Zawsze": "Завжди",
    "Typ dodanego kosztu": "Тип доданої вартості",
    "Dodaj sekcję": "",
    "Powiązania z dzielnicą": "Зв'язки з районом",
    "Wpisz nazwę dzielnicy...": "Введіть назву району...",
    "Sortuj po": "Сортувати за",
    "Informacje": "Інформація",
    "Do sprawdzenia - przeniesione": "Підлягає перевірці - переміщенню",
    "Potwierdzenie usunięcia": "Підтвердження видалення",
    "Miasta": "Міста",
    "Lista nieruchomości": "Список нерухомості",
    "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Поле «%0» не містить дійсної URL-адреси.",
    "zaznacz wszystko": "вибрати все",
    "Tag został usunięty.": "Тег було видалено.",
    "Adres 2": "Адреса 2",
    "Wartość domyślna": "Вартість за замовчуванням",
    "Brak zadania": "Бракує завдання",
    "Nazwa nieruchomości roboczej": "Найменування робочого майна",
    "Generuję plik...": "Генерую файл...",
    "Opcje": "Параметри",
    "Imie i nazwisko osoby, która dodawała koszty": "Ім'я і прізвище особи, яка додала витрати",
    "Pozostało %0 znaków.": "Залишилося %0 знаків.",
    "Nie udało się zmienić statusu zadania": "Не вдалося змінити статус завдання",
    "Kwota brutto": "",
    "Nazwa katalogu": "Назва каталогу",
    "Wstaw dwie równe kolumny": "Вставте два рівних стовпця",
    "Zastępstwo": "Заміна",
    "Ma dzisiaj": "На сьогоднішній день",
    "Grafik pracowniczy": "Робочий графік",
    "Adres": "Адреса",
    "Narzędzia": "Інструменти",
    "Wersja": "",
    "Dziś": "Сьогодні",
    "Odejmowanie": "Віднімання",
    "Kolor": "колір",
    "Brak daty": "Немає дати",
    "Obciążenie Magazyn": "Плата на рахунок Складу",
    "Kwota za zadania": "Сумма за завдання",
    "Odpowiedź 4": "Відповідь 4",
    "Adres e-mail": "Адреса e-mail",
    "Zapisz i wróć": "Зберегти і повернутися назад",
    "Wiadomość": "Відомість",
    "Lipiec": "Липень",
    "Typ nieruchomości": "Тип нерухомості",
    "Koordynator HK": "Координатор HK",
    "Obciążenie Właściciela": "Плата стягується з Власника",
    "Host główny": "Головний хост",
    "Dodanie zastępstwa": "Додавання заміни",
    "Data usunięcia": "Дата видалення",
    "Zapomniałeś hasła?": "Забули пароль?",
    "Zadanie zostało ukończone przez kogoś z Twojego zespołu.": "Завдання виконав хтось із вашої команди.",
    "Niski": "Низький",
    "Domyślny czas rezerwacji": "Час бронювання за замовчуванням",
    "Stwórz czat z zadania": "Творіть чат завдання",
    "Zakończone": "Завершено",
    "Not Available": "Not Available",
    "Firma": "Копанія",
    "Typ konta": "Тип рахунку",
    "Dodaj szablon": "Додати шаблон",
    "Dodanie serwera": "Додавання сервера",
    "Zespoły": "Команди",
    "Miesiąc": "Місяць",
    "Załączniki": "Вкладення",
    "Zgłoszenie serwisowe": "Запит на обслуговування",
    "Inspekcje": "Інспекції",
    "Brak wersji": "Немає версії",
    "Anuluj i wyjdź z kreatora": "Скасування та вихід із майстра",
    "Wyszukuję...": "Пошук...",
    "Marzec": "Березень",
    "Filtry globalne": "Глобальні фільтри",
    "Zadanie zostało dodane.": "Завдання додано.",
    "Dodawanie": "Додавання",
    "Dane dostępowe": "Доступ до даних",
    "Data zakończenia od": "Дата закінчення від",
    "Nie możesz edytować tego punktu. Został on już oznaczony jako odwiedzony": "Ви не можете редагувати цей пункт. Його вже позначено як відвіданий",
    "Numer rezerwacji": "Номер резервації",
    "usunięto dzielnice": "видалено район",
    "edycja": "редагування",
    "Wyszukaj nieruchomość...": "Пошук нерухомості...",
    "reset": "перезавантаження",
    "Nie udało się pobrać listy działów": "Не вдалося завантажити список відділів",
    "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Виберіть тип сповіщення щоб побачити доступні ключі.",
    "Wybierz inspektora": "Виберіть інспектора",
    "Notatka/Komentarz": "",
    "Nie podano wymaganej ilości znaków: %0.": "Кількість символів не вказано: %0.",
    "Dodaj urlop": "Додай відпустку",
    "Wynagrodzenia HK": "Заробітна плата НК",
    "Gotowe": "Готовий",
    "Wykonane zadania": "Виконати завдання",
    "Przywrócić wiadomość?": "Повернути повідомлення?",
    "5 minut": "5 хвилин",
    "Get it on Google Play": "Отримайте його в Google Play",
    "Nazwa klienta": "Ім'я клієнта",
    "Zlecenie zostało zaktualizowane.": "Наказ оновлено.",
    "SUMA": "СУМА",
    "Edytuj obraz": "Редагувати зображення",
    "Nazwa tagu": "Назва тегу",
    "Typ powiadomienia": "Тип повідомлення",
    "Komentarz został zapisany": "",
    "Usuń datę": "Видалити дату",
    "Wystąpił problem z dostępem do kamery": "Виникла проблема з доступом до камери",
    "Ulica": "Вулиця",
    "Ukryj czat": "Приховати чат",
    "Minimalna długość hasła": "Мінімальна довжина пароля",
    "Nie masz uprawnień do panelu administracyjnego.": "У вас немає дозволів на панель адміністрування.",
    "Ilość gości": "Кількість гостей",
    "checklista": "контрольний список",
    "Styczeń": "Січень",
    "Progress Gotowości": "Готовий процес",
    "Nie udało się ustawić miasta.": "Не вдалося встановити місто.",
    "Pracownicy z brakującymi ustawieniami wynagrodzenia": "Працівники з відсутніми налаштуваннями заробітної плати",
    "Dodaj inwentaryzacje": "Додати інвентаризацію",
    "Wygeneruj pilik": "Створити файл",
    "Typ wynagrodzenia": "Тип заробітної плати",
    "zaznacz wszystko": "вибрати все",
    "Filtr globalny": "Глобальний фільтр",
    "Rezerwacje anulowane": "Бронювання скасовано",
    "Cofam": "Вертаюсь",
    "Dane dostępu": "Дані доступу",
    "Przypisz obiekty": "Призначити об'єкти",
    "Stawka nieruchomości": "Сумма нерухомості",
    "Stwórz czat": "Створіть чат",
    "Dobrze": "Добре",
    "Kanały komunikacji": "Канали зв'язку",
    "Polska": "Польща",
    "Adres email nadawcy": "Адреса електронної пошти відправника",
    "Wartości": "Цінності",
    "Wczytuję...": "Завантажувати...",
    "Zrób zdjęcie": "Зробіть фото",
    "Zdecydowanie nie": "Однозначно ні",
    "Koniec dystansu": "Кінець дистанції",
    "Zastępuje osobę": "Замінює людину",
    "Nazwa zadania": "Назва завдання",
    "Nazwa źródła danych": "Назва джерела даних",
    "Zastępstwa": "Заміни",
    "Brak zadań": "Немає завдань",
    "Stwórz zadanie z tej rezerwacji": "Створіть завдання з цього бронювання",
    "Przyznaj dostęp": "Надати доступ",
    "Dark mode": "Темний режим",
    "Klient aktywny": "Активний клієнт",
    "Zobacz czaty": "Переглянути чати",
    "Maksymalny rozmiar pliku w MB": "Максимальний розмір файлу в Мб",
    "Rola": "Роль",
    "Strona została usunięta.": "Сторінку видалено.",
    "Ładuję zgłoszenia...": "Завантажую заявки...",
    "Domyślna firma": "Компанія за замовчуванням",
    "Wklej komponent": "Вставте компонент",
    "Odpowiedź 3": "Відповідь 3",
    "Przywrócić wiadomość?": "Повернути повідомлення?",
    "Zmień rozmiar": "Змінити розмір",
    "Zapisuję...": "Записую...",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "Назва форми не може бути довшою за % 0 символів",
    "Kolor obramowania": "Колір бордюру",
    "Podgląd szablonu e-maila": "Попередній перегляд шаблону Електронної Пошти",
    "Nadpisz kwotę dla": "Перепишіть квоту для",
    "Filtry kalendarza": "Фільтри календаря",
    "Avantio ID nieruchomości": "Авантіо ID нерухомості",
    "Zapisz": "Зберегти",
    "Tag nieruchomości": "Тег нерухомості",
    "Zgoda": "Згоден",
    "Co 2 godziny": "Кожні 2 години",
    "Klient został dodany.": "Клієнта додано.",
    "Zgłoszenia w apartamencie": "Зголошення в апартменті",
    "Opłacono": "Сплачено",
    "Materiał": "Матеріал",
    "Filtry globalne": "Глобальні фільтри",
    "Brak tagów": "Немає тегів",
    "Zablokowano możliwość edycji": "Можливість редагування заблокована",
    "Data modyfikacji": "Дата зміни",
    "Data Zmiany": "Дата зміни",
    "Typ dodanego kosztu": "Тип доданої вартості",
    "Potwierdzenie archiwizacji": "Підтвердження архівації",
    "Ostatnie sprzątanie": "Останнє прибирання",
    "Data ukończenia": "Дата завершення",
    "Utworzone": "Створене",
    "Wersje dokumentu": "Версії документів",
    "Testowy adres email": "Тестова адреса електронної пошти",
    "Poprzednia strona": "Попередня сторінка",
    "Powiązania z dzielnicą": "Зв'язки з районом",
    "Zgłoszone problemy": "Повідомлені проблеми",
    "Dodanych plików %0 (limit wynosi %1).": "Доданих файлів %0 (ліміт складає %1).",
    "Pobyt: ": "Перебування: ",
    "Checklista:": "Чек-лист:",
    "Zapisz komentarz": "",
    "Migracje": "Міграція",
    "Nie można przenosić plików między sekcjami o różnych typach": "",
    "Jest to lista obiektów które nie mają jeszcze przypisanego właściciela.": "Це список об'єктів, які ще не мають призначеного власника.",
    "Czy na pewno chcesz usunąć tę sekcję?": "",
    "Łóżeczko": "Ліжечко",
    "Brak działu nadrzędnego": "Бракує головного відділу",
    "Adres firmy": "Адреса компанії",
    "Kwota kosztów": "Сума витрат",
    "Nazwa źródła": "Назва джерела",
    "Katalog": "Каталог",
    "Dane nieruchomości": "Дані про нерухомість",
    "Wstaw trzy kolumny 1/3": "Вставте три стовпці 1/3",
    "Rola": "Роль",
    "CustomerService": "Клієнтське обслуговування",
    "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "Цей канал має можливість відправляти форматований текст.",
    "BOK": "Обслуговування клієнтів",
    "Koszt pracownika": "",
    "Dział": "Відділ",
    "Bazy danych": "База даних",
    "Zapauzowano:": "Призупинено:",
    "Wyjazd": "Від'їзд",
    "pl": "..pl",
    "Przełącznik": "Перемикач",
    "Pokaż tytuł formularza": "Показати заголовок форми",
    "Wyposażenie": "Обладнання",
    "Neutralne": "Нейтральні",
    "Dane kierowcy: ": "Дані водія: ",
    "Nazwa bazy danych": "Ім'я бази даних",
    "HR": "Управління персоналом",
    "NIP firmy": "NIP firmy (Номер платника ПДВ компанії)",
    "Adres serwera": "Адреса сервера",
    "Zadania dzisiaj": "Сьогоднішні завдання",
    "Ten element nie zawiera menu kontekstowego.": "Цей пункт не містить контекстного меню.",
    "Zastępstwa": "Заміни",
    "Wzorzec": "Зразок",
    "Edytuj szablon": "Редагувати шаблон",
    "Usunięte zadanie": "Видалене завдання",
    "Data od": "Дата від",
    "Data ukończenia": "Дата завершення",
    "Szczegóły zdarzenia": "Детальніше про подію",
    "Zapisz jako": "Зберегти як",
    "Wyposażenie zostało zaktualizowane.": "Обладнання оновлено.",
    "Edytuj uprawnienia": "Редагувати дозвіл",
    "Pokaż": "Показати",
    "Data realizacji": "Дата реалізації",
    "Jestem w drodze": "Я в дорозі",
    "Poczta": "Пошта",
    "Numer Guesty": "Номер гостя",
    "Dostęp przyznany": "Доступ надано",
    "Wyszukaj": "Пошук",
    "Nazwa nadawcy": "Ім'я відправника",
    "Filtry": "Фільтри",
    "Firma własna": "Власна компанія",
    "Przepracowana liczba godzin w miesiącu": "Відпрацьована кількість годин на місяць",
    "Zadanie na dziś": "Завдання на сьогодні",
    "W momencie tworzenia kosztu": "На момент створення вартості",
    "Uczestnicy rozmowy:": "Учасники розмови:",
    "linie": "лінії",
    "Ilość punktów: ": "Кількість балів: ",
    "Przypisane tagi:": "Приписані теги:",
    "Otwórz w nowym oknie": "Відкрити в новому вікні",
    "Dostępne czaty:": "Доступні чати:",
    "Usługi": "Послуги",
    "Oczekuje na wysłanie": "В очікуванні відправки",
    "Nazwa trasy": "Назва маршруту",
    "Informacje o czacie": "Інформація про чат",
    "Multimedia": "Мультимедіа",
    "Dopuść brak odpowiedzi": "Дозволити відсутність відповіді",
    "Dane Adresowe": "Адресні дані",
    "Wynagrodzenia Pracowników": "Заробітна плата Працівників",
    "Nazwa pokoju": "Назва кімнати",
    "Niedziela": "Неділя",
    "Wymagane jest ustawienie minimalnej długości hasła": "Необхідно встановити мінімальну довжину пароля",
    "Zgłoszenia w apartamencie": "Зголошення в апартменті",
    "To miasto jest już przypisane do użytkownika.": "Це місто вже закріплений за користувачем.",
    "Dodaj źródło": "Додати джерело",
    "Wybierz sekcję, do której chcesz dodać pliki": "",
    "Data zakończenia/wykonania": "Дата закінчення/виконання",
    "Zapisz nową kolejność punktów": "Збережіть новий порядок точок",
    "pokaż więcej...": "показати більше...",
    "Nie znaleziono nieruchomości": "",
    "Źródła danych": "Джерела даних",
    "Przypisane do:": "Призначається:",
    "Dodaj rolę": "Додати роль",
    "Dodaj opłaconą kwotę": "Додати сплачену суму",
    "Zapisz filtr": "Зберегти фільтр",
    "Utworzył": "Створити",
    "Suma wynagrodzeń koordynatorów": "Сума заробітної плати координаторів",
    "Harmonogram został zmieniony": "Розклад змінено",
    "Typ obiektu": "Тип об'єкта",
    "Wyczyść sesję": "Очистити сесію",
    "Minuty": "Хвилини",
    "Nie udało się pobrać ról!": "Не вдалося завантажити ролі!",
    "Miasto zostało zaktualizowane.": "Місто оновилося.",
    "Bez dzielnicy": "Без району",
    "Aktywna nieruchomość": "Активна нерухомість",
    "Wewnętrznie": "Внутрішньо",
    "Tytuł formularza jest wymagany": "Назва форми є обов'язковою",
    "Powiadomienia zostały skonfigurowane.": "Сповіщення налаштовано.",
    "Pasek": "Ремінець",
    "Szablon został zaktualizowany.": "Шаблон оновлено.",
    "Liczba dziesiętna": "Десятковий",
    "Filtr został usunięty": "Фільтр видалено",
    "Zmiana motywu": "Зміна теми",
    "Rola przypisana do tego wydziału jest nieaktywna": "Роль, відведена цьому відділу, неактивна",
    "Numer konta bankowego": "Номер банківського рахунку",
    "Pokaż zadania bez przypisanej osoby": "Показувати завдання без призначеної особи",
    "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "Браузер, який ви використовуєте, не підтримує PUSH-повідомлення",
    "Gość": "Гість",
    "Ten miesiąc": "Цей місяць",
    "Koordynator Główny": "Головний координатор",
    "Firmy": "Компанії",
    "Nieudane": "Не вдалося",
    "Data utworzenia wersji": "Дата створення версії",
    "Raczej się nie zgadzam": "Я радше не згоден",
    "Nie udało się pobrać szczegółów zmiany": "Не вдалося завантажити відомості про зміни",
    "Dodaj koszt": "Додати вартість",
    "Wykonane": "Виконане",
    "Dane dostępu": "Дані доступу",
    "Członkowie zespołu": "Учасники команди",
    "Pre-booking": "Pre-booking",
    "Inwentaryzacje": "Інвентаризації",
    "Wszystkie zadania": "Всі завдання",
    "Data:": "Дата:",
    "Id": "Id",
    "Utwórz czat": "Створити чат",
    "Stawka PLN brutto za godzinę": "Сумма PLN брутто за годину",
    "Rozmiar": "Розмір",
    "Dodaj do regionu": "Додати до регіону",
    "Data zalogowania": "Дата входу",
    "Wysłano powiadomienie.": "Повідомлення надіслано.",
    "Trasy archiwalne": "Архівні маршрути",
    "Musisz wybrać obiekt na mapie": "Необхідно вибрати об'єкт на карті",
    "Pokaż filtry": "Показати фільтри",
    "do": "до",
    "Komentarz Konserwatora": "Коментар Техніка",
    "Imię właściciela": "Ім'я власника",
    "Obiekty": "Об'єкти",
    "Nie udało się wgrać pliku": "Не вдалося завантажити файл",
    "W drodze": "В дорозі",
    "Wyszukiwany ciąg znaków": "Рядок пошуку",
    "Udało się dodać nieruchomość do trasy": "Успішно додано нерухомість до маршруту",
    "Edycja wynagrodzenia za posprzątane obiekty dla:": "Редагування заробітної плати за прибраний апартамент для:",
    "Nieprawidłowy adres URL": "Недійсна URL-адреса",
    "Niestandardowy błąd": "Нестандартна помилка",
    "Koszt został usunięty": "",
    "Synchronizacja rezerwacji": "Синхронізація бронювання",
    "Manager Firmy Zewnętrznej": "Зовнішній менеджер компанії",
    "Faktyczny czas pracy": "Фактичний робочий час",
    "Ustawienia zostały zaktualizowane.": "Налаштування були оновлені.",
    "Nie udało się pobrać zadań": "Не вдалося завантажити завдання",
    "Aktywna": "Активна",
    "Wprowadzona wartość nie jest poprawna": "Введене значення невірне",
    "Wybór języka": "Вибір мови",
    "Zmień nazwę katalogu": "Перейменувати каталог",
    "Problemy": "проблеми",
    "Dzielnica została dodana.": "Район додано.",
    "Brak numeru": "Немає номера",
    "Kategoria została usunięta.": "Категорію видалено.",
    "Zadanie zostało włączone": "Завдання ввімкнуто",
    "Ankieta": "Анкета",
    "Koszty wg regionów": "Витрати по регіонах",
    "Dane właściciela": "Дані власника",
    "Wprowadzona wartość jest za wysoka": "Введене значення занадто велике",
    "Dodatkowe wynagrodzenie - kwota": "Додаткова винагорода - сума",
    "REGON firmy": "REGON фірми",
    "VAT (wyliczany automatycznie)": "",
    "Ukończone przez użytkownika": "Завершено користувачем",
    "Logo": "Логотип",
    "Tagi": "Теги",
    "Archiwalny": "Архівний",
    "Pokaż tytuł strony": "Показати заголовок сторінки",
    "Administracja - Kraje": "Адміністрування - Країни",
    "Pomoc": "Допомога",
    "Dane podstawowe": "Основні дані",
    "Sformatowany rzeczywisty czas pracy": "Відформатований фактичний робочий час",
    "Przesyłanie zdjęcia nie powiodło się": "Не вдалося завантажити фотографію",
    "dni temu": "днів тому",
    "Nie możesz rozpocząć obsługi tego zadania": "Не можна починати це завдання",
    "Zarządzaj": "Керуй",
    "Dane zadania": "Дані завдання",
    "Filmy": "",
    "Aktywny": "Активний",
    "Zacznik pisać Form lub Entry aby uruchomić podpowiadanie.": "Почніть вводити Form або Entry, щоб викликати підказку.",
    "Kalendarz nieruchomości": "Календар нерухомості",
    "Dodanie Notatki": "Додавання Примітки",
    "Bezpieczeństwo": "Безпека",
    "Dwie kolumny": "Два стовпці",
    "Administracja - Miasta": "Адміністрування - Міста",
    "Stawka mieszana została zaktualizowana.": "Змішана ставка актуалізована.",
    "Zacznij pisać aby wyszukać osobę...": "Почніть вводити текст, щоб шукати людину...",
    "Szczegóły rezerwacji": "Деталі бронювання",
    "Link do czatu": "Посилання на чат",
    "Kwota kosztu do": "Сума витрат до",
    "Podaj swój adres email": "Введіть свою адресу електронної пошти",
    "Edytuj Notatkę": "Редагувати примітку",
    "Nieruchomość zagrożona wypowiedzeniem": "Майно під загрозою припинення",
    "Nie udało się pobrać danych o rolach zalogowanego użytkownika": "Не вдалося отримати дані про роль користувача, який увійшов до системи",
    "Stawka za godzinę brutto": "Ставка за годину брутто",
    "To zadanie nie posiada jeszcze przypisanych użytkowników.": "Це завдання ще не має призначених користувачів.",
    "Uwzględnij miasto": "Включити місто",
    "Dodaj dane wydziału": "Додати дані відділу",
    "Czy na pewno chcesz ukryć wiadomość?": "Чи справді хочете сховати повідомлення?",
    "Układ": "Система",
    "Serwer plików": "Файловий сервер",
    "Kwota opłacona": "Сума сплачена",
    "Koniec szerokości geograficznej użytkownika": "Кінцева широта користувача",
    "Zadania": "Завдання",
    "ID obiektu": "ID об'єкту",
    "Serwer został zaktualizowany.": "Сервер оновлено.",
    "Srednie wynagrodzenie pracowników": "Середня заробітна плата працівників",
    "Zmiana rozmiaru obrazu": "Зміна розміру зображення",
    "źródło danych zostało dodane.": "додано джерело даних.",
    "Przypisane dzielnice:": "Закріплені райони:",
    "Nazwisko właściciela": "Прізвище власника",
    "Język": "Мова",
    "Stawka domyślna": "Ставка за замовчуванням",
    "Pokaż więcej": "Показати більше",
    "Odpowiedź 5": "Відповідь 5",
    "Weekend": "Вихідні",
    "Uwzględnij zadania z miesiąca:": "Включити завдання за місяць:",
    "Zamknięte przez": "Закрито",
    "Przypisane do": "Призначено до",
    "Historia logowania": "Історія входу",
    "Wstaw z prawej strony": "Вставити справа",
    "Data wykonania do": "Дата виконання до",
    "Zadanie zostało wznowione.": "Завдання було відновлено.",
    "Nie udało się pobrać listy serwerów baz danych": "Не вдалося отримати список серверів баз даних",
    "Data nieobecności od": "Дата відсутності від",
    "Ten region nie posiada jeszcze przypisanych miast.": "Цей регіон ще не має закріплених за собою міст.",
    "Masz nową wiadomość!": "Маєш нове повідомлення!",
    "Wpisz nazwę trasy": "Введіть назву маршруту",
    "Nieudane próby logowania": "Невдалі спроби входу",
    "Na pewno usunąć wybrane elementy?": "Дійсно видалити вибрані елементи?",
    "dzisiaj": "сьогодні",
    "Telefon": "Телефон",
    "Zadanie na nieruchomościach roboczych": "Завдання по робочим властивостям",
    "Usuń plik z listy": "Видалити файл зі списку",
    "Zmień dane kosztu": "Змінити дані сумми",
    "Zmień status edytowanej wersji": "Змінити статус відредагованої версії",
    "Filtry systemowe": "Системні фільтри",
    "Wynagrodzenia Konserwatorzy": "Заробітна плата техніки",
    "Walidacja certyfikatu SSL": "Перевірка SSL сертифіката",
    "Operacja": "хірургічне втручання",
    "Wybrane miasto": "Вибране місто",
    "Stawka za typ apartamentu": "Ставка за тип апартаменту",
    "Mnożenie": "Множення",
    "Uwzględniaj Miasta": "Включити Міста",
    "Edycja zastępstwa": "Редагування заміни",
    "Zaczyna sie od": "Починається з",
    "Nieobecny do": "Відсутній до",
    "Dodaj zaopatrzenie": "Додати постачання",
    "Email został wysłany.": "Імейл висланий.",
    "Co 20 minut": "Кожні 20 хвилин",
    "km": "кмс",
    "Oczekujące": "Очікуванні",
    "Confirmed": "Підтверджений",
    "Godzina:": "Година:",
    "Administratorzy": "Адміністратори",
    "Notatki": "Нотатки",
    "Edycja stawki godzinowej dla:": "Редагування ставки за годину для:",
    "Dodaj opis...": "Додайте опис...",
    "Wynagrodzenie stałe brutto": "Фіксована заробітна плата брутто",
    "Przejdź do rezerwacji": "Перейти до бронювання",
    "Parametry, wymagane do wykonania zapytania:": "Параметри, необхідні для виконання запиту:",
    "Pliki zostały pobrane": "",
    "gotowe": "готово",
    "Co 5 minut": "Кожні 5 хвилин",
    "Miasta:": "Міста:",
    "Wynagrodzenie za przepracowane godziny": "Оплата за відпрацьовані години",
    "10 minut": "10 хвилин",
    "Typ mime": "Тип MIME",
    "Edytuj urlop": "Редагуй відпустку",
    "Powtórzone": "Повторюється",
    "Azure AD": "Azure AD",
    "Prestiżowe": "Престижні",
    "Sformatowany czas całkowity": "Відформатований загальний час",
    "Liczba małych prześcieradeł": "Кількість невеликих аркушів",
    "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "Доступне нове оновлення. Будь ласка, збережіть хід роботи і натисніть кнопку \"Оновити\". Ви також можете прийняти оновлення, оновивши вікно браузера. Відмова від оновлення може призвести до помилок.",
    "Użytkownik został zablokowany, a jego wiadomość ukryte.": "Користувач був заблокований, і його повідомлення приховано.",
    "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Тільки сервер розробки. Не використовувати в режимі виробництва. ",
    "Dział aktywny": "Активний відділ",
    "Wynagrodzenia mieszane": "Змішана заробітна плата",
    "Inne": "Інше",
    "Zdarzenie": "Подія",
    "Co 12 godzin": "Кожні 12 годин",
    "Zadanie zostało wyłączone": "Завдання вимкнуто",
    "Wyślij": "Надіслати",
    "Nie udało się zapisać notatki": "Не вдалося зберегти нотатку",
    "Nie możesz modyfikować uprawnień": "Не можна змінити дозволи",
    "Bezpieczne połączenie SSL": "Безпечне з'єднання SSL",
    "Przepracowana ilość godzin": "Відпрацьована кількість годин",
    "Dane dostępowe:  ": "Дані доступу:  ",
    "Końcowy stan licznika": "Кінцевий стан лічильника",
    "Wyznacz punkty": "Позначте точки",
    "%0 znaków": "%0 знаків",
    "więcej...": "більше...",
    "Imię i nazwisko pracownika": "Ім'я і прізвище працівника",
    "Wpisz treść wiadomości.": "Введіть текст повідомлення.",
    "Plik jest wysyłany": "Файл відправлено",
    "Brak wyników": "Немає результатів",
    "Nazwa sieci Wi-Fi": "Назва мережі Wi-Fi",
    "Sekcja została utworzona": "",
    "Trasa została zaktualizowana.": "Маршрут оновлено.",
    "Nazwa checklisty": "Назва чек-листа",
    "Zlecenia magazynowe": "Замовлення на склад",
    "Biuro": "Офіс",
    "Ilość wyników do odrzucenia": "Кількість результатів для відхилення",
    "Paid": "Paid",
    "Notatka dla": "Примітка до",
    "Wybrana sekcja nie istnieje": "",
    "Numer mieszkania (Door)": "Номер квартири (Двері)",
    "Czas pomiędzy": "Час між",
    "Równość": "Рівності",
    "Podstawowe operacje na datach": "Основні операції з датами",
    "Zakończone przez": "Завершене",
    "Porównanie": "Порівняння",
    "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "Пароль повинен містити принаймні один спеціальний символ, наприклад: ~ @ # $ % ^ & *",
    "Przypisz do czatu": "Припис до чату",
    "Zdjęcie użytkownika": "Фото користувача",
    "Włączone": "Включений",
    "Wtorek": "Вівторок",
    "Upload plików": "Завантаження файлів",
    "Status formularza został zmieniony.": "Статус форми був змінений.",
    "Powrót": "Повернення",
    "Szczegóły zadania": "Деталі про завдання",
    "Pracownik niedostępny od": "Працівник недоступний від",
    "Dodaj zadanie": "Додати завдання",
    "Kategoria została dodana.": "Категорія додана.",
    "Rozliczone": "Розрахунковий",
    "(nowe wiadomości)": "(нові повідомлення)",
    "Usuń spacje": "Видалити пробіл",
    "Trasy dla Kierowców": "Маршрути для водіїв",
    "Nawiguj do kolejnego punktu": "Перехід до наступного пункту",
    "Testowe powiadomienie wysłane": "Тестове повідомлення надіслано",
    "Średni": "Середній",
    "Katalog został utworzony.": "Створено каталог.",
    "Miejscowość": "Місцевість",
    "Źle": "Погано",
    "Wytnij": "Вирізати",
    "Ładuję...": "Завантаження...",
    "Nieaktywni": "Неактивні",
    "Stwórz zlecenie z notatki": "Створення замовлення з нотатки",
    "Nie udało się usunąć szablonu": "Не вдалося видалити шаблон",
    "Źródło rezerwacji": "Джерело бронювання",
    "Zaznacz wszystkie w sekcji": "",
    "Właściciele": "Власники",
    "Wczytuję...": "Завантажувати...",
    "Zobacz trasę": "Подивитися маршрут",
    "Wybrane elementy zostały przeniesione.": "Вибрані елементи переміщено.",
    "Zamknięte przez użytkownika": "Закрито користувачем",
    "Kontrolki specjalizowane": "Спеціалізовані елементи управління",
    "Dodawanie inwentaryzacji": "Додавання інвентаризації",
    "Wybierz osobę spoza dzielnicy": "Виберіть людину за межами мікрорайону",
    "Stała wartość": "Стала вартість",
    "Data rejestracji": "Дата реєстрації",
    "Treści pytań są wymagane": "Потрібен зміст питань",
    "Planuj automatycznie w dniu zakończenia blokady": "Автоматично плануйте в день завершення блокування",
    "Data opuszczenia zespołu": "Дата відходу з колективу",
    "Zamiany zostały zapisane.": "Заміни були збережені.",
    "Brak przypisanych tagów.": "Ніяких тегів не призначено.",
    "Podano nieprawidłowe dane.": "Надані невірні дані.",
    "Konserwacje": "Обслуговування",
    "Dodatkowa kwota wynagrodzenia": "Додаткова сума зарплати",
    "Zacznij pisać aby wyszukać tag nieruchomości...": "Почніть писати для пошуку по тегу нерухомості...",
    "Wstaw stronę": "Вставити сторінку",
    "Moje konto": "Мій аккаунт",
    "co się wydarzyło": "що сталося",
    "Ilość łóżek jednoosobowe": "Кількість односпальних ліжок",
    "Wszystkie": "Всі",
    "Zwierzę": "Тварина",
    "wybierz długość": "виберіть довжину",
    "Nieruchomość została zaktualizowana.": "Нерухомість оновлено.",
    "Dodaj klienta": "Додати клієнта",
    "Usunięte zadania": "Видалене завдання",
    "Owner Booking": "Owner Booking",
    "Co 3 miesiące": "Кожні 3 місяці",
    "Nie możesz rozpocząć obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "Ви не можете розпочати виконання цього завдання, оскільки зараз виконуєте інше завдання",
    "${item.text}": "$ {елемент.текст}",
    "Wybrane": "Вибране",
    "Rodzaj nieruchomości": "Тип нерухомості",
    "Co pół roku": "Що півроку",
    "Nieruchomości robocze": "Робочі нерухомості",
    "Miasto apartamentu": "Місто квартири",
    "Podstawowe operacje na liczbach": "Основні операції з числами",
    "W przyszłości": "Попереду",
    "Wybrane pliki: {0}": "Вибрані файли: {0}",
    "Zgłoszone problemy": "Повідомлені проблеми",
    "odznacz wszystko": "відзнач все",
    "Kalendarz": "Календар",
    "Podana nazwa jest zajęta.": "Введене вами ім'я зайнято.",
    "Wysoki": "Високий",
    "Dobrze": "Добре",
    "Materiał": "Матеріал",
    "Statystyki pracownicze": "Статистика співробітників",
    "Sprzątanie": "Прибирання",
    "Udało się zaktualizować nieruchomości!": "Успішно оновлено нерухомість!",
    "Inwentaryzacja została usunięta.": "Інвентаризація видалена.",
    "Wynagrodzenia w regionie łącznie z wynagrodzeniami koordynatorów": "Зарплати в регіоні, включаючи зарплати координаторів",
    "Zaloguj się": "Ввійти",
    "Edytuj dane wydziału": "Редагувати дані відділу",
    "Pytanie 3": "Питання 3",
    "Lista rozwijana": "Випадаючий список",
    "Dni": "Днів",
    "Potwierdź usunięcie": "Підтвердити видалення",
    "Przywróć oryginał": "Відновити оригінал",
    "Podziedziałek - Piątek": "Понеділок - П'ятниця",
    "Godzina wymeldowania": "Час виїзду",
    "Data i czas": "Дата й час",
    "Id rezerwacji": "Ідентифікатор бронювання",
    "Zmień widok": "Змінити вигляд",
    "Suma wynagrodzeń pracowników": "Сума заробітної плати працівників",
    "Zmień ustawienia": "Зміна параметрів",
    "Wiadomości": "Відомості",
    "Data modyfikacji do": "Дата зміни до",
    "Baza danych": "База даних",
    "Główny Konserwator": "Головний консерватор",
    "Ilość sypialni": "Кількість спалень",
    "Dzielnica została usunięta.": "Район був видалений.",
    "Kod pocztowy": "Поштовий індекс",
    "Do akceptacji": "На ухвалення",
    "Tłumaczę...": "Перекладаю...",
    "Rzeczywisty czas pracy": "Фактичний робочий час",
    "Dodaj wpis": "Додати запис",
    "Edytuj wpis": "Редагувати запис",
    "Zwiń": "Згорнути",
    "Data rozpoczęcia": "Дата початку",
    "Dodane przez: ": "Додав: ",
    "Wiadomość została przywrócona.": "Повідомлення було відновлено.",
    "Właściciel regionu": "Власник регіону",
    "Brak szczegółów zmian": "Подробиці без змін",
    "Wpisz tytuł...": "Введіть заголовок...",
    "Uwaga! wraz z miastem": "Увага! разом з містом",
    "Usunięto": "Вилучено",
    "Profil został zaktualizowany.": "Ваш профіль оновлено.",
    "Nazwa:": "Назва:",
    "Dostępne obiekty:": "Доступні об'єкти:",
    "Ustawienia zostały zapisane.": "Налаштування збережено.",
    "Attempt of reservation by Credit Card": "Спроба резервації за допомогою кредитної картки",
    "Czas uruchomienia": "Час запуску",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Зберегти маршрут і відправити його водієві?",
    "Zacznij pisać aby wyszukać regionu...": "Почніть вводити текст для пошуку регіону...",
    "Avantio ID": "Авантіо ID",
    "Co 3 godziny": "Кожні 3 години",
    "Godziny": "Години",
    "Zespół został usunięty.": "Команду прибрали.",
    "Wybierz plik": "Виберіть файл",
    "Tag został zaktualizowany.": "Тег актуалізований.",
    "Dodanie zespołu": "Додавання команди",
    "Przesuń do góry": "Проведіть вгору",
    "Koszty": "Витрати",
    "przejdź do komentarzy": "перейти до коментарів",
    "Wersje dokumentu": "Версії документів",
    "Dodanych plików %0 (limit wynosi %1).": "Доданих файлів %0 (ліміт складає %1).",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Не всі вибрані елементи переміщено. У вас немає необхідних дозволів або, якщо ви переміщуєте каталоги, каталог призначення є підкаталогом вихідного каталогу. Каталоги та файли, які не вдалося перемістити, залишаються у вкладці Вибране.",
    "Zakończ zadanie": "Закінчити завдання",
    "Indywidualne tokeny": "Індивідуальні жетони",
    "Zacznij pisać aby wyszukać firmę...": "Почніть вводити текст для пошуку компанії...",
    "Nazwa firmy": "Назва компанії",
    "Małe znaki": "Символи з малої літери",
    "Nie można usunąć swojego konta.": "Ви не можете видалити свій обліковий запис.",
    "Uwzględnij wydziały podrzędne": "Включити підпорядковані відділи",
    "Kwota pozostała": "Залишкова кількість",
    "Administracja - Role": "Адміністрування - Ролі",
    "Zadanie na trasie": "",
    "Ustawienia powiadomień zostały zapisane": "Налаштування сповіщень збережено",
    "Tekst": "Текст",
    "Stan licznika koniec": "Статус кінцевого лічильника",
    "Plik został przeniesiony": "",
    "Dokument %0": "Документ %0",
    "Wpisz nazwę miasta...": "Введіть назву міста...",
    "Data zmiany statusu od": "Дата зміни статусу від",
    "Lista powiadomień": "Список повідомлень",
    "Formularz został dodany.": "Форму додано.",
    "co 3 miesiące": "кожні 3 місяці",
    "Brak odpowiedzi": "Немає відповіді",
    "Litery": "Літери",
    "Data utworzenia": "Дата створення",
    "Koniec dystansu": "Кінець дистанції",
    "Hasło użytkownika serwisowego": "Пароль користувача служби",
    "Data utworzenia od": "Дата створення від",
    "Ustaw szerokości proporcjonalnie": "Встановіть ширину пропорційно",
    "Zacznij pisać aby wyszukać tagi...": "Почніть писати для пошуку тегу...",
    "Pokaż przycisk ``Wyślij``": "Показати кнопку \"Відправити\"",
    "Czeklisty": "Контрольні списки",
    "Zadanie": "Завдання",
    "Uwzględniaj Dzielnice": "Візьміть до уваги райони",
    "Dołącz do czatu": "Приєднуйтесь до чату",
    "Dodaj dane dostepowe...": "Додати доступні дані...",
    "Edycja miasta": "Редагування міста",
    "Nie udało się przesłać plików": "",
    "Ilość pracowników": "Кількість співробітників",
    "Pasek postępu": "Індикатор виконання",
    "Magazyn": "Склад",
    "Brak nowych wiadomości.": "Немає нових повідомлень.",
    "Podano nieprawidłowe dane": "Надані невірні дані",
    "Dodane:": "Додано:",
    "Pobierz Excel": "",
    "Nieobecny od": "Відсутній від",
    "Nazwa": "Назва",
    "Back Office (BO)": "Бек-офіс (BO)",
    "Wyświetl szczegóły": "Покажи деталі",
    "Podstawowe operacje warunkowe": "Основні умовні операції",
    "Nazwa kolumny z opisem": "Назва стовпця з описом",
    "Tag": "Тег",
    "Ostatnie 5 zadań": "Останні 5 завдань",
    "Pilne": "Термінове",
    "Opis źródła": "Опис джерела",
    "Nazwisko klienta": "Прізвище клієнта",
    "Zadanie zostało zapauzowane.": "Завдання призупинено.",
    "Wprowadzona wartość jest za krótka": "Введене значення закоротке",
    "Pokaż listę dostępnych tras": "Показати список доступних маршрутів",
    "Wyszukaj tag...": "Пошук тегу...",
    "Nazwa przedmiotu": "Назва елемента",
    "Przypisane:": "Призначені:",
    "Checklista": "Чек-лист",
    "Zapisz filtry": "Зберегти фільтри",
    "Zostałeś zablokowany, dodanie wiadomości jest niemożliwe": "Ви заблоковані, додавання повідомлення неможливо",
    "Nie udało się dodać nieruchomość do trasy": "Не вдалося додати нерухомість до маршруту",
    "Załącz plik excel": "Прикріпіть файл excel",
    "Wybierz użytkownika": "Вибір користувача",
    "Zaopatrzenie zostało usunięte.": "Постачання були усунуті.",
    "Historia zmian kosztu": "",
    "Prefix": "Префікс",
    "Użytkownik został dodany.": "Користувача додано.",
    "Tak, przejdź do mapy": "",
    "Wynagrodzenia Koordynatorzy": "Заробітна плата координатори",
    "Data wylogowania": "Дата виходу з системи",
    "Usunięte przez użytkownika": "Видалено користувачем",
    "Adres email nadawcy": "Адреса електронної пошти відправника",
    "Klient został dodany.": "Клієнта додано.",
    "Rola została usunięta.": "Роль видалена.",
    "Edycja klienta": "Редагування клієнта",
    "Filtry kalendarza": "Фільтри календаря",
    "Województwo": "Воєводство",
    "Data modyfikacji": "Дата зміни",
    "Sekcja": "Розділ",
    "Sortowanie malejąco": "Сортування за спаданням",
    "Nie udało się pobrać tras": "Не вдалося завантажити маршрути",
    "Typ": "Тип",
    "Czy na pewno chcesz zablokować użytkownika?": "Чи насправді хочете заблокувати користувача?",
    "Kwota za godzinę": "Сумма за годину",
    "Edycja zadania": "Редагування завдання",
    "Kategoria jest wymagana": "Категорія обов'язкова",
    "Zaokrąglenie": "Округлення",
    "Wprowadzona wartość jest za długa": "Введене значення задовге",
    "Edytuj zlecenie": "Редагувати замовлення",
    "Treść": "Зміст",
    "Nie znaleziono żadnych plików": "Файлів не знайдено",
    "Użytkownicy w tej roli": "Користувачі в цій ролі",
    "Został przywrócony oryginalny harmonogram": "Початковий графік був відновлений",
    "Zaakceptuj, wyślij": "Прийняти, відправити",
    "treść notatki": "зміст примітки",
    "Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\".": "Будь ласка, збережіть хід роботи та натисніть кнопку «Оновити».",
    "Przypisz obiekty": "Призначити об'єкти",
    "Zacznij pisać aby wyszukać dzielnicę...": "Почніть писати для пошуку районів....",
    "Sypialnia": "",
    "Edycja nowej trasy": "Редагування нового маршруту",
    "Następna strona": "Наступна сторінка",
    "Przypisane zadanie:": "Призначена задача:",
    "Harmonogram zadań": "Розклад завдань",
    "Lista Tras:": "Перелік маршрутів:",
    "Kwota łącznie": "Сума всього",
    "Zadanie zostało ukończone.": "Завдання виконано.",
    "Uwzględniaj dzielnice": "Візьміть до уваги райони",
    "Numer inwentaryzacji": "Номер інвентаризації",
    "Brak sekcji multimediów": "",
    "Kosz": "Кошик",
    "Kierowca": "Водій",
    "Zajęte": "Зайнятий",
    "Brak zmian": "Немає змін",
    "Edycja działu": "Редагування розділу",
    "Porównania": "Порівняння",
    "Informacje podstawowe": "Основна інформація",
    "Nieobecność": "Відсутність",
    "Dodanie nieruchomości": "Додавання нерухомості",
    "Nie udało się pobrać listy serwerów plików": "Не вдалося отримати список файлових серверів",
    "Kontener plików": "Файловий контейнер",
    "Kalendarz - Kategorie zasobów": "Календар – категорії засобів",
    "Dodaj kolor": "Додати колір",
    "Do kogo chcesz napisać?": "До кого хочеш написати?",
    "Statystyki wniosków": "Статистика заявок",
    "Wynagrodzenie za konserwację": "Плата за утримання",
    "od": "від",
    "co 6 miesięcy": "кожні 6 місяців",
    "Wstaw z dołu": "Вставити знизу",
    "Ustawienia powiadomień": "Налаштування сповіщень",
    "Pokaż zdjęcia": "Показати фото",
    "Region": "Область",
    "Miniaturki": "Ескізи",
    "Zastosuj": "Застосовувати",
    "Dodanie klienta": "Додавання клієнта",
    "Nazwa szablonu": "Назва шаблону",
    "Czy jesteś pewien? ": "Ви впевнені? ",
    "Wyświetlam": "Відображення",
    "Checklista została usunięta": "Видалено чек-лист",
    "Identyfikator publiczny": "Публічний ідентифікатор",
    "Nazwa kategorii": "Назва категорії",
    "Liczba miast w regionie": "Кількість міст в регіоні",
    "Kontrolki podstawowe": "Основні елементи керування",
    "Tydzień": "Тиждень",
    "Codziennie": "Щодня",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "Назва форми не може бути довшою за % 0 символів",
    "Rozpoczęto synchronizację rezerwacji": "Розпочато синхронізацію бронювання",
    "Adres URL": "URL-адреса Adres",
    "Dodaj notatkę/komentarz": "",
    "Typ źródła danych": "Тип джерела даних",
    "Zobacz czaty": "Переглянути чати",
    "Housekeeping (HK)": "Хаус-кіпінг (HK)",
    "Klienci": "Клієнти",
    "Zacznij pisać aby wyszukać inspektora...": "Почніть вводити текст для пошуку інспектора...",
    "Przybornik": "Ящик інструментів",
    "Angielski": "Англійська",
    "Zamknięte": "Закрито",
    "Pokaż zaplanowane punkty": "Показати заплановані бали",
    "Opis kosztu": "",
    "ID nazwa obiektu": "ID назва об'єкту",
    "Zacznij pisać aby wyszukać nieruchomość...": "Почніть вводити текст, щоб знайти нерухомість...",
    "Zadanie zostało zaktualizowane.": "Завдання оновлено.",
    "Kwota opłacona od": "Сума, сплачена від",
    "Pole zawiera": "Поле містить",
    "Pole \"Imię\" jest wymagane.": "Поле «Ім'я» обов'язкове для заповнення.",
    "Koniec długości geograficznej użytkownika": "Кінцева довгота користувача",
    "TAK": "ТАК",
    "Pokaż nieruchomości (bez zadań i rezerwacji)": "Показати властивості (без завдань і застережень)",
    "Zadanie zostało usunięte": "Завдання видалено",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "У вас немає необхідних дозволів на виконання вибраної операції.",
    "Numer mieszkania": "Номер квартири",
    "Numer telefonu: ": "Номер телефону: ",
    "Zamknij": "Закрити",
    "Statystyki regionalne - regiony": "Регіональна статистика - регіони",
    "Tryb konserwacji systemu": "Режим обслуговування системи",
    "Przyrostek": "Суфікс",
    "Numer sesji": "Номер сесії",
    "Notatka": "Примітка",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "",
    "Brak dostępnych tras": "Бракує доступних маршрутів",
    "Statystyki kosztów w obiektach": "Статистика витрат на об'єктах",
    "Stwórz czat z rezerwacji": "Створіть чат резервації",
    "Klient został usunięty.": "Клієнт був видалений.",
    "Zawiera": "Містить",
    "Opis zespołu": "Опис команди",
    "Krzesełko": "Голова",
    "Serwer bazy danych": "Сервер баз даних",
    "Wynagrodzenia Kierowcy": "Заробітна плата водія",
    "Adres e-mail potwierdzony": "Підтверджена адреса електронної пошти",
    "Podanie nazwy jest wymagane.": "Необхідно вказати ім'я.",
    "Ilość osób": "Кількість осіб",
    "Nazwisko": "Прізвище",
    "Szablon został dodany.": "Шаблон додано.",
    "NIE": "НІ",
    "Data uruchomienia": "Дата запуску",
    "Co 5 dni": "Кожні 5 днів",
    "Urlopy": "Відпустки",
    "Stopka": "Вихідні дані",
    "Rozliczenia": "Розрахування",
    "Nie wiem": "Я не знаю",
    "Historia lokalizacji": "Історія місцезнаходжень",
    "Nigdy": "Ніколи",
    "Wersja utowrzona przez": "Версія створена",
    "Ukryj": "Сховай",
    "Wybierz miasta": "Виберіть міста",
    "Przeniesienie wybranych elementów": "Перемістити вибрані елементи",
    "Wystąpił błąd podczas zapisywania ustawień": "Під час збереження налаштувань сталася помилка",
    "Ukryj podczas dodawania zadania": "Приховати під час додавання завдання",
    "Czerwiec": "Червень",
    "Osoba odpowiedzialna": "Особа відповідальна",
    "Usunął": "Видалений",
    "Zacznij pisać aby wyszukać nieruchomość roboczą...": "Почніть вводити текст, щоб шукати працюючу властивість...",
    "Eksportuj do PDF": "Експортуйте до PDF",
    "Zlecenie na nieruchomość roboczą": "Замовлення на працюючу нерухомість",
    "Kolejność punktów trasy została zaktualizowana": "Оновлено порядок розташування маршрутних точок",
    "Obsługa Właściciela (OW)": "Служба підтримки власників (OW)",
    "Dozwolone rozszerzenia": "Дозволені розширення",
    "Tag nieruchomości": "Тег нерухомості",
    "Blokada konta": "Блокада облікового запису",
    "Typ nieobecności": "Тип відсутності",
    "Następna inwentaryzacja": "Наступна інвентаризація",
    "Tylko do odczytu": "Лише для читання",
    "Bardzo dobrze": "Дуже добре",
    "W organizacji nie ma jeszcze żadnych działów.": "В організації поки немає відділів.",
    "Trasa została usunięta": "Маршрут прибрали",
    "Nr nieruchomości Avantio": "Нерухомість № Авантіо",
    "Imię i Nazwisko": "Ім'я та прізвище",
    "Ważność": "Важливість",
    "Pracownik": "Працівник",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Помилка 404. Запитуваний ресурс не був знайдений.",
    "W zespole od %0 do %1": "В команді від %0 до %1",
    "To pole jest wymagane": "Це поле є обов'язковим для заповнення",
    "Wynagrodzenia od ilości posprzątanych obiektów": "Зарплата від кількості прибраних об'єктів",
    "OW": "Обслуговування власників",
    "(AirBnb) Wysłano żądanie do gościa": "(AirBnb) Запит висланий до гостя",
    "Data pauzy": "Дата паузи",
    "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "За замовчуванням потрібен канал. Відключити відправку повідомлень через цей канал не представляється можливим. Можливо лише змінити заголовок і зміст повідомлення.",
    "Wysłano kolejne wezwanie do zapłaty": "Був відправлений ще один платіжний виклик",
    "Zastępstwo zostało usunięte.": "Заміну видалено.",
    "Wklej komponent": "Вставте компонент",
    "Przeterminowane": "Прострочення",
    "Procent": "Відсоток",
    "Rezerwacje": "Бронювання",
    "Zacznij pisać aby wyszukać tag...": "Почніть писати для пошуку тегу...",
    "Data do": "Дата до",
    "Oznacz widoczne jako przeczytane": "Відзнач видиме як прочитане",
    "Dzisiaj": "Сьогодні",
    "Szczegóły zmian": "Деталі змін",
    "Zakończone: ${$filters.datetime(task.dateCompleted)}": "Виконано: ${$filters.datetime(task.dateCompleted)}",
    "Użytkownik Inspekcja": "Перевірка користувача",
    "Typ słownika": "Тип словника",
    "Zablokuj użytkownika": "Заблокувати користувача",
    "Data użycia": "Дата використання",
    "Typ zadania": "Тип завдання",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą klienta": "Люди, призначені за замовчуванням для завдань обслуговування клієнтів",
    "Pytanie 1": "Питання 1",
    "Nieważne": "Не має значення",
    "Sekcja została zaktualizowana": "",
    "Kontrolka wyboru (pojedynczy wybór)": "Елемент керування виділенням (одинарне виділення)",
    "Kolor został zaktualizowany": "Колір оновлено",
    "Kwiecień": "Квітень",
    "Kanały obsługiwane przez wybrany typ powiadmienia": "Канали, підтримувані обраним типом повідомлень",
    "Region został dodany.": "Регіон додано.",
    "Usunięto przez: ": "Видалено: ",
    "Komunikat błędu": "Повідомлення про помилку",
    "Typ Nieruchomości": "Тип нерухомості",
    "Classic mode": "Класичний режим",
    "Strona %0": "Сторінка %0",
    "Pokaż rezerwacje właścicielskie": "Показати бронювання власників",
    "nie wymuszaj zmiany hasła": "не примушуйте до зміни пароля",
    "Nazwa pliku została zmieniona.": "Файл перейменовано.",
    "Nazwa użytkownika serwisowego": "Ім'я користувача служби",
    "Nadpisz kwotę dla": "Перепишіть квоту для",
    "Konfiguracja domyślna": "Конфігурація за замовчуванням",
    "Aby wysłać wiadomość, dołącz do czatu": "Щоб надіслати повідомлення, приєднуйтесь до чату",
    "Plik został wysłany": "Файл надіслано",
    "Nazwa regionu": "Назва регіону",
    "Tytuł": "Назва",
    "Edycja nieruchomości roboczej": "Редагування робочої нерухомості",
    "Uwzględnij dodatkowe nieruchomości": "Включити додаткові нерухомості",
    "Rezerwacja": "Бронювання",
    "Admin": "Адміністратор",
    "Cena PLN": "Ціна PLN",
    "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "Цей канал не має можливості відправляти форматований текст.",
    "Administracja - Województwa": "Адміністрування - Воєводства",
    "Pokaż punkty bez kierowcy": "Показувати бали без водія",
    "Przypomnij": "Нагадай",
    "Typ źródła": "Тип джерела",
    "Domyślna firma": "Компанія за замовчуванням",
    "Czy jesteś pewien, że chcesz przypisać dzielnicę do nowego miasta? Wszystkie nieruchomości i użytkownicy przypisani do tej dzielnicy przestaną być do niej przypisani.": "Ви впевнені, що хочете приєднати район до нового міста? Всі нерухомості та користувачі, призначені до цього району, більше не будуть до нього приписані.",
    "Wyślij link": "Надіслати посилання",
    "Dostęp niezdefiniowany": "Невизначений доступ",
    "Na wniosek": "За запитом",
    "Od ilości posprzątanych obiektów": "Від кількості прибраних об'єктів",
    "Przenieś": "Перемістити",
    "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "Якщо вибрано цей параметр, індивідуальні та рольові дозволи не враховуються.",
    "Zadanie do wykonania": "Завдання для виконання",
    "Pole wymagane": "Обов'язкове поле",
    "Maj": "Травень",
    "Dane formularza są przechowywane w obiekcie Entry.": "Дані форми зберігаються в об'єкті Entry.",
    "Pliki publiczne": "Загальнодоступні файли",
    "Zaakceptowane, zapisz": "Прийнято, зберегти",
    "Symbol klienta": "Символ клієнта",
    "Dodaj zespół": "Додати команду",
    "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Поле «%0» не містить дійсну адресу електронної пошти.",
    "Kwota netto": "",
    "Korytarz": "",
    "Numer dowodu osobistego": "Номер посвідчення особи",
    "W trakcie": "В процесі",
    "Ostatnia wiadomość - data": "Останнє повідомлення - дата",
    "Sprawdzić": "Перевіряти",
    "Dodaj nowy tag": "Додай новий тег",
    "Zatwierdź": "Затвердити",
    "Nie udało się pobrać listy ról": "Не вдалося завантажити список ролей",
    "kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)": "коли це має статися (коли ми можемо відвідати квартиру)",
    "Wynagrodzenia Pracownicy": "Заробітна плата Працівників",
    "Pytania": "Питання",
    "Pobierz raport": "Завантажити звіт",
    "Sesja": "Сесія",
    "Treść wiadomości": "Зміст повідомлення",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą właściciela": "Люди, призначені за замовчуванням для завдань, пов'язаних із службою власника",
    "Użytkownik i jego wiadomości zostały przywrócone.": "Користувач і його повідомлення були відновлені.",
    "Serwer został dodany.": "Сервер додано.",
    "Booking with conflict": "Резервація з конфліктом",
    "Otwórz Ustawienia": "Відкрийте налаштування",
    "Obciążenie Renters": "Плата на рахунок Рентерс",
    "Brak zadań do wyświetlenia": "Немає завдань для відображення",
    "Typ wynagrodzenia został usunięty": "Тип заробітної плати був усунутий",
    "Sesja użytkownika": "Сесія  користувача",
    "Tekst zastępczy": "Замісний текст",
    "Dodaj użytkownika": "Додати користувача",
    "Dodaj Notatkę": "Додати Примітку",
    "Zadanie wykonuje": "Завдання виконує",
    "Pokaż historię": "Показати історію",
    "Piątek": "П'ятниця",
    "Aktualne hasło": "Поточний пароль",
    "Kolor został usunięty": "Колір був видалений",
    "Maksymalna ilość plików": "Максимальна кількість файлів",
    "Dodaj dział": "Додати відділ",
    "Średnie wynagrodzenie": "Середня зарплата",
    "Nie udało się usunąć zlecenia.": "Не вдалося видалити замовлення.",
    "Edycja checklisty": "Редагування чек-листа",
    "Zespół aktywny": "Активна команда",
    "Nr rezerwacji": "Номер бронювання",
    "Historia nieruchomości": "Історія об'єкта нерухомості",
    "Zaopatrzenie zostało dodane.": "Були додані поставки.",
    "Wybrane elementy zostały usunięte.": "Вибрані елементи видалено.",
    "Dodaj": "Додай",
    "Dodaj chat": "Додай чат",
    "Top mieszkań generujacych najwięcej kosztów": "Кращі квартири, що генерують найбільшу вартість",
    "Sesja nr %0": "Сесія nr %0",
    "Procent obciążeń": "Відсоток навантажень",
    "Stan licznika start": "Стан лічильника запуску",
    "Id modelu: %0": "Id моделі: %0",
    "Do kogo wysłać testowe powiadomienie": "Кому надіслати тестове повідомлення",
    "Zespół został zaktualizowany.": "Команда оновилася.",
    "Dzielnice": "Райони",
    "Dodanie dzielnicy": "Додавання району",
    "Stwórz zadanie": "Створити завдання",
    "Wielokrotny wybór": "Широкий вибір",
    "To miasto znajduję się już w tym regionie.": "Це місто вже є в цьому регіоні.",
    "Minimum": "Мінімум",
    "Nr rezerwacji:": "Номер резервації:",
    "Ustawienia domyślne": "Налаштування за замовчуванням",
    "Ostatnie sprzątanie": "Останнє прибирання",
    "Dodaj Koszt": "Додати Вартість",
    "Usuń wybrane": "Видалити виділене",
    "Ten region jest już przypisany do użytkownika.": "Цей регіон вже закріплений за користувачем.",
    "Źródło": "Джерело",
    "Status zadania": "Статус завдання",
    "Godzina trasy": "Час проходження маршруту",
    "Dzielnica": "Район",
    "Tłumacz": "Перекладач",
    "W polu możemy umieszczać jedynie cyfry": "Ми можемо вводити тільки цифри в полі",
    "Edytuj zadanie": "Редагування завдання",
    "Nadpisanie kwoty wynagrodzenia zostało dodane.": "Перезапис суми зарплати був доданий.",
    "Zameldowanie": "Заселення",
    "Monitor kolejek": "Монітор черги",
    "Konto aktywne": "Активний рахунок",
    "Pojedynczy wybór": "Єдиний вибір",
    "Zacznij pisać aby wyszukać użytkownika...": "Почніть вводити текст для пошуку користувача...",
    "dzień temu": "день тому",
    "Niewidoczne": "Невидимий",
    "Filtry systemowe": "Системні фільтри",
    "Imię właściciela": "Ім'я власника",
    "Szczegóły zmiany": "Подробиці зміни",
    "Lewy panel": "Ліва панель",
    "Dodaj media": "Додати медіа",
    "Nieobecność do": "Відсутність до",
    "Nie udało się zapisać komentarza": "",
    "Host główny": "Головний хост",
    "Dodaj pliki": "Додати файли",
    "Dodaj sekcję": "Додати розділ",
    "Edytuj sekcję": "Редагувати розділ",
    "Sekcja została utworzona": "Розділ створено",
    "Sekcja została zaktualizowana": "Розділ оновлено",
    "Sekcja została usunięta": "Розділ видалено",
    "Sekcja nie została znaleziona": "Розділ не знайдено",
    "Typ pomieszczenia jest wymagany": "Потрібно вказати тип приміщення",
    "Typ plików jest wymagany": "",
    "Wybierz pliki do dodania": "Виберіть файли для додавання",
    "Pliki zostały dodane": "Файли додано",
    "Pliki zostały pobrane": "Файли завантажено",
    "Plik został przeniesiony": "Файл переміщено",
    "Brak sekcji multimediów": "Немає медіарозділу",
    "Czy na pewno chcesz usunąć tę sekcję?": "Ви впевнені, що хочете видалити цей розділ?",
    "Zaznacz wszystkie w sekcji": "Виділити всі в розділі",
    "Brak plików w sekcji": "У цьому розділі немає файлів",
    "Wybierz sekcję": "Виберіть розділ",
    "Brak sekcji - najpierw utwórz sekcję": "Немає розділу — спочатку створіть розділ",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "Щоб додати файли, спочатку потрібно створити розділ.",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "Вибраний розділ приймає лише файли типу: {0}",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "Вибрані файли мають тип {0}, а розділ приймає лише {1}",
    "Wybierz sekcję, do której chcesz dodać pliki": "Виберіть розділ, до якого ви хочете додати файли",
    "Sekcja jest wymagana": "Розділ є обов’язковим",
    "Wybrana sekcja nie istnieje": "Вибраного розділу не існує",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "Неможливо додавати файли різних типів одночасно. Виберіть файли одного типу.",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "Неможливо додати файли типу {0} до розділу типу {1}",
    "Nie udało się przesłać plików": "Не вдалося завантажити файли",
    "Budynek": "Будівля",
    "Pokój dzienny": "Вітальня",
    "Sypialnia": "Спальня",
    "Kuchnia": "Кухня",
    "Łazienka": "Ванна кімната",
    "Korytarz": "Коридор",
    "Typ pomieszczenia": "Тип приміщення",
    "Nie znaleziono nieruchomości": "Нерухомість не знайдено",
    "Nie udało się załadować plików": "Не вдалося завантажити файли",
    "Usuń zaznaczone": "Видалити виділені",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "Ви впевнені, що хочете видалити виділені файли?",
    "Pliki zostały usunięte": "Файли видалено",
    "Nie można przenosić plików między sekcjami o różnych typach": "Неможливо переміщувати файли між розділами з різними типами",
    "Pliki zostaną automatycznie dodane do odpowiednich sekcji 'Inne' na podstawie typu pliku.": "Файли будуть автоматично додані до відповідних розділів «Інше» залежно від типу файлу.",
    "Pliki": "Файли",
    "Dane kosztu": "Дані витрат",
    "Nazwa kosztu": "Назва витрати",
    "Opis kosztu": "Опис витрати",
    "Kwota brutto": "Сума брутто",
    "Kwota netto": "Сума нетто",
    "VAT (wyliczany automatycznie)": "ПДВ (обчислюється автоматично)",
    "VAT": "ПДВ",
    "Historia zmian kosztu": "Історія змін витрати",
    "Brak historii zmian": "Немає історії змін",
    "Wersja": "Версія",
    "Koszt został dodany.": "Витрату додано.",
    "Koszt został zaktualizowany.": "Витрату оновлено.",
    "Pobierz Excel": "Завантажити Excel",
    "Koszt został usunięty": "Витрату видалено",
    "Excel został wygenerowany i wysłany na adres e-mail": "Файл Excel згенеровано та надіслано на електронну адресу",
    "Materiały": "Матеріали",
    "Koszt pracownika": "Вартість працівника",
    "Dane z VROS": "Дані з VROS",
    "Parking": "Паркування",
    "Wi-Fi": "Wi-Fi",
    "Router": "Роутер",
    "Nazwa sieci": "Назва мережі",
    "Instrukcje": "Інструкції",
    "Instrukcje zameldowania": "Інструкції щодо заселення",
    "Instrukcje wymeldowania": "Інструкції щодо виселення",
    "Przewodnik gościa": "Гід для гостей",
    "Kod do skrytki na klucze": "Код до сейфа для ключів",
    "Godzina zameldowania (Guesty)": "Час заселення (Guesty)",
    "Godzina końca zameldowania (Guesty)": "Час завершення заселення (Guesty)",
    "Godzina wymeldowania (Guesty)": "Час виселення (Guesty)",
    "Hiszpański": "Іспанська",
    "Brak wybranej firmy": "Не вибрано компанію",
    "Lista kosztów": "Список витрат",
    "Akceptacja kosztów": "Затвердження витрат",
    "Recenzje sprzątaczy": "Відгуки про прибиральників",
    "Przekroczono czas oczekiwania na odpowiedź serwera lub połączenie zostało anulowane.": "Перевищено час очікування на відповідь сервера або з’єднання було скасовано.",
    "Tylko Administrator lub ExternalManager może tworzyć nowe konta": "Лише Administrator або ExternalManager може створювати нові облікові записи.",
    "Kwota dodatkowego wynagrodzenia nie może być ujemna": "Сума додаткової винагороди не може бути від’ємною",
    "Nazwa czynności": "Назва дії",
    "Dodaj czynność": "Додати дію",
    "Liczba czynności": "Кількість дій",
    "Dodaj kategorię zadań": "Додати категорію завдань",
    "Obsługa właścicieli": "ОУ",
    "Edycja kategorii zadań": "Редагування категорії завдань",
    "Edycja czynności": "Редагування дії",
    "Brak wydziału": "Немає відділу",
    "Zacznij pisać aby wyszukać czynność...": "Почніть вводити текст, щоб знайти дію...",
    "Czynność została zaktualizowana.": "Дію оновлено.",
    "Czynność została usunięta.": "Дію видалено.",
    "Czynność została dodana.": "Дію додано.",
    "Nie można dodać tej czynności do zadania.": "Не можна додати цю дію до завдання.",
    "Przypisane czynności": "Призначені дії",
    "Brak przypisanych czynności.": "Немає призначених дій.",
    "Kategorie zadań": "Категорії завдань",
    "Czynności zadań": "Дії завдань",
    "czynności": "дії",
    "usunięta": "видалено",
    "Komentarz (opcjonalny)": "Коментар (необов'язково)",
    "Wszystkie kategorie": "Усі категорії",
    "Wybierz kategorię": "Виберіть категорію",
    "Formularz zadania nie jest poprawny.": "Форма завдання недійсна.",
    "Biblioteka czynności": "Бібліотека дій",
    "Szukaj czynności": "Шукати дії",
    "Wszystkie statusy": "Усі статуси",
    "Przenieś na samą górę": "Перемістити на самий верх",
    "Przenieś na sam dół": "Перемістити в самий низ",
    "Widoczna w zadaniach": "Видима в завданнях",
    "Czynność jest widoczna w zadaniach.": "Дія тепер видима в завданнях.",
    "Czynność została ukryta w zadaniach.": "Дію приховано в завданнях.",
    "Edytuj kategorię": "Редагувати категорію",
    "Edytuj czynność": "Редагувати дію",
    "Nowa czynność": "Нова дія",
    "Kolejność została zapisana.": "Порядок збережено.",
    "Nie udało się zapisać kolejności.": "Не вдалося зберегти порядок.",
    "Przypisana do działu": "Призначена до відділу",
    "Przypisana do kategorii": "Призначена до категорії",
    "Np. wymiana okien": "Напр. заміна вікон",
    "Użyta w": "Використано в",
    "%0 zadaniach": "%0 завданнях",
    "Zmiana nazwy nie zmieni istniejących zadań.": "Зміна назви не змінить наявних завдань.",
    "Upewnij się, że nazwa czynności:": "Переконайтеся, що назва дії:",
    "Nie zawiera literówek": "Не містить помилок",
    "Jest jasna, klarowna i precyzyjna": "Є зрозумілою, чіткою та точною",
    "Zawiera polskie znaki": "Містить польські літери",
    "Aktywna w nowych zadaniach": "Активна в нових завданнях",
    "Czynność „Inne” (pokazuje pole komentarza w aplikacji mobilnej)": "Дія «Інше» (показує поле коментаря в мобільному застосунку)",
    "Czynności nigdy nie są usuwane, można je tylko dezaktywować": "Дії ніколи не видаляються, їх можна лише деактивувати",
    "Np. Hydraulika": "Напр. Сантехніка",
    "Przeciągnij, aby zmienić kolejność działów": "Перетягніть, щоб змінити порядок відділів",
    "Zameldowanie / Wymeldowanie": "Заселення / Виселення",
    "Media": "Комунальні послуги",
    "Dostawca": "Постачальник",
    "Inwentarz": "Інвентар",
    "Komfort": "Комфорт",
    "Dodatki": "Додатково",
    "A/C": "Кондиціонер",
    "Ogrzewanie centralne": "Центральне опалення",
    "Kanapa": "Диван",
    "Zaciemnienie": "Затемнення",
    "Grzejniki": "Обігрівачі",
    "Bojler": "Бойлер",
    "Pościel": "Постільна білизна",
    "TV": "Телевізор",
    "Suszarka do ubrań": "Сушильна машина",
    "Suszarka do włosów": "Фен",
    "Żelazko": "Праска",
    "Piekarnik": "Духовка",
    "Kuchenka mikrofalowa": "Мікрохвильова піч",
    "Czajnik": "Чайник",
    "Dzbanek na wodę": "Глечик для води",
    "Środki czystości": "Засоби для прибирання",
    "Pralka": "Пральна машина",
    "Suszarka na pranie": "Сушарка для білизни",
    "Lampki nocne": "Нічні лампи",
    "Deska do prasowania": "Прасувальна дошка",
    "Kuchenka": "Плита",
    "Toster": "Тостер",
    "Zmywarka": "Посудомийна машина",
    "Odkurzacz": "Пилосос",
    "Ekspres do kawy": "Кавомашина",
    "Apteczka": "Аптечка",
    "Czujnik CO2": "Датчик CO2",
    "Gaśnica": "Вогнегасник",
    "Czujnik dymu": "Датчик диму",
    "Przyjazne zwierzętom": "Дозволено з тваринами",
    "Widok": "Краєвид",
    "Prąd": "Електроенергія",
    "Ogrzewanie": "Опалення",
    "Woda": "Вода",
    "Gaz": "Газ",
    "Internet": "Інтернет",
    "Dane zostały zapisane.": "Дані збережено.",
    "Piętro": "Поверх",
    "Winda": "Ліфт",
    "Balkon": "Балкон"
  },
  "bg-BG": {
    "Ulubione": "Любими",
    "Dodaj do ulubionych": "Добави в любими",
    "Usuń z ulubionych": "Премахни от любими",
    "Wybierz typ Firmy": "Изберете вид на фирмата",
    "Zacznij pisać aby wyszukać dzielnice...": "Започнете да пишете, за да търсите квартали...",
    "Co godzinę": "На всеки час",
    "Dostępne wersje językowe.": "",
    "Strona nadrzędna": "",
    "Autor notatki": "Авторът на бележката",
    "zacznij pisać aby wyszukać artykuł...": "",
    "Slajd został dodany.": "",
    "Ten użytkownik już jest przypisany do czatu": "Този потребител вече е назначен към чата",
    "Zlecenia": "Поръчки",
    "Otwórz czat - link": "",
    "Na żądanie działu": "По искане на отдела",
    "W każdy dzień tygodnia": "Всеки ден от седмицата",
    "Rozwiń": "Разшири",
    "Artykuł": "",
    "10": "",
    "Budynek": "",
    "Ostatnio oglądane": "",
    "Nieobecność do": "Отсъствие на",
    "Wybierz pliki (do {0})": "Изберете файлове (до {0})",
    "Co 2 godziny": "На всеки 2 часа",
    "Moja trasa": "Моят маршрут",
    "Dodanie źródła danych": "Добавяне на източник на данни",
    "Publikuj szkolenie": "",
    "5 ostatnich zadań": "5 скорошни задачи",
    "Eksportuj do Excel": "Експортиране в Excel",
    "Przypisana do (Imię i Nazwisko)": "Присвоен на (име и фамилия)",
    "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "",
    "Zmniejsz": "Намаляване",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "",
    "Data Wykonania": "",
    "Dodaj kategorię": "Добавяне на категория",
    "Dział został zaktualizowany.": "Отделът е актуализиран.",
    "Klient aktywny": "Активен клиент",
    "Wprowadzona wartość jest nieprawidłowa": "Въведената от вас стойност е невалидна",
    "Slajd został zaktualizowany.": "",
    "Szablon checklisty": "Шаблон за контролен списък",
    "Tak/Nie": "Да/Не",
    "Strona szkolenia ukryta": "",
    "Dodanie nieruchomości roboczej": "Добавяне на работещ имот",
    "Nazwa taga": "Име на етикета",
    "Edytuj koszt": "",
    "Wybrana dzielnica": "Избран район",
    "Dodaj odpowiedź": "",
    "Nazwa użytkownika": "Потребителско име",
    "Kolejka": "Опашка",
    "Wartości": "Ценности",
    "Strona dostępna tylko dla zalogowanych użytkowników": "",
    "Zastępstwo wygaśnie za minutę.": "Замяната изтича след минута.",
    "Token został usunięty.": "Токенът е премахнат.",
    "Liczba wyświetlanych najnowszych elementów": "",
    "Pomyślnie dołączono do czatu": "Успешно се присъедини към чата",
    "Początek szerokości geograficznej użytkownika": "Началото на географската ширина на потребителя",
    "Wybrany szablon": "",
    "Link został zaktualizowany.": "",
    "Edycja zespołu": "Редактиране на екипа",
    "Miasto": "град",
    "Zakończone przez: ": "Завършено от: ",
    "Nie możesz wznowić obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "Не можете да възобновите работата с тази задача, защото сега изпълнявате друга задача",
    "Sekcje i bloki": "",
    "Tło strona 2": "",
    "Nazwa Kategorii": "",
    "Posprzątane": "Почистен",
    "Pokaż czaty": "",
    "Stwórz zadanie z tej rezerwacji": "Създайте задача от тази резервация",
    "Zespół został przypisany do ścieżki szkoleniowej.": "",
    "Dodaj test": "",
    "Usunięcie wybranych elementów": "Изтриване на избрани елементи",
    "Zapisuję...": "Аз спестявам...",
    "Sekcje dla gości": "",
    "Włączone (Index)": "",
    "Zdecydowanie nie": "Определено не",
    "Certyfikat został usunięty.": "",
    "Notatka została zaktualizowana.": "Бележката е актуализирана.",
    "Ważne": "Важно",
    "Tryb monitorowania aktywności": "",
    "Link": "",
    "Maksymalny rozmiar pliku w MB": "Максимален размер на файла в MB",
    "Stawka wynagrodzenia została zaktualizowana.": "Процентът на заплатите е актуализиран.",
    "Statystyki wyniosków": "Статистика за ефективността",
    "Lista plików": "Списък с файлове",
    "UWAGA! Ta tabela pokazuje tylko przeterminowane zadania, filtr \"STATUS\" nie jest aktywny. Wróć do \"Wszystkie zadania\" aby mieć dostępne wszystkie filtry": "ВНИМАНИЕ! Тази таблица показва само задачи с изтекъл срок на годност, филтърът „STATUS“ не е активен. Върнете се в „Всички задачи“, за да имате налични всички филтри",
    "Usuń plik": "Изтриване на файл",
    "Element został zaktualizowany.": "",
    "Dział:": "Отдел:",
    "Logi aktywności zostały wyczyszczone": "",
    "Nazwa katalogu lub pliku": "Името на директорията или файла",
    "Utworzono kopię checklisty": "Създадено е копие от контролния списък",
    "Tryb wyświetlania": "",
    "Użytkownik Obsługa": "Потребителско обслужване",
    "Zapisz zmiany": "Запазване на промените",
    "Zastępstwo zostało zaktualizowane.": "Подмяната е актуализирана.",
    "Polska": "Полша",
    "Skala 1-5": "Скала 1-5",
    "Wydrukuj": "Печат",
    "Firma domyślna": "Компания по подразбиране",
    "Nazwa Firmy": "Наименование на фирмата",
    "Zgoda": "предоставен",
    "Wyszukiwarka miejsc": "Търсач на места",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "Поставете две колони 1/3 и 2/3",
    "Szablon został usunięty.": "Шаблонът е премахнат.",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "",
    "Niezakończone": "Недовършен",
    "Data wykonania od": "Дата на изпълнение от",
    "Ukryj czaty": "",
    "Co drugi miesiąc": "Всеки друг месец",
    "Nazwa kolumny z wartością": "Име на колона със стойност",
    "Ostatnia strona": "Последна страница",
    "Komentarz konserwatora": "Коментар на консерватора",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "Сигурни ли сте, че ще преместите избраните елементи в текущата директория?",
    "Statyczny": "",
    "Zadania na wniosek działu": "Задачи по искане на отдела",
    "Planuj automatycznie w dniu wymeldowania": "Планирайте автоматично в деня на напускане",
    "Jutro": "утре",
    "Wszystkie próby": "Всички опити",
    "Przejdź do zadania": "Отидете на задачата",
    "Godzina przełomowa synchronizacji": "Пробивен час на синхронизация",
    "Ilość wierszy": "Брой редове",
    "Dodaj do zespołu": "Добави към екипа",
    "Inspekcja": "Инспекция",
    "Łazienka": "",
    "Wydział": "Факултет",
    "Nie udało się pobrać listy filtrów": "Неуспешно изтегляне на списъка с филтри",
    "Strona logowania": "",
    "Administracja - Użytkownicy": "Администрация - Потребители",
    "Wybierz plik lub katalog": "Изберете файл или директория",
    "Miejsca po przecinku": "Места след запетая",
    "Dodane Koszty": "Добавени разходи",
    "Designer": "",
    "-": "-",
    "Wyślij testowe powiadomienie": "Изпращане на известие за тест",
    "Formularze": "Форми",
    "Nie udało sie zaktualizować zadania": "Неуспешно актуализиране на задачата",
    "Początek dystansu": "Началото на разстоянието",
    "Dane do sieci": "",
    "Koszt Renters": "Цена на наемателите",
    "Brak właściciela": "Липса на собственик",
    "Publikacja": "",
    "Resetuj zmiany": "",
    "Cyfry": "Цифри",
    "Status: ": "Държава: ",
    "Potwierdzam": "Потвърждаване",
    "Co drugi dzień": "Всеки друг ден",
    "PDF": "",
    "Ustawienia globalne": "Глобални настройки",
    "Usuń": "Изтриване",
    "Nieruchomość jest widoczna": "Имотът е видим",
    "Nie udało się pobrać listy katalogów": "",
    "Zaakceptowany": "Приет",
    "Zadanie zostało rozpoczęte.": "Задачата е започната.",
    "Nazwa chatu": "Име на чата",
    "Facebook Application ID": "",
    "Wyświetl nieruchomości robocze": "Преглед на работните свойства",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Възникна грешка в сървъра при работа с избраната операция. Моля, опитайте отново.",
    "15 minut": "15 минути",
    "Edycja formularza": "Редактиране на формуляр",
    "Zakolejkowane": "Запечатан",
    "Adres URL profilu autora.": "",
    "Opis szkolenia": "",
    "Dostęp przyznany przez zespół": "",
    "Modyfikacja": "Модификация",
    "Nieprzeczytane": "",
    "Numer nieruchomości (StreetNumber)": "Номер на имота (Номер на улицата)",
    "Kod Bing Webmaster": "",
    "Administracja - Stanowiska pracy": "Администрация - Работа",
    "Wszystkie konta": "",
    "Edytuj lekcje wideo": "",
    "Dostęp niezdefiniowany": "Неопределен достъп",
    "Potwierdź wyłączenie publikacji": "",
    "Treść notatki": "Съдържание на бележката",
    "edycja": "издание",
    "Link został zaktualizowany.": "",
    "Widoczność": "Видимост",
    "Przypisani użytkownicy": "Присвоени потребители",
    "Ukończone przez użytkownika o Id": "Попълнено от потребител o Id",
    "Ta dzielnica jest już przypisana do użytkownika.": "Този район вече е присвоен на потребителя.",
    "Kwota opłacona": "Платена сума",
    "zacznij pisać aby wyszukać slajder...": "",
    "Odepnij menu": "",
    "Tekst alternatywny": "Алтернативен текст",
    "Stawka za typ apartamentu": "Цена за тип апартамент",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Брой служители, работещи в повече от един регион",
    "Nie udało się pobrać listy kolejek": "Неуспешно извличане на списъка с опашки",
    "Dodanie roli": "Добавяне на роля",
    "Wyżej": "",
    "Role i uprawnienia": "Роли и разрешения",
    "Tekst zastępczy": "Алтернативен текст",
    "Zarządzaj zespołami": "",
    "Szkolenie kończy się": "",
    "Potwierdź wyczyszczenie logów": "",
    "W polu możemy umieszczać jedynie cyfry całkowite, nie ujemne": "В полето можем да поставим само цели цифри, а не отрицателни",
    "Kierowca Główny": "Водещ шофьор",
    "Region został zaktualizowany.": "Регионът е актуализиран.",
    "Regulamin został zaktualizowany.": "",
    "Certyfikat jest opublikowany": "",
    "Nie masz uprawnień do publikacji aranżacji.": "",
    "Checklista nie ma przypisanych miast.": "Checklist няма определени градове.",
    "Opublikuj materiał": "",
    "Monitoring": "Мониторинг",
    "Status rozliczenia": "Статус на фактуриране",
    "Zmień status": "Промяна на състоянието",
    "Klient został zaktualizowany.": "Клиентът е актуализиран.",
    "Edytuj treść": "",
    "Zaopatrzenie": "Осигуряване",
    "Temat": "Тема",
    "Zdecydowanie się nie zgadzam": "Силно не съм съгласен",
    "Dodaj szkolenie": "",
    "Nazwa kosztu": "Наименование на разходите",
    "Dostępny w sekcjach": "",
    "%$ – znacznik otwierający tag": "",
    "Notatka utworzona z zadania": "Бележка, създадена от задача",
    "Wybierz sekcję": "",
    "Hasło": "Парола",
    "Dodaj firmę": "Добавяне на фирма",
    "Nieruchomość": "Недвижими имоти",
    "Zapisz slajd": "",
    "Wyświetlaj tylko treść": "",
    "Sekcje wspólne": "",
    "Zdecydowanie nieważne": "Определено не е важно",
    "Nazwa apartamentu": "Име на апартамента",
    "${DepartmentName(DepartmentEnum[this.task.department])}": "$ {Име на отдела (Наум на отдела [this.task.department])}",
    "Październik": "Октомври",
    "Właściwość ``%0`` aktywnego wpisu": "",
    "W zespole do": "",
    "Usuń zadanie": "Изтриване на задача",
    "Materiał opisowy": "",
    "Wybierz strony": "",
    "Dodane przeze mnie": "Добавено от мен",
    "Właściciel został usunięty": "Собственикът е премахнат",
    "Checklista została dodana.": "Контролният списък е добавен.",
    "zgłoś problem w apartamencie": "съобщете за проблем в апартамента",
    "Proszę zapisać postęp pracy i kliknąć przycisk \"Aktualizuj\".": "Моля, запазете напредъка на работата и кликнете върху бутона „Актуализиране“.",
    "Email": "Имейл",
    "Obraz został wycięty.": "Изображението беше изрязано.",
    "Wybrany materiał został już dodany do lekcji": "",
    "Wybrane pliki": "Избрани файлове",
    "Kontrolka wyboru (wybór wielokrotny)": "Контрол на избора (многократен избор)",
    "Odpowiedź": "",
    "Można dodawać tylko pliki typu: \"%0\".": "Можете да добавяте само файлове от тип: „⇑“.",
    "Typ pomieszczenia": "",
    "Paczki SCORM": "",
    "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "",
    "Zacznij pisać aby wyszukać szablon checklisty...": "Започнете да пишете, за да търсите шаблон за контролен списък...",
    "Nazwa pola": "Име на полето",
    "Projekt": "Проект",
    "Edycja inwentaryzacji": "Редактиране на описа",
    "Wybór": "Избор",
    "Dodanie zadania": "Добавяне на задача",
    "Wyświetlaj nazwę bloczka": "",
    "Uprawnienia": "Разрешения",
    "Renters": "Наематели",
    "Log z aktywności": "",
    "Data dezaktywacji": "",
    "Słownik systemowy": "Системен речник",
    "Umożliwienie sprawdzania odpowiedzi": "",
    "Ścieżka szkoleniowa została dodana.": "",
    "Źródło danych": "Източник на данни",
    "Inwentaryzacja została dodana.": "Инвентарът е добавен.",
    "Zastępstwo wygaśnie za 10 minut.": "Замяната изтича след 10 минути.",
    "Kolor powinien być w formacie #XXXXXX (np. #f07d00)": "Цветът трябва да бъде във формат #XXXXXX (напр. #f07d00)",
    "Strony opisowe": "",
    "Nie udało się pobrać listy kanałów": "Неуспешно изтегляне на списъка с канали",
    "Generator plików PDF:": "PDF генератор:",
    "Raporty z rozliczeń": "Отчети за фактуриране",
    "Nie zdefiniowano żadnych ról.": "Няма дефинирани роли.",
    "Nie udało się wczytać podglądu strony.": "",
    "Nazwa testu": "",
    "Typ pomieszczenia jest wymagany": "",
    "Zmień rozmiar": "преоразмеряване",
    "Komunikat mailowy": "",
    "Notatka do zadania": "Забележка за задачата",
    "Numer pinezki": "Пин номер",
    "Dodanie regionu": "Добавяне на регион",
    "Checklisty": "Контролни списъци",
    "Dostęp zabroniony": "Достъпът е забранен",
    "NIP": "ЩИПКА",
    "Adres email": "Имейл адрес",
    "Materiał wideo": "",
    "Komunikat": "Комюнике",
    "Wprowadzona wartość jest za niska": "Въведената от вас стойност е твърде ниска",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "",
    "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "",
    "Stawka za apartamenty została zaktualizowana.": "Цената на апартаментите е актуализирана.",
    "Pokaż numery stron": "Показване на номера на страници",
    "Tytuł witryny": "",
    "Organizuj": "Организирайте",
    "Zobacz wszystkie": "Виж всички",
    "Sekcje dla zalogowanych": "",
    "Kobieta": "",
    "Przywróć": "Възстановяване",
    "Dane wydziałów": "Данни за факултета",
    "Typ strony": "",
    "Dostępne bloki": "",
    "Wpis domyślny": "Запис по подразбиране",
    "Witryna została usunięta.": "",
    "Urlop został dodany.": "Ваканцията е добавена.",
    "Zmień nazwę pliku": "Преименуване на файла",
    "Lewy panel": "Ляв панел",
    "Data przejścia": "Дата на преминаване",
    "Nieruchomość niestandardowa": "Персонализирана собственост",
    "MasterCode nieruchomości": "Мастеркод Недвижими имоти",
    "Kreator trasy: ": "Съветник за маршрути: ",
    "Tytuł kafelka": "",
    "Dodaj slajd": "",
    "Wczytaj zapisany filtr": "Заредете запазения филтър",
    "Wybrana data jest mniejsza niż dozwolona %0.": "Избраната дата е по-малка от разрешената% 0.",
    "Pokaż nieaktywnych właścicieli": "Показване на неактивни собственици",
    "Litery i cyfry": "Букви и цифри",
    "Klucze": "ключове",
    "Lista urządzeń na których jesteś zalogowany": "Списък на устройствата, на които сте влезли",
    "Edycja": "Редактиране",
    "Statystyki": "Статистика",
    "Odrzuć": "Отхвърли",
    "Formularz został zaktualizowany.": "Формулярът е актуализиран.",
    "Lista": "Списък",
    "Usuń materiał z lekcji": "",
    "Szablon nr 1": "",
    "Nazwa przycisku": "",
    "Lista artykułów": "",
    "Szukaj": "търсене",
    "Logo firmy": "Лого на компанията",
    "Pliki": "",
    "Filtruj": "Филтър",
    "Data wystąpienia": "",
    "${PriorityName(PriorityEnum[this.task.priority])}": "$ {Име на приоритет (Приоритетно име [this.task.priority])}",
    "Lekcja SCORM została dodana.": "",
    "Opublikowane języki": "",
    "Do poziomu": "",
    "Wymagany": "",
    "Udało się usunąć zadania!": "Успешно изтрити задачи!",
    "Co rok": "",
    "Nieopublikowany": "",
    "Data wygaśnięcia": "Срок на годност",
    "Role użytkownika": "Потребителски роли",
    "Imie i nazwisko": "Име и фамилия",
    "Status": "Статус",
    "Oznacz wszystkie jako przeczytane": "Маркирайте всички като прочетени",
    "Wartości statusów": "Стойности на състоянието",
    "Wznów zadanie": "Възобновяване на задачата",
    "Przeglądanie logów aktywności": "",
    "Walidacja": "Валидиране",
    "Trasa została rozpoczęta": "Маршрутът започна",
    "Lista linków": "",
    "Zdecydowanie ważne": "Определено важно",
    "Dodawanie wyposażenia": "Добавяне на оборудване",
    "Co 10 minut": "На всеки 10 минути",
    "Witryna internetowa": "",
    "Powiązane artykuły": "",
    "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "",
    "Zmodyfikowano": "модифициран",
    "Odśwież": "Освежи",
    "Wymeldowanie": "Напускане",
    "Wybierz pliki": "Изберете файлове",
    "Użytkownicy": "Потребители",
    "Typ wynagrodzenia": "Вид възнаграждение",
    "Dzielenie": "Разделяне",
    "Co 2 minuty": "На всеки 2 минути",
    "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "",
    "Link do rezerwacji": "Връзка към резервацията",
    "Odejmij kwotę": "Извадете сумата",
    "Koszt został dodany.": "Цената е добавена.",
    "Dopasuj do kategorii": "",
    "Nazwa nieruchmości": "Име на имота",
    "Peticion informacion": "Искане за информация",
    "Konfiguracja bloku została zapisana.": "",
    "Witryna tylko dla zalogowanych użytkowników": "",
    "Uzupełnij luki": "",
    "Zapis został usunięty": "",
    "Stawki nieruchomości": "Цени на недвижими имоти",
    "Brak elementów podsumowania": "Липса на обобщени елементи",
    "Wynagrodzenie podstawowe": "Основна заплата",
    "Wpis nieprzeczytany": "",
    "Linia": "линия",
    "Pobierz": "",
    "Usuń publikację": "",
    "Zaopatrzenie zostało zaktualizowane.": "Доставката е актуализирана.",
    "Ważne informacje": "Важна информация",
    "Edycja regionu": "Редактиране на региона",
    "12 godzin": "12 часа",
    "Stan licznika końcowego nie może być mniejszy bądź równy w porównaniu do licznika początkującego": "Състоянието на крайния брояч не трябва да бъде по-малко или равно на първоначалния брояч",
    "Załaduj": "Натоварване",
    "Zastępstwo wygaśnie za 5 minut.": "Подмяната ще изтече след 5 минути.",
    "Zdecydowanie tak": "Определено да",
    "Kwota opłacona do": "Платена сума до",
    "Ten czat nie posiada przypisanych konkretnych użytkowników.": "",
    "Przywróć użytkownika": "Възстановяване на потребителя",
    "Zadowolony": "доволен",
    "Wybierz dzielnice": "Изберете райони",
    "Tagi:": "Етикети:",
    "Imię i nazwisko właściciela": "Име и фамилия на собственика",
    "Rozpocznij zadanie": "Стартирайте задачата",
    "Brak sekcji - najpierw utwórz sekcję": "",
    "Nieruchomość jest już przypisana": "Имотът вече е назначен",
    "Marka": "марка",
    "Edycja ankiety": "",
    "Zapauzuj zadanie": "Пауза на задачата",
    "Podgląd szablonu e-maila": "Преглед на шаблон за имейл",
    "zacznij pisać aby wyszukać paczkę SCORM...": "",
    "Nazwa serwera": "Име на сървъра",
    "Google Nexus 10": "",
    "Kwota brakująca": "Липсваща сума",
    "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Възможността за промяна на този раздел е ограничена. Неактивните полета се синхронизират с външната база данни %0.",
    "Powiązane": "Свързани",
    "Czas realizacji": "Време за изпълнение",
    "Brak nowych powiadomień.": "Няма нови известия.",
    "Wymuś zmianę hasła": "Принудителна промяна на паролата",
    "Data przejścia na nowe API": "Дата на преход към новия API",
    "Zmodyfikowane przez": "Модифициран от",
    "Kwota zniszczeń": "Размер на щетите",
    "Wersje aranżacji": "",
    "Ustawienia podstawowe": "",
    "Id nieruchomości": "Ид на имота",
    "Wybrana data jest większa niż dozwolona %0.": "Избраната дата е по-голяма от разрешената% 0.",
    "Status dokumentu został zmieniony.": "Състоянието на документа е променено.",
    "Wpis został usunięty.": "Записът е заличен.",
    "Edytuj datę opuszczenia zespołu": "",
    "Częstotliwość odświeżania": "",
    "Podgląd": "Визуализация",
    "Ustawienia witryny": "",
    "Ustawienia strony": "",
    "Liczba nocy": "Брой нощувки",
    "Program został zaktualizowany.": "",
    "Edycja artykułu": "",
    "Data automatycznej akceptacji": "",
    "Dodanie firmy": "Добавяне на компания",
    "Prawy panel": "Десен панел",
    "Wynagrodzenie za sprzątanie": "Възнаграждение за почистване",
    "Link do raportu": "Връзка към доклада",
    "Wynagrodzenie za inspecję": "Заплата за инспекция",
    "Opis sekcji": "",
    "Edycja ustawień": "",
    "Port": "пристанище",
    "Nowa umowa": "Нов договор",
    "Użytkownik": "Потребител",
    "Tagi nieruchomości": "Етикети за имоти",
    "Dodaj typ wynagrodzenia": "Добавете тип заплата",
    "Data": "дата",
    "Pokaż na mapie": "Покажи на картата",
    "Dodatkowy komentarz do wynagrodzenia": "Допълнителен коментар за заплатата",
    "Opublikowane na wybranej stronie": "",
    "Rozpoczęcie": "",
    "Wybrano 1 plik": "",
    "Opracowane, zapisz": "Разработено, запазено",
    "Nie udało się pobrać użytkowników": "Неуспешно изтегляне на потребители",
    "Edycja firmy": "Редактиране на компанията",
    "Nazwa ścieżki": "",
    "Dodaj zasób": "Добавяне на ресурс",
    "Lista zespołów": "",
    "Warunki logiczne": "Логически условия",
    "Pierwsza strona": "Първата страница",
    "Usunięte": "Премахнати",
    "Zespół został przypisany do szkolenia.": "",
    "Wyczyść aranżację": "",
    "Słowa oddzielone przecinkami.": "",
    "Default mode": "Режим по подразбиране",
    "Wybranie strony jest wymagane": "",
    "Powiadomienie dla administratora chatu o nowych wiadomościach": "",
    "Liczba pracowników zatrudnionych tylko w tym mieście": "Брой служители, заети само в този град",
    "Cancelled": "Отменен",
    "Aktualność została dodana.": "",
    "Zdjęcia": "Снимки",
    "Uruchom zadanie": "Изпълнете задачата",
    "Data dodania": "Дата на добавяне",
    "Zarchiwizowany": "Архивиран",
    "Wiadomość testowa została wysłana.": "Изпратено е тестово съобщение.",
    "Numer nieruchomości Avantio": "",
    "Inwentaryzacja": "Инвентар",
    "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "",
    "Kraj": "Държава",
    "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "",
    "Informacja o ciasteczkach": "",
    "Wybierz koordynatora": "Изберете координатор",
    "Plik": "",
    "Nieruchomość robocza": "Работна собственост",
    "Kopiuj": "копиране",
    "Pokój dzienny": "",
    "Link do wybranej strony serwisu": "",
    "Robocizna": "Труд",
    "Nie do odzyskania": "Невъзстановими",
    "Tekst alternatywny": "Алтернативен текст",
    "Koordynator Konserwacji": "Координатор за поддръжка",
    "usuń notatkę": "изтриване на бележката",
    "Domyślny": "",
    "Odstęp": "Разстояние",
    "Nazwa dzielnicy": "Наименование на района",
    "Wyszukiwana fraza:": "Фраза за търсене:",
    "zacznij pisać aby wyszukać kategorię...": "",
    "Usuń blok z sekcji": "",
    "Ranga": "Ранг",
    "Czyim kosztem jest dodany przedmiot?": "За чия сметка се добавя артикулът?",
    "Czas": "време",
    "Odrzucone": "Отхвърлен",
    "Cofam": "Спомен",
    "Subskrypcja": "",
    "Ilość znaków": "Брой символи",
    "Excel został wygenerowany i wysłany na adres e-mail": "",
    "Aranżacje": "",
    "Informacje Podstawowe": "Основна информация",
    "Zobacz szczegóły sesji użytkownika": "Преглед на подробностите за потребителската сесия",
    "Sobota": "Събота",
    "3 godziny": "3 часа",
    "Rozliczenia pracowników": "Счетоводство на служ",
    "Ustawienia powiadomień zostały zaktualizowane.": "Настройките за уведомяване са актуализирани.",
    "Adres url do pliku wideo": "",
    "Dark mode": "Тъмен режим",
    "Ten Miesiąc": "Този месец",
    "Mapa": "Карта",
    "Ilość łóżek dwuosobowe": "Брой двойни легла",
    "Brak tagów": "Няма тагове",
    "Dane gościa": "Данни за посетителите",
    "Identyfikator zadania": "Идентификатор на задача",
    "Dodaj do trasy": "Добавяне към маршрута",
    "Apple iPhone 5": "",
    "Program": "",
    "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "",
    "Certyfikaty": "",
    "Data zakończenia": "Дата на завършване",
    "Trasy można wykonywać w aplikacji Hi!Renters Mobile": "Маршрутите могат да бъдат направени в Здравейте! Мобилни наематели",
    "Potwierdź akceptację": "Потвърдете приемането",
    "Czy na pewno chcesz zkopiować szkolenie?": "",
    "Login": "Вход",
    "Niepotwierdzeni": "",
    "Zakończone: ${$filters.datetime(route.dateCompletedUtc)}": "Завършено: $ {$филтри.датавреме (маршрут.dateCompleteUTC)}",
    "Chat": "Чатове",
    "Raczej się zgadzam": "По-скоро съм съгласен",
    "Pole nie może być puste": "",
    "1 godzina": "1 час",
    "Wydział zadania": "Отдел за задачи",
    "Wysokość": "височина",
    "ISBN": "",
    "Tło certyfikatu": "",
    "Osoba zastępowana": "Лице, което трябва да бъде заменено",
    "do czasu ręcznego odblokowania": "до ръчно отключване",
    "Ikona": "",
    "Co 30 minut": "На всеки 30 минути",
    "Zobacz zdjęcia": "Вижте снимки",
    "Wynagrodzenie": "Възнаграждение",
    "Wyrażenie regularne": "Регуларен израз",
    "Osiągnąłeś limit zdjęć. Nie możesz dodać więcej zdjęć": "Достигнали сте лимита си за снимки. Не можете да добавяте повече снимки",
    "Link przycisku": "",
    "Czy na pewno chcesz usunąć ten kolor?": "Сигурни ли сте, че искате да премахнете този цвят?",
    "Nie wybrano paczki.": "",
    "Proszę obciążyć gościa": "Моля, таксувайте госта",
    "Data publikacji": "",
    "Blokowanie użytkowników": "",
    "Dodawanie checklisty": "Добавяне на контролен списък",
    "Dodaj pytanie": "",
    "Zmodyfikował": "модифициран",
    "Numer telefonu": "Телефонен номер",
    "Dział nadrzędny": "Родителски отдел",
    "Wybierz tagi": "Изберете тагове",
    "Kolejne pozycje z lewej strony": "",
    "Wykonaj": "Изпълнение",
    "Wyloguj się": "Излезте",
    "Powiązane zadanie": "",
    "Poniedziałek": "Понеделник",
    "Nie mam zdania": "Нямам мнение",
    "Lista rezerwacji": "Списък с резервации",
    "Ładuje...": "Зареждане...",
    "Jesteś pewien?": "Сигурен ли си?",
    "Teraz": "сега",
    "Strona została zaktualizowana.": "",
    "Synchronizuj": "",
    "Numer mieszkania (Number)": "",
    "Usunięto użytkownika z czatu": "Премахнат потребител от чата",
    "Nazwa elementu": "",
    "Anuluj edycję": "",
    "Wróć na dół": "Върнете се на дъното",
    "Pokaż przycisk": "Показване на бутона",
    "Nazwa obiektu": "Име на обекта",
    "Uwzględniaj zadania z miesiąca": "Включете задачите на месеца",
    "Nazwa zespołu": "Име на отбора",
    "Wideo z biblioteki": "",
    "Data logowania": "",
    "Archiwum": "",
    "Zastępstwo wygasło.": "Замяната е изтекла.",
    "Typ Firmy": "Вид на фирмата",
    "Data przyjazdu": "Дата на пристигане",
    "ID użytkownika": "Потребителски идентификатор",
    "Log błędu": "",
    "Książka": "",
    "Typ serwera": "Тип сървър",
    "Maksimum": "Максимум",
    "Wybrany region": "Избран регион",
    "Pobrane z magazynu Renters": "Извлечено от списание Rentals",
    "Sekcja nie została znaleziona": "",
    "Nazwa zadania": "Име на задачата",
    "ID zadania": "Идентификатор на задача",
    "Nikomu nie przydzielono uprawnień": "Никой не е получил привилегии",
    "Kwota wynagrodzenia PLN brutto": "Размер на заплатата PLN бруто",
    "Rola aktywna": "Активна роля",
    "Usuń z zespołu": "Премахване от екипа",
    "Utworzone": "Създаден",
    "Nie udało się pobrać powiadomień.": "Неуспешно изтегляне на известия.",
    "Utwórz raport wyników": "",
    "Get it on Appstore": "Вземете го в Appstore",
    "Nazwa koordynatora": "",
    "Aplikacja nie ma uprawnień do wysyłania powiadomień PUSH": "Приложението няма разрешение за изпращане на PUSH известия",
    "Opis kategorii": "",
    "Nazwa autora": "",
    "Certyfikat został dodany.": "",
    "Tłumaczenia": "Преводи",
    "Liczba": "Номер",
    "Checkbox": "Квадрат за отметка",
    "Treść notatki": "Съдържание на бележката",
    "Miasto zostało usunięte": "Градът е премахнат",
    "+": "+",
    "Statystyki użytkowników": "Потребителска статистика",
    "Ustawienia wynagrodzenia zostały zaktualizowane.": "Настройките за заплата са актуализирани.",
    "Posiadasz niezapisane materiały": "",
    "Nadpisz kwotę": "Презапишете сумата",
    "Sortowanie rosnąco": "Сортиране възходящо",
    "Rejestr zmian": "Дневник на промените",
    "Urządzenie zostało usunięte.": "Устройството е премахнато.",
    "Notatka została dodana.": "Добавена е бележка.",
    "Prawda-Fałsz": "",
    "Dodanie użytkownika": "Добавяне на потребител",
    "Edytuj": "Редактиране",
    "Usuń filtr": "Премахване на филтъра",
    "Dodaj formularz": "Добавяне на формуляр",
    "Zapytanie SQL": "SQL заявка",
    "Akceptacja": "Приемане",
    "Podana wartość jest nieprawidłowa.": "Посочената стойност е невалидна.",
    "Edycja nieruchomości": "Редактиране на имота",
    "Niezadowolony": "Недоволен",
    "Utwórz zlecenie": "Създаване на поръчка",
    "Liczba całkowita": "Цяло число",
    "Czas wykonania": "Време за изпълнение",
    "Imie i nazwisko: ": "Име и фамилия: ",
    "Średnie wynagrodzenie koordynatora": "Средната заплата на координатор",
    "Kwota jednostkowa": "Единична сума",
    "Wyszukaj...": "Търсене...",
    "Edycja zestawu regulaminóe": "",
    "Informacje dodatkowe": "Допълнителна информация",
    "Średnie wynagrodzenie pracowników": "Средна заплата на служителите",
    "Tytuł sekcji": "Заглавие на раздела",
    "Blokowanie użytkowników szkoleń": "",
    "Warunkowo": "Условно",
    "Blok aktywny": "",
    "Aktualizuj": "Актуализиране",
    "Wybierz autora z listy": "",
    "Kolor obramowania": "Цвят на границата",
    "Urlop": "Почивки",
    "Stwórz czat": "Създайте чат",
    "Rola została dodana.": "Ролята е добавена.",
    "Lista zgłoszeń w tym apartamancie": "Списък на заявките в този апартамент",
    "Brak": "Няма",
    "Szczegóły zmiany": "Подробности за промяната",
    "Ta nieruchomość nie posiada informacji na temat wyposażenia.": "Този имот не разполага с информация за оборудване.",
    "Edytuj kategorie": "",
    "Status dokumentu": "",
    "Osoby przypisane jako domyślne do zadań zwiazanych ze sprzątaniem": "Хора, назначени като по подразбиране на задачи, свързани с почистването",
    "Jest problem": "Има проблем",
    "Adres domenowy": "",
    "i posiadających wymagane uprawnienia": "",
    "Wartość": "Стойност",
    "Dodaj stwierdzenie": "",
    "Tag został dodany.": "Маркерът е добавен.",
    "co 30 dni": "на всеки 30 дни",
    "Sekcja jest wymagana": "",
    "Przenieś wyżej": "",
    "Komentarz zadania nie może być dłuższy niż 500 znaków.": "Коментарът на задачата не може да бъде по-дълъг от 500 знака.",
    "Szkolenie jest opublikowane": "",
    "Rozpocznij synchronizację": "Започнете синхронизирането",
    "Dane wydziału zostały usunięte.": "Данните от факултета са изтрити.",
    "Zadanie zostało uruchomione.": "Задачата е започната.",
    "Dodano zdjęć": "Добавени снимки",
    "Kategorie szkoleń": "",
    "Pole \"Nazwisko\" jest wymagane.": "Полето „Фамилия“ е задължително.",
    "Zabierz dostęp": "Отстранете достъпа",
    "Kategorie": "Категории",
    "Typ obciążenia": "Тип натоварване",
    "Dokument nie jest jeszcze nigdzie opublikowany.": "",
    "Rozpocznij trasę": "Започнете маршрута",
    "Wybrano pliki różnych typów. Wybierz pliki tego samego typu.": "",
    "Nazwa tytułu nie może być dłuższa niż 240 znaków ani krótsza niż 3 znaki.": "",
    "Magazynier": "Складир",
    "Wielkość kroku": "Размер на стъпката",
    "Dodaj etykietę": "",
    "Firma sprzątająca": "Фирма за почистване",
    "Jeszcze nie ma kategorii.": "",
    "Aranżacja została zachowana.": "",
    "Edycja dzielnicy": "Редактиране на района",
    "Język domyślny": "",
    "Ogólne": "",
    "Koszty do zadania": "",
    "Dodanie ścieżki szkoleniowej": "",
    "Zaplanowane": "Планиран",
    "Wyczyść": "Изчистете",
    "Nazwa przycisku ``Dalej``": "Име на бутона „Следващия“",
    "Szkolenie jest puste": "",
    "Symbol strony": "",
    "Zacznij pisać aby wyszukać kierowcę...": "Започнете да пишете, за да търсите драйвер...",
    "Ilość wyników do pobrania": "Брой резултати за изтегляне",
    "Tylko priorytetowe": "",
    "Nie udało się wysłać pliku": "Неуспешно изпращане на файл",
    "Dodaj zdjęcia": "Добавяне на снимки",
    "Czas trwania:": "Продължителност:",
    "Koordynator": "Координатор",
    "Edycja źródła danych": "Редактиране на източника на данни",
    "Dane rezerwacji": "Данни за резервацията",
    "Wersja opublikowana": "",
    "Użytkownik jest liderem zespołu": "Потребителят е лидер на екипа",
    "Utworzone przez:": "Създаден от:",
    "Użytkownik został usunięty.": "Потребителят е изтрит.",
    "Deadline - Data wykonania": "",
    "L4": "Л4",
    "Opis": "Описание",
    "Nie ma ustalonej roli dla tego wydziału": "Няма фиксирана роля за този отдел",
    "Ukryj materiał": "",
    "Pokaż tytuły stron": "Показване на заглавия на страници",
    "Moje filtry": "Моите филтри",
    "Moje czaty": "Моите чатове",
    "Zapamiętaj logowanie": "Запомнете влизане",
    "Data zdarzenia": "Дата на събитието",
    "Wartość musi być liczbą ujemną": "Стойността трябва да бъде отрицателно число",
    "Filtr prywatny": "Частен филтър",
    "Zakończ trasę": "Завършете маршрута",
    "Dodaj wszystkich dopasowanych użytkowników": "Добавяне на всички съвпадащи потребители",
    "Stawka nieruchomości": "",
    "Publikacja została dodana.": "",
    "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "Ще можете да добавяте термини към речника само след като запазите източника на данни.",
    "Godzina zameldowania": "Време за настаняване",
    "Zakres czasu": "Времеви диапазон",
    "Nazwa katalogu została zmieniona.": "Името на директорията е променено.",
    "Najnowsze": "",
    "Certyfikat nie jest opublikowany": "",
    "Tekst do uzupełnienia": "",
    "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "За да добавите членове на екипа, първо трябва да запазите формуляра.",
    "Statusy użytkowników": "Статуси на потребителя",
    "Nr telefonu": "Телефонен номер",
    "Dodaj nowy koszt": "Добавете нова цена",
    "Zmodyfikowane przez użytkownika": "Променен от потребителя",
    "Liczba zgłoszonych problemów": "Брой съобщени проблеми",
    "Domyślny kolor trasy (dotyczy kierowców)": "Цвят на маршрута по подразбиране (важи за водачите)",
    "Peticion disponibilidad": "Заявка за наличност",
    "Brak miast": "Няма градове",
    "Nowa kwota": "Нова сума",
    "Łączenie treści": "Свързване на съдържание",
    "Data wykonania": "Дата на изпълнение",
    "Ten użytkownik nie posiada jeszcze przypisanych dzielnic.": "Този потребител все още няма определени райони.",
    "Niewidoczne": "Невидим",
    "Zadania do wykonania": "Задачи за изпълнение",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "",
    "Zapauzowane": "Изоставен",
    "Pole może zawierać jedynie cyfry.": "Полето може да съдържа само цифри.",
    "kanał wymagany": "необходим канал",
    "Usuń regulamin": "",
    "Podstawowe operacje tekstowe": "Основни текстови операции",
    "Nierozwiązane": "Нерешени",
    "Brak plików w sekcji": "",
    "Brak aktywnego filtru": "Няма активен филтър",
    "Element został dodany.": "",
    "Dashboard": "Табло за управление",
    "Odznacz wszystko": "Премахнете отметката от всички",
    "Nazwa przycisku ``Wstecz``": "Име на бутона ``Назад ``",
    "z": "",
    "Podstawowe": "основен",
    "Edycja wielu elementów": "Редактиране на няколко елемента",
    "Przesyłam...": "Изпращам...",
    "Liczba wyświetlanych elementów": "",
    "Edycja aranżacji": "",
    "Formularz": "Форма",
    "Łączny czas wykonywania zadań": "Общо време за изпълнение на задачата",
    "Przypisz do zadania": "",
    "Google Nexus 7": "",
    "Serwer dostępny": "Наличен сървър",
    "Wybierz artykuł": "",
    "Archiwizuj": "Архив",
    "BIC/Swift": "BIC/Swift",
    "Koszty zadania zostały zaktualizowane.": "Разходите за задачи са актуализирани.",
    "Wybrano:": "Избрани:",
    "Dodanie właściciela": "Добавяне на собственик",
    "Przejdź do zlecenia z notatki": "Отидете на поръчката от бележката",
    "Dodaj do zestawu": "",
    "Data zakończenia do": "Крайна дата до",
    "Role": "",
    "Twój token": "Вашият жетон",
    "Publiczne": "Публичен",
    "Edycja wynagrodzenia mieszanego dla:": "Редактирайте смесената заплата за:",
    "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
    "Przeciągnij i upuść aby posortować pliki": "Плъзнете и пуснете, за да сортирате файлове",
    "Edycja szablonu": "",
    "Słownik": "Речник",
    "Wybierz wydział": "Изберете факултет",
    "To szkolenie znajduje się już w ścieżce szkoleń": "",
    "Trasa została zapisana.": "Маршрутът е запазен.",
    "Początkowy stan licznika": "Първоначалното състояние на брояча",
    "Nie można jednocześnie wybrać tagów i zaznaczyć opcji 'Usuń wszystkie tagi'": "",
    "To zadanie dotyczy nieruchomości, która znajduje się na trasie. Czy chcesz przejść do mapy, aby edytować punkt?": "",
    "Rodzaj adresu kanonicznego": "",
    "Nie udało się pobrać listy powiadomień": "Неуспешно изтегляне на списъка с уведомления",
    "Usuń odpowiedź": "",
    "Powiązane zadania": "Свързани задачи",
    "Nie": "не",
    "Zaznacz wszystkie": "Изберете всички",
    "Obsługa Klienta (BOK)": "Обслужване на клиенти (BOK)",
    "Tak": "Да",
    "Rozwiązane": "Решено",
    "Kolor został dodany": "Цветът е добавен",
    "Wybrana liczba jest mniejsza niż dozwolona %0.": "Избраният брой е по-малък от допустимото% 0.",
    "Dodaj wiersz": "",
    "Dowolny": "Всяко",
    "Pokaż nieaktywne nieruchomości": "Показване на неактивни имоти",
    "Dodano użytkownika do czatu": "Добавен потребител към чата",
    "Ta dzielnica jest już przypisana do użytkownika.": "Този район вече е присвоен на потребителя.",
    "Zasoby": "Ресурси",
    "Utworzone przez": "Създаден от",
    "Adres kanoniczny": "",
    "Dodaj dni": "Добавяне на дни",
    "Zamknięte przez użytkownika o Id": "Затворено от потребителя относно Id",
    "Usuń wiersz": "",
    "Wielokrotnego wyboru": "",
    "Dodanie slajdów": "",
    "Dodaj nową stronę lub wybierz z menu aby edytować.": "",
    "Poprzednia strona": "Предишна страница",
    "Pomieszczenie": "Стая",
    "Dostęp": "Достъп",
    "Rola została zaktualizowana.": "Ролята е актуализирана.",
    "Materiały": "",
    "Widok tygodniowy": "Седмичен изглед",
    "Dodanie strony": "",
    "Definicja szablonu": "",
    "Stan powiadomienia": "Статус на уведомлението",
    "Uwzględniaj miasta": "Включване на градове",
    "Nieruchomości": "Недвижими имоти",
    "Bank": "Банка",
    "Usuń pytanie": "",
    "Moje trasy": "Моите маршрути",
    "Plik wideo": "",
    "Edytowana wersja": "Редактирана версия",
    "Edycja testu": "",
    "Dalej": "По-нататък",
    "Zespół": "Екип",
    "Przyczyna": "Причината",
    "Opublikuj tutaj": "",
    "...nie znalazłeś bloku?": "",
    "Definicja formularza znajduje się w obiekcie Form.": "Дефиницията на формуляра се намира в обекта Форма.",
    "Liczba dużych prześcieradeł": "Брой големи листове",
    "Domyślna checklista": "Контролен списък по подразбиране",
    "Dodaj Koszt do zadania": "Добавяне на цена към задачата",
    "Użytkownik został zaktualizowany.": "Потребителят е актуализиран.",
    "Wstaw szablon informacyjny ze zdjęciem": "Вмъкнете информационен шаблон със снимка",
    "Szkic": "скица",
    "Data końcowa nie może być wcześniejsza niż data początkowa": "Крайната дата не може да бъде по-ранна от началната дата",
    "Legacy mode": "",
    "Wrzesień": "Септември",
    "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "",
    "Utwórz katalog": "Създаване на каталог",
    "Wszystkie typy": "",
    "Zobacz przed opublikowaniem": "",
    "Raport został wysłany na adres e-mail": "Докладът е изпратен на имейла",
    "Wybranie katalogu jest wymagane": "",
    "Nie udało się pobrać listy modułów": "",
    "Trasa została wznowiona": "Маршрутът е възобновен",
    "Zapisz wersję": "",
    "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "",
    "Zacznij pisać numer aby wyszukać źródło rezerwacji...": "Започнете да въвеждате номера, за да търсите източник на резервация...",
    "Slajder został usunięty.": "",
    "Satysfakcja": "Удовлетворение",
    "Formularz kontaktowy": "",
    "Utwórz nowy": "",
    "Dodaj slajder": "",
    "Separator elementów w tytule": "",
    "Wyloguj": "Излезте",
    "Przypisane miasta:": "Присвоени градове:",
    "Notatka magazyniera": "Бележка на складовеца",
    "Wyszukaj blok": "",
    "Usunięcie": "Изтриване",
    "Nie udało się usunąć użytkownika z czatu": "Неуспешно премахване на потребителя от чата",
    "Statystyki regionalne - miasta": "Регионална статистика - градове",
    "Nazwa konta (Klucz dostępu)": "Име на акаунта (ключ за достъп)",
    "Aktywność": "Дейност",
    "Nazwa szkolenia": "",
    "Ustawienia sekcji \"%0\"": "",
    "Id rezerwacji:": "",
    "Losowa kolejność elementów": "",
    "Edycja Notatki": "Редактиране на бележки",
    "Wstaw z góry": "Вмъкнете отгоре",
    "Standard 2004": "",
    "Mieszane": "смесени",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "",
    "Dodaj serwer": "Добавяне на сървър",
    "Listopad": "Ноември",
    "obrót": "въртене",
    "Dodaj ścieżkę": "",
    "Wybierz kategorię": "Изберете категория",
    "Nazwa paczki": "",
    "Aktualne urządzenie": "Текущо устройство",
    "Priorytet": "Приоритет",
    "Edytuj zestaw": "",
    "Ustawienia zaawansowane": "Разширени настройки",
    "Średnie wynagrodzenie pracownika": "Средна заплата на служител",
    "Jedna kolumna": "Единична колона",
    "Adres aktywnej strony": "",
    "Noclegi": "Настаняване",
    "Przypisane regiony:": "Присвоени региони:",
    "Edytuj dział": "Редактиране на отдел",
    "Rozmiar zdjęcia został zmieniony.": "Размерът на снимката е променен.",
    "Pole może zawierać jedynie litery i cyfry.": "Полето може да съдържа само букви и цифри.",
    "Moje dokumenty": "",
    "Planowana data wykonania": "Планирана дата на изпълнение",
    "Edycja tagu nieruchomości": "Редактиране на маркер на свойствата",
    "Otwórz stronę w nowym oknie": "",
    "Dodano": "Добавена",
    "Data dodania inwentaryzacji": "Дата на добавяне на инвентара",
    "Edycja roli": "Редактиране на ролята",
    "Dołączanie...": "Присъединяване към...",
    "Czy zablokować użytkownika i jego wiadomość?": "Блокирате потребителя и неговото съобщение?",
    "Typ plików jest wymagany": "",
    "Ogólne informacje": "",
    "Szerokość": "Ширина",
    "URL": "",
    "Edytuj stawkę za godzinę": "Редактиране на скорост на час",
    "Lista regulaminów": "",
    "Imię gościa": "Име на госта",
    "Przenieś wybrane": "Преместване на избрани",
    "Lista ścieżek szkoleniowych": "",
    "Oraz nowe hasło": "И нова парола",
    "Dodaj tag nieruchomości": "Добавяне на етикет на свойствата",
    "Zestaw został zaktualizowany.": "",
    "Serwer został usunięty.": "Сървърът е изтрит.",
    "wybierz szablon": "",
    "Porównaj %0": "Сравняване% 0",
    "Nie wybrano strony": "",
    "Status edytowanej wersji dokumentu": "Състояние на редактираната версия на документа",
    "Edycja strony": "",
    "Jestem w pracy": "Аз съм на работа",
    "W pracy": "На работа",
    "Poza pracą": "Извън работа",
    "Status pracy": "Статус на работа",
    "Przejdź do zadania": "Към задачата",
    "Jesteś w pracy. Kliknij, aby ustawić status Poza pracą": "Вие сте на работа. Щракнете, за да зададете Извън работа",
    "Jesteś poza pracą. Kliknij, aby ustawić status W pracy": "Вие сте извън работа. Щракнете, за да зададете На работа",
    "Zaloguj się loginem i hasłem": "Вход с потребителско име и парола",
    "Zakończyć pracę?": "Край на работата?",
    "Masz rozpoczęte zadanie:": "Имате започната задача:",
    "Po wyłączeniu statusu nie będziesz mógł rozpoczynać zadań.": "След изключване на статуса няма да можете да започвате задачи.",
    "Zakończ pracę": "Край на работата",
    "Aby rozpocząć zadanie, musisz mieć włączony status \"W pracy\".": "За да започнете задачата, трябва да имате включен статус \"На работа\".",
    "Status zostanie włączony automatycznie, a zadanie rozpocznie się od razu.": "Статусът ще бъде включен автоматично, а задачата ще започне веднага.",
    "Włącz i rozpocznij zadanie": "Включи и започни задачата",
    "Zadanie pozostanie rozpoczęte. Pamiętaj, aby je zakończyć lub zapauzować.": "Задачата ще остане започната. Не забравяйте да я завършите или паузирате.",
    "Nie jesteś w pracy": "Не сте на работа",
    "Dopasuj do obrazka": "",
    "Punkty": "",
    "Zmień hasło": "Промяна на паролата",
    "Nie udało się pobrać listy aranżacji": "",
    "wybierz": "изберете",
    "Opiekun ścieżki": "",
    "Powtórz hasło": "Повторете паролата",
    "Czwartek": "четвъртък",
    "Nowe hasło": "Нова парола",
    "Dodawanie trasy": "Добавяне на маршрут",
    "Dodaj trasę": "Добавяне на маршрут",
    "Strona główna": "Главна страница",
    "VAT": "",
    "Pokaż etykietę": "Показване на етикета",
    "Data modyfikacji od": "Изменена дата от",
    "Wyrażenia warunkowe": "Условни изрази",
    "Potwierdź zapis do aktualnej wersji": "",
    "Dział został dodany.": "Отделът е добавен.",
    "Opracowane": "Разработен",
    "Wysłane wezwanie do zapłaty": "Изпратено искане за плащане",
    "Podpis": "Подпис",
    "Data początkowa nie może być późniejsza niż data końcowa": "Началната дата не може да бъде по-късна от крайната дата",
    "Nieruchomość niestandardowa o Id": "Персонализиран имот с идентификатор",
    "Dodaj zastępstwo": "Добавяне на заместител",
    "Zastępstwo zostało dodane.": "Добавен е заместител.",
    "Planowanie inwentaryzacji": "Инвентарно планиране",
    "Kategoria wyszukiwanego matariału": "",
    "Powiadomienia": "Известия",
    "Edycja wynagrodzenia stałego dla:": "Редактиране на фиксирана заплата за:",
    "Data ostatniej zmiany statusu": "Дата на последната промяна на статута",
    "Aby zakończyć trasę należy uzupełnić stan licznika na koniec": "За да завършите маршрута, трябва да попълните състоянието на измервателния уред в края",
    "Osoby przypisane jako domyślne do zadań zwiazanych z konserwacją": "Хора, назначени като по подразбиране на задачите за поддръжка",
    "Pliki zostały dodane": "",
    "Ustawienia ogólne": "Общи настройки",
    "Okładka": "",
    "Konserwacja": "Поддръжка",
    "Publikuj od": "",
    "Do sprawdzenia": "Трябва да се провери",
    "Pliki prywatne": "Частни файлове",
    "Dodanie linku": "",
    "Czas trwania blokady": "Продължителност на ключалката",
    "Stwórz nowy czat": "Създайте нов чат",
    "Nieopłacone/dłużnik": "Неплатен/Длъжник",
    "Wyświetl materiały": "",
    "Chat został zarchiwizowany.": "Чатът е архивиран.",
    "Reżyseria": "",
    "Zablokowano możliwość edycji": "Блокира възможността за редактиране",
    "IBAN": "ИБАН",
    "Nie udało się pobrać listy typów modeli": "Неуспешно изтегляне на списъка с типове модели",
    "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Възможността за промяна на този акаунт е ограничена. Неактивните полета се синхронизират с външната база данни %0.",
    "Nazwa pliku": "Име на файла",
    "Data zakończenia blokady konta": "Крайна дата на заключване на акаунта",
    "Kategoria": "категория",
    "Autor": "Автор",
    "Wybierz": "изберете",
    "Ilość koordynatorów w regionie": "Брой координатори в региона",
    "Lista paczek SCORM": "",
    "Brak modułu": "",
    "Ukończone przez użytkownika o Id": "Попълнено от потребител o Id",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Имаше грешка във връзката. Уверете се, че имате включен интернет и опитайте отново.",
    "Zaloguj się na swoje konto": "",
    "Wideo": "",
    "W zespole od": "",
    "Potwierdzam, zapisz": "Потвърждавам, запазвам",
    "Wróć do logowania": "Върнете се към вход",
    "Suma Wynagrodzeń": "Общо заплати",
    "Grudzień": "Декември",
    "Najniższy": "",
    "Kuchnia": "",
    "Usuń element": "Изтриване на елемент",
    "Facturada": "Фактурирана",
    "Usunięte przez": "Изтрит от",
    "Rodzaj kosztu": "Вид на разходите",
    "Zastępuje osobę": "Заменя човек",
    "Inspektor": "Инспектор",
    "Filtry powiadomień": "Филтри за уведомяване",
    "Dodaj stronę": "Добавяне на страница",
    "Data ostatniej inwentaryzacji": "Дата на последната инвентаризация",
    "Co 15 minut": "На всеки 15 минути",
    "Dane osobowe": "Лични данни",
    "Dopasowanie": "",
    "Data odrzucenia": "",
    "Formularz zarchiwizowany": "Архивиран формуляр",
    "Wyzeruj licznik": "Нулиране на брояча",
    "Kwota średnia": "Средна сума",
    "Nie podano nazwy poprzedniej kategorii.": "",
    "Dodaj obrazek": "",
    "Wybrany język": "Избран език",
    "Akceptuj": "Приемете",
    "Aby rozpocząć trasę należy uzupełnić stan licznika na start": "За да стартирате маршрута, е необходимо да завършите състоянието на стартовия брояч",
    "Stan licznika nie może być wartością ujemną": "Стойността на брояча не може да бъде отрицателна",
    "Standard nieznany": "",
    "Data aktualizacji": "Дата на актуализация",
    "Stwierdzenia": "",
    "Legenda": "",
    "Przejdź do zadania z notatki": "Отидете на задачата от бележката",
    "Pokaż tytuł sekcji": "Покажи заглавието на секцията",
    "Trzy kolumny": "Три колони",
    "Ścieżka nawigacyjna": "",
    "Edytuj test": "",
    "Kontakty - Typ działania": "Контакти - Вид дейност",
    "Ten użytkownik nie posiada jeszcze przypisanych miast.": "Този потребител все още няма назначени градове.",
    "Osoby przypisane jako domyślne do zadań zwiazanych z inspekcją": "Хора, назначени като по подразбиране на задачи, свързани с одита",
    "24 godziny": "24 часа",
    "Inna": "Инна",
    "Szczegóły zdarzenia nr %0": "Подробности за събитието #% 0",
    "Tytuł strony": "",
    "Dodanie formularza": "Добавяне на формуляр",
    "Wyloguj zalogowanego obecnie użytkownika": "Излезте от текущо влязъл потребител",
    "Potwierdzenie archiwizacji": "Потвърждение на архивирането",
    "Dodaj pliki": "",
    "źródło zostało usunięte.": "Източникът е премахнат.",
    "Uwzględnij wydziały i statusy jednocześnie": "Включете факултети и статуси наведнъж",
    "Włącz system powiadomień": "Активирайте системата за уведомяване",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "Не може да се добави файл (и): „% 0\". Можете да добавяте само файлове от типа „% 1\".",
    "Wygeneruj plik": "Генериране на файл",
    "Nie pokazuj linku do archiwum strony (NoArchive)": "",
    "Nazwa roli": "Име на ролята",
    "Organizacja": "Организация",
    "${title}": "$ {заглавие}",
    "Usuń z trasy": "Премахване от маршрута",
    "Serwery plików": "Файлови сървъри",
    "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "",
    "Ten Tydzień": "Тази седмица",
    "Element został usunięty.": "Елементът е премахнат.",
    "Co 2 tygodnie": "На всеки 2 седмици",
    "Co tydzień": "Всяка седмица",
    "Zlecenie": "Поръчайте",
    "Właściciel został zaktualizowany.": "Собственикът е актуализиран.",
    "Radio": "радио",
    "Lekcja ukryta": "",
    "Suma wynagrodzeń": "Сумата на заплатите",
    "Koordynator*": "",
    "Nie udało się dodać użytkownika do czatu": "Неуспешно добавяне на потребител към чата",
    "Aktywne": "Активен",
    "Nazwa strony": "",
    "Uwzględniaj tagi": "Включване на тагове",
    "Google Nexus 5": "",
    "Brakujące tytuły kafelków.": "",
    "Kwota pobrana": "Събрана сума",
    "Dodaj media": "Добавяне на медия",
    "Ikona wyświetlana jest w postaci kwadratu.": "",
    "Edycja aktualności": "",
    "Dane został wgrane": "Данните са качени",
    "Pokaż cały błąd": "",
    "Wybrana liczba jest większa niż dozwolona %0.": "Избраният брой е по-голям от допустимото% 0.",
    "Krótki opis": "",
    "Komentarz dotyczący naprawy problemu": "Коментар за отстраняване на проблема",
    "Strony": "",
    "Serial telewizyjny": "",
    "Wyszukaj wszędzie": "Търсене навсякъде",
    "Hasło (Klucz ukryty)": "Парола (скрит ключ)",
    "Ustawienia chatów": "Настройки за чат",
    "Filtr został zapisany": "Филтърът е запазен",
    "Odpowiedź 3": "Отговор 3",
    "Edycja serwera": "Сървърно редактиране",
    "Nie przypisano": "Не е назначен",
    "Wykonaj akcję": "Изпълнете действието",
    "Czaty": "Чатове",
    "Dodaj katalog": "",
    "Firma została usunięta.": "Компанията е премахната.",
    "Data wymeldowania do": "Дата на напускане до",
    "Konta publiczne": "",
    "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "В настройките за уведомяване не е активиран комуникационен канал.",
    "Pole \"%0\" jest wymagane.": "Полето „% 0\" е задължително.",
    "Nie udało się pobrać listy stron": "",
    "Jeśli pole jest puste to wstawiana automatycznie.": "",
    "Płyta z muzyką": "",
    "Tagi zadań": "Тагове на задачите",
    "Próg zaliczenia (%)": "",
    "Wybierz autora": "",
    "Co 10 dni": "На всеки 10 дни",
    "Konfiguracja harmonogramu": "Конфигурация на графика",
    "Repozytorium plików": "Файлово хранилище",
    "Usuń kafelek": "",
    "Musisz najpierw zapisać zmienioną kolejność punktów zanim oznaczysz punkt": "Първо трябва да запазите променения ред на точките, преди да маркирате точка",
    "Kalendarz pracowników": "",
    "Przypisane tagi: ": "Присвоени маркери: ",
    "Dodaj Zadanie": "Добавяне на задача",
    "Obok siebie": "Рамо до рамо",
    "Potwierdź wyłączenie publikacji": "",
    "Ilość kosztów": "Размер на разходите",
    "Co 6 godzin": "На всеки 6 часа",
    "Czat": "Чат",
    "Imię": "Име",
    "Kolory rezerwacji": "Цветове за резервация",
    "Proszę obciążyć właściciela obiektu": "Моля, таксувайте собственика на имота",
    "Usuń trasę": "Изтриване на маршрута",
    "Zacznij pisać aby wyszukać właściciela...": "Започнете да пишете, за да търсите собственика...",
    "Slajdy": "",
    "Dzielnica nieruchomości": "Квартал Недвижими Имоти",
    "Resetuj": "Нулиране",
    "Urlop został usunięty": "Празникът е премахнат",
    "Host dodatkowy": "Вторичен хост",
    "Komentarz": "Коментар",
    "Status notatki": "Състояние на бележката",
    "Witryna została zaktualizowana.": "",
    "Imię i nazwisko": "Име и фамилия",
    "Zacznij pisać numer aby wyszukać rezerwację...": "Започнете да въвеждате номера, за да търсите резервация...",
    "Zdecydowanie się zgadzam": "Силно съм съгласен",
    "Element został przywrócony.": "Елементът е възстановен.",
    "Wymagaj kolejności zaliczania elementów": "",
    "co rok": "всяка година",
    "Zajawka": "",
    "Zestaw niestandardowy": "",
    "Edycja lekcji": "",
    "Co minutę": "Всяка минута",
    "Open Graph": "",
    "Role i uprawnienia": "Роли и разрешения",
    "Coś poszło nie tak": "Нещо се обърка",
    "Data wymeldowania od": "Дата на напускане от",
    "Nazwa przycisku ``Wyślij``": "Име на бутона ``Изпращи``",
    "Rezerwacje anulowane": "Резервации анулирани",
    "Dane": "Данни",
    "zacznij pisać aby wyszukać certyfikat...": "",
    "Wyżej": "",
    "Nie udało się pobrać listy zastępstw": "Неуспешно извличане на списък със заместители",
    "Id sesji": "Ид на сесията",
    "Opłacono": "Платени",
    "Przekroczono dozwoloną ilość znaków: %0.": "Разрешеният брой символи е надвишен:% 0.",
    "Inwentaryzacja została zaktualizowana.": "Инвентарът е актуализиран.",
    "Bułgarski": "Български",
    "Ok": "Добре",
    "Nazwa certyfikatu": "",
    "Edycja właściciela": "Редактиране на собственик",
    "Data rezerwacji do": "Дата на резервацията до",
    "Domyślne ustawienie dla witryny": "",
    "znaki": "знаци",
    "Edycja slajdów": "",
    "Data Zmiany": "Дата на промяната",
    "Niżej": "",
    "Pytanie i odpowiedzi": "",
    "Wgraj plik": "Качване на файл",
    "Odpowiedź 1": "Отговор 1",
    "Przypisani użytkownicy": "Присвоени потребители",
    "Miejsce logowania": "Местоположение за влизане",
    "Wróć do strony głównej": "Върнете се на главната страница",
    "Użytkownik Sprzatanie": "Почистване на потребителя",
    "Laptop 17\"": "",
    "Ukraiński": "Украински",
    "6 godzin": "6 часа",
    "Koszt został zaktualizowany.": "Цената е актуализирана.",
    "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "",
    "Imię lub nazwisko właściciela": "",
    "W zespole od %0": "В екип от% 0",
    "Adres IP": "IP адрес",
    "Konfiguracja": "",
    "Profil użytkownika": "Потребителски профил",
    "Notatki Koordynatorów": "Бележки на координаторите",
    "Ilość nocy": "Брой нощувки",
    "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "",
    "Trasa została zakończona": "Маршрутът е завършен",
    "Czy opublikowany": "",
    "Zaakceptowane": "Приет",
    "Niewykonane zadania": "Неизпълнени задачи",
    "Edytuj kolor": "Редактиране на цвета",
    "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Известието се изисква по подразбиране. Не е възможно да се деактивира изпращането на това уведомление.",
    "Strona lekcji SCORM opublikowana": "",
    "Nieaktywni właściciele": "Неактивни собственици",
    "Data następnej inwentaryzacji": "Дата на следващата инвентаризация",
    "Przetestuj ustawienia poczty": "Тествайте настройките за поща",
    "Wszystkie kategorie": "Всички категории",
    "Odpowiedzi": "Отговори",
    "Kalendarz Pracowniczy": "Календар на служителите",
    "Element": "",
    "Brak dodanych punktów trasy": "Не са добавени точки за маршрут",
    "Słownik dowolny": "Произволен речник",
    "Nazwa witryny": "",
    "Raporty": "Доклади",
    "Dodaj kategorie": "",
    "Synchronizuj razem z anulowanymi": "Синхронизирайте заедно с отменените",
    "Pytanie 2": "Въпрос 2",
    "Zrób zdjęcie": "Направете снимка",
    "Numer domu": "Номер на къщата",
    "Ilość toalet": "Брой тоалетни",
    "Dodaj zadanie: inspekcja": "Добавяне на задача: проверка",
    "ID": "ИДЕНТИФИКАЦИОНЕН НОМЕР",
    "Przycisk": "",
    "Wysłane powiadomienie": "",
    "co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)": "какво ще се случи сега (какво е очакването на госта)",
    "Nie udało się zapisać komentarza": "",
    "Powiadomienie o oczekującym szkoleniu": "",
    "Pokaż zdjęcie w raporcie": "Показване на снимката в доклада",
    "zacznij pisać aby wyszukać użytkownika...": "започнете да пишете, за да търсите потребител...",
    "Zaznacz": "Марк",
    "Historia zmian": "История на промените",
    "Dodaj nieruchomość do trasy": "Добавяне на свойство към маршрута",
    "Rozwiń do": "",
    "Wstaw z lewej strony": "Вмъкнете отляво",
    "Kopiuj filtr": "Копиране на филтъра",
    "Nieaktywne": "Неактивен",
    "Ilość zadań": "Брой задачи",
    "Hasło zostało zmienione. Zaloguj się ponownie": "Паролата е променена. Влезте отново",
    "Nazwa wydziału": "Име на отдела",
    "Poziomo": "",
    "Bardzo zadowolony": "Много доволен",
    "Zacznij pisać aby wyszukać...": "Започнете да пишете, за да търсите...",
    "Nie udało się pobrać danych odnośnie rezerwacji i zadań": "Неуспешно извличане на данни за резервации и задачи",
    "Publikacja została usunięta.": "",
    "Zlecenie zostało utworzone.": "Поръчката е създадена.",
    "Podaj adres url...": "",
    "KRS": "КРС",
    "Przedrostek": "Префикс",
    "Galeria zdjęć": "",
    "Bloki": "",
    "Pytanie": "",
    "Od poziomu": "",
    "Nie udało się zapisać szablonu": "Неуспешно запазване на шаблона",
    "Strona testu opublikowana": "",
    "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "",
    "Stworzone przez użytkownika": "Създаден от потребителя",
    "Wstaw przycisk": "",
    "Id checklisty": "Идентификатор на контролния списък",
    "Region apartamentu": "Районът на апартамента",
    "Nie udało się utworzyć zlecenia.": "Не успя да се създаде поръчка.",
    "5": "",
    "Bardzo niezadowolony": "Много недоволен",
    "Cron": "Крон",
    "Dzielnica została zaktualizowana.": "Областта е актуализирана.",
    "Luty": "Фев",
    "Włącz social media": "",
    "Monitor aktywności": "",
    "Utworzono przez: ": "Създаден от: ",
    "Drugie imię": "Второ име",
    "Typ elementu": "",
    "Podaj dane autora": "",
    "${(ex as any).response.data.errors.message[0]}": "$ {(напр. като всеки) .response.data.errors.message [0]}",
    "Usuń kategorię": "",
    "Po przejściu na mapę zadanie zostanie usunięte.": "",
    "Typ pola": "Тип на полето",
    "Opracowanie kosztu": "Развитие на разходите",
    "Dodanie miasta": "Добавяне на град",
    "Katalog linków": "",
    "Przypisani użytkownicy:": "",
    "Elementy": "",
    "Dane wydziału zostały dodane.": "Добавени са данни от факултета.",
    "Zapisz": "Запазване",
    "Kwota kosztu od": "Размер на разходите от",
    "Pobierz plik": "Изтегляне на файла",
    "Data wznowienia": "Дата на възобновяване",
    "zacznij pisać aby wyszukać szkolenie...": "",
    "Imię klienta": "Име на клиента",
    "Opis obrazka": "",
    "Edycja ustawień wynagrodzenia dla:": "Редактиране на настройките за заплата за:",
    "Usuń obrazek": "",
    "Wymagane": "Задължително",
    "Lista jest pusta": "Списъкът е празен",
    "Porównywana wersja": "Сравнима версия",
    "Edytuj lekcje SCORM": "",
    "Zacznij pisać aby wyszukać region...": "Започнете да пишете, за да търсите регион...",
    "Nazwisko i Imię": "Фамилия и собствено име",
    "Region został usunięty": "Регионът е премахнат",
    "Stwórz zadanie z notatki": "Създаване на задача от бележка",
    "Edytuj sekcję": "",
    "Dostępne języki": "",
    "Wybierz dział": "Изберете отдел",
    "Usuń slajd": "",
    "Lista certyfikatów": "",
    "Niestandardowy adres strony": "",
    "Dodatkowe wynagrodzenie - komentarz": "Допълнителна заплата - коментар",
    "Nazwa slajdu": "",
    "Data utworzenia do": "Дата на създаване до",
    "Ten zespół nie posiada jeszcze żadnych członków.": "Този екип все още няма членове.",
    "Harmonogram": "График",
    "Za przepracowane godziny": "За отработени часове",
    "Wynagrodzenie PLN brutto": "Заплата PLN бруто",
    "Symbol": "",
    "Zaznacz wszystko ": "Маркирайте всички ",
    "Witryna została dodana.": "",
    "Lista punktów": "Списък на точките",
    "Środa": "сряда",
    "Zwierzątko": "",
    "Są to wszystkie obiekty, nawet te, które posiadają już właściciela.": "Това са всички обекти, дори тези, които вече имат собственик.",
    "Ukryj filtry": "Скриване на филтри",
    "Typ zestawu": "",
    "Edycja certyfikatu": "",
    "Wpisz kwotę": "Въведете сумата",
    "Testowy adres email": "Тестване на имейл адреса",
    "Szablon": "",
    "Wynagrodzenie stałe miesięczne": "Фиксирана месечна заплата",
    "Udało się zaktualizować zadania!": "Успешно актуализирани задачи!",
    "Ostateczne wynagrodzenie:": "Окончателна заплата:",
    "Nie udało się dodać pliku typu ": "Неуспешно добавяне на тип файл ",
    "Nieruchomość została dodana.": "Имотът е добавен.",
    "Standard": "",
    "E-mail": "Електронна поща",
    "Miesiąc edycji wynagrodzenia": "Месец за редактиране на заплата",
    "Edytuj lekcje wideo": "",
    "Edycja trasy": "Редактиране на маршрута",
    "Powrót do historii": "Обратно към историята",
    "Nazwa domyślnej checklisty": "Име на контролния списък по подразбиране",
    "Moje zadania": "Моите задачи",
    "Link został usunięty.": "",
    "Ustawienia": "Настройки",
    "Nie udało się dodać miasta lub dzielnicy": "Неуспешно добавяне на град или област",
    "Dodaj lekcję Wideo": "",
    "Apple iPad": "",
    "Nie ma żadnych etykiet dla wybranej daty": "Няма етикети за избраната дата",
    "Sekcja została usunięta": "",
    "Zdjęcie główne": "",
    "Aktualność została zaktualizowana.": "",
    "Liczba pracowników w regionie": "Брой служители в региона",
    "Slajd został usunięty.": "",
    "Notatka została usunięta.": "Бележката е изтрита.",
    "Filtry map": "Филтри за карти",
    "Wysłane": "Изпратено",
    "Pole może zawierać jedynie litery.": "Полето може да съдържа само букви.",
    "Nie udało się pobrać listy kolejek": "Неуспешно извличане на списъка с опашки",
    "Stack Trace": "",
    "Stwierdzenie": "Твърдение",
    "Data utworzenia zadania": "",
    "Wyczyść filtry": "Изчистване на филтрите",
    "Zobacz szczegóły zdarzenia": "Вижте подробности за събитието",
    "Ustawienia Domyślne": "Настройки по подразбиране",
    "Firma została dodana.": "Компанията е добавена.",
    "Całkowity dystans (km)": "Общо разстояние (km)",
    "Checklista została zaktualizowana.": "Контролният списък е актуализиран.",
    "Brak kategorii nadrzędnej": "",
    "Przyjazd": "пристигане",
    "Wyczyść defaultowych użytkowników": "Изчистване на потребителите по подразбиране",
    "Automatyczna akceptacja": "",
    "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Могат да се редактират само активирани и поддържани шаблони за канали.",
    "Liczba szkoleń w ścieżce": "",
    "Data wyjazdu": "Дата на заминаване",
    "Dodanie zestawu regulaminów": "",
    "Kategoria materiałów": "",
    "Edytuj slajder": "",
    "Szukana fraza": "Търсена фраза",
    "Punkt został oznaczony": "Точката е отбелязана",
    "Akcje": "акции",
    "Wstaw cztery kolumny 1/4": "Поставете четири 1/4 колони",
    "Podsumowanie": "резюме",
    "Miesiące": "Месеци",
    "Marketing": "",
    "Co 4 miesiące": "На всеки 4 месеца",
    "Wyrażone zgody": "",
    "Sierpień": "Август",
    "Potwierdzenie zmiany statusu": "Потвърждение за промяна на състоянието",
    "Film": "",
    "Wymagane jest wybranie źródła danych": "Необходимо е да изберете източник на данни",
    "Obciążenie Gościa": "Натоварване на гостите",
    "Numer rezerwacji Avantio": "",
    "Nie udało się pobrać listy wydziałów": "Неуспешно изтегляне на списъка с преподаватели",
    "Pozycja": "Позиция",
    "Strona ukryta": "",
    "wybierz...": "изберете...",
    "Certyfikat został zaktualizowany.": "",
    "Wybrana ikona powinna być kwadratem": "",
    "Wybierz serwer": "Изберете сървър",
    "Zarządzaj zespołami": "",
    "Zwrócony": "Върнато",
    "Wiadomość została ukryta.": "Съобщението беше скрито.",
    "Kolor trasy": "",
    "Potwierdzenie przywrócenia": "Потвърждение на възстановяването",
    "Data nieobecności do": "Дата на отсъствие до",
    "Dowolna data": "Всяка дата",
    "Zmiana hasła": "Промяна на паролата",
    "Pole \"Drugie imię\" jest wymagane.": "Полето „Средно име“ е задължително.",
    "Resetuj filtry": "Нулиране на филтрите",
    "Zaawansowane": "",
    "Nie możesz wpływać na kolejność punktów już oznaczonych jako odwiedzone": "Не можете да повлияете на реда на точките, които вече са отбелязани като посетени",
    "Automatyczny": "",
    "Aktywne kanały komunikacji": "Активни комуникационни канали",
    "Nieruchomość została usunięta.": "Имотът е премахнат.",
    "ID lub typ zadania": "Идентификатор на задачата или тип",
    "Tło przycisku": "",
    "Lista koordynatorów": "",
    "Lekcja wideo została dodana.": "",
    "Nie znaleziono żadnych wyników.": "Няма намерени резултати.",
    "Back Office": "Бек офис",
    "Szkolenie rozpoczyna się": "",
    "Nazwa grupy": "",
    "ŚREDNIA": "СРЕДЕН",
    "Niemiecki": "Немски",
    "Data akceptacji": "",
    "Wymiary": "Размери",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Брой служители, работещи в повече от един регион",
    "Ostatnia aktywność": "Скорошна дейност",
    "Dodaj wszystkie z kategorii": "",
    "Widoczność": "Видимост",
    "Uwzględniaj nieruchomości": "Вземете под внимание недвижимите имоти",
    "Host": "Домакини",
    "Id zdarzenia": "Ид на събитието",
    "Długość": "",
    "Rok": "Година",
    "Dodaj nowy": "",
    "Edycja wynagrodzenia": "Редактиране на заплата",
    "słowa": "думи",
    "Wersje": "Версии",
    "Dodanie": "Доставка",
    "Zablokowany": "Блокиран",
    "Więcej...": "Още...",
    "Dodaj zdjęcia do wiadomości": "Добавяне на снимки към съобщението",
    "Ten punkt został już odwiedzony": "Тази точка вече е посетена",
    "Dodaj premię": "Добавете бонус",
    "Płeć": "",
    "Dodaj link": "",
    "Zespół został dodany.": "Екипът е добавен.",
    "Przejdź do mapy": "Отидете на картата",
    "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "",
    "Opublikowany": "",
    "Data rezerwacji od": "Дата на резервация от",
    "Porównaj z edytowaną wersją": "Сравнете с редактираната версия",
    "Symbol lekcji": "",
    "Numer aktywnej strony": "",
    "Wpis został zaktualizowany.": "Записът е актуализиран.",
    "Co miesiąc": "Всеки месец",
    "Sprawdzenie czy pusty": "Проверете дали е празен",
    "Właściciel został dodany.": "Собственикът е добавен.",
    "Pracownicy": "Служителите",
    "Historia zadania": "История на задачата",
    "Nieobecność od": "Отсъствие от",
    "Kategoria została zaktualizowana.": "Категорията е актуализирана.",
    "Całkowity czas": "Общо време",
    "Przetwarzane": "Обработени",
    "Data zmiany statusu do": "Дата на промяна на статута на",
    "Przejdź do Checklisty": "Отидете в контролния списък",
    "Slajder został zaktualizowany.": "",
    "Kwota rezerwacji": "Сума на резервацията",
    "Wybierz język": "",
    "Zacznij pisać aby wyszukać miasto...": "Започнете да пишете, за да търсите град...",
    "Element opublikowany": "",
    "30 minut": "30 минути",
    "Dodanie roli": "Добавяне на роля",
    "Lekcja została zaktualizowana.": "",
    "Wysyłaj tym kanałem": "Изпратете чрез този канал",
    "Zmień kolejność punktów": "Промяна на реда на точките",
    "Prywatne": "Частен",
    "Pojedynczy artykuł (strona opisowa)": "",
    "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
    "Wszystkie obiekty:": "Всички обекти:",
    "Inwentaryzaje": "",
    "Typ slajdu": "",
    "brak danych": "няма данни",
    "Regulaminy": "",
    "Usuń wszystkie tagi": "",
    "Dodanie działu": "Добавяне на отдел",
    "Ustawienia slajdera": "",
    "Zmień nazwę": "Преименуване",
    "Exclusivity": "Изключителност",
    "Resetowanie podejść użytkowników": "",
    "Dodaj nieruchomość": "Добавяне на имот",
    "Domyślna wartość": "Стойност по подразбиране",
    "Powiadomienie o zmianach": "Уведомяване за промени",
    "Nie udało się zaktualizować zlecenia.": "Неуспешно актуализиране на поръчката.",
    "Wyliczenie stawki godzinowej (statystyczna)": "Изчисляване на почасовата ставка (статистическа)",
    "Link do strony": "",
    "Zacznij pisać aby wyszukać zaopatrzenie...": "Започнете да пишете, за да търсите консумативи...",
    "Poprawne": "Правилно",
    "Zapisz trasę": "Запазете маршрута",
    "Rodzaj odpowiedzi": "Вид на отговора",
    "Upload": "Качване",
    "Data dodania kosztu": "Дата на добавяне на разходи",
    "Właściciel": "собственик",
    "Etykiety": "Етикети",
    "Typ rezerwacji": "Вид на резервацията",
    "${ex.data.errors.symbol[0]}": "",
    "Odznacz wszystkie": "Премахнете отметката от всички",
    "Anuluj": "отменете",
    "Treści odpowiedzi są wymagane": "Съдържанието на отговора е задължително",
    "Rezerwacja właścicielska": "Резервация на собственост",
    "Publikacja została zmieniona.": "",
    "Wczutuję...": "",
    "Tłumacz checklistę": "Превод на контролния списък",
    "Koszt dla nieruchomości roboczej": "Разходи за работен имот",
    "Załączone zdjęcia": "Приложени снимки",
    "Źródło URL": "",
    "Wstęp": "",
    "Dane wydziału zostały zaktualizowane.": "Данните от факултета са актуализирани.",
    "Kopiuj numer rezerwacji": "Копиране на номера на резервацията",
    "Wymagaj znaków specjalnych w hasłach": "Изисквайте специални символи в паролите",
    "Wybór kategorii": "",
    "Aktywni": "Активен",
    "Wpis został dodany.": "Записът е добавен.",
    "zacznij pisać aby wyszukać slajder...": "",
    "Szczegóły": "Детайли",
    "Brak historii zmian": "",
    "po %0 nieudanych próbach logowania": "след неуспешни опити за влизане %0",
    "Nazwa źródła danych": "Име на източника на данни",
    "Nazwa ulicy (StreetName)": "Име на улицата (Име на улицата)",
    "Odpowiedź 2": "Отговор 2",
    "Administracja - Zespoły": "Администрация - Екипи",
    "Użytkownik posiada pełne uprawnienia": "Потребителят има пълни права",
    "Liczba inspektorów": "Брой инспектори",
    "Pole zawiera": "Полето съдържа",
    "Odpowiedź": "",
    "Rezerwacja właściciela": "Резервация на собственика",
    "Niedostępne": "Недостъпно",
    "Zapytanie": "Запитване",
    "Odrzucone": "Отказано",
    "Wygasłe": "Изтекло",
    "Anulowane": "Анулирано",
    "Zamknięte": "Затворено",
    "Zarezerwowane": "Резервирано",
    "Potwierdzone": "Потвърдено",
    "Katalog został utworzony.": "Директорията е създадена.",
    "W tym katalogu nie ma jeszcze żadnych stron.": "",
    "Dodanie dzielnicy": "Добавяне на област",
    "Data zdarzenia": "Дата на събитието",
    "Edytuj stawkę za godzinę": "Редактиране на скорост на час",
    "Dostęp do": "",
    "Data publikacji": "",
    "Profil użytkownika": "Потребителски профил",
    "ID nazwa obiektu": "Име на обект за идентификация",
    "Stała wartość": "Фиксирана стойност",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Грешка 404. Исканият ресурс не е намерен.",
    "Edycja ścieżki szkoleniowej": "",
    "Czy opublikowany": "",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Запазете маршрута и го изпратите на водача?",
    "Rola została dodana.": "Ролята е добавена.",
    "Tryb monitorowania aktywności wyłączony.": "",
    "Następna inwentaryzacja": "Следващ инвентар",
    "Godzina wykonania": "Време на изпълнение",
    "Pokaż szczegóły": "Показване на детайли",
    "Wszyscy": "всички",
    "Urlop został zaktualizowany.": "Празникът е актуализиран.",
    "Aktualności ze strony": "",
    "Miasto zostało dodane.": "Градът е добавен.",
    "(AirBnb) Wysłano żądanie do portalu": "(AirBnB) Запитване е изпратено до портала",
    "Widoczny obszar": "",
    "ZMIANA": "ПРОМЯНА",
    "REGON": "РЕГОН",
    "Kanały włączone w ustawieniach aplikacji": "Канали, активирани в настройките на приложението",
    "Edycja użytkownika": "Редактиране на потребителя",
    "Wyłącz powiadomienia": "Деактивиране на известия",
    "Zresetuj hasło": "Нулиране на паролата",
    "Wstecz": "Назад",
    "Załącz zdjęcia": "",
    "Edycja regulaminu": "",
    "Nieruchomości (Data przyjazdu)": "Недвижими имоти (дата на пристигане)",
    "Nazwa bloku": "",
    "Wartość musi być liczbą dodatnią": "Стойността трябва да бъде положително число",
    "Fiirma została zaktualizowana.": "Fiirma е актуализирана.",
    "Przypisane miasta do regionu:": "Присвоени градове на региона:",
    "Imie i nazwisko właściciela": "Име и фамилия на собственика",
    "Nazwa działu": "Наименование на отдела",
    "Hasło do sieci Wi-Fi": "Wi-Fi парола",
    "Etykieta": "Етикет",
    "Udostępnij": "Сподели",
    "Cancelled by owner": "Отменено от собственика",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "",
    "Wyświetl również zarchiwizowane formularze": "Вижте също архивирани формуляри",
    "jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji": "ако е необходим контакт, моля посочете с кого и кога и данни за контакт, ако са различни от тези на резервацията",
    "Potwierdzenie usunięcia. Usunięcie tematu spowoduje usunięcie przypisanych do niego lekcji": "",
    "Kod HTML": "",
    "Uprawnienia użytkownika": "",
    "Wybrane regulaminy:": "",
    "Kategoria materiału": "",
    "Grupa": "група",
    "Under request": "Под реквизиция",
    "Dodanie ankiety": "",
    "Liczba pracowników": "Брой служители",
    "Dodaj zlecenie": "Добавяне на поръчка",
    "Wpisz komentarz...": "Напишете коментар...",
    "Komunikat walidacji": "Съобщение за валидиране",
    "Publikuj na stronie": "",
    "Wpisz nazwę regionu...": "Въведете името на региона...",
    "Błędne": "Грешен",
    "Zasięg": "Покритие",
    "Język:": "Език:",
    "Publikacja priorytetowa": "",
    "Ukryj przycisk": "Бутон за скриване",
    "Pole \"Tytuł\" jest wymagane.": "Полето „Заглавие“ е задължително.",
    "Pralnia": "Пране",
    "Zdjęcie": "",
    "Test został dodany.": "",
    "Ostatnia wiadomość - użytkownik": "Последно съобщение - потребител",
    "Elementy inwentaryzacji": "Инвентарни артикули",
    "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "",
    "Przypisane miasta": "Присвоени градове",
    "Ponów zadanie": "",
    "UWAGA! Nieruchomość jest już przypisana od innego właściciela": "ВНИМАНИЕ! Имотът вече е възложен от друг собственик",
    "Wszystkie niezapisane zmiany zostaną utracone.": "Всички незапазени промени ще бъдат загубени.",
    "Usuń zaznaczone": "",
    "Szablon nr 3": "",
    "Aranżacja utowrzona przez": "",
    "Osoba zastępująca": "Заместител",
    "Kanały komunikacji": "Комуникационни канали",
    "Nazwa nieruchomości": "Име на имота",
    "Kroki": "Стъпки",
    "Dodaj lekcję SCORM": "",
    "Strona została usunięta.": "Страницата е изтрита.",
    "Osoba przypisana do zadania": "Лице, възложено на задачата",
    "Pokaż czat": "Показване на чата",
    "Dostępy": "",
    "Powiększ": "Увеличете",
    "Filtr globalny": "Глобален филтър",
    "Uzupełnij dane dotyczące szkolenia": "",
    "Brak kluczy": "Без ключове",
    "Polski": "Полски",
    "Cztery kolumny": "Четири колони",
    "Avantio ID nieruchomości": "Авантио ИД на имот",
    "Wybierz kierowce": "Изберете шофьор",
    "Szkolenie": "",
    "Przeciągnij do innej sekcji": "",
    "Brak zadań": "Без задачи",
    "Edycja poradnika": "",
    "Zlecenie zostało usunięte.": "Поръчката е изтрита.",
    "Opis zadania": "Описание на задачата",
    "Pliki do wysłania: %0": "Файлове за качване:% 0",
    "Nie podano nazwy poprzedniego elementu.": "",
    "Ta nieruchomość już posiada takie wyposażenie.": "Този имот вече разполага с такова оборудване.",
    "OwnerService": "Собственик-обслужване",
    "Przyznaj dostęp": "Предоставяне на достъп",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "",
    "Ładuję zgłoszenia...": "Зареждане на подадени документи...",
    "Wstaw kontrolkę": "Вмъкване на контрол",
    "Top kosztów wg miast": "Най-високи разходи по град",
    "Nieprawidłowy adres email": "Невалиден имейл",
    "Potwierdź wyczyszczenie logów": "",
    "Brak przypisanych użytkowników.": "Няма назначени потребители.",
    "Nie znaleziono szczegółów zmiany": "Не са намерени подробности за промяната",
    "Wybierz pliki do dodania": "",
    "Witryna domyślna": "",
    "Ścieżka szkoleniowa": "",
    "Generuj PDF": "Генериране на PDF",
    "Dodanie etykiety": "",
    "Brudne": "мръсен",
    "Nr nieruchomości Guesty": "Имот №. Гести",
    "Ta czynność została wykonana przez kogoś innego. Odśwież aplikację.": "Това действие е извършено от някой друг. Освежете приложението.",
    "Poprzedni miesiąc": "Предишен месец",
    "Nieaktywna": "Неактивен",
    "Strona": "Страница",
    "Rejestracja konta": "",
    "Nie udało się pobrać listy bloków": "",
    "Nowa data": "Нова дата",
    "Typ plików": "",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "Поставете две колони 2/3 и 1/3",
    "Edycja etykiety": "",
    "Publikuj certyfikat": "",
    "Kategoria linku": "",
    "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
    "Nazwa płyty": "",
    "Obojętny": "Безразличен",
    "Twoje hasło wygasło. Zmień je na nowe.": "Вашата парола е изтекла. Променете ги на нови.",
    "Liczba dni co ile wysyłane jest powiadomienie": "",
    "Nazwa slajdera": "",
    "Token": "Токени",
    "Ukryj przypisane zadania": "Скриване на зададени задачи",
    "Baza danych tego klienta jest nieaktualna. Uruchom aktualizację za pomocą przycisku na dole formularza.": "Базата данни на този клиент е остаряла. Стартирайте актуализацията с помощта на бутона в долната част на формуляра.",
    "Typ szablonu": "Тип шаблон",
    "Dodaj element": "Добавяне на елемент",
    "Edycja witryny": "",
    "${StatusName(StatusEnum[this.form.bookingType])}": "$ {Име на състоянието (Наименование на състоянието [this.form.BookingType])}",
    "Bardzo źle": "Много лошо",
    "Przywrócić użytkownika i jego wiadomości?": "Възстановяване на потребителя и неговите съобщения?",
    "Kolor tła": "",
    "Administracja": "Администрация",
    "Status regulaminu został zmieniony.": "",
    "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "",
    "Szef regionu": "Ръководител на региона",
    "Zadanie znajduje się na trasach:": "",
    "Ilość": "количество",
    "Średnio": "Среден",
    "Logowanie zakończyło się niepowodzeniem.": "Влизането е неуспешно.",
    "Opisy": "Описания",
    "Wybierz zaznaczone": "Изберете избрания",
    "Stałe/miesięczne": "Фиксирано/месечно",
    "Wydział / Rola": "Факултет/Роля",
    "Trasa została zapauzowana": "Маршрутът е спрян",
    "Wybierz typy powiadomień, które chcesz wyłączyć:": "Изберете типовете известия, които искате да деактивирате:",
    "Wysłano kolejne powiadomienie": "",
    "Wybierz punkt": "Изберете точка",
    "Regiony": "Региони",
    "Użytkownik został dodany do zespołu.": "Потребителят е добавен към екипа.",
    "Źródło danych zostało zaktualizowane.": "Източникът на данни е актуализиран.",
    "Przesuń na dół": "Преместете се на дъното",
    "Pliki zostały usunięte": "",
    "Laptop 15\"": "",
    "Zobacz sesję użytkownika": "Преглед на потребителската сесия",
    "Kwota": "Количество",
    "Konto publiczne": "",
    "Wpis przeczytany": "",
    "Słowa kluczowe": "",
    "Szef Regionu": "Ръководител на региона",
    "Dane kosztu": "",
    "Wartość musi być liczbą całkowitą": "Стойността трябва да бъде цяло число",
    "Początek długości geograficznej użytkownika": "Началото на дължината на потребителя",
    "Akcja": "Действие",
    "Ukryj już zaplanowane punkty": "Скриване на вече планирани точки",
    "Właściciel aktywny": "Активен собственик",
    "Zmień daty publikacji": "",
    "Wybierz certyfikat": "",
    "Zawsze": "винаги",
    "Typ dodanego kosztu": "Вид добавени разходи",
    "Dodaj sekcję": "",
    "Nie zdefiniowano żadnych sekcji.": "",
    "Powiązania z dzielnicą": "Връзки с района",
    "Wpisz nazwę dzielnicy...": "Въведете името на района...",
    "Sortuj po": "",
    "Informacje": "Информация",
    "Blok został usunięty.": "",
    "Do sprawdzenia - przeniesione": "Трябва да се провери - преместен",
    "Potwierdzenie usunięcia": "Потвърждение за изтриване",
    "Wybór listy stron": "",
    "zacznij pisać aby wyszukać zespół...": "",
    "Miasta": "Градове",
    "Lista nieruchomości": "Списък на имотите",
    "Nie podano odpowiedzi dla ostatniego elementu.": "",
    "Mężczyzna": "",
    "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Полето „% 0“ не съдържа валиден URL адрес.",
    "zaznacz wszystko": "Проверете всички",
    "Metadane": "",
    "Tag został usunięty.": "Етикетът е премахнат.",
    "Adres 2": "Адрес 2",
    "Wartość domyślna": "Стойност по подразбиране",
    "Brak zadania": "",
    "Dodanie certyfikatu": "",
    "Dokument": "",
    "Nazwa linku": "",
    "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
    "Nazwa nieruchomości roboczej": "Наименование на работния имот",
    "Generuję plik...": "Генериране на файл...",
    "Opcje": "Опции",
    "Imie i nazwisko osoby, która dodawała koszty": "Име и фамилия на лицето, което е добавило разходите",
    "Pozostało %0 znaków.": "Остана% 0 символа.",
    "Nie udało się zmienić statusu zadania": "Неуспешна промяна на състоянието на задачата",
    "Kwota brutto": "",
    "Treść certyfikatu": "",
    "Nazwa katalogu": "Име на каталога",
    "Laptop 15,6\"": "",
    "Dokument nie ma ustawionej daty publikacji.": "",
    "Wstaw dwie równe kolumny": "Поставете две равни колони",
    "Zastępstwo": "Заместване",
    "Ma dzisiaj": "Той има днес",
    "Grafik pracowniczy": "Планиратор на служителите",
    "Adres": "Адрес",
    "Narzędzia": "Инструменти",
    "Wersja": "",
    "Strona dostępna dla wszystkich": "",
    "Pionowo": "",
    "Dziś": "Днес",
    "Edycja szkolenia": "",
    "Odejmowanie": "Изваждане",
    "Kolor": "цвят",
    "Symbol testu": "",
    "Brak daty": "Няма дата",
    "Obciążenie Magazyn": "Складово натоварване",
    "Kwota za zadania": "Сума за задачи",
    "Odpowiedź 4": "Отговор 4",
    "Adres e-mail": "Имейл адрес",
    "Zapisz i wróć": "Запазване и връщане",
    "Wiadomość": "Съобщение",
    "Lipiec": "юли",
    "Typ nieruchomości": "Вид на имота",
    "Koordynator HK": "Координатор HK",
    "Obciążenie Właściciela": "Тежестта на собственика",
    "Host główny": "Основен домакин",
    "Dodaj kafelek": "",
    "Dodanie zastępstwa": "Добавяне на заместител",
    "Data usunięcia": "Дата на изтриване",
    "Test został zaktualizowany.": "",
    "Edytuj katalog": "",
    "Zapomniałeś hasła?": "Забравихте паролата си?",
    "Zadanie zostało ukończone przez kogoś z Twojego zespołu.": "",
    "Niski": "ниско",
    "Domyślny czas rezerwacji": "Време за резервация по подразбиране",
    "Stwórz czat z zadania": "Създаване на чат от задача",
    "Zakończone": "Завършен",
    "Ścieżka": "",
    "Not Available": "Не е наличен",
    "Firma": "Фирма",
    "Wybór koloru jest wymagany": "",
    "Typ konta": "",
    "Dodanie szablonu": "",
    "Dodaj szablon": "Добавяне на шаблон",
    "Docelowa strona": "",
    "Dodanie serwera": "Добавяне на сървър",
    "Włączenie protokołu SSL dla tej witryny": "",
    "Test ukryty": "",
    "Wyszukaj użytkownika": "",
    "Zespoły": "Екипи",
    "Miesiąc": "месец",
    "Załączniki": "Приложения",
    "Zgłoszenie serwisowe": "",
    "Konta prywatne": "",
    "Inspekcje": "Инспекции",
    "Brak wersji": "Няма версия",
    "Anuluj i wyjdź z kreatora": "Отмяна и излез от съветника",
    "Wyszukuję...": "Търся...",
    "Marzec": "Март",
    "Filtry globalne": "Глобални филтри",
    "Zadanie zostało dodane.": "Задачата е добавена.",
    "Dodawanie": "Допълнение",
    "Dane dostępowe": "Достъп до данни",
    "Data zakończenia od": "Крайна дата от",
    "Nie możesz edytować tego punktu. Został on już oznaczony jako odwiedzony": "Не можете да редактирате тази точка. Вече е маркиран като посетен",
    "Przenieś do sekcji": "",
    "Adres url": "",
    "Numer rezerwacji": "Номер на резервацията",
    "usunięto dzielnice": "премахнати квартали",
    "edycja": "издание",
    "Wyszukaj nieruchomość...": "Търсене на имот...",
    "reset": "нулиране",
    "Nie udało się pobrać listy działów": "Неуспешно изтегляне на списъка с отдели",
    "Nie wybrano obrazu.": "",
    "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Изберете типа уведомление, за да видите наличните клавиши.",
    "Wybierz inspektora": "Изберете инспектор",
    "Notatka/Komentarz": "",
    "Nie podano wymaganej ilości znaków: %0.": "Необходимият брой символи не е посочен:% 0.",
    "Dodaj urlop": "Добавете ваканция",
    "Wynagrodzenia HK": "HK Заплати",
    "Gotowe": "готово",
    "Wykonane zadania": "Изпълнени задачи",
    "Przywrócić wiadomość?": "Възстановяване на съобщението?",
    "5 minut": "5 минути",
    "Get it on Google Play": "Вземете го в Google Play",
    "Nazwa klienta": "Име на клиента",
    "Zlecenie zostało zaktualizowane.": "Поръчката е актуализирана.",
    "SUMA": "СУМА",
    "Edytuj obraz": "Редактиране на изображението",
    "Nazwa tagu": "Име на етикета",
    "Typ powiadomienia": "Тип уведомление",
    "Nie podano nazwy tytułu.": "",
    "Komentarz został zapisany": "",
    "Właściwości": "",
    "Usuń datę": "Изтриване на дата",
    "Wystąpił problem z dostępem do kamery": "Имаше проблем с достъпа до камерата",
    "Ulica": "Улица",
    "Ukryj czat": "Скриване на чата",
    "Minimalna długość hasła": "Минимална дължина на паролата",
    "Nie masz uprawnień do panelu administracyjnego.": "Нямате разрешения за администраторския панел.",
    "Ilość gości": "Брой гости",
    "Zawartość": "",
    "checklista": "контролен списък",
    "Nie wybrano żadnej strony.": "",
    "Styczeń": "януари",
    "Progress Gotowości": "",
    "Szablon nr 2": "",
    "Facebook Admins": "",
    "Nie udało się ustawić miasta.": "Не успя да се създаде град.",
    "Edycja linku": "",
    "Pracownicy z brakującymi ustawieniami wynagrodzenia": "Служители с липсващи настройки на заплатите",
    "Dodaj inwentaryzacje": "Добавяне на запаси",
    "Wygeneruj pilik": "",
    "Pobyt: ": "Останете: ",
    "Checklista:": "Контролен списък:",
    "Strona lekcji opublikowana": "",
    "Zapisz komentarz": "",
    "Usuń materiał z testu": "",
    "Migracje": "Миграции",
    "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "",
    "Nie można przenosić plików między sekcjami o różnych typach": "",
    "Jest to lista obiektów które nie mają jeszcze przypisanego właściciela.": "Това е списък с обекти, които все още нямат назначен собственик.",
    "Folder został usunięty.": "",
    "Symbol strony szkolenia": "",
    "Czy na pewno chcesz usunąć tę sekcję?": "",
    "Łóżeczko": "Детско креватче",
    "Brak działu nadrzędnego": "Няма родителски отдел",
    "Adres firmy": "Адрес на компанията",
    "Kwota kosztów": "Размер на разходите",
    "Nazwa źródła": "Име на източника",
    "Katalog": "каталог",
    "Dane nieruchomości": "Данни за собствеността",
    "$% - znacznik zamykający tag": "",
    "Wstaw trzy kolumny 1/3": "Поставете три колони 1/3",
    "Brak danych.": "",
    "Rola": "Роля",
    "CustomerService": "Обслужване на клиенти",
    "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "Този канал има възможност за изпращане на форматиран текст.",
    "BOK": "Обслужване на клиенти",
    "Koszt pracownika": "",
    "Dział": "Отдел",
    "Typy materiałów": "",
    "Bazy danych": "Бази данни",
    "Włączone (Follow)": "",
    "Zapauzowano:": "Пауза:",
    "Wyjazd": "Отпътуване",
    "pl": "",
    "Przełącznik": "Превключвател",
    "Pokaż tytuł formularza": "Показване на заглавието на формата",
    "Wyposażenie": "Оборудване",
    "Neutralne": "Неутрален",
    "Dane kierowcy: ": "Данни за водача: ",
    "Nazwa bazy danych": "Име на база данни",
    "HR": "ЧАС",
    "Kategorie materiałów": "",
    "NIP firmy": "Данъчен идентификационен номер на дружеството",
    "Połącz w pary": "",
    "Lekcja wideo została zaktualizowana.": "",
    "Adres serwera": "Адрес на сървъра",
    "Zadania dzisiaj": "Задачи днес",
    "Ten element nie zawiera menu kontekstowego.": "Този елемент не съдържа контекстно меню.",
    "Zastępstwa": "Замяния",
    "Wzorzec": "Модел",
    "Liczba podejść": "",
    "Edytuj szablon": "Редактирайте шаблон",
    "Usunięte zadanie": "Изтрита задача",
    "Data od": "Дата от",
    "Data ukończenia": "Дата на завършване",
    "Szczegóły zdarzenia": "Подробности за събитието",
    "Zapisz jako": "Запазете като",
    "Wyposażenie zostało zaktualizowane.": "Оборудването е актуализирано.",
    "Edytuj uprawnienia": "Редактиране на разрешенията",
    "Powiadomienie o zbliżającym się zakończeniu szkolenia": "",
    "Pokaż": "Покажи",
    "Data realizacji": "",
    "Jestem w drodze": "На път съм",
    "Poczta": "поща",
    "Numer Guesty": "Номер на гостите",
    "Dostęp przyznany": "Достъпът е предоставен",
    "Wyszukaj": "Търсене",
    "Wybierz regulamin": "",
    "Nazwa nadawcy": "Име на подателя",
    "Filtry": "Филтри",
    "Zakończenie": "",
    "Firma własna": "Собствена компания",
    "Przepracowana liczba godzin w miesiącu": "Брой отработени часове на месец",
    "Zadanie na dziś": "Задача за днес",
    "W momencie tworzenia kosztu": "По време на създаването на разходи",
    "Edytuj temat": "",
    "Uczestnicy rozmowy:": "Участници в разговора:",
    "linie": "линии",
    "Ilość punktów: ": "Брой точки: ",
    "Przypisane tagi:": "Присвоени маркери:",
    "Otwórz w nowym oknie": "Отваряне в нов прозорец",
    "Dostępne czaty:": "Налични чатове:",
    "Usługi": "Услуги",
    "Oczekuje na wysłanie": "В очакване на изпращане",
    "Nazwa trasy": "Име на маршрута",
    "Informacje o czacie": "Информация за чата",
    "Multimedia": "Мултимедия",
    "Dopuść brak odpowiedzi": "Не позволявайте отговор",
    "Dodaj treść": "",
    "Dane Adresowe": "Адресни данни",
    "Wynagrodzenia Pracowników": "Заплати на служителите",
    "Nazwa pokoju": "Име на стаята",
    "Niedziela": "Неделя",
    "Wymagane jest ustawienie minimalnej długości hasła": "Необходимо е да зададете минимална дължина на паролата",
    "Zgłoszenia w apartamencie": "Подаване в апартамента",
    "To miasto jest już przypisane do użytkownika.": "Този град вече е присвоен на потребителя.",
    "Dodaj źródło": "Добавяне на източник",
    "Skrócony opis": "",
    "Wybierz sekcję, do której chcesz dodać pliki": "",
    "Data zakończenia/wykonania": "",
    "Zapisz nową kolejność punktów": "Запазване на нов ред на точки",
    "Strona została dodana.": "",
    "pokaż więcej...": "Покажи повече...",
    "Nie znaleziono nieruchomości": "",
    "Źródła danych": "Източници на данни",
    "Wyświetl popup z kontynuacją lekcji": "",
    "Przypisane do:": "Присвоен на:",
    "Dodaj rolę": "Добавяне на роля",
    "Status linku został zmieniony.": "",
    "Dodaj opłaconą kwotę": "Добавете сумата, която сте платили",
    "Zapisz filtr": "Запазване на филтъра",
    "Utworzył": "Създаден",
    "Suma wynagrodzeń koordynatorów": "Общо заплати на координаторите",
    "Harmonogram został zmieniony": "Графикът е променен",
    "Typ obiektu": "Тип обект",
    "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
    "Wyczyść sesję": "Изчистване на сесията",
    "Minuty": "Минути",
    "Nie udało się pobrać ról!": "Неуспешно изтегляне на роли!",
    "Miasto zostało zaktualizowane.": "Градът е актуализиран.",
    "Bez dzielnicy": "Без област",
    "Aktywna nieruchomość": "Активни недвижими имоти",
    "Wewnętrznie": "Вътрешно",
    "Potwierdzenie publikacji": "",
    "Tytuł formularza jest wymagany": "Заглавието на формуляра е задължително",
    "Powiadomienia zostały skonfigurowane.": "Известията са конфигурирани.",
    "Ustawienia dostępności": "",
    "Pasek": "Колан",
    "E-learning": "",
    "Szablon został zaktualizowany.": "Шаблонът е актуализиран.",
    "Liczba dziesiętna": "Десетичен",
    "Filtr został usunięty": "Филтърът е премахнат",
    "Usuń tag": "",
    "Dołącz stronę do pliku sitemap.xml": "",
    "Zmiana motywu": "Промяна на темата",
    "Rola przypisana do tego wydziału jest nieaktywna": "Ролята, възложена на този отдел, е неактивна",
    "Numer konta bankowego": "Номер на банкова сметка",
    "Logger": "",
    "Pokaż zadania bez przypisanej osoby": "Показване на задачи без възложено лице",
    "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
    "Gość": "гост",
    "Ten miesiąc": "Този месец",
    "Koordynator Główny": "Главен координатор",
    "Firmy": "Фирми",
    "Nieudane": "Неуспешен",
    "Data utworzenia wersji": "Дата на създаване на версията",
    "Treść została dodana.": "",
    "Raczej się nie zgadzam": "Предпочитам да не съм съгласен",
    "Nie udało się pobrać szczegółów zmiany": "Неуспешно изтегляне на подробности за промяната",
    "Dodaj koszt": "Добавяне на цена",
    "Wykonane": "Произведено",
    "Dane dostępu": "Достъп до данни",
    "Członkowie zespołu": "Членове на екипа",
    "Pre-booking": "Предварителна резервация",
    "Nazwa zestawu": "",
    "Inwentaryzacje": "Запаси",
    "Wszystkie zadania": "Всички задачи",
    "Szablon graficzny": "",
    "Opis witryny": "",
    "Data:": "дата:",
    "Id": "Идентификация",
    "Utwórz czat": "Създайте чат",
    "Stawka PLN brutto za godzinę": "Брутна ставка PLN на час",
    "Rozmiar": "размер",
    "Dodaj do regionu": "Добави към региона",
    "Data zalogowania": "Дата на влизане",
    "Wysłano powiadomienie.": "Изпратено е уведомление.",
    "Trasy archiwalne": "Архивни маршрути",
    "Musisz wybrać obiekt na mapie": "Трябва да изберете обект на картата",
    "Pokaż filtry": "Показване на филтри",
    "Włączenie obsługi cacheu dla witryny": "",
    "do": "до",
    "Komentarz Konserwatora": "Коментар на консерватора",
    "Imię właściciela": "Име на собственика",
    "Kategoria slajdu": "",
    "Obiekty": "Обекти",
    "Nie udało się wgrać pliku": "Неуспешно качване на файл",
    "W drodze": "На пътя",
    "Zaawansowane polecenia": "",
    "Wyszukiwany ciąg znaków": "Низът за търсене",
    "Udało się dodać nieruchomość do trasy": "Успешно добавено свойство към маршрута",
    "Edycja wynagrodzenia za posprzątane obiekty dla:": "Редактиране на възнаграждението за почистени съоръжения за:",
    "Nieprawidłowy adres URL": "Невалиден URL адрес",
    "Wybierz blok": "",
    "Obrazek wyróżniający": "",
    "Niestandardowy błąd": "Персонализиран бъг",
    "Koszt został usunięty": "",
    "Slajder został dodany.": "",
    "Synchronizacja rezerwacji": "Синхронизиране на резервациите",
    "Manager Firmy Zewnętrznej": "Външен мениджър на компанията",
    "Logowanie": "",
    "Brak kategorii": "",
    "Faktyczny czas pracy": "Действително работно време",
    "Ustawienia konta": "",
    "Domyślny tytuł aktywnej strony": "",
    "Ustawienia zostały zaktualizowane.": "Настройките са актуализирани.",
    "Nie udało się pobrać zadań": "Неуспешно изтегляне на задачи",
    "Aktywna": "Активен",
    "Wprowadzona wartość nie jest poprawna": "Въведената от вас стойност не е правилна",
    "Wybór języka": "Избор на език",
    "Zmień nazwę katalogu": "Преименуване на директорията",
    "Problemy": "Проблеми",
    "Edycja kategorii": "",
    "Dzielnica została dodana.": "Областта е добавена.",
    "Brak numeru": "Няма номер",
    "Kategoria została usunięta.": "Категорията е премахната.",
    "Wybierz stronę": "",
    "Zadanie zostało włączone": "Задачата е активирана",
    "Ankieta": "проучване",
    "Dodaj temat/link": "",
    "Koszty wg regionów": "Разходи по региони",
    "Dane właściciela": "Данни за собственика",
    "Brak typu zadania": "",
    "zacznij pisać aby wyszukać regulamin...": "",
    "Wprowadzona wartość jest za wysoka": "Стойността, която сте въвели, е твърде висока",
    "Dodatkowe wynagrodzenie - kwota": "Допълнителна заплата - сума",
    "REGON firmy": "REGON на дружеството",
    "VAT (wyliczany automatycznie)": "",
    "Miniaturka wideo": "",
    "Ukończone przez użytkownika": "Попълнено от потребителя",
    "Logo": "Логотип",
    "Brak strony nadrzędnej": "",
    "Tagi": "Тагове",
    "Archiwalny": "Архивиране",
    "Pokaż tytuł strony": "Показване на заглавието на страницата",
    "Administracja - Kraje": "Администрация - Държави",
    "Pomoc": "Помощ",
    "Dane podstawowe": "Основни данни",
    "Czas (minuty)": "",
    "Sformatowany rzeczywisty czas pracy": "Форматирано действително работно време",
    "Przesyłanie zdjęcia nie powiodło się": "Неуспешно качване на снимка",
    "dni temu": "преди дни",
    "Nie możesz rozpocząć obsługi tego zadania": "",
    "Zarządzaj": "Управление",
    "Wideo zewnętrzne (URL)": "",
    "Dane zadania": "Данни за задачите",
    "Szkolenie zostało zaktualizowane.": "",
    "Filmy": "",
    "Pytania i odpowiedzi": "",
    "Aktywny": "Активен",
    "Liczba szkoleń": "",
    "Dostęp do": "",
    "Dodanie wpisu": "",
    "Zacznik pisać Form lub Entry aby uruchomić podpowiadanie.": "Започнете да въвеждате формуляр или запис, за да стартирате подканата.",
    "Kalendarz nieruchomości": "",
    "Dodanie Notatki": "Добавяне на бележка",
    "Bezpieczeństwo": "Сигурност",
    "Dwie kolumny": "Две колони",
    "Administracja - Miasta": "Администрация - Градове",
    "Stawka mieszana została zaktualizowana.": "Смесената ставка е актуализирана.",
    "Zacznij pisać aby wyszukać osobę...": "Започнете да пишете, за да търсите човек...",
    "Szczegóły rezerwacji": "Подробности за резервацията",
    "Link do czatu": "Връзка за чат",
    "Kwota kosztu do": "Размерът на разходите до",
    "Obrazek": "",
    "Podaj swój adres email": "Моля, въведете вашия имейл",
    "Edytuj Notatkę": "Редактиране на бележката",
    "Nieruchomość zagrożona wypowiedzeniem": "Имоти, изложени на риск от прекратяване",
    "Nie udało się pobrać danych o rolach zalogowanego użytkownika": "Неуспешно извличане на ролеви данни за влязъл потребител",
    "Tryb monitorowania aktywności wyłączony.": "",
    "Stawka za godzinę brutto": "Стойност на час бруто",
    "To zadanie nie posiada jeszcze przypisanych użytkowników.": "",
    "Regulamin wymagany": "",
    "Uwzględnij miasto": "Включете град",
    "Dodaj dane wydziału": "Добавяне на данни от факултета",
    "Czy na pewno chcesz ukryć wiadomość?": "Сигурен ли си, че искаш да скриеш съобщението?",
    "Układ": "Оформление",
    "Serwer plików": "Файлов сървър",
    "Kwota opłacona": "Платена сума",
    "Koniec szerokości geograficznej użytkownika": "Крайна ширина на потребителя",
    "Zadania": "Задачи",
    "ID obiektu": "ИД на обекта",
    "W tym katalogu nie ma jeszcze żadnych stron.": "",
    "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "",
    "Serwer został zaktualizowany.": "Сървърът е актуализиран.",
    "Srednie wynagrodzenie pracowników": "Средна заплата на служителите",
    "Zmiana rozmiaru obrazu": "Преоразмеряване на изображение",
    "źródło danych zostało dodane.": "Източникът на данни е добавен.",
    "Zestaw został dodany.": "",
    "Edytuj blok": "",
    "Przypisane dzielnice:": "Назначени райони:",
    "Nazwisko właściciela": "Име на собственика",
    "Język": "Език",
    "Nazwa sekcji": "",
    "Stawka domyślna": "Стойност по подразбиране",
    "Pokaż więcej": "Покажи повече",
    "Odpowiedź 5": "Отговор 5",
    "Witryna / Wersja językowa": "",
    "Weekend": "уикенд",
    "Uwzględnij zadania z miesiąca:": "Включете задачите на месеца:",
    "Zamknięte przez": "Затворено от",
    "Przypisane do": "Присвоен на",
    "Historia logowania": "История на влизането",
    "Wstaw z prawej strony": "Вмъкнете отдясно",
    "Wyłączone (NoIndex)": "",
    "Artykuły": "",
    "Data wykonania do": "Дата на изпълнение до",
    "Zadanie zostało wznowione.": "Задачата е възобновена.",
    "Witryna aktywna": "",
    "Nie udało się pobrać listy serwerów baz danych": "Неуспешно изтегляне на списъка със сървъри на база данни",
    "Data nieobecności od": "Дата на отсъствие от",
    "Ten region nie posiada jeszcze przypisanych miast.": "Този регион все още няма определени градове.",
    "Masz nową wiadomość!": "Имате ново съобщение!",
    "Wpisz nazwę trasy": "Въведете името на маршрута",
    "Przeglądnij logi": "",
    "Nieudane próby logowania": "Неуспешни опити за влизане",
    "Na pewno usunąć wybrane elementy?": "Сигурни ли сте, че ще изтриете избраните елементи?",
    "dzisiaj": "днес",
    "Wróć do strony logowania": "",
    "Telefon": "Тел",
    "Nazwa aranżacji": "",
    "Zadanie na nieruchomościach roboczych": "Задача за работни свойства",
    "Biblioteka": "",
    "Usuń plik z listy": "Премахване на файл от списъка",
    "Zmień dane kosztu": "Промяна на данните за разходите",
    "Zmień status edytowanej wersji": "Промяна на състоянието на редактираната версия",
    "Filtry systemowe": "Системни филтри",
    "Wynagrodzenia Konserwatorzy": "Заплати на консерваторите",
    "Walidacja certyfikatu SSL": "Валидиране на SSL сертификат",
    "Operacja": "хирургия",
    "Edycja ścieżki szkoleniowej": "",
    "Wybrane miasto": "Избран град",
    "Stawka za typ apartamentu": "Цена за тип апартамент",
    "Mnożenie": "Умножение",
    "Uwzględniaj Miasta": "Включете градове",
    "Edycja zastępstwa": "Редактиране на замяна",
    "Konfiguruj stronę": "",
    "Zaczyna sie od": "Започва с",
    "Nieobecny do": "Отсъства на",
    "Dodaj zaopatrzenie": "Добавяне на провизии",
    "Email został wysłany.": "Имейлът е изпратен.",
    "Co 20 minut": "На всеки 20 минути",
    "km": "км",
    "Ustaw w kolejności": "",
    "Użytkownik został przypisany do ścieżki szkoleniowej.": "",
    "Oczekujące": "В очакване",
    "Confirmed": "Потвърдено",
    "Godzina:": "Време:",
    "Lekcja SCORM ukryta": "",
    "Adres strony": "",
    "Administratorzy": "Администратори",
    "Notatki": "",
    "Edycja stawki godzinowej dla:": "Редактирайте почасовата ставка за:",
    "Dodaj opis...": "Добавете описание...",
    "Wynagrodzenie stałe brutto": "Брутна фиксирана заплата",
    "Przejdź do rezerwacji": "Отидете на резервацията",
    "Parametry, wymagane do wykonania zapytania:": "Параметри, необходими за изпълнение на заявката:",
    "Pliki zostały pobrane": "",
    "gotowe": "готов",
    "Co 5 minut": "На всеки 5 минути",
    "Szkolenie kończy się": "",
    "Link został dodany.": "",
    "Kolejne pozycje z prawej strony": "",
    "Miasta:": "Градове:",
    "Usuń poprzednie wersje certyfikatu": "",
    "Wynagrodzenie za przepracowane godziny": "Възнаграждение за отработени часове",
    "10 minut": "10 минути",
    "Paczka została usunięta.": "",
    "Typ mime": "Тип Миме",
    "Dodaj temat": "",
    "Edytuj urlop": "Редактирайте ваканцията",
    "Szukaj...": "",
    "Ścieżka szkoleniowa została zaktualizowana.": "",
    "Powtórzone": "Повтарящи се",
    "Nie wybrano żadnej kategorii.": "",
    "Azure AD": "Азур АД",
    "Prestiżowe": "Престижен",
    "Błąd": "",
    "3": "",
    "Sformatowany czas całkowity": "Форматирано общо време",
    "Liczba małych prześcieradeł": "Брой малки листове",
    "Wersja językowa": "",
    "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
    "Użytkownik został zablokowany, a jego wiadomość ukryte.": "Потребителят е блокиран и съобщението му е скрито.",
    "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Само сървър за разработчици. Не използвайте в производствен режим. ",
    "Dział aktywny": "Активен отдел",
    "Wynagrodzenia mieszane": "Смесени заплати",
    "Inne": "Други",
    "Zdarzenie": "Събитие",
    "Kategorie linków": "",
    "Co 12 godzin": "На всеки 12 часа",
    "Zadanie zostało wyłączone": "Задачата е деактивирана",
    "Wyślij": "Изпрати",
    "Nie udało się zapisać notatki": "Неуспешно запазване на бележката",
    "Nie możesz modyfikować uprawnień": "Не можете да променяте разрешенията",
    "Bezpieczne połączenie SSL": "Сигурна SSL връзка",
    "Przepracowana ilość godzin": "Брой отработени часове",
    "Dane dostępowe:  ": "Данни за достъп:  ",
    "Końcowy stan licznika": "Крайното състояние на измервателния уред",
    "Ilość wyświetlanych aktualności": "",
    "Wyznacz punkty": "Определете точки",
    "%0 znaków": "% 0 символа",
    "Szkolenie zostało dodane.": "",
    "Domyślna witryna": "",
    "więcej...": "още...",
    "Dodanie testu": "",
    "Imię i nazwisko pracownika": "Име и фамилия на служителя",
    "Wpisz treść wiadomości.": "Въведете тялото на съобщението.",
    "Publikacja zarchiwizowana": "",
    "Plik jest wysyłany": "Файлът се изпраща",
    "Brak wyników": "Няма резултати",
    "Nazwa sieci Wi-Fi": "Име на Wi-Fi мрежа",
    "Sekcja została utworzona": "",
    "Trasa została zaktualizowana.": "Маршрутът е актуализиран.",
    "Nazwa checklisty": "Име на контролния списък",
    "Szkolenie nie jest opublikowane": "",
    "Zlecenia magazynowe": "Поръчки за склад",
    "Edytuj tag": "",
    "Dodanie witryny": "",
    "Biuro": "Офис",
    "Ilość wyników do odrzucenia": "Брой резултати, които трябва да бъдат отхвърлени",
    "Paid": "Платени",
    "Zewnętrzny serwis": "",
    "Element grupujący": "",
    "Brak tematu": "",
    "Notatka dla": "Бележка за",
    "Wybrana sekcja nie istnieje": "",
    "Szkolenie zostało usunięte.": "",
    "Scenariusz": "",
    "Numer mieszkania (Door)": "Номер на апартамента (врата)",
    "Czas pomiędzy": "Времето между",
    "Wersja nieopublikowana": "",
    "Opublikuj": "",
    "Wymuszaj zaliczenie elementów ścieżki zgodnie z kolejnością szkoleń na liście": "",
    "Lista wyboru": "",
    "Filtr o podanej nazwie już istnieje.": "",
    "Równość": "Равенство",
    "Podstawowe operacje na datach": "Основни операции на дати",
    "Zakończone przez": "Завършва от",
    "Porównanie": "Сравнение",
    "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "Паролата трябва да съдържа поне един специален знак, например: ~ @ # $% ^ & *",
    "Przypisz do czatu": "",
    "np. pl-PL": "",
    "Standard 1.2": "",
    "Zdjęcie użytkownika": "Снимка на потребителя",
    "Włączone": "Активирано",
    "Wtorek": "Вторник",
    "Upload plików": "Качване на файлове",
    "Status formularza został zmieniony.": "Състоянието на формуляра е променено.",
    "Powrót": "връщане",
    "Szczegóły zadania": "Детайли за задачата",
    "Pracownik niedostępny od": "Служителят е недостъпен от",
    "Strona opublikowana": "",
    "Włączenie generowania pliku sitemap.xml dla całej witryny": "",
    "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "",
    "Dodaj zadanie": "Добавяне на задача",
    "Kategoria została dodana.": "Категорията е добавена.",
    "Rozliczone": "Установено",
    "(nowe wiadomości)": "(нови новини)",
    "Usuń spacje": "Премахване на интервали",
    "Data utworzenia aranżacji": "",
    "Zarządzanie zespołami": "",
    "Trasy dla Kierowców": "Маршрути за шофьори",
    "Nawiguj do kolejnego punktu": "Придвижете се до следващата точка",
    "Testowe powiadomienie wysłane": "Изпратено известие за теста",
    "Średni": "Среден",
    "Katalog został utworzony.": "Директорията е създадена.",
    "Tryb monitorowania aktywności włączony.": "",
    "Zarządzanie witrynami": "",
    "Miejscowość": "Местоположение",
    "Sekcje": "",
    "Źle": "грешно",
    "Dodanie aktualności": "",
    "zacznij pisać aby wyszukać materiał...": "",
    "Nie można usunąć kategorii do ktorej są przypisane elementy.": "",
    "Wytnij": "Изрежете",
    "Skopiowano": "",
    "Pozostałe ustawienia": "",
    "Liczba wyświetlanych slajdów": "",
    "Dashboard szkolenia": "",
    "Ładuję...": "Зареждане...",
    "Włącz chat": "",
    "Nieaktywni": "Неактивен",
    "Stwórz zlecenie z notatki": "Създаване на поръчка от бележка",
    "Nie udało się usunąć szablonu": "Неуспешно изтриване на шаблона",
    "Usuń kurs z ścieżki szkoleń": "",
    " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": "",
    "Źródło rezerwacji": "Източник на резервацията",
    "Zaznacz wszystkie w sekcji": "",
    "Nowe połączenie": "",
    "Właściciele": "Собственици",
    "Wczytuję...": "Зареждане...",
    "Regulamin został dodany.": "",
    "Publikuj do": "",
    "Zobacz trasę": "Вижте маршрута",
    "Wybrane elementy zostały przeniesione.": "Избраните елементи са преместени.",
    "Zamknięte przez użytkownika": "Затворено от потребителя",
    "Zapisz wersję slajdu": "",
    "Kontrolki specjalizowane": "Специализирани контроли",
    "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "",
    "Dodaj paczkę SCORM": "",
    "Dodawanie inwentaryzacji": "Добавяне на инвентар",
    "Wybierz osobę spoza dzielnicy": "Изберете човек извън квартала",
    "Stała wartość": "Фиксирана стойност",
    "Data rejestracji": "Дата на регистрация",
    "Treści pytań są wymagane": "Съдържанието на въпросите е задължително",
    "Planuj automatycznie w dniu zakończenia blokady": "Планирайте автоматично в деня на приключване на блокирането",
    "Data opuszczenia zespołu": "Дата на напускане на отбора",
    "Zamiany zostały zapisane.": "Суаповете са спасени.",
    "Brak przypisanych tagów.": "Няма зададени тагове.",
    "Podano nieprawidłowe dane.": "Предоставени невалидни данни.",
    "Konserwacje": "Консерванти",
    "Dodatkowa kwota wynagrodzenia": "Допълнителен размер на заплатата",
    "Pełny ekran": "",
    "Zacznij pisać aby wyszukać tag nieruchomości...": "Започнете да пишете, за да търсите маркера...",
    "Wstaw stronę": "Вмъкване на страница",
    "Moje konto": "Моят акаунт",
    "co się wydarzyło": "какво се случи",
    "Ilość łóżek jednoosobowe": "Брой единични легла",
    "Wszystkie": "Всички",
    "Opublikowana": "",
    "Zwierzę": "Животното",
    "wybierz długość": "изберете дължината",
    "Nieruchomość została zaktualizowana.": "Имотът е актуализиран.",
    "Dodaj klienta": "Добавяне на клиент",
    "Usunięte zadania": "Изтрити задачи",
    "Owner Booking": "Резервация на собственик",
    "Nazwa paczki SCORM": "",
    "Co 3 miesiące": "На всеки 3 месеца",
    "Nie możesz rozpocząć obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "Не можете да започнете да обработвате тази задача, защото сега изпълнявате друга задача",
    "${item.text}": "$ {артикула.текст}",
    "Wybrane": "Избрани",
    "Rodzaj nieruchomości": "Вид на имота",
    "Co pół roku": "На всеки шест месеца",
    "Nieruchomości robocze": "Работни недвижими имоти",
    "Miasto apartamentu": "Град на апартамента",
    "Podstawowe operacje na liczbach": "Основни операции с числа",
    "W przyszłości": "В бъдеще",
    "Wybrane pliki: {0}": "Избрани файлове: {0}",
    "Zgłoszone problemy": "Докладвани проблеми",
    "odznacz wszystko": "премахнете отметката на всички",
    "Podążanie za linkami": "",
    "Dodaj witrynę": "",
    "Kalendarz": "Календар",
    "Podana nazwa jest zajęta.": "Даденото име е взето.",
    "Wysoki": "висок",
    "Dobrze": "добре",
    "wybierz katalog": "",
    "Materiał": "Материал",
    "Wybrane kategorie": "",
    "zacznij pisać aby wyszukać autora...": "",
    "Statystyki pracownicze": "Статистика на служителите",
    "Sprzątanie": "Почистване",
    "Udało się zaktualizować nieruchomości!": "Успешно обновен имота!",
    "Inwentaryzacja została usunięta.": "Инвентарът е премахнат.",
    "Wynagrodzenia w regionie łącznie z wynagrodzeniami koordynatorów": "Заплати в региона, включително заплатите на координаторите",
    "Zaloguj się": "Влезте",
    "Data informująca o terminie wejścia w życie tego regulaminu.": "",
    "Edytuj dane wydziału": "Редактиране на данни от факулт",
    "Pytanie 3": "Въпрос 3",
    "Lista rozwijana": "Падащ списък",
    "Edycja slajdera": "",
    "Ankiety": "",
    "Dni": "Дни",
    "Potwierdź usunięcie": "Потвърдете изтриването",
    "Przywróć oryginał": "Възстановяване на оригинала",
    "Podziedziałek - Piątek": "Заместител - петък",
    "Godzina wymeldowania": "Време за напускане",
    "Data i czas": "Дата и час",
    "Jednokrotnego wyboru": "",
    "Nie podano opisu.": "",
    "Id rezerwacji": "Номер на резервацията",
    "Zmień widok": "Промяна на изгледа",
    "Dodanie kategorii": "",
    "Suma wynagrodzeń pracowników": "Сумата на заплатите на служителите",
    "Zmień ustawienia": "Промяна на настройките",
    "Powiązany artykuł": "",
    "Wiadomości": "новини",
    "Data modyfikacji do": "Дата на промяна на",
    "Baza danych": "база данни",
    "Główny Konserwator": "Главен консерватор",
    "Ilość sypialni": "Брой спални",
    "Dzielnica została usunięta.": "Областта е премахната.",
    "Publikacja aranżacji została wyłączona.": "",
    "Kod pocztowy": "Пощенски код",
    "Do akceptacji": "Приемливо",
    "Tłumaczę...": "Превеждам...",
    "Rzeczywisty czas pracy": "Действително работно време",
    "Dodaj wpis": "Добавяне на запис",
    "Edytuj wpis": "Редактиране на записа",
    "Zwiń": "Колапс",
    "Data rozpoczęcia": "Начална дата",
    "Dodane przez: ": "Добавено от: ",
    "Szkolenia": "",
    "Wiadomość została przywrócona.": "Съобщението е възстановено.",
    "Właściciel regionu": "Собственикът на региона",
    "Brak szczegółów zmian": "Без подробности за промяна",
    "Dostęp przyznany ręcznie": "",
    "Wpisz tytuł...": "Въведете заглавие...",
    "Uwaga! wraz z miastem": "Внимание! Заедно с града",
    "Usunięto": "Премахнати",
    "Dodanie szkolenia": "",
    "Profil został zaktualizowany.": "Профилът е актуализиран.",
    "Nazwa:": "Име:",
    "Data dodania do": "",
    "Wyszukaj albo dodaj nowy tag": "",
    "Dostępne obiekty:": "Налични съоръжения:",
    "Dostępne moduły": "",
    "Ustawienia zostały zapisane.": "Настройките са запазени.",
    "Attempt of reservation by Credit Card": "Опит за резервация с кредитна карта",
    "Czas uruchomienia": "Време за стартиране",
    "Premiera": "",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "Запазете маршрута и го изпратите на водача?",
    "Zacznij pisać aby wyszukać regionu...": "Започнете да пишете, за да търсите регион...",
    "Avantio ID": "Авантио ИД",
    "Lekcja SCORM została zaktualizowana.": "",
    "Zawierające jeden z wybranych tagów": "",
    "Co 3 godziny": "На всеки 3 часа",
    "Godziny": "Часове",
    "Edytuj stronę": "",
    "Zespół został usunięty.": "Екипът е премахнат.",
    "Indeksowanie strony": "",
    "Wybierz plik": "Изберете файл",
    "Tag został zaktualizowany.": "Етикетът е актуализиран.",
    "Dodanie zespołu": "Добавяне на екип",
    "Przesuń do góry": "Плъзнете нагоре",
    "Koszty": "Разходи",
    "przejdź do komentarzy": "",
    "Wersje dokumentu": "Версии на документа",
    "Kategoria nadrzędna": "",
    "Dodanych plików %0 (limit wynosi %1).": "Добавени файлове% 0 (ограничението е% 1).",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "Не всички избрани елементи са преместени. Нямате необходимите разрешения или, ако преместите директории, целевата директория е поддиректория на изходната директория. Папките и файловете, които не могат да бъдат преместени, все още са в раздела Избрани.",
    "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "",
    "Zakończ zadanie": "Завършете задачата",
    "Indywidualne tokeny": "Индивидуални жетони",
    "Aby dodawać strony należy najpierw stworzyć nowy katalog.": "",
    "Zacznij pisać aby wyszukać firmę...": "Започнете да пишете, за да търсите компания...",
    "Nazwa firmy": "Име на фирмата",
    "Dodanie artykułu": "",
    "Małe znaki": "Малки знаци",
    "Nie można usunąć swojego konta.": "Не можете да изтриете акаунта си.",
    "Czas na slajd": "",
    "Uwzględnij wydziały podrzędne": "Включете подчинени отдели",
    "Kwota pozostała": "Останала сума",
    "Paczka SCORM została dodana.": "",
    "Administracja - Role": "Администрация - Роли",
    "Zadanie na trasie": "",
    "Ustawienia powiadomień zostały zapisane": "Настройките за уведомяване са запазени",
    "Tekst": "Текст",
    "Apple iPhone 6": "",
    "Stan licznika koniec": "Състояние на крайния брояч",
    "Plik został przeniesiony": "",
    "Brak powiązań": "",
    "Dokument %0": "Документ% 0",
    "Opublikowany na stronach": "",
    "Wpisz nazwę miasta...": "Въведете името на града...",
    "Szkolenie zostało skopiowane": "",
    "Data zmiany statusu od": "Дата на промяна на статута от",
    "Lista powiadomień": "Списък на уведомленията",
    "Numer zadania": "",
    "Formularz został dodany.": "Формулярът е добавен.",
    "co 3 miesiące": "на всеки 3 месеца",
    "Brak odpowiedzi": "Няма отговор",
    "Litery": "Писма",
    "Data utworzenia": "Дата на създаване",
    "Koniec dystansu": "Край на разстоянието",
    "Hasło użytkownika serwisowego": "Потребителска парола на услугата",
    "Data utworzenia od": "Дата на създаване от",
    "Ustaw szerokości proporcjonalnie": "Задайте ширини пропорционално",
    "Zacznij pisać aby wyszukać tagi...": "Започнете да пишете, за да търсите тагове...",
    "Pokaż przycisk ``Wyślij``": "Показване на бутона „Изпрати“",
    "Czeklisty": "Контролни списъци",
    "Zadanie": "Задание",
    "Uwzględniaj Dzielnice": "Включете райони",
    "Edycja wpisu": "",
    "Powtóz hasło": "",
    "Dołącz do czatu": "Присъединете се към чата",
    "Dodaj dane dostepowe...": "Добавяне на налични данни...",
    "Edycja miasta": "Редактиране на града",
    "Nie udało się przesłać plików": "",
    "Niestandardowy adres": "",
    "Ilość pracowników": "Брой служители",
    "Pasek postępu": "Лента за напредък",
    "Wyłączone (NoFollow)": "",
    "Uzupełnij brakujące pola.": "",
    "Magazyn": "Склад",
    "Brak nowych wiadomości.": "Няма нови съобщения.",
    "Podano nieprawidłowe dane": "Предоставени невалидни данни",
    "Hasło zostało zmienione.": "",
    "Brak stron": "",
    "Dodane:": "Добавено:",
    "Pobierz Excel": "",
    "Treść została zaktualizowana.": "",
    "Nieobecny od": "Отсъства от",
    "Nazwa": "име",
    "Back Office (BO)": "Бек офис (BO)",
    "Lekcja może zawierać tylko materiały opisowe lub materiały video": "",
    "Wyświetl szczegóły": "Вижте подробности",
    "Podstawowe operacje warunkowe": "Основни условни операции",
    "Nazwa kolumny z opisem": "Име на колоната с описание",
    "Tag": "Етикет",
    "Moduł": "",
    "Ostatnie 5 zadań": "Последните 5 задачи",
    "Pilne": "Спешно",
    "*Koordynator zespołu posiada dostęp do panelu koordynatora": "",
    "Opis źródła": "Описание на източника",
    "Nazwisko klienta": "Име на клиента",
    "Zadanie zostało zapauzowane.": "Задачата е спряна.",
    "Wprowadzona wartość jest za krótka": "Въведената от вас стойност е твърде кратка",
    "Lista użytkowników": "",
    "Pokaż listę dostępnych tras": "Показване на списък с налични маршрути",
    "Wyszukaj tag...": "Търсене на таг...",
    "Nazwa przedmiotu": "Име на артикула",
    "Przypisane:": "Присвоен:",
    "Checklista": "Контролен списък",
    "Zapisz filtry": "Запазване на филтри",
    "Zostałeś zablokowany, dodanie wiadomości jest niemożliwe": "Били сте блокирани, невъзможно е да добавите съобщение",
    "Nie udało się dodać nieruchomość do trasy": "Неуспешно добавяне на свойство към маршрута",
    "Zbliżająca się data zakończenia": "",
    "Załącz plik excel": "Прикачете файл на Excel",
    "Status został zmieniony.": "",
    "Wybierz...": "",
    "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "",
    "Wybierz użytkownika": "Изберете потребител",
    "Podlega ocenie": "",
    "Zaopatrzenie zostało usunięte.": "Доставката е премахната.",
    "Nie udało się pobrać listy typów materiałów": "",
    "Historia zmian kosztu": "",
    "Prefix": "Префикс",
    "Użytkownik został dodany.": "Потребителят е добавен.",
    "Tak, przejdź do mapy": "",
    "Wynagrodzenia Koordynatorzy": "Заплати на координаторите",
    "Data wylogowania": "Дата на излизане",
    "Usunięte przez użytkownika": "Изтрито от потребителя",
    "Adres email nadawcy": "Имейл на подателя",
    "Wartości": "Ценности",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "",
    "Wczytuję...": "Зареждане...",
    "Zrób zdjęcie": "Направете снимка",
    "Zdecydowanie nie": "Определено не",
    "Koniec dystansu": "Край на разстоянието",
    "Zastępuje osobę": "Заменя човек",
    "Zawartość": "",
    "Nazwa bloku": "",
    "Nazwa zadania": "Име на задачата",
    "Domyślna": "",
    "Nazwa źródła danych": "Име на източника на данни",
    "Zastępstwa": "Замяния",
    "Brak zadań": "Без задачи",
    "Stwórz zadanie z tej rezerwacji": "Създайте задача от тази резервация",
    "Rozwiń do": "",
    "Przyznaj dostęp": "Предоставяне на достъп",
    "Dark mode": "Тъмен режим",
    "Wyświetl materiały": "",
    "Klient aktywny": "Активен клиент",
    "Zobacz czaty": "Преглед на чатовете",
    "Maksymalny rozmiar pliku w MB": "Максимален размер на файла в MB",
    "Rola": "Роля",
    "Strona została usunięta.": "Страницата е изтрита.",
    "Ładuję zgłoszenia...": "Зареждане на подадени документи...",
    "Separator elementów w tytule": "",
    "Domyślna firma": "Компания по подразбиране",
    "Dodaj do zestawu": "",
    "Wklej komponent": "Компонент за поставяне",
    "Odpowiedź 3": "Отговор 3",
    "Przywrócić wiadomość?": "Възстановяване на съобщението?",
    "Zmień rozmiar": "преоразмеряване",
    "3": "",
    "Strona nadrzędna": "",
    "Książka": "",
    "Zapisuję...": "Аз спестявам...",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "Заглавието на формуляра не може да бъде по-дълго от% 0 знака",
    "Kolor obramowania": "Цвят на границата",
    "Laptop 15,6\"": "",
    "Podgląd szablonu e-maila": "Преглед на шаблон за имейл",
    "Nadpisz kwotę dla": "Презапишете сумата за",
    "Filtry kalendarza": "Календарни филтри",
    "Avantio ID nieruchomości": "Авантио ИД на имот",
    "Zapisz": "Запазване",
    "Tag nieruchomości": "Етикет на собственост",
    "Program": "",
    "Zgoda": "предоставен",
    "Szablon nr 2": "",
    "Lista koordynatorów": "",
    "Co 2 godziny": "На всеки 2 часа",
    "Klient został dodany.": "Клиентът е добавен.",
    "Rola została usunięta.": "Ролята е премахната.",
    "Edycja klienta": "Редактиране на клиента",
    "Filtry kalendarza": "Календарни филтри",
    "Województwo": "Войводство",
    "Data modyfikacji": "Дата на изменение",
    "Wymagane jest wybranie sekcji": "",
    "Sekcja": "секция",
    "Sortowanie malejąco": "Сортиране низходящо",
    "Nie udało się pobrać tras": "Неуспешно изтегляне на маршрути",
    "Typ": "Тип",
    "Najwyższy": "",
    "Czy na pewno chcesz zablokować użytkownika?": "Сигурни ли сте, че искате да блокирате потребителя?",
    "Przenieś niżej": "",
    "Kwota za godzinę": "Количество на час",
    "Edycja zadania": "Редактиране на задача",
    "Kategoria jest wymagana": "Категория е задължителна",
    "Potwierdź publikację wersji": "",
    "Potwierdzenie usunięcia.": "",
    "Zaokrąglenie": "Закръгляване",
    "Wprowadzona wartość jest za długa": "Въведената от вас стойност е твърде дълга",
    "Edytuj zlecenie": "Редактиране на поръчката",
    "Treść": "Съдържание",
    "Bez \"http(s)://\" i \"/\" na końcu.": "",
    "Nie znaleziono żadnych plików": "Не са намерени файлове",
    "Usuń powiązanie": "",
    "Użytkownicy w tej roli": "Потребители в тази роля",
    "Został przywrócony oryginalny harmonogram": "Оригиналният график е възстановен",
    "Zaakceptuj, wyślij": "Приемете, изпращайте",
    "treść notatki": "Съдържание на бележката",
    "Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\".": "Моля, запазете напредъка на работата и кликнете върху бутона „Актуализиране“.",
    "Przypisz obiekty": "Присвояване на обекти",
    "Zacznij pisać aby wyszukać dzielnicę...": "Започнете да пишете, за да търсите квартал...",
    "Poprawna odpowiedź": "",
    "Sypialnia": "",
    "Edycja nowej trasy": "Редактиране на нов маршрут",
    "Następna strona": "Следваща страница",
    "Dodanie regulaminu": "",
    "Przypisane zadanie:": "Възложена задача:",
    "Harmonogram zadań": "Планиране на задачи",
    "Lista Tras:": "Списък на трасите:",
    "Opis certyfikatu": "",
    "Ścieżka aktywnej strony": "",
    "Potwierdzenie ukrycia": "",
    "Slajder": "",
    "Kwota łącznie": "Обща сума",
    "Przypnij menu": "",
    "Nie masz uprawnień do modyfikacji aranżacji.": "",
    "Data wydania": "",
    "Zadanie zostało ukończone.": "Задачата е изпълнена.",
    "Wyświetlanie": "",
    "Uwzględniaj dzielnice": "Включете райони",
    "Numer inwentaryzacji": "Номер на инвентара",
    "Brak sekcji multimediów": "",
    "Kosz": "Кошница",
    "Dodanie poradnika": "",
    "Kierowca": "шофьор",
    "Zajęte": "Зает",
    "Brak zmian": "Няма промени",
    "Edycja działu": "Редактиране на отдел",
    "Porównania": "Сравнения",
    "Informacje podstawowe": "Основна информация",
    "Nieobecność": "Отсъствие",
    "Dodanie nieruchomości": "Добавяне на свойство",
    "Nie udało się pobrać listy serwerów plików": "Неуспешно изтегляне на списъка с файлови сървъри",
    "Odepnij menu": "",
    "Ilość dostępnych bloków": "",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "",
    "Kontener plików": "Контейнер на файлове",
    "Kalendarz - Kategorie zasobów": "Календар - Категории ресурси",
    "Opublikowane wersje językowe.": "",
    "Dodaj kolor": "Добавяне на цвят",
    "Do kogo chcesz napisać?": "На кого искаш да пишеш?",
    "Statystyki wniosków": "Статистика на приложенията",
    "Wstaw treść widoczną po rozwinięciu": "",
    "Wynagrodzenie za konserwację": "Заплащане за поддръжка",
    "Kod Google Webmaster": "",
    "Domyślna": "",
    "od": "откакто",
    "co 6 miesięcy": "на всеки 6 месеца",
    "Wybierz paczkę": "",
    "Wstaw z dołu": "Вмъкнете отдолу",
    "Ustawienia powiadomień": "Настройки за известяване",
    "Pokaż zdjęcia": "Показване на снимки",
    "FavIcona": "",
    "Region": "Регион",
    "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
    "Dostęp do szkoleń:": "",
    "Miniaturki": "Миниатюри",
    "Nowy materiał": "",
    "Zastosuj": "Кандидатствайте",
    "Dodanie klienta": "Добавяне на клиент",
    "Nazwa szablonu": "Име на шаблона",
    "Czy jesteś pewien? ": "Сигурен ли си? ",
    "Wyświetlam": "Показвам",
    "Checklista została usunięta": "Контролният списък е премахнат",
    "Identyfikator publiczny": "Публичен идентификационен номер",
    "Slajdery": "",
    "Nazwa kategorii": "Име на категорията",
    "Liczba miast w regionie": "Брой градове в региона",
    "Kontrolki podstawowe": "Основни контроли",
    "Tydzień": "Седмица",
    "Usuń katalog": "",
    "Podtytuł": "",
    "Codziennie": "Всеки ден",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "Заглавието на формуляра не може да бъде по-дълго от% 0 знака",
    "Rozpoczęto synchronizację rezerwacji": "Синхронизирането на резервациите започна",
    "Adres URL": "URL АДРЕС",
    "Dodaj notatkę/komentarz": "",
    "Szablony": "",
    "Typ źródła danych": "Тип източник на данни",
    "Zobacz czaty": "Преглед на чатовете",
    "Housekeeping (HK)": "Домакинство (HK)",
    "Klienci": "Клиенти",
    "Zacznij pisać aby wyszukać inspektora...": "Започнете да пишете, за да търсите инспектор...",
    "Przybornik": "Кутия с инструменти",
    "Angielski": "Английски",
    "Nie możesz zapisać zmian, gdyż liczba elementów nie może być mniejsza niż ustawiona liczba wymaganych elementów w zakładce ustawienia testu": "",
    "Zamknięte": "затворен",
    "Pokaż zaplanowane punkty": "Показване на планирани точки",
    "Opis kosztu": "",
    "ID nazwa obiektu": "Име на обект за идентификация",
    "Zacznij pisać aby wyszukać nieruchomość...": "Започнете да пишете, за да търсите имот...",
    "Odrzucone zgody": "",
    "Witryny": "",
    "Zadanie zostało zaktualizowane.": "Задачата е актуализирана.",
    "Kwota opłacona od": "Сумата, платена от",
    "Pole zawiera": "Полето съдържа",
    "Pole \"Imię\" jest wymagane.": "Полето „Име“ е задължително.",
    "Koniec długości geograficznej użytkownika": "Крайна дължина на потребителя",
    "TAK": "ДА",
    "Pokaż nieruchomości (bez zadań i rezerwacji)": "Показване на имоти (без задачи и резервации)",
    "Zadanie zostało usunięte": "Задачата е изтрита",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "Нямате необходимите разрешения за извършване на избраната операция.",
    "Numer mieszkania": "Номер на апартамента",
    "Numer telefonu: ": "Телефонен номер: ",
    "Zamknij": "Затвори",
    "Statystyki regionalne - regiony": "Регионална статистика - региони",
    "Tryb konserwacji systemu": "Режим на поддръжка на системата",
    "Przyrostek": "Наставка",
    "Numer sesji": "Номер на сесията",
    "Notatka": "Бележка",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "",
    "Konfiguracja bloku": "",
    "Brak dostępnych tras": "Няма налични маршрути",
    "Statystyki kosztów w obiektach": "Статистика на разходите в съоръженията",
    "Stwórz czat z rezerwacji": "Създаване на чат от резервация",
    "Klient został usunięty.": "Клиентът е премахнат.",
    "Zawiera": "Включва",
    "Krótki tytuł": "",
    "Opis zespołu": "Описание на екипа",
    "Krzesełko": "Стол",
    "Serwer bazy danych": "Сървър за база данни",
    "Wynagrodzenia Kierowcy": "Заплати на водача",
    "Adres e-mail potwierdzony": "",
    "Podanie nazwy jest wymagane.": "Името е задължително.",
    "Data dodania od": "",
    "Ilość osób": "Брой на хората",
    "Nazwisko": "Фамилия",
    "Wartość 0 oznacza brak limitu": "",
    "Szablon został dodany.": "Шаблонът е добавен.",
    "NIE": "НЕ",
    "Data uruchomienia": "Дата на стартиране",
    "Wyszukaj zespół": "",
    "Paczka SCORM została zaktualizowana.": "",
    "Co 5 dni": "На всеки 5 дни",
    "Daty publikacji zostały zaktualizowane.": "",
    "Urlopy": "Почивки",
    "Stopka": "Долен колонтитул",
    "Aranżacja została opublikowana.": "",
    "Rozliczenia": "Населени места",
    "Nie wiem": "Не знам",
    "Historia lokalizacji": "История на местоположението",
    "Nigdy": "никога",
    "Nie udało się pobrać listy szablonów": "",
    "Wersja utowrzona przez": "Версия създадена от",
    "Kategoria szkolenia": "",
    "Lista szkoleń": "",
    "Ukryj": "Скриване",
    "Wykonawca": "",
    "Profil koordynatora": "",
    "Edytuj aranżację": "",
    "Wybierz miasta": "Изберете градове",
    "Moduły": "",
    "Przeniesienie wybranych elementów": "Преместване на избрани елементи",
    "Link do zewnętrznej strony": "",
    "Data zakońćzenia": "",
    "Wystąpił błąd podczas zapisywania ustawień": "Възникна грешка при запазване на настройките",
    "Ukryj podczas dodawania zadania": "Скриване при добавяне на задача",
    "Tytuł aktywnej witryny": "",
    "Czerwiec": "юни",
    "Osoba odpowiedzialna": "Отговарящо лице",
    "Usunął": "Изтрит",
    "Zacznij pisać aby wyszukać nieruchomość roboczą...": "Започнете да пишете, за да търсите работещ имот...",
    "Eksportuj do PDF": "Експортиране в PDF",
    "Zlecenie na nieruchomość roboczą": "Поръчка за работещи недвижими имоти",
    "Kolejność punktów trasy została zaktualizowana": "Редът на маршрутните точки е актуализиран",
    "Obsługa Właściciela (OW)": "Обслужване на собствениците (OW)",
    "Dozwolone rozszerzenia": "Разрешени разширения",
    "Tag nieruchomości": "Етикет на собственост",
    "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "",
    "Blokada konta": "Заключване на сметка",
    "Status paczki został zmieniony.": "",
    "Usuń ze szkolenia": "",
    "Dokument został dodany.": "",
    "Wymagaj odpowiedzi, aby przejść dalej": "",
    "Typ nieobecności": "Тип отсъствие",
    "Następna inwentaryzacja": "Следващ инвентар",
    "Tylko do odczytu": "Само за четене",
    "Bardzo dobrze": "Много добър",
    "Struktura serwisu": "",
    "W organizacji nie ma jeszcze żadnych działów.": "Все още няма отдели в организацията.",
    "Trasa została usunięta": "Маршрутът е премахнат",
    "Nr nieruchomości Avantio": "Имот №. Авантио",
    "Imię i Nazwisko": "Име и фамилия",
    "Ważność": "Валидност",
    "Pracownik": "Работник",
    "Hiszpański": "Испански",
    "Dokument został zaktualizowany.": "",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Грешка 404. Исканият ресурс не е намерен.",
    "W zespole od %0 do %1": "В екип от% 0 до% 1",
    "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
    "To pole jest wymagane": "Това поле е задължително",
    "Dodanie paczki SCORM": "",
    "Wynagrodzenia od ilości posprzątanych obiektów": "Възнаграждение от броя на почистените обекти",
    "OW": "Обслужване на собственици",
    "(AirBnb) Wysłano żądanie do gościa": "(AirBnB) Заявка, изпратена до гост",
    "Data pauzy": "Дата на пауза",
    "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Каналът се изисква по подразбиране. Не е възможно да деактивирате изпращането на известие през този канал. Възможно е само да промените заглавието и съдържанието на съобщението.",
    "Wysłano kolejne wezwanie do zapłaty": "Изпратено е още едно искане за плащане",
    "Zastępstwo zostało usunięte.": "Подмяната е премахната.",
    "Wklej komponent": "Компонент за поставяне",
    "Przeterminowane": "Изтекъл",
    "Procent": "Процент",
    "Rezerwacje": "Резервации",
    "Zacznij pisać aby wyszukać tag...": "Започнете да пишете, за да търсите таг...",
    "Data do": "Дата до",
    "Oznacz widoczne jako przeczytane": "Маркирайте видимо като прочетено",
    "Dzisiaj": "днес",
    "Szczegóły zmian": "Подробности за промените",
    "Zakończone: ${$filters.datetime(task.dateCompleted)}": "Завършен: $ {$filters.datetime (task.dateComplete)}",
    "Treść opublikowana": "",
    "Nazwa lekcji": "",
    "Użytkownik Inspekcja": "Инспекция на потребителя",
    "Typ słownika": "Тип речник",
    "Zablokuj użytkownika": "Блокиране на потребителя",
    "Data użycia": "Дата на употреба",
    "Typ zadania": "Тип на задачата",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą klienta": "Хора, назначени като по подразбиране на задачите за обслужване на клиенти",
    "Pytanie 1": "Въпрос 1",
    "Nieważne": "Не е важно",
    "Sekcja została zaktualizowana": "",
    "Kontrolka wyboru (pojedynczy wybór)": "Контрол на избора (единичен избор)",
    "Kolor został zaktualizowany": "Цветът е актуализиран",
    "Lekcja została dodana.": "",
    "Kwiecień": "април",
    "Kanały obsługiwane przez wybrany typ powiadmienia": "Канали, поддържани от избрания тип въздух",
    "Region został dodany.": "Регионът е добавен.",
    "Usunięto przez: ": "Премахнати от: ",
    "Komunikat błędu": "Съобщение за грешка",
    "Typ Nieruchomości": "Тип имот",
    "Classic mode": "",
    "Strona %0": "Страница% 0",
    "Pokaż rezerwacje właścicielskie": "Покажи резервации на собственика",
    "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "",
    "nie wymuszaj zmiany hasła": "не принуждавайте смяна на паролата",
    "Nazwa pliku została zmieniona.": "Името на файла е променено.",
    "Nazwa użytkownika serwisowego": "Потребителско име на услугата",
    "Nadpisz kwotę dla": "Презапишете сумата за",
    "Konfiguracja domyślna": "конфигурация по подразбиране",
    "Edytuj lekcje": "",
    "Aby wysłać wiadomość, dołącz do czatu": "За да изпратите съобщение, присъединете се към чата",
    "Plik został wysłany": "Файлът е изпратен",
    "Nazwa regionu": "Име на региона",
    "Tytuł": "Заглавие",
    "Edycja nieruchomości roboczej": "Редактиране на работещо свойство",
    "Uwzględnij dodatkowe nieruchomości": "Включете допълнителни свойства",
    "Rezerwacja": "Резервация",
    "Admin": "Админиул",
    "Cena PLN": "Цена PLN",
    "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "Този канал няма възможност да изпраща форматиран текст.",
    "Administracja - Województwa": "Администрация - войводства",
    "Pokaż punkty bez kierowcy": "Показване на точки без шофьор",
    "Nie udało się pobrać listy kategorii": "",
    "Materiały szkoleniowe": "",
    "Przypomnij": "напомнете",
    "Typ źródła": "Тип източник",
    "Domyślna firma": "Компания по подразбиране",
    "Czy jesteś pewien, że chcesz przypisać dzielnicę do nowego miasta? Wszystkie nieruchomości i użytkownicy przypisani do tej dzielnicy przestaną być do niej przypisani.": "Сигурни ли сте, че искате да назначите квартал на нов град? Всички имоти и потребители, присвоени към този район, вече няма да бъдат присвоени към него.",
    "Wyślij link": "Изпрати линк",
    "Dostęp niezdefiniowany": "Неопределен достъп",
    "Na wniosek": "",
    "Od ilości posprzątanych obiektów": "От броя на почистените обекти",
    "Aktualności": "",
    "Przenieś": "Трансфер",
    "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "Когато тази опция е избрана, индивидуалните и базираните на роли разрешения не се вземат предвид.",
    "Zadanie do wykonania": "Задача, която трябва да бъде изпълнена",
    "Pole wymagane": "Задължително поле",
    "Maj": "май",
    "Dane formularza są przechowywane w obiekcie Entry.": "Данните от формуляра се съхраняват в обекта Entry.",
    "Pliki publiczne": "Публични файлове",
    "Zaakceptowane, zapisz": "Прието, запазване",
    "Symbol klienta": "Символ на клиента",
    "Dodaj zespół": "Добавяне на екип",
    "Dodanie lekcji": "",
    "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Полето „% 0\" не съдържа валиден имейл адрес.",
    "Kwota netto": "",
    "Korytarz": "",
    "Numer dowodu osobistego": "Номер на лична карта",
    "W trakcie": "В хода на",
    "Użytkownik został przypisany do szkolenia.": "",
    "Skopiuj szkolenie": "",
    "Piosenka": "",
    "Edytuj datę dostępu": "",
    "Ostatnia wiadomość - data": "Последно съобщение - дата",
    "Wybrane regulaminy: ": "",
    "Sprawdzić": "Проверете",
    "Dodaj nowy tag": "Добавяне на нов таг",
    "Zatwierdź": "изпрати",
    "Nie udało się pobrać listy ról": "Неуспешно изтегляне на списъка с роли",
    "kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)": "кога трябва да се случи (когато можем да посетим апартамента)",
    "Wynagrodzenia Pracownicy": "Заплати на служителите",
    "Pytania": "Въпроси",
    "Pobierz raport": "Изтеглете доклада",
    "Sesja": "Сесия",
    "Treść wiadomości": "Съдържание на съобщението",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą właściciela": "Хора, назначени като по подразбиране на задачи, свързани с услугата на собственика",
    "Przeczytane": "",
    "Użytkownik i jego wiadomości zostały przywrócone.": "Потребителят и неговите съобщения са възстановени.",
    "Serwer został dodany.": "Сървърът е добавен.",
    "Booking with conflict": "Резервация с конфликт",
    "Usuń zestaw": "",
    "Otwórz Ustawienia": "Отворете Настройки",
    "Obciążenie Renters": "Борд на наемателите",
    "Brak zadań do wyświetlenia": "Няма задачи за показване",
    "Rozwiń/Zwiń": "",
    "Dodane przez moje zespoły": "",
    "Typ wynagrodzenia został usunięty": "Видът на заплатата е премахнат",
    "Sesja użytkownika": "Потребителска сесия",
    "Tekst zastępczy": "Алтернативен текст",
    "Dodaj użytkownika": "Добавяне на потребител",
    "Dodaj Notatkę": "Добавяне на бележка",
    "Zadanie wykonuje": "Задачата изпълнява",
    "Pokaż historię": "Показване на историята",
    "Edycja paczek SCORM": "",
    "Dodaj certyfikat": "",
    "Resetowanie podejść": "",
    "Piątek": "петък",
    "Aktualne hasło": "Текуща парола",
    "Kolor został usunięty": "Цветът е премахнат",
    "Maksymalna ilość plików": "Максимален брой файлове",
    "Dodaj dział": "Добавяне на отдел",
    "Włącz monitorowanie aktywności": "",
    "Średnie wynagrodzenie": "Средна заплата",
    "Wybierz temat": "",
    "Nie udało się usunąć zlecenia.": "Неуспешно изтриване на поръчката.",
    "Edycja checklisty": "Редактиране на контролния списък",
    "Zespół aktywny": "Активен екип",
    "Nr rezerwacji": "Номер на резервацията",
    "Batch": "",
    "Historia nieruchomości": "История на недвижимите имоти",
    "Zaopatrzenie zostało dodane.": "Добавени са доставки.",
    "Wybrane elementy zostały usunięte.": "Избраните елементи са изтрити.",
    "Dodaj": "добавяне",
    "Dodaj chat": "Добавяне на чат",
    "Typ materiału": "",
    "Top mieszkań generujacych najwięcej kosztów": "Топ апартаменти, генериращи най-много разходи",
    "Sesja nr %0": "Сесия #% 0",
    "Dodanie slajdera": "",
    "Procent obciążeń": "Процент товари",
    "Stan licznika start": "Статус на стартиране на брояча",
    "Id modelu: %0": "Идентификационен номер на модела:% 0",
    "Do kogo wysłać testowe powiadomienie": "На кого да изпратите известие за теста",
    "Zespół został zaktualizowany.": "Екипът е актуализиран.",
    "Wybierz paczkę SCORM": "",
    "Dzielnice": "Области",
    "Dodanie dzielnicy": "Добавяне на област",
    "Stwórz zadanie": "",
    "Standardowa strona": "",
    "Wielokrotny wybór": "Множествен избор",
    "To miasto znajduję się już w tym regionie.": "Този град вече е в този регион.",
    "Pseudonim": "",
    "Minimum": "Минимално",
    "Ustawienia domyślne": "Настройки по подразбиране",
    "Ostatnie sprzątanie": "Последно почистване",
    "Dodaj Koszt": "Добавяне на цена",
    "Dodaj zestaw": "",
    "Usuń wybrane": "Изтриване на избраните",
    "Ten region jest już przypisany do użytkownika.": "Този регион вече е присвоен на потребителя.",
    "Źródło": "източник",
    "Nie wypełniono poprzedniego wiersza.": "",
    "Status zadania": "Състояние на задачата",
    "Nazwa aktywnej strony": "",
    "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "",
    "Aranżacja": "",
    "Dostęp od": "",
    "Godzina trasy": "Час на маршрута",
    "Ścieżka szkoleniowa została usunięta.": "",
    "Program szkolenia": "",
    "Dzielnica": "квартал",
    "Tłumacz": "Преводач",
    "W polu możemy umieszczać jedynie cyfry": "В полето можем да поставим само числа",
    "Edytuj zadanie": "Редактиране на задача",
    "Nadpisanie kwoty wynagrodzenia zostało dodane.": "Добавено е отмяна на размера на заплатата.",
    "Zameldowanie": "Настаняване",
    "Monitor kolejek": "Монитор на опашката",
    "Zawiera sekcje": "",
    "Konto aktywne": "Активен акаунт",
    "Usuń stronę": "",
    "Pojedynczy wybór": "Единичен избор",
    "Dodaj lekcję": "",
    "Zacznij pisać aby wyszukać użytkownika...": "Започнете да пишете, за да търсите потребител...",
    "dzień temu": "преди един ден",
    "Brak wybranej firmy": "Няма избрана фирма",
    "Lista kosztów": "Списък с разходи",
    "Akceptacja kosztów": "Одобрение на разходите",
    "Recenzje sprzątaczy": "Отзиви за чистачи",
    "Przekroczono czas oczekiwania na odpowiedź serwera lub połączenie zostało anulowane.": "Времето за изчакване на отговор от сървъра е изтекло или връзката е прекратена.",
    "Tylko Administrator lub ExternalManager może tworzyć nowe konta": "Само Administrator или ExternalManager може да създава нови акаунти.",
    "Kwota dodatkowego wynagrodzenia nie może być ujemna": "Размерът на допълнителното възнаграждение не може да бъде отрицателен.",
    "Nazwa czynności": "Име на дейността",
    "Dodaj czynność": "Добавяне на дейност",
    "Liczba czynności": "Брой дейности",
    "Dodaj kategorię zadań": "Добавяне на категория за задачи",
    "Obsługa właścicieli": "ОУ",
    "Edycja kategorii zadań": "Редактиране на категория за задачи",
    "Edycja czynności": "Редактиране на дейност",
    "Brak wydziału": "Няма отдел",
    "Zacznij pisać aby wyszukać czynność...": "Започнете да пишете, за да потърсите дейност...",
    "Czynność została zaktualizowana.": "Дейността беше актуализирана.",
    "Czynność została usunięta.": "Дейността беше изтрита.",
    "Czynność została dodana.": "Дейността беше добавена.",
    "Nie można dodać tej czynności do zadania.": "Тази дейност не може да бъде добавена към задачата.",
    "Przypisane czynności": "Присвоени дейности",
    "Brak przypisanych czynności.": "Няма присвоени дейности.",
    "Kategorie zadań": "Категории за задачи",
    "Czynności zadań": "Дейности по задачи",
    "czynności": "дейности",
    "usunięta": "изтрита",
    "Komentarz (opcjonalny)": "Коментар (по избор)",
    "Formularz zadania nie jest poprawny.": "Формулярът на задачата е невалиден.",
    "Biblioteka czynności": "Библиотека с дейности",
    "Szukaj czynności": "Търсене на дейности",
    "Wszystkie statusy": "Всички статуси",
    "Przenieś na samą górę": "Премести най-горе",
    "Przenieś na sam dół": "Премести най-долу",
    "Widoczna w zadaniach": "Видима в задачите",
    "Czynność jest widoczna w zadaniach.": "Дейността вече е видима в задачите.",
    "Czynność została ukryta w zadaniach.": "Дейността е скрита от задачите.",
    "Edytuj kategorię": "Редактиране на категория",
    "Edytuj czynność": "Редактиране на дейност",
    "Nowa czynność": "Нова дейност",
    "Kolejność została zapisana.": "Редът е запазен.",
    "Nie udało się zapisać kolejności.": "Неуспешно запазване на реда.",
    "Przypisana do działu": "Причислена към отдел",
    "Przypisana do kategorii": "Причислена към категория",
    "Np. wymiana okien": "Напр. смяна на прозорци",
    "Użyta w": "Използвана в",
    "%0 zadaniach": "%0 задачи",
    "Zmiana nazwy nie zmieni istniejących zadań.": "Преименуването няма да промени съществуващите задачи.",
    "Upewnij się, że nazwa czynności:": "Уверете се, че името на дейността:",
    "Nie zawiera literówek": "Не съдържа печатни грешки",
    "Jest jasna, klarowna i precyzyjna": "Е ясно, разбираемо и точно",
    "Zawiera polskie znaki": "Съдържа полските букви",
    "Aktywna w nowych zadaniach": "Активна в новите задачи",
    "Czynność „Inne” (pokazuje pole komentarza w aplikacji mobilnej)": "Дейност „Друго“ (показва поле за коментар в мобилното приложение)",
    "Czynności nigdy nie są usuwane, można je tylko dezaktywować": "Дейностите никога не се изтриват, могат само да бъдат деактивирани",
    "Np. Hydraulika": "Напр. ВиК",
    "Przeciągnij, aby zmienić kolejność działów": "Плъзнете, за да промените реда на отделите",
    "Parking": "Паркинг",
    "Wi-Fi": "Wi-Fi",
    "Router": "Рутер",
    "Nazwa sieci": "Име на мрежата",
    "Zameldowanie / Wymeldowanie": "Настаняване / Напускане",
    "Kod do skrytki na klucze": "Код за кутията за ключове",
    "Instrukcje zameldowania": "Инструкции за настаняване",
    "Instrukcje wymeldowania": "Инструкции за напускане",
    "Media": "Комунални услуги",
    "Dostawca": "Доставчик",
    "Inwentarz": "Инвентар",
    "Komfort": "Комфорт",
    "Dodatki": "Допълнително",
    "A/C": "Климатик",
    "Ogrzewanie centralne": "Централно отопление",
    "Kanapa": "Диван",
    "Zaciemnienie": "Затъмняване",
    "Grzejniki": "Нагреватели",
    "Bojler": "Бойлер",
    "Pościel": "Спално бельо",
    "TV": "Телевизор",
    "Suszarka do ubrań": "Сушилня",
    "Suszarka do włosów": "Сешоар",
    "Żelazko": "Ютия",
    "Piekarnik": "Фурна",
    "Kuchenka mikrofalowa": "Микровълнова фурна",
    "Czajnik": "Чайник",
    "Dzbanek na wodę": "Кана за вода",
    "Środki czystości": "Почистващи препарати",
    "Pralka": "Пералня",
    "Suszarka na pranie": "Простор за дрехи",
    "Lampki nocne": "Нощни лампи",
    "Deska do prasowania": "Дъска за гладене",
    "Kuchenka": "Печка",
    "Toster": "Тостер",
    "Zmywarka": "Съдомиялна машина",
    "Odkurzacz": "Прахосмукачка",
    "Ekspres do kawy": "Кафемашина",
    "Apteczka": "Аптечка",
    "Czujnik CO2": "Датчик за CO2",
    "Gaśnica": "Пожарогасител",
    "Czujnik dymu": "Детектор за дим",
    "Przyjazne zwierzętom": "Приемливо за домашни любимци",
    "Widok": "Гледка",
    "Prąd": "Електричество",
    "Ogrzewanie": "Отопление",
    "Woda": "Вода",
    "Gaz": "Газ",
    "Internet": "Интернет",
    "Dane zostały zapisane.": "Данните са запазени.",
    "Piętro": "Етаж",
    "Winda": "Асансьор",
    "Balkon": "Балкон"
  },
  "es-ES": {
    "Ulubione": "Favoritos",
    "Dodaj do ulubionych": "Añadir a favoritos",
    "Usuń z ulubionych": "Quitar de favoritos",
    "Wybierz typ Firmy": "Selecciona el tipo de empresa",
    "Zacznij pisać aby wyszukać dzielnice...": "Empieza a escribir para buscar barrios...",
    "Co godzinę": "Cada hora",
    "Dostępne wersje językowe.": "Versiones lingüísticas disponibles.",
    "Strona nadrzędna": "Página principal",
    "Autor notatki": "El autor de la nota",
    "zacznij pisać aby wyszukać artykuł...": "empieza a escribir para buscar un artículo...",
    "Slajd został dodany.": "Se ha agregado la diapositiva.",
    "Ten użytkownik już jest przypisany do czatu": "Este usuario ya está asignado al chat",
    "Zlecenia": "Pedidos",
    "Otwórz czat - link": "Abrir chat - enlace",
    "Na żądanie działu": "A petición del departamento",
    "W każdy dzień tygodnia": "Todos los días de la semana",
    "Rozwiń": "Expandir",
    "Artykuł": "Artículo",
    "10": "10",
    "Budynek": "Edifici",
    "Ostatnio oglądane": "Visto por última vez",
    "Nieobecność do": "Ausencia de",
    "Wybierz pliki (do {0})": "Seleccionar archivos (hasta {0})",
    "Co 2 godziny": "Cada 2 horas",
    "Moja trasa": "Mi ruta",
    "Dodanie źródła danych": "Agregar una fuente de datos",
    "Publikuj szkolenie": "Publicar formación",
    "5 ostatnich zadań": "5 tareas recientes",
    "Eksportuj do Excel": "Exportar a Excel",
    "Przypisana do (Imię i Nazwisko)": "Asignado a (nombre y apellidos)",
    "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "Para ver la vista previa actual del certificado, haga clic en Guardar.",
    "Zmniejsz": "Disminuir",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "",
    "Data Wykonania": "Fecha de ejecución",
    "Dodaj kategorię": "Añadir categoría",
    "Dział został zaktualizowany.": "El departamento se ha actualizado.",
    "Klient aktywny": "Cliente activo",
    "Wprowadzona wartość jest nieprawidłowa": "El valor que has introducido no es válido",
    "Slajd został zaktualizowany.": "La diapositiva se ha actualizado.",
    "Szablon checklisty": "Plantilla de lista de verificación",
    "Tak/Nie": "Sí/No",
    "Strona szkolenia ukryta": "Página de formación oculta",
    "Dodanie nieruchomości roboczej": "Añadir una propiedad funcional",
    "Nazwa taga": "Nombre de etiqueta",
    "Edytuj koszt": "",
    "Wybrana dzielnica": "Distrito seleccionado",
    "Dodaj odpowiedź": "Agregar una respuesta",
    "Nazwa użytkownika": "Nombre de usuario",
    "Kolejka": "Fila",
    "Wartości": "Valores",
    "Strona dostępna tylko dla zalogowanych użytkowników": "Esta página solo está disponible para usuarios que hayan iniciado sesión",
    "Zastępstwo wygaśnie za minutę.": "El reemplazo caduca en un minuto.",
    "Token został usunięty.": "Se ha eliminado el token.",
    "Liczba wyświetlanych najnowszych elementów": "Número de artículos recientes mostrados",
    "Pomyślnie dołączono do czatu": "Se unió correctamente al chat",
    "Początek szerokości geograficznej użytkownika": "El inicio de la latitud del usuario",
    "Wybrany szablon": "Plantilla seleccionada",
    "Link został zaktualizowany.": "El enlace se ha actualizado.",
    "Edycja zespołu": "Edición de equipo",
    "Miasto": "ciudad",
    "Zakończone przez: ": "Completado por: ",
    "Nie możesz wznowić obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "No puede reanudar la gestión de esta tarea porque ahora está realizando una tarea diferente",
    "Sekcje i bloki": "Secciones y bloques",
    "Tło strona 2": "Página de antecedentes 2",
    "Nazwa Kategorii": "Nombre de la categoría",
    "Posprzątane": "Limpiado",
    "Pokaż czaty": "Mostrar chats",
    "Stwórz zadanie z tej rezerwacji": "Crear una tarea a partir de esta reserva",
    "Zespół został przypisany do ścieżki szkoleniowej.": "El equipo fue asignado a la ruta de entrenamiento.",
    "Dodaj test": "Agregar prueba",
    "Usunięcie wybranych elementów": "Eliminar los elementos seleccionados",
    "Zapisuję...": "Estoy ahorrando...",
    "Sekcje dla gości": "Secciones de invitados",
    "Włączone (Index)": "Activado (índice)",
    "Zdecydowanie nie": "Definitivamente no",
    "Certyfikat został usunięty.": "Se ha eliminado el certificado.",
    "Notatka została zaktualizowana.": "La nota se ha actualizado.",
    "Ważne": "Importante",
    "Tryb monitorowania aktywności": "Modo de monitoreo de actividad",
    "Link": "Link",
    "Maksymalny rozmiar pliku w MB": "Tamaño máximo de archivo en MB",
    "Stawka wynagrodzenia została zaktualizowana.": "Se ha actualizado la tasa salarial.",
    "Statystyki wyniosków": "Estadísticas de rendimiento",
    "Lista plików": "Lista de archivos",
    "UWAGA! Ta tabela pokazuje tylko przeterminowane zadania, filtr \"STATUS\" nie jest aktywny. Wróć do \"Wszystkie zadania\" aby mieć dostępne wszystkie filtry": "ATENCIÓN! Esta tabla muestra solo las tareas caducadas; el filtro «ESTADO» no está activo. Vuelva a «Todas las tareas» para tener todos los filtros disponibles",
    "Usuń plik": "Eliminar archivo",
    "Element został zaktualizowany.": "El artículo se ha actualizado.",
    "Dział:": "Departamento:",
    "Logi aktywności zostały wyczyszczone": "Se han borrado los registros de actividad",
    "Nazwa katalogu lub pliku": "El nombre del directorio o archivo",
    "Utworzono kopię checklisty": "Se ha creado una copia de la lista de verificación",
    "Tryb wyświetlania": "Modo de visualización",
    "Użytkownik Obsługa": "Servicio de usuario",
    "Zapisz zmiany": "Guardar cambios",
    "Zastępstwo zostało zaktualizowane.": "El reemplazo se ha actualizado.",
    "Polska": "Polonia",
    "Skala 1-5": "Escala 1-5",
    "Wydrukuj": "Imprimir",
    "Firma domyślna": "Empresa predeterminada",
    "Nazwa Firmy": "Nombre de la empresa",
    "Zgoda": "concedido",
    "Wyszukiwarka miejsc": "Buscador de asientos",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "Inserte dos columnas 1/3 y 2/3",
    "Szablon został usunięty.": "Se ha eliminado la plantilla.",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "",
    "Niezakończone": "Inacabado",
    "Data wykonania od": "Fecha de ejecución desde",
    "Ukryj czaty": "Ocultar chats",
    "Co drugi miesiąc": "Cada dos meses",
    "Nazwa kolumny z wartością": "Nombre de columna con valor",
    "Ostatnia strona": "Última página",
    "Komentarz konserwatora": "Comentario del conservador",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "¿Está seguro de mover los elementos seleccionados al directorio actual?",
    "Statyczny": "Estática",
    "Zadania na wniosek działu": "Tareas a petición del departamento",
    "Planuj automatycznie w dniu wymeldowania": "Programe automáticamente el día de la salida",
    "Jutro": "mañana",
    "Wszystkie próby": "Todos los intentos",
    "Przejdź do zadania": "Ir a la tarea",
    "Godzina przełomowa synchronizacji": "La hora revolucionaria de la sincronización",
    "Ilość wierszy": "Número de filas",
    "Dodaj do zespołu": "Añadir al equipo",
    "Inspekcja": "Inspección",
    "Wydział": "Facultad",
    "Łazienka": "Cuarto de baño",
    "Nie udało się pobrać listy filtrów": "No se pudo descargar la lista de filtros",
    "Strona logowania": "Página de inicio de sesión",
    "Administracja - Użytkownicy": "Administración - Usuarios",
    "Wybierz plik lub katalog": "Seleccione un archivo o directorio",
    "Miejsca po przecinku": "Lugares después de la coma",
    "Dodane Koszty": "Costos adicionales",
    "Designer": "Diseñador",
    "-": "-",
    "Wyślij testowe powiadomienie": "Enviar una notificación de prueba",
    "Formularze": "Formularios",
    "Nie udało sie zaktualizować zadania": "No se pudo actualizar la tarea",
    "Początek dystansu": "El inicio de la distancia",
    "Dane do sieci": "Datos a la red",
    "Koszt Renters": "Costo de los inquilinos",
    "Brak właściciela": "Falta de propietario",
    "Publikacja": "Publication",
    "Resetuj zmiany": "Restablecer cambios",
    "Cyfry": "Dígitos",
    "Status: ": "Estado: ",
    "Potwierdzam": "Reafirmando",
    "Co drugi dzień": "Cada dos días",
    "Ustawienia globalne": "Configuración global",
    "PDF": "PDF",
    "Usuń": "Borrar",
    "Nieruchomość jest widoczna": "La propiedad está visible",
    "Nie udało się pobrać listy katalogów": "No se pudo descargar la lista de directorios",
    "Zaakceptowany": "Aceptado",
    "Zadanie zostało rozpoczęte.": "Se ha iniciado la tarea.",
    "Nazwa chatu": "Nombre del chat",
    "Facebook Application ID": "ID de aplicación de Facebook",
    "Wyświetl nieruchomości robocze": "Ver propiedades de trabajo",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "Se ha producido un error del servidor al gestionar la operación seleccionada. Por favor, inténtelo de nuevo.",
    "15 minut": "15 minutos",
    "Edycja formularza": "Edición de formularios",
    "Zakolejkowane": "Calafateado",
    "Adres URL profilu autora.": "URL del perfil del autor.",
    "Opis szkolenia": "Descripción de la formación",
    "Dostęp przyznany przez zespół": "Acceso otorgado por el equipo",
    "Modyfikacja": "Modificación",
    "Nieprzeczytane": "No leído",
    "Numer nieruchomości (StreetNumber)": "Número de propiedad (StreetNumber)",
    "Kod Bing Webmaster": "Código para webmasters de Bing",
    "Administracja - Stanowiska pracy": "Administración - Puestos de trabajo",
    "Wszystkie konta": "Todas las cuentas",
    "W polu możemy umieszczać jedynie cyfry całkowite, nie ujemne": "En el campo solo podemos poner dígitos enteros, no negativos",
    "Kierowca Główny": "Conductor principal",
    "Region został zaktualizowany.": "Se ha actualizado la región.",
    "Regulamin został zaktualizowany.": "Los términos y condiciones se han actualizado.",
    "Certyfikat jest opublikowany": "El certificado está publicado",
    "Nie masz uprawnień do publikacji aranżacji.": "No tienes permiso para publicar el acuerdo.",
    "Checklista nie ma przypisanych miast.": "Checklista no tiene ciudades asignadas.",
    "Opublikuj materiał": "Publicar material",
    "Monitoring": "Monitorización",
    "Status rozliczenia": "Estado de facturación",
    "Zmień status": "Cambiar estado",
    "Klient został zaktualizowany.": "El cliente se ha actualizado.",
    "Edytuj treść": "Editar contenido",
    "Zaopatrzenie": "Aprovisionamiento",
    "Temat": "Tema",
    "Zdecydowanie się nie zgadzam": "Totalmente en desacuerdo",
    "Dodaj szkolenie": "Añadir formación",
    "Nazwa kosztu": "Nombre del costo",
    "Dostępny w sekcjach": "Disponible en secciones",
    "%$ – znacznik otwierający tag": "%$ — etiqueta de apertura de etiqueta",
    "Notatka utworzona z zadania": "Una nota creada a partir de una tarea",
    "Wybierz sekcję": "Selecciona una sección",
    "Hasło": "Contraseña",
    "Dodaj firmę": "Añadir una empresa",
    "Nieruchomość": "inmueble",
    "Zapisz slajd": "Guardar diapositiva",
    "Wyświetlaj tylko treść": "Mostrar solo contenido",
    "Sekcje wspólne": "Secciones comunes",
    "Zdecydowanie nieważne": "Definitivamente no es importante",
    "Nazwa apartamentu": "Nombre del apartamento",
    "${DepartmentName(DepartmentEnum[this.task.department])}": "$ {departmentName (departmentEnum [this.task.department])}",
    "Październik": "oct",
    "Właściwość ``%0`` aktywnego wpisu": "Propiedad ``%0`` de la entrada activa",
    "W zespole do": "En el equipo para",
    "Usuń zadanie": "Eliminar una tarea",
    "Materiał opisowy": "Material descriptivo",
    "Wybierz strony": "Seleccione páginas",
    "Dodane przeze mnie": "Agregado por mí",
    "Właściciel został usunięty": "El propietario ha sido eliminado",
    "Checklista została dodana.": "Se ha agregado la lista de verificación.",
    "zgłoś problem w apartamencie": "informar de un problema en el apartamento",
    "Proszę zapisać postęp pracy i kliknąć przycisk \"Aktualizuj\".": "Guarde el progreso del trabajo y haga clic en el botón «Actualizar».",
    "Email": "Correo electrónico",
    "Obraz został wycięty.": "La imagen estaba recortada.",
    "Wybrany materiał został już dodany do lekcji": "El material seleccionado ya se ha agregado a la lección",
    "Wybrane pliki": "Archivos seleccionados",
    "Kontrolka wyboru (wybór wielokrotny)": "Control de selección (selección múltiple)",
    "Odpowiedź": "Responder",
    "Można dodawać tylko pliki typu: \"%0\".": "Solo puedes añadir archivos del tipo: «».",
    "Paczki SCORM": "Paquetes SCORM",
    "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "El número de días hasta el final de la formación en los que se enviará la notificación",
    "Typ pomieszczenia": "Tipo de habitación",
    "Zacznij pisać aby wyszukać szablon checklisty...": "Empieza a escribir para buscar una plantilla de lista de verificación...",
    "Nazwa pola": "Nombre de campo",
    "Projekt": "Projekt",
    "Edycja inwentaryzacji": "Editar inventario",
    "Wybór": "Selección",
    "Dodanie zadania": "Añadir una tarea",
    "Wyświetlaj nazwę bloczka": "Mostrar el nombre del bloque",
    "Uprawnienia": "Permisos",
    "Renters": "Inquilinos",
    "Log z aktywności": "Registro de actividad",
    "Data dezaktywacji": "Fecha de desactivación",
    "Słownik systemowy": "Diccionario del sistema",
    "Umożliwienie sprawdzania odpowiedzi": "Le permiten comprobar sus respuestas",
    "Ścieżka szkoleniowa została dodana.": "Se ha agregado la ruta de entrenamiento.",
    "Źródło danych": "Fuente de datos",
    "Inwentaryzacja została dodana.": "Se ha añadido el inventario.",
    "Zastępstwo wygaśnie za 10 minut.": "El reemplazo caduca en 10 minutos.",
    "Kolor powinien być w formacie #XXXXXX (np. #f07d00)": "El color debe tener el formato #XXXXXX (por ejemplo, #f07d00)",
    "Strony opisowe": "Páginas descriptivas",
    "Nie udało się pobrać listy kanałów": "No se pudo descargar la lista de canales",
    "Generator plików PDF:": "Generador de PDF:",
    "Raporty z rozliczeń": "Informes de facturación",
    "Nie zdefiniowano żadnych ról.": "No hay funciones definidas.",
    "Nie udało się wczytać podglądu strony.": "No se pudo cargar la vista previa de la página.",
    "Nazwa testu": "Nombre de la prueba",
    "Typ pomieszczenia jest wymagany": "El tipo de habitación es obligatorio",
    "Zmień rozmiar": "cambiar el tamaño",
    "Komunikat mailowy": "Mensaje de correo electrónico",
    "Notatka do zadania": "Nota de tarea",
    "Numer pinezki": "Número PIN",
    "Dodanie regionu": "Agregar región",
    "Checklisty": "Listas de verificación",
    "Dostęp zabroniony": "Acceso prohibido",
    "NIP": "PELLIZCO",
    "Adres email": "Dirección de correo electrónico",
    "Materiał wideo": "Material de vídeo",
    "Komunikat": "Comunicado",
    "Wprowadzona wartość jest za niska": "El valor que has introducido es demasiado bajo",
    "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "Número de días a partir de los cuales el usuario recibirá la notificación",
    "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Habilita al menos una versión en un idioma para que tu sitio comience a administrar páginas.",
    "Stawka za apartamenty została zaktualizowana.": "La tarifa de los apartamentos se ha actualizado.",
    "Pokaż numery stron": "Mostrar números de página",
    "Tytuł witryny": "Título del sitio",
    "Organizuj": "Organizar",
    "Zobacz wszystkie": "Ver todos",
    "Sekcje dla zalogowanych": "Secciones para personas que han iniciado sesión",
    "Kobieta": "mujer",
    "Przywróć": "Restaurar",
    "Dane wydziałów": "Datos del profesorado",
    "Typ strony": "Tipo de página",
    "Dostępne bloki": "Bloques disponibles",
    "Wpis domyślny": "Entrada predeterminada",
    "Witryna została usunięta.": "Se ha eliminado el sitio.",
    "Urlop został dodany.": "Se han añadido vacaciones.",
    "Zmień nazwę pliku": "Cambiar el nombre del archivo",
    "Lewy panel": "Panel izquierdo",
    "Data przejścia": "Fecha de paso",
    "Nieruchomość niestandardowa": "Propiedad personalizada",
    "MasterCode nieruchomości": "Casas de Venta en MasterCode",
    "Kreator trasy: ": "Asistente de rutas: ",
    "Tytuł kafelka": "Título del título",
    "Dodaj slajd": "Añadir diapositiva",
    "Wczytaj zapisany filtr": "Cargar filtro guardado",
    "Wybrana data jest mniejsza niż dozwolona %0.": "La fecha seleccionada es inferior al %0 permitido.",
    "Pokaż nieaktywnych właścicieli": "Mostrar propietarios inactivos",
    "Litery i cyfry": "Letras y números",
    "Klucze": "llaves",
    "Lista urządzeń na których jesteś zalogowany": "Lista de dispositivos en los que ha iniciado sesión",
    "Edycja": "Editar",
    "Statystyki": "Statistik",
    "Odrzuć": "Rechazar",
    "Formularz został zaktualizowany.": "El formulario se ha actualizado.",
    "Lista": "Lista",
    "Usuń materiał z lekcji": "Eliminar el material de la lección",
    "Szablon nr 1": "Plantilla n.° 1",
    "Nazwa przycisku": "Nombre del botón",
    "Lista artykułów": "Lista de artículos",
    "Szukaj": "búsqueda",
    "Logo firmy": "Logo de la empresa",
    "Pliki": "Expedientes",
    "Filtruj": "Filtrar",
    "Data wystąpienia": "Fecha de aparición",
    "${PriorityName(PriorityEnum[this.task.priority])}": "$ {priorityName (priorityEnum [this.task.priority])}",
    "Lekcja SCORM została dodana.": "Se ha agregado la lección SCORM.",
    "Opublikowane języki": "Idiomas publicados",
    "Do poziomu": "Hasta el nivel",
    "Wymagany": "Necesario",
    "Udało się usunąć zadania!": "¡Las tareas se eliminaron correctamente!",
    "Co rok": "Todos los años",
    "Nieopublikowany": "Inédito",
    "Data wygaśnięcia": "Fecha de caducidad",
    "Role użytkownika": "Funciones de usuario",
    "Imie i nazwisko": "Nombre y apellidos",
    "Status": "Estado",
    "Oznacz wszystkie jako przeczytane": "Marcar todo como leído",
    "Wartości statusów": "Valores de estado",
    "Wznów zadanie": "Reanudar tarea",
    "Przeglądanie logów aktywności": "Visualización de registros de actividad",
    "Walidacja": "Validación",
    "Trasa została rozpoczęta": "La ruta ha comenzado",
    "Lista linków": "List of links",
    "Zdecydowanie ważne": "Definitivamente importante",
    "Dodawanie wyposażenia": "Agregar equipo",
    "Co 10 minut": "Cada 10 minutos",
    "Witryna internetowa": "Sitio web",
    "Powiązane artykuły": "Artículos relacionados",
    "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "Aún no se ha asignado ningún usuario a la formación.",
    "Zmodyfikowano": "Modificado",
    "Odśwież": "Refrescar",
    "Wymeldowanie": "Salida",
    "Wybierz pliki": "Seleccionar archivos",
    "Użytkownicy": "Usuarios",
    "Typ wynagrodzenia": "Tipo de remuneración",
    "Dzielenie": "Dividiendo",
    "Co 2 minuty": "Cada 2 minutos",
    "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "Lista de variables disponibles que se pueden usar en todos los campos de texto:",
    "Link do rezerwacji": "Enlace a la reserva",
    "Odejmij kwotę": "Restar la cantidad",
    "Koszt został dodany.": "Se ha añadido el coste.",
    "Dopasuj do kategorii": "Coincidir con la categoría",
    "Nazwa nieruchmości": "Nombre de la propiedad",
    "Peticion informacion": "Solicitud de información",
    "Konfiguracja bloku została zapisana.": "Se ha guardado la configuración del bloque.",
    "Witryna tylko dla zalogowanych użytkowników": "Sitio web solo para usuarios que han iniciado sesión",
    "Uzupełnij luki": "Rellene los huecos",
    "Zapis został usunięty": "Se ha eliminado el registro",
    "Stawki nieruchomości": "Tarifas inmobiliarias",
    "Brak elementów podsumowania": "Falta de elementos resumidos",
    "Wynagrodzenie podstawowe": "Salario base",
    "Wpis nieprzeczytany": "Entrada no leída",
    "Linia": "línea",
    "Pobierz": "Descargar",
    "Usuń publikację": "Eliminar publicación",
    "Zaopatrzenie zostało zaktualizowane.": "Se ha actualizado el suministro.",
    "Ważne informacje": "Información importante",
    "Edycja regionu": "Edición de región",
    "12 godzin": "12 horas",
    "Stan licznika końcowego nie może być mniejszy bądź równy w porównaniu do licznika początkującego": "El estado del contador final no debe ser inferior o igual al del contador inicial",
    "Załaduj": "Cargar",
    "Zastępstwo wygaśnie za 5 minut.": "El reemplazo caducará en 5 minutos.",
    "Zdecydowanie tak": "Definitivamente sí",
    "Kwota opłacona do": "Monto pagado hasta",
    "Ten czat nie posiada przypisanych konkretnych użytkowników.": "Este chat no tiene usuarios específicos asignados.",
    "Przywróć użytkownika": "Restaurar usuario",
    "Zadowolony": "satisfecho",
    "Wybierz dzielnice": "Seleccione distritos",
    "Tagi:": "Etiquetas:",
    "Imię i nazwisko właściciela": "Nombre y apellidos del propietario",
    "Rozpocznij zadanie": "Iniciar la tarea",
    "Brak sekcji - najpierw utwórz sekcję": "",
    "Nieruchomość jest już przypisana": "La propiedad ya está asignada",
    "Marka": "marca",
    "Edycja ankiety": "Edición de encuestas",
    "Zapauzuj zadanie": "Pausar tarea",
    "Podgląd szablonu e-maila": "Vista previa de plantilla de correo electrónico",
    "zacznij pisać aby wyszukać paczkę SCORM...": "comience a escribir para buscar el paquete SCORM...",
    "Nazwa serwera": "Nombre del servidor",
    "Google Nexus 10": "Google Nexus 10",
    "Kwota brakująca": "Cantidad faltante",
    "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "La posibilidad de modificar esta sección es limitada. Los campos inactivos se sincronizan con la base de datos externa %0.",
    "Powiązane": "Relacionado",
    "Czas realizacji": "Plazo de entrega",
    "Brak nowych powiadomień.": "No hay notificaciones nuevas.",
    "Wymuś zmianę hasła": "Forzar el cambio de contraseña",
    "Data przejścia na nowe API": "Fecha de transición a la nueva API",
    "Zmodyfikowane przez": "Modificado por",
    "Kwota zniszczeń": "Cantidad de daño",
    "Wersje aranżacji": "Versiones de arreglo",
    "Ustawienia podstawowe": "Ajustes básicos",
    "Id nieruchomości": "ID de propiedad",
    "Wybrana data jest większa niż dozwolona %0.": "La fecha seleccionada es superior al %0 permitido.",
    "Status dokumentu został zmieniony.": "Se ha modificado el estado del documento.",
    "Wpis został usunięty.": "Se ha eliminado la entrada.",
    "Edytuj datę opuszczenia zespołu": "Editar la fecha de abandono del equipo",
    "Częstotliwość odświeżania": "Frecuencia de actualización",
    "Podgląd": "Vista previa",
    "Ustawienia witryny": "Configuración del sitio",
    "Ustawienia strony": "Ajustes de página",
    "Liczba nocy": "Cantidad de noches",
    "Program został zaktualizowany.": "El programa se ha actualizado.",
    "Edycja artykułu": "Edición de un artículo",
    "Data automatycznej akceptacji": "Fecha de aceptación automática",
    "Dodanie firmy": "Añadir una empresa",
    "Prawy panel": "Panel derecho",
    "Wynagrodzenie za sprzątanie": "Remuneración por limpieza",
    "Link do raportu": "Enlace al informe",
    "Wynagrodzenie za inspecję": "Salario por inspección",
    "Opis sekcji": "Descripción de la sección",
    "Edycja ustawień": "Editar ajustes",
    "Port": "puerto",
    "Nowa umowa": "Nuevo contrato",
    "Użytkownik": "Usuario",
    "Tagi nieruchomości": "Etiquetas de propiedad",
    "Dodaj typ wynagrodzenia": "Añadir un tipo de salario",
    "Data": "Dato",
    "Pokaż na mapie": "Mostrar en el mapa",
    "Dodatkowy komentarz do wynagrodzenia": "Comentario adicional sobre el salario",
    "Opublikowane na wybranej stronie": "Publicado en la página seleccionada",
    "Rozpoczęcie": "comienzo",
    "Wybrano 1 plik": "1 archivo seleccionado",
    "Opracowane, zapisz": "Elaborado, guarda",
    "Nie udało się pobrać użytkowników": "No se pudieron descargar los usuarios",
    "Edycja firmy": "Edición de la empresa",
    "Nazwa ścieżki": "Nombre de ruta",
    "Dodaj zasób": "Agregar un recurso",
    "Lista zespołów": "Lista de bandas",
    "Warunki logiczne": "Condiciones lógicas",
    "Pierwsza strona": "La primera página",
    "Usunięte": "Eliminado",
    "Zespół został przypisany do szkolenia.": "El equipo fue asignado a la capacitación.",
    "Wyczyść aranżację": "Disposición clara",
    "Słowa oddzielone przecinkami.": "Palabras separadas por comas.",
    "Default mode": "Modo predeterminado",
    "Wybranie strony jest wymagane": "Es necesario seleccionar una página",
    "Powiadomienie dla administratora chatu o nowych wiadomościach": "Notificación de nuevos mensajes al administrador del chat",
    "Liczba pracowników zatrudnionych tylko w tym mieście": "Número de empleados empleados solo en esta ciudad",
    "Cancelled": "Cancelado",
    "Aktualność została dodana.": "Se ha añadido la actualidad.",
    "Zdjęcia": "Fotos",
    "Uruchom zadanie": "Ejecute la tarea",
    "Data dodania": "Fecha añadida",
    "Zarchiwizowany": "Archivado",
    "Wiadomość testowa została wysłana.": "Se ha enviado un mensaje de prueba.",
    "Numer nieruchomości Avantio": "Número de propiedad Avantio",
    "Inwentaryzacja": "Inventario",
    "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "El carácter seleccionado reemplaza la etiqueta separadora | insertada en el título.",
    "Kraj": "País",
    "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "No mostrar la página como fuente de imagen en los resultados de búsqueda (noImageIndex)",
    "Informacja o ciasteczkach": "Información sobre las cookies",
    "Wybierz koordynatora": "Elige un coordinador",
    "Plik": "Expediente",
    "Nieruchomość robocza": "Propiedad en funcionamiento",
    "Kopiuj": "copiar",
    "Pokój dzienny": "sala de estar",
    "Link do wybranej strony serwisu": "Enlace a la página seleccionada del servicio",
    "Robocizna": "Trabajo",
    "Nie do odzyskania": "Irrecuperable",
    "Tekst alternatywny": "Texto alternativo",
    "Koordynator Konserwacji": "Coordinadora de mantenimiento",
    "usuń notatkę": "eliminar nota",
    "Domyślny": "Predeterminado",
    "Odstęp": "Espaciado",
    "Nazwa dzielnicy": "Nombre del distrito",
    "Wyszukiwana fraza:": "Frase de búsqueda:",
    "zacznij pisać aby wyszukać kategorię...": "empieza a escribir para buscar la categoría...",
    "Usuń blok z sekcji": "Eliminar un bloque de una sección",
    "Ranga": "Rango",
    "Czyim kosztem jest dodany przedmiot?": "¿A costa de quién se añade el artículo?",
    "Czas": "tiempo",
    "Odrzucone": "Rechazado",
    "Cofam": "Recolección",
    "Subskrypcja": "suscripción",
    "Ilość znaków": "Cantidad de caracteres",
    "Excel został wygenerowany i wysłany na adres e-mail": "",
    "Aranżacje": "Arreglos",
    "Informacje Podstawowe": "Información básica",
    "Zobacz szczegóły sesji użytkownika": "Ver detalles de la sesión de usuario",
    "Sobota": "sábado",
    "3 godziny": "3 horas",
    "Rozliczenia pracowników": "Contabilidad de empleados",
    "Ustawienia powiadomień zostały zaktualizowane.": "Se actualizó la configuración de las notificaciones.",
    "Adres url do pliku wideo": "La URL del archivo de vídeo",
    "Dark mode": "Moda oscura",
    "Ten Miesiąc": "Este mes",
    "Mapa": "Mapa",
    "Ilość łóżek dwuosobowe": "Número de camas dobles",
    "Brak tagów": "Sin etiquetas",
    "Dane gościa": "Datos de visitantes",
    "Identyfikator zadania": "ID de tarea",
    "Dodaj do trasy": "Añadir a la ruta",
    "Apple iPhone 5": "Apple iPhone 5",
    "Program": "programa",
    "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Agregue un nuevo sitio para empezar a administrar las páginas.",
    "Certyfikaty": "Certificados",
    "Data zakończenia": "Fecha de finalización",
    "Trasy można wykonywać w aplikacji Hi!Renters Mobile": "Las rutas se pueden hacer en Hi! Inquilinos móviles",
    "Potwierdź akceptację": "Confirme la aceptación",
    "Czy na pewno chcesz zkopiować szkolenie?": "¿Está seguro de que desea copiar la formación?",
    "Login": "Iniciar sesión",
    "Niepotwierdzeni": "Sin confirmar",
    "Zakończone: ${$filters.datetime(route.dateCompletedUtc)}": "Completado: $ {$filters.datetime (route.dateCompleteUTC)}",
    "Chat": "Charlas",
    "Raczej się zgadzam": "Más bien, estoy de acuerdo",
    "Pole nie może być puste": "El campo no puede estar vacío",
    "1 godzina": "1 hora",
    "Wydział zadania": "Departamento de tareas",
    "Wysokość": "altura",
    "ISBN": "ISBN",
    "Tło certyfikatu": "Antecedentes del certificado",
    "Osoba zastępowana": "Persona a reemplazar",
    "do czasu ręcznego odblokowania": "hasta el desbloqueo manual",
    "Ikona": "icono",
    "Co 30 minut": "Cada 30 minutos",
    "Zobacz zdjęcia": "Ver fotos",
    "Wynagrodzenie": "Retribución",
    "Wyrażenie regularne": "Expresión regular",
    "Osiągnąłeś limit zdjęć. Nie możesz dodać więcej zdjęć": "Has alcanzado el límite de fotos. No puedes añadir más fotos",
    "Link przycisku": "Enlace del botón",
    "Czy na pewno chcesz usunąć ten kolor?": "¿Estás seguro de que quieres eliminar este color?",
    "Nie wybrano paczki.": "No se ha seleccionado ningún paquete.",
    "Proszę obciążyć gościa": "Por favor, cobre al huésped",
    "Data publikacji": "Fecha de publicación",
    "Blokowanie użytkowników": "Bloquear usuarios",
    "Dodawanie checklisty": "Agregar una lista de verificación",
    "Dodaj pytanie": "Añadir pregunta",
    "Zmodyfikował": "Modificado",
    "Numer telefonu": "número de teléfono",
    "Dział nadrzędny": "Departamento de padres",
    "Wybierz tagi": "Selecciona etiquetas",
    "Kolejne pozycje z lewej strony": "Próximos elementos de la izquierda",
    "Wykonaj": "Ejecutar",
    "Wyloguj się": "Cerrar sesión",
    "Powiązane zadanie": "",
    "Poniedziałek": "lunes",
    "Nie mam zdania": "No tengo opinión",
    "Lista rezerwacji": "Lista de reservas",
    "Ładuje...": "Cargando...",
    "Jesteś pewien?": "¿Estás seguro?",
    "Teraz": "ahora",
    "Strona została zaktualizowana.": "La página se ha actualizado.",
    "Synchronizuj": "Sincronizar",
    "Numer mieszkania (Number)": "Número del apartamento (Número)",
    "Usunięto użytkownika z czatu": "Usuario eliminado del chat",
    "Nazwa elementu": "Nombre del artículo",
    "Anuluj edycję": "Cancelar edición",
    "Wróć na dół": "Volver al final",
    "Pokaż przycisk": "Botón Mostrar",
    "Nazwa obiektu": "Nombre del objeto",
    "Uwzględniaj zadania z miesiąca": "Incluye las tareas del mes",
    "Nazwa zespołu": "Nombre del equipo",
    "Wideo z biblioteki": "Vídeo de la biblioteca",
    "Data logowania": "Fecha de inicio de sesión",
    "Archiwum": "Archivo",
    "Zastępstwo wygasło.": "El reemplazo ha caducado.",
    "Typ Firmy": "Tipo de empresa",
    "Data przyjazdu": "Fecha de llegada",
    "ID użytkownika": "ID de usuario",
    "Log błędu": "Registro de errores",
    "Książka": "Libro",
    "Typ serwera": "Tipo de servidor",
    "Maksimum": "Máximo",
    "Wybrany region": "Región seleccionada",
    "Pobrane z magazynu Renters": "Recuperado de la revista Renters",
    "Sekcja nie została znaleziona": "No se encontró la sección",
    "Nazwa zadania": "Nombre de la tarea",
    "ID zadania": "ID de tarea",
    "Nikomu nie przydzielono uprawnień": "A nadie se le han otorgado privilegios",
    "Kwota wynagrodzenia PLN brutto": "Importe salarial en PLN brutos",
    "Rola aktywna": "Rol activo",
    "Usuń z zespołu": "Eliminar del equipo",
    "Utworzone": "Creado",
    "Nie udało się pobrać powiadomień.": "No se pudieron descargar las notificaciones.",
    "Utwórz raport wyników": "Crear un informe de resultados",
    "Get it on Appstore": "Consíguelo en la Appstore",
    "Nazwa koordynatora": "Nombre del coordinador",
    "Aplikacja nie ma uprawnień do wysyłania powiadomień PUSH": "La aplicación no tiene permiso para enviar notificaciones PUSH",
    "Opis kategorii": "Descripción de la categoría",
    "Nazwa autora": "Nombre del autor",
    "Certyfikat został dodany.": "Se ha agregado el certificado.",
    "Tłumaczenia": "Traducciones",
    "Liczba": "Número",
    "Checkbox": "Casilla de verificación",
    "Treść notatki": "Contenido de la nota",
    "Miasto zostało usunięte": "La ciudad ha sido removida",
    "+": "+",
    "Statystyki użytkowników": "Estadísticas de usuario",
    "Ustawienia wynagrodzenia zostały zaktualizowane.": "Se ha actualizado la configuración salarial.",
    "Posiadasz niezapisane materiały": "Tienes material sin guardar",
    "Nadpisz kwotę": "Sobrescribir el importe",
    "Sortowanie rosnąco": "Ordenar de forma ascendente",
    "Rejestr zmian": "Registro de cambios",
    "Urządzenie zostało usunięte.": "Se ha retirado el dispositivo.",
    "Notatka została dodana.": "Se ha añadido una nota.",
    "Prawda-Fałsz": "Verdadero-Falso",
    "Dodanie użytkownika": "Añadir un usuario",
    "Edytuj": "Editar",
    "Usuń filtr": "Eliminar filtro",
    "Dodaj formularz": "Añadir formulario",
    "Zapytanie SQL": "Consulta SQL",
    "Akceptacja": "Aceptación",
    "Podana wartość jest nieprawidłowa.": "El valor especificado no es válido.",
    "Edycja nieruchomości": "Edición de propiedades",
    "Niezadowolony": "Insatisfecho",
    "Utwórz zlecenie": "Crear un pedido",
    "Liczba całkowita": "Entero",
    "Czas wykonania": "Tiempo de ejecución",
    "Imie i nazwisko: ": "Nombre y apellidos: ",
    "Średnie wynagrodzenie koordynatora": "El salario promedio de un coordinador",
    "Kwota jednostkowa": "Monto unitario",
    "Wyszukaj...": "Buscar...",
    "Edycja zestawu regulaminóe": "Edición de un conjunto de reglas",
    "Informacje dodatkowe": "Información adicional",
    "Średnie wynagrodzenie pracowników": "Salario promedio de los empleados",
    "Tytuł sekcji": "Título de la sección",
    "Blokowanie użytkowników szkoleń": "Bloqueo de usuarios en formación",
    "Warunkowo": "Condicionalmente",
    "Blok aktywny": "Bloqueo activo",
    "Aktualizuj": "Actualización",
    "Wybierz autora z listy": "Seleccione un autor de la lista",
    "Kolor obramowania": "Color del borde",
    "Urlop": "Vacaciones",
    "Stwórz czat": "Crea un chat",
    "Rola została dodana.": "Se ha agregado la función.",
    "Lista zgłoszeń w tym apartamancie": "Lista de solicitudes en este apartamento",
    "Brak": "Ninguna",
    "Szczegóły zmiany": "Detalles del cambio",
    "Ta nieruchomość nie posiada informacji na temat wyposażenia.": "Esta propiedad no tiene información sobre el equipo.",
    "Edytuj kategorie": "Editar categorías",
    "Status dokumentu": "Estado del documento",
    "Osoby przypisane jako domyślne do zadań zwiazanych ze sprzątaniem": "Personas asignadas por defecto a tareas relacionadas con la limpieza",
    "Jest problem": "Hay un problema",
    "Adres domenowy": "Domain Address",
    "i posiadających wymagane uprawnienia": "y quienes tienen los permisos necesarios",
    "Wartość": "Valor",
    "Dodaj stwierdzenie": "Agregar una declaración",
    "Tag został dodany.": "Se ha añadido la etiqueta.",
    "co 30 dni": "cada 30 días",
    "Sekcja jest wymagana": "",
    "Przenieś wyżej": "Muévete más alto",
    "Komentarz zadania nie może być dłuższy niż 500 znaków.": "El comentario de la tarea no puede tener más de 500 caracteres.",
    "Szkolenie jest opublikowane": "La formación está publicada",
    "Rozpocznij synchronizację": "Comenzar a sincronizar",
    "Dane wydziału zostały usunięte.": "Se han eliminado los datos del profesorado.",
    "Zadanie zostało uruchomione.": "Se ha iniciado la tarea.",
    "Dodano zdjęć": "Fotos añadidas",
    "Kategorie szkoleń": "Categorías de formación",
    "Pole \"Nazwisko\" jest wymagane.": "El campo «Apellido» es obligatorio.",
    "Zabierz dostęp": "Acceso para llevar",
    "Kategorie": "Categorías",
    "Typ obciążenia": "Tipo de carga",
    "Dokument nie jest jeszcze nigdzie opublikowany.": "El documento aún no se ha publicado en ningún sitio.",
    "Rozpocznij trasę": "Comenzar la ruta",
    "Wybrano pliki różnych typów. Wybierz pliki tego samego typu.": "",
    "Nazwa tytułu nie może być dłuższa niż 240 znaków ani krótsza niż 3 znaki.": "El nombre del título no puede tener más de 240 caracteres ni menos de 3 caracteres.",
    "Magazynier": "Almacenista",
    "Wielkość kroku": "Tamaño del escalón",
    "Dodaj etykietę": "Añadir etiqueta",
    "Firma sprzątająca": "Empresa de limpieza",
    "Jeszcze nie ma kategorii.": "Aún no hay categorías.",
    "Aranżacja została zachowana.": "El arreglo se ha conservado.",
    "Edycja dzielnicy": "Edición de distrito",
    "Język domyślny": "Idioma predeterminado",
    "Ogólne": "General",
    "Koszty do zadania": "Costos de la tarea",
    "Dodanie ścieżki szkoleniowej": "Añadir una ruta de formación",
    "Zaplanowane": "Programado",
    "Wyczyść": "Borrar",
    "Nazwa przycisku ``Dalej``": "Nombre del botón ``Siguiente``",
    "Szkolenie jest puste": "La formación está vacía",
    "Symbol strony": "Símbolo de página",
    "Zacznij pisać aby wyszukać kierowcę...": "Empieza a escribir para buscar un conductor...",
    "Ilość wyników do pobrania": "Número de resultados para descargar",
    "Tylko priorytetowe": "Solo prioridad",
    "Nie udało się wysłać pliku": "No se pudo enviar el archivo",
    "Dodaj zdjęcia": "Añadir fotos",
    "Czas trwania:": "Duración:",
    "Koordynator": "Coordinadora",
    "Edycja źródła danych": "Editar la fuente de datos",
    "Dane rezerwacji": "Datos de reserva",
    "Wersja opublikowana": "Versión publicada",
    "Użytkownik jest liderem zespołu": "El usuario es el líder del equipo",
    "Utworzone przez:": "Creado por:",
    "Użytkownik został usunięty.": "Se ha eliminado el usuario.",
    "Deadline - Data wykonania": "Fecha límite - Fecha de ejecución",
    "L4": "L4",
    "Opis": "Descripción",
    "Nie ma ustalonej roli dla tego wydziału": "No hay una función fija para este departamento",
    "Ukryj materiał": "Ocultar material",
    "Pokaż tytuły stron": "Mostrar títulos de página",
    "Moje filtry": "Mis filtros",
    "Moje czaty": "Mis chats",
    "Zapamiętaj logowanie": "Recordar inicio de sesión",
    "Data zdarzenia": "Fecha del evento",
    "Wartość musi być liczbą ujemną": "El valor debe ser un número negativo",
    "Filtr prywatny": "Filtro privado",
    "Zakończ trasę": "Completa la ruta",
    "Dodaj wszystkich dopasowanych użytkowników": "Añadir todos los usuarios coincidentes",
    "Stawka nieruchomości": "Tasa inmobiliaria",
    "Publikacja została dodana.": "Se ha agregado la publicación.",
    "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "Solo podrá agregar términos al diccionario después de guardar la fuente de datos.",
    "Godzina zameldowania": "Hora de entrada",
    "Zakres czasu": "Intervalo de tiempo",
    "Nazwa katalogu została zmieniona.": "Se ha cambiado el nombre del directorio.",
    "Najnowsze": "Último",
    "Certyfikat nie jest opublikowany": "El certificado no está publicado",
    "Tekst do uzupełnienia": "Texto a completar",
    "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "Para añadir miembros al equipo, primero debes guardar el formulario.",
    "Statusy użytkowników": "Estados de usuario",
    "Nr telefonu": "número de teléfono",
    "Dodaj nowy koszt": "Añadir un coste nuevo",
    "Zmodyfikowane przez użytkownika": "Modificado por el usuario",
    "Liczba zgłoszonych problemów": "Número de problemas notificados",
    "Domyślny kolor trasy (dotyczy kierowców)": "Color de ruta predeterminado (se aplica a los conductores)",
    "Peticion disponibilidad": "Solicitud de disponibilidad",
    "Brak miast": "No hay ciudades",
    "Nowa kwota": "Monto nuevo",
    "Łączenie treści": "Vinculación de contenido",
    "Data wykonania": "Fecha de ejecución",
    "Ten użytkownik nie posiada jeszcze przypisanych dzielnic.": "Este usuario aún no tiene distritos asignados.",
    "Niewidoczne": "Invisible",
    "Zadania do wykonania": "Tareas por completar",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "",
    "Zapauzowane": "Abandonado",
    "Pole może zawierać jedynie cyfry.": "El campo solo puede contener números.",
    "kanał wymagany": "canal requerido",
    "Usuń regulamin": "Eliminar términos y condiciones",
    "Podstawowe operacje tekstowe": "Operaciones de texto básicas",
    "Nierozwiązane": "Sin resolver",
    "Brak plików w sekcji": "No hay archivos en la sección",
    "Brak aktywnego filtru": "Sin filtro activo",
    "Element został dodany.": "Se ha añadido el artículo.",
    "Dashboard": "Tablero",
    "Odznacz wszystko": "Desmarcar todo",
    "Nazwa przycisku ``Wstecz``": "Nombre del botón ``Atrás``",
    "z": "",
    "Podstawowe": "básica",
    "Edycja wielu elementów": "Edición de varios elementos",
    "Przesyłam...": "Estoy enviando...",
    "Liczba wyświetlanych elementów": "Número de artículos mostrados",
    "Edycja aranżacji": "Editar arreglo",
    "Formularz": "Formulario",
    "Łączny czas wykonywania zadań": "Tiempo total de ejecución de la tarea",
    "Przypisz do zadania": "Asignar a la tarea",
    "Google Nexus 7": "Google Nexus 7",
    "Serwer dostępny": "Servidor disponible",
    "Wybierz artykuł": "Selecciona un artículo",
    "Archiwizuj": "Archivo",
    "BIC/Swift": "BIC/Swift",
    "Koszty zadania zostały zaktualizowane.": "Se han actualizado los costos de las tareas.",
    "Wybrano:": "Seleccionado:",
    "Dodanie właściciela": "Añadir un propietario",
    "Przejdź do zlecenia z notatki": "Ir al pedido desde la nota",
    "Dodaj do zestawu": "Agregar al conjunto",
    "Data zakończenia do": "Fecha de finalización hasta",
    "Role": "Funciones",
    "Twój token": "Tu token",
    "Publiczne": "Público",
    "Edycja wynagrodzenia mieszanego dla:": "Editar salario mixto para:",
    "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "Para añadir un equipo a una ruta de formación, primero debes guardar el formulario.",
    "Przeciągnij i upuść aby posortować pliki": "Arrastrar y soltar para ordenar los archivos",
    "Edycja szablonu": "Edición de una plantilla",
    "Słownik": "Glosario",
    "Wybierz wydział": "Seleccione el cuerpo docente",
    "To szkolenie znajduje się już w ścieżce szkoleń": "Esta formación ya está en proceso de formación",
    "Trasa została zapisana.": "Se ha guardado la ruta.",
    "Początkowy stan licznika": "El estado inicial del contador",
    "Nie można jednocześnie wybrać tagów i zaznaczyć opcji 'Usuń wszystkie tagi'": "No puedes seleccionar etiquetas al mismo tiempo y marcar la opción «Eliminar todas las etiquetas»",
    "Rodzaj adresu kanonicznego": "Tipo de dirección canónica",
    "To zadanie dotyczy nieruchomości, która znajduje się na trasie. Czy chcesz przejść do mapy, aby edytować punkt?": "Esta tarea se aplica a los bienes inmuebles, que se encuentran en la ruta. ¿Desea ir al mapa para editar un punto?",
    "Nie udało się pobrać listy powiadomień": "No se pudo descargar la lista de notificaciones",
    "Usuń odpowiedź": "Eliminar respuesta",
    "Powiązane zadania": "Tareas relacionadas",
    "Nie": "no",
    "Zaznacz wszystkie": "Selecciona todo",
    "Obsługa Klienta (BOK)": "Servicio al cliente (BOK)",
    "Tak": "Sí",
    "Rozwiązane": "Resuelto",
    "Kolor został dodany": "Se ha añadido color",
    "Wybrana liczba jest mniejsza niż dozwolona %0.": "El número seleccionado es inferior al %0 permitido.",
    "Dodaj wiersz": "Añadir una fila",
    "Dowolny": "Cualquier",
    "Pokaż nieaktywne nieruchomości": "Mostrar propiedades inactivas",
    "Dodano użytkownika do czatu": "Se ha añadido un usuario al chat",
    "Ta dzielnica jest już przypisana do użytkownika.": "Este distrito ya está asignado al usuario.",
    "Zasoby": "Recursos",
    "Utworzone przez": "Creado por",
    "Adres kanoniczny": "Dirección canónica",
    "Dodaj dni": "Añadir días",
    "Zamknięte przez użytkownika o Id": "Cerrado por el usuario acerca de Id",
    "Usuń wiersz": "Eliminar fila",
    "Wielokrotnego wyboru": "Opción múltiple",
    "Dodanie slajdów": "Añadir diapositivas",
    "Dodaj nową stronę lub wybierz z menu aby edytować.": "Añada una página nueva o selecciónela en el menú para editarla.",
    "Poprzednia strona": "Página anterior",
    "Pomieszczenie": "Habitación",
    "Dostęp": "Acceso",
    "Rola została zaktualizowana.": "Se ha actualizado el rol.",
    "Materiały": "",
    "Widok tygodniowy": "Vista semanal",
    "Dodanie strony": "Añadir una página",
    "Definicja szablonu": "Definición de plantilla",
    "Stan powiadomienia": "Estado de la notificación",
    "Uwzględniaj miasta": "Incluir ciudades",
    "Nieruchomości": "Bienes raíces",
    "Bank": "Banco",
    "Usuń pytanie": "Eliminar pregunta",
    "Moje trasy": "Mis rutas",
    "Plik wideo": "Archivo de vídeo",
    "Edytowana wersja": "Versión editada",
    "Edycja testu": "Edición de prueba",
    "Dalej": "Más allá",
    "Zespół": "Equipo",
    "Przyczyna": "La causa",
    "Opublikuj tutaj": "Publica aquí",
    "...nie znalazłeś bloku?": "... ¿no encontraste el bloque?",
    "Definicja formularza znajduje się w obiekcie Form.": "La definición del formulario se encuentra en el objeto Form.",
    "Liczba dużych prześcieradeł": "Número de hojas grandes",
    "Domyślna checklista": "Lista de verificación predeterminada",
    "Dodaj Koszt do zadania": "Agregar costo a la tarea",
    "Użytkownik został zaktualizowany.": "Se ha actualizado el usuario.",
    "Wstaw szablon informacyjny ze zdjęciem": "Inserte una plantilla de información con una foto",
    "Szkic": "Croquis",
    "Data końcowa nie może być wcześniejsza niż data początkowa": "La fecha de finalización no puede ser anterior a la fecha de inicio",
    "Legacy mode": "Modo Legacy",
    "Wrzesień": "Sept",
    "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "La configuración de la sección no está disponible porque no se proporciona ninguna definición de plantilla.",
    "Utwórz katalog": "Crear un catálogo",
    "Wszystkie typy": "Todos los tipos",
    "Zobacz przed opublikowaniem": "Ver antes de publicar",
    "Raport został wysłany na adres e-mail": "El informe se ha enviado al correo electrónico",
    "Wybranie katalogu jest wymagane": "Es necesario seleccionar un directorio",
    "Nie udało się pobrać listy modułów": "No se pudo descargar la lista de módulos",
    "Trasa została wznowiona": "La ruta se ha reanudado",
    "Zapisz wersję": "Guardar versión",
    "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "Para añadir un equipo a la formación, primero debes guardar el formulario.",
    "Zacznij pisać numer aby wyszukać źródło rezerwacji...": "Empieza a escribir el número para buscar una fuente de reservas...",
    "Slajder został usunięty.": "Se ha quitado el control deslizante.",
    "Satysfakcja": "Satisfacción",
    "Formularz kontaktowy": "Formulario de contacto",
    "Utwórz nowy": "Crear un nuevo",
    "Dodaj slajder": "Agregar control deslizante",
    "Separator elementów w tytule": "Separador de elementos en el título",
    "Wyloguj": "Cerrar sesión",
    "Przypisane miasta:": "Ciudades asignadas:",
    "Notatka magazyniera": "Nota del almacenista",
    "Wyszukaj blok": "Bloque de búsqueda",
    "Usunięcie": "Eliminación",
    "Nie udało się usunąć użytkownika z czatu": "No se pudo eliminar al usuario del chat",
    "Statystyki regionalne - miasta": "Estadísticas regionales - ciudades",
    "Nazwa konta (Klucz dostępu)": "Nombre de la cuenta (clave de acceso)",
    "Aktywność": "Actividad",
    "Nazwa szkolenia": "Nombre de la formación",
    "Ustawienia sekcji \"%0\"": "Ajustes de sección «»",
    "Id rezerwacji:": "ID de reserva:",
    "Losowa kolejność elementów": "Orden aleatorio de los elementos",
    "Edycja Notatki": "Editar notas",
    "Wstaw z góry": "Insertar desde arriba",
    "Standard 2004": "Estándar 2004",
    "Mieszane": "mezclado",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "",
    "Dodaj serwer": "Agregar servidor",
    "Listopad": "noviembre",
    "obrót": "girar",
    "Dodaj ścieżkę": "Añadir una ruta",
    "Wybierz kategorię": "Seleccione una categoría",
    "Nazwa paczki": "Nombre del paquete",
    "Aktualne urządzenie": "Dispositivo actual",
    "Priorytet": "Prioridad",
    "Edytuj zestaw": "Conjunto de edición",
    "Ustawienia zaawansowane": "Ajustes avanzados",
    "Średnie wynagrodzenie pracownika": "Salario promedio de un empleado",
    "Jedna kolumna": "Columna única",
    "Adres aktywnej strony": "La dirección de la página activa",
    "Noclegi": "Alojamientos",
    "Przypisane regiony:": "Regiones asignadas:",
    "Edytuj dział": "Departamento de edición",
    "Rozmiar zdjęcia został zmieniony.": "Se ha cambiado el tamaño de la foto.",
    "Pole może zawierać jedynie litery i cyfry.": "El campo solo puede contener letras y números.",
    "Moje dokumenty": "Mis documentos",
    "Planowana data wykonania": "Fecha de ejecución prevista",
    "Edycja tagu nieruchomości": "Edición de una etiqueta de propiedad",
    "Otwórz stronę w nowym oknie": "Abrir la página en una ventana nueva",
    "Dodano": "Añadido",
    "Data dodania inwentaryzacji": "Fecha de adición del inventario",
    "Edycja roli": "Editar rol",
    "Dołączanie...": "Uniéndose...",
    "Czy zablokować użytkownika i jego wiadomość?": "¿Bloquear al usuario y su mensaje?",
    "Typ plików jest wymagany": "El tipo de archivos es obligatorio",
    "Ogólne informacje": "Información general",
    "Szerokość": "Anchura",
    "URL": "URL",
    "Edytuj stawkę za godzinę": "Editar tarifa por hora",
    "Lista regulaminów": "Lista de términos y condiciones",
    "Imię gościa": "Nombre del huésped",
    "Przenieś wybrane": "Movimiento seleccionado",
    "Lista ścieżek szkoleniowych": "Lista de itinerarios formativos",
    "Oraz nowe hasło": "Y una nueva contraseña",
    "Dodaj tag nieruchomości": "Añadir etiqueta de propiedad",
    "Zestaw został zaktualizowany.": "El kit se ha actualizado.",
    "Serwer został usunięty.": "Se ha eliminado el servidor.",
    "wybierz szablon": "seleccionar plantilla",
    "Porównaj %0": "Comparar %0",
    "Nie wybrano strony": "Página no seleccionada",
    "Status edytowanej wersji dokumentu": "Estado de la versión editada del documento",
    "Edycja strony": "Editar página",
    "Jestem w pracy": "Estoy en el trabajo",
    "W pracy": "En el trabajo",
    "Poza pracą": "Fuera del trabajo",
    "Status pracy": "Estado laboral",
    "Przejdź do zadania": "Ir a la tarea",
    "Jesteś w pracy. Kliknij, aby ustawić status Poza pracą": "Estás en el trabajo. Haz clic para cambiar a Fuera del trabajo",
    "Jesteś poza pracą. Kliknij, aby ustawić status W pracy": "Estás fuera del trabajo. Haz clic para cambiar a En el trabajo",
    "Zaloguj się loginem i hasłem": "Iniciar sesión con usuario y contraseña",
    "Zakończyć pracę?": "¿Terminar el trabajo?",
    "Masz rozpoczęte zadanie:": "Tienes una tarea en curso:",
    "Po wyłączeniu statusu nie będziesz mógł rozpoczynać zadań.": "Al desactivar el estado no podrás iniciar tareas.",
    "Zakończ pracę": "Terminar el trabajo",
    "Aby rozpocząć zadanie, musisz mieć włączony status \"W pracy\".": "Para iniciar la tarea debes tener activado el estado \"En el trabajo\".",
    "Status zostanie włączony automatycznie, a zadanie rozpocznie się od razu.": "El estado se activará automáticamente y la tarea comenzará de inmediato.",
    "Włącz i rozpocznij zadanie": "Activar e iniciar la tarea",
    "Zadanie pozostanie rozpoczęte. Pamiętaj, aby je zakończyć lub zapauzować.": "La tarea seguirá en curso. Recuerda finalizarla o pausarla.",
    "Nie jesteś w pracy": "No estás en el trabajo",
    "Dopasuj do obrazka": "Ajustar a la imagen",
    "Punkty": "Puntos",
    "Zmień hasło": "Cambiar contraseña",
    "Nie udało się pobrać listy aranżacji": "No se pudo recuperar la lista de arreglos",
    "wybierz": "seleccionar",
    "Opiekun ścieżki": "Guardián del sendero",
    "Powtórz hasło": "Repite la contraseña",
    "Czwartek": "jueves",
    "Nowe hasło": "Contraseña nueva",
    "Dodawanie trasy": "Añadir una ruta",
    "Dodaj trasę": "Añadir ruta",
    "Strona główna": "Página principal",
    "VAT": "",
    "Pokaż etykietę": "Mostrar etiqueta",
    "Data modyfikacji od": "Fecha de modificación desde",
    "Wyrażenia warunkowe": "Expresiones condicionales",
    "Potwierdź zapis do aktualnej wersji": "Confirme que ha guardado en la versión actual",
    "Dział został dodany.": "Se ha agregado el departamento.",
    "Opracowane": "Elaborado",
    "Wysłane wezwanie do zapłaty": "Solicitud de pago enviada",
    "Podpis": "Firma",
    "Data początkowa nie może być późniejsza niż data końcowa": "La fecha de inicio no puede ser posterior a la fecha de finalización",
    "Nieruchomość niestandardowa o Id": "Propiedad personalizada con ID",
    "Dodaj zastępstwo": "Añadir un sustituto",
    "Zastępstwo zostało dodane.": "Se ha agregado un reemplazo.",
    "Planowanie inwentaryzacji": "Planificación del inventario",
    "Kategoria wyszukiwanego matariału": "Categoría del material de búsqueda",
    "Powiadomienia": "Notificaciones",
    "Edycja wynagrodzenia stałego dla:": "Edición del salario fijo para:",
    "Data ostatniej zmiany statusu": "Fecha del último cambio de estado",
    "Aby zakończyć trasę należy uzupełnić stan licznika na koniec": "Para completar la ruta, debe completar el estado del medidor al final",
    "Osoby przypisane jako domyślne do zadań zwiazanych z konserwacją": "Personas asignadas por defecto a las tareas de mantenimiento",
    "Ustawienia ogólne": "Ajustes generales",
    "Pliki zostały dodane": "Se han agregado archivos",
    "Okładka": "Portada",
    "Konserwacja": "Mantenimiento",
    "Publikuj od": "Publicar desde",
    "Do sprawdzenia": "Para comprobar",
    "Pliki prywatne": "Archivos privados",
    "Dodanie linku": "Añadir un enlace",
    "Czas trwania blokady": "Duración del bloqueo",
    "Stwórz nowy czat": "Crear un chat nuevo",
    "Nieopłacone/dłużnik": "Impagado/Deudor",
    "Wyświetl materiały": "Ver materiales",
    "Chat został zarchiwizowany.": "El chat se ha archivado.",
    "Reżyseria": "Dirigiendo",
    "Zablokowano możliwość edycji": "Bloqueó la posibilidad de editar",
    "IBAN": "IBAN",
    "Nie udało się pobrać listy typów modeli": "No se pudo descargar la lista de tipos de modelos",
    "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "La posibilidad de modificar esta cuenta es limitada. Los campos inactivos se sincronizan con la base de datos externa %0.",
    "Nazwa pliku": "Nombre del archivo",
    "Data zakończenia blokady konta": "Fecha de finalización del bloqueo de la cuenta",
    "Kategoria": "categoría",
    "Autor": "autor",
    "Wybierz": "seleccionar",
    "Ilość koordynatorów w regionie": "Número de coordinadores en la región",
    "Lista paczek SCORM": "Lista de paquetes SCORM",
    "Brak modułu": "Sin módulo",
    "Ukończone przez użytkownika o Id": "Completado por usuario o identificador",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "Se ha producido un error de conexión. Asegúrate de tener la conexión a Internet encendida e inténtalo de nuevo.",
    "Zaloguj się na swoje konto": "Inicia sesión en tu cuenta",
    "Wideo": "Vídeo",
    "W zespole od": "En un equipo de",
    "Potwierdzam, zapisz": "Confirmo, guardo",
    "Wróć do logowania": "Volver al inicio de sesión",
    "Suma Wynagrodzeń": "Salarios totales",
    "Grudzień": "diciembre",
    "Najniższy": "El más bajo",
    "Usuń element": "Eliminar artículo",
    "Facturada": "Facturado",
    "Kuchnia": "Cocina",
    "Usunięte przez": "Eliminado por",
    "Rodzaj kosztu": "Tipo de coste",
    "Zastępuje osobę": "Sustituye a una persona",
    "Inspektor": "Inspector",
    "Filtry powiadomień": "Filtros de notificación",
    "Dodaj stronę": "Añadir página",
    "Data ostatniej inwentaryzacji": "Fecha del último inventario",
    "Co 15 minut": "Cada 15 minutos",
    "Dane osobowe": "Datos personales",
    "Dopasowanie": "Coincidencia",
    "Data odrzucenia": "Fecha de rechazo",
    "Formularz zarchiwizowany": "Formulario archivado",
    "Wyzeruj licznik": "Reiniciar contador",
    "Kwota średnia": "Monto promedio",
    "Nie podano nazwy poprzedniej kategorii.": "No se indica el nombre de la categoría anterior.",
    "Dodaj obrazek": "Añadir una imagen",
    "Wybrany język": "Idioma seleccionado",
    "Akceptuj": "Aceptar",
    "Aby rozpocząć trasę należy uzupełnić stan licznika na start": "Para iniciar la ruta es necesario completar el estado del contador de inicio",
    "Stan licznika nie może być wartością ujemną": "El valor del contador no puede ser negativo",
    "Standard nieznany": "Estándar desconocido",
    "Data aktualizacji": "Fecha de actualización",
    "Stwierdzenia": "Declaraciones",
    "Legenda": "leyenda",
    "Przejdź do zadania z notatki": "Ir a la tarea desde la nota",
    "Pokaż tytuł sekcji": "Mostrar título de sección",
    "Trzy kolumny": "Tres columnas",
    "Ścieżka nawigacyjna": "Ruta de navegación",
    "Edytuj test": "Editar prueba",
    "Kontakty - Typ działania": "Contactos - Tipo de actividad",
    "Ten użytkownik nie posiada jeszcze przypisanych miast.": "Este usuario aún no tiene ciudades asignadas.",
    "Osoby przypisane jako domyślne do zadań zwiazanych z inspekcją": "Personas asignadas de forma predeterminada a tareas relacionadas con la auditoría",
    "24 godziny": "24 horas",
    "Inna": "Inna",
    "Szczegóły zdarzenia nr %0": "Detalles del evento #%0",
    "Tytuł strony": "Título de la página",
    "Dodanie formularza": "Agregar un formulario",
    "Wyloguj zalogowanego obecnie użytkownika": "Cierre la sesión del usuario que ha iniciado sesión actualmente",
    "Potwierdzenie archiwizacji": "Confirmación del archivo",
    "Dodaj pliki": "Agregar archivos",
    "źródło zostało usunięte.": "Se ha eliminado la fuente.",
    "Uwzględnij wydziały i statusy jednocześnie": "Incluya facultades y estados a la vez",
    "Włącz system powiadomień": "Habilitar el sistema de notificaciones",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "No se pueden agregar archivos: «%0\". Solo puede agregar archivos del tipo: «%1\".",
    "Wygeneruj plik": "Generar archivo",
    "Nie pokazuj linku do archiwum strony (NoArchive)": "No mostrar un enlace al archivo de la página (NoArchive)",
    "Nazwa roli": "Nombre del rol",
    "Organizacja": "Organización",
    "${title}": "$ {title}",
    "Usuń z trasy": "Eliminar de la ruta",
    "Serwery plików": "Servidores de archivos",
    "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "Puede usar la variable %HEAD_TITLE% en otros campos de texto.",
    "Ten Tydzień": "Esta semana",
    "Element został usunięty.": "Se ha retirado el artículo.",
    "Co 2 tygodnie": "Cada 2 semanas",
    "Co tydzień": "Todas las semanas",
    "Zlecenie": "Pedido",
    "Właściciel został zaktualizowany.": "El propietario ha sido actualizado.",
    "Radio": "radio",
    "Lekcja ukryta": "Lección oculta",
    "Suma wynagrodzeń": "Suma de sueldos",
    "Koordynator*": "Coordinador*",
    "Nie udało się dodać użytkownika do czatu": "No se pudo agregar el usuario al chat",
    "Aktywne": "Activo",
    "Nazwa strony": "Nombre de página",
    "Uwzględniaj tagi": "Incluir etiquetas",
    "Google Nexus 5": "Google Nexus 5",
    "Dodaj media": "Añadir contenido multimedia",
    "Brakujące tytuły kafelków.": "Faltan los títulos de los azulejos.",
    "Kwota pobrana": "Monto recaudado",
    "Ikona wyświetlana jest w postaci kwadratu.": "El icono se muestra en forma de cuadrado.",
    "Edycja aktualności": "Edición de noticias",
    "Dane został wgrane": "Se han cargado los datos",
    "Pokaż cały błąd": "Mostrar todos los errores",
    "Wybrana liczba jest większa niż dozwolona %0.": "El número seleccionado es mayor que el %0 permitido.",
    "Krótki opis": "Breve descripción",
    "Komentarz dotyczący naprawy problemu": "Comente sobre la solución del problema",
    "Strony": "Páginas",
    "Serial telewizyjny": "serie de televisión",
    "Wyszukaj wszędzie": "Busca en todas partes",
    "Hasło (Klucz ukryty)": "Contraseña (clave oculta)",
    "Ustawienia chatów": "Ajustes de chat",
    "Filtr został zapisany": "El filtro se ha guardado",
    "Odpowiedź 3": "Respuesta 3",
    "Edycja serwera": "Edición de servidor",
    "Nie przypisano": "No asignado",
    "Wykonaj akcję": "Ejecuta la acción",
    "Czaty": "Charlas",
    "Dodaj katalog": "Añadir catálogo",
    "Firma została usunięta.": "La empresa ha sido eliminada.",
    "Data wymeldowania do": "Fecha de salida hasta",
    "Konta publiczne": "Cuentas públicas",
    "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "No se ha habilitado ningún canal de comunicación en la configuración de notificaciones.",
    "Pole \"%0\" jest wymagane.": "El campo «%0\" es obligatorio.",
    "Nie udało się pobrać listy stron": "No se pudo descargar la lista de páginas",
    "Jeśli pole jest puste to wstawiana automatycznie.": "Si el campo está vacío, se inserta automáticamente.",
    "Płyta z muzyką": "CD con música",
    "Tagi zadań": "Etiquetas de tareas",
    "Próg zaliczenia (%)": "Umbral de superación (%)",
    "Wybierz autora": "Seleccione el autor",
    "Co 10 dni": "Cada 10 días",
    "Konfiguracja harmonogramu": "Configuración del cronograma",
    "Repozytorium plików": "Repositorio de archivos",
    "Usuń kafelek": "Quitar el azulejo",
    "Musisz najpierw zapisać zmienioną kolejność punktów zanim oznaczysz punkt": "Primero debe guardar el orden modificado de los puntos antes de marcar un punto",
    "Kalendarz pracowników": "Calendario de empleados",
    "Przypisane tagi: ": "Etiquetas asignadas: ",
    "Dodaj Zadanie": "Agregar tarea",
    "Obok siebie": "Lado a lado",
    "Potwierdź wyłączenie publikacji": "Confirme la exclusión de la publicación",
    "Ilość kosztów": "Importe de los costos",
    "Co 6 godzin": "Cada 6 horas",
    "Czat": "Charla",
    "Imię": "Nombre",
    "Kolory rezerwacji": "Colores de reserva",
    "Proszę obciążyć właściciela obiektu": "Por favor, cobre al propietario",
    "Usuń trasę": "Eliminar ruta",
    "Zacznij pisać aby wyszukać właściciela...": "Empieza a escribir para buscar al propietario...",
    "Slajdy": "Diapositivas",
    "Dzielnica nieruchomości": "Distrito inmobiliario",
    "Resetuj": "Reiniciar",
    "Urlop został usunięty": "Se ha eliminado el feriado",
    "Host dodatkowy": "Anfitrión secundario",
    "Komentarz": "Comentario",
    "Status notatki": "Estado de la nota",
    "Witryna została zaktualizowana.": "El sitio se ha actualizado.",
    "Imię i nazwisko": "Nombre y apellidos",
    "Zacznij pisać numer aby wyszukać rezerwację...": "Empieza a escribir el número para buscar una reserva...",
    "Zdecydowanie się zgadzam": "Totalmente de acuerdo",
    "Element został przywrócony.": "El artículo se ha restaurado.",
    "Wymagaj kolejności zaliczania elementów": "Exigir el orden en el que se pasan los elementos",
    "co rok": "cada año",
    "Zajawka": "Un adelanto",
    "Zestaw niestandardowy": "Set personalizado",
    "Edycja lekcji": "Edición de lección",
    "Co minutę": "Cada minuto",
    "Open Graph": "Abrir gráfico",
    "Role i uprawnienia": "Funciones y permisos",
    "Coś poszło nie tak": "Algo salió mal",
    "Data wymeldowania od": "Fecha de salida desde",
    "Nazwa przycisku ``Wyślij``": "Nombre del botón ``Enviar``",
    "Rezerwacje anulowane": "Reservaciones canceladas",
    "Dane": "Datos",
    "zacznij pisać aby wyszukać certyfikat...": "empieza a escribir para buscar un certificado...",
    "Wyżej": "Más alto",
    "Nie udało się pobrać listy zastępstw": "No se pudo recuperar la lista de reemplazos",
    "Id sesji": "ID de sesión",
    "Opłacono": "Pagado",
    "Przekroczono dozwoloną ilość znaków: %0.": "Se supera el número de caracteres permitido: %0.",
    "Inwentaryzacja została zaktualizowana.": "Se ha actualizado el inventario.",
    "Ok": "Ok",
    "Bułgarski": "Búlgaro",
    "Nazwa certyfikatu": "Nombre del certificado",
    "Edycja właściciela": "Edición del propietario",
    "Data rezerwacji do": "Fecha de reserva hasta",
    "Domyślne ustawienie dla witryny": "Configuración predeterminada del sitio",
    "znaki": "señales",
    "Edycja slajdów": "Editar diapositivas",
    "Data Zmiany": "Fecha de cambio",
    "Niżej": "Inferior",
    "Pytanie i odpowiedzi": "Preguntas y respuestas",
    "Wgraj plik": "Cargar archivo",
    "Odpowiedź 1": "Respuesta 1",
    "Przypisani użytkownicy": "Usuarios asignados",
    "Miejsce logowania": "Ubicación de inicio de sesión",
    "Wróć do strony głównej": "Volver a la página principal",
    "Użytkownik Sprzatanie": "Limpieza de usuarios",
    "Laptop 17\"": "Ordenador portátil de 17\"",
    "Ukraiński": "Ucraniano",
    "6 godzin": "6 horas",
    "Koszt został zaktualizowany.": "Se actualizó el costo.",
    "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Especifica desde qué lado se van a añadir más elementos a la ruta.",
    "Imię lub nazwisko właściciela": "Nombre o apellidos del propietario",
    "W zespole od %0": "En un equipo de %0",
    "Adres IP": "Dirección IP",
    "Konfiguracja": "Configuración",
    "Profil użytkownika": "Perfil de usuario",
    "Notatki Koordynatorów": "Notas de los coordinadores",
    "Ilość nocy": "Cantidad de noches",
    "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "Aceptación automática de la versión al llegar a la fecha de publicación. La versión seleccionada debe tener el estado establecido en «Completada»",
    "Trasa została zakończona": "La ruta se ha completado",
    "Czy opublikowany": "Ya sea publicado",
    "Zaakceptowane": "Aceptado",
    "Niewykonane zadania": "Tareas incompletas",
    "Edytuj kolor": "Editar color",
    "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "La notificación es obligatoria de forma predeterminada. No es posible deshabilitar el envío de esta notificación.",
    "Strona lekcji SCORM opublikowana": "Publicada la página de la lección de SCORM",
    "Nieaktywni właściciele": "Propietarios inactivos",
    "Data następnej inwentaryzacji": "Fecha del siguiente inventario",
    "Przetestuj ustawienia poczty": "Probar la configuración del correo",
    "Wszystkie kategorie": "Todas las categorías",
    "Odpowiedzi": "Respuestas",
    "Kalendarz Pracowniczy": "Calendario de empleados",
    "Element": "Elemento",
    "Brak dodanych punktów trasy": "No se han añadido puntos de ruta",
    "Słownik dowolny": "Diccionario arbitrario",
    "Nazwa witryny": "Nombre del sitio",
    "Raporty": "Informes",
    "Dodaj kategorie": "Añadir categorías",
    "Synchronizuj razem z anulowanymi": "Sincronizar junto con cancelado",
    "Pliki zostaną automatycznie dodane do odpowiednich sekcji 'Inne' na podstawie typu pliku.": "Los archivos se añadirán automáticamente a las secciones «Otros» correspondientes según el tipo de archivo.",
    "Pytanie 2": "Pregunta 2",
    "Zrób zdjęcie": "Toma una foto",
    "Numer domu": "Número de casa",
    "Ilość toalet": "Cantidad de baños",
    "Dodaj zadanie: inspekcja": "Añadir tarea: inspección",
    "ID": "CARNÉ DE IDENTIDAD",
    "Przycisk": "Botón",
    "Wysłane powiadomienie": "Notificación enviada",
    "co ma się teraz wydarzyć (jakie jest oczekiwanie gościa)": "qué va a pasar ahora (cuáles son las expectativas del huésped)",
    "Nie udało się zapisać komentarza": "No se pudo guardar el comentario",
    "Powiadomienie o oczekującym szkoleniu": "Notificación de formación pendiente",
    "Pokaż zdjęcie w raporcie": "Mostrar imagen en el informe",
    "zacznij pisać aby wyszukać użytkownika...": "empieza a escribir para buscar un usuario...",
    "Zaznacz": "Mark",
    "Historia zmian": "Historial de cambios",
    "Dodaj nieruchomość do trasy": "Añadir propiedad a la ruta",
    "Rozwiń do": "Expandir a",
    "Wstaw z lewej strony": "Insertar desde la izquierda",
    "Kopiuj filtr": "Filtro de copia",
    "Nieaktywne": "Inactivo",
    "Ilość zadań": "Cantidad de tareas",
    "Hasło zostało zmienione. Zaloguj się ponownie": "Se ha cambiado la contraseña. Vuelva a iniciar sesión",
    "Nazwa wydziału": "Nombre del departamento",
    "Poziomo": "Horizontalmente",
    "Bardzo zadowolony": "Muy satisfecho",
    "Zacznij pisać aby wyszukać...": "Empieza a escribir para buscar...",
    "Nie udało się pobrać danych odnośnie rezerwacji i zadań": "No se pudieron recuperar los datos de la reserva y la tarea",
    "Publikacja została usunięta.": "Se ha eliminado la publicación.",
    "Zlecenie zostało utworzone.": "Se ha creado el pedido.",
    "Podaj adres url...": "Introduzca la URL...",
    "KRS": "KRS",
    "Przedrostek": "Prefijo",
    "Galeria zdjęć": "Galería de fotos",
    "Bloki": "bloques",
    "Pytanie": "Pregunta",
    "Od poziomu": "Desde el nivel",
    "Nie udało się zapisać szablonu": "No se pudo guardar la plantilla",
    "Strona testu opublikowana": "Página de prueba publicada",
    "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "Para añadir usuarios a la formación, primero debe guardar el formulario.",
    "Stworzone przez użytkownika": "Creado por el usuario",
    "Wstaw przycisk": "Botón Insertar",
    "Id checklisty": "ID de la lista de verificación",
    "Region apartamentu": "La región del apartamento",
    "Nie udało się utworzyć zlecenia.": "No se pudo crear el pedido.",
    "5": "5",
    "Bardzo niezadowolony": "Muy insatisfecho",
    "Cron": "Cron",
    "Dzielnica została zaktualizowana.": "El distrito se ha actualizado.",
    "Luty": "Febrero",
    "Włącz social media": "Activa las redes sociales",
    "Monitor aktywności": "Monitor de actividad",
    "Utworzono przez: ": "Creado por: ",
    "Drugie imię": "Segundo nombre",
    "Typ elementu": "Tipo de elemento",
    "Podaj dane autora": "Introduzca los datos del autor",
    "${(ex as any).response.data.errors.message[0]}": "$ {(por ejemplo, como cualquier otro) .response.data.errors.message [0]}",
    "Usuń kategorię": "Eliminar categoría",
    "Po przejściu na mapę zadanie zostanie usunięte.": "Cuando vaya al mapa, la tarea se eliminará.",
    "Typ pola": "Tipo de campo",
    "Opracowanie kosztu": "Desarrollo de costos",
    "Dodanie miasta": "Añadir una ciudad",
    "Katalog linków": "Directorio de enlaces",
    "Przypisani użytkownicy:": "Usuarios asignados:",
    "Elementy": "Elementos",
    "Dane wydziału zostały dodane.": "Se han agregado los datos del cuerpo docente.",
    "Zapisz": "Guardar",
    "Kwota kosztu od": "Importe del coste desde",
    "Pobierz plik": "Descargar archivo",
    "Data wznowienia": "Fecha de reanudación",
    "zacznij pisać aby wyszukać szkolenie...": "empieza a escribir para buscar formación...",
    "Imię klienta": "Nombre del cliente",
    "Opis obrazka": "Descripción de la imagen",
    "Edycja ustawień wynagrodzenia dla:": "Editar la configuración salarial para:",
    "Usuń obrazek": "Eliminar imagen",
    "Wymagane": "Necesario",
    "Lista jest pusta": "La lista está vacía",
    "Porównywana wersja": "Versión comparable",
    "Edytuj lekcje SCORM": "Editar lecciones de SCORM",
    "Zacznij pisać aby wyszukać region...": "Empieza a escribir para buscar la región...",
    "Nazwisko i Imię": "Apellidos y nombre",
    "Region został usunięty": "Se ha eliminado la región",
    "Stwórz zadanie z notatki": "Crear una tarea a partir de una nota",
    "Dostępne języki": "Idiomas disponibles",
    "Edytuj sekcję": "Sección de edición",
    "Wybierz dział": "Seleccione departamento",
    "Usuń slajd": "Eliminar diapositiva",
    "Lista certyfikatów": "Lista de certificados",
    "Niestandardowy adres strony": "Dirección de página personalizada",
    "Dodatkowe wynagrodzenie - komentarz": "Salario adicional - comentario",
    "Nazwa slajdu": "Nombre de la diapositiva",
    "Data utworzenia do": "Fecha de creación hasta",
    "Ten zespół nie posiada jeszcze żadnych członków.": "Este equipo aún no tiene miembros.",
    "Harmonogram": "Programar",
    "Za przepracowane godziny": "Por horas trabajadas",
    "Wynagrodzenie PLN brutto": "Salario en PLN brutos",
    "Symbol": "Símbolo",
    "Zaznacz wszystko ": "Marcar todos ",
    "Witryna została dodana.": "Se ha agregado el sitio.",
    "Lista punktów": "Lista de puntos",
    "Środa": "miércoles",
    "Zwierzątko": "Mascota",
    "Są to wszystkie obiekty, nawet te, które posiadają już właściciela.": "Todos estos son objetos, incluso aquellos que ya tienen un propietario.",
    "Ukryj filtry": "Ocultar filtros",
    "Typ zestawu": "Tipo de kit",
    "Edycja certyfikatu": "Edición de certificado",
    "Wpisz kwotę": "Introduce el importe",
    "Testowy adres email": "Dirección de correo electrónico de prueba",
    "Szablon": "Esténcil",
    "Wynagrodzenie stałe miesięczne": "Salario mensual fijo",
    "Udało się zaktualizować zadania!": "¡Las tareas se actualizaron correctamente!",
    "Ostateczne wynagrodzenie:": "Salario final:",
    "Nie udało się dodać pliku typu ": "No se pudo agregar el tipo de archivo ",
    "Nieruchomość została dodana.": "Se ha añadido la propiedad.",
    "Standard": "Estándar",
    "E-mail": "Correo electrónico",
    "Miesiąc edycji wynagrodzenia": "Mes de edición de salario",
    "Edytuj lekcje wideo": "Edición de lecciones en vídeo",
    "Edycja trasy": "Editar ruta",
    "Powrót do historii": "Volver a la historia",
    "Nazwa domyślnej checklisty": "Nombre predeterminado de la lista de verificación",
    "Moje zadania": "Mis tareas",
    "Link został usunięty.": "Se ha eliminado el enlace.",
    "Ustawienia": "Ajustes",
    "Nie udało się dodać miasta lub dzielnicy": "No se pudo agregar la ciudad o el distrito",
    "Dodaj lekcję Wideo": "Añadir lección en vídeo",
    "Apple iPad": "iPad de Apple",
    "Nie ma żadnych etykiet dla wybranej daty": "No hay etiquetas para la fecha seleccionada",
    "Sekcja została usunięta": "Se ha eliminado la sección",
    "Zdjęcie główne": "Foto principal",
    "Aktualność została zaktualizowana.": "Se ha actualizado la actualidad.",
    "Liczba pracowników w regionie": "Número de empleados en la región",
    "Slajd został usunięty.": "Se quitó la diapositiva.",
    "Notatka została usunięta.": "Se ha eliminado la nota.",
    "Filtry map": "Filtros de mapas",
    "Wysłane": "Enviado",
    "Pole może zawierać jedynie litery.": "El campo solo puede contener letras.",
    "Nie udało się pobrać listy kolejek": "No se pudo recuperar la lista de colas",
    "Stack Trace": "Stack Trace",
    "Stwierdzenie": "Afirmación",
    "Data utworzenia zadania": "Fecha en que se creó la tarea",
    "Wyczyść filtry": "Borrar filtros",
    "Zobacz szczegóły zdarzenia": "Ver detalles del evento",
    "Ustawienia Domyślne": "Configuración predeterminada",
    "Firma została dodana.": "Se ha añadido la empresa.",
    "Całkowity dystans (km)": "Distancia total (km)",
    "Checklista została zaktualizowana.": "La lista de verificación se ha actualizado.",
    "Brak kategorii nadrzędnej": "Sin categoría principal",
    "Przyjazd": "llegada",
    "Wyczyść defaultowych użytkowników": "Borrar usuarios predeterminados",
    "Automatyczna akceptacja": "Aceptación automática",
    "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Solo se pueden editar las plantillas de canales habilitadas y compatibles.",
    "Liczba szkoleń w ścieżce": "Número de entrenamientos en la pista",
    "Data wyjazdu": "Fecha de salida",
    "Dodanie zestawu regulaminów": "Añadir un conjunto de términos y condiciones",
    "Kategoria materiałów": "Categoría de materiales",
    "Edytuj slajder": "Editar control deslizante",
    "Szukana fraza": "Frase buscada",
    "Punkt został oznaczony": "El punto ha sido marcado",
    "Akcje": "comparte",
    "Wstaw cztery kolumny 1/4": "Inserte cuatro columnas de 1/4",
    "Podsumowanie": "resumen",
    "Miesiące": "Meses",
    "Marketing": "Mercadeo",
    "Co 4 miesiące": "Cada 4 meses",
    "Wyrażone zgody": "Consentimiento otorgado",
    "Sierpień": "agosto",
    "Potwierdzenie zmiany statusu": "Confirmación del cambio de estado",
    "Film": "Película",
    "Wymagane jest wybranie źródła danych": "Es necesario seleccionar una fuente de datos",
    "Obciążenie Gościa": "Carga de invitados",
    "Numer rezerwacji Avantio": "Número de reserva Avantio",
    "Nie udało się pobrać listy wydziałów": "No se pudo descargar la lista de profesores",
    "Pozycja": "Posición",
    "Strona ukryta": "Página oculta",
    "wybierz...": "seleccionar...",
    "Certyfikat został zaktualizowany.": "Se ha actualizado el certificado.",
    "Wybrana ikona powinna być kwadratem": "El icono seleccionado debe ser un cuadrado",
    "Wybierz serwer": "Seleccione un servidor",
    "Zarządzaj zespołami": "Gestiona equipos",
    "Zwrócony": "Devuelto",
    "Wiadomość została ukryta.": "El mensaje estaba oculto.",
    "Kolor trasy": "Color de ruta",
    "Potwierdzenie przywrócenia": "Confirmación de la restauración",
    "Data nieobecności do": "Fecha de ausencia hasta",
    "Dowolna data": "Cualquier fecha",
    "Zmiana hasła": "Cambio de contraseña",
    "Pole \"Drugie imię\" jest wymagane.": "El campo «Segundo nombre» es obligatorio.",
    "Resetuj filtry": "Restablecer filtros",
    "Zaawansowane": "Avanzado",
    "Nie możesz wpływać na kolejność punktów już oznaczonych jako odwiedzone": "No puede influir en el orden de los puntos ya marcados como visitados",
    "Automatyczny": "automática",
    "Aktywne kanały komunikacji": "Canales de comunicación activos",
    "Nieruchomość została usunięta.": "Se ha retirado la propiedad.",
    "ID lub typ zadania": "ID o tipo de tarea",
    "Tło przycisku": "Fondo del botón",
    "Lista koordynatorów": "Lista de coordinadores",
    "Lekcja wideo została dodana.": "Se ha añadido una lección en vídeo.",
    "Nie znaleziono żadnych wyników.": "No se han encontrado resultados.",
    "Back Office": "Oficina administrativa",
    "Szkolenie rozpoczyna się": "Comienza la formación",
    "Nazwa grupy": "Nombre del grupo",
    "ŚREDNIA": "PROMEDIO",
    "Niemiecki": "alemán",
    "Data akceptacji": "Fecha de aceptación",
    "Wymiary": "Dimensiones",
    "Liczba pracowników pracujących w więcej niż jednym regionie": "Número de empleados que trabajan en más de una región",
    "Ostatnia aktywność": "Actividad reciente",
    "Dodaj wszystkie z kategorii": "Agregar todo de la categoría",
    "Widoczność": "Visibilidad",
    "Uwzględniaj nieruchomości": "Tenga en cuenta los bienes inmuebles",
    "Host": "Hospedadores",
    "Id zdarzenia": "ID de evento",
    "Długość": "Longitud",
    "Rok": "Año",
    "Dodaj nowy": "Añadir nuevo",
    "Edycja wynagrodzenia": "Edición de salario",
    "słowa": "palabras",
    "Wersje": "Versiones",
    "Dodanie": "Entrega",
    "Zablokowany": "Bloqueado",
    "Więcej...": "Más...",
    "Dodaj zdjęcia do wiadomości": "Añadir fotos al mensaje",
    "Ten punkt został już odwiedzony": "Este punto ya ha sido visitado",
    "Dodaj premię": "Añadir bonificación",
    "Płeć": "Género",
    "Dodaj link": "Añadir un enlace",
    "Zespół został dodany.": "Se ha agregado el equipo.",
    "Przejdź do mapy": "Ir al mapa",
    "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "No mostrar una descripción breve de la página en los resultados de búsqueda (NoSnippet)",
    "Opublikowany": "Publicado",
    "Data rezerwacji od": "Fecha de reserva desde",
    "Porównaj z edytowaną wersją": "Comparar con la versión editada",
    "Symbol lekcji": "Símbolo de lección",
    "Numer aktywnej strony": "Número de página activo",
    "Wpis został zaktualizowany.": "La entrada se ha actualizado.",
    "Co miesiąc": "Todos los meses",
    "Sprawdzenie czy pusty": "Comprueba si está vacío",
    "Właściciel został dodany.": "Se ha añadido el propietario.",
    "Pracownicy": "Empleados",
    "Historia zadania": "Historia de la tarea",
    "Nieobecność od": "Ausencia de",
    "Kategoria została zaktualizowana.": "La categoría se ha actualizado.",
    "Całkowity czas": "Tiempo total",
    "Przetwarzane": "Procesado",
    "Data zmiany statusu do": "Fecha de cambio de estado a",
    "Przejdź do Checklisty": "Ir a la lista de verificación",
    "Slajder został zaktualizowany.": "Se ha actualizado el control deslizante.",
    "Kwota rezerwacji": "Importe de la reserva",
    "Wybierz język": "Selecciona idioma",
    "Zacznij pisać aby wyszukać miasto...": "Empieza a escribir para buscar una ciudad...",
    "Element opublikowany": "Artículo publicado",
    "30 minut": "30 minutos",
    "Dodanie roli": "Añadir un rol",
    "Lekcja została zaktualizowana.": "La lección se ha actualizado.",
    "Wysyłaj tym kanałem": "Enviar por este canal",
    "Zmień kolejność punktów": "Cambiar el orden de los puntos",
    "Prywatne": "Privada",
    "Pojedynczy artykuł (strona opisowa)": "Artículo único (página de descripción)",
    "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "Para añadir usuarios a la ruta de formación, primero debe guardar el formulario.",
    "Wszystkie obiekty:": "Todos los objetos:",
    "Inwentaryzaje": "Inventario",
    "Typ slajdu": "Tipo de diapositiva",
    "brak danych": "sin datos",
    "Regulaminy": "Términos y condiciones",
    "Usuń wszystkie tagi": "Eliminar todas las etiquetas",
    "Dodanie działu": "Añadir un departamento",
    "Ustawienia slajdera": "Configuración del control deslizante",
    "Zmień nazwę": "Cambiar nombre",
    "Exclusivity": "Exclusividad",
    "Resetowanie podejść użytkowników": "Restablecer los enfoques de los usuarios",
    "Dodaj nieruchomość": "Añadir propiedad",
    "Domyślna wartość": "Valor predeterminado",
    "Powiadomienie o zmianach": "Notificación de cambios",
    "Nie udało się zaktualizować zlecenia.": "No se pudo actualizar el pedido.",
    "Wyliczenie stawki godzinowej (statystyczna)": "Cálculo de la tarifa por hora (estadística)",
    "Link do strony": "Enlace al sitio",
    "Zacznij pisać aby wyszukać zaopatrzenie...": "Empieza a escribir para buscar suministros...",
    "Poprawne": "Correcto",
    "Zapisz trasę": "Guarda la ruta",
    "Rodzaj odpowiedzi": "Tipo de respuesta",
    "Upload": "Subiendo",
    "Data dodania kosztu": "Fecha de costo agregado",
    "Właściciel": "propietaria",
    "Etykiety": "Etiquetas",
    "Typ rezerwacji": "Tipo de reserva",
    "${ex.data.errors.symbol[0]}": "$ {ex.data.errors.symbol [0]}",
    "Odznacz wszystkie": "Desmarcar todo",
    "Anuluj": "cancelar",
    "Treści odpowiedzi są wymagane": "El contenido de la respuesta es obligatorio",
    "Rezerwacja właścicielska": "Reserva de propiedad",
    "Publikacja została zmieniona.": "Se ha modificado la publicación.",
    "Wczutuję...": "Puedo sentir...",
    "Tłumacz checklistę": "Traducir la lista de verificación",
    "Koszt dla nieruchomości roboczej": "Costo de la propiedad en funcionamiento",
    "Załączone zdjęcia": "Fotos adjuntas",
    "Źródło URL": "URL de origen",
    "Wstęp": "Introducción",
    "Dane wydziału zostały zaktualizowane.": "Se han actualizado los datos del profesorado.",
    "Kopiuj numer rezerwacji": "Copiar número de reserva",
    "Wymagaj znaków specjalnych w hasłach": "Requerir caracteres especiales en las contraseñas",
    "Wybór kategorii": "Selección de categoría",
    "Aktywni": "Activo",
    "Wpis został dodany.": "Se ha añadido la entrada.",
    "zacznij pisać aby wyszukać slajder...": "empieza a escribir para buscar el slider...",
    "Szczegóły": "Detalles",
    "Brak historii zmian": "",
    "po %0 nieudanych próbach logowania": "después de %0 intentos fallidos de inicio de sesión",
    "Nazwa źródła danych": "Nombre de la fuente de datos",
    "Nazwa ulicy (StreetName)": "Nombre de la calle (StreetName)",
    "Odpowiedź 2": "Respuesta 2",
    "Administracja - Zespoły": "Administración - Equipos",
    "Użytkownik posiada pełne uprawnienia": "El usuario tiene todos los derechos",
    "Liczba inspektorów": "Número de inspectores",
    "Godzina wykonania": "Hora de ejecución",
    "Pokaż szczegóły": "Mostrar detalles",
    "Wszyscy": "todos",
    "Urlop został zaktualizowany.": "El feriado se ha actualizado.",
    "Aktualności ze strony": "Noticias del sitio",
    "Miasto zostało dodane.": "Se ha añadido la ciudad.",
    "(AirBnb) Wysłano żądanie do portalu": "(AirBnB) Se ha enviado una solicitud al portal",
    "Widoczny obszar": "Área visible",
    "ZMIANA": "CAMBIAR",
    "REGON": "REGON",
    "Kanały włączone w ustawieniach aplikacji": "Canales habilitados en la configuración de la aplicación",
    "Edycja użytkownika": "Edición de usuario",
    "Wyłącz powiadomienia": "Desactivar las notificaciones",
    "Zresetuj hasło": "Restablecer contraseña",
    "Wstecz": "Atrás",
    "Załącz zdjęcia": "Adjuntar fotos",
    "Edycja regulaminu": "Edición de los términos y condiciones",
    "Nieruchomości (Data przyjazdu)": "Bienes inmuebles (fecha de llegada)",
    "Nazwa bloku": "Nombre del bloque",
    "Wartość musi być liczbą dodatnią": "El valor debe ser un número positivo",
    "Fiirma została zaktualizowana.": "Firma se ha actualizado.",
    "Przypisane miasta do regionu:": "Ciudades asignadas a la región:",
    "Imie i nazwisko właściciela": "Nombre y apellidos del propietario",
    "Nazwa działu": "Nombre del departamento",
    "Hasło do sieci Wi-Fi": "Contraseña de Wi-Fi",
    "Etykieta": "Etiqueta",
    "Udostępnij": "Compartir",
    "Cancelled by owner": "Cancelado por el propietario",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "¿Está seguro de que desea eliminar los archivos seleccionados?",
    "Wyświetl również zarchiwizowane formularze": "Ver también los formularios archivados",
    "jeśli potrzebny jest kontakt, podaj z kim i kiedy oraz dane kontaktowe, jeśli różnią się od tych z rezerwacji": "si es necesario ponerse en contacto, indique con quién y cuándo y los datos de contacto si son diferentes a los de la reserva",
    "Potwierdzenie usunięcia. Usunięcie tematu spowoduje usunięcie przypisanych do niego lekcji": "Confirmación de la eliminación. Al eliminar un tema, se eliminarán las lecciones que se le hayan asignado",
    "Kod HTML": "Código HTML",
    "Uprawnienia użytkownika": "Permisos de usuario",
    "Wybrane regulaminy:": "Regulaciones seleccionadas:",
    "Kategoria materiału": "Categoría de material",
    "Grupa": "grupo",
    "Under request": "En proceso de solicitud",
    "Dodanie ankiety": "Agregar una encuesta",
    "Liczba pracowników": "Número de empleados",
    "Dodaj zlecenie": "Añadir pedido",
    "Wpisz komentarz...": "Escribe un comentario...",
    "Komunikat walidacji": "Mensaje de validación",
    "Publikuj na stronie": "Publicar en el sitio",
    "Wpisz nazwę regionu...": "Introduzca el nombre de la región...",
    "Błędne": "Erróneo",
    "Zasięg": "Cobertura",
    "Język:": "Idioma:",
    "Publikacja priorytetowa": "Publicación prioritaria",
    "Ukryj przycisk": "Botón Ocultar",
    "Pole \"Tytuł\" jest wymagane.": "El campo «Título» es obligatorio.",
    "Pralnia": "Lavandería",
    "Zdjęcie": "Foto",
    "Test został dodany.": "Se ha agregado la prueba.",
    "Ostatnia wiadomość - użytkownik": "Último mensaje: usuario",
    "Elementy inwentaryzacji": "Artículos de inventario",
    "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "El certificado se prepara en formato A4. La vista previa que se muestra es solo una vista de trabajo. El aspecto final del certificado se vinculará a los datos pertinentes de formación y usuario.",
    "Przypisane miasta": "Ciudades asignadas",
    "Ponów zadanie": "Reanudar tarea",
    "UWAGA! Nieruchomość jest już przypisana od innego właściciela": "ATENCIÓN! La propiedad ya está asignada por otro propietario",
    "Wszystkie niezapisane zmiany zostaną utracone.": "Se perderán todos los cambios no guardados.",
    "Szablon nr 3": "Plantilla nº 3",
    "Usuń zaznaczone": "Eliminar lo seleccionado",
    "Aranżacja utowrzona przez": "Arreglo creado por",
    "Osoba zastępująca": "Substituto",
    "Kanały komunikacji": "Canales de comunicación",
    "Nazwa nieruchomości": "Nombre de la propiedad",
    "Kroki": "Pasos",
    "Dodaj lekcję SCORM": "Agregar lección SCORM",
    "Strona została usunięta.": "Se ha eliminado la página.",
    "Osoba przypisana do zadania": "Persona asignada a la tarea",
    "Pokaż czat": "Mostrar chat",
    "Dostępy": "Accesos",
    "Powiększ": "Ampliar",
    "Filtr globalny": "Filtro global",
    "Uzupełnij dane dotyczące szkolenia": "Complete los datos de entrenamiento",
    "Brak kluczy": "Sin llaves",
    "Polski": "Polaco",
    "Cztery kolumny": "Cuatro columnas",
    "Avantio ID nieruchomości": "ID de propiedad de Avantio",
    "Wybierz kierowce": "Elige un conductor",
    "Szkolenie": "Entrenamiento",
    "Przeciągnij do innej sekcji": "Arrastrar a otra sección",
    "Brak zadań": "Sin tareas",
    "Edycja poradnika": "Edición de la guía",
    "Zlecenie zostało usunięte.": "Se ha eliminado el pedido.",
    "Opis zadania": "Descripción de la tarea",
    "Pliki do wysłania: %0": "Archivos para cargar: %0",
    "Nie podano nazwy poprzedniego elementu.": "No se especifica el nombre del elemento anterior.",
    "Ta nieruchomość już posiada takie wyposażenie.": "Esta propiedad ya cuenta con este tipo de equipamiento.",
    "OwnerService": "Servicio al propietario",
    "Przyznaj dostęp": "Otorgar acceso",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "Aún no se ha asignado ningún equipo a la ruta de entrenamiento.",
    "Ładuję zgłoszenia...": "Cargando envíos...",
    "Wstaw kontrolkę": "Insertar control",
    "Top kosztów wg miast": "Los mejores costos por ciudad",
    "Nieprawidłowy adres email": "Correo electrónico no válido",
    "Potwierdź wyczyszczenie logów": "Confirme la limpieza de los registros",
    "Brak przypisanych użytkowników.": "No hay usuarios asignados.",
    "Nie znaleziono szczegółów zmiany": "No se ha encontrado ningún detalle de cambio",
    "Wybierz pliki do dodania": "Seleccione los archivos para agregar",
    "Witryna domyślna": "Sitio predeterminado",
    "Ścieżka szkoleniowa": "Ruta formativa",
    "Generuj PDF": "Generar PDF",
    "Dodanie etykiety": "Añadir una etiqueta",
    "Brudne": "sucio",
    "Nr nieruchomości Guesty": "Nº de propiedad Invitado",
    "Ta czynność została wykonana przez kogoś innego. Odśwież aplikację.": "Esta acción la llevó a cabo otra persona. Actualiza la aplicación.",
    "Poprzedni miesiąc": "Mes anterior",
    "Nieaktywna": "Inactivo",
    "Strona": "Pagina",
    "Rejestracja konta": "Registro de cuenta",
    "Nie udało się pobrać listy bloków": "No se pudo obtener la lista de bloqueos",
    "Nowa data": "Nueva fecha",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "Inserte dos columnas 2/3 y 1/3",
    "Typ plików": "Tipo de archivo",
    "Edycja etykiety": "Editar la etiqueta",
    "Publikuj certyfikat": "Publicar certificado",
    "Kategoria linku": "Categoría de enlace",
    "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "Una lista de los permisos de usuario en vigor derivados de los permisos y funciones individuales.",
    "Nazwa płyty": "Nombre del disco",
    "Obojętny": "Indiferente",
    "Twoje hasło wygasło. Zmień je na nowe.": "Tu contraseña ha caducado. Cámbielos por otros nuevos.",
    "Liczba dni co ile wysyłane jest powiadomienie": "Número de días en que se envía cada notificación",
    "Nazwa slajdera": "Nombre del slider",
    "Token": "Fichas",
    "Ukryj przypisane zadania": "Ocultar tareas asignadas",
    "Baza danych tego klienta jest nieaktualna. Uruchom aktualizację za pomocą przycisku na dole formularza.": "La base de datos de este cliente está desactualizada. Ejecute la actualización con el botón situado en la parte inferior del formulario.",
    "Typ szablonu": "Tipo de plantilla",
    "Dodaj element": "Añadir artículo",
    "Edycja witryny": "Edición de tu sitio",
    "${StatusName(StatusEnum[this.form.bookingType])}": "$ {statusName (statusEnum [this.form.bookingType])}",
    "Bardzo źle": "Muy mal",
    "Przywrócić użytkownika i jego wiadomości?": "¿Restaurar al usuario y sus mensajes?",
    "Kolor tła": "Color de fondo",
    "Administracja": "Administración",
    "Status regulaminu został zmieniony.": "Se ha modificado el estado de las reglas.",
    "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Agregue un nuevo directorio para comenzar a administrar las páginas.",
    "Szef regionu": "Jefe de la región",
    "Zadanie znajduje się na trasach:": "La tarea se encuentra en las rutas:",
    "Ilość": "cantidad",
    "Średnio": "Mediano",
    "Logowanie zakończyło się niepowodzeniem.": "No se pudo iniciar sesión.",
    "Opisy": "Descripciones",
    "Wybierz zaznaczone": "Selecciona el seleccionado",
    "Stałe/miesięczne": "Fijo/Mensual",
    "Wydział / Rola": "Facultad/rol",
    "Trasa została zapauzowana": "La ruta se ha pausado",
    "Wybierz typy powiadomień, które chcesz wyłączyć:": "Selecciona los tipos de notificaciones que deseas deshabilitar:",
    "Wysłano kolejne powiadomienie": "Se ha enviado otra notificación",
    "Wybierz punkt": "Selecciona un punto",
    "Regiony": "Regiones",
    "Użytkownik został dodany do zespołu.": "El usuario se ha agregado al equipo.",
    "Źródło danych zostało zaktualizowane.": "Se actualizó la fuente de datos.",
    "Przesuń na dół": "Ir a la parte inferior",
    "Pliki zostały usunięte": "Se han eliminado los archivos",
    "Laptop 15\"": "Ordenador portátil de 15 pulgadas",
    "Zobacz sesję użytkownika": "Ver sesión de usuario",
    "Kwota": "Monto",
    "Konto publiczne": "Cuenta pública",
    "Wpis przeczytany": "Publicación leída",
    "Słowa kluczowe": "Palabras clave",
    "Szef Regionu": "Jefe de la región",
    "Dane kosztu": "",
    "Wartość musi być liczbą całkowitą": "El valor debe ser un entero",
    "Początek długości geograficznej użytkownika": "El inicio de la longitud del usuario",
    "Akcja": "Acción",
    "Ukryj już zaplanowane punkty": "Ocultar puntos ya programados",
    "Właściciel aktywny": "Propietario activo",
    "Zmień daty publikacji": "Cambiar fechas de publicación",
    "Wybierz certyfikat": "Elige un certificado",
    "Zawsze": "siempre",
    "Typ dodanego kosztu": "Tipo de coste añadido",
    "Nie zdefiniowano żadnych sekcji.": "No hay secciones definidas.",
    "Powiązania z dzielnicą": "Conexiones con el distrito",
    "Dodaj sekcję": "Añadir una sección",
    "Wpisz nazwę dzielnicy...": "Introduzca el nombre del distrito...",
    "Sortuj po": "Ordenar por",
    "Informacje": "información",
    "Blok został usunięty.": "Se ha eliminado el bloqueo.",
    "Do sprawdzenia - przeniesione": "Para comprobar - mover",
    "Potwierdzenie usunięcia": "Confirmación de la eliminación",
    "Wybór listy stron": "Selección de una lista de páginas",
    "zacznij pisać aby wyszukać zespół...": "empieza a escribir para buscar un equipo...",
    "Miasta": "Municipios",
    "Lista nieruchomości": "Listado de propiedades",
    "Nie podano odpowiedzi dla ostatniego elementu.": "No se dio ninguna respuesta para el último elemento.",
    "Mężczyzna": "hombre",
    "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "El campo «%0\" no contiene una URL válida.",
    "zaznacz wszystko": "comprobar todo",
    "Metadane": "Metadatos",
    "Tag został usunięty.": "Se ha quitado la etiqueta.",
    "Adres 2": "Dirección 2",
    "Wartość domyślna": "Valor predeterminado",
    "Brak zadania": "Sin tarea",
    "Dodanie certyfikatu": "Agregar un certificado",
    "Dokument": "Documento",
    "Nazwa linku": "Nombre del enlace",
    "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Solo letras minúsculas, sin caracteres especiales, números ni espacios.",
    "Nazwa nieruchomości roboczej": "Nombre de la propiedad en funcionamiento",
    "Generuję plik...": "Generando un archivo...",
    "Opcje": "Opciones",
    "Imie i nazwisko osoby, która dodawała koszty": "Nombre y apellidos de la persona que agregó los costos",
    "Pozostało %0 znaków.": "Quedan %0 caracteres.",
    "Nie udało się zmienić statusu zadania": "No se pudo cambiar el estado de la tarea",
    "Kwota brutto": "",
    "Treść certyfikatu": "Contenido del certificado",
    "Nazwa katalogu": "Nombre del catálogo",
    "Laptop 15,6\"": "Portátil de 15,6 pulgadas",
    "Dokument nie ma ustawionej daty publikacji.": "El documento no tiene una fecha de publicación establecida.",
    "Wstaw dwie równe kolumny": "Inserte dos columnas iguales",
    "Zastępstwo": "Substitución",
    "Ma dzisiaj": "Tiene hoy",
    "Grafik pracowniczy": "Programador de empleados",
    "Adres": "Dirección",
    "Narzędzia": "Herramientas",
    "Wersja": "",
    "Strona dostępna dla wszystkich": "Sitio web accesible para todos",
    "Pionowo": "Verticalmente",
    "Dziś": "Hoy",
    "Edycja szkolenia": "Edición de entrenamiento",
    "Odejmowanie": "Sustracción",
    "Kolor": "color",
    "Symbol testu": "Símbolo de la prueba",
    "Brak daty": "Sin fecha",
    "Obciążenie Magazyn": "Carga de almacén",
    "Kwota za zadania": "Importe para tareas",
    "Odpowiedź 4": "Respuesta 4",
    "Adres e-mail": "Dirección de correo electrónico",
    "Zapisz i wróć": "Guardar y devolver",
    "Wiadomość": "Mensaje",
    "Lipiec": "julio",
    "Typ nieruchomości": "Tipo de propiedad",
    "Koordynator HK": "Coordinadora HK",
    "Obciążenie Właściciela": "La carga del propietario",
    "Host główny": "Anfitrión principal",
    "Dodaj kafelek": "Añadir un mosaico",
    "Dodanie zastępstwa": "Añadir un sustituto",
    "Data usunięcia": "Fecha de borrado",
    "Test został zaktualizowany.": "La prueba se ha actualizado.",
    "Edytuj katalog": "Editar catálogo",
    "Zapomniałeś hasła?": "¿Has olvidado tu contraseña?",
    "Zadanie zostało ukończone przez kogoś z Twojego zespołu.": "Alguien de tu equipo completó la tarea.",
    "Niski": "baja",
    "Domyślny czas rezerwacji": "Hora de reserva predeterminada",
    "Stwórz czat z zadania": "Crear un chat a partir de una tarea",
    "Zakończone": "Completado",
    "Ścieżka": "Ruta",
    "Not Available": "No disponible",
    "Firma": "Firma",
    "Wybór koloru jest wymagany": "Se requiere la elección del color",
    "Typ konta": "Tipo de cuenta",
    "Dodanie szablonu": "Añadir una plantilla",
    "Dodaj szablon": "Agregar plantilla",
    "Docelowa strona": "Página de destino",
    "Dodanie serwera": "Agregar un servidor",
    "Włączenie protokołu SSL dla tej witryny": "Habilitar SSL para este sitio",
    "Test ukryty": "Prueba oculta",
    "Wyszukaj użytkownika": "Búsqueda de usuario",
    "Zespoły": "Equipos",
    "Miesiąc": "mes",
    "Załączniki": "Apéndices",
    "Zgłoszenie serwisowe": "Solicitud de servicio",
    "Konta prywatne": "Cuentas privadas",
    "Inspekcje": "Inspecciones",
    "Brak wersji": "Sin versión",
    "Anuluj i wyjdź z kreatora": "Cancelar y salir del asistente",
    "Wyszukuję...": "Estoy buscando...",
    "Marzec": "marzo",
    "Filtry globalne": "Filtros globales",
    "Zadanie zostało dodane.": "Se ha agregado la tarea.",
    "Dodawanie": "Adición",
    "Dane dostępowe": "Datos de acceso",
    "Data zakończenia od": "Fecha de finalización desde",
    "Nie możesz edytować tego punktu. Został on już oznaczony jako odwiedzony": "No puede editar este punto. Ya se ha marcado como visitado",
    "Przenieś do sekcji": "Ir a la sección",
    "Adres url": "URL",
    "Numer rezerwacji": "Número de reserva",
    "usunięto dzielnice": "barrios retirados",
    "edycja": "edición",
    "Wyszukaj nieruchomość...": "Buscar propiedad...",
    "reset": "restablecer",
    "Nie udało się pobrać listy działów": "No se pudo descargar la lista de departamentos",
    "Nie wybrano obrazu.": "No se ha seleccionado ninguna imagen.",
    "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Selecciona el tipo de notificación para ver las claves disponibles.",
    "Wybierz inspektora": "Seleccione un inspector",
    "Notatka/Komentarz": "Nota/comentario",
    "Nie podano wymaganej ilości znaków: %0.": "No se especificó el número de caracteres requerido: %0.",
    "Dodaj urlop": "Añadir vacaciones",
    "Wynagrodzenia HK": "Salarios de Hong Kong",
    "Gotowe": "terminado",
    "Wykonane zadania": "Tareas completadas",
    "Przywrócić wiadomość?": "¿Restaurar el mensaje?",
    "5 minut": "5 minutos",
    "Get it on Google Play": "Consíguelo en Google Play",
    "Nazwa klienta": "Nombre del cliente",
    "Zlecenie zostało zaktualizowane.": "El pedido se ha actualizado.",
    "SUMA": "SUMA",
    "Edytuj obraz": "Editar imagen",
    "Nazwa tagu": "Nombre de etiqueta",
    "Typ powiadomienia": "Tipo de notificación",
    "Nie podano nazwy tytułu.": "No se indica el nombre del título.",
    "Komentarz został zapisany": "Se ha guardado el comentario",
    "Właściwości": "Propiedades",
    "Usuń datę": "Eliminar fecha",
    "Wystąpił problem z dostępem do kamery": "Se ha producido un problema con el acceso a la cámara",
    "Ulica": "Calle",
    "Ukryj czat": "Ocultar chat",
    "Minimalna długość hasła": "Longitud mínima de la contraseña",
    "Nie masz uprawnień do panelu administracyjnego.": "No tienes permisos para acceder al panel de administración.",
    "Ilość gości": "Número de huéspedes",
    "Zawartość": "contenido",
    "checklista": "lista de verificación",
    "Nie wybrano żadnej strony.": "No se ha seleccionado ninguna página.",
    "Styczeń": "enero",
    "Progress Gotowości": "Preparación para el progreso",
    "Szablon nr 2": "Plantilla nº 2",
    "Facebook Admins": "Administradores de Facebook",
    "Nie udało się ustawić miasta.": "No se pudo configurar la ciudad.",
    "Edycja linku": "Editar enlace",
    "Pracownicy z brakującymi ustawieniami wynagrodzenia": "Empleados a los que les falta una configuración salarial",
    "Dodaj inwentaryzacje": "Añadir inventarios",
    "Wygeneruj pilik": "Genera una píldora",
    "Pobyt: ": "Estancia: ",
    "Checklista:": "Lista de verificación:",
    "Strona lekcji opublikowana": "Página de la lección publicada",
    "Zapisz komentarz": "Guardar comentario",
    "Usuń materiał z testu": "Retirar el material de la prueba",
    "Migracje": "Migraciones",
    "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "Número especificado incorrectamente, verifique la cantidad de materiales publicados.",
    "Nie można przenosić plików między sekcjami o różnych typach": "No se pueden mover archivos entre secciones de diferentes tipos",
    "Jest to lista obiektów które nie mają jeszcze przypisanego właściciela.": "Esta es una lista de objetos que aún no tienen un propietario asignado.",
    "Folder został usunięty.": "Se ha eliminado la carpeta.",
    "Symbol strony szkolenia": "Símbolo de página de entrenamiento",
    "Łóżeczko": "Cuna",
    "Czy na pewno chcesz usunąć tę sekcję?": "¿Está seguro de que desea eliminar esta sección?",
    "Brak działu nadrzędnego": "Sin departamento de padres",
    "Adres firmy": "Dirección de la empresa",
    "Kwota kosztów": "Importe de los costos",
    "Nazwa źródła": "Nombre de la fuente",
    "Katalog": "catálogo",
    "Dane nieruchomości": "Datos de propiedad",
    "$% - znacznik zamykający tag": "$% - etiqueta de cierre",
    "Wstaw trzy kolumny 1/3": "Inserte tres columnas 1/3",
    "Brak danych.": "Sin datos.",
    "Rola": "Rol",
    "CustomerService": "Servicio al cliente",
    "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "Este canal tiene la capacidad de enviar texto formateado.",
    "BOK": "Atención al cliente",
    "Koszt pracownika": "",
    "Dział": "Departamento",
    "Typy materiałów": "Tipos de materiales",
    "Bazy danych": "bases de datos",
    "Włączone (Follow)": "Activado (Seguir)",
    "Zapauzowano:": "En pausa:",
    "Wyjazd": "Salida",
    "pl": "es",
    "Przełącznik": "Interruptor",
    "Pokaż tytuł formularza": "Mostrar título del formulario",
    "Wyposażenie": "Equipos",
    "Neutralne": "Neutro",
    "Dane kierowcy: ": "Datos del conductor: ",
    "Nazwa bazy danych": "Nombre de base de datos",
    "HR": "HORA",
    "Kategorie materiałów": "Categorías de materiales",
    "NIP firmy": "Número de identificación fiscal de la empresa",
    "Połącz w pary": "Pareja",
    "Lekcja wideo została zaktualizowana.": "La lección en vídeo se ha actualizado.",
    "Adres serwera": "Dirección del servidor",
    "Zadania dzisiaj": "Tareas actuales",
    "Ten element nie zawiera menu kontekstowego.": "Este elemento no contiene un menú contextual.",
    "Zastępstwa": "Sustituciones",
    "Wzorzec": "Patrón",
    "Liczba podejść": "Número de enfoques",
    "Edytuj szablon": "Editar plantilla",
    "Usunięte zadanie": "Tarea eliminada",
    "Data od": "Fecha desde",
    "Data ukończenia": "Fecha de finalización",
    "Szczegóły zdarzenia": "Detalles del evento",
    "Zapisz jako": "Guardar como",
    "Wyposażenie zostało zaktualizowane.": "El equipo se ha actualizado.",
    "Edytuj uprawnienia": "Permisos de edición",
    "Powiadomienie o zbliżającym się zakończeniu szkolenia": "Notificación de la finalización inminente de la formación",
    "Pokaż": "show",
    "Data realizacji": "Fecha de implementación",
    "Jestem w drodze": "Estoy en camino",
    "Poczta": "correo",
    "Numer Guesty": "Número de huésped",
    "Dostęp przyznany": "Acceso concedido",
    "Wyszukaj": "Búsqueda",
    "Wybierz regulamin": "Seleccione los términos y condiciones",
    "Nazwa nadawcy": "Nombre del remitente",
    "Filtry": "Filtros",
    "Zakończenie": "final",
    "Firma własna": "Empresa propia",
    "Przepracowana liczba godzin w miesiącu": "Número de horas trabajadas al mes",
    "Zadanie na dziś": "Tarea para hoy",
    "W momencie tworzenia kosztu": "En el momento de la creación de costos",
    "Edytuj temat": "Editar tema",
    "Uczestnicy rozmowy:": "Participantes de la conversación:",
    "linie": "líneas",
    "Ilość punktów: ": "Cantidad de puntos: ",
    "Przypisane tagi:": "Etiquetas asignadas:",
    "Otwórz w nowym oknie": "Abrir en una ventana nueva",
    "Dostępne czaty:": "Chats disponibles:",
    "Usługi": "Servicios",
    "Oczekuje na wysłanie": "Esperando ser enviado",
    "Nazwa trasy": "Nombre de la ruta",
    "Informacje o czacie": "Información de chat",
    "Multimedia": "Multimedia",
    "Dopuść brak odpowiedzi": "No permitir ninguna respuesta",
    "Dodaj treść": "Añadir contenido",
    "Dane Adresowe": "Datos de dirección",
    "Wynagrodzenia Pracowników": "Salarios de los empleados",
    "Nazwa pokoju": "Nombre de la habitación",
    "Niedziela": "Sonntag",
    "Wymagane jest ustawienie minimalnej długości hasła": "Es necesario establecer una longitud mínima de contraseña",
    "Zgłoszenia w apartamencie": "Presentaciones en el apartamento",
    "To miasto jest już przypisane do użytkownika.": "Esta ciudad ya está asignada al usuario.",
    "Dodaj źródło": "Agregar fuente",
    "Skrócony opis": "Descripción breve",
    "Wybierz sekcję, do której chcesz dodać pliki": "",
    "Data zakończenia/wykonania": "Fecha de finalización/ejecución",
    "Zapisz nową kolejność punktów": "Guardar un nuevo orden de puntos",
    "Strona została dodana.": "Se ha añadido la página.",
    "pokaż więcej...": "mostrar más...",
    "Źródła danych": "Fuentes de datos",
    "Nie znaleziono nieruchomości": "No se encontró la propiedad",
    "Wyświetl popup z kontynuacją lekcji": "Mostrar una ventana emergente con la continuación de la lección",
    "Przypisane do:": "Asignado a:",
    "Dodaj rolę": "Añadir un rol",
    "Status linku został zmieniony.": "Se ha cambiado el estado del enlace.",
    "Dodaj opłaconą kwotę": "Agrega la cantidad que pagaste",
    "Zapisz filtr": "Guardar filtro",
    "Utworzył": "Creado",
    "Suma wynagrodzeń koordynatorów": "Salarios totales de los coordinadores",
    "Harmonogram został zmieniony": "Se ha modificado el horario",
    "Typ obiektu": "Tipo de objeto",
    "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "El símbolo solo puede consistir en letras minúsculas, números y un signo - ",
    "Wyczyść sesję": "Borrar sesión",
    "Minuty": "Minutos",
    "Nie udało się pobrać ról!": "¡No se pudieron descargar los roles!",
    "Miasto zostało zaktualizowane.": "La ciudad se ha actualizado.",
    "Bez dzielnicy": "Sin distrito",
    "Aktywna nieruchomość": "Bienes inmuebles activos",
    "Wewnętrznie": "Internamente",
    "Potwierdzenie publikacji": "Confirmación de publicación",
    "Tytuł formularza jest wymagany": "El título del formulario es obligatorio",
    "Powiadomienia zostały skonfigurowane.": "Se han configurado las notificaciones.",
    "Ustawienia dostępności": "Ajustes de accesibilidad",
    "Pasek": "Cinturón",
    "E-learning": "Aprendizaje electrónico",
    "Szablon został zaktualizowany.": "La plantilla se ha actualizado.",
    "Liczba dziesiętna": "Decimal",
    "Filtr został usunięty": "Se ha quitado el filtro",
    "Usuń tag": "Eliminar etiqueta",
    "Dołącz stronę do pliku sitemap.xml": "Adjunte la página al archivo sitemap.xml",
    "Zmiana motywu": "Cambio de tema",
    "Rola przypisana do tego wydziału jest nieaktywna": "El rol asignado a este departamento está inactivo",
    "Numer konta bankowego": "Número de cuenta bancaria",
    "Logger": "maderero",
    "Pokaż zadania bez przypisanej osoby": "Mostrar tareas sin una persona asignada",
    "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "El navegador que está utilizando no admite las notificaciones PUSH",
    "Gość": "huésped",
    "Ten miesiąc": "Este mes",
    "Koordynator Główny": "Coordinadora en jefe",
    "Firmy": "Firmas",
    "Nieudane": "Sin éxito",
    "Data utworzenia wersji": "Fecha de creación de la versión",
    "Treść została dodana.": "Se ha añadido contenido.",
    "Raczej się nie zgadzam": "Prefiero estar en desacuerdo",
    "Nie udało się pobrać szczegółów zmiany": "No se pudieron descargar los detalles del cambio",
    "Dodaj koszt": "Añadir coste",
    "Wykonane": "Hecho",
    "Dane dostępu": "Datos de acceso",
    "Członkowie zespołu": "Miembros del equipo",
    "Pre-booking": "Pre-reserva",
    "Nazwa zestawu": "Nombre del conjunto",
    "Inwentaryzacje": "Inventarios",
    "Wszystkie zadania": "Todas las tareas",
    "Szablon graficzny": "Plantilla gráfica",
    "Opis witryny": "Descripción del sitio",
    "Data:": "Fecha:",
    "Id": "Identidad",
    "Utwórz czat": "Crea un chat",
    "Stawka PLN brutto za godzinę": "Tarifa bruta de PLN por hora",
    "Rozmiar": "tamaño",
    "Dodaj do regionu": "Agregar a la región",
    "Data zalogowania": "Fecha de inicio de sesión",
    "Wysłano powiadomienie.": "Se ha enviado una notificación.",
    "Trasy archiwalne": "Rutas de archivo",
    "Musisz wybrać obiekt na mapie": "Debe seleccionar un objeto en el mapa",
    "Pokaż filtry": "Mostrar filtros",
    "Włączenie obsługi cacheu dla witryny": "Habilitar el soporte de Cacheu para el sitio",
    "do": "hasta",
    "Komentarz Konserwatora": "Comentario del conservador",
    "Imię właściciela": "Nombre del propietario",
    "Kategoria slajdu": "Categoría de diapositiva",
    "Obiekty": "Objetos",
    "Nie udało się wgrać pliku": "No se pudo cargar el archivo",
    "W drodze": "En la carretera",
    "Zaawansowane polecenia": "Comandos avanzados",
    "Wyszukiwany ciąg znaków": "Cadena de búsqueda",
    "Udało się dodać nieruchomość do trasy": "La propiedad se agregó correctamente a la ruta",
    "Edycja wynagrodzenia za posprzątane obiekty dla:": "Edición de la remuneración de las instalaciones limpiadas para:",
    "Nieprawidłowy adres URL": "URL no válida",
    "Wybierz blok": "Selecciona un bloque",
    "Obrazek wyróżniający": "Imagen distintiva",
    "Niestandardowy błąd": "Error personalizado",
    "Koszt został usunięty": "",
    "Slajder został dodany.": "Se ha añadido el control deslizante.",
    "Synchronizacja rezerwacji": "Sincronización de reservas",
    "Manager Firmy Zewnętrznej": "Gerente externo de la empresa",
    "Logowanie": "Iniciar sesión",
    "Brak kategorii": "Sin categoría",
    "Faktyczny czas pracy": "Tiempo de trabajo real",
    "Ustawienia konta": "Configuración de la cuenta",
    "Domyślny tytuł aktywnej strony": "Título predeterminado de la página activa",
    "Ustawienia zostały zaktualizowane.": "La configuración se ha actualizado.",
    "Nie udało się pobrać zadań": "No se pudieron descargar las tareas",
    "Aktywna": "Activo",
    "Wprowadzona wartość nie jest poprawna": "El valor que has introducido no es correcto",
    "Wybór języka": "Elección de idioma",
    "Zmień nazwę katalogu": "Cambiar el nombre del directorio",
    "Problemy": "problemas",
    "Edycja kategorii": "Edición de categorías",
    "Dzielnica została dodana.": "Se ha agregado el distrito.",
    "Brak numeru": "Sin número",
    "Kategoria została usunięta.": "Se ha eliminado la categoría.",
    "Wybierz stronę": "Elige una página",
    "Zadanie zostało włączone": "Se ha habilitado la tarea",
    "Ankieta": "encuesta",
    "Dodaj temat/link": "Añadir tema/enlace",
    "Koszty wg regionów": "Costos por región",
    "Dane właściciela": "Datos del propietario",
    "Brak typu zadania": "Sin tipo de tarea",
    "zacznij pisać aby wyszukać regulamin...": "empieza a escribir para buscar términos y condiciones...",
    "Wprowadzona wartość jest za wysoka": "El valor que has introducido es demasiado alto",
    "Dodatkowe wynagrodzenie - kwota": "Salario adicional: importe",
    "REGON firmy": "REGON de la empresa",
    "VAT (wyliczany automatycznie)": "",
    "Miniaturka wideo": "Miniatura del vídeo",
    "Ukończone przez użytkownika": "Completado por el usuario",
    "Logo": "Logotipo",
    "Brak strony nadrzędnej": "No hay página principal",
    "Tagi": "Etiquetas",
    "Archiwalny": "Archivístico",
    "Pokaż tytuł strony": "Mostrar título de la página",
    "Administracja - Kraje": "Administración - Países",
    "Pomoc": "Ayuda",
    "Dane podstawowe": "Datos básicos",
    "Czas (minuty)": "Tiempo (minutos)",
    "Sformatowany rzeczywisty czas pracy": "Tiempo de trabajo real formateado",
    "Przesyłanie zdjęcia nie powiodło się": "No se pudo cargar la foto",
    "dni temu": "hace días",
    "Nie możesz rozpocząć obsługi tego zadania": "No puedes empezar a gestionar esta tarea",
    "Zarządzaj": "Administrar",
    "Wideo zewnętrzne (URL)": "Vídeo externo (URL)",
    "Dane zadania": "Datos de tareas",
    "Szkolenie zostało zaktualizowane.": "Se ha actualizado la formación.",
    "Pytania i odpowiedzi": "Preguntas y respuestas",
    "Filmy": "Vídeos",
    "Aktywny": "Activo",
    "Liczba szkoleń": "Número de capacitaciones",
    "Dostęp do": "Acceso a",
    "Dodanie wpisu": "Añadir una entrada",
    "Zacznik pisać Form lub Entry aby uruchomić podpowiadanie.": "Empieza a escribir Formulario o Entrada para iniciar el mensaje.",
    "Kalendarz nieruchomości": "Calendario inmobiliario",
    "Dodanie Notatki": "Añadir una nota",
    "Bezpieczeństwo": "Seguridad",
    "Dwie kolumny": "Dos columnas",
    "Administracja - Miasta": "Administración - Ciudades",
    "Stawka mieszana została zaktualizowana.": "Se ha actualizado la tasa mixta.",
    "Zacznij pisać aby wyszukać osobę...": "Empieza a escribir para buscar a una persona...",
    "Szczegóły rezerwacji": "Detalles de la reserva",
    "Link do czatu": "Enlace de chat",
    "Kwota kosztu do": "El importe del coste hasta",
    "Obrazek": "Imagen",
    "Podaj swój adres email": "Por favor, introduce tu correo electrónico",
    "Edytuj Notatkę": "Editar nota",
    "Nieruchomość zagrożona wypowiedzeniem": "Propiedad en riesgo de rescisión",
    "Nie udało się pobrać danych o rolach zalogowanego użytkownika": "No se pudieron recuperar los datos del rol del usuario que inició sesión",
    "Tryb monitorowania aktywności wyłączony.": "Modo de monitoreo de actividad desactivado.",
    "Stawka za godzinę brutto": "Tarifa bruta por hora",
    "To zadanie nie posiada jeszcze przypisanych użytkowników.": "Esta tarea aún no tiene ningún usuario asignado.",
    "Regulamin wymagany": "Se requieren términos y condiciones",
    "Uwzględnij miasto": "Incluir ciudad",
    "Dodaj dane wydziału": "Agregar datos del cuerpo docente",
    "Czy na pewno chcesz ukryć wiadomość?": "¿Estás seguro de que quieres ocultar el mensaje?",
    "Układ": "Disposición",
    "Serwer plików": "Servidor de archivos",
    "Kwota opłacona": "Monto pagado",
    "Koniec szerokości geograficznej użytkownika": "Latitud de usuario final",
    "Zadania": "Tareas",
    "ID obiektu": "ID de objeto",
    "W tym katalogu nie ma jeszcze żadnych stron.": "Aún no hay páginas en este directorio.",
    "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "Notificación al usuario de nuevos mensajes en el chat",
    "Serwer został zaktualizowany.": "Se ha actualizado el servidor.",
    "Srednie wynagrodzenie pracowników": "Salario promedio de los empleados",
    "Zmiana rozmiaru obrazu": "Cambiar el tamaño de una imagen",
    "źródło danych zostało dodane.": "Se ha agregado la fuente de datos.",
    "Zestaw został dodany.": "Se ha añadido el conjunto.",
    "Edytuj blok": "Editar bloque",
    "Przypisane dzielnice:": "Distritos asignados:",
    "Nazwisko właściciela": "Nombre del propietario",
    "Język": "Idioma",
    "Nazwa sekcji": "Nombre de la sección",
    "Stawka domyślna": "Tasa predeterminada",
    "Pokaż więcej": "Mostrar más",
    "Odpowiedź 5": "Respuesta 5",
    "Witryna / Wersja językowa": "Sitio web/idioma",
    "Weekend": "fin de semana",
    "Uwzględnij zadania z miesiąca:": "Incluye las tareas del mes:",
    "Zamknięte przez": "Cerrado por",
    "Przypisane do": "Asignado a",
    "Historia logowania": "Historial de inicio de sesión",
    "Wstaw z prawej strony": "Insertar desde la derecha",
    "Wyłączone (NoIndex)": "Desactivado (NoIndex)",
    "Artykuły": "Artículos",
    "Data wykonania do": "Fecha de ejecución hasta",
    "Zadanie zostało wznowione.": "La tarea se ha reanudado.",
    "Witryna aktywna": "Sitio activo",
    "Nie udało się pobrać listy serwerów baz danych": "No se pudo descargar la lista de servidores de base de datos",
    "Data nieobecności od": "Fecha de ausencia de",
    "Ten region nie posiada jeszcze przypisanych miast.": "Esta región aún no tiene ciudades asignadas.",
    "Masz nową wiadomość!": "¡Tienes un mensaje nuevo!",
    "Wpisz nazwę trasy": "Introduzca el nombre de la ruta",
    "Przeglądnij logi": "Navegar por los registros",
    "Nieudane próby logowania": "Intentos de acceso fallidos",
    "Na pewno usunąć wybrane elementy?": "¿Estás seguro de eliminar los elementos seleccionados?",
    "dzisiaj": "hoy",
    "Wróć do strony logowania": "Volver a la página de inicio de sesión",
    "Telefon": "Tlf",
    "Nazwa aranżacji": "Nombre del arreglo",
    "Zadanie na nieruchomościach roboczych": "Tarea sobre propiedades de trabajo",
    "Biblioteka": "Biblioteca",
    "Usuń plik z listy": "Eliminar un archivo de la lista",
    "Zmień dane kosztu": "Cambiar los datos de costos",
    "Zmień status edytowanej wersji": "Cambiar el estado de la versión editada",
    "Filtry systemowe": "Filtros del sistema",
    "Wynagrodzenia Konserwatorzy": "Salarios de los conservadores",
    "Walidacja certyfikatu SSL": "Validación de certificados SSL",
    "Operacja": "cirugía",
    "Edycja ścieżki szkoleniowej": "Editar la ruta de entrenamiento",
    "Wybrane miasto": "Ciudad seleccionada",
    "Stawka za typ apartamentu": "Tarifa por tipo de apartamento",
    "Mnożenie": "Multiplicación",
    "Uwzględniaj Miasta": "Incluir ciudades",
    "Edycja zastępstwa": "Modificar sustitución",
    "Konfiguruj stronę": "Configurar la página",
    "Zaczyna sie od": "Empieza con",
    "Nieobecny do": "Ausente para",
    "Dodaj zaopatrzenie": "Agregar aprovisionamiento",
    "Email został wysłany.": "Se ha enviado el correo electrónico.",
    "Co 20 minut": "Cada 20 minutos",
    "km": "kilometros",
    "Ustaw w kolejności": "Poner en orden",
    "Użytkownik został przypisany do ścieżki szkoleniowej.": "El usuario ha sido asignado a la ruta de formación.",
    "Oczekujące": "Pendiente",
    "Confirmed": "Confirmado",
    "Godzina:": "Hora:",
    "Lekcja SCORM ukryta": "Lección de SCORM oculta",
    "Adres strony": "Dirección del sitio",
    "Administratorzy": "Administradores",
    "Notatki": "Notas",
    "Edycja stawki godzinowej dla:": "Edita la tarifa por hora para:",
    "Dodaj opis...": "Añadir una descripción...",
    "Wynagrodzenie stałe brutto": "Salario fijo bruto",
    "Przejdź do rezerwacji": "Ir a la reserva",
    "Parametry, wymagane do wykonania zapytania:": "Parámetros necesarios para ejecutar la consulta:",
    "Pliki zostały pobrane": "Se han descargado los archivos",
    "gotowe": "preparado",
    "Co 5 minut": "Cada 5 minutos",
    "Szkolenie kończy się": "Finaliza la formación",
    "Link został dodany.": "Se ha añadido el enlace.",
    "Kolejne pozycje z prawej strony": "Próximos elementos a la derecha",
    "Miasta:": "Ciudades:",
    "Usuń poprzednie wersje certyfikatu": "Eliminar versiones anteriores del certificado",
    "Wynagrodzenie za przepracowane godziny": "Remuneración por horas trabajadas",
    "10 minut": "10 minutos",
    "Paczka została usunięta.": "Se ha retirado el paquete.",
    "Typ mime": "Tipo MIME",
    "Dodaj temat": "Añadir un tema",
    "Edytuj urlop": "Editar vacaciones",
    "Szukaj...": "Buscar...",
    "Ścieżka szkoleniowa została zaktualizowana.": "Se ha actualizado la ruta de formación.",
    "Powtórzone": "Repitido",
    "Nie wybrano żadnej kategorii.": "No se ha seleccionado ninguna categoría.",
    "Azure AD": "Azure AD",
    "Prestiżowe": "Prestigio",
    "Błąd": "Error",
    "3": "3",
    "Sformatowany czas całkowity": "Tiempo total formateado",
    "Liczba małych prześcieradeł": "Número de hojas pequeñas",
    "Wersja językowa": "Versión lingüística",
    "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "Hay una nueva actualización disponible. Guarde el progreso del trabajo y haga clic en el botón «Actualizar». También puedes aceptar la actualización actualizando la ventana del navegador. Si no se actualiza, se pueden producir errores.",
    "Użytkownik został zablokowany, a jego wiadomość ukryte.": "El usuario ha sido bloqueado y su mensaje está oculto.",
    "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "Solo servidor para desarrolladores. No lo use en modo de producción. ",
    "Dział aktywny": "Departamento activo",
    "Wynagrodzenia mieszane": "Salarios mixtos",
    "Inne": "Otros",
    "Zdarzenie": "Evento",
    "Kategorie linków": "Categorías de enlaces",
    "Co 12 godzin": "Cada 12 horas",
    "Zadanie zostało wyłączone": "La tarea se ha desactivado",
    "Wyślij": "Enviar",
    "Nie udało się zapisać notatki": "No se pudo guardar la nota",
    "Nie możesz modyfikować uprawnień": "No puede modificar los permisos",
    "Bezpieczne połączenie SSL": "Conexión SSL segura",
    "Przepracowana ilość godzin": "Número de horas trabajadas",
    "Dane dostępowe:  ": "Datos de acceso:  ",
    "Końcowy stan licznika": "El estado final del medidor",
    "Ilość wyświetlanych aktualności": "Número de noticias mostradas",
    "Wyznacz punkty": "Designar puntos",
    "%0 znaków": "%0 caracteres",
    "Szkolenie zostało dodane.": "Se ha añadido la formación.",
    "Domyślna witryna": "Sitio predeterminado",
    "więcej...": "más...",
    "Dodanie testu": "Entrega de la prueba",
    "Imię i nazwisko pracownika": "Nombre y apellidos del empleado",
    "Wpisz treść wiadomości.": "Introduzca el cuerpo del mensaje.",
    "Publikacja zarchiwizowana": "Publicación archivada",
    "Plik jest wysyłany": "Se envía el archivo",
    "Brak wyników": "No hay resultados",
    "Nazwa sieci Wi-Fi": "Nombre de la red Wi-Fi",
    "Sekcja została utworzona": "Se ha creado la sección",
    "Trasa została zaktualizowana.": "Se ha actualizado la ruta.",
    "Nazwa checklisty": "Nombre de la lista de verificación",
    "Szkolenie nie jest opublikowane": "La formación no está publicada",
    "Zlecenia magazynowe": "Pedidos de almacén",
    "Edytuj tag": "Editar etiqueta",
    "Dodanie witryny": "Añadir un sitio",
    "Biuro": "Oficina",
    "Ilość wyników do odrzucenia": "Número de resultados a rechazar",
    "Paid": "Pagado",
    "Zewnętrzny serwis": "Servicio externo",
    "Element grupujący": "Elemento de agrupamiento",
    "Brak tematu": "Sin tema",
    "Notatka dla": "Memo para",
    "Wybrana sekcja nie istnieje": "",
    "Szkolenie zostało usunięte.": "Se ha eliminado la formación.",
    "Scenariusz": "Escenario",
    "Numer mieszkania (Door)": "Número del apartamento (puerta)",
    "Czas pomiędzy": "El tiempo entre",
    "Wersja nieopublikowana": "Versión inédita",
    "Opublikuj": "Publicar",
    "Wymuszaj zaliczenie elementów ścieżki zgodnie z kolejnością szkoleń na liście": "Forzar la aprobación de los elementos de la pista según el orden de entrenamiento de la lista",
    "Lista wyboru": "Lista de selección",
    "Filtr o podanej nazwie już istnieje.": "El filtro con el nombre dado ya existe.",
    "Równość": "Igualdad",
    "Podstawowe operacje na datach": "Operaciones básicas sobre fechas",
    "Zakończone przez": "Finalizado por",
    "Porównanie": "Comparación",
    "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "La contraseña debe contener al menos un carácter especial, por ejemplo: ~ @ # $% ^ & *",
    "Przypisz do czatu": "Asignar al chat",
    "np. pl-PL": "por ejemplo, PL-pl",
    "Standard 1.2": "Estándar 1.2",
    "Zdjęcie użytkownika": "Foto del usuario",
    "Włączone": "Habilitado",
    "Wtorek": "martes",
    "Upload plików": "Cargar archivos",
    "Status formularza został zmieniony.": "Se ha modificado el estado del formulario.",
    "Powrót": "revertir",
    "Szczegóły zadania": "Detalles de la tarea",
    "Pracownik niedostępny od": "Empleado no disponible desde",
    "Strona opublikowana": "Página publicada",
    "Włączenie generowania pliku sitemap.xml dla całej witryny": "Habilitar la generación de sitemap.xml en todo el sitio",
    "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "Aún no se ha asignado ningún equipo a la capacitación.",
    "Dodaj zadanie": "Añadir una tarea",
    "Kategoria została dodana.": "Se ha añadido la categoría.",
    "Rozliczone": "Resuelto",
    "(nowe wiadomości)": "(nueva noticia)",
    "Usuń spacje": "Eliminar espacios",
    "Data utworzenia aranżacji": "Fecha de creación del acuerdo",
    "Zarządzanie zespołami": "Administración de equipos",
    "Trasy dla Kierowców": "Rutas para conductores",
    "Nawiguj do kolejnego punktu": "Navega al siguiente punto",
    "Testowe powiadomienie wysłane": "Notificación de prueba enviada",
    "Średni": "Mediano",
    "Katalog został utworzony.": "Se ha creado el directorio.",
    "Tryb monitorowania aktywności włączony.": "Modo de monitoreo de actividad activado.",
    "Zarządzanie witrynami": "Administración del sitio",
    "Miejscowość": "Localidad",
    "Sekcje": "secciones",
    "Źle": "incorrecta",
    "Dodanie aktualności": "Añadir noticias",
    "zacznij pisać aby wyszukać materiał...": "empieza a escribir para buscar material...",
    "Nie można usunąć kategorii do ktorej są przypisane elementy.": "No puede eliminar la categoría a la que están asignados los artículos.",
    "Wytnij": "Cortar",
    "Skopiowano": "Copiado",
    "Pozostałe ustawienia": "Otros ajustes",
    "Liczba wyświetlanych slajdów": "Número de diapositivas mostradas",
    "Dashboard szkolenia": "Tablero de entrenamiento",
    "Ładuję...": "Cargando...",
    "Włącz chat": "Habilitar el chat",
    "Nieaktywni": "Inactivo",
    "Stwórz zlecenie z notatki": "Crear un pedido a partir de una nota",
    "Nie udało się usunąć szablonu": "No se pudo eliminar la plantilla",
    "Usuń kurs z ścieżki szkoleń": "Eliminar un curso de la ruta de formación",
    " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": " Los elementos que se deben completar en el texto se colocan entre las etiquetas definidas %$any_name$%.",
    "Źródło rezerwacji": "Fuente de reserva",
    "Zaznacz wszystkie w sekcji": "Selecciona todo en la sección",
    "Nowe połączenie": "Nueva conexión",
    "Właściciele": "Propietarios",
    "Wczytuję...": "Cargando...",
    "Regulamin został dodany.": "Se han agregado regulaciones.",
    "Publikuj do": "Publicar en",
    "Zobacz trasę": "Ver la ruta",
    "Wybrane elementy zostały przeniesione.": "Los elementos seleccionados se han movido.",
    "Zamknięte przez użytkownika": "Cerrado por usuario",
    "Zapisz wersję slajdu": "Guardar la versión de la diapositiva",
    "Kontrolki specjalizowane": "Controles especializados",
    "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "Indica a los robots de los motores de búsqueda si deben seguir los enlaces.",
    "Dodaj paczkę SCORM": "Añadir un paquete SCORM",
    "Dodawanie inwentaryzacji": "Añadir inventario",
    "Wybierz osobę spoza dzielnicy": "Selecciona a una persona de fuera del vecindario",
    "Stała wartość": "Valor fijo",
    "Data rejestracji": "Fecha de registro",
    "Treści pytań są wymagane": "El contenido de las preguntas es obligatorio",
    "Planuj automatycznie w dniu zakończenia blokady": "Programe automáticamente el día en que finalice el bloqueo",
    "Data opuszczenia zespołu": "Fecha de abandono del equipo",
    "Zamiany zostały zapisane.": "Se han guardado los swaps.",
    "Brak przypisanych tagów.": "No hay etiquetas asignadas.",
    "Podano nieprawidłowe dane.": "Se proporcionaron datos no válidos.",
    "Konserwacje": "Preservaciones",
    "Dodatkowa kwota wynagrodzenia": "Importe adicional de salario",
    "Pełny ekran": "Pantalla completa",
    "Zacznij pisać aby wyszukać tag nieruchomości...": "Empieza a escribir para buscar la etiqueta...",
    "Wstaw stronę": "Insertar página",
    "Moje konto": "Mi cuenta",
    "co się wydarzyło": "lo que pasó",
    "Ilość łóżek jednoosobowe": "Número de camas individuales",
    "Wszystkie": "Todas",
    "Opublikowana": "Publicado",
    "Zwierzę": "El animal",
    "wybierz długość": "elige la longitud",
    "Nieruchomość została zaktualizowana.": "La propiedad se ha actualizado.",
    "Dodaj klienta": "Añadir un cliente",
    "Usunięte zadania": "Tareas eliminadas",
    "Owner Booking": "Reserva de propietario",
    "Nazwa paczki SCORM": "Nombre del paquete: SCORM",
    "Co 3 miesiące": "Cada 3 meses",
    "Nie możesz rozpocząć obsługi tego zadania, ponieważ wykonujesz teraz inne zadanie": "No puede empezar a gestionar esta tarea porque ahora está realizando una tarea diferente",
    "${item.text}": "$ {item.text}",
    "Wybrane": "Seleccionado",
    "Rodzaj nieruchomości": "Tipo de propiedad",
    "Co pół roku": "Cada seis meses",
    "Nieruchomości robocze": "Bienes inmuebles en funcionamiento",
    "Miasto apartamentu": "Ciudad del apartamento",
    "Podstawowe operacje na liczbach": "Operaciones básicas con números",
    "W przyszłości": "En el futuro",
    "Wybrane pliki: {0}": "Archivos seleccionados: {0}",
    "Zgłoszone problemy": "Problemas reportados",
    "odznacz wszystko": "deseleccionar todo",
    "Podążanie za linkami": "Siguiendo los enlaces",
    "Dodaj witrynę": "Agregar un sitio",
    "Kalendarz": "Calendário",
    "Podana nazwa jest zajęta.": "Se toma el nombre de pila.",
    "Wysoki": "alto",
    "Dobrze": "bien",
    "wybierz katalog": "seleccionar un directorio",
    "Materiał": "Material",
    "Wybrane kategorie": "Categorías seleccionadas",
    "zacznij pisać aby wyszukać autora...": "Empieza a escribir para encontrar al autor...",
    "Statystyki pracownicze": "Estadísticas de empleados",
    "Sprzątanie": "Limpieza",
    "Udało się zaktualizować nieruchomości!": "¡Se actualizó correctamente la propiedad!",
    "Inwentaryzacja została usunięta.": "Se ha retirado el inventario.",
    "Wynagrodzenia w regionie łącznie z wynagrodzeniami koordynatorów": "Salarios en la región, incluidos los salarios de los coordinadores",
    "Zaloguj się": "Iniciar sesión",
    "Data informująca o terminie wejścia w życie tego regulaminu.": "La fecha de entrada en vigor del presente Reglamento.",
    "Edytuj dane wydziału": "Editar datos del profesorado",
    "Pytanie 3": "Pregunta 3",
    "Lista rozwijana": "Lista desplegable",
    "Edycja slajdera": "Edición deslizante",
    "Ankiety": "Encuestas",
    "Dni": "Días",
    "Potwierdź usunięcie": "Confirmar la eliminación",
    "Przywróć oryginał": "Restaurar el original",
    "Podziedziałek - Piątek": "Sustituto: viernes",
    "Godzina wymeldowania": "Hora de salida",
    "Data i czas": "Fecha y hora",
    "Jednokrotnego wyboru": "Selección única",
    "Nie podano opisu.": "No se proporciona ninguna descripción.",
    "Id rezerwacji": "ID de reserva",
    "Zmień widok": "Cambiar vista",
    "Dodanie kategorii": "Añadir una categoría",
    "Suma wynagrodzeń pracowników": "Suma de los salarios de los empleados",
    "Zmień ustawienia": "Cambiar la configuración",
    "Powiązany artykuł": "Artículo relacionado",
    "Wiadomości": "noticias",
    "Data modyfikacji do": "Fecha de modificación a",
    "Baza danych": "base de datos",
    "Główny Konserwator": "Conservador jefe",
    "Ilość sypialni": "Número de dormitorios",
    "Dzielnica została usunięta.": "El distrito ha sido eliminado.",
    "Publikacja aranżacji została wyłączona.": "Se ha desactivado la publicación del acuerdo.",
    "Kod pocztowy": "Código postal",
    "Do akceptacji": "Aceptable",
    "Tłumaczę...": "Traduzco...",
    "Rzeczywisty czas pracy": "Tiempo de trabajo real",
    "Dodaj wpis": "Añadir una entrada",
    "Edytuj wpis": "Editar entrada",
    "Zwiń": "Colapso",
    "Data rozpoczęcia": "Fecha de inicio",
    "Dodane przez: ": "Añadido por: ",
    "Szkolenia": "Entrenamientos",
    "Wiadomość została przywrócona.": "Se ha restaurado el mensaje.",
    "Właściciel regionu": "El propietario de la región",
    "Brak szczegółów zmian": "No hay cambios en los detalles",
    "Dostęp przyznany ręcznie": "Acceso otorgado manualmente",
    "Wpisz tytuł...": "Introduce un título...",
    "Uwaga! wraz z miastem": "¡Atención! con la ciudad",
    "Usunięto": "Eliminado",
    "Dodanie szkolenia": "Añadir formación",
    "Profil został zaktualizowany.": "Se ha actualizado el perfil.",
    "Nazwa:": "Nombre:",
    "Data dodania do": "Fecha añadida a",
    "Wyszukaj albo dodaj nowy tag": "Buscar o añadir una etiqueta nueva",
    "Dostępne obiekty:": "Instalaciones disponibles:",
    "Dostępne moduły": "Módulos disponibles",
    "Ustawienia zostały zapisane.": "Se ha guardado la configuración.",
    "Attempt of reservation by Credit Card": "Intento de reserva con tarjeta de crédito",
    "Czas uruchomienia": "Tiempo de puesta en marcha",
    "Premiera": "Estreno",
    "Czy zapisać trasę i wysłac ją do kierowcy?": "¿Guardar la ruta y enviarla al conductor?",
    "Zacznij pisać aby wyszukać regionu...": "Empieza a escribir para buscar la región...",
    "Avantio ID": "ID de Avantio",
    "Lekcja SCORM została zaktualizowana.": "La lección de SCORM se ha actualizado.",
    "Zawierające jeden z wybranych tagów": "Contiene una de las etiquetas seleccionadas",
    "Co 3 godziny": "Cada 3 horas",
    "Godziny": "Horas",
    "Edytuj stronę": "Editar página",
    "Zespół został usunięty.": "El equipo ha sido eliminado.",
    "Indeksowanie strony": "Indexación de la página",
    "Wybierz plik": "Selecciona un archivo",
    "Tag został zaktualizowany.": "La etiqueta se ha actualizado.",
    "Dodanie zespołu": "Añadir un equipo",
    "Przesuń do góry": "Desliza hacia arriba",
    "Koszty": "Gastos",
    "przejdź do komentarzy": "ir a comentarios",
    "Wersje dokumentu": "Versiones del documento",
    "Kategoria nadrzędna": "Categoría principal",
    "Dodanych plików %0 (limit wynosi %1).": "Archivos agregados %0 (el límite es %1).",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "No se han movido todos los elementos seleccionados. No tiene los permisos necesarios o, si mueve directorios, el directorio de destino es un subdirectorio del directorio de origen. Las carpetas y los archivos que no se pudieron mover siguen en la pestaña Seleccionados.",
    "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "La configuración de bloques no está disponible porque no se proporciona ninguna definición de plantilla.",
    "Zakończ zadanie": "Termina la tarea",
    "Indywidualne tokeny": "Tokens individuales",
    "Aby dodawać strony należy najpierw stworzyć nowy katalog.": "Para agregar páginas, primero debe crear un directorio nuevo.",
    "Zacznij pisać aby wyszukać firmę...": "Empieza a escribir para buscar una empresa...",
    "Nazwa firmy": "Nombre de la empresa",
    "Dodanie artykułu": "Añadir un artículo",
    "Małe znaki": "Pequeños letreros",
    "Nie można usunąć swojego konta.": "No se ha podido eliminar tu cuenta.",
    "Czas na slajd": "Es hora de un tobogán",
    "Uwzględnij wydziały podrzędne": "Incluir departamentos subordinados",
    "Kwota pozostała": "Monto restante",
    "Paczka SCORM została dodana.": "Se ha agregado el paquete SCORM.",
    "Administracja - Role": "Administración: funciones",
    "Zadanie na trasie": "Misión en la ruta",
    "Ustawienia powiadomień zostały zapisane": "Se ha guardado la configuración de las notificaciones",
    "Tekst": "Texto",
    "Apple iPhone 6": "Apple iPhone 6",
    "Stan licznika koniec": "Estado del contador final",
    "Plik został przeniesiony": "El archivo se ha movido",
    "Brak powiązań": "Ausencia de conexiones",
    "Dokument %0": "Documento %0",
    "Opublikowany na stronach": "Publicado en las páginas",
    "Wpisz nazwę miasta...": "Introduzca el nombre de la ciudad...",
    "Szkolenie zostało skopiowane": "Se ha copiado la formación",
    "Data zmiany statusu od": "Fecha de cambio de estado desde",
    "Lista powiadomień": "Lista de notificaciones",
    "Numer zadania": "Número de tarea",
    "Formularz został dodany.": "Se ha agregado el formulario.",
    "co 3 miesiące": "cada 3 meses",
    "Brak odpowiedzi": "Sin respuesta",
    "Litery": "Cartas",
    "Data utworzenia": "Fecha de creación",
    "Koniec dystansu": "Fin de la distancia",
    "Hasło użytkownika serwisowego": "Contraseña de usuario del servicio",
    "Data utworzenia od": "Fecha de creación desde",
    "Ustaw szerokości proporcjonalnie": "Definir anchuras proporcionalmente",
    "Zacznij pisać aby wyszukać tagi...": "Empieza a escribir para buscar etiquetas...",
    "Pokaż przycisk ``Wyślij``": "Mostrar el botón ``Enviar``",
    "Czeklisty": "Listas de verificación",
    "Zadanie": "Cesión",
    "Uwzględniaj Dzielnice": "Incluir distritos",
    "Edycja wpisu": "Edición de una entrada",
    "Powtóz hasło": "Repite la contraseña",
    "Dołącz do czatu": "Únete al chat",
    "Dodaj dane dostepowe...": "Agregar datos disponibles...",
    "Edycja miasta": "Edición de ciudad",
    "Nie udało się przesłać plików": "",
    "Niestandardowy adres": "Dirección personalizada",
    "Ilość pracowników": "Número de empleados",
    "Pasek postępu": "Barra de progreso",
    "Wyłączone (NoFollow)": "Desactivado (noFollow)",
    "Uzupełnij brakujące pola.": "Rellene los campos que faltan.",
    "Magazyn": "Almacén",
    "Brak nowych wiadomości.": "No hay mensajes nuevos.",
    "Podano nieprawidłowe dane": "Se proporcionaron datos no válidos",
    "Hasło zostało zmienione.": "Se ha cambiado la contraseña.",
    "Brak stron": "Sin páginas",
    "Dodane:": "Añadido:",
    "Pobierz Excel": "",
    "Treść została zaktualizowana.": "Se ha actualizado el contenido.",
    "Nieobecny od": "Ausente de",
    "Nazwa": "nombre",
    "Back Office (BO)": "Oficina administrativa (BO)",
    "Lekcja może zawierać tylko materiały opisowe lub materiały video": "La lección puede contener solo materiales descriptivos o materiales de vídeo",
    "Wyświetl szczegóły": "Ver detalles",
    "Podstawowe operacje warunkowe": "Operaciones condicionales básicas",
    "Nazwa kolumny z opisem": "Nombre de columna con descripción",
    "Tag": "Tag",
    "Moduł": "Módulo",
    "Ostatnie 5 zadań": "Últimas 5 tareas",
    "Pilne": "Urgente",
    "*Koordynator zespołu posiada dostęp do panelu koordynatora": "*El coordinador del equipo tiene acceso al panel de coordinadores",
    "Opis źródła": "Descripción de la fuente",
    "Nazwisko klienta": "Nombre del cliente",
    "Zadanie zostało zapauzowane.": "La tarea se ha pausado.",
    "Wprowadzona wartość jest za krótka": "El valor que has introducido es demasiado corto",
    "Lista użytkowników": "Lista de usuarios",
    "Pokaż listę dostępnych tras": "Mostrar una lista de rutas disponibles",
    "Wyszukaj tag...": "Etiqueta de búsqueda...",
    "Nazwa przedmiotu": "Nombre del artículo",
    "Przypisane:": "Asignado:",
    "Checklista": "Lista de verificación",
    "Zapisz filtry": "Guardar filtros",
    "Zostałeś zablokowany, dodanie wiadomości jest niemożliwe": "Se te ha bloqueado, no es posible añadir un mensaje",
    "Nie udało się dodać nieruchomość do trasy": "No se pudo agregar la propiedad a la ruta",
    "Zbliżająca się data zakończenia": "Próxima fecha de finalización",
    "Załącz plik excel": "Adjuntar archivo excel",
    "Status został zmieniony.": "Se ha cambiado el estado.",
    "Wybierz...": "Selecciona...",
    "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "Indica a los robots de los motores de búsqueda si quieren indexar la página.",
    "Wybierz użytkownika": "Selecciona un usuario",
    "Podlega ocenie": "Sujeto a evaluación",
    "Zaopatrzenie zostało usunięte.": "Se ha retirado el suministro.",
    "Nie udało się pobrać listy typów materiałów": "No se pudo recuperar la lista de tipos de material",
    "Historia zmian kosztu": "",
    "Prefix": "Prefijo",
    "Użytkownik został dodany.": "Se ha agregado el usuario.",
    "Wynagrodzenia Koordynatorzy": "Salarios de los coordinadores",
    "Tak, przejdź do mapy": "Sí, ve al mapa",
    "Data wylogowania": "Fecha de cierre de sesión",
    "Usunięte przez użytkownika": "Eliminado por el usuario",
    "Adres email nadawcy": "Correo electrónico del remitente",
    "Klient został dodany.": "Se ha agregado el cliente.",
    "Rola została usunięta.": "Se ha eliminado la función.",
    "Edycja klienta": "Edición de cliente",
    "Filtry kalendarza": "Filtros de calendario",
    "Województwo": "Voivodato",
    "Data modyfikacji": "Fecha de modificación",
    "Wymagane jest wybranie sekcji": "Es necesario seleccionar una sección",
    "Sekcja": "sección",
    "Sortowanie malejąco": "Ordenar de forma descendente",
    "Nie udało się pobrać tras": "No se pudieron descargar las rutas",
    "Typ": "Tipo",
    "Najwyższy": "Suprema",
    "Czy na pewno chcesz zablokować użytkownika?": "¿Estás seguro de que quieres bloquear al usuario?",
    "Przenieś niżej": "Muévete hacia abajo",
    "Kwota za godzinę": "Cantidad por hora",
    "Edycja zadania": "Editar una tarea",
    "Kategoria jest wymagana": "La categoría es obligatoria",
    "Potwierdź publikację wersji": "Confirme el lanzamiento de la versión",
    "Potwierdzenie usunięcia.": "Confirmación de la eliminación.",
    "Zaokrąglenie": "Redondeo",
    "Wprowadzona wartość jest za długa": "El valor que has introducido es demasiado largo",
    "Edytuj zlecenie": "Editar pedido",
    "Treść": "Contenido",
    "Bez \"http(s)://\" i \"/\" na końcu.": "Sin «http (s) ://» y «/» al final.",
    "Nie znaleziono żadnych plików": "No se ha encontrado ningún archivo",
    "Usuń powiązanie": "Eliminar enlace",
    "Użytkownicy w tej roli": "Usuarios en este rol",
    "Został przywrócony oryginalny harmonogram": "Se ha restablecido el cronograma original",
    "Zaakceptuj, wyślij": "Aceptar, enviar",
    "treść notatki": "contenido de la nota",
    "Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\".": "Guarde el progreso del trabajo y haga clic en el botón «Actualizar».",
    "Przypisz obiekty": "Asignar objetos",
    "Zacznij pisać aby wyszukać dzielnicę...": "Empieza a escribir para buscar un barrio...",
    "Poprawna odpowiedź": "Respuesta correcta",
    "Sypialnia": "Dormitorio",
    "Edycja nowej trasy": "Edición de una nueva ruta",
    "Następna strona": "Página siguiente",
    "Dodanie regulaminu": "Adición de los términos y condiciones",
    "Przypisane zadanie:": "Tarea asignada:",
    "Harmonogram zadań": "Programador de tareas",
    "Lista Tras:": "Lista de basura:",
    "Opis certyfikatu": "Descripción del certificado",
    "Ścieżka aktywnej strony": "Ruta de página activa",
    "Potwierdzenie ukrycia": "Confirme la ocultación",
    "Slajder": "Deslizador",
    "Kwota łącznie": "Importe total",
    "Przypnij menu": "Fija el menú",
    "Nie masz uprawnień do modyfikacji aranżacji.": "No tiene permiso para modificar el acuerdo.",
    "Data wydania": "Fecha de lanzamiento",
    "Zadanie zostało ukończone.": "La tarea se ha completado.",
    "Wyświetlanie": "Mostrando",
    "Uwzględniaj dzielnice": "Incluir distritos",
    "Numer inwentaryzacji": "Número de inventario",
    "Brak sekcji multimediów": "Sin sección de medios",
    "Kosz": "Cesta",
    "Dodanie poradnika": "Añadir una guía",
    "Kierowca": "Conductor",
    "Zajęte": "Ocupado",
    "Brak zmian": "Sin cambios",
    "Edycja działu": "Departamento de edición",
    "Porównania": "Comparaciones",
    "Informacje podstawowe": "Información básica",
    "Nieobecność": "Ausencia",
    "Dodanie nieruchomości": "Añadir una propiedad",
    "Nie udało się pobrać listy serwerów plików": "No se pudo descargar la lista de servidores de archivos",
    "Odepnij menu": "Deshacer el menú",
    "Ilość dostępnych bloków": "Cantidad de bloques disponibles",
    "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "Aún no se ha asignado ningún usuario a la ruta de formación.",
    "Kontener plików": "Contenedor de archivos",
    "Kalendarz - Kategorie zasobów": "Calendario - Categorías de recursos",
    "Opublikowane wersje językowe.": "Versiones lingüísticas publicadas.",
    "Dodaj kolor": "Añadir color",
    "Do kogo chcesz napisać?": "¿A quién quieres escribirle?",
    "Statystyki wniosków": "Estadísticas de solicitudes",
    "Wstaw treść widoczną po rozwinięciu": "Inserta contenido visible cuando está expandido",
    "Wynagrodzenie za konserwację": "Pago de manutención",
    "Kod Google Webmaster": "Código para webmasters de Google",
    "Domyślna": "Predeterminado",
    "od": "ya que",
    "co 6 miesięcy": "cada 6 meses",
    "Wybierz paczkę": "Elige un paquete",
    "Wstaw z dołu": "Insertar desde la parte inferior",
    "Ustawienia powiadomień": "Configuración de notificaciones",
    "Pokaż zdjęcia": "Mostrar fotos",
    "FavIcona": "Favicona",
    "Region": "Región",
    "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "El número de diapositivas visibles para el usuario no puede ser mayor que el número de diapositivas añadidas al panel.",
    "Dostęp do szkoleń:": "Acceso a la formación:",
    "Miniaturki": "Miniaturas",
    "Nowy materiał": "Nuevo material",
    "Zastosuj": "Aplica",
    "Dodanie klienta": "Añadir un cliente",
    "Nazwa szablonu": "Nombre de plantilla",
    "Czy jesteś pewien? ": "¿Estás seguro? ",
    "Wyświetlam": "Yo muestro",
    "Checklista została usunięta": "Se ha eliminado la lista de verificación",
    "Identyfikator publiczny": "ID público",
    "Slajdery": "Deslizadores",
    "Nazwa kategorii": "Nombre de la categoría",
    "Liczba miast w regionie": "Número de ciudades de la región",
    "Kontrolki podstawowe": "Controles básicos",
    "Tydzień": "Semana",
    "Usuń katalog": "Eliminar directorio",
    "Podtytuł": "Subtítulo",
    "Codziennie": "Todos los días",
    "Tytuł formularza nie może być dłuższy niż %0 znaków": "El título del formulario no puede tener más de %0 caracteres",
    "Rozpoczęto synchronizację rezerwacji": "Se inició la sincronización de reservas",
    "Adres URL": "URL",
    "Dodaj notatkę/komentarz": "Añadir una nota/comentario",
    "Szablony": "Plantillas",
    "Typ źródła danych": "Tipo de fuente de datos",
    "Zobacz czaty": "Ver chats",
    "Housekeeping (HK)": "Limpieza (HK)",
    "Klienci": "Clientes",
    "Zacznij pisać aby wyszukać inspektora...": "Empieza a escribir para buscar un inspector...",
    "Przybornik": "Caja de herramientas",
    "Angielski": "Inglés",
    "Polski": "Polaco",
    "Ukraiński": "Ucraniano",
    "Bułgarski": "Búlgaro",
    "Hiszpański": "Español",
    "Nie możesz zapisać zmian, gdyż liczba elementów nie może być mniejsza niż ustawiona liczba wymaganych elementów w zakładce ustawienia testu": "No puede guardar los cambios porque la cantidad de elementos no puede ser inferior a la cantidad establecida de elementos necesarios en la pestaña de configuración de la prueba.",
    "Zamknięte": "cerrada",
    "Pokaż zaplanowane punkty": "Mostrar puntos programados",
    "Opis kosztu": "",
    "ID nazwa obiektu": "Nombre del objeto ID",
    "Zacznij pisać aby wyszukać nieruchomość...": "Empieza a escribir para buscar una propiedad...",
    "Odrzucone zgody": "Consentimiento rechazado",
    "Witryny": "Sitios",
    "Zadanie zostało zaktualizowane.": "La tarea se ha actualizado.",
    "Kwota opłacona od": "Monto pagado desde",
    "Pole zawiera": "El campo contiene",
    "Pole \"Imię\" jest wymagane.": "El campo «Nombre» es obligatorio.",
    "Koniec długości geograficznej użytkownika": "Longitud al final del usuario",
    "TAK": "SÍ",
    "Pokaż nieruchomości (bez zadań i rezerwacji)": "Mostrar propiedades (sin tareas ni reservas)",
    "Zadanie zostało usunięte": "Se ha eliminado la tarea",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "No tiene los permisos necesarios para realizar la operación seleccionada.",
    "Numer mieszkania": "Número de apartamento",
    "Numer telefonu: ": "Número de teléfono: ",
    "Zamknij": "Cerrar",
    "Statystyki regionalne - regiony": "Estadísticas regionales - regiones",
    "Tryb konserwacji systemu": "Modo de mantenimiento del sistema",
    "Przyrostek": "Sufijo",
    "Numer sesji": "Número de sesión",
    "Notatka": "Memo",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "",
    "Konfiguracja bloku": "Configuración de bloques",
    "Brak dostępnych tras": "No hay rutas disponibles",
    "Statystyki kosztów w obiektach": "Estadísticas de costos en instalaciones",
    "Stwórz czat z rezerwacji": "Crear un chat a partir de una reserva",
    "Klient został usunięty.": "Se ha eliminado el cliente.",
    "Zawiera": "Incluye",
    "Krótki tytuł": "Título abreviado",
    "Opis zespołu": "Descripción del equipo",
    "Krzesełko": "Silla",
    "Serwer bazy danych": "Servidor de bases de datos",
    "Wynagrodzenia Kierowcy": "Salarios de los conductores",
    "Adres e-mail potwierdzony": "Dirección de correo electrónico confirmada",
    "Podanie nazwy jest wymagane.": "El nombre es obligatorio.",
    "Data dodania od": "Fecha añadida desde",
    "Ilość osób": "Cantidad de personas",
    "Nazwisko": "Apellidos",
    "Wartość 0 oznacza brak limitu": "Un valor de 0 significa que no hay límite",
    "Szablon został dodany.": "Se ha agregado la plantilla.",
    "NIE": "NO",
    "Data uruchomienia": "Fecha de lanzamiento",
    "Wyszukaj zespół": "Busca un equipo",
    "Paczka SCORM została zaktualizowana.": "Se ha actualizado el paquete SCORM.",
    "Co 5 dni": "Cada 5 días",
    "Daty publikacji zostały zaktualizowane.": "Se han actualizado las fechas de publicación.",
    "Urlopy": "Vacaciones",
    "Stopka": "Pie de página",
    "Aranżacja została opublikowana.": "El acuerdo se ha publicado.",
    "Rozliczenia": "Asentamientos",
    "Nie wiem": "No lo sé",
    "Historia lokalizacji": "Historial de ubicaciones",
    "Nigdy": "jamás",
    "Nie udało się pobrać listy szablonów": "No se pudo descargar la lista de plantillas",
    "Wersja utowrzona przez": "Versión creada por",
    "Kategoria szkolenia": "Categoría de formación",
    "Lista szkoleń": "Lista de capacitaciones",
    "Ukryj": "Esconder",
    "Wykonawca": "Contratista",
    "Profil koordynatora": "Perfil del coordinador",
    "Edytuj aranżację": "Editar arreglo",
    "Wybierz miasta": "Selecciona ciudades",
    "Moduły": "Módulos",
    "Przeniesienie wybranych elementów": "Mover los elementos seleccionados",
    "Link do zewnętrznej strony": "Enlace a un sitio externo",
    "Data zakońćzenia": "Fecha de finalización",
    "Wystąpił błąd podczas zapisywania ustawień": "Se ha producido un error al guardar la configuración",
    "Ukryj podczas dodawania zadania": "Ocultar al añadir una tarea",
    "Tytuł aktywnej witryny": "Título del sitio activo",
    "Czerwiec": "Jun",
    "Osoba odpowiedzialna": "Persona a cargo",
    "Usunął": "Eliminado",
    "Zacznij pisać aby wyszukać nieruchomość roboczą...": "Empieza a escribir para buscar una propiedad en funcionamiento...",
    "Eksportuj do PDF": "Exportar a PDF",
    "Zlecenie na nieruchomość roboczą": "Pedido de bienes inmuebles en funcionamiento",
    "Kolejność punktów trasy została zaktualizowana": "Se ha actualizado el orden de los puntos de ruta",
    "Obsługa Właściciela (OW)": "Servicio al propietario (OW)",
    "Dozwolone rozszerzenia": "Extensiones permitidas",
    "Tag nieruchomości": "Etiqueta de propiedad",
    "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "Proporcione los ID de usuario de Facebook, separados por comas, para que puedan acceder a las estadísticas (Facebook Insights).",
    "Blokada konta": "Bloqueo de cuenta",
    "Status paczki został zmieniony.": "Se ha cambiado el estado del paquete.",
    "Usuń ze szkolenia": "Retirar del entrenamiento",
    "Dokument został dodany.": "Se ha agregado el documento.",
    "Wymagaj odpowiedzi, aby przejść dalej": "Requerir respuestas para seguir adelante",
    "Typ nieobecności": "Tipo de ausencia",
    "Następna inwentaryzacja": "Siguiente inventario",
    "Tylko do odczytu": "Solo lectura",
    "Bardzo dobrze": "Muy bueno",
    "Struktura serwisu": "La estructura del sitio",
    "W organizacji nie ma jeszcze żadnych działów.": "Aún no hay departamentos en la organización.",
    "Trasa została usunięta": "Se ha eliminado la ruta",
    "Nr nieruchomości Avantio": "Nº de propiedad Avantio",
    "Imię i Nazwisko": "Nombre y apellidos",
    "Ważność": "Validez",
    "Pracownik": "Trabajador",
    "Dokument został zaktualizowany.": "El documento se ha actualizado.",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "Error 404. No se encontró el recurso solicitado.",
    "W zespole od %0 do %1": "En equipo de %0 a %1",
    "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "Tu cuenta permanecerá inactiva hasta que se confirme tu dirección de correo electrónico",
    "To pole jest wymagane": "Este campo es obligatorio",
    "Dodanie paczki SCORM": "Agregar un paquete SCORM",
    "Wynagrodzenia od ilości posprzątanych obiektów": "Remuneración por el número de objetos limpiados",
    "OW": "Atención al propietario",
    "(AirBnb) Wysłano żądanie do gościa": "(AirBnB) Solicitud enviada al huésped",
    "Data pauzy": "Fecha de pausa",
    "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "El canal es obligatorio de forma predeterminada. No es posible deshabilitar el envío de una notificación a través de este canal. Solo es posible cambiar el título y el contenido del mensaje.",
    "Wysłano kolejne wezwanie do zapłaty": "Se ha enviado otra solicitud de pago",
    "Zastępstwo zostało usunięte.": "Se ha retirado la pieza de repuesto.",
    "Wklej komponent": "Componente de pasta",
    "Przeterminowane": "Expirado",
    "Procent": "Porcentaje",
    "Rezerwacje": "Reservaciones",
    "Zacznij pisać aby wyszukać tag...": "Empieza a escribir para buscar una etiqueta...",
    "Data do": "Fecha hasta",
    "Oznacz widoczne jako przeczytane": "Marcar visible como leído",
    "Dzisiaj": "hoy",
    "Szczegóły zmian": "Detalles de los cambios",
    "Zakończone: ${$filters.datetime(task.dateCompleted)}": "Completado: $ {$filters.datetime (task.dateComplete)}",
    "Treść opublikowana": "Contenido publicado",
    "Nazwa lekcji": "Nombre de la lección",
    "Użytkownik Inspekcja": "Inspección de usuarios",
    "Typ słownika": "Tipo de diccionario",
    "Zablokuj użytkownika": "Bloquear usuario",
    "Data użycia": "Fecha de uso",
    "Typ zadania": "Tipo de tarea",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą klienta": "Personas asignadas de forma predeterminada a las tareas de servicio al cliente",
    "Pytanie 1": "Pregunta 1",
    "Nieważne": "No es importante",
    "Sekcja została zaktualizowana": "La sección se ha actualizado",
    "Kontrolka wyboru (pojedynczy wybór)": "Control de selección (selección única)",
    "Kolor został zaktualizowany": "Se ha actualizado el color",
    "Lekcja została dodana.": "Se ha agregado una lección.",
    "Kwiecień": "Abr",
    "Kanały obsługiwane przez wybrany typ powiadmienia": "Canales compatibles con el tipo de aire seleccionado",
    "Region został dodany.": "Se ha agregado la región.",
    "Usunięto przez: ": "Eliminado por: ",
    "Komunikat błędu": "Mensaje de error",
    "Typ Nieruchomości": "Tipo de propiedad",
    "Classic mode": "Moda clásica",
    "Strona %0": "Página %0",
    "Pokaż rezerwacje właścicielskie": "Mostrar reservas de propietarios",
    "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "La configuración del arreglo no está disponible porque no se proporciona ninguna definición de plantilla.",
    "nie wymuszaj zmiany hasła": "no fuerce el cambio de contraseña",
    "Nazwa pliku została zmieniona.": "Se ha cambiado el nombre del archivo.",
    "Nazwa użytkownika serwisowego": "Nombre de usuario del servicio",
    "Nadpisz kwotę dla": "Sobrescribir el importe de",
    "Konfiguracja domyślna": "Configuración predeterminada",
    "Edytuj lekcje": "Editar lecciones",
    "Aby wysłać wiadomość, dołącz do czatu": "Para enviar un mensaje, únete al chat",
    "Plik został wysłany": "El archivo se ha enviado",
    "Nazwa regionu": "Nombre de la región",
    "Tytuł": "Título",
    "Edycja nieruchomości roboczej": "Edición de una propiedad funcional",
    "Uwzględnij dodatkowe nieruchomości": "Incluir propiedades adicionales",
    "Rezerwacja": "Reservación",
    "Admin": "Adminul",
    "Cena PLN": "Precio PLN",
    "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "Este canal no puede enviar texto formateado.",
    "Administracja - Województwa": "Administración - Voivodías",
    "Pokaż punkty bez kierowcy": "Mostrar puntos sin conductor",
    "Nie udało się pobrać listy kategorii": "No se pudo descargar la lista de categorías",
    "Materiały szkoleniowe": "Materiales de formación",
    "Przypomnij": "recordar",
    "Typ źródła": "Tipo de fuente",
    "Domyślna firma": "Empresa predeterminada",
    "Czy jesteś pewien, że chcesz przypisać dzielnicę do nowego miasta? Wszystkie nieruchomości i użytkownicy przypisani do tej dzielnicy przestaną być do niej przypisani.": "¿Está seguro de que desea asignar un distrito a una nueva ciudad? Todas las propiedades y usuarios asignados a este distrito dejarán de estar asignados a él.",
    "Wyślij link": "Enviar enlace",
    "Dostęp niezdefiniowany": "Acceso indefinido",
    "Na wniosek": "A petición",
    "Od ilości posprzątanych obiektów": "De la cantidad de objetos limpiados",
    "Aktualności": "noticias",
    "Przenieś": "Traslado",
    "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "Cuando se selecciona esta opción, no se tienen en cuenta los permisos individuales y basados en roles.",
    "Zadanie do wykonania": "Tarea por completar",
    "Pole wymagane": "Campo obligatorio",
    "Maj": "mayo",
    "Dane formularza są przechowywane w obiekcie Entry.": "Los datos del formulario se almacenan en el objeto Entry.",
    "Pliki publiczne": "Expedientes públicos",
    "Zaakceptowane, zapisz": "Aceptado, guardar",
    "Symbol klienta": "Símbolo de cliente",
    "Dodaj zespół": "Añadir un equipo",
    "Dodanie lekcji": "Añadir lecciones",
    "Pole \"%0\" nie zawiera prawidłowego adresu email.": "El campo «%0\" no contiene una dirección de correo electrónico válida.",
    "Kwota netto": "",
    "Numer dowodu osobistego": "Número de tarjeta de identificación",
    "Korytarz": "Corredor",
    "W trakcie": "En el transcurso de",
    "Użytkownik został przypisany do szkolenia.": "El usuario ha sido asignado a la formación.",
    "Skopiuj szkolenie": "Copia la formación",
    "Piosenka": "Canción",
    "Edytuj datę dostępu": "Editar fecha de acceso",
    "Ostatnia wiadomość - data": "Último mensaje - fecha",
    "Wybrane regulaminy: ": "Regulaciones seleccionadas: ",
    "Sprawdzić": "Comprobar",
    "Dodaj nowy tag": "Añadir una etiqueta nueva",
    "Zatwierdź": "enviar",
    "Nie udało się pobrać listy ról": "No se pudo descargar la lista de funciones",
    "kiedy ma się to wydarzyć (kiedy możemy odwiedzić apartament)": "cuándo se supone que va a suceder (cuándo podemos visitar el apartamento)",
    "Wynagrodzenia Pracownicy": "Salarios empleados",
    "Pytania": "Preguntas",
    "Pobierz raport": "Descargar el informe",
    "Sesja": "Sesión",
    "Treść wiadomości": "Contenido del mensaje",
    "Osoby przypisane jako domyślne do zadań zwiazanych z obsługą właściciela": "Personas asignadas de forma predeterminada a las tareas relacionadas con el servicio del propietario",
    "Przeczytane": "Leer",
    "Użytkownik i jego wiadomości zostały przywrócone.": "Se han restaurado el usuario y sus mensajes.",
    "Serwer został dodany.": "Se ha agregado el servidor.",
    "Booking with conflict": "Reserva con conflicto",
    "Usuń zestaw": "Retirar el conjunto",
    "Otwórz Ustawienia": "Abrir configuración",
    "Obciążenie Renters": "La carga de los inquilinos",
    "Brak zadań do wyświetlenia": "No hay tareas que mostrar",
    "Rozwiń/Zwiń": "Expandir/contraer",
    "Dodane przez moje zespoły": "Agregado por mis equipos",
    "Typ wynagrodzenia został usunięty": "Se ha eliminado el tipo de salario",
    "Sesja użytkownika": "Sesión de usuario",
    "Tekst zastępczy": "Texto alternativo",
    "Dodaj użytkownika": "Agregar usuario",
    "Dodaj Notatkę": "Añadir nota",
    "Zadanie wykonuje": "La tarea se realiza",
    "Pokaż historię": "Mostrar historial",
    "Edycja paczek SCORM": "Edición de paquetes SCORM",
    "Dodaj certyfikat": "Añadir certificado",
    "Resetowanie podejść": "Restablecimiento de enfoques",
    "Piątek": "viernes",
    "Aktualne hasło": "Contraseña actual",
    "Kolor został usunięty": "Se ha eliminado el color",
    "Maksymalna ilość plików": "Cantidad máxima de archivos",
    "Dodaj dział": "Añadir un departamento",
    "Włącz monitorowanie aktywności": "Habilitar la supervisión de la actividad",
    "Średnie wynagrodzenie": "Salario promedio",
    "Wybierz temat": "Elige un tema",
    "Nie udało się usunąć zlecenia.": "No se pudo eliminar el pedido.",
    "Edycja checklisty": "Editar lista de verificación",
    "Zespół aktywny": "Equipo activo",
    "Nr rezerwacji": "No de reserva",
    "Batch": "Lote",
    "Historia nieruchomości": "Historia inmobiliaria",
    "Zaopatrzenie zostało dodane.": "Se han agregado suministros.",
    "Wybrane elementy zostały usunięte.": "Se han eliminado los elementos seleccionados.",
    "Dodaj": "agregar",
    "Dodaj chat": "Añadir chat",
    "Typ materiału": "Tipo de material",
    "Top mieszkań generujacych najwięcej kosztów": "Los mejores apartamentos que generan la mayor cantidad de costos",
    "Sesja nr %0": "Sesión #%0",
    "Dodanie slajdera": "Añadir un control deslizante",
    "Procent obciążeń": "Porcentaje de cargas",
    "Stan licznika start": "Iniciar el estado del contador",
    "Id modelu: %0": "ID del modelo: %0",
    "Do kogo wysłać testowe powiadomienie": "A quién enviar una notificación de prueba",
    "Zespół został zaktualizowany.": "El equipo se ha actualizado.",
    "Wybierz paczkę SCORM": "Elige tu paquete SCORM",
    "Dzielnice": "Distritos",
    "Dodanie dzielnicy": "Añadir un distrito",
    "Stwórz zadanie": "Crear una tarea",
    "Standardowa strona": "Página estándar",
    "Wielokrotny wybór": "Opción múltiple",
    "To miasto znajduję się już w tym regionie.": "Esta ciudad ya está en esta región.",
    "Pseudonim": "Seudónimo",
    "Minimum": "Mínimo",
    "Ustawienia domyślne": "Ajustes predeterminados",
    "Ostatnie sprzątanie": "Última limpieza",
    "Dodaj Koszt": "Añadir coste",
    "Dodaj zestaw": "Añadir un conjunto",
    "Usuń wybrane": "Eliminar lo seleccionado",
    "Ten region jest już przypisany do użytkownika.": "Esta región ya está asignada al usuario.",
    "Źródło": "fuente",
    "Nie wypełniono poprzedniego wiersza.": "La fila anterior no se ha completado.",
    "Status zadania": "Estado de la tarea",
    "Nazwa aktywnej strony": "Nombre de la página activa",
    "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Selecciona una dirección canónica de la lista o introdúcela manualmente.",
    "Aranżacja": "Arreglo",
    "Dostęp od": "Acceso desde",
    "Godzina trasy": "Hora de la ruta",
    "Ścieżka szkoleniowa została usunięta.": "Se ha eliminado la ruta de entrenamiento.",
    "Program szkolenia": "Programa de formación",
    "Dzielnica": "municipio",
    "Tłumacz": "Traductor",
    "W polu możemy umieszczać jedynie cyfry": "En el campo solo podemos poner números",
    "Edytuj zadanie": "Editar tarea",
    "Nadpisanie kwoty wynagrodzenia zostało dodane.": "Se ha añadido la anulación del importe del salario.",
    "Zameldowanie": "Registrarse",
    "Monitor kolejek": "Monitor de cola",
    "Zawiera sekcje": "Incluye secciones",
    "Konto aktywne": "Cuenta activa",
    "Usuń stronę": "Eliminar página",
    "Pojedynczy wybór": "Elección única",
    "Dodaj lekcję": "Añadir una lección",
    "Zacznij pisać aby wyszukać użytkownika...": "Empieza a escribir para buscar un usuario...",
    "dzień temu": "hace un día",
    "Zapisz wersję": "",
    "Trasa została wznowiona": "Маршрутът е възобновен",
    "Ustawienia powiadomień": "Настройки за известяване",
    "Marka": "марка",
    "Kategoria wyszukiwanego matariału": "",
    "Ilość pracowników": "Брой служители",
    "Wybierz osobę spoza dzielnicy": "Изберете човек извън квартала",
    "Nieaktywne": "Неактивен",
    "Przeciągnij do innej sekcji": "",
    "Podlega ocenie": "",
    "Nieruchomość zagrożona wypowiedzeniem": "Имоти, изложени на риск от прекратяване",
    "Nie udało się pobrać listy serwerów baz danych": "Неуспешно изтегляне на списъка със сървъри на база данни",
    "Ustawienia": "Настройки",
    "Zaplanowane": "Планиран",
    "Usuń wybrane": "Изтриване на избраните",
    "Niewidoczne": "Невидим",
    "Filtry systemowe": "Системни филтри",
    "Szkolenie zostało zaktualizowane.": "",
    "Opis sekcji": "",
    "Imię właściciela": "Име на собственика",
    "Krótki tytuł": "",
    "Opis certyfikatu": "",
    "Szczegóły zmiany": "Подробности за промяната",
    "Lewy panel": "Ляв панел",
    "Dodaj media": "Добавяне на медия",
    "Nieobecność do": "Отсъствие на",
    "Nie udało się zapisać komentarza": "",
    "Host główny": "Основен домакин",
    "Dodaj pliki": "Добавяне на файлове",
    "Dodaj sekcję": "Добавяне на секция",
    "Edytuj sekcję": "Редактиране на секция",
    "Sekcja została utworzona": "Секцията е създадена",
    "Sekcja została zaktualizowana": "Секцията е актуализирана",
    "Sekcja została usunięta": "Секцията е изтрита",
    "Sekcja nie została znaleziona": "Секцията не е намерена",
    "Typ pomieszczenia jest wymagany": "Изисква се тип помещение",
    "Typ plików jest wymagany": "",
    "Wybierz pliki do dodania": "Изберете файлове за добавяне",
    "Pliki zostały dodane": "Файловете са добавени",
    "Pliki zostały pobrane": "Файловете са изтеглени",
    "Plik został przeniesiony": "Файлът е преместен",
    "Brak sekcji multimediów": "Липсва мултимедийна секция",
    "Czy na pewno chcesz usunąć tę sekcję?": "Сигурни ли сте, че искате да изтриете тази секция?",
    "Zaznacz wszystkie w sekcji": "Изберете всички в секцията",
    "Brak plików w sekcji": "Няма файлове в секцията",
    "Wybierz sekcję": "Изберете секция",
    "Brak sekcji - najpierw utwórz sekcję": "Няма секция – първо създайте секция",
    "Aby dodać pliki, najpierw musisz utworzyć sekcję.": "За да добавите файлове, първо трябва да създадете секция.",
    "Wybrana sekcja akceptuje tylko pliki typu: {0}": "Избраната секция приема само файлове от тип: {0}",
    "Wybrane pliki są typu {0}, a sekcja akceptuje tylko {1}": "Избраните файлове са от тип {0}, а секцията приема само {1}",
    "Wybierz sekcję, do której chcesz dodać pliki": "Изберете секция, към която искате да добавите файлове",
    "Sekcja jest wymagana": "Секцията е задължителна",
    "Wybrana sekcja nie istnieje": "Избраната секция не съществува",
    "Nie można dodawać plików różnych typów jednocześnie. Wybierz pliki tego samego typu.": "Не можете да добавяте файлове от различни типове едновременно. Изберете файлове от един и същи тип.",
    "Nie można dodać plików typu {0} do sekcji typu {1}": "Не може да се добавят файлове от тип {0} към секция от тип {1}",
    "Nie udało się przesłać plików": "Неуспешно качване на файлове",
    "Budynek": "Сграда",
    "Pokój dzienny": "Дневна",
    "Sypialnia": "Спалня",
    "Kuchnia": "Кухня",
    "Łazienka": "Баня",
    "Korytarz": "Коридор",
    "Typ pomieszczenia": "Тип помещение",
    "Nie znaleziono nieruchomości": "Имотът не е намерен",
    "Nie udało się załadować plików": "Неуспешно зареждане на файловете",
    "Usuń zaznaczone": "Изтрий избраното",
    "Czy na pewno chcesz usunąć zaznaczone pliki?": "Сигурни ли сте, че искате да изтриете избраните файлове?",
    "Pliki zostały usunięte": "Файловете са изтрити",
    "Nie można przenosić plików między sekcjami o różnych typach": "Файловете не могат да се преместват между секции с различни типове",
    "Pliki zostaną automatycznie dodane do odpowiednich sekcji 'Inne' na podstawie typu pliku.": "Файловете ще бъдат автоматично добавени в съответните секции „Друго“ според типа на файла.",
    "Pliki": "Файлове",
    "Dane kosztu": "Данни за разхода",
    "Nazwa kosztu": "Име на разхода",
    "Opis kosztu": "Описание на разхода",
    "Kwota brutto": "Брутна сума",
    "Kwota netto": "Нетна сума",
    "VAT (wyliczany automatycznie)": "ДДС (изчислява се автоматично)",
    "VAT": "ДДС",
    "Historia zmian kosztu": "История на промените на разхода",
    "Brak historii zmian": "Няма история на промените",
    "Wersja": "Версия",
    "Koszt został dodany.": "Разходът беше добавен.",
    "Koszt został zaktualizowany.": "Разходът беше актуализиран.",
    "Pobierz Excel": "Изтегли Excel",
    "Koszt został usunięty": "Разходът беше изтрит",
    "Excel został wygenerowany i wysłany na adres e-mail": "Excel файлът беше генериран и изпратен на имейл адреса",
    "Materiały": "Материали",
    "Koszt pracownika": "Разход за служител",
    "Dane z VROS": "Данни от VROS",
    "Parking": "Паркинг",
    "Wi-Fi": "Wi-Fi",
    "Router": "Рутер",
    "Nazwa sieci": "Име на мрежата",
    "Instrukcje": "Инструкции",
    "Instrukcje zameldowania": "Инструкции за настаняване",
    "Instrukcje wymeldowania": "Инструкции за освобождаване",
    "Przewodnik gościa": "Ръководство за гости",
    "Kod do skrytki na klucze": "Код за кутията за ключове",
    "Godzina zameldowania (Guesty)": "Час за настаняване (Guesty)",
    "Godzina końca zameldowania (Guesty)": "Час за край на настаняването (Guesty)",
    "Godzina wymeldowania (Guesty)": "Час за напускане (Guesty)",
    "Brak wybranej firmy": "No hay ninguna empresa seleccionada",
    "Lista kosztów": "Lista de gastos",
    "Akceptacja kosztów": "Aprobación de gastos",
    "Recenzje sprzątaczy": "Reseñas de limpiadores",
    "Przekroczono czas oczekiwania na odpowiedź serwera lub połączenie zostało anulowane.": "Se agotó el tiempo de espera para recibir una respuesta del servidor o la conexión fue cancelada.",
    "Tylko Administrator lub ExternalManager może tworzyć nowe konta": "Solo Administrator o ExternalManager puede crear nuevas cuentas.",
    "Kwota dodatkowego wynagrodzenia nie może być ujemna": "El importe de la remuneración adicional no puede ser negativo",
    "Nazwa czynności": "Nombre de la actividad",
    "Dodaj czynność": "Añadir actividad",
    "Liczba czynności": "Número de actividades",
    "Dodaj kategorię zadań": "Añadir categoría de tareas",
    "Obsługa właścicieli": "AHORA",
    "Edycja kategorii zadań": "Editar categoría de tareas",
    "Edycja czynności": "Editar actividad",
    "Brak wydziału": "Sin departamento",
    "Zacznij pisać aby wyszukać czynność...": "Empieza a escribir para buscar una actividad...",
    "Czynność została zaktualizowana.": "La actividad se ha actualizado.",
    "Czynność została usunięta.": "La actividad se ha eliminado.",
    "Czynność została dodana.": "La actividad se ha añadido.",
    "Nie można dodać tej czynności do zadania.": "No se puede añadir esta actividad a la tarea.",
    "Przypisane czynności": "Actividades asignadas",
    "Brak przypisanych czynności.": "No hay actividades asignadas.",
    "Kategorie zadań": "Categorías de tareas",
    "Czynności zadań": "Actividades de tareas",
    "czynności": "actividades",
    "usunięta": "eliminada",
    "Komentarz (opcjonalny)": "Comentario (opcional)",
    "Formularz zadania nie jest poprawny.": "El formulario de la tarea no es válido.",
    "Biblioteka czynności": "Biblioteca de actividades",
    "Szukaj czynności": "Buscar actividades",
    "Wszystkie statusy": "Todos los estados",
    "Przenieś na samą górę": "Mover al principio",
    "Przenieś na sam dół": "Mover al final",
    "Widoczna w zadaniach": "Visible en las tareas",
    "Czynność jest widoczna w zadaniach.": "La actividad ahora es visible en las tareas.",
    "Czynność została ukryta w zadaniach.": "La actividad se ha ocultado en las tareas.",
    "Edytuj kategorię": "Editar categoría",
    "Edytuj czynność": "Editar actividad",
    "Nowa czynność": "Nueva actividad",
    "Kolejność została zapisana.": "Se ha guardado el orden.",
    "Nie udało się zapisać kolejności.": "No se ha podido guardar el orden.",
    "Przypisana do działu": "Asignada al departamento",
    "Przypisana do kategorii": "Asignada a la categoría",
    "Np. wymiana okien": "P. ej., cambio de ventanas",
    "Użyta w": "Usada en",
    "%0 zadaniach": "%0 tareas",
    "Zmiana nazwy nie zmieni istniejących zadań.": "Cambiar el nombre no modificará las tareas existentes.",
    "Upewnij się, że nazwa czynności:": "Asegúrate de que el nombre de la actividad:",
    "Nie zawiera literówek": "No contiene erratas",
    "Jest jasna, klarowna i precyzyjna": "Es claro y preciso",
    "Zawiera polskie znaki": "Incluye los caracteres polacos",
    "Aktywna w nowych zadaniach": "Activa en las tareas nuevas",
    "Czynność „Inne” (pokazuje pole komentarza w aplikacji mobilnej)": "Actividad «Otros» (muestra un campo de comentario en la aplicación móvil)",
    "Czynności nigdy nie są usuwane, można je tylko dezaktywować": "Las actividades nunca se eliminan, solo se pueden desactivar",
    "Np. Hydraulika": "P. ej., Fontanería",
    "Przeciągnij, aby zmienić kolejność działów": "Arrastra para cambiar el orden de los departamentos",
    "Zameldowanie / Wymeldowanie": "Check-in / Check-out",
    "Media": "Suministros",
    "Dostawca": "Proveedor",
    "Inwentarz": "Inventario",
    "Komfort": "Confort",
    "Dodatki": "Extras",
    "A/C": "Aire acondicionado",
    "Ogrzewanie centralne": "Calefacción central",
    "Kanapa": "Sofá",
    "Zaciemnienie": "Oscurecimiento",
    "Grzejniki": "Calefactores",
    "Bojler": "Calentador de agua",
    "Pościel": "Ropa de cama",
    "TV": "TV",
    "Suszarka do ubrań": "Secadora",
    "Suszarka do włosów": "Secador de pelo",
    "Żelazko": "Plancha",
    "Piekarnik": "Horno",
    "Kuchenka mikrofalowa": "Microondas",
    "Czajnik": "Hervidor",
    "Dzbanek na wodę": "Jarra de agua",
    "Środki czystości": "Productos de limpieza",
    "Pralka": "Lavadora",
    "Suszarka na pranie": "Tendedero",
    "Lampki nocne": "Lámparas de noche",
    "Deska do prasowania": "Tabla de planchar",
    "Kuchenka": "Cocina",
    "Toster": "Tostadora",
    "Zmywarka": "Lavavajillas",
    "Odkurzacz": "Aspiradora",
    "Ekspres do kawy": "Cafetera",
    "Apteczka": "Botiquín de primeros auxilios",
    "Czujnik CO2": "Detector de CO2",
    "Gaśnica": "Extintor",
    "Czujnik dymu": "Detector de humo",
    "Przyjazne zwierzętom": "Admite mascotas",
    "Widok": "Vistas",
    "Prąd": "Electricidad",
    "Ogrzewanie": "Calefacción",
    "Woda": "Agua",
    "Gaz": "Gas",
    "Internet": "Internet",
    "Dane zostały zapisane.": "Los datos se han guardado.",
    "Piętro": "Planta",
    "Winda": "Ascensor",
    "Balkon": "Balcón"
  }
}